export const sub_districts = [
    {
        "id": 100101,
        "name_th": "พระบรมมหาราชวัง",
        "name_en": "Phra Borom Maha Ratchawang",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100102,
        "name_th": "วังบูรพาภิรมย์",
        "name_en": "Wang Burapha Phirom",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100103,
        "name_th": "วัดราชบพิธ",
        "name_en": "Wat Ratchabophit",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100104,
        "name_th": "สำราญราษฎร์",
        "name_en": "Samran Rat",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100105,
        "name_th": "ศาลเจ้าพ่อเสือ",
        "name_en": "San Chao Pho Suea",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100106,
        "name_th": "เสาชิงช้า",
        "name_en": "Sao Chingcha",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100107,
        "name_th": "บวรนิเวศ",
        "name_en": "Bowon Niwet",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100108,
        "name_th": "ตลาดยอด",
        "name_en": "Talat Yot",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100109,
        "name_th": "ชนะสงคราม",
        "name_en": "Chana Songkhram",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100110,
        "name_th": "บ้านพานถม",
        "name_en": "Ban Phan Thom",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100111,
        "name_th": "บางขุนพรหม",
        "name_en": "Bang Khun Phrom",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100112,
        "name_th": "วัดสามพระยา",
        "name_en": "Wat Sam Phraya",
        "zip_codes": [
            10200
        ],
        "district_id": 1001
    },
    {
        "id": 100201,
        "name_th": "ดุสิต",
        "name_en": "Dusit",
        "zip_codes": [
            10300
        ],
        "district_id": 1002
    },
    {
        "id": 100202,
        "name_th": "วชิรพยาบาล",
        "name_en": "Wachira Phayaban",
        "zip_codes": [
            10300
        ],
        "district_id": 1002
    },
    {
        "id": 100203,
        "name_th": "สวนจิตรลดา",
        "name_en": "Suan Chitlada",
        "zip_codes": [
            10300,
            10303
        ],
        "district_id": 1002
    },
    {
        "id": 100204,
        "name_th": "สี่แยกมหานาค",
        "name_en": "Si Yaek Mahanak",
        "zip_codes": [
            10300
        ],
        "district_id": 1002
    },
    {
        "id": 100206,
        "name_th": "ถนนนครไชยศรี",
        "name_en": "Thanon Nakhon Chai Si",
        "zip_codes": [
            10300
        ],
        "district_id": 1002
    },
    {
        "id": 100301,
        "name_th": "กระทุ่มราย",
        "name_en": "Krathum Rai",
        "zip_codes": [
            10530
        ],
        "district_id": 1003
    },
    {
        "id": 100302,
        "name_th": "หนองจอก",
        "name_en": "Nong Chok",
        "zip_codes": [
            10530
        ],
        "district_id": 1003
    },
    {
        "id": 100303,
        "name_th": "คลองสิบ",
        "name_en": "Khlong Sip",
        "zip_codes": [
            10530
        ],
        "district_id": 1003
    },
    {
        "id": 100304,
        "name_th": "คลองสิบสอง",
        "name_en": "Khlong Sip Song",
        "zip_codes": [
            10530
        ],
        "district_id": 1003
    },
    {
        "id": 100305,
        "name_th": "โคกแฝด",
        "name_en": "Khok Faet",
        "zip_codes": [
            10530
        ],
        "district_id": 1003
    },
    {
        "id": 100306,
        "name_th": "คู้ฝั่งเหนือ",
        "name_en": "Khu Fang Nuea",
        "zip_codes": [
            10530
        ],
        "district_id": 1003
    },
    {
        "id": 100307,
        "name_th": "ลำผักชี",
        "name_en": "Lam Phak Chi",
        "zip_codes": [
            10530
        ],
        "district_id": 1003
    },
    {
        "id": 100308,
        "name_th": "ลำต้อยติ่ง",
        "name_en": "Lam Toiting",
        "zip_codes": [
            10530
        ],
        "district_id": 1003
    },
    {
        "id": 100401,
        "name_th": "มหาพฤฒาราม",
        "name_en": "Maha Phruettharam",
        "zip_codes": [
            10500
        ],
        "district_id": 1004
    },
    {
        "id": 100402,
        "name_th": "สีลม",
        "name_en": "Si Lom",
        "zip_codes": [
            10500
        ],
        "district_id": 1004
    },
    {
        "id": 100403,
        "name_th": "สุริยวงศ์",
        "name_en": "Suriyawong",
        "zip_codes": [
            10500
        ],
        "district_id": 1004
    },
    {
        "id": 100404,
        "name_th": "บางรัก",
        "name_en": "Bang Rak",
        "zip_codes": [
            10500
        ],
        "district_id": 1004
    },
    {
        "id": 100405,
        "name_th": "สี่พระยา",
        "name_en": "Si Phraya",
        "zip_codes": [
            10500
        ],
        "district_id": 1004
    },
    {
        "id": 100502,
        "name_th": "อนุสาวรีย์",
        "name_en": "Anusawari",
        "zip_codes": [
            10220
        ],
        "district_id": 1005
    },
    {
        "id": 100508,
        "name_th": "ท่าแร้ง",
        "name_en": "Tha Raeng",
        "zip_codes": [
            10220,
            10230
        ],
        "district_id": 1005
    },
    {
        "id": 100601,
        "name_th": "คลองจั่น",
        "name_en": "Khlong Chan",
        "zip_codes": [
            10240
        ],
        "district_id": 1006
    },
    {
        "id": 100608,
        "name_th": "หัวหมาก",
        "name_en": "Hua Mak",
        "zip_codes": [
            10240,
            10250
        ],
        "district_id": 1006
    },
    {
        "id": 100701,
        "name_th": "รองเมือง",
        "name_en": "Rong Mueang",
        "zip_codes": [
            10330
        ],
        "district_id": 1007
    },
    {
        "id": 100702,
        "name_th": "วังใหม่",
        "name_en": "Wang Mai",
        "zip_codes": [
            10110,
            10120,
            10330,
            10400,
            10500
        ],
        "district_id": 1007
    },
    {
        "id": 100703,
        "name_th": "ปทุมวัน",
        "name_en": "Pathum Wan",
        "zip_codes": [
            10330
        ],
        "district_id": 1007
    },
    {
        "id": 100704,
        "name_th": "ลุมพินี",
        "name_en": "Lumphini",
        "zip_codes": [
            10330
        ],
        "district_id": 1007
    },
    {
        "id": 100801,
        "name_th": "ป้อมปราบ",
        "name_en": "Pom Prap",
        "zip_codes": [
            10100
        ],
        "district_id": 1008
    },
    {
        "id": 100802,
        "name_th": "วัดเทพศิรินทร์",
        "name_en": "Wat Thep Sirin",
        "zip_codes": [
            10100
        ],
        "district_id": 1008
    },
    {
        "id": 100803,
        "name_th": "คลองมหานาค",
        "name_en": "Khlong Maha Nak",
        "zip_codes": [
            10100
        ],
        "district_id": 1008
    },
    {
        "id": 100804,
        "name_th": "บ้านบาตร",
        "name_en": "Ban Bat",
        "zip_codes": [
            10100
        ],
        "district_id": 1008
    },
    {
        "id": 100805,
        "name_th": "วัดโสมนัส",
        "name_en": "Wat Sommanat",
        "zip_codes": [
            10100
        ],
        "district_id": 1008
    },
    {
        "id": 100905,
        "name_th": "บางจาก",
        "name_en": "Bang Chak",
        "zip_codes": [
            10260
        ],
        "district_id": 1009
    },
    {
        "id": 100910,
        "name_th": "พระโขนงใต้",
        "name_en": "Phra Khanong Tai",
        "zip_codes": [
            10260
        ],
        "district_id": 1009
    },
    {
        "id": 101001,
        "name_th": "มีนบุรี",
        "name_en": "Min Buri",
        "zip_codes": [
            10510
        ],
        "district_id": 1010
    },
    {
        "id": 101002,
        "name_th": "แสนแสบ",
        "name_en": "Saen Saep",
        "zip_codes": [
            10510
        ],
        "district_id": 1010
    },
    {
        "id": 101101,
        "name_th": "ลาดกระบัง",
        "name_en": "Lat Krabang",
        "zip_codes": [
            10520
        ],
        "district_id": 1011
    },
    {
        "id": 101102,
        "name_th": "คลองสองต้นนุ่น",
        "name_en": "Khlong Song Ton Nun",
        "zip_codes": [
            10520
        ],
        "district_id": 1011
    },
    {
        "id": 101103,
        "name_th": "คลองสามประเวศ",
        "name_en": "Khlong Sam Prawet",
        "zip_codes": [
            10520
        ],
        "district_id": 1011
    },
    {
        "id": 101104,
        "name_th": "ลำปลาทิว",
        "name_en": "Lam Pla Thio",
        "zip_codes": [
            10520
        ],
        "district_id": 1011
    },
    {
        "id": 101105,
        "name_th": "ทับยาว",
        "name_en": "Thap Yao",
        "zip_codes": [
            10520
        ],
        "district_id": 1011
    },
    {
        "id": 101106,
        "name_th": "ขุมทอง",
        "name_en": "Khum Thong",
        "zip_codes": [
            10520
        ],
        "district_id": 1011
    },
    {
        "id": 101203,
        "name_th": "ช่องนนทรี",
        "name_en": "Chong Nonsi",
        "zip_codes": [
            10120
        ],
        "district_id": 1012
    },
    {
        "id": 101204,
        "name_th": "บางโพงพาง",
        "name_en": "Bang Phongphang",
        "zip_codes": [
            10120
        ],
        "district_id": 1012
    },
    {
        "id": 101301,
        "name_th": "จักรวรรดิ",
        "name_en": "Chakkrawat",
        "zip_codes": [
            10100
        ],
        "district_id": 1013
    },
    {
        "id": 101302,
        "name_th": "สัมพันธวงศ์",
        "name_en": "Samphanthawong",
        "zip_codes": [
            10100
        ],
        "district_id": 1013
    },
    {
        "id": 101303,
        "name_th": "ตลาดน้อย",
        "name_en": "Talat Noi",
        "zip_codes": [
            10100
        ],
        "district_id": 1013
    },
    {
        "id": 101401,
        "name_th": "สามเสนใน",
        "name_en": "Sam Sen Nai",
        "zip_codes": [
            10400
        ],
        "district_id": 1014
    },
    {
        "id": 101406,
        "name_th": "พญาไท",
        "name_en": "Phaya Thai",
        "zip_codes": [
            10400
        ],
        "district_id": 1014
    },
    {
        "id": 101501,
        "name_th": "วัดกัลยาณ์",
        "name_en": "Wat Kanlaya",
        "zip_codes": [
            10600
        ],
        "district_id": 1015
    },
    {
        "id": 101502,
        "name_th": "หิรัญรูจี",
        "name_en": "Hiran Ruchi",
        "zip_codes": [
            10600
        ],
        "district_id": 1015
    },
    {
        "id": 101503,
        "name_th": "บางยี่เรือ",
        "name_en": "Bang Yi Ruea",
        "zip_codes": [
            10600
        ],
        "district_id": 1015
    },
    {
        "id": 101504,
        "name_th": "บุคคโล",
        "name_en": "Bukkhalo",
        "zip_codes": [
            10600
        ],
        "district_id": 1015
    },
    {
        "id": 101505,
        "name_th": "ตลาดพลู",
        "name_en": "Talat Phlu",
        "zip_codes": [
            10600
        ],
        "district_id": 1015
    },
    {
        "id": 101506,
        "name_th": "ดาวคะนอง",
        "name_en": "Dao Khanong",
        "zip_codes": [
            10600
        ],
        "district_id": 1015
    },
    {
        "id": 101507,
        "name_th": "สำเหร่",
        "name_en": "Samre",
        "zip_codes": [
            10600
        ],
        "district_id": 1015
    },
    {
        "id": 101601,
        "name_th": "วัดอรุณ",
        "name_en": "Wat Arun",
        "zip_codes": [
            10600
        ],
        "district_id": 1016
    },
    {
        "id": 101602,
        "name_th": "วัดท่าพระ",
        "name_en": "Wat Tha Phra",
        "zip_codes": [
            10600
        ],
        "district_id": 1016
    },
    {
        "id": 101701,
        "name_th": "ห้วยขวาง",
        "name_en": "Huai Khwang",
        "zip_codes": [
            10310
        ],
        "district_id": 1017
    },
    {
        "id": 101702,
        "name_th": "บางกะปิ",
        "name_en": "Bang Kapi",
        "zip_codes": [
            10310
        ],
        "district_id": 1017
    },
    {
        "id": 101704,
        "name_th": "สามเสนนอก",
        "name_en": "Sam Sen Nok",
        "zip_codes": [
            10310
        ],
        "district_id": 1017
    },
    {
        "id": 101801,
        "name_th": "สมเด็จเจ้าพระยา",
        "name_en": "Somdet Chao Phraya",
        "zip_codes": [
            10600
        ],
        "district_id": 1018
    },
    {
        "id": 101802,
        "name_th": "คลองสาน",
        "name_en": "Khlong San",
        "zip_codes": [
            10600
        ],
        "district_id": 1018
    },
    {
        "id": 101803,
        "name_th": "บางลำภูล่าง",
        "name_en": "Bang Lamphu Lang",
        "zip_codes": [
            10600
        ],
        "district_id": 1018
    },
    {
        "id": 101804,
        "name_th": "คลองต้นไทร",
        "name_en": "Khlong Ton Sai",
        "zip_codes": [
            10600
        ],
        "district_id": 1018
    },
    {
        "id": 101901,
        "name_th": "คลองชักพระ",
        "name_en": "Khlong Chak Phra",
        "zip_codes": [
            10170
        ],
        "district_id": 1019
    },
    {
        "id": 101902,
        "name_th": "ตลิ่งชัน",
        "name_en": "Taling Chan",
        "zip_codes": [
            10170
        ],
        "district_id": 1019
    },
    {
        "id": 101903,
        "name_th": "ฉิมพลี",
        "name_en": "Chimphli",
        "zip_codes": [
            10170
        ],
        "district_id": 1019
    },
    {
        "id": 101904,
        "name_th": "บางพรม",
        "name_en": "Bang Phrom",
        "zip_codes": [
            10170
        ],
        "district_id": 1019
    },
    {
        "id": 101905,
        "name_th": "บางระมาด",
        "name_en": "Bang Ramat",
        "zip_codes": [
            10170
        ],
        "district_id": 1019
    },
    {
        "id": 101907,
        "name_th": "บางเชือกหนัง",
        "name_en": "Bang Chueak Nang",
        "zip_codes": [
            10170
        ],
        "district_id": 1019
    },
    {
        "id": 102004,
        "name_th": "ศิริราช",
        "name_en": "Sirirat",
        "zip_codes": [
            10700
        ],
        "district_id": 1020
    },
    {
        "id": 102005,
        "name_th": "บ้านช่างหล่อ",
        "name_en": "Ban Chang Lo",
        "zip_codes": [
            10700
        ],
        "district_id": 1020
    },
    {
        "id": 102006,
        "name_th": "บางขุนนนท์",
        "name_en": "Bang Khun Non",
        "zip_codes": [
            10700
        ],
        "district_id": 1020
    },
    {
        "id": 102007,
        "name_th": "บางขุนศรี",
        "name_en": "Bang Khun Si",
        "zip_codes": [
            10700
        ],
        "district_id": 1020
    },
    {
        "id": 102009,
        "name_th": "อรุณอมรินทร์",
        "name_en": "Arun Ammarin",
        "zip_codes": [
            10700
        ],
        "district_id": 1020
    },
    {
        "id": 102105,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            10150
        ],
        "district_id": 1021
    },
    {
        "id": 102107,
        "name_th": "แสมดำ",
        "name_en": "Samae Dam",
        "zip_codes": [
            10150
        ],
        "district_id": 1021
    },
    {
        "id": 102201,
        "name_th": "บางหว้า",
        "name_en": "Bang Wa",
        "zip_codes": [
            10160
        ],
        "district_id": 1022
    },
    {
        "id": 102202,
        "name_th": "บางด้วน",
        "name_en": "Bang Duan",
        "zip_codes": [
            10160
        ],
        "district_id": 1022
    },
    {
        "id": 102206,
        "name_th": "บางจาก",
        "name_en": "Bang Chak",
        "zip_codes": [
            10160
        ],
        "district_id": 1022
    },
    {
        "id": 102207,
        "name_th": "บางแวก",
        "name_en": "Bang Waek",
        "zip_codes": [
            10160
        ],
        "district_id": 1022
    },
    {
        "id": 102208,
        "name_th": "คลองขวาง",
        "name_en": "Khlong Khwang",
        "zip_codes": [
            10160
        ],
        "district_id": 1022
    },
    {
        "id": 102209,
        "name_th": "ปากคลองภาษีเจริญ",
        "name_en": "Pak Khlong Phasi Charoen",
        "zip_codes": [
            10160
        ],
        "district_id": 1022
    },
    {
        "id": 102210,
        "name_th": "คูหาสวรรค์",
        "name_en": "Khuha Sawan",
        "zip_codes": [
            10160
        ],
        "district_id": 1022
    },
    {
        "id": 102302,
        "name_th": "หนองแขม",
        "name_en": "Nong Khaem",
        "zip_codes": [
            10160
        ],
        "district_id": 1023
    },
    {
        "id": 102303,
        "name_th": "หนองค้างพลู",
        "name_en": "Nong Khang Phlu",
        "zip_codes": [
            10160
        ],
        "district_id": 1023
    },
    {
        "id": 102401,
        "name_th": "ราษฎร์บูรณะ",
        "name_en": "Rat Burana",
        "zip_codes": [
            10140
        ],
        "district_id": 1024
    },
    {
        "id": 102402,
        "name_th": "บางปะกอก",
        "name_en": "Bang Pa Kok",
        "zip_codes": [
            10140
        ],
        "district_id": 1024
    },
    {
        "id": 102501,
        "name_th": "บางพลัด",
        "name_en": "Bang Phlat",
        "zip_codes": [
            10700
        ],
        "district_id": 1025
    },
    {
        "id": 102502,
        "name_th": "บางอ้อ",
        "name_en": "Bang O",
        "zip_codes": [
            10700
        ],
        "district_id": 1025
    },
    {
        "id": 102503,
        "name_th": "บางบำหรุ",
        "name_en": "Bang Bamru",
        "zip_codes": [
            10700
        ],
        "district_id": 1025
    },
    {
        "id": 102504,
        "name_th": "บางยี่ขัน",
        "name_en": "Bang Yi Khan",
        "zip_codes": [
            10700
        ],
        "district_id": 1025
    },
    {
        "id": 102601,
        "name_th": "ดินแดง",
        "name_en": "Din Daeng",
        "zip_codes": [
            10400
        ],
        "district_id": 1026
    },
    {
        "id": 102602,
        "name_th": "รัชดาภิเษก",
        "name_en": "Ratchadaphisek",
        "zip_codes": [
            10400
        ],
        "district_id": 1026
    },
    {
        "id": 102701,
        "name_th": "คลองกุ่ม",
        "name_en": "Khlong Kum",
        "zip_codes": [
            10230,
            10240
        ],
        "district_id": 1027
    },
    {
        "id": 102704,
        "name_th": "นวมินทร์",
        "name_en": "Nawamin",
        "zip_codes": [
            10240
        ],
        "district_id": 1027
    },
    {
        "id": 102705,
        "name_th": "นวลจันทร์",
        "name_en": "Nuan Chan",
        "zip_codes": [
            10230
        ],
        "district_id": 1027
    },
    {
        "id": 102801,
        "name_th": "ทุ่งวัดดอน",
        "name_en": "Thung Wat Don",
        "zip_codes": [
            10120
        ],
        "district_id": 1028
    },
    {
        "id": 102802,
        "name_th": "ยานนาวา",
        "name_en": "Yan Nawa",
        "zip_codes": [
            10120
        ],
        "district_id": 1028
    },
    {
        "id": 102803,
        "name_th": "ทุ่งมหาเมฆ",
        "name_en": "Thung Maha Mek",
        "zip_codes": [
            10120
        ],
        "district_id": 1028
    },
    {
        "id": 102901,
        "name_th": "บางซื่อ",
        "name_en": "Bang Sue",
        "zip_codes": [
            10800
        ],
        "district_id": 1029
    },
    {
        "id": 102902,
        "name_th": "วงศ์สว่าง",
        "name_en": "Wong Sawang",
        "zip_codes": [
            10800
        ],
        "district_id": 1029
    },
    {
        "id": 103001,
        "name_th": "ลาดยาว",
        "name_en": "Lat Yao",
        "zip_codes": [
            10900
        ],
        "district_id": 1030
    },
    {
        "id": 103002,
        "name_th": "เสนานิคม",
        "name_en": "Sena Nikhom",
        "zip_codes": [
            10900
        ],
        "district_id": 1030
    },
    {
        "id": 103003,
        "name_th": "จันทรเกษม",
        "name_en": "Chan Kasem",
        "zip_codes": [
            10900
        ],
        "district_id": 1030
    },
    {
        "id": 103004,
        "name_th": "จอมพล",
        "name_en": "Chom Phon",
        "zip_codes": [
            10900
        ],
        "district_id": 1030
    },
    {
        "id": 103005,
        "name_th": "จตุจักร",
        "name_en": "Chatuchak",
        "zip_codes": [
            10900
        ],
        "district_id": 1030
    },
    {
        "id": 103101,
        "name_th": "บางคอแหลม",
        "name_en": "Bang Kho Laem",
        "zip_codes": [
            10120
        ],
        "district_id": 1031
    },
    {
        "id": 103102,
        "name_th": "วัดพระยาไกร",
        "name_en": "Wat Phraya Krai",
        "zip_codes": [
            10120
        ],
        "district_id": 1031
    },
    {
        "id": 103103,
        "name_th": "บางโคล่",
        "name_en": "Bang Khlo",
        "zip_codes": [
            10120
        ],
        "district_id": 1031
    },
    {
        "id": 103201,
        "name_th": "ประเวศ",
        "name_en": "Prawet",
        "zip_codes": [
            10250
        ],
        "district_id": 1032
    },
    {
        "id": 103202,
        "name_th": "หนองบอน",
        "name_en": "Nong Bon",
        "zip_codes": [
            10250
        ],
        "district_id": 1032
    },
    {
        "id": 103203,
        "name_th": "ดอกไม้",
        "name_en": "Dok Mai",
        "zip_codes": [
            10250
        ],
        "district_id": 1032
    },
    {
        "id": 103301,
        "name_th": "คลองเตย",
        "name_en": "Khlong Toei",
        "zip_codes": [
            10110
        ],
        "district_id": 1033
    },
    {
        "id": 103302,
        "name_th": "คลองตัน",
        "name_en": "Khlong Tan",
        "zip_codes": [
            10110
        ],
        "district_id": 1033
    },
    {
        "id": 103303,
        "name_th": "พระโขนง",
        "name_en": "Phra Khanong",
        "zip_codes": [
            10110,
            10260
        ],
        "district_id": 1033
    },
    {
        "id": 103401,
        "name_th": "สวนหลวง",
        "name_en": "Suan Luang",
        "zip_codes": [
            10250
        ],
        "district_id": 1034
    },
    {
        "id": 103402,
        "name_th": "อ่อนนุช",
        "name_en": "On Nut",
        "zip_codes": [
            10250
        ],
        "district_id": 1034
    },
    {
        "id": 103403,
        "name_th": "พัฒนาการ",
        "name_en": "Phatthanakan",
        "zip_codes": [
            10250
        ],
        "district_id": 1034
    },
    {
        "id": 103501,
        "name_th": "บางขุนเทียน",
        "name_en": "Bang Khun Thian",
        "zip_codes": [
            10150
        ],
        "district_id": 1035
    },
    {
        "id": 103502,
        "name_th": "บางค้อ",
        "name_en": "Bang Kho",
        "zip_codes": [
            10150
        ],
        "district_id": 1035
    },
    {
        "id": 103503,
        "name_th": "บางมด",
        "name_en": "Bang Mot",
        "zip_codes": [
            10150
        ],
        "district_id": 1035
    },
    {
        "id": 103504,
        "name_th": "จอมทอง",
        "name_en": "Chom Thong",
        "zip_codes": [
            10150
        ],
        "district_id": 1035
    },
    {
        "id": 103602,
        "name_th": "สีกัน",
        "name_en": "Si Kan",
        "zip_codes": [
            10210
        ],
        "district_id": 1036
    },
    {
        "id": 103604,
        "name_th": "ดอนเมือง",
        "name_en": "Don Mueang",
        "zip_codes": [
            10210
        ],
        "district_id": 1036
    },
    {
        "id": 103605,
        "name_th": "สนามบิน",
        "name_en": "Sanam Bin",
        "zip_codes": [
            10210
        ],
        "district_id": 1036
    },
    {
        "id": 103701,
        "name_th": "ทุ่งพญาไท",
        "name_en": "Thung Phaya Thai",
        "zip_codes": [
            10400
        ],
        "district_id": 1037
    },
    {
        "id": 103702,
        "name_th": "ถนนพญาไท",
        "name_en": "Thanon Phaya Thai",
        "zip_codes": [
            10400
        ],
        "district_id": 1037
    },
    {
        "id": 103703,
        "name_th": "ถนนเพชรบุรี",
        "name_en": "Thanon Phetchaburi",
        "zip_codes": [
            10400
        ],
        "district_id": 1037
    },
    {
        "id": 103704,
        "name_th": "มักกะสัน",
        "name_en": "Makkasan",
        "zip_codes": [
            10400
        ],
        "district_id": 1037
    },
    {
        "id": 103801,
        "name_th": "ลาดพร้าว",
        "name_en": "Lat Phrao",
        "zip_codes": [
            10230
        ],
        "district_id": 1038
    },
    {
        "id": 103802,
        "name_th": "จรเข้บัว",
        "name_en": "Chorakhe Bua",
        "zip_codes": [
            10230
        ],
        "district_id": 1038
    },
    {
        "id": 103901,
        "name_th": "คลองเตยเหนือ",
        "name_en": "Khlong Toei Nuea",
        "zip_codes": [
            10110
        ],
        "district_id": 1039
    },
    {
        "id": 103902,
        "name_th": "คลองตันเหนือ",
        "name_en": "Khlong Tan Nuea",
        "zip_codes": [
            10110
        ],
        "district_id": 1039
    },
    {
        "id": 103903,
        "name_th": "พระโขนงเหนือ",
        "name_en": "Phra Khanong Nuea",
        "zip_codes": [
            10110,
            10260
        ],
        "district_id": 1039
    },
    {
        "id": 104001,
        "name_th": "บางแค",
        "name_en": "Bang Khae",
        "zip_codes": [
            10160
        ],
        "district_id": 1040
    },
    {
        "id": 104002,
        "name_th": "บางแคเหนือ",
        "name_en": "Bang Khae Nuea",
        "zip_codes": [
            10160
        ],
        "district_id": 1040
    },
    {
        "id": 104003,
        "name_th": "บางไผ่",
        "name_en": "Bang Phai",
        "zip_codes": [
            10160
        ],
        "district_id": 1040
    },
    {
        "id": 104004,
        "name_th": "หลักสอง",
        "name_en": "Lak Song",
        "zip_codes": [
            10160
        ],
        "district_id": 1040
    },
    {
        "id": 104101,
        "name_th": "ทุ่งสองห้อง",
        "name_en": "Thung Song Hong",
        "zip_codes": [
            10210
        ],
        "district_id": 1041
    },
    {
        "id": 104102,
        "name_th": "ตลาดบางเขน",
        "name_en": "Talat Bang Khen",
        "zip_codes": [
            10210
        ],
        "district_id": 1041
    },
    {
        "id": 104201,
        "name_th": "สายไหม",
        "name_en": "Sai Mai",
        "zip_codes": [
            10220
        ],
        "district_id": 1042
    },
    {
        "id": 104202,
        "name_th": "ออเงิน",
        "name_en": "O Ngoen",
        "zip_codes": [
            10220
        ],
        "district_id": 1042
    },
    {
        "id": 104203,
        "name_th": "คลองถนน",
        "name_en": "Khlong Thanon",
        "zip_codes": [
            10220
        ],
        "district_id": 1042
    },
    {
        "id": 104301,
        "name_th": "คันนายาว",
        "name_en": "Khan Na Yao",
        "zip_codes": [
            10230
        ],
        "district_id": 1043
    },
    {
        "id": 104302,
        "name_th": "รามอินทรา",
        "name_en": "Ram Inthra",
        "zip_codes": [
            10230
        ],
        "district_id": 1043
    },
    {
        "id": 104401,
        "name_th": "สะพานสูง",
        "name_en": "Saphan Sung",
        "zip_codes": [
            10240,
            10250
        ],
        "district_id": 1044
    },
    {
        "id": 104402,
        "name_th": "ราษฎร์พัฒนา",
        "name_en": "Rat Phatthana",
        "zip_codes": [
            10240
        ],
        "district_id": 1044
    },
    {
        "id": 104403,
        "name_th": "ทับช้าง",
        "name_en": "Thap Chang",
        "zip_codes": [
            10250
        ],
        "district_id": 1044
    },
    {
        "id": 104501,
        "name_th": "วังทองหลาง",
        "name_en": "Wang Thonglang",
        "zip_codes": [
            10310
        ],
        "district_id": 1045
    },
    {
        "id": 104502,
        "name_th": "สะพานสอง",
        "name_en": "Saphan Song",
        "zip_codes": [
            10310
        ],
        "district_id": 1045
    },
    {
        "id": 104503,
        "name_th": "คลองเจ้าคุณสิงห์",
        "name_en": "Khlong Chao Khun Sing",
        "zip_codes": [
            10310
        ],
        "district_id": 1045
    },
    {
        "id": 104504,
        "name_th": "พลับพลา",
        "name_en": "Phlapphla",
        "zip_codes": [
            10310
        ],
        "district_id": 1045
    },
    {
        "id": 104601,
        "name_th": "สามวาตะวันตก",
        "name_en": "Sam Wa Tawan Tok",
        "zip_codes": [
            10510
        ],
        "district_id": 1046
    },
    {
        "id": 104602,
        "name_th": "สามวาตะวันออก",
        "name_en": "Sam Wa Tawan Ok",
        "zip_codes": [
            10510
        ],
        "district_id": 1046
    },
    {
        "id": 104603,
        "name_th": "บางชัน",
        "name_en": "Bang Chan",
        "zip_codes": [
            10510
        ],
        "district_id": 1046
    },
    {
        "id": 104604,
        "name_th": "ทรายกองดิน",
        "name_en": "Sai Kong Din",
        "zip_codes": [
            10510
        ],
        "district_id": 1046
    },
    {
        "id": 104605,
        "name_th": "ทรายกองดินใต้",
        "name_en": "Sai Kong Din Tai",
        "zip_codes": [
            10510
        ],
        "district_id": 1046
    },
    {
        "id": 104702,
        "name_th": "บางนาเหนือ",
        "name_en": "Bang Na Nuea",
        "zip_codes": [
            10260
        ],
        "district_id": 1047
    },
    {
        "id": 104703,
        "name_th": "บางนาใต้",
        "name_en": "Bang Na Tai",
        "zip_codes": [
            10260
        ],
        "district_id": 1047
    },
    {
        "id": 104801,
        "name_th": "ทวีวัฒนา",
        "name_en": "Thawi Watthana",
        "zip_codes": [
            10170
        ],
        "district_id": 1048
    },
    {
        "id": 104802,
        "name_th": "ศาลาธรรมสพน์",
        "name_en": "Sala Thammasop",
        "zip_codes": [
            10170
        ],
        "district_id": 1048
    },
    {
        "id": 104901,
        "name_th": "บางมด",
        "name_en": "Bang Mot",
        "zip_codes": [
            10140
        ],
        "district_id": 1049
    },
    {
        "id": 104902,
        "name_th": "ทุ่งครุ",
        "name_en": "Thung Khru",
        "zip_codes": [
            10140
        ],
        "district_id": 1049
    },
    {
        "id": 105002,
        "name_th": "บางบอนเหนือ",
        "name_en": "Bang Bon Nuea",
        "zip_codes": [
            10150
        ],
        "district_id": 1050
    },
    {
        "id": 105003,
        "name_th": "บางบอนใต้",
        "name_en": "Bang Bon Tai",
        "zip_codes": [
            10150
        ],
        "district_id": 1050
    },
    {
        "id": 105004,
        "name_th": "คลองบางพราน",
        "name_en": "Khlong Bang Phran",
        "zip_codes": [
            10150
        ],
        "district_id": 1050
    },
    {
        "id": 105005,
        "name_th": "คลองบางบอน",
        "name_en": "Khlong Bang Bon",
        "zip_codes": [
            10150
        ],
        "district_id": 1050
    },
    {
        "id": 110101,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            10270
        ],
        "district_id": 1101
    },
    {
        "id": 110102,
        "name_th": "สำโรงเหนือ",
        "name_en": "Samrong Nuea",
        "zip_codes": [
            10270
        ],
        "district_id": 1101
    },
    {
        "id": 110103,
        "name_th": "บางเมือง",
        "name_en": "Bang Mueang",
        "zip_codes": [
            10270
        ],
        "district_id": 1101
    },
    {
        "id": 110104,
        "name_th": "ท้ายบ้าน",
        "name_en": "Thai Ban",
        "zip_codes": [
            10280
        ],
        "district_id": 1101
    },
    {
        "id": 110108,
        "name_th": "บางปูใหม่",
        "name_en": "Bang Pu Mai",
        "zip_codes": [
            10280
        ],
        "district_id": 1101
    },
    {
        "id": 110110,
        "name_th": "แพรกษา",
        "name_en": "Phraek Sa",
        "zip_codes": [
            10280
        ],
        "district_id": 1101
    },
    {
        "id": 110111,
        "name_th": "บางโปรง",
        "name_en": "Bang Prong",
        "zip_codes": [
            10270
        ],
        "district_id": 1101
    },
    {
        "id": 110112,
        "name_th": "บางปู",
        "name_en": "Bang Pu",
        "zip_codes": [
            10280
        ],
        "district_id": 1101
    },
    {
        "id": 110113,
        "name_th": "บางด้วน",
        "name_en": "Bang Duan",
        "zip_codes": [
            10270
        ],
        "district_id": 1101
    },
    {
        "id": 110114,
        "name_th": "บางเมืองใหม่",
        "name_en": "Bang Mueang Mai",
        "zip_codes": [
            10270
        ],
        "district_id": 1101
    },
    {
        "id": 110115,
        "name_th": "เทพารักษ์",
        "name_en": "Thepharak",
        "zip_codes": [
            10270
        ],
        "district_id": 1101
    },
    {
        "id": 110116,
        "name_th": "ท้ายบ้านใหม่",
        "name_en": "Thai Ban Mai",
        "zip_codes": [
            10280
        ],
        "district_id": 1101
    },
    {
        "id": 110117,
        "name_th": "แพรกษาใหม่",
        "name_en": "Phraek Sa Mai",
        "zip_codes": [
            10280
        ],
        "district_id": 1101
    },
    {
        "id": 110201,
        "name_th": "บางบ่อ",
        "name_en": "Bang Bo",
        "zip_codes": [
            10560
        ],
        "district_id": 1102
    },
    {
        "id": 110202,
        "name_th": "บ้านระกาศ",
        "name_en": "Ban Rakat",
        "zip_codes": [
            10560
        ],
        "district_id": 1102
    },
    {
        "id": 110203,
        "name_th": "บางพลีน้อย",
        "name_en": "Bang Phli Noi",
        "zip_codes": [
            10560
        ],
        "district_id": 1102
    },
    {
        "id": 110204,
        "name_th": "บางเพรียง",
        "name_en": "Bang Phriang",
        "zip_codes": [
            10560
        ],
        "district_id": 1102
    },
    {
        "id": 110205,
        "name_th": "คลองด่าน",
        "name_en": "Khlong Dan",
        "zip_codes": [
            10550
        ],
        "district_id": 1102
    },
    {
        "id": 110206,
        "name_th": "คลองสวน",
        "name_en": "Khlong Suan",
        "zip_codes": [
            10560
        ],
        "district_id": 1102
    },
    {
        "id": 110207,
        "name_th": "เปร็ง",
        "name_en": "Preng",
        "zip_codes": [
            10560
        ],
        "district_id": 1102
    },
    {
        "id": 110208,
        "name_th": "คลองนิยมยาตรา",
        "name_en": "Khlong Niyom Yattra",
        "zip_codes": [
            10560
        ],
        "district_id": 1102
    },
    {
        "id": 110301,
        "name_th": "บางพลีใหญ่",
        "name_en": "Blang Phli Yai",
        "zip_codes": [
            10540
        ],
        "district_id": 1103
    },
    {
        "id": 110302,
        "name_th": "บางแก้ว",
        "name_en": "Bang Kaeo",
        "zip_codes": [
            10540
        ],
        "district_id": 1103
    },
    {
        "id": 110303,
        "name_th": "บางปลา",
        "name_en": "Bang Pla",
        "zip_codes": [
            10540
        ],
        "district_id": 1103
    },
    {
        "id": 110304,
        "name_th": "บางโฉลง",
        "name_en": "Bang Chalong",
        "zip_codes": [
            10540
        ],
        "district_id": 1103
    },
    {
        "id": 110308,
        "name_th": "ราชาเทวะ",
        "name_en": "Racha Thewa",
        "zip_codes": [
            10540
        ],
        "district_id": 1103
    },
    {
        "id": 110309,
        "name_th": "หนองปรือ",
        "name_en": "Nong Prue",
        "zip_codes": [
            10540
        ],
        "district_id": 1103
    },
    {
        "id": 110401,
        "name_th": "ตลาด",
        "name_en": "Talat",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110402,
        "name_th": "บางพึ่ง",
        "name_en": "Bang Phueng",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110403,
        "name_th": "บางจาก",
        "name_en": "Bang Chak",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110404,
        "name_th": "บางครุ",
        "name_en": "Bang Khru",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110405,
        "name_th": "บางหญ้าแพรก",
        "name_en": "Bang Ya Phraek",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110406,
        "name_th": "บางหัวเสือ",
        "name_en": "Bang Hua Suea",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110407,
        "name_th": "สำโรงใต้",
        "name_en": "Samrong Tai",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110408,
        "name_th": "บางยอ",
        "name_en": "Bang Yo",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110409,
        "name_th": "บางกะเจ้า",
        "name_en": "Bang Kachao",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110410,
        "name_th": "บางน้ำผึ้ง",
        "name_en": "Bang Nam Phueng",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110411,
        "name_th": "บางกระสอบ",
        "name_en": "Bang Krasop",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110412,
        "name_th": "บางกอบัว",
        "name_en": "Bang Ko Bua",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110413,
        "name_th": "ทรงคนอง",
        "name_en": "Song Khanong",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110414,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110415,
        "name_th": "สำโรงกลาง",
        "name_en": "Samrong Klang",
        "zip_codes": [
            10130
        ],
        "district_id": 1104
    },
    {
        "id": 110501,
        "name_th": "นาเกลือ",
        "name_en": "Na Kluea",
        "zip_codes": [
            10290
        ],
        "district_id": 1105
    },
    {
        "id": 110502,
        "name_th": "บ้านคลองสวน",
        "name_en": "Ban Khlong Suan",
        "zip_codes": [
            10290
        ],
        "district_id": 1105
    },
    {
        "id": 110503,
        "name_th": "แหลมฟ้าผ่า",
        "name_en": "Laem Fa Pha",
        "zip_codes": [
            10290
        ],
        "district_id": 1105
    },
    {
        "id": 110504,
        "name_th": "ปากคลองบางปลากด",
        "name_en": "Pak Khlong Bang Pla Kot",
        "zip_codes": [
            10290
        ],
        "district_id": 1105
    },
    {
        "id": 110505,
        "name_th": "ในคลองบางปลากด",
        "name_en": "Nai Khlong Bang Pla Kot",
        "zip_codes": [
            10290
        ],
        "district_id": 1105
    },
    {
        "id": 110601,
        "name_th": "บางเสาธง",
        "name_en": "Bang Sao Thong",
        "zip_codes": [
            10570
        ],
        "district_id": 1106
    },
    {
        "id": 110602,
        "name_th": "ศีรษะจรเข้น้อย",
        "name_en": "Sisa Chorakhe Noi",
        "zip_codes": [
            10570
        ],
        "district_id": 1106
    },
    {
        "id": 110603,
        "name_th": "ศีรษะจรเข้ใหญ่",
        "name_en": "Sisa Chorakhe Yai",
        "zip_codes": [
            10570
        ],
        "district_id": 1106
    },
    {
        "id": 120101,
        "name_th": "สวนใหญ่",
        "name_en": "Suan Yai",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120102,
        "name_th": "ตลาดขวัญ",
        "name_en": "Talat Khwan",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120103,
        "name_th": "บางเขน",
        "name_en": "Bang Khen",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120104,
        "name_th": "บางกระสอ",
        "name_en": "Bang Kraso",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120105,
        "name_th": "ท่าทราย",
        "name_en": "Tha Sai",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120106,
        "name_th": "บางไผ่",
        "name_en": "Bang Phai",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120107,
        "name_th": "บางศรีเมือง",
        "name_en": "Bang Si Mueang",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120108,
        "name_th": "บางกร่าง",
        "name_en": "Bang Krang",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120109,
        "name_th": "ไทรม้า",
        "name_en": "Sai Ma",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120110,
        "name_th": "บางรักน้อย",
        "name_en": "Bang Rak Noi",
        "zip_codes": [
            11000
        ],
        "district_id": 1201
    },
    {
        "id": 120201,
        "name_th": "วัดชลอ",
        "name_en": "Wat Chalo",
        "zip_codes": [
            11130
        ],
        "district_id": 1202
    },
    {
        "id": 120202,
        "name_th": "บางกรวย",
        "name_en": "Bang Kruai",
        "zip_codes": [
            11130
        ],
        "district_id": 1202
    },
    {
        "id": 120203,
        "name_th": "บางสีทอง",
        "name_en": "Bang Si Thong",
        "zip_codes": [
            11130
        ],
        "district_id": 1202
    },
    {
        "id": 120204,
        "name_th": "บางขนุน",
        "name_en": "Bang Khanun",
        "zip_codes": [
            11130
        ],
        "district_id": 1202
    },
    {
        "id": 120205,
        "name_th": "บางขุนกอง",
        "name_en": "Bang Khun Kong",
        "zip_codes": [
            11130
        ],
        "district_id": 1202
    },
    {
        "id": 120206,
        "name_th": "บางคูเวียง",
        "name_en": "Bang Khu Wiang",
        "zip_codes": [
            11130
        ],
        "district_id": 1202
    },
    {
        "id": 120207,
        "name_th": "มหาสวัสดิ์",
        "name_en": "Maha Sawat",
        "zip_codes": [
            11130
        ],
        "district_id": 1202
    },
    {
        "id": 120208,
        "name_th": "ปลายบาง",
        "name_en": "Plai Bang",
        "zip_codes": [
            11130
        ],
        "district_id": 1202
    },
    {
        "id": 120209,
        "name_th": "ศาลากลาง",
        "name_en": "Sala Klang",
        "zip_codes": [
            11130
        ],
        "district_id": 1202
    },
    {
        "id": 120301,
        "name_th": "บางม่วง",
        "name_en": "Bang Muang",
        "zip_codes": [
            11140
        ],
        "district_id": 1203
    },
    {
        "id": 120302,
        "name_th": "บางแม่นาง",
        "name_en": "Bang Mae Nang",
        "zip_codes": [
            11140
        ],
        "district_id": 1203
    },
    {
        "id": 120303,
        "name_th": "บางเลน",
        "name_en": "Bang Len",
        "zip_codes": [
            11140
        ],
        "district_id": 1203
    },
    {
        "id": 120304,
        "name_th": "เสาธงหิน",
        "name_en": "Sao Thong Hin",
        "zip_codes": [
            11140
        ],
        "district_id": 1203
    },
    {
        "id": 120305,
        "name_th": "บางใหญ่",
        "name_en": "Bang Yai",
        "zip_codes": [
            11140
        ],
        "district_id": 1203
    },
    {
        "id": 120306,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            11140
        ],
        "district_id": 1203
    },
    {
        "id": 120401,
        "name_th": "โสนลอย",
        "name_en": "Sano Loi",
        "zip_codes": [
            11110
        ],
        "district_id": 1204
    },
    {
        "id": 120402,
        "name_th": "บางบัวทอง",
        "name_en": "Bang Bua Thong",
        "zip_codes": [
            11110
        ],
        "district_id": 1204
    },
    {
        "id": 120403,
        "name_th": "บางรักใหญ่",
        "name_en": "Bang Rak Yai",
        "zip_codes": [
            11110
        ],
        "district_id": 1204
    },
    {
        "id": 120404,
        "name_th": "บางคูรัด",
        "name_en": "Bang Khu Rat",
        "zip_codes": [
            11110
        ],
        "district_id": 1204
    },
    {
        "id": 120405,
        "name_th": "ละหาร",
        "name_en": "Lahan",
        "zip_codes": [
            11110
        ],
        "district_id": 1204
    },
    {
        "id": 120406,
        "name_th": "ลำโพ",
        "name_en": "Lam Pho",
        "zip_codes": [
            11110
        ],
        "district_id": 1204
    },
    {
        "id": 120407,
        "name_th": "พิมลราช",
        "name_en": "Phimon Rat",
        "zip_codes": [
            11110
        ],
        "district_id": 1204
    },
    {
        "id": 120408,
        "name_th": "บางรักพัฒนา",
        "name_en": "Bang Rak Phatthana",
        "zip_codes": [
            11110
        ],
        "district_id": 1204
    },
    {
        "id": 120501,
        "name_th": "ไทรน้อย",
        "name_en": "Sai Noi",
        "zip_codes": [
            11150
        ],
        "district_id": 1205
    },
    {
        "id": 120502,
        "name_th": "ราษฎร์นิยม",
        "name_en": "Rat Niyom",
        "zip_codes": [
            11150
        ],
        "district_id": 1205
    },
    {
        "id": 120503,
        "name_th": "หนองเพรางาย",
        "name_en": "Nong Phrao Ngai",
        "zip_codes": [
            11150
        ],
        "district_id": 1205
    },
    {
        "id": 120504,
        "name_th": "ไทรใหญ่",
        "name_en": "Sai Yai",
        "zip_codes": [
            11150
        ],
        "district_id": 1205
    },
    {
        "id": 120505,
        "name_th": "ขุนศรี",
        "name_en": "Khun Si",
        "zip_codes": [
            11150
        ],
        "district_id": 1205
    },
    {
        "id": 120506,
        "name_th": "คลองขวาง",
        "name_en": "Khlong Khwang",
        "zip_codes": [
            11150
        ],
        "district_id": 1205
    },
    {
        "id": 120507,
        "name_th": "ทวีวัฒนา",
        "name_en": "Thawi Watthana",
        "zip_codes": [
            11150
        ],
        "district_id": 1205
    },
    {
        "id": 120601,
        "name_th": "ปากเกร็ด",
        "name_en": "Pak Kret",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120602,
        "name_th": "บางตลาด",
        "name_en": "Bang Talat",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120603,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120604,
        "name_th": "บางพูด",
        "name_en": "Bang Phut",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120605,
        "name_th": "บางตะไนย์",
        "name_en": "Bang Tanai",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120606,
        "name_th": "คลองพระอุดม",
        "name_en": "Khlong Phra Udom",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120607,
        "name_th": "ท่าอิฐ",
        "name_en": "Tha It",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120608,
        "name_th": "เกาะเกร็ด",
        "name_en": "Ko Kret",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120609,
        "name_th": "อ้อมเกร็ด",
        "name_en": "Om Kret",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120610,
        "name_th": "คลองข่อย",
        "name_en": "Khlong Khoi",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120611,
        "name_th": "บางพลับ",
        "name_en": "Bang Phlap",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 120612,
        "name_th": "คลองเกลือ",
        "name_en": "Khlong Kluea",
        "zip_codes": [
            11120
        ],
        "district_id": 1206
    },
    {
        "id": 130101,
        "name_th": "บางปรอก",
        "name_en": "Bang Prok",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130102,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130103,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130104,
        "name_th": "บ้านฉาง",
        "name_en": "Ban Chang",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130105,
        "name_th": "บ้านกระแชง",
        "name_en": "Ban Krachaeng",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130106,
        "name_th": "บางขะแยง",
        "name_en": "Bang Khayaeng",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130107,
        "name_th": "บางคูวัด",
        "name_en": "Bang Khu Wat",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130108,
        "name_th": "บางหลวง",
        "name_en": "Bang Luang",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130109,
        "name_th": "บางเดื่อ",
        "name_en": "Bang Duea",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130110,
        "name_th": "บางพูด",
        "name_en": "Bang Phut",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130111,
        "name_th": "บางพูน",
        "name_en": "Bang Phun",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130112,
        "name_th": "บางกะดี",
        "name_en": "Bang Kadi",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130113,
        "name_th": "สวนพริกไทย",
        "name_en": "Suan Phrik Thai",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130114,
        "name_th": "หลักหก",
        "name_en": "Lak Hok",
        "zip_codes": [
            12000
        ],
        "district_id": 1301
    },
    {
        "id": 130201,
        "name_th": "คลองหนึ่ง",
        "name_en": "Khlong Nueng",
        "zip_codes": [
            12120,
            12121,
            13180
        ],
        "district_id": 1302
    },
    {
        "id": 130202,
        "name_th": "คลองสอง",
        "name_en": "Khlong Song",
        "zip_codes": [
            12120
        ],
        "district_id": 1302
    },
    {
        "id": 130203,
        "name_th": "คลองสาม",
        "name_en": "Khlong Sam",
        "zip_codes": [
            12120
        ],
        "district_id": 1302
    },
    {
        "id": 130204,
        "name_th": "คลองสี่",
        "name_en": "Khlong Si",
        "zip_codes": [
            12120
        ],
        "district_id": 1302
    },
    {
        "id": 130205,
        "name_th": "คลองห้า",
        "name_en": "Khlong Ha",
        "zip_codes": [
            12110,
            12120
        ],
        "district_id": 1302
    },
    {
        "id": 130206,
        "name_th": "คลองหก",
        "name_en": "Khlong Hok",
        "zip_codes": [
            12110,
            12120
        ],
        "district_id": 1302
    },
    {
        "id": 130207,
        "name_th": "คลองเจ็ด",
        "name_en": "Khlong Chet",
        "zip_codes": [
            12120
        ],
        "district_id": 1302
    },
    {
        "id": 130301,
        "name_th": "ประชาธิปัตย์",
        "name_en": "Prachathipat",
        "zip_codes": [
            12130
        ],
        "district_id": 1303
    },
    {
        "id": 130302,
        "name_th": "บึงยี่โถ",
        "name_en": "Bueng Yitho",
        "zip_codes": [
            12130
        ],
        "district_id": 1303
    },
    {
        "id": 130303,
        "name_th": "รังสิต",
        "name_en": "Rangsit",
        "zip_codes": [
            12110
        ],
        "district_id": 1303
    },
    {
        "id": 130304,
        "name_th": "ลำผักกูด",
        "name_en": "Lam Phak Kut",
        "zip_codes": [
            12110
        ],
        "district_id": 1303
    },
    {
        "id": 130305,
        "name_th": "บึงสนั่น",
        "name_en": "Bueng Sanan",
        "zip_codes": [
            12110
        ],
        "district_id": 1303
    },
    {
        "id": 130306,
        "name_th": "บึงน้ำรักษ์",
        "name_en": "Bueng Nam Rak",
        "zip_codes": [
            12110
        ],
        "district_id": 1303
    },
    {
        "id": 130401,
        "name_th": "บึงบา",
        "name_en": "Bueng Ba",
        "zip_codes": [
            12170
        ],
        "district_id": 1304
    },
    {
        "id": 130402,
        "name_th": "บึงบอน",
        "name_en": "Bueng Bon",
        "zip_codes": [
            12170
        ],
        "district_id": 1304
    },
    {
        "id": 130403,
        "name_th": "บึงกาสาม",
        "name_en": "Bueng Ka Sam",
        "zip_codes": [
            12170
        ],
        "district_id": 1304
    },
    {
        "id": 130404,
        "name_th": "บึงชำอ้อ",
        "name_en": "Bueng Cham O",
        "zip_codes": [
            12170
        ],
        "district_id": 1304
    },
    {
        "id": 130405,
        "name_th": "หนองสามวัง",
        "name_en": "Nong Sam Wang",
        "zip_codes": [
            12170
        ],
        "district_id": 1304
    },
    {
        "id": 130406,
        "name_th": "ศาลาครุ",
        "name_en": "Sala Khru",
        "zip_codes": [
            12170
        ],
        "district_id": 1304
    },
    {
        "id": 130407,
        "name_th": "นพรัตน์",
        "name_en": "Noppharat",
        "zip_codes": [
            12170
        ],
        "district_id": 1304
    },
    {
        "id": 130501,
        "name_th": "ระแหง",
        "name_en": "Rahaeng",
        "zip_codes": [
            12140
        ],
        "district_id": 1305
    },
    {
        "id": 130502,
        "name_th": "ลาดหลุมแก้ว",
        "name_en": "Lat Lum Kaeo",
        "zip_codes": [
            12140
        ],
        "district_id": 1305
    },
    {
        "id": 130503,
        "name_th": "คูบางหลวง",
        "name_en": "Khu Bang Luang",
        "zip_codes": [
            12140
        ],
        "district_id": 1305
    },
    {
        "id": 130504,
        "name_th": "คูขวาง",
        "name_en": "Khu Khwang",
        "zip_codes": [
            12140
        ],
        "district_id": 1305
    },
    {
        "id": 130505,
        "name_th": "คลองพระอุดม",
        "name_en": "Khlong Phra Udom",
        "zip_codes": [
            12140
        ],
        "district_id": 1305
    },
    {
        "id": 130506,
        "name_th": "บ่อเงิน",
        "name_en": "Bo Ngoen",
        "zip_codes": [
            12140
        ],
        "district_id": 1305
    },
    {
        "id": 130507,
        "name_th": "หน้าไม้",
        "name_en": "Na Mai",
        "zip_codes": [
            12140
        ],
        "district_id": 1305
    },
    {
        "id": 130601,
        "name_th": "คูคต",
        "name_en": "Khu Khot",
        "zip_codes": [
            12130
        ],
        "district_id": 1306
    },
    {
        "id": 130602,
        "name_th": "ลาดสวาย",
        "name_en": "Lat Sawai",
        "zip_codes": [
            12150
        ],
        "district_id": 1306
    },
    {
        "id": 130603,
        "name_th": "บึงคำพร้อย",
        "name_en": "Bueng Kham Phroi",
        "zip_codes": [
            12150
        ],
        "district_id": 1306
    },
    {
        "id": 130604,
        "name_th": "ลำลูกกา",
        "name_en": "Lum Luk Ka",
        "zip_codes": [
            12150
        ],
        "district_id": 1306
    },
    {
        "id": 130605,
        "name_th": "บึงทองหลาง",
        "name_en": "Bueng Thonglang",
        "zip_codes": [
            12150
        ],
        "district_id": 1306
    },
    {
        "id": 130606,
        "name_th": "ลำไทร",
        "name_en": "Lam Sai",
        "zip_codes": [
            12150
        ],
        "district_id": 1306
    },
    {
        "id": 130607,
        "name_th": "บึงคอไห",
        "name_en": "Bueng Kho Hai",
        "zip_codes": [
            12150
        ],
        "district_id": 1306
    },
    {
        "id": 130608,
        "name_th": "พืชอุดม",
        "name_en": "Phuet Udom",
        "zip_codes": [
            12150
        ],
        "district_id": 1306
    },
    {
        "id": 130701,
        "name_th": "บางเตย",
        "name_en": "Bang Toei",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130702,
        "name_th": "คลองควาย",
        "name_en": "Khlong Khwai",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130703,
        "name_th": "สามโคก",
        "name_en": "Sam Khok",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130704,
        "name_th": "กระแชง",
        "name_en": "Krachaeng",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130705,
        "name_th": "บางโพธิ์เหนือ",
        "name_en": "Bang Pho Nuea",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130706,
        "name_th": "เชียงรากใหญ่",
        "name_en": "Chiang Rak Yai",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130707,
        "name_th": "บ้านปทุม",
        "name_en": "Ban Pathum",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130708,
        "name_th": "บ้านงิ้ว",
        "name_en": "Ban Ngio",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130709,
        "name_th": "เชียงรากน้อย",
        "name_en": "Chiang Rak Noi",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130710,
        "name_th": "บางกระบือ",
        "name_en": "Bang Krabue",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 130711,
        "name_th": "ท้ายเกาะ",
        "name_en": "Thai Ko",
        "zip_codes": [
            12160
        ],
        "district_id": 1307
    },
    {
        "id": 140101,
        "name_th": "ประตูชัย",
        "name_en": "Pratu Chai",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140102,
        "name_th": "กะมัง",
        "name_en": "Kamang",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140103,
        "name_th": "หอรัตนไชย",
        "name_en": "Ho Rattanachai",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140104,
        "name_th": "หัวรอ",
        "name_en": "Hua Ro",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140105,
        "name_th": "ท่าวาสุกรี",
        "name_en": "Tha Wasukri",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140106,
        "name_th": "ไผ่ลิง",
        "name_en": "Phai Ling",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140107,
        "name_th": "ปากกราน",
        "name_en": "Pak Kran",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140108,
        "name_th": "ภูเขาทอง",
        "name_en": "Phukhao Thong",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140109,
        "name_th": "สำเภาล่ม",
        "name_en": "Samphao Lom",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140110,
        "name_th": "สวนพริก",
        "name_en": "Suan Phrik",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140111,
        "name_th": "คลองตะเคียน",
        "name_en": "Khlong Takhian",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140112,
        "name_th": "วัดตูม",
        "name_en": "Wat Tum",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140113,
        "name_th": "หันตรา",
        "name_en": "Hantra",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140114,
        "name_th": "ลุมพลี",
        "name_en": "Lumphli",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140115,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140116,
        "name_th": "บ้านเกาะ",
        "name_en": "Ban Ko",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140117,
        "name_th": "คลองสวนพลู",
        "name_en": "Khlong Suan Phlu",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140118,
        "name_th": "คลองสระบัว",
        "name_en": "Khlong Sa Bua",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140119,
        "name_th": "เกาะเรียน",
        "name_en": "Ko Rian",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140120,
        "name_th": "บ้านป้อม",
        "name_en": "Ban Pom",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140121,
        "name_th": "บ้านรุน",
        "name_en": "Ban Run",
        "zip_codes": [
            13000
        ],
        "district_id": 1401
    },
    {
        "id": 140201,
        "name_th": "ท่าเรือ",
        "name_en": "Tha Ruea",
        "zip_codes": [
            13130
        ],
        "district_id": 1402
    },
    {
        "id": 140202,
        "name_th": "จำปา",
        "name_en": "Champa",
        "zip_codes": [
            13130
        ],
        "district_id": 1402
    },
    {
        "id": 140203,
        "name_th": "ท่าหลวง",
        "name_en": "Tha Luang",
        "zip_codes": [
            13130,
            18270
        ],
        "district_id": 1402
    },
    {
        "id": 140204,
        "name_th": "บ้านร่อม",
        "name_en": "Ban Rom",
        "zip_codes": [
            13130
        ],
        "district_id": 1402
    },
    {
        "id": 140205,
        "name_th": "ศาลาลอย",
        "name_en": "Sala Loi",
        "zip_codes": [
            13130
        ],
        "district_id": 1402
    },
    {
        "id": 140206,
        "name_th": "วังแดง",
        "name_en": "Wang Daeng",
        "zip_codes": [
            13130
        ],
        "district_id": 1402
    },
    {
        "id": 140207,
        "name_th": "โพธิ์เอน",
        "name_en": "Pho En",
        "zip_codes": [
            13130
        ],
        "district_id": 1402
    },
    {
        "id": 140208,
        "name_th": "ปากท่า",
        "name_en": "Pak Tha",
        "zip_codes": [
            13130
        ],
        "district_id": 1402
    },
    {
        "id": 140209,
        "name_th": "หนองขนาก",
        "name_en": "Nong Khanak",
        "zip_codes": [
            13130
        ],
        "district_id": 1402
    },
    {
        "id": 140210,
        "name_th": "ท่าเจ้าสนุก",
        "name_en": "Tha Chao Sanuk",
        "zip_codes": [
            13130
        ],
        "district_id": 1402
    },
    {
        "id": 140301,
        "name_th": "นครหลวง",
        "name_en": "Nakhon Luang",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140302,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140303,
        "name_th": "บ่อโพง",
        "name_en": "Bo Phong",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140304,
        "name_th": "บ้านชุ้ง",
        "name_en": "Ban Chung",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140305,
        "name_th": "ปากจั่น",
        "name_en": "Pak Chan",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140306,
        "name_th": "บางระกำ",
        "name_en": "Bang Rakam",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140307,
        "name_th": "บางพระครู",
        "name_en": "Bang Phra Khru",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140308,
        "name_th": "แม่ลา",
        "name_en": "Mae La",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140309,
        "name_th": "หนองปลิง",
        "name_en": "Nong Pling",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140310,
        "name_th": "คลองสะแก",
        "name_en": "Khlong Sakae",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140311,
        "name_th": "สามไถ",
        "name_en": "Sam Thai",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140312,
        "name_th": "พระนอน",
        "name_en": "Phra Non",
        "zip_codes": [
            13260
        ],
        "district_id": 1403
    },
    {
        "id": 140401,
        "name_th": "บางไทร",
        "name_en": "Bang Sai",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140402,
        "name_th": "บางพลี",
        "name_en": "Bang Phli",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140403,
        "name_th": "สนามชัย",
        "name_en": "Sanam Chai",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140404,
        "name_th": "บ้านแป้ง",
        "name_en": "Ban Paeng",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140405,
        "name_th": "หน้าไม้",
        "name_en": "Na Mai",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140406,
        "name_th": "บางยี่โท",
        "name_en": "Bang Yi Tho",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140407,
        "name_th": "แคออก",
        "name_en": "Khae Ok",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140408,
        "name_th": "แคตก",
        "name_en": "Khae Tok",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140409,
        "name_th": "ช่างเหล็ก",
        "name_en": "Chang Lek",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140410,
        "name_th": "กระแชง",
        "name_en": "Krachaeng",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140411,
        "name_th": "บ้านกลึง",
        "name_en": "Ban Klueng",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140412,
        "name_th": "ช้างน้อย",
        "name_en": "Chang Noi",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140413,
        "name_th": "ห่อหมก",
        "name_en": "Homok",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140414,
        "name_th": "ไผ่พระ",
        "name_en": "Phai Phra",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140415,
        "name_th": "กกแก้วบูรพา",
        "name_en": "Kok Kaeo Burapha",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140416,
        "name_th": "ไม้ตรา",
        "name_en": "Mai Tra",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140417,
        "name_th": "บ้านม้า",
        "name_en": "Ban Ma",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140418,
        "name_th": "บ้านเกาะ",
        "name_en": "Ban Ko",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140419,
        "name_th": "ราชคราม",
        "name_en": "Ratchakhram",
        "zip_codes": [
            13290
        ],
        "district_id": 1404
    },
    {
        "id": 140420,
        "name_th": "ช้างใหญ่",
        "name_en": "Chang Yai",
        "zip_codes": [
            13290
        ],
        "district_id": 1404
    },
    {
        "id": 140421,
        "name_th": "โพแตง",
        "name_en": "Pho Taeng",
        "zip_codes": [
            13290
        ],
        "district_id": 1404
    },
    {
        "id": 140422,
        "name_th": "เชียงรากน้อย",
        "name_en": "Chiang Rak Noi",
        "zip_codes": [
            13290
        ],
        "district_id": 1404
    },
    {
        "id": 140423,
        "name_th": "โคกช้าง",
        "name_en": "Khok Chang",
        "zip_codes": [
            13190
        ],
        "district_id": 1404
    },
    {
        "id": 140501,
        "name_th": "บางบาล",
        "name_en": "Bang Ban",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140502,
        "name_th": "วัดยม",
        "name_en": "Wat Yom",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140503,
        "name_th": "ไทรน้อย",
        "name_en": "Sai Noi",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140504,
        "name_th": "สะพานไทย",
        "name_en": "Saphan Thai",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140505,
        "name_th": "มหาพราหมณ์",
        "name_en": "Maha Phram",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140506,
        "name_th": "กบเจา",
        "name_en": "Kop Chao",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140507,
        "name_th": "บ้านคลัง",
        "name_en": "Ban Khlang",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140508,
        "name_th": "พระขาว",
        "name_en": "Phra Khao",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140509,
        "name_th": "น้ำเต้า",
        "name_en": "Nam Tao",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140510,
        "name_th": "ทางช้าง",
        "name_en": "Thang Chang",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140511,
        "name_th": "วัดตะกู",
        "name_en": "Wat Taku",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140512,
        "name_th": "บางหลวง",
        "name_en": "Bang Luang",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140513,
        "name_th": "บางหลวงโดด",
        "name_en": "Bang Luang Dot",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140514,
        "name_th": "บางหัก",
        "name_en": "Bang Hak",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140515,
        "name_th": "บางชะนี",
        "name_en": "Bang Chani",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140516,
        "name_th": "บ้านกุ่ม",
        "name_en": "Ban Kum",
        "zip_codes": [
            13250
        ],
        "district_id": 1405
    },
    {
        "id": 140601,
        "name_th": "บ้านเลน",
        "name_en": "Ban Len",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140602,
        "name_th": "เชียงรากน้อย",
        "name_en": "Chiang Rak Noi",
        "zip_codes": [
            13180
        ],
        "district_id": 1406
    },
    {
        "id": 140603,
        "name_th": "บ้านโพ",
        "name_en": "Ban Pho",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140604,
        "name_th": "บ้านกรด",
        "name_en": "Ban Krot",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140605,
        "name_th": "บางกระสั้น",
        "name_en": "Bang Krasan",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140606,
        "name_th": "คลองจิก",
        "name_en": "Khlong Chik",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140607,
        "name_th": "บ้านหว้า",
        "name_en": "Ban Wa",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140608,
        "name_th": "วัดยม",
        "name_en": "Wat Yom",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140609,
        "name_th": "บางประแดง",
        "name_en": "Bang Pradaeng",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140610,
        "name_th": "สามเรือน",
        "name_en": "Sam Ruean",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140611,
        "name_th": "เกาะเกิด",
        "name_en": "Ko Koet",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140612,
        "name_th": "บ้านพลับ",
        "name_en": "Ban Phlap",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140613,
        "name_th": "บ้านแป้ง",
        "name_en": "Ban Paeng",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140614,
        "name_th": "คุ้งลาน",
        "name_en": "Khung Lan",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140615,
        "name_th": "ตลิ่งชัน",
        "name_en": "Taling Chan",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140616,
        "name_th": "บ้านสร้าง",
        "name_en": "Ban Sang",
        "zip_codes": [
            13170
        ],
        "district_id": 1406
    },
    {
        "id": 140617,
        "name_th": "ตลาดเกรียบ",
        "name_en": "Talat Kriap",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140618,
        "name_th": "ขนอนหลวง",
        "name_en": "Khanon Luang",
        "zip_codes": [
            13160
        ],
        "district_id": 1406
    },
    {
        "id": 140701,
        "name_th": "บางปะหัน",
        "name_en": "Bang Pahan",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140702,
        "name_th": "ขยาย",
        "name_en": "Khayai",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140703,
        "name_th": "บางเดื่อ",
        "name_en": "Bang Duea",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140704,
        "name_th": "เสาธง",
        "name_en": "Sao Thong",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140705,
        "name_th": "ทางกลาง",
        "name_en": "Thang Klang",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140706,
        "name_th": "บางเพลิง",
        "name_en": "Bang Phloeng",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140707,
        "name_th": "หันสัง",
        "name_en": "Han Sang",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140708,
        "name_th": "บางนางร้า",
        "name_en": "Bang Nang Ra",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140709,
        "name_th": "ตานิม",
        "name_en": "Ta Nim",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140710,
        "name_th": "ทับน้ำ",
        "name_en": "Thap Nam",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140711,
        "name_th": "บ้านม้า",
        "name_en": "Ban Ma",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140712,
        "name_th": "ขวัญเมือง",
        "name_en": "Khwan Mueang",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140713,
        "name_th": "บ้านลี่",
        "name_en": "Ban Li",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140714,
        "name_th": "โพธิ์สามต้น",
        "name_en": "Pho Sam Ton",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140715,
        "name_th": "พุทเลา",
        "name_en": "Phut Lao",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140716,
        "name_th": "ตาลเอน",
        "name_en": "Tan En",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140717,
        "name_th": "บ้านขล้อ",
        "name_en": "Ban Khlo",
        "zip_codes": [
            13220
        ],
        "district_id": 1407
    },
    {
        "id": 140801,
        "name_th": "ผักไห่",
        "name_en": "Phak Hai",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140802,
        "name_th": "อมฤต",
        "name_en": "Ammarit",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140803,
        "name_th": "บ้านแค",
        "name_en": "Ban Khae",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140804,
        "name_th": "ลาดน้ำเค็ม",
        "name_en": "Lat Nam Khem",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140805,
        "name_th": "ตาลาน",
        "name_en": "Ta Lan",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140806,
        "name_th": "ท่าดินแดง",
        "name_en": "Tha Din Daeng",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140807,
        "name_th": "ดอนลาน",
        "name_en": "Don Lan",
        "zip_codes": [
            13280
        ],
        "district_id": 1408
    },
    {
        "id": 140808,
        "name_th": "นาคู",
        "name_en": "Na Khu",
        "zip_codes": [
            13280
        ],
        "district_id": 1408
    },
    {
        "id": 140809,
        "name_th": "กุฎี",
        "name_en": "Kudi",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140810,
        "name_th": "ลำตะเคียน",
        "name_en": "Lam Takhian",
        "zip_codes": [
            13280
        ],
        "district_id": 1408
    },
    {
        "id": 140811,
        "name_th": "โคกช้าง",
        "name_en": "Khok Chang",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140812,
        "name_th": "จักราช",
        "name_en": "Chakkarat",
        "zip_codes": [
            13280
        ],
        "district_id": 1408
    },
    {
        "id": 140813,
        "name_th": "หนองน้ำใหญ่",
        "name_en": "Nong Nam Yai",
        "zip_codes": [
            13280
        ],
        "district_id": 1408
    },
    {
        "id": 140814,
        "name_th": "ลาดชิด",
        "name_en": "Lat Chit",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140815,
        "name_th": "หน้าโคก",
        "name_en": "Na Khok",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140816,
        "name_th": "บ้านใหญ่",
        "name_en": "Ban Yai",
        "zip_codes": [
            13120
        ],
        "district_id": 1408
    },
    {
        "id": 140901,
        "name_th": "ภาชี",
        "name_en": "Phachi",
        "zip_codes": [
            13140
        ],
        "district_id": 1409
    },
    {
        "id": 140902,
        "name_th": "โคกม่วง",
        "name_en": "Khok Muang",
        "zip_codes": [
            13140
        ],
        "district_id": 1409
    },
    {
        "id": 140903,
        "name_th": "ระโสม",
        "name_en": "Rasom",
        "zip_codes": [
            13140,
            18250
        ],
        "district_id": 1409
    },
    {
        "id": 140904,
        "name_th": "หนองน้ำใส",
        "name_en": "Nong Nam Sai",
        "zip_codes": [
            13140
        ],
        "district_id": 1409
    },
    {
        "id": 140905,
        "name_th": "ดอนหญ้านาง",
        "name_en": "Don Ya Nang",
        "zip_codes": [
            13140
        ],
        "district_id": 1409
    },
    {
        "id": 140906,
        "name_th": "ไผ่ล้อม",
        "name_en": "Phai Lom",
        "zip_codes": [
            13140
        ],
        "district_id": 1409
    },
    {
        "id": 140907,
        "name_th": "กระจิว",
        "name_en": "Krachio",
        "zip_codes": [
            13140
        ],
        "district_id": 1409
    },
    {
        "id": 140908,
        "name_th": "พระแก้ว",
        "name_en": "Phra Kaeo",
        "zip_codes": [
            13140
        ],
        "district_id": 1409
    },
    {
        "id": 141001,
        "name_th": "ลาดบัวหลวง",
        "name_en": "Lat Bua Luang",
        "zip_codes": [
            13230
        ],
        "district_id": 1410
    },
    {
        "id": 141002,
        "name_th": "หลักชัย",
        "name_en": "Lak Chai",
        "zip_codes": [
            13230
        ],
        "district_id": 1410
    },
    {
        "id": 141003,
        "name_th": "สามเมือง",
        "name_en": "Sam Mueang",
        "zip_codes": [
            13230
        ],
        "district_id": 1410
    },
    {
        "id": 141004,
        "name_th": "พระยาบันลือ",
        "name_en": "Phraya Banlue",
        "zip_codes": [
            13230
        ],
        "district_id": 1410
    },
    {
        "id": 141005,
        "name_th": "สิงหนาท",
        "name_en": "Singhanat",
        "zip_codes": [
            13230
        ],
        "district_id": 1410
    },
    {
        "id": 141006,
        "name_th": "คู้สลอด",
        "name_en": "Khu Salot",
        "zip_codes": [
            13230
        ],
        "district_id": 1410
    },
    {
        "id": 141007,
        "name_th": "คลองพระยาบันลือ",
        "name_en": "Khlong Phraya Banlue",
        "zip_codes": [
            13230
        ],
        "district_id": 1410
    },
    {
        "id": 141101,
        "name_th": "ลำตาเสา",
        "name_en": "Lam Ta Sao",
        "zip_codes": [
            13170
        ],
        "district_id": 1411
    },
    {
        "id": 141102,
        "name_th": "บ่อตาโล่",
        "name_en": "Bo ta Lo",
        "zip_codes": [
            13170
        ],
        "district_id": 1411
    },
    {
        "id": 141103,
        "name_th": "วังน้อย",
        "name_en": "Wang Noi",
        "zip_codes": [
            13170
        ],
        "district_id": 1411
    },
    {
        "id": 141104,
        "name_th": "ลำไทร",
        "name_en": "Lam Sai",
        "zip_codes": [
            13170
        ],
        "district_id": 1411
    },
    {
        "id": 141105,
        "name_th": "สนับทึบ",
        "name_en": "Sanap Thuep",
        "zip_codes": [
            13170
        ],
        "district_id": 1411
    },
    {
        "id": 141106,
        "name_th": "พยอม",
        "name_en": "Phayom",
        "zip_codes": [
            13170,
            13180
        ],
        "district_id": 1411
    },
    {
        "id": 141107,
        "name_th": "หันตะเภา",
        "name_en": "Han Taphao",
        "zip_codes": [
            13170
        ],
        "district_id": 1411
    },
    {
        "id": 141108,
        "name_th": "วังจุฬา",
        "name_en": "Wang Chula",
        "zip_codes": [
            13170
        ],
        "district_id": 1411
    },
    {
        "id": 141109,
        "name_th": "ข้าวงาม",
        "name_en": "Khao Ngam",
        "zip_codes": [
            13170
        ],
        "district_id": 1411
    },
    {
        "id": 141110,
        "name_th": "ชะแมบ",
        "name_en": "Chamaep",
        "zip_codes": [
            13170
        ],
        "district_id": 1411
    },
    {
        "id": 141201,
        "name_th": "เสนา",
        "name_en": "Sena",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141202,
        "name_th": "บ้านแพน",
        "name_en": "Ban Phaen",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141203,
        "name_th": "เจ้าเจ็ด",
        "name_en": "Chao Chet",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141204,
        "name_th": "สามกอ",
        "name_en": "Sam Ko",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141205,
        "name_th": "บางนมโค",
        "name_en": "Bang Nom Kho",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141206,
        "name_th": "หัวเวียง",
        "name_en": "Hua Wiang",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141207,
        "name_th": "มารวิชัย",
        "name_en": "Manwichai",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141208,
        "name_th": "บ้านโพธิ์",
        "name_en": "Ban Pho",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141209,
        "name_th": "รางจรเข้",
        "name_en": "Rang Chorakhe",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141210,
        "name_th": "บ้านกระทุ่ม",
        "name_en": "Ban Krathum",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141211,
        "name_th": "บ้านแถว",
        "name_en": "Ban Thaeo",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141212,
        "name_th": "ชายนา",
        "name_en": "Chai Na",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141213,
        "name_th": "สามตุ่ม",
        "name_en": "Sam Tum",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141214,
        "name_th": "ลาดงา",
        "name_en": "Lat Nga",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141215,
        "name_th": "ดอนทอง",
        "name_en": "Don Thong",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141216,
        "name_th": "บ้านหลวง",
        "name_en": "Ban Luang",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141217,
        "name_th": "เจ้าเสด็จ",
        "name_en": "Chao Sadet",
        "zip_codes": [
            13110
        ],
        "district_id": 1412
    },
    {
        "id": 141301,
        "name_th": "บางซ้าย",
        "name_en": "Bang Sai",
        "zip_codes": [
            13270
        ],
        "district_id": 1413
    },
    {
        "id": 141302,
        "name_th": "แก้วฟ้า",
        "name_en": "Kaeo Fa",
        "zip_codes": [
            13270
        ],
        "district_id": 1413
    },
    {
        "id": 141303,
        "name_th": "เต่าเล่า",
        "name_en": "Tao Lao",
        "zip_codes": [
            13270
        ],
        "district_id": 1413
    },
    {
        "id": 141304,
        "name_th": "ปลายกลัด",
        "name_en": "Plai Klat",
        "zip_codes": [
            13270
        ],
        "district_id": 1413
    },
    {
        "id": 141305,
        "name_th": "เทพมงคล",
        "name_en": "Thep Mongkhon",
        "zip_codes": [
            13270
        ],
        "district_id": 1413
    },
    {
        "id": 141306,
        "name_th": "วังพัฒนา",
        "name_en": "Wang Phatthana",
        "zip_codes": [
            13270
        ],
        "district_id": 1413
    },
    {
        "id": 141401,
        "name_th": "คานหาม",
        "name_en": "Khan Ham",
        "zip_codes": [
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141402,
        "name_th": "บ้านช้าง",
        "name_en": "Ban Chang",
        "zip_codes": [
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141403,
        "name_th": "สามบัณฑิต",
        "name_en": "Sam Bandit",
        "zip_codes": [
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141404,
        "name_th": "บ้านหีบ",
        "name_en": "Ban Hip",
        "zip_codes": [
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141405,
        "name_th": "หนองไม้ซุง",
        "name_en": "Nong Mai Sung",
        "zip_codes": [
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141406,
        "name_th": "อุทัย",
        "name_en": "Uthai",
        "zip_codes": [
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141407,
        "name_th": "เสนา",
        "name_en": "Sena",
        "zip_codes": [
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141408,
        "name_th": "หนองน้ำส้ม",
        "name_en": "Nong Nam Som",
        "zip_codes": [
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141409,
        "name_th": "โพสาวหาญ",
        "name_en": "Pho Sao Han",
        "zip_codes": [
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141410,
        "name_th": "ธนู",
        "name_en": "Thanu",
        "zip_codes": [
            13000,
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141411,
        "name_th": "ข้าวเม่า",
        "name_en": "Khao Mao",
        "zip_codes": [
            13000,
            13210
        ],
        "district_id": 1414
    },
    {
        "id": 141501,
        "name_th": "หัวไผ่",
        "name_en": "Hua Phai",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141502,
        "name_th": "กะทุ่ม",
        "name_en": "Kathum",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141503,
        "name_th": "มหาราช",
        "name_en": "Maha Rat",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141504,
        "name_th": "น้ำเต้า",
        "name_en": "Nam Tao",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141505,
        "name_th": "บางนา",
        "name_en": "Bang Na",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141506,
        "name_th": "โรงช้าง",
        "name_en": "Rong Chang",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141507,
        "name_th": "เจ้าปลุก",
        "name_en": "Chao Pluk",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141508,
        "name_th": "พิตเพียน",
        "name_en": "Phit Phian",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141509,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141510,
        "name_th": "บ้านขวาง",
        "name_en": "Ban Khwang",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141511,
        "name_th": "ท่าตอ",
        "name_en": "Tha To",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141512,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            13150
        ],
        "district_id": 1415
    },
    {
        "id": 141601,
        "name_th": "บ้านแพรก",
        "name_en": "Ban Phraek",
        "zip_codes": [
            13240
        ],
        "district_id": 1416
    },
    {
        "id": 141602,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            13240
        ],
        "district_id": 1416
    },
    {
        "id": 141603,
        "name_th": "สำพะเนียง",
        "name_en": "Sam Phaniang",
        "zip_codes": [
            13240
        ],
        "district_id": 1416
    },
    {
        "id": 141604,
        "name_th": "คลองน้อย",
        "name_en": "Khlong Noi",
        "zip_codes": [
            13240
        ],
        "district_id": 1416
    },
    {
        "id": 141605,
        "name_th": "สองห้อง",
        "name_en": "Song Hong",
        "zip_codes": [
            13240
        ],
        "district_id": 1416
    },
    {
        "id": 150101,
        "name_th": "ตลาดหลวง",
        "name_en": "Talat Luang",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150102,
        "name_th": "บางแก้ว",
        "name_en": "Bang Kaeo",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150103,
        "name_th": "ศาลาแดง",
        "name_en": "Sala Daeng",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150104,
        "name_th": "ป่างิ้ว",
        "name_en": "Pa Ngio",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150105,
        "name_th": "บ้านแห",
        "name_en": "Ban Hae",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150106,
        "name_th": "ตลาดกรวด",
        "name_en": "Talat Kruat",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150107,
        "name_th": "มหาดไทย",
        "name_en": "Mahat Thai",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150108,
        "name_th": "บ้านอิฐ",
        "name_en": "Ban It",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150109,
        "name_th": "หัวไผ่",
        "name_en": "Hua Phai",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150110,
        "name_th": "จำปาหล่อ",
        "name_en": "Champa Lo",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150111,
        "name_th": "โพสะ",
        "name_en": "Phosa",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150112,
        "name_th": "บ้านรี",
        "name_en": "Ban Ri",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150113,
        "name_th": "คลองวัว",
        "name_en": "Khlong Wua",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150114,
        "name_th": "ย่านซื่อ",
        "name_en": "Yan Sue",
        "zip_codes": [
            14000
        ],
        "district_id": 1501
    },
    {
        "id": 150201,
        "name_th": "จรเข้ร้อง",
        "name_en": "Chorakhe Rong",
        "zip_codes": [
            14140
        ],
        "district_id": 1502
    },
    {
        "id": 150202,
        "name_th": "ไชยภูมิ",
        "name_en": "Chaiyaphum",
        "zip_codes": [
            14140
        ],
        "district_id": 1502
    },
    {
        "id": 150203,
        "name_th": "ชัยฤทธิ์",
        "name_en": "Chai Rit",
        "zip_codes": [
            14140
        ],
        "district_id": 1502
    },
    {
        "id": 150204,
        "name_th": "เทวราช",
        "name_en": "Thewarat",
        "zip_codes": [
            14140
        ],
        "district_id": 1502
    },
    {
        "id": 150205,
        "name_th": "ราชสถิตย์",
        "name_en": "Rat Sathit",
        "zip_codes": [
            14140
        ],
        "district_id": 1502
    },
    {
        "id": 150206,
        "name_th": "ไชโย",
        "name_en": "Chaiyo",
        "zip_codes": [
            14140
        ],
        "district_id": 1502
    },
    {
        "id": 150207,
        "name_th": "หลักฟ้า",
        "name_en": "Lak Fa",
        "zip_codes": [
            14140
        ],
        "district_id": 1502
    },
    {
        "id": 150208,
        "name_th": "ชะไว",
        "name_en": "Chawai",
        "zip_codes": [
            14140
        ],
        "district_id": 1502
    },
    {
        "id": 150209,
        "name_th": "ตรีณรงค์",
        "name_en": "Tri Narong",
        "zip_codes": [
            14140
        ],
        "district_id": 1502
    },
    {
        "id": 150301,
        "name_th": "บางปลากด",
        "name_en": "Bang Pla Kot",
        "zip_codes": [
            14130
        ],
        "district_id": 1503
    },
    {
        "id": 150302,
        "name_th": "ป่าโมก",
        "name_en": "Pa Mok",
        "zip_codes": [
            14130
        ],
        "district_id": 1503
    },
    {
        "id": 150303,
        "name_th": "สายทอง",
        "name_en": "Sai Thong",
        "zip_codes": [
            14130
        ],
        "district_id": 1503
    },
    {
        "id": 150304,
        "name_th": "โรงช้าง",
        "name_en": "Rong Chang",
        "zip_codes": [
            14130
        ],
        "district_id": 1503
    },
    {
        "id": 150305,
        "name_th": "บางเสด็จ",
        "name_en": "Bang Sadet",
        "zip_codes": [
            14130
        ],
        "district_id": 1503
    },
    {
        "id": 150306,
        "name_th": "นรสิงห์",
        "name_en": "Norasing",
        "zip_codes": [
            14130
        ],
        "district_id": 1503
    },
    {
        "id": 150307,
        "name_th": "เอกราช",
        "name_en": "Ekkarat",
        "zip_codes": [
            14130
        ],
        "district_id": 1503
    },
    {
        "id": 150308,
        "name_th": "โผงเผง",
        "name_en": "Phongpheng",
        "zip_codes": [
            14130
        ],
        "district_id": 1503
    },
    {
        "id": 150401,
        "name_th": "อ่างแก้ว",
        "name_en": "Ang Kaeo",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150402,
        "name_th": "อินทประมูล",
        "name_en": "Inthapramun",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150403,
        "name_th": "บางพลับ",
        "name_en": "Bang Phlap",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150404,
        "name_th": "หนองแม่ไก่",
        "name_en": "Nong Mae Kai",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150405,
        "name_th": "รำมะสัก",
        "name_en": "Ram Masak",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150406,
        "name_th": "บางระกำ",
        "name_en": "Bang Rakam",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150407,
        "name_th": "โพธิ์รังนก",
        "name_en": "Pho Rang Nok",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150408,
        "name_th": "องครักษ์",
        "name_en": "Ongkharak",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150409,
        "name_th": "โคกพุทรา",
        "name_en": "Khok Phutsa",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150410,
        "name_th": "ยางช้าย",
        "name_en": "Yang Chai",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150411,
        "name_th": "บ่อแร่",
        "name_en": "Bo Rae",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150412,
        "name_th": "ทางพระ",
        "name_en": "Thang Phra",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150413,
        "name_th": "สามง่าม",
        "name_en": "Sam Ngam",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150414,
        "name_th": "บางเจ้าฉ่า",
        "name_en": "Bang Chao Cha",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150415,
        "name_th": "คำหยาด",
        "name_en": "Kham Yat",
        "zip_codes": [
            14120
        ],
        "district_id": 1504
    },
    {
        "id": 150501,
        "name_th": "แสวงหา",
        "name_en": "Sawaeng Ha",
        "zip_codes": [
            14150
        ],
        "district_id": 1505
    },
    {
        "id": 150502,
        "name_th": "ศรีพราน",
        "name_en": "Si Phran",
        "zip_codes": [
            14150
        ],
        "district_id": 1505
    },
    {
        "id": 150503,
        "name_th": "บ้านพราน",
        "name_en": "Ban Phran",
        "zip_codes": [
            14150
        ],
        "district_id": 1505
    },
    {
        "id": 150504,
        "name_th": "วังน้ำเย็น",
        "name_en": "Wang Nam Yen",
        "zip_codes": [
            14150
        ],
        "district_id": 1505
    },
    {
        "id": 150505,
        "name_th": "สีบัวทอง",
        "name_en": "Si Bua Thong",
        "zip_codes": [
            14150
        ],
        "district_id": 1505
    },
    {
        "id": 150506,
        "name_th": "ห้วยไผ่",
        "name_en": "Huai Phai",
        "zip_codes": [
            14150
        ],
        "district_id": 1505
    },
    {
        "id": 150507,
        "name_th": "จำลอง",
        "name_en": "Chamlong",
        "zip_codes": [
            14150
        ],
        "district_id": 1505
    },
    {
        "id": 150601,
        "name_th": "ไผ่จำศีล",
        "name_en": "Phai Cham Sin",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150602,
        "name_th": "ศาลเจ้าโรงทอง",
        "name_en": "San Chao Rong Thong",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150603,
        "name_th": "ไผ่ดำพัฒนา",
        "name_en": "Phai Dam Phatthana",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150604,
        "name_th": "สาวร้องไห้",
        "name_en": "Sao Rong Hai",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150605,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150606,
        "name_th": "ยี่ล้น",
        "name_en": "Yi Lon",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150607,
        "name_th": "บางจัก",
        "name_en": "Bang Chak",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150608,
        "name_th": "ห้วยคันแหลน",
        "name_en": "Huai Khan Laen",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150609,
        "name_th": "คลองขนาก",
        "name_en": "Khlong Khanak",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150610,
        "name_th": "ไผ่วง",
        "name_en": "Phai Wong",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150611,
        "name_th": "สี่ร้อย",
        "name_en": "Si Roi",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150612,
        "name_th": "ม่วงเตี้ย",
        "name_en": "Muang Tia",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150613,
        "name_th": "หัวตะพาน",
        "name_en": "Hua Taphan",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150614,
        "name_th": "หลักแก้ว",
        "name_en": "Lak Kaeo",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150615,
        "name_th": "ตลาดใหม่",
        "name_en": "Talat Mai",
        "zip_codes": [
            14110
        ],
        "district_id": 1506
    },
    {
        "id": 150701,
        "name_th": "สามโก้",
        "name_en": "Samko",
        "zip_codes": [
            14160
        ],
        "district_id": 1507
    },
    {
        "id": 150702,
        "name_th": "ราษฎรพัฒนา",
        "name_en": "Ratsadon Phatthana",
        "zip_codes": [
            14160
        ],
        "district_id": 1507
    },
    {
        "id": 150703,
        "name_th": "อบทม",
        "name_en": "Op Thom",
        "zip_codes": [
            14160
        ],
        "district_id": 1507
    },
    {
        "id": 150704,
        "name_th": "โพธิ์ม่วงพันธ์",
        "name_en": "Pho Muang Phan",
        "zip_codes": [
            14160
        ],
        "district_id": 1507
    },
    {
        "id": 150705,
        "name_th": "มงคลธรรมนิมิต",
        "name_en": "Mongkhon Tham Nimit",
        "zip_codes": [
            14160
        ],
        "district_id": 1507
    },
    {
        "id": 160101,
        "name_th": "ทะเลชุบศร",
        "name_en": "Thale Chup Son",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160102,
        "name_th": "ท่าหิน",
        "name_en": "Tha Hin",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160103,
        "name_th": "กกโก",
        "name_en": "Kok Ko",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160104,
        "name_th": "โก่งธนู",
        "name_en": "Kong Thanu",
        "zip_codes": [
            13240
        ],
        "district_id": 1601
    },
    {
        "id": 160105,
        "name_th": "เขาพระงาม",
        "name_en": "Khao Phra Ngam",
        "zip_codes": [
            15160
        ],
        "district_id": 1601
    },
    {
        "id": 160106,
        "name_th": "เขาสามยอด",
        "name_en": "Khao Sam Yot",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160107,
        "name_th": "โคกกะเทียม",
        "name_en": "Khok Kathiam",
        "zip_codes": [
            15160
        ],
        "district_id": 1601
    },
    {
        "id": 160108,
        "name_th": "โคกลำพาน",
        "name_en": "Khok Lam Phan",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160109,
        "name_th": "โคกตูม",
        "name_en": "Khok Tum",
        "zip_codes": [
            15210
        ],
        "district_id": 1601
    },
    {
        "id": 160110,
        "name_th": "งิ้วราย",
        "name_en": "Ngio Rai",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160111,
        "name_th": "ดอนโพธิ์",
        "name_en": "Don Pho",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160112,
        "name_th": "ตะลุง",
        "name_en": "Talung",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160114,
        "name_th": "ท่าแค",
        "name_en": "Tha Khae",
        "zip_codes": [
            15000,
            15160
        ],
        "district_id": 1601
    },
    {
        "id": 160115,
        "name_th": "ท่าศาลา",
        "name_en": "Tha Sala",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160116,
        "name_th": "นิคมสร้างตนเอง",
        "name_en": "Nikhom Sang Ton Eng",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160117,
        "name_th": "บางขันหมาก",
        "name_en": "Bang Khan Mak",
        "zip_codes": [
            15000,
            15160
        ],
        "district_id": 1601
    },
    {
        "id": 160118,
        "name_th": "บ้านข่อย",
        "name_en": "Ban Khoi",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160119,
        "name_th": "ท้ายตลาด",
        "name_en": "Thai Talat",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160120,
        "name_th": "ป่าตาล",
        "name_en": "Pa Tan",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160121,
        "name_th": "พรหมมาสตร์",
        "name_en": "Phrommat",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160122,
        "name_th": "โพธิ์เก้าต้น",
        "name_en": "Pho Kao Ton",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160123,
        "name_th": "โพธิ์ตรุ",
        "name_en": "Pho Tru",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160124,
        "name_th": "สี่คลอง",
        "name_en": "Si Khlong",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160125,
        "name_th": "ถนนใหญ่",
        "name_en": "Thanon Yai",
        "zip_codes": [
            15000
        ],
        "district_id": 1601
    },
    {
        "id": 160201,
        "name_th": "พัฒนานิคม",
        "name_en": "Phatthana Nikhom",
        "zip_codes": [
            15140
        ],
        "district_id": 1602
    },
    {
        "id": 160202,
        "name_th": "ช่องสาริกา",
        "name_en": "Chong Sarika",
        "zip_codes": [
            15220
        ],
        "district_id": 1602
    },
    {
        "id": 160203,
        "name_th": "มะนาวหวาน",
        "name_en": "Manao Wan",
        "zip_codes": [
            15140
        ],
        "district_id": 1602
    },
    {
        "id": 160204,
        "name_th": "ดีลัง",
        "name_en": "Di Lang",
        "zip_codes": [
            15220
        ],
        "district_id": 1602
    },
    {
        "id": 160205,
        "name_th": "โคกสลุง",
        "name_en": "Khok Salung",
        "zip_codes": [
            15140
        ],
        "district_id": 1602
    },
    {
        "id": 160206,
        "name_th": "ชอนน้อย",
        "name_en": "Chon Noi",
        "zip_codes": [
            15140
        ],
        "district_id": 1602
    },
    {
        "id": 160207,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            15140
        ],
        "district_id": 1602
    },
    {
        "id": 160208,
        "name_th": "ห้วยขุนราม",
        "name_en": "Huai Khun Ram",
        "zip_codes": [
            18220
        ],
        "district_id": 1602
    },
    {
        "id": 160209,
        "name_th": "น้ำสุด",
        "name_en": "Nam Sut",
        "zip_codes": [
            15140
        ],
        "district_id": 1602
    },
    {
        "id": 160301,
        "name_th": "โคกสำโรง",
        "name_en": "Khok Samrong",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160302,
        "name_th": "เกาะแก้ว",
        "name_en": "Ko Kaeo",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160303,
        "name_th": "ถลุงเหล็ก",
        "name_en": "Thalung Lek",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160304,
        "name_th": "หลุมข้าว",
        "name_en": "Lum Khao",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160305,
        "name_th": "ห้วยโป่ง",
        "name_en": "Huai Pong",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160306,
        "name_th": "คลองเกตุ",
        "name_en": "Khlong Ket",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160307,
        "name_th": "สะแกราบ",
        "name_en": "Sakae Rap",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160308,
        "name_th": "เพนียด",
        "name_en": "Phaniat",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160309,
        "name_th": "วังเพลิง",
        "name_en": "Wang Phloeng",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160310,
        "name_th": "ดงมะรุม",
        "name_en": "Dong Marum",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160318,
        "name_th": "วังขอนขว้าง",
        "name_en": "Wang Khon Khwang",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160320,
        "name_th": "วังจั่น",
        "name_en": "Wang Chan",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160322,
        "name_th": "หนองแขม",
        "name_en": "Nong Khaem",
        "zip_codes": [
            15120
        ],
        "district_id": 1603
    },
    {
        "id": 160401,
        "name_th": "ลำนารายณ์",
        "name_en": "Lam Narai",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160402,
        "name_th": "ชัยนารายณ์",
        "name_en": "Chai Narai",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160403,
        "name_th": "ศิลาทิพย์",
        "name_en": "Sila Thip",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160404,
        "name_th": "ห้วยหิน",
        "name_en": "Huai Hin",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160405,
        "name_th": "ม่วงค่อม",
        "name_en": "Muang Khom",
        "zip_codes": [
            15230
        ],
        "district_id": 1604
    },
    {
        "id": 160406,
        "name_th": "บัวชุม",
        "name_en": "Bua Chum",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160407,
        "name_th": "ท่าดินดำ",
        "name_en": "Tha Din Dam",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160408,
        "name_th": "มะกอกหวาน",
        "name_en": "Makok Wan",
        "zip_codes": [
            15230
        ],
        "district_id": 1604
    },
    {
        "id": 160409,
        "name_th": "ซับตะเคียน",
        "name_en": "Sap Takhian",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160410,
        "name_th": "นาโสม",
        "name_en": "Na Som",
        "zip_codes": [
            15190
        ],
        "district_id": 1604
    },
    {
        "id": 160411,
        "name_th": "หนองยายโต๊ะ",
        "name_en": "Nong Yai To",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160412,
        "name_th": "เกาะรัง",
        "name_en": "Ko Rang",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160414,
        "name_th": "ท่ามะนาว",
        "name_en": "Tha Manao",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160417,
        "name_th": "นิคมลำนารายณ์",
        "name_en": "Nikhom Lam Narai",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160418,
        "name_th": "ชัยบาดาล",
        "name_en": "Chai Badan",
        "zip_codes": [
            15230
        ],
        "district_id": 1604
    },
    {
        "id": 160419,
        "name_th": "บ้านใหม่สามัคคี",
        "name_en": "Ban Mai Samakkhi",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160422,
        "name_th": "เขาแหลม",
        "name_en": "Khao Laem",
        "zip_codes": [
            15130
        ],
        "district_id": 1604
    },
    {
        "id": 160501,
        "name_th": "ท่าวุ้ง",
        "name_en": "Tha Wung",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160502,
        "name_th": "บางคู้",
        "name_en": "Bang Khu",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160503,
        "name_th": "โพตลาดแก้ว",
        "name_en": "Pho Talat Kaeo",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160504,
        "name_th": "บางลี่",
        "name_en": "Bang Li",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160505,
        "name_th": "บางงา",
        "name_en": "Bang Nga",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160506,
        "name_th": "โคกสลุด",
        "name_en": "Khok Salut",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160507,
        "name_th": "เขาสมอคอน",
        "name_en": "Khao Samo Khon",
        "zip_codes": [
            15180
        ],
        "district_id": 1605
    },
    {
        "id": 160508,
        "name_th": "หัวสำโรง",
        "name_en": "Hua Samrong",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160509,
        "name_th": "ลาดสาลี่",
        "name_en": "Lat Sali",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160510,
        "name_th": "บ้านเบิก",
        "name_en": "Ban Boek",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160511,
        "name_th": "มุจลินท์",
        "name_en": "Mutchalin",
        "zip_codes": [
            15150
        ],
        "district_id": 1605
    },
    {
        "id": 160601,
        "name_th": "ไผ่ใหญ่",
        "name_en": "Phai Yai",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160602,
        "name_th": "บ้านทราย",
        "name_en": "Ban Sai",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160603,
        "name_th": "บ้านกล้วย",
        "name_en": "Ban Kluai",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160604,
        "name_th": "ดงพลับ",
        "name_en": "Dong Phlap",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160605,
        "name_th": "บ้านชี",
        "name_en": "Ban Chi",
        "zip_codes": [
            15180
        ],
        "district_id": 1606
    },
    {
        "id": 160606,
        "name_th": "พุคา",
        "name_en": "Phu Kha",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160607,
        "name_th": "หินปัก",
        "name_en": "Hin Pak",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160608,
        "name_th": "บางพึ่ง",
        "name_en": "Bang Phueng",
        "zip_codes": [
            15110,
            15180
        ],
        "district_id": 1606
    },
    {
        "id": 160609,
        "name_th": "หนองทรายขาว",
        "name_en": "Nong Sai Khao",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160610,
        "name_th": "บางกะพี้",
        "name_en": "Bang Kaphi",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160611,
        "name_th": "หนองเต่า",
        "name_en": "Nong Tao",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160612,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160613,
        "name_th": "บางขาม",
        "name_en": "Bang Kham",
        "zip_codes": [
            15180
        ],
        "district_id": 1606
    },
    {
        "id": 160614,
        "name_th": "ดอนดึง",
        "name_en": "Don Dueng",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160615,
        "name_th": "ชอนม่วง",
        "name_en": "Chon Muang",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160616,
        "name_th": "หนองกระเบียน",
        "name_en": "Nong Krabian",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160617,
        "name_th": "สายห้วยแก้ว",
        "name_en": "Sai Huai Kaeo",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160618,
        "name_th": "มหาสอน",
        "name_en": "Maha Son",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160619,
        "name_th": "บ้านหมี่",
        "name_en": "Ban Mi",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160620,
        "name_th": "เชียงงา",
        "name_en": "Chiang Nga",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160621,
        "name_th": "หนองเมือง",
        "name_en": "Nong Mueang",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160622,
        "name_th": "สนามแจง",
        "name_en": "Sanam Chaeng",
        "zip_codes": [
            15110
        ],
        "district_id": 1606
    },
    {
        "id": 160701,
        "name_th": "ท่าหลวง",
        "name_en": "Tha Luang",
        "zip_codes": [
            15230
        ],
        "district_id": 1607
    },
    {
        "id": 160702,
        "name_th": "แก่งผักกูด",
        "name_en": "Kaeng Phak Kut",
        "zip_codes": [
            15230
        ],
        "district_id": 1607
    },
    {
        "id": 160703,
        "name_th": "ซับจำปา",
        "name_en": "Sap Champa",
        "zip_codes": [
            15230
        ],
        "district_id": 1607
    },
    {
        "id": 160704,
        "name_th": "หนองผักแว่น",
        "name_en": "Nong Phak Waen",
        "zip_codes": [
            15230
        ],
        "district_id": 1607
    },
    {
        "id": 160705,
        "name_th": "ทะเลวังวัด",
        "name_en": "Thale Wang Wat",
        "zip_codes": [
            15230
        ],
        "district_id": 1607
    },
    {
        "id": 160706,
        "name_th": "หัวลำ",
        "name_en": "Hua Lam",
        "zip_codes": [
            15230
        ],
        "district_id": 1607
    },
    {
        "id": 160801,
        "name_th": "สระโบสถ์",
        "name_en": "Sa Bot",
        "zip_codes": [
            15240
        ],
        "district_id": 1608
    },
    {
        "id": 160802,
        "name_th": "มหาโพธิ",
        "name_en": "Maha Phot",
        "zip_codes": [
            15240,
            15250
        ],
        "district_id": 1608
    },
    {
        "id": 160803,
        "name_th": "ทุ่งท่าช้าง",
        "name_en": "Thung Tha Chang",
        "zip_codes": [
            15240
        ],
        "district_id": 1608
    },
    {
        "id": 160804,
        "name_th": "ห้วยใหญ่",
        "name_en": "Huai Yai",
        "zip_codes": [
            15240
        ],
        "district_id": 1608
    },
    {
        "id": 160805,
        "name_th": "นิยมชัย",
        "name_en": "Niyom Chai",
        "zip_codes": [
            15240
        ],
        "district_id": 1608
    },
    {
        "id": 160901,
        "name_th": "โคกเจริญ",
        "name_en": "Khok Charoen",
        "zip_codes": [
            15250
        ],
        "district_id": 1609
    },
    {
        "id": 160902,
        "name_th": "ยางราก",
        "name_en": "Yang Rak",
        "zip_codes": [
            15250
        ],
        "district_id": 1609
    },
    {
        "id": 160903,
        "name_th": "หนองมะค่า",
        "name_en": "Nong Makha",
        "zip_codes": [
            15250
        ],
        "district_id": 1609
    },
    {
        "id": 160904,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "zip_codes": [
            15250
        ],
        "district_id": 1609
    },
    {
        "id": 160905,
        "name_th": "โคกแสมสาร",
        "name_en": "Khok Samae San",
        "zip_codes": [
            15250
        ],
        "district_id": 1609
    },
    {
        "id": 161001,
        "name_th": "ลำสนธิ",
        "name_en": "Lam Sonthi",
        "zip_codes": [
            15190
        ],
        "district_id": 1610
    },
    {
        "id": 161002,
        "name_th": "ซับสมบูรณ์",
        "name_en": "Sap Sombun",
        "zip_codes": [
            15190
        ],
        "district_id": 1610
    },
    {
        "id": 161003,
        "name_th": "หนองรี",
        "name_en": "Nong Ri",
        "zip_codes": [
            15190
        ],
        "district_id": 1610
    },
    {
        "id": 161004,
        "name_th": "กุดตาเพชร",
        "name_en": "Kut Ta Phet",
        "zip_codes": [
            15190
        ],
        "district_id": 1610
    },
    {
        "id": 161005,
        "name_th": "เขารวก",
        "name_en": "Khao Ruak",
        "zip_codes": [
            15190
        ],
        "district_id": 1610
    },
    {
        "id": 161006,
        "name_th": "เขาน้อย",
        "name_en": "Khao Noi",
        "zip_codes": [
            15130
        ],
        "district_id": 1610
    },
    {
        "id": 161101,
        "name_th": "หนองม่วง",
        "name_en": "Nong Muang",
        "zip_codes": [
            15170
        ],
        "district_id": 1611
    },
    {
        "id": 161102,
        "name_th": "บ่อทอง",
        "name_en": "Bo Thong",
        "zip_codes": [
            15170
        ],
        "district_id": 1611
    },
    {
        "id": 161103,
        "name_th": "ดงดินแดง",
        "name_en": "Dong Din Daeng",
        "zip_codes": [
            15170
        ],
        "district_id": 1611
    },
    {
        "id": 161104,
        "name_th": "ชอนสมบูรณ์",
        "name_en": "Chon Sombun",
        "zip_codes": [
            15170
        ],
        "district_id": 1611
    },
    {
        "id": 161105,
        "name_th": "ยางโทน",
        "name_en": "Yang Thon",
        "zip_codes": [
            15170
        ],
        "district_id": 1611
    },
    {
        "id": 161106,
        "name_th": "ชอนสารเดช",
        "name_en": "Chon Saradet",
        "zip_codes": [
            15170
        ],
        "district_id": 1611
    },
    {
        "id": 170101,
        "name_th": "บางพุทรา",
        "name_en": "Bang Phutsa",
        "zip_codes": [
            16000
        ],
        "district_id": 1701
    },
    {
        "id": 170102,
        "name_th": "บางมัญ",
        "name_en": "Bang Man",
        "zip_codes": [
            16000
        ],
        "district_id": 1701
    },
    {
        "id": 170103,
        "name_th": "โพกรวม",
        "name_en": "Phok Ruam",
        "zip_codes": [
            16000
        ],
        "district_id": 1701
    },
    {
        "id": 170104,
        "name_th": "ม่วงหมู่",
        "name_en": "Muang Mu",
        "zip_codes": [
            16000
        ],
        "district_id": 1701
    },
    {
        "id": 170105,
        "name_th": "หัวไผ่",
        "name_en": "Hua Phai",
        "zip_codes": [
            16000
        ],
        "district_id": 1701
    },
    {
        "id": 170106,
        "name_th": "ต้นโพธิ์",
        "name_en": "Ton Pho",
        "zip_codes": [
            16000
        ],
        "district_id": 1701
    },
    {
        "id": 170107,
        "name_th": "จักรสีห์",
        "name_en": "Chaksi",
        "zip_codes": [
            16000
        ],
        "district_id": 1701
    },
    {
        "id": 170108,
        "name_th": "บางกระบือ",
        "name_en": "Bang Krabue",
        "zip_codes": [
            16000
        ],
        "district_id": 1701
    },
    {
        "id": 170201,
        "name_th": "สิงห์",
        "name_en": "Sing",
        "zip_codes": [
            16130
        ],
        "district_id": 1702
    },
    {
        "id": 170202,
        "name_th": "ไม้ดัด",
        "name_en": "Mai Dat",
        "zip_codes": [
            16130
        ],
        "district_id": 1702
    },
    {
        "id": 170203,
        "name_th": "เชิงกลัด",
        "name_en": "Choeng Klat",
        "zip_codes": [
            16130
        ],
        "district_id": 1702
    },
    {
        "id": 170204,
        "name_th": "โพชนไก่",
        "name_en": "Pho Chon Kai",
        "zip_codes": [
            16130
        ],
        "district_id": 1702
    },
    {
        "id": 170205,
        "name_th": "แม่ลา",
        "name_en": "Mae La",
        "zip_codes": [
            16130
        ],
        "district_id": 1702
    },
    {
        "id": 170206,
        "name_th": "บ้านจ่า",
        "name_en": "Ban Cha",
        "zip_codes": [
            16130
        ],
        "district_id": 1702
    },
    {
        "id": 170207,
        "name_th": "พักทัน",
        "name_en": "Phak Than",
        "zip_codes": [
            16130
        ],
        "district_id": 1702
    },
    {
        "id": 170208,
        "name_th": "สระแจง",
        "name_en": "Sa Chaeng",
        "zip_codes": [
            16130
        ],
        "district_id": 1702
    },
    {
        "id": 170301,
        "name_th": "โพทะเล",
        "name_en": "Pho Thale",
        "zip_codes": [
            16150
        ],
        "district_id": 1703
    },
    {
        "id": 170302,
        "name_th": "บางระจัน",
        "name_en": "Bang Rachan",
        "zip_codes": [
            16150
        ],
        "district_id": 1703
    },
    {
        "id": 170303,
        "name_th": "โพสังโฆ",
        "name_en": "Pho Sangkho",
        "zip_codes": [
            16150
        ],
        "district_id": 1703
    },
    {
        "id": 170304,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            16150
        ],
        "district_id": 1703
    },
    {
        "id": 170305,
        "name_th": "คอทราย",
        "name_en": "Kho Sai",
        "zip_codes": [
            16150
        ],
        "district_id": 1703
    },
    {
        "id": 170306,
        "name_th": "หนองกระทุ่ม",
        "name_en": "Nong Krathum",
        "zip_codes": [
            16150
        ],
        "district_id": 1703
    },
    {
        "id": 170401,
        "name_th": "พระงาม",
        "name_en": "Phra Ngam",
        "zip_codes": [
            16120
        ],
        "district_id": 1704
    },
    {
        "id": 170402,
        "name_th": "พรหมบุรี",
        "name_en": "Phrom Buri",
        "zip_codes": [
            16160
        ],
        "district_id": 1704
    },
    {
        "id": 170403,
        "name_th": "บางน้ำเชี่ยว",
        "name_en": "Bang Nam Chiao",
        "zip_codes": [
            16120
        ],
        "district_id": 1704
    },
    {
        "id": 170404,
        "name_th": "บ้านหม้อ",
        "name_en": "Ban Mo",
        "zip_codes": [
            16120
        ],
        "district_id": 1704
    },
    {
        "id": 170405,
        "name_th": "บ้านแป้ง",
        "name_en": "Ban Paeng",
        "zip_codes": [
            16120
        ],
        "district_id": 1704
    },
    {
        "id": 170406,
        "name_th": "หัวป่า",
        "name_en": "Hua Pa",
        "zip_codes": [
            16120
        ],
        "district_id": 1704
    },
    {
        "id": 170407,
        "name_th": "โรงช้าง",
        "name_en": "Rong Chang",
        "zip_codes": [
            16120
        ],
        "district_id": 1704
    },
    {
        "id": 170501,
        "name_th": "ถอนสมอ",
        "name_en": "Thon Samo",
        "zip_codes": [
            16140
        ],
        "district_id": 1705
    },
    {
        "id": 170502,
        "name_th": "โพประจักษ์",
        "name_en": "Pho Prachak",
        "zip_codes": [
            16140
        ],
        "district_id": 1705
    },
    {
        "id": 170503,
        "name_th": "วิหารขาว",
        "name_en": "Wihan Khao",
        "zip_codes": [
            16140
        ],
        "district_id": 1705
    },
    {
        "id": 170504,
        "name_th": "พิกุลทอง",
        "name_en": "Phikun Thong",
        "zip_codes": [
            16140
        ],
        "district_id": 1705
    },
    {
        "id": 170601,
        "name_th": "อินทร์บุรี",
        "name_en": "In Buri",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 170602,
        "name_th": "ประศุก",
        "name_en": "Prasuk",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 170603,
        "name_th": "ทับยา",
        "name_en": "Thap Ya",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 170604,
        "name_th": "งิ้วราย",
        "name_en": "Ngio Rai",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 170605,
        "name_th": "ชีน้ำร้าย",
        "name_en": "Chi Nam Rai",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 170606,
        "name_th": "ท่างาม",
        "name_en": "Tha Ngam",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 170607,
        "name_th": "น้ำตาล",
        "name_en": "Nam Tan",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 170608,
        "name_th": "ทองเอน",
        "name_en": "Thong En",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 170609,
        "name_th": "ห้วยชัน",
        "name_en": "Huai Chan",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 170610,
        "name_th": "โพธิ์ชัย",
        "name_en": "Pho Chai",
        "zip_codes": [
            16110
        ],
        "district_id": 1706
    },
    {
        "id": 180101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            17000
        ],
        "district_id": 1801
    },
    {
        "id": 180102,
        "name_th": "บ้านกล้วย",
        "name_en": "Ban Kuai",
        "zip_codes": [
            17000
        ],
        "district_id": 1801
    },
    {
        "id": 180103,
        "name_th": "ท่าชัย",
        "name_en": "Tha Chai",
        "zip_codes": [
            17000
        ],
        "district_id": 1801
    },
    {
        "id": 180104,
        "name_th": "ชัยนาท",
        "name_en": "Chai Nat",
        "zip_codes": [
            17000
        ],
        "district_id": 1801
    },
    {
        "id": 180105,
        "name_th": "เขาท่าพระ",
        "name_en": "Khao Tha Phra",
        "zip_codes": [
            17000
        ],
        "district_id": 1801
    },
    {
        "id": 180106,
        "name_th": "หาดท่าเสา",
        "name_en": "Hat Tha Sao",
        "zip_codes": [
            17000,
            17120
        ],
        "district_id": 1801
    },
    {
        "id": 180107,
        "name_th": "ธรรมามูล",
        "name_en": "Thammamun",
        "zip_codes": [
            17000
        ],
        "district_id": 1801
    },
    {
        "id": 180108,
        "name_th": "เสือโฮก",
        "name_en": "Suea Hok",
        "zip_codes": [
            17000
        ],
        "district_id": 1801
    },
    {
        "id": 180109,
        "name_th": "นางลือ",
        "name_en": "Nang Lue",
        "zip_codes": [
            17000
        ],
        "district_id": 1801
    },
    {
        "id": 180201,
        "name_th": "คุ้งสำเภา",
        "name_en": "Khung Samphao",
        "zip_codes": [
            17110
        ],
        "district_id": 1802
    },
    {
        "id": 180202,
        "name_th": "วัดโคก",
        "name_en": "Wat Khok",
        "zip_codes": [
            17110,
            17170
        ],
        "district_id": 1802
    },
    {
        "id": 180203,
        "name_th": "ศิลาดาน",
        "name_en": "Sila Dan",
        "zip_codes": [
            17110
        ],
        "district_id": 1802
    },
    {
        "id": 180204,
        "name_th": "ท่าฉนวน",
        "name_en": "Tha Chanuan",
        "zip_codes": [
            17110
        ],
        "district_id": 1802
    },
    {
        "id": 180205,
        "name_th": "หางน้ำสาคร",
        "name_en": "Hang Nam Sakhon",
        "zip_codes": [
            17170
        ],
        "district_id": 1802
    },
    {
        "id": 180206,
        "name_th": "ไร่พัฒนา",
        "name_en": "Rai Phatthana",
        "zip_codes": [
            17170
        ],
        "district_id": 1802
    },
    {
        "id": 180207,
        "name_th": "อู่ตะเภา",
        "name_en": "U Taphao",
        "zip_codes": [
            17170
        ],
        "district_id": 1802
    },
    {
        "id": 180301,
        "name_th": "วัดสิงห์",
        "name_en": "Wat Sing",
        "zip_codes": [
            17120
        ],
        "district_id": 1803
    },
    {
        "id": 180302,
        "name_th": "มะขามเฒ่า",
        "name_en": "Makham Thao",
        "zip_codes": [
            17120
        ],
        "district_id": 1803
    },
    {
        "id": 180303,
        "name_th": "หนองน้อย",
        "name_en": "Nong Noi",
        "zip_codes": [
            17120
        ],
        "district_id": 1803
    },
    {
        "id": 180304,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            17120
        ],
        "district_id": 1803
    },
    {
        "id": 180306,
        "name_th": "หนองขุ่น",
        "name_en": "Nong Khun",
        "zip_codes": [
            17120
        ],
        "district_id": 1803
    },
    {
        "id": 180307,
        "name_th": "บ่อแร่",
        "name_en": "Bo Rae",
        "zip_codes": [
            17120
        ],
        "district_id": 1803
    },
    {
        "id": 180311,
        "name_th": "วังหมัน",
        "name_en": "Wang Man",
        "zip_codes": [
            17120
        ],
        "district_id": 1803
    },
    {
        "id": 180401,
        "name_th": "สรรพยา",
        "name_en": "Sapphaya",
        "zip_codes": [
            17150
        ],
        "district_id": 1804
    },
    {
        "id": 180402,
        "name_th": "ตลุก",
        "name_en": "Taluk",
        "zip_codes": [
            17150
        ],
        "district_id": 1804
    },
    {
        "id": 180403,
        "name_th": "เขาแก้ว",
        "name_en": "Khao Kaeo",
        "zip_codes": [
            17150
        ],
        "district_id": 1804
    },
    {
        "id": 180404,
        "name_th": "โพนางดำตก",
        "name_en": "Pho Nang Dam Tok",
        "zip_codes": [
            17150
        ],
        "district_id": 1804
    },
    {
        "id": 180405,
        "name_th": "โพนางดำออก",
        "name_en": "Pho Nang Dam Ok",
        "zip_codes": [
            17150
        ],
        "district_id": 1804
    },
    {
        "id": 180406,
        "name_th": "บางหลวง",
        "name_en": "Bang Luang",
        "zip_codes": [
            17150
        ],
        "district_id": 1804
    },
    {
        "id": 180407,
        "name_th": "หาดอาษา",
        "name_en": "Hat Asa",
        "zip_codes": [
            17150
        ],
        "district_id": 1804
    },
    {
        "id": 180501,
        "name_th": "แพรกศรีราชา",
        "name_en": "Phraek Si Racha",
        "zip_codes": [
            17140
        ],
        "district_id": 1805
    },
    {
        "id": 180502,
        "name_th": "เที่ยงแท้",
        "name_en": "Thiang Thae",
        "zip_codes": [
            17140
        ],
        "district_id": 1805
    },
    {
        "id": 180503,
        "name_th": "ห้วยกรด",
        "name_en": "Huai Krot",
        "zip_codes": [
            17140
        ],
        "district_id": 1805
    },
    {
        "id": 180504,
        "name_th": "โพงาม",
        "name_en": "Pho Ngam",
        "zip_codes": [
            17140
        ],
        "district_id": 1805
    },
    {
        "id": 180505,
        "name_th": "บางขุด",
        "name_en": "Bang Khut",
        "zip_codes": [
            17140
        ],
        "district_id": 1805
    },
    {
        "id": 180506,
        "name_th": "ดงคอน",
        "name_en": "Dong Khon",
        "zip_codes": [
            17140
        ],
        "district_id": 1805
    },
    {
        "id": 180507,
        "name_th": "ดอนกำ",
        "name_en": "Don Kam",
        "zip_codes": [
            17140
        ],
        "district_id": 1805
    },
    {
        "id": 180508,
        "name_th": "ห้วยกรดพัฒนา",
        "name_en": "Huai Krot Phatthana",
        "zip_codes": [
            17140
        ],
        "district_id": 1805
    },
    {
        "id": 180601,
        "name_th": "หันคา",
        "name_en": "Hankha",
        "zip_codes": [
            17130
        ],
        "district_id": 1806
    },
    {
        "id": 180602,
        "name_th": "บ้านเชี่ยน",
        "name_en": "Ban Chian",
        "zip_codes": [
            17130
        ],
        "district_id": 1806
    },
    {
        "id": 180605,
        "name_th": "ไพรนกยูง",
        "name_en": "Phrai Nok Yung",
        "zip_codes": [
            17130
        ],
        "district_id": 1806
    },
    {
        "id": 180606,
        "name_th": "หนองแซง",
        "name_en": "Nong Saeng",
        "zip_codes": [
            17160
        ],
        "district_id": 1806
    },
    {
        "id": 180607,
        "name_th": "ห้วยงู",
        "name_en": "Huai Ngu",
        "zip_codes": [
            17160
        ],
        "district_id": 1806
    },
    {
        "id": 180608,
        "name_th": "วังไก่เถื่อน",
        "name_en": "Wang Kai Thuean",
        "zip_codes": [
            17130
        ],
        "district_id": 1806
    },
    {
        "id": 180609,
        "name_th": "เด่นใหญ่",
        "name_en": "Den Yai",
        "zip_codes": [
            17130
        ],
        "district_id": 1806
    },
    {
        "id": 180611,
        "name_th": "สามง่ามท่าโบสถ์",
        "name_en": "Sam Ngam Tha Bot",
        "zip_codes": [
            17160
        ],
        "district_id": 1806
    },
    {
        "id": 180701,
        "name_th": "หนองมะโมง",
        "name_en": "Nong Mamong",
        "zip_codes": [
            17120
        ],
        "district_id": 1807
    },
    {
        "id": 180702,
        "name_th": "วังตะเคียน",
        "name_en": "Wang Takhian",
        "zip_codes": [
            17120
        ],
        "district_id": 1807
    },
    {
        "id": 180703,
        "name_th": "สะพานหิน",
        "name_en": "Saphan Hin",
        "zip_codes": [
            17120
        ],
        "district_id": 1807
    },
    {
        "id": 180704,
        "name_th": "กุดจอก",
        "name_en": "Kut Chok",
        "zip_codes": [
            17120
        ],
        "district_id": 1807
    },
    {
        "id": 180801,
        "name_th": "เนินขาม",
        "name_en": "Noen Kham",
        "zip_codes": [
            17130
        ],
        "district_id": 1808
    },
    {
        "id": 180802,
        "name_th": "กะบกเตี้ย",
        "name_en": "Kabok Tia",
        "zip_codes": [
            17130
        ],
        "district_id": 1808
    },
    {
        "id": 180803,
        "name_th": "สุขเดือนห้า",
        "name_en": "Suk Duean Ha",
        "zip_codes": [
            17130
        ],
        "district_id": 1808
    },
    {
        "id": 190101,
        "name_th": "ปากเพรียว",
        "name_en": "Pak Phriao",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190105,
        "name_th": "ดาวเรือง",
        "name_en": "Dao Rueang",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190106,
        "name_th": "นาโฉง",
        "name_en": "Na Chong",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190107,
        "name_th": "โคกสว่าง",
        "name_en": "Khok Sawang",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190108,
        "name_th": "หนองโน",
        "name_en": "Nong No",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190109,
        "name_th": "หนองยาว",
        "name_en": "Nong Yao",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190110,
        "name_th": "ปากข้าวสาร",
        "name_en": "Pak Khao San",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190111,
        "name_th": "หนองปลาไหล",
        "name_en": "Nong Pla Lai",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190112,
        "name_th": "กุดนกเปล้า",
        "name_en": "Kut Nok Plao",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190113,
        "name_th": "ตลิ่งชัน",
        "name_en": "Taling Chan",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190114,
        "name_th": "ตะกุด",
        "name_en": "Takut",
        "zip_codes": [
            18000
        ],
        "district_id": 1901
    },
    {
        "id": 190201,
        "name_th": "แก่งคอย",
        "name_en": "Kaeng Khoi",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190202,
        "name_th": "ทับกวาง",
        "name_en": "Thap Kwang",
        "zip_codes": [
            18260
        ],
        "district_id": 1902
    },
    {
        "id": 190203,
        "name_th": "ตาลเดี่ยว",
        "name_en": "Tan Diao",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190204,
        "name_th": "ห้วยแห้ง",
        "name_en": "Huai Haeng",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190205,
        "name_th": "ท่าคล้อ",
        "name_en": "Tha Khlo",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190206,
        "name_th": "หินซ้อน",
        "name_en": "Hin Son",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190207,
        "name_th": "บ้านธาตุ",
        "name_en": "Ban That",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190208,
        "name_th": "บ้านป่า",
        "name_en": "Ban Pa",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190209,
        "name_th": "ท่าตูม",
        "name_en": "Tha Tum",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190210,
        "name_th": "ชะอม",
        "name_en": "Cha-om",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190211,
        "name_th": "สองคอน",
        "name_en": "Song Khon",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190212,
        "name_th": "เตาปูน",
        "name_en": "Tao Pun",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190213,
        "name_th": "ชำผักแพว",
        "name_en": "Cham Phak Phaeo",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190215,
        "name_th": "ท่ามะปราง",
        "name_en": "Tha Maprang",
        "zip_codes": [
            18110
        ],
        "district_id": 1902
    },
    {
        "id": 190301,
        "name_th": "หนองแค",
        "name_en": "Nong Khae",
        "zip_codes": [
            18140
        ],
        "district_id": 1903
    },
    {
        "id": 190302,
        "name_th": "กุ่มหัก",
        "name_en": "Kum Hak",
        "zip_codes": [
            18140
        ],
        "district_id": 1903
    },
    {
        "id": 190303,
        "name_th": "คชสิทธิ์",
        "name_en": "Khotchasit",
        "zip_codes": [
            18250
        ],
        "district_id": 1903
    },
    {
        "id": 190304,
        "name_th": "โคกตูม",
        "name_en": "Khok Tum",
        "zip_codes": [
            18250
        ],
        "district_id": 1903
    },
    {
        "id": 190305,
        "name_th": "โคกแย้",
        "name_en": "Khok Yae",
        "zip_codes": [
            18230
        ],
        "district_id": 1903
    },
    {
        "id": 190306,
        "name_th": "บัวลอย",
        "name_en": "Bua Loi",
        "zip_codes": [
            18140,
            18230
        ],
        "district_id": 1903
    },
    {
        "id": 190307,
        "name_th": "ไผ่ต่ำ",
        "name_en": "Phai Tam",
        "zip_codes": [
            18140
        ],
        "district_id": 1903
    },
    {
        "id": 190308,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            18250
        ],
        "district_id": 1903
    },
    {
        "id": 190309,
        "name_th": "ห้วยขมิ้น",
        "name_en": "Huai Khamin",
        "zip_codes": [
            18230
        ],
        "district_id": 1903
    },
    {
        "id": 190310,
        "name_th": "ห้วยทราย",
        "name_en": "Huai Sai",
        "zip_codes": [
            18230
        ],
        "district_id": 1903
    },
    {
        "id": 190311,
        "name_th": "หนองไข่น้ำ",
        "name_en": "Nong Khai Nam",
        "zip_codes": [
            18140
        ],
        "district_id": 1903
    },
    {
        "id": 190312,
        "name_th": "หนองแขม",
        "name_en": "Nong Khaem",
        "zip_codes": [
            18140
        ],
        "district_id": 1903
    },
    {
        "id": 190313,
        "name_th": "หนองจิก",
        "name_en": "Nong Chik",
        "zip_codes": [
            18230
        ],
        "district_id": 1903
    },
    {
        "id": 190314,
        "name_th": "หนองจรเข้",
        "name_en": "Nong Chorakhe",
        "zip_codes": [
            18140
        ],
        "district_id": 1903
    },
    {
        "id": 190315,
        "name_th": "หนองนาก",
        "name_en": "Nong Nak",
        "zip_codes": [
            18230
        ],
        "district_id": 1903
    },
    {
        "id": 190316,
        "name_th": "หนองปลาหมอ",
        "name_en": "Nong Pla Mo",
        "zip_codes": [
            18140
        ],
        "district_id": 1903
    },
    {
        "id": 190317,
        "name_th": "หนองปลิง",
        "name_en": "Nong Pling",
        "zip_codes": [
            18140
        ],
        "district_id": 1903
    },
    {
        "id": 190318,
        "name_th": "หนองโรง",
        "name_en": "Nong Rong",
        "zip_codes": [
            18140
        ],
        "district_id": 1903
    },
    {
        "id": 190401,
        "name_th": "หนองหมู",
        "name_en": "Nong Mu",
        "zip_codes": [
            18150
        ],
        "district_id": 1904
    },
    {
        "id": 190402,
        "name_th": "บ้านลำ",
        "name_en": "Ban Lam",
        "zip_codes": [
            18150
        ],
        "district_id": 1904
    },
    {
        "id": 190403,
        "name_th": "คลองเรือ",
        "name_en": "Khlong Ruea",
        "zip_codes": [
            18150
        ],
        "district_id": 1904
    },
    {
        "id": 190404,
        "name_th": "วิหารแดง",
        "name_en": "Wihan Daeng",
        "zip_codes": [
            18150
        ],
        "district_id": 1904
    },
    {
        "id": 190405,
        "name_th": "หนองสรวง",
        "name_en": "Nong Suang",
        "zip_codes": [
            18150
        ],
        "district_id": 1904
    },
    {
        "id": 190406,
        "name_th": "เจริญธรรม",
        "name_en": "Charoen Tham",
        "zip_codes": [
            18150
        ],
        "district_id": 1904
    },
    {
        "id": 190501,
        "name_th": "หนองแซง",
        "name_en": "Nong Saeng",
        "zip_codes": [
            18170
        ],
        "district_id": 1905
    },
    {
        "id": 190502,
        "name_th": "หนองควายโซ",
        "name_en": "Nong Khwai So",
        "zip_codes": [
            18170
        ],
        "district_id": 1905
    },
    {
        "id": 190503,
        "name_th": "หนองหัวโพ",
        "name_en": "Nong Hua Pho",
        "zip_codes": [
            18170
        ],
        "district_id": 1905
    },
    {
        "id": 190504,
        "name_th": "หนองสีดา",
        "name_en": "Nong Sida",
        "zip_codes": [
            18170
        ],
        "district_id": 1905
    },
    {
        "id": 190505,
        "name_th": "หนองกบ",
        "name_en": "Nong Kop",
        "zip_codes": [
            18170
        ],
        "district_id": 1905
    },
    {
        "id": 190506,
        "name_th": "ไก่เส่า",
        "name_en": "Kai Sao",
        "zip_codes": [
            18170
        ],
        "district_id": 1905
    },
    {
        "id": 190507,
        "name_th": "โคกสะอาด",
        "name_en": "Khok Sa-at",
        "zip_codes": [
            18170
        ],
        "district_id": 1905
    },
    {
        "id": 190508,
        "name_th": "ม่วงหวาน",
        "name_en": "Muang Wan",
        "zip_codes": [
            18170
        ],
        "district_id": 1905
    },
    {
        "id": 190509,
        "name_th": "เขาดิน",
        "name_en": "Khao Din",
        "zip_codes": [
            18170
        ],
        "district_id": 1905
    },
    {
        "id": 190601,
        "name_th": "บ้านหมอ",
        "name_en": "Ban Mo",
        "zip_codes": [
            18130
        ],
        "district_id": 1906
    },
    {
        "id": 190602,
        "name_th": "บางโขมด",
        "name_en": "Bang Khamot",
        "zip_codes": [
            18130,
            18270
        ],
        "district_id": 1906
    },
    {
        "id": 190603,
        "name_th": "สร่างโศก",
        "name_en": "Sang Sok",
        "zip_codes": [
            18130
        ],
        "district_id": 1906
    },
    {
        "id": 190604,
        "name_th": "ตลาดน้อย",
        "name_en": "Talat Noi",
        "zip_codes": [
            18130
        ],
        "district_id": 1906
    },
    {
        "id": 190605,
        "name_th": "หรเทพ",
        "name_en": "Horathep",
        "zip_codes": [
            18130,
            18210
        ],
        "district_id": 1906
    },
    {
        "id": 190606,
        "name_th": "โคกใหญ่",
        "name_en": "Khok Yai",
        "zip_codes": [
            18130
        ],
        "district_id": 1906
    },
    {
        "id": 190607,
        "name_th": "ไผ่ขวาง",
        "name_en": "Phai Khwang",
        "zip_codes": [
            18130
        ],
        "district_id": 1906
    },
    {
        "id": 190608,
        "name_th": "บ้านครัว",
        "name_en": "Ban Khrua",
        "zip_codes": [
            18270
        ],
        "district_id": 1906
    },
    {
        "id": 190609,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            18130
        ],
        "district_id": 1906
    },
    {
        "id": 190701,
        "name_th": "ดอนพุด",
        "name_en": "Don Phut",
        "zip_codes": [
            18210
        ],
        "district_id": 1907
    },
    {
        "id": 190702,
        "name_th": "ไผ่หลิ่ว",
        "name_en": "Phai Lio",
        "zip_codes": [
            18210
        ],
        "district_id": 1907
    },
    {
        "id": 190703,
        "name_th": "บ้านหลวง",
        "name_en": "Ban Luang",
        "zip_codes": [
            18210
        ],
        "district_id": 1907
    },
    {
        "id": 190704,
        "name_th": "ดงตะงาว",
        "name_en": "Dong Ta-ngao",
        "zip_codes": [
            18210
        ],
        "district_id": 1907
    },
    {
        "id": 190801,
        "name_th": "หนองโดน",
        "name_en": "Nong Don",
        "zip_codes": [
            18190
        ],
        "district_id": 1908
    },
    {
        "id": 190802,
        "name_th": "บ้านกลับ",
        "name_en": "Ban Klap",
        "zip_codes": [
            18190
        ],
        "district_id": 1908
    },
    {
        "id": 190803,
        "name_th": "ดอนทอง",
        "name_en": "Don Thong",
        "zip_codes": [
            18190
        ],
        "district_id": 1908
    },
    {
        "id": 190804,
        "name_th": "บ้านโปร่ง",
        "name_en": "Ban Prong",
        "zip_codes": [
            18190
        ],
        "district_id": 1908
    },
    {
        "id": 190901,
        "name_th": "พระพุทธบาท",
        "name_en": "Phra Phutthabat",
        "zip_codes": [
            18120
        ],
        "district_id": 1909
    },
    {
        "id": 190902,
        "name_th": "ขุนโขลน",
        "name_en": "Khun Khlon",
        "zip_codes": [
            18120
        ],
        "district_id": 1909
    },
    {
        "id": 190903,
        "name_th": "ธารเกษม",
        "name_en": "Than Kasem",
        "zip_codes": [
            18120
        ],
        "district_id": 1909
    },
    {
        "id": 190904,
        "name_th": "นายาว",
        "name_en": "Na Yao",
        "zip_codes": [
            18120
        ],
        "district_id": 1909
    },
    {
        "id": 190905,
        "name_th": "พุคำจาน",
        "name_en": "Phu Kham Chan",
        "zip_codes": [
            18120
        ],
        "district_id": 1909
    },
    {
        "id": 190906,
        "name_th": "เขาวง",
        "name_en": "Khao Wong",
        "zip_codes": [
            18120
        ],
        "district_id": 1909
    },
    {
        "id": 190907,
        "name_th": "ห้วยป่าหวาย",
        "name_en": "Huai Pa Wai",
        "zip_codes": [
            18120
        ],
        "district_id": 1909
    },
    {
        "id": 190908,
        "name_th": "พุกร่าง",
        "name_en": "Phu Krang",
        "zip_codes": [
            18120
        ],
        "district_id": 1909
    },
    {
        "id": 190909,
        "name_th": "หนองแก",
        "name_en": "Nong Kae",
        "zip_codes": [
            18120
        ],
        "district_id": 1909
    },
    {
        "id": 191001,
        "name_th": "เสาไห้",
        "name_en": "Sao Hai",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191002,
        "name_th": "บ้านยาง",
        "name_en": "Ban Yang",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191003,
        "name_th": "หัวปลวก",
        "name_en": "Hua Pluak",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191004,
        "name_th": "งิ้วงาม",
        "name_en": "Ngio Ngam",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191005,
        "name_th": "ศาลารีไทย",
        "name_en": "Sala Ri Thai",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191006,
        "name_th": "ต้นตาล",
        "name_en": "Ton Tan",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191007,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191008,
        "name_th": "พระยาทด",
        "name_en": "Phraya Thot",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191009,
        "name_th": "ม่วงงาม",
        "name_en": "Muang Ngam",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191010,
        "name_th": "เริงราง",
        "name_en": "Roeng Rang",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191011,
        "name_th": "เมืองเก่า",
        "name_en": "Mueang Kao",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191012,
        "name_th": "สวนดอกไม้",
        "name_en": "Suan Dok Mai",
        "zip_codes": [
            18160
        ],
        "district_id": 1910
    },
    {
        "id": 191101,
        "name_th": "มวกเหล็ก",
        "name_en": "Muak Lek",
        "zip_codes": [
            18180
        ],
        "district_id": 1911
    },
    {
        "id": 191102,
        "name_th": "มิตรภาพ",
        "name_en": "Mittraphap",
        "zip_codes": [
            18180
        ],
        "district_id": 1911
    },
    {
        "id": 191104,
        "name_th": "หนองย่างเสือ",
        "name_en": "Nong Yang Suea",
        "zip_codes": [
            18180
        ],
        "district_id": 1911
    },
    {
        "id": 191105,
        "name_th": "ลำสมพุง",
        "name_en": "Lam Somphung",
        "zip_codes": [
            30130
        ],
        "district_id": 1911
    },
    {
        "id": 191107,
        "name_th": "ลำพญากลาง",
        "name_en": "Lam Phaya Klang",
        "zip_codes": [
            30130
        ],
        "district_id": 1911
    },
    {
        "id": 191109,
        "name_th": "ซับสนุ่น",
        "name_en": "Sap Sanun",
        "zip_codes": [
            18220
        ],
        "district_id": 1911
    },
    {
        "id": 191201,
        "name_th": "แสลงพัน",
        "name_en": "Salaeng Phan",
        "zip_codes": [
            18220
        ],
        "district_id": 1912
    },
    {
        "id": 191202,
        "name_th": "คำพราน",
        "name_en": "Kham Phran",
        "zip_codes": [
            18220
        ],
        "district_id": 1912
    },
    {
        "id": 191203,
        "name_th": "วังม่วง",
        "name_en": "Wang Muang",
        "zip_codes": [
            18220
        ],
        "district_id": 1912
    },
    {
        "id": 191301,
        "name_th": "เขาดินพัฒนา",
        "name_en": "Khao Din Phatthana",
        "zip_codes": [
            18000
        ],
        "district_id": 1913
    },
    {
        "id": 191302,
        "name_th": "บ้านแก้ง",
        "name_en": "Ban Kaeng",
        "zip_codes": [
            18000
        ],
        "district_id": 1913
    },
    {
        "id": 191303,
        "name_th": "ผึ้งรวง",
        "name_en": "Phueng Ruang",
        "zip_codes": [
            18000
        ],
        "district_id": 1913
    },
    {
        "id": 191304,
        "name_th": "พุแค",
        "name_en": "Phu Khae",
        "zip_codes": [
            18240
        ],
        "district_id": 1913
    },
    {
        "id": 191305,
        "name_th": "ห้วยบง",
        "name_en": "Huai Bong",
        "zip_codes": [
            18000,
            18240
        ],
        "district_id": 1913
    },
    {
        "id": 191306,
        "name_th": "หน้าพระลาน",
        "name_en": "Na Phra Lan",
        "zip_codes": [
            18240
        ],
        "district_id": 1913
    },
    {
        "id": 200101,
        "name_th": "บางปลาสร้อย",
        "name_en": "Bang Pla Soi",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200102,
        "name_th": "มะขามหย่ง",
        "name_en": "Makham Yong",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200103,
        "name_th": "บ้านโขด",
        "name_en": "Ban Khot",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200104,
        "name_th": "แสนสุข",
        "name_en": "Saen Suk",
        "zip_codes": [
            20130,
            20131
        ],
        "district_id": 2001
    },
    {
        "id": 200105,
        "name_th": "บ้านสวน",
        "name_en": "Ban Suan",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200106,
        "name_th": "หนองรี",
        "name_en": "Nong Ri",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200107,
        "name_th": "นาป่า",
        "name_en": "Na Pa",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200108,
        "name_th": "หนองข้างคอก",
        "name_en": "Nong Khang Khok",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200109,
        "name_th": "ดอนหัวฬ่อ",
        "name_en": "Don Hua Lo",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200110,
        "name_th": "หนองไม้แดง",
        "name_en": "Nong Mai Daeng",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200111,
        "name_th": "บางทราย",
        "name_en": "Bang Sai",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200112,
        "name_th": "คลองตำหรุ",
        "name_en": "Khlong Tamru",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200113,
        "name_th": "เหมือง",
        "name_en": "Mueang",
        "zip_codes": [
            20130
        ],
        "district_id": 2001
    },
    {
        "id": 200114,
        "name_th": "บ้านปึก",
        "name_en": "Ban Puek",
        "zip_codes": [
            20130
        ],
        "district_id": 2001
    },
    {
        "id": 200115,
        "name_th": "ห้วยกะปิ",
        "name_en": "Huai Kapi",
        "zip_codes": [
            20000,
            20130
        ],
        "district_id": 2001
    },
    {
        "id": 200116,
        "name_th": "เสม็ด",
        "name_en": "Samet",
        "zip_codes": [
            20000,
            20130
        ],
        "district_id": 2001
    },
    {
        "id": 200117,
        "name_th": "อ่างศิลา",
        "name_en": "Ang Sila",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200118,
        "name_th": "สำนักบก",
        "name_en": "Samnak Bok",
        "zip_codes": [
            20000
        ],
        "district_id": 2001
    },
    {
        "id": 200201,
        "name_th": "บ้านบึง",
        "name_en": "Ban Bueng",
        "zip_codes": [
            20170
        ],
        "district_id": 2002
    },
    {
        "id": 200202,
        "name_th": "คลองกิ่ว",
        "name_en": "Khlong Kio",
        "zip_codes": [
            20220
        ],
        "district_id": 2002
    },
    {
        "id": 200203,
        "name_th": "มาบไผ่",
        "name_en": "Map Phai",
        "zip_codes": [
            20170
        ],
        "district_id": 2002
    },
    {
        "id": 200204,
        "name_th": "หนองซ้ำซาก",
        "name_en": "Nong Samsak",
        "zip_codes": [
            20170
        ],
        "district_id": 2002
    },
    {
        "id": 200205,
        "name_th": "หนองบอนแดง",
        "name_en": "Nong Bon Daeng",
        "zip_codes": [
            20170
        ],
        "district_id": 2002
    },
    {
        "id": 200206,
        "name_th": "หนองชาก",
        "name_en": "Nong Chak",
        "zip_codes": [
            20170
        ],
        "district_id": 2002
    },
    {
        "id": 200207,
        "name_th": "หนองอิรุณ",
        "name_en": "Nong Irun",
        "zip_codes": [
            20220
        ],
        "district_id": 2002
    },
    {
        "id": 200208,
        "name_th": "หนองไผ่แก้ว",
        "name_en": "Nong Phai Kaeo",
        "zip_codes": [
            20220
        ],
        "district_id": 2002
    },
    {
        "id": 200301,
        "name_th": "หนองใหญ่",
        "name_en": "Nong Yai",
        "zip_codes": [
            20190
        ],
        "district_id": 2003
    },
    {
        "id": 200302,
        "name_th": "คลองพลู",
        "name_en": "Khlong Phlu",
        "zip_codes": [
            20190
        ],
        "district_id": 2003
    },
    {
        "id": 200303,
        "name_th": "หนองเสือช้าง",
        "name_en": "Nong Suea Chang",
        "zip_codes": [
            20190
        ],
        "district_id": 2003
    },
    {
        "id": 200304,
        "name_th": "ห้างสูง",
        "name_en": "Hang Sung",
        "zip_codes": [
            20190
        ],
        "district_id": 2003
    },
    {
        "id": 200305,
        "name_th": "เขาซก",
        "name_en": "Khao Sok",
        "zip_codes": [
            20190
        ],
        "district_id": 2003
    },
    {
        "id": 200401,
        "name_th": "บางละมุง",
        "name_en": "Bang Lamung",
        "zip_codes": [
            20150
        ],
        "district_id": 2004
    },
    {
        "id": 200402,
        "name_th": "หนองปรือ",
        "name_en": "Nong Prue",
        "zip_codes": [
            20150
        ],
        "district_id": 2004
    },
    {
        "id": 200403,
        "name_th": "หนองปลาไหล",
        "name_en": "Nong Pla Lai",
        "zip_codes": [
            20150
        ],
        "district_id": 2004
    },
    {
        "id": 200404,
        "name_th": "โป่ง",
        "name_en": "Pong",
        "zip_codes": [
            20150
        ],
        "district_id": 2004
    },
    {
        "id": 200405,
        "name_th": "เขาไม้แก้ว",
        "name_en": "Khao Mai Kaeo",
        "zip_codes": [
            20150
        ],
        "district_id": 2004
    },
    {
        "id": 200406,
        "name_th": "ห้วยใหญ่",
        "name_en": "Huai Yai",
        "zip_codes": [
            20150
        ],
        "district_id": 2004
    },
    {
        "id": 200407,
        "name_th": "ตะเคียนเตี้ย",
        "name_en": "Takhian Tia",
        "zip_codes": [
            20150
        ],
        "district_id": 2004
    },
    {
        "id": 200408,
        "name_th": "นาเกลือ",
        "name_en": "Na Kluea",
        "zip_codes": [
            20150
        ],
        "district_id": 2004
    },
    {
        "id": 200501,
        "name_th": "พานทอง",
        "name_en": "Phan Thong",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200502,
        "name_th": "หนองตำลึง",
        "name_en": "Nong Tamlueng",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200503,
        "name_th": "มาบโป่ง",
        "name_en": "Map Pong",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200504,
        "name_th": "หนองกะขะ",
        "name_en": "Nong Kakha",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200505,
        "name_th": "หนองหงษ์",
        "name_en": "Nong Hong",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200506,
        "name_th": "โคกขี้หนอน",
        "name_en": "Khok Khi Non",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200507,
        "name_th": "บ้านเก่า",
        "name_en": "Ban Kao",
        "zip_codes": [
            20000,
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200508,
        "name_th": "หน้าประดู่",
        "name_en": "Na Pradu",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200509,
        "name_th": "บางนาง",
        "name_en": "Bang Nang",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200510,
        "name_th": "เกาะลอย",
        "name_en": "Ko Loi",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200511,
        "name_th": "บางหัก",
        "name_en": "Bang Hak",
        "zip_codes": [
            20160
        ],
        "district_id": 2005
    },
    {
        "id": 200601,
        "name_th": "พนัสนิคม",
        "name_en": "Phanat Nikhom",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200602,
        "name_th": "หน้าพระธาตุ",
        "name_en": "Na Phra That",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200603,
        "name_th": "วัดหลวง",
        "name_en": "Wat Luang",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200604,
        "name_th": "บ้านเซิด",
        "name_en": "Ban Soet",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200605,
        "name_th": "นาเริก",
        "name_en": "Na Roek",
        "zip_codes": [
            20140,
            20240
        ],
        "district_id": 2006
    },
    {
        "id": 200606,
        "name_th": "หมอนนาง",
        "name_en": "Mon Nang",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200607,
        "name_th": "สระสี่เหลี่ยม",
        "name_en": "Sa Si Liam",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200608,
        "name_th": "วัดโบสถ์",
        "name_en": "Wat Bot",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200609,
        "name_th": "กุฎโง้ง",
        "name_en": "Kut Ngong",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200610,
        "name_th": "หัวถนน",
        "name_en": "Hua Thanon",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200611,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200613,
        "name_th": "หนองปรือ",
        "name_en": "Nong Prue",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200614,
        "name_th": "หนองขยาด",
        "name_en": "Nong Khayat",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200615,
        "name_th": "ทุ่งขวาง",
        "name_en": "Thung Khwang",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200616,
        "name_th": "หนองเหียง",
        "name_en": "Nong Hiang",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200617,
        "name_th": "นาวังหิน",
        "name_en": "Na Wang Hin",
        "zip_codes": [
            20140,
            20240
        ],
        "district_id": 2006
    },
    {
        "id": 200618,
        "name_th": "บ้านช้าง",
        "name_en": "Ban Chang",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200620,
        "name_th": "โคกเพลาะ",
        "name_en": "Khok Phlo",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200621,
        "name_th": "ไร่หลักทอง",
        "name_en": "Rai Lak Thong",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200622,
        "name_th": "นามะตูม",
        "name_en": "Na Matum",
        "zip_codes": [
            20140
        ],
        "district_id": 2006
    },
    {
        "id": 200701,
        "name_th": "ศรีราชา",
        "name_en": "Si Racha",
        "zip_codes": [
            20110
        ],
        "district_id": 2007
    },
    {
        "id": 200702,
        "name_th": "สุรศักดิ์",
        "name_en": "Surasak",
        "zip_codes": [
            20110
        ],
        "district_id": 2007
    },
    {
        "id": 200703,
        "name_th": "ทุ่งสุขลา",
        "name_en": "Thung Sukhla",
        "zip_codes": [
            20230
        ],
        "district_id": 2007
    },
    {
        "id": 200704,
        "name_th": "บึง",
        "name_en": "Bueng",
        "zip_codes": [
            20230
        ],
        "district_id": 2007
    },
    {
        "id": 200705,
        "name_th": "หนองขาม",
        "name_en": "Nong Kham",
        "zip_codes": [
            20110,
            20230
        ],
        "district_id": 2007
    },
    {
        "id": 200706,
        "name_th": "เขาคันทรง",
        "name_en": "Khao Khansong",
        "zip_codes": [
            20110
        ],
        "district_id": 2007
    },
    {
        "id": 200707,
        "name_th": "บางพระ",
        "name_en": "Bang Phra",
        "zip_codes": [
            20110
        ],
        "district_id": 2007
    },
    {
        "id": 200708,
        "name_th": "บ่อวิน",
        "name_en": "Bo Win",
        "zip_codes": [
            20230
        ],
        "district_id": 2007
    },
    {
        "id": 200801,
        "name_th": "ท่าเทววงษ์",
        "name_en": "Tha Thewawong",
        "zip_codes": [
            20120
        ],
        "district_id": 2008
    },
    {
        "id": 200901,
        "name_th": "สัตหีบ",
        "name_en": "Sattahip",
        "zip_codes": [
            20180,
            20182
        ],
        "district_id": 2009
    },
    {
        "id": 200902,
        "name_th": "นาจอมเทียน",
        "name_en": "Na Chom Thian",
        "zip_codes": [
            20250
        ],
        "district_id": 2009
    },
    {
        "id": 200903,
        "name_th": "พลูตาหลวง",
        "name_en": "Phlu Ta Luang",
        "zip_codes": [
            20180
        ],
        "district_id": 2009
    },
    {
        "id": 200904,
        "name_th": "บางเสร่",
        "name_en": "Bang Sare",
        "zip_codes": [
            20250,
            20251
        ],
        "district_id": 2009
    },
    {
        "id": 200905,
        "name_th": "แสมสาร",
        "name_en": "Samaesan",
        "zip_codes": [
            20180
        ],
        "district_id": 2009
    },
    {
        "id": 201001,
        "name_th": "บ่อทอง",
        "name_en": "Bo Thong",
        "zip_codes": [
            20270
        ],
        "district_id": 2010
    },
    {
        "id": 201002,
        "name_th": "วัดสุวรรณ",
        "name_en": "Wat Suwan",
        "zip_codes": [
            20270
        ],
        "district_id": 2010
    },
    {
        "id": 201003,
        "name_th": "บ่อกวางทอง",
        "name_en": "Bo Kwang Thong",
        "zip_codes": [
            20270
        ],
        "district_id": 2010
    },
    {
        "id": 201004,
        "name_th": "ธาตุทอง",
        "name_en": "That Thong",
        "zip_codes": [
            20270
        ],
        "district_id": 2010
    },
    {
        "id": 201005,
        "name_th": "เกษตรสุวรรณ",
        "name_en": "Kaset Suwan",
        "zip_codes": [
            20270
        ],
        "district_id": 2010
    },
    {
        "id": 201006,
        "name_th": "พลวงทอง",
        "name_en": "Phluang Thong",
        "zip_codes": [
            20270
        ],
        "district_id": 2010
    },
    {
        "id": 201101,
        "name_th": "เกาะจันทร์",
        "name_en": "Ko Chan",
        "zip_codes": [
            20240
        ],
        "district_id": 2011
    },
    {
        "id": 201102,
        "name_th": "ท่าบุญมี",
        "name_en": "Tha Bun Mi",
        "zip_codes": [
            20240
        ],
        "district_id": 2011
    },
    {
        "id": 210101,
        "name_th": "ท่าประดู่",
        "name_en": "Tha Pradu",
        "zip_codes": [
            21000
        ],
        "district_id": 2101
    },
    {
        "id": 210102,
        "name_th": "เชิงเนิน",
        "name_en": "Choeng Noen",
        "zip_codes": [
            21000
        ],
        "district_id": 2101
    },
    {
        "id": 210103,
        "name_th": "ตะพง",
        "name_en": "Taphong",
        "zip_codes": [
            21000
        ],
        "district_id": 2101
    },
    {
        "id": 210104,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            21000
        ],
        "district_id": 2101
    },
    {
        "id": 210105,
        "name_th": "เพ",
        "name_en": "Phe",
        "zip_codes": [
            21160
        ],
        "district_id": 2101
    },
    {
        "id": 210106,
        "name_th": "แกลง",
        "name_en": "Klaeng",
        "zip_codes": [
            21160
        ],
        "district_id": 2101
    },
    {
        "id": 210107,
        "name_th": "บ้านแลง",
        "name_en": "Ban Laeng",
        "zip_codes": [
            21000
        ],
        "district_id": 2101
    },
    {
        "id": 210108,
        "name_th": "นาตาขวัญ",
        "name_en": "Na Ta Khwan",
        "zip_codes": [
            21000
        ],
        "district_id": 2101
    },
    {
        "id": 210109,
        "name_th": "เนินพระ",
        "name_en": "Noen Phra",
        "zip_codes": [
            21000,
            21150
        ],
        "district_id": 2101
    },
    {
        "id": 210110,
        "name_th": "กะเฉด",
        "name_en": "Kachet",
        "zip_codes": [
            21100
        ],
        "district_id": 2101
    },
    {
        "id": 210111,
        "name_th": "ทับมา",
        "name_en": "Thap Ma",
        "zip_codes": [
            21000
        ],
        "district_id": 2101
    },
    {
        "id": 210112,
        "name_th": "น้ำคอก",
        "name_en": "Nam Khok",
        "zip_codes": [
            21000
        ],
        "district_id": 2101
    },
    {
        "id": 210113,
        "name_th": "ห้วยโป่ง",
        "name_en": "Huai Pong",
        "zip_codes": [
            21150
        ],
        "district_id": 2101
    },
    {
        "id": 210114,
        "name_th": "มาบตาพุด",
        "name_en": "Map Ta Phut",
        "zip_codes": [
            21150
        ],
        "district_id": 2101
    },
    {
        "id": 210115,
        "name_th": "สำนักทอง",
        "name_en": "Samnak Thong",
        "zip_codes": [
            21100
        ],
        "district_id": 2101
    },
    {
        "id": 210201,
        "name_th": "สำนักท้อน",
        "name_en": "Samnak Thon",
        "zip_codes": [
            21130
        ],
        "district_id": 2102
    },
    {
        "id": 210202,
        "name_th": "พลา",
        "name_en": "Phala",
        "zip_codes": [
            21130
        ],
        "district_id": 2102
    },
    {
        "id": 210203,
        "name_th": "บ้านฉาง",
        "name_en": "Ban Chang",
        "zip_codes": [
            21130
        ],
        "district_id": 2102
    },
    {
        "id": 210301,
        "name_th": "ทางเกวียน",
        "name_en": "Thang Kwian",
        "zip_codes": [
            21110
        ],
        "district_id": 2103
    },
    {
        "id": 210302,
        "name_th": "วังหว้า",
        "name_en": "Wang Wa",
        "zip_codes": [
            21110
        ],
        "district_id": 2103
    },
    {
        "id": 210303,
        "name_th": "ชากโดน",
        "name_en": "Chak Don",
        "zip_codes": [
            21110
        ],
        "district_id": 2103
    },
    {
        "id": 210304,
        "name_th": "เนินฆ้อ",
        "name_en": "Noen Kho",
        "zip_codes": [
            21110
        ],
        "district_id": 2103
    },
    {
        "id": 210305,
        "name_th": "กร่ำ",
        "name_en": "Kram",
        "zip_codes": [
            21190
        ],
        "district_id": 2103
    },
    {
        "id": 210306,
        "name_th": "ชากพง",
        "name_en": "Chak Phong",
        "zip_codes": [
            21190
        ],
        "district_id": 2103
    },
    {
        "id": 210307,
        "name_th": "กระแสบน",
        "name_en": "Krasae Bon",
        "zip_codes": [
            21110
        ],
        "district_id": 2103
    },
    {
        "id": 210308,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            21110
        ],
        "district_id": 2103
    },
    {
        "id": 210309,
        "name_th": "ทุ่งควายกิน",
        "name_en": "Thung Khwai Kin",
        "zip_codes": [
            21110
        ],
        "district_id": 2103
    },
    {
        "id": 210310,
        "name_th": "กองดิน",
        "name_en": "Kong Din",
        "zip_codes": [
            22160
        ],
        "district_id": 2103
    },
    {
        "id": 210311,
        "name_th": "คลองปูน",
        "name_en": "Khlong Pun",
        "zip_codes": [
            21170
        ],
        "district_id": 2103
    },
    {
        "id": 210312,
        "name_th": "พังราด",
        "name_en": "Phang Rat",
        "zip_codes": [
            21170
        ],
        "district_id": 2103
    },
    {
        "id": 210313,
        "name_th": "ปากน้ำกระแส",
        "name_en": "Pak Nam Krasae",
        "zip_codes": [
            21170
        ],
        "district_id": 2103
    },
    {
        "id": 210317,
        "name_th": "ห้วยยาง",
        "name_en": "Huai Yang",
        "zip_codes": [
            21110
        ],
        "district_id": 2103
    },
    {
        "id": 210318,
        "name_th": "สองสลึง",
        "name_en": "Song Salueng",
        "zip_codes": [
            21110
        ],
        "district_id": 2103
    },
    {
        "id": 210401,
        "name_th": "วังจันทร์",
        "name_en": "Wang Chan",
        "zip_codes": [
            21210
        ],
        "district_id": 2104
    },
    {
        "id": 210402,
        "name_th": "ชุมแสง",
        "name_en": "Chum Saeng",
        "zip_codes": [
            21210
        ],
        "district_id": 2104
    },
    {
        "id": 210403,
        "name_th": "ป่ายุบใน",
        "name_en": "Pa Yup Nai",
        "zip_codes": [
            21210
        ],
        "district_id": 2104
    },
    {
        "id": 210404,
        "name_th": "พลงตาเอี่ยม",
        "name_en": "Phlong Ta Iam",
        "zip_codes": [
            21210
        ],
        "district_id": 2104
    },
    {
        "id": 210501,
        "name_th": "บ้านค่าย",
        "name_en": "Ban Khai",
        "zip_codes": [
            21120
        ],
        "district_id": 2105
    },
    {
        "id": 210502,
        "name_th": "หนองละลอก",
        "name_en": "Nong Lalok",
        "zip_codes": [
            21120
        ],
        "district_id": 2105
    },
    {
        "id": 210503,
        "name_th": "หนองตะพาน",
        "name_en": "Nong Taphan",
        "zip_codes": [
            21120
        ],
        "district_id": 2105
    },
    {
        "id": 210504,
        "name_th": "ตาขัน",
        "name_en": "Ta Khan",
        "zip_codes": [
            21120
        ],
        "district_id": 2105
    },
    {
        "id": 210505,
        "name_th": "บางบุตร",
        "name_en": "Bang But",
        "zip_codes": [
            21120
        ],
        "district_id": 2105
    },
    {
        "id": 210506,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            21120
        ],
        "district_id": 2105
    },
    {
        "id": 210507,
        "name_th": "ชากบก",
        "name_en": "Chak Bok",
        "zip_codes": [
            21120
        ],
        "district_id": 2105
    },
    {
        "id": 210601,
        "name_th": "ปลวกแดง",
        "name_en": "Pluak Daeng",
        "zip_codes": [
            21140
        ],
        "district_id": 2106
    },
    {
        "id": 210602,
        "name_th": "ตาสิทธิ์",
        "name_en": "Ta Sit",
        "zip_codes": [
            21140
        ],
        "district_id": 2106
    },
    {
        "id": 210603,
        "name_th": "ละหาร",
        "name_en": "Lahan",
        "zip_codes": [
            21140
        ],
        "district_id": 2106
    },
    {
        "id": 210604,
        "name_th": "แม่น้ำคู้",
        "name_en": "Maenam Khu",
        "zip_codes": [
            21140
        ],
        "district_id": 2106
    },
    {
        "id": 210605,
        "name_th": "มาบยางพร",
        "name_en": "Map Yang Phon",
        "zip_codes": [
            21140
        ],
        "district_id": 2106
    },
    {
        "id": 210606,
        "name_th": "หนองไร่",
        "name_en": "Nong Rai",
        "zip_codes": [
            21140
        ],
        "district_id": 2106
    },
    {
        "id": 210701,
        "name_th": "น้ำเป็น",
        "name_en": "Nam Pen",
        "zip_codes": [
            21110
        ],
        "district_id": 2107
    },
    {
        "id": 210702,
        "name_th": "ห้วยทับมอญ",
        "name_en": "Huai Thap Mon",
        "zip_codes": [
            21110
        ],
        "district_id": 2107
    },
    {
        "id": 210703,
        "name_th": "ชำฆ้อ",
        "name_en": "Cham Kho",
        "zip_codes": [
            21110
        ],
        "district_id": 2107
    },
    {
        "id": 210704,
        "name_th": "เขาน้อย",
        "name_en": "Khao Noi",
        "zip_codes": [
            21110
        ],
        "district_id": 2107
    },
    {
        "id": 210801,
        "name_th": "นิคมพัฒนา",
        "name_en": "Nikhom Phatthana",
        "zip_codes": [
            21180
        ],
        "district_id": 2108
    },
    {
        "id": 210802,
        "name_th": "มาบข่า",
        "name_en": "Map Kha",
        "zip_codes": [
            21180
        ],
        "district_id": 2108
    },
    {
        "id": 210803,
        "name_th": "พนานิคม",
        "name_en": "Phana Nikhom",
        "zip_codes": [
            21180
        ],
        "district_id": 2108
    },
    {
        "id": 210804,
        "name_th": "มะขามคู่",
        "name_en": "Makham Khu",
        "zip_codes": [
            21180
        ],
        "district_id": 2108
    },
    {
        "id": 220101,
        "name_th": "ตลาด",
        "name_en": "Talat",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220102,
        "name_th": "วัดใหม่",
        "name_en": "Wat Mai",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220103,
        "name_th": "คลองนารายณ์",
        "name_en": "Khlong Narai",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220104,
        "name_th": "เกาะขวาง",
        "name_en": "Ko Khwang",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220105,
        "name_th": "คมบาง",
        "name_en": "Khom Bang",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220106,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220107,
        "name_th": "จันทนิมิต",
        "name_en": "Chanthanimit",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220108,
        "name_th": "บางกะจะ",
        "name_en": "Bang Kacha",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220109,
        "name_th": "แสลง",
        "name_en": "Salaeng",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220110,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220111,
        "name_th": "พลับพลา",
        "name_en": "Phlapphla",
        "zip_codes": [
            22000
        ],
        "district_id": 2201
    },
    {
        "id": 220201,
        "name_th": "ขลุง",
        "name_en": "Khlung",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220202,
        "name_th": "บ่อ",
        "name_en": "Bo",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220203,
        "name_th": "เกวียนหัก",
        "name_en": "Kwian Hak",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220204,
        "name_th": "ตะปอน",
        "name_en": "Tapon",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220205,
        "name_th": "บางชัน",
        "name_en": "Bang Chan",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220206,
        "name_th": "วันยาว",
        "name_en": "Wan Yao",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220207,
        "name_th": "ซึ้ง",
        "name_en": "Sueng",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220208,
        "name_th": "มาบไพ",
        "name_en": "Map Phai",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220209,
        "name_th": "วังสรรพรส",
        "name_en": "Wang Sappharot",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220210,
        "name_th": "ตรอกนอง",
        "name_en": "Trok Nong",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220211,
        "name_th": "ตกพรม",
        "name_en": "Tok Phom",
        "zip_codes": [
            22110
        ],
        "district_id": 2202
    },
    {
        "id": 220212,
        "name_th": "บ่อเวฬุ",
        "name_en": "Bo Weru",
        "zip_codes": [
            22150
        ],
        "district_id": 2202
    },
    {
        "id": 220301,
        "name_th": "ท่าใหม่",
        "name_en": "Tha Mai",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220302,
        "name_th": "ยายร้า",
        "name_en": "Yai Ra",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220303,
        "name_th": "สีพยา",
        "name_en": "Si Phaya",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220304,
        "name_th": "บ่อพุ",
        "name_en": "Bo Phu",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220305,
        "name_th": "พลอยแหวน",
        "name_en": "Phloi Waen",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220306,
        "name_th": "เขาวัว",
        "name_en": "Khao Wua",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220307,
        "name_th": "เขาบายศรี",
        "name_en": "Khao Baisi",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220308,
        "name_th": "สองพี่น้อง",
        "name_en": "Song Phi Nong",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220309,
        "name_th": "ทุ่งเบญจา",
        "name_en": "Thung Bencha",
        "zip_codes": [
            22170
        ],
        "district_id": 2203
    },
    {
        "id": 220311,
        "name_th": "รำพัน",
        "name_en": "Ramphan",
        "zip_codes": [
            22170
        ],
        "district_id": 2203
    },
    {
        "id": 220312,
        "name_th": "โขมง",
        "name_en": "Khamong",
        "zip_codes": [
            22170
        ],
        "district_id": 2203
    },
    {
        "id": 220313,
        "name_th": "ตะกาดเง้า",
        "name_en": "Takat Ngao",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220314,
        "name_th": "คลองขุด",
        "name_en": "Khlong Khut",
        "zip_codes": [
            22120
        ],
        "district_id": 2203
    },
    {
        "id": 220324,
        "name_th": "เขาแก้ว",
        "name_en": "Khao Kaeo",
        "zip_codes": [
            22170
        ],
        "district_id": 2203
    },
    {
        "id": 220401,
        "name_th": "ทับไทร",
        "name_en": "Thap Sai",
        "zip_codes": [
            22140
        ],
        "district_id": 2204
    },
    {
        "id": 220402,
        "name_th": "โป่งน้ำร้อน",
        "name_en": "Pong Nam Ron",
        "zip_codes": [
            22140
        ],
        "district_id": 2204
    },
    {
        "id": 220404,
        "name_th": "หนองตาคง",
        "name_en": "Nong Ta Khong",
        "zip_codes": [
            22140
        ],
        "district_id": 2204
    },
    {
        "id": 220409,
        "name_th": "เทพนิมิต",
        "name_en": "Thep Nimit",
        "zip_codes": [
            22140
        ],
        "district_id": 2204
    },
    {
        "id": 220410,
        "name_th": "คลองใหญ่",
        "name_en": "Khlong Yai",
        "zip_codes": [
            22140
        ],
        "district_id": 2204
    },
    {
        "id": 220501,
        "name_th": "มะขาม",
        "name_en": "Makham",
        "zip_codes": [
            22150
        ],
        "district_id": 2205
    },
    {
        "id": 220502,
        "name_th": "ท่าหลวง",
        "name_en": "Tha Luang",
        "zip_codes": [
            22150
        ],
        "district_id": 2205
    },
    {
        "id": 220503,
        "name_th": "ปัถวี",
        "name_en": "Patthawi",
        "zip_codes": [
            22150
        ],
        "district_id": 2205
    },
    {
        "id": 220504,
        "name_th": "วังแซ้ม",
        "name_en": "Wang Saem",
        "zip_codes": [
            22150
        ],
        "district_id": 2205
    },
    {
        "id": 220506,
        "name_th": "ฉมัน",
        "name_en": "Chaman",
        "zip_codes": [
            22150
        ],
        "district_id": 2205
    },
    {
        "id": 220508,
        "name_th": "อ่างคีรี",
        "name_en": "Ang Khiri",
        "zip_codes": [
            22150
        ],
        "district_id": 2205
    },
    {
        "id": 220601,
        "name_th": "ปากน้ำแหลมสิงห์",
        "name_en": "Pak Nam Laem Sing",
        "zip_codes": [
            22130
        ],
        "district_id": 2206
    },
    {
        "id": 220602,
        "name_th": "เกาะเปริด",
        "name_en": "Ko Proet",
        "zip_codes": [
            22130
        ],
        "district_id": 2206
    },
    {
        "id": 220603,
        "name_th": "หนองชิ่ม",
        "name_en": "Nong Chim",
        "zip_codes": [
            22130
        ],
        "district_id": 2206
    },
    {
        "id": 220604,
        "name_th": "พลิ้ว",
        "name_en": "Phlio",
        "zip_codes": [
            22190
        ],
        "district_id": 2206
    },
    {
        "id": 220605,
        "name_th": "คลองน้ำเค็ม",
        "name_en": "Khlong Nam Khem",
        "zip_codes": [
            22190
        ],
        "district_id": 2206
    },
    {
        "id": 220606,
        "name_th": "บางสระเก้า",
        "name_en": "Bang Sa Kao",
        "zip_codes": [
            22190
        ],
        "district_id": 2206
    },
    {
        "id": 220607,
        "name_th": "บางกะไชย",
        "name_en": "Bang Kachai",
        "zip_codes": [
            22120
        ],
        "district_id": 2206
    },
    {
        "id": 220701,
        "name_th": "ปะตง",
        "name_en": "Patong",
        "zip_codes": [
            22180
        ],
        "district_id": 2207
    },
    {
        "id": 220702,
        "name_th": "ทุ่งขนาน",
        "name_en": "Thung Khanan",
        "zip_codes": [
            22180
        ],
        "district_id": 2207
    },
    {
        "id": 220703,
        "name_th": "ทับช้าง",
        "name_en": "Thap Chang",
        "zip_codes": [
            22180
        ],
        "district_id": 2207
    },
    {
        "id": 220704,
        "name_th": "ทรายขาว",
        "name_en": "Sai Khao",
        "zip_codes": [
            22180
        ],
        "district_id": 2207
    },
    {
        "id": 220705,
        "name_th": "สะตอน",
        "name_en": "Saton",
        "zip_codes": [
            22180
        ],
        "district_id": 2207
    },
    {
        "id": 220801,
        "name_th": "แก่งหางแมว",
        "name_en": "Kaeng Hang Maeo",
        "zip_codes": [
            22160
        ],
        "district_id": 2208
    },
    {
        "id": 220802,
        "name_th": "ขุนซ่อง",
        "name_en": "Khun Song",
        "zip_codes": [
            22160
        ],
        "district_id": 2208
    },
    {
        "id": 220803,
        "name_th": "สามพี่น้อง",
        "name_en": "Sam Phi Nong",
        "zip_codes": [
            22160
        ],
        "district_id": 2208
    },
    {
        "id": 220804,
        "name_th": "พวา",
        "name_en": "Phawa",
        "zip_codes": [
            22160
        ],
        "district_id": 2208
    },
    {
        "id": 220805,
        "name_th": "เขาวงกต",
        "name_en": "Khao Wongkot",
        "zip_codes": [
            22160
        ],
        "district_id": 2208
    },
    {
        "id": 220901,
        "name_th": "นายายอาม",
        "name_en": "Na Yai Am",
        "zip_codes": [
            22160
        ],
        "district_id": 2209
    },
    {
        "id": 220902,
        "name_th": "วังโตนด",
        "name_en": "Wang Tanot",
        "zip_codes": [
            22170
        ],
        "district_id": 2209
    },
    {
        "id": 220903,
        "name_th": "กระแจะ",
        "name_en": "Krachae",
        "zip_codes": [
            22170
        ],
        "district_id": 2209
    },
    {
        "id": 220904,
        "name_th": "สนามไชย",
        "name_en": "Sanam Chai",
        "zip_codes": [
            22170
        ],
        "district_id": 2209
    },
    {
        "id": 220905,
        "name_th": "ช้างข้าม",
        "name_en": "Chang Kham",
        "zip_codes": [
            22160
        ],
        "district_id": 2209
    },
    {
        "id": 220906,
        "name_th": "วังใหม่",
        "name_en": "Wang Mai",
        "zip_codes": [
            22170
        ],
        "district_id": 2209
    },
    {
        "id": 221001,
        "name_th": "ชากไทย",
        "name_en": "Chak Thai",
        "zip_codes": [
            22210
        ],
        "district_id": 2210
    },
    {
        "id": 221002,
        "name_th": "พลวง",
        "name_en": "Phluang",
        "zip_codes": [
            22210
        ],
        "district_id": 2210
    },
    {
        "id": 221003,
        "name_th": "ตะเคียนทอง",
        "name_en": "Takhian Thong",
        "zip_codes": [
            22210
        ],
        "district_id": 2210
    },
    {
        "id": 221004,
        "name_th": "คลองพลู",
        "name_en": "Khlong Phlu",
        "zip_codes": [
            22210
        ],
        "district_id": 2210
    },
    {
        "id": 221005,
        "name_th": "จันทเขลม",
        "name_en": "Chanthakhlem",
        "zip_codes": [
            22210
        ],
        "district_id": 2210
    },
    {
        "id": 230101,
        "name_th": "บางพระ",
        "name_en": "Bang Phra",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230102,
        "name_th": "หนองเสม็ด",
        "name_en": "Nong Samet",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230103,
        "name_th": "หนองโสน",
        "name_en": "Nong Sano",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230104,
        "name_th": "หนองคันทรง",
        "name_en": "Nong Khan Song",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230105,
        "name_th": "ห้วงน้ำขาว",
        "name_en": "Huang Nam Khao",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230106,
        "name_th": "อ่าวใหญ่",
        "name_en": "Ao Yai",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230107,
        "name_th": "วังกระแจะ",
        "name_en": "Wang Krachae",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230108,
        "name_th": "ห้วยแร้ง",
        "name_en": "Huai Raeng",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230109,
        "name_th": "เนินทราย",
        "name_en": "Noen Sai",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230110,
        "name_th": "ท่าพริก",
        "name_en": "Tha Phrik",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230111,
        "name_th": "ท่ากุ่ม",
        "name_en": "Tha Kum",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230112,
        "name_th": "ตะกาง",
        "name_en": "Takang",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230113,
        "name_th": "ชำราก",
        "name_en": "Chamrak",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230114,
        "name_th": "แหลมกลัด",
        "name_en": "Laem Klat",
        "zip_codes": [
            23000
        ],
        "district_id": 2301
    },
    {
        "id": 230201,
        "name_th": "คลองใหญ่",
        "name_en": "Khlong Yai",
        "zip_codes": [
            23110
        ],
        "district_id": 2302
    },
    {
        "id": 230202,
        "name_th": "ไม้รูด",
        "name_en": "Mai Rut",
        "zip_codes": [
            23110
        ],
        "district_id": 2302
    },
    {
        "id": 230203,
        "name_th": "หาดเล็ก",
        "name_en": "Hat Lek",
        "zip_codes": [
            23110
        ],
        "district_id": 2302
    },
    {
        "id": 230301,
        "name_th": "เขาสมิง",
        "name_en": "Khao Saming",
        "zip_codes": [
            23130
        ],
        "district_id": 2303
    },
    {
        "id": 230302,
        "name_th": "แสนตุ้ง",
        "name_en": "Saen Tung",
        "zip_codes": [
            23150
        ],
        "district_id": 2303
    },
    {
        "id": 230303,
        "name_th": "วังตะเคียน",
        "name_en": "Wang Takhian",
        "zip_codes": [
            23130
        ],
        "district_id": 2303
    },
    {
        "id": 230304,
        "name_th": "ท่าโสม",
        "name_en": "Tha Som",
        "zip_codes": [
            23150
        ],
        "district_id": 2303
    },
    {
        "id": 230305,
        "name_th": "สะตอ",
        "name_en": "Sato",
        "zip_codes": [
            23150
        ],
        "district_id": 2303
    },
    {
        "id": 230306,
        "name_th": "ประณีต",
        "name_en": "Pranit",
        "zip_codes": [
            23150
        ],
        "district_id": 2303
    },
    {
        "id": 230307,
        "name_th": "เทพนิมิต",
        "name_en": "Thep Nimit",
        "zip_codes": [
            23150
        ],
        "district_id": 2303
    },
    {
        "id": 230308,
        "name_th": "ทุ่งนนทรี",
        "name_en": "Thung Nonsi",
        "zip_codes": [
            23130
        ],
        "district_id": 2303
    },
    {
        "id": 230401,
        "name_th": "บ่อพลอย",
        "name_en": "Bo Phloi",
        "zip_codes": [
            23140
        ],
        "district_id": 2304
    },
    {
        "id": 230402,
        "name_th": "ช้างทูน",
        "name_en": "Chang Thun",
        "zip_codes": [
            23140
        ],
        "district_id": 2304
    },
    {
        "id": 230403,
        "name_th": "ด่านชุมพล",
        "name_en": "Dan Chumphon",
        "zip_codes": [
            23140
        ],
        "district_id": 2304
    },
    {
        "id": 230404,
        "name_th": "หนองบอน",
        "name_en": "Nong Bon",
        "zip_codes": [
            23140
        ],
        "district_id": 2304
    },
    {
        "id": 230405,
        "name_th": "นนทรีย์",
        "name_en": "Nonsi",
        "zip_codes": [
            23140
        ],
        "district_id": 2304
    },
    {
        "id": 230501,
        "name_th": "แหลมงอบ",
        "name_en": "Laem Ngop",
        "zip_codes": [
            23120
        ],
        "district_id": 2305
    },
    {
        "id": 230502,
        "name_th": "น้ำเชี่ยว",
        "name_en": "Nam Chiao",
        "zip_codes": [
            23120
        ],
        "district_id": 2305
    },
    {
        "id": 230503,
        "name_th": "บางปิด",
        "name_en": "Bang Pit",
        "zip_codes": [
            23120
        ],
        "district_id": 2305
    },
    {
        "id": 230507,
        "name_th": "คลองใหญ่",
        "name_en": "Khlong Yai",
        "zip_codes": [
            23120
        ],
        "district_id": 2305
    },
    {
        "id": 230601,
        "name_th": "เกาะหมาก",
        "name_en": "Ko Mak",
        "zip_codes": [
            23120
        ],
        "district_id": 2306
    },
    {
        "id": 230602,
        "name_th": "เกาะกูด",
        "name_en": "Ko Kut",
        "zip_codes": [
            23000
        ],
        "district_id": 2306
    },
    {
        "id": 230701,
        "name_th": "เกาะช้าง",
        "name_en": "Ko Chang",
        "zip_codes": [
            23170
        ],
        "district_id": 2307
    },
    {
        "id": 230702,
        "name_th": "เกาะช้างใต้",
        "name_en": "Ko Chang Tai",
        "zip_codes": [
            23170
        ],
        "district_id": 2307
    },
    {
        "id": 240101,
        "name_th": "หน้าเมือง",
        "name_en": "Na Mueang",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240102,
        "name_th": "ท่าไข่",
        "name_en": "Tha Khai",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240103,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240104,
        "name_th": "คลองนา",
        "name_en": "Khlong Na",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240105,
        "name_th": "บางตีนเป็ด",
        "name_en": "Bang Tin Pet",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240106,
        "name_th": "บางไผ่",
        "name_en": "Bang Phai",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240107,
        "name_th": "คลองจุกกระเฌอ",
        "name_en": "Khlong Chuk Krachoe",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240108,
        "name_th": "บางแก้ว",
        "name_en": "Bang Kaeo",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240109,
        "name_th": "บางขวัญ",
        "name_en": "Bang Khwan",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240110,
        "name_th": "คลองนครเนื่องเขต",
        "name_en": "Khlong Nakhon Nueang Khet",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240111,
        "name_th": "วังตะเคียน",
        "name_en": "Wang Takhian",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240112,
        "name_th": "โสธร",
        "name_en": "Sothon",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240113,
        "name_th": "บางพระ",
        "name_en": "Bang Phra",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240114,
        "name_th": "บางกะไห",
        "name_en": "Bang Kahai",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240115,
        "name_th": "หนามแดง",
        "name_en": "Nam Daeng",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240116,
        "name_th": "คลองเปรง",
        "name_en": "Khlong Preng",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240117,
        "name_th": "คลองอุดมชลจร",
        "name_en": "Khlong Udom Chonlachon",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240118,
        "name_th": "คลองหลวงแพ่ง",
        "name_en": "Khlong Luang Phaeng",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240119,
        "name_th": "บางเตย",
        "name_en": "Bang Toei",
        "zip_codes": [
            24000
        ],
        "district_id": 2401
    },
    {
        "id": 240201,
        "name_th": "บางคล้า",
        "name_en": "Bang Khla",
        "zip_codes": [
            24110
        ],
        "district_id": 2402
    },
    {
        "id": 240204,
        "name_th": "บางสวน",
        "name_en": "Bang Suan",
        "zip_codes": [
            24110
        ],
        "district_id": 2402
    },
    {
        "id": 240208,
        "name_th": "บางกระเจ็ด",
        "name_en": "Bang Krachet",
        "zip_codes": [
            24110
        ],
        "district_id": 2402
    },
    {
        "id": 240209,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            24110
        ],
        "district_id": 2402
    },
    {
        "id": 240210,
        "name_th": "ท่าทองหลาง",
        "name_en": "Tha Thonglang",
        "zip_codes": [
            24110
        ],
        "district_id": 2402
    },
    {
        "id": 240211,
        "name_th": "สาวชะโงก",
        "name_en": "Sao Cha-ngok",
        "zip_codes": [
            24110
        ],
        "district_id": 2402
    },
    {
        "id": 240212,
        "name_th": "เสม็ดเหนือ",
        "name_en": "Samet Nuea",
        "zip_codes": [
            24110
        ],
        "district_id": 2402
    },
    {
        "id": 240213,
        "name_th": "เสม็ดใต้",
        "name_en": "Samet Tai",
        "zip_codes": [
            24110
        ],
        "district_id": 2402
    },
    {
        "id": 240214,
        "name_th": "หัวไทร",
        "name_en": "Hua Sai",
        "zip_codes": [
            24110
        ],
        "district_id": 2402
    },
    {
        "id": 240301,
        "name_th": "บางน้ำเปรี้ยว",
        "name_en": "Bang Nam Priao",
        "zip_codes": [
            24150
        ],
        "district_id": 2403
    },
    {
        "id": 240302,
        "name_th": "บางขนาก",
        "name_en": "Bang Khanak",
        "zip_codes": [
            24150
        ],
        "district_id": 2403
    },
    {
        "id": 240303,
        "name_th": "สิงโตทอง",
        "name_en": "Singto Thong",
        "zip_codes": [
            24150
        ],
        "district_id": 2403
    },
    {
        "id": 240304,
        "name_th": "หมอนทอง",
        "name_en": "Mon Thong",
        "zip_codes": [
            24150
        ],
        "district_id": 2403
    },
    {
        "id": 240305,
        "name_th": "บึงน้ำรักษ์",
        "name_en": "Bueng Nam Rak",
        "zip_codes": [
            24170
        ],
        "district_id": 2403
    },
    {
        "id": 240306,
        "name_th": "ดอนเกาะกา",
        "name_en": "Don Ko Ka",
        "zip_codes": [
            24170
        ],
        "district_id": 2403
    },
    {
        "id": 240307,
        "name_th": "โยธะกา",
        "name_en": "Yothaka",
        "zip_codes": [
            24150
        ],
        "district_id": 2403
    },
    {
        "id": 240308,
        "name_th": "ดอนฉิมพลี",
        "name_en": "Don Chimphli",
        "zip_codes": [
            24170
        ],
        "district_id": 2403
    },
    {
        "id": 240309,
        "name_th": "ศาลาแดง",
        "name_en": "Sala Daeng",
        "zip_codes": [
            24000
        ],
        "district_id": 2403
    },
    {
        "id": 240310,
        "name_th": "โพรงอากาศ",
        "name_en": "Phrong Akat",
        "zip_codes": [
            24150
        ],
        "district_id": 2403
    },
    {
        "id": 240401,
        "name_th": "บางปะกง",
        "name_en": "Bang Pakong",
        "zip_codes": [
            24130
        ],
        "district_id": 2404
    },
    {
        "id": 240402,
        "name_th": "ท่าสะอ้าน",
        "name_en": "Tha Sa-an",
        "zip_codes": [
            24130
        ],
        "district_id": 2404
    },
    {
        "id": 240403,
        "name_th": "บางวัว",
        "name_en": "Bang Wua",
        "zip_codes": [
            24180
        ],
        "district_id": 2404
    },
    {
        "id": 240404,
        "name_th": "บางสมัคร",
        "name_en": "Bang Samak",
        "zip_codes": [
            24180
        ],
        "district_id": 2404
    },
    {
        "id": 240405,
        "name_th": "บางผึ้ง",
        "name_en": "Bang Phueng",
        "zip_codes": [
            24130
        ],
        "district_id": 2404
    },
    {
        "id": 240406,
        "name_th": "บางเกลือ",
        "name_en": "Bang Kluea",
        "zip_codes": [
            24180
        ],
        "district_id": 2404
    },
    {
        "id": 240407,
        "name_th": "สองคลอง",
        "name_en": "Song Khlong",
        "zip_codes": [
            24130
        ],
        "district_id": 2404
    },
    {
        "id": 240408,
        "name_th": "หนองจอก",
        "name_en": "Nong Chok",
        "zip_codes": [
            24130
        ],
        "district_id": 2404
    },
    {
        "id": 240409,
        "name_th": "พิมพา",
        "name_en": "Phimpha",
        "zip_codes": [
            24180
        ],
        "district_id": 2404
    },
    {
        "id": 240410,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            24130
        ],
        "district_id": 2404
    },
    {
        "id": 240411,
        "name_th": "หอมศีล",
        "name_en": "Hom Sin",
        "zip_codes": [
            24180
        ],
        "district_id": 2404
    },
    {
        "id": 240412,
        "name_th": "เขาดิน",
        "name_en": "Khao Din",
        "zip_codes": [
            24130
        ],
        "district_id": 2404
    },
    {
        "id": 240501,
        "name_th": "บ้านโพธิ์",
        "name_en": "Ban Pho",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240502,
        "name_th": "เกาะไร่",
        "name_en": "Ko Rai",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240503,
        "name_th": "คลองขุด",
        "name_en": "Khlong Khut",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240504,
        "name_th": "คลองบ้านโพธิ์",
        "name_en": "Khlong Ban Pho",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240505,
        "name_th": "คลองประเวศ",
        "name_en": "Khlong Prawet",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240506,
        "name_th": "ดอนทราย",
        "name_en": "Don Sai",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240507,
        "name_th": "เทพราช",
        "name_en": "Theppharat",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240508,
        "name_th": "ท่าพลับ",
        "name_en": "Tha Phlap",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240509,
        "name_th": "หนองตีนนก",
        "name_en": "Nong Tin Nok",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240510,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240511,
        "name_th": "บางซ่อน",
        "name_en": "Bang Son",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240512,
        "name_th": "บางกรูด",
        "name_en": "Bang Krut",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240513,
        "name_th": "แหลมประดู่",
        "name_en": "Laem Pradu",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240514,
        "name_th": "ลาดขวาง",
        "name_en": "Lat Khwang",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240515,
        "name_th": "สนามจันทร์",
        "name_en": "Sanam Chan",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240516,
        "name_th": "แสนภูดาษ",
        "name_en": "Saen Phu Dat",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240517,
        "name_th": "สิบเอ็ดศอก",
        "name_en": "Sip Et Sok",
        "zip_codes": [
            24140
        ],
        "district_id": 2405
    },
    {
        "id": 240601,
        "name_th": "เกาะขนุน",
        "name_en": "Ko Khanun",
        "zip_codes": [
            24120
        ],
        "district_id": 2406
    },
    {
        "id": 240602,
        "name_th": "บ้านซ่อง",
        "name_en": "Ban Song",
        "zip_codes": [
            24120
        ],
        "district_id": 2406
    },
    {
        "id": 240603,
        "name_th": "พนมสารคาม",
        "name_en": "Phanom Sarakham",
        "zip_codes": [
            24120
        ],
        "district_id": 2406
    },
    {
        "id": 240604,
        "name_th": "เมืองเก่า",
        "name_en": "Mueang Kao",
        "zip_codes": [
            24120
        ],
        "district_id": 2406
    },
    {
        "id": 240605,
        "name_th": "หนองยาว",
        "name_en": "Nong Yao",
        "zip_codes": [
            24120
        ],
        "district_id": 2406
    },
    {
        "id": 240606,
        "name_th": "ท่าถ่าน",
        "name_en": "Tha Than",
        "zip_codes": [
            24120
        ],
        "district_id": 2406
    },
    {
        "id": 240607,
        "name_th": "หนองแหน",
        "name_en": "Nong Nae",
        "zip_codes": [
            24120
        ],
        "district_id": 2406
    },
    {
        "id": 240608,
        "name_th": "เขาหินซ้อน",
        "name_en": "Khao Hin Son",
        "zip_codes": [
            24120
        ],
        "district_id": 2406
    },
    {
        "id": 240701,
        "name_th": "บางคา",
        "name_en": "Bang Kha",
        "zip_codes": [
            24120
        ],
        "district_id": 2407
    },
    {
        "id": 240702,
        "name_th": "เมืองใหม่",
        "name_en": "Mueang Mai",
        "zip_codes": [
            24120
        ],
        "district_id": 2407
    },
    {
        "id": 240703,
        "name_th": "ดงน้อย",
        "name_en": "Dong Noi",
        "zip_codes": [
            24120
        ],
        "district_id": 2407
    },
    {
        "id": 240801,
        "name_th": "คู้ยายหมี",
        "name_en": "Ku Yai Mi",
        "zip_codes": [
            24160
        ],
        "district_id": 2408
    },
    {
        "id": 240802,
        "name_th": "ท่ากระดาน",
        "name_en": "Tha Kradan",
        "zip_codes": [
            24160
        ],
        "district_id": 2408
    },
    {
        "id": 240803,
        "name_th": "ทุ่งพระยา",
        "name_en": "Thung Phraya",
        "zip_codes": [
            24160
        ],
        "district_id": 2408
    },
    {
        "id": 240805,
        "name_th": "ลาดกระทิง",
        "name_en": "Lat Krathing",
        "zip_codes": [
            24160
        ],
        "district_id": 2408
    },
    {
        "id": 240901,
        "name_th": "แปลงยาว",
        "name_en": "Plaeng Yao",
        "zip_codes": [
            24190
        ],
        "district_id": 2409
    },
    {
        "id": 240902,
        "name_th": "วังเย็น",
        "name_en": "Wang Yen",
        "zip_codes": [
            24190
        ],
        "district_id": 2409
    },
    {
        "id": 240903,
        "name_th": "หัวสำโรง",
        "name_en": "Hua Samrong",
        "zip_codes": [
            24190
        ],
        "district_id": 2409
    },
    {
        "id": 240904,
        "name_th": "หนองไม้แก่น",
        "name_en": "Nong Mai Kaen",
        "zip_codes": [
            24190
        ],
        "district_id": 2409
    },
    {
        "id": 241001,
        "name_th": "ท่าตะเกียบ",
        "name_en": "Tha Takiap",
        "zip_codes": [
            24160
        ],
        "district_id": 2410
    },
    {
        "id": 241002,
        "name_th": "คลองตะเกรา",
        "name_en": "Khlong Takrao",
        "zip_codes": [
            24160
        ],
        "district_id": 2410
    },
    {
        "id": 241101,
        "name_th": "ก้อนแก้ว",
        "name_en": "Kon Kaeo",
        "zip_codes": [
            24000
        ],
        "district_id": 2411
    },
    {
        "id": 241102,
        "name_th": "คลองเขื่อน",
        "name_en": "Khlong Khuean",
        "zip_codes": [
            24000
        ],
        "district_id": 2411
    },
    {
        "id": 241103,
        "name_th": "บางเล่า",
        "name_en": "Bang Lao",
        "zip_codes": [
            24000
        ],
        "district_id": 2411
    },
    {
        "id": 241104,
        "name_th": "บางโรง",
        "name_en": "Bang Rong",
        "zip_codes": [
            24000
        ],
        "district_id": 2411
    },
    {
        "id": 241105,
        "name_th": "บางตลาด",
        "name_en": "Bang Talat",
        "zip_codes": [
            24110
        ],
        "district_id": 2411
    },
    {
        "id": 250101,
        "name_th": "หน้าเมือง",
        "name_en": "Na Mueang",
        "zip_codes": [
            25000
        ],
        "district_id": 2501
    },
    {
        "id": 250102,
        "name_th": "รอบเมือง",
        "name_en": "Rop Mueang",
        "zip_codes": [
            25000
        ],
        "district_id": 2501
    },
    {
        "id": 250103,
        "name_th": "วัดโบสถ์",
        "name_en": "Wat Bot",
        "zip_codes": [
            25000
        ],
        "district_id": 2501
    },
    {
        "id": 250104,
        "name_th": "บางเดชะ",
        "name_en": "Bang Decha",
        "zip_codes": [
            25000
        ],
        "district_id": 2501
    },
    {
        "id": 250105,
        "name_th": "ท่างาม",
        "name_en": "Tha Ngam",
        "zip_codes": [
            25000
        ],
        "district_id": 2501
    },
    {
        "id": 250106,
        "name_th": "บางบริบูรณ์",
        "name_en": "Bang Boribun",
        "zip_codes": [
            25000
        ],
        "district_id": 2501
    },
    {
        "id": 250107,
        "name_th": "ดงพระราม",
        "name_en": "Dong Phra Ram",
        "zip_codes": [
            25000
        ],
        "district_id": 2501
    },
    {
        "id": 250108,
        "name_th": "บ้านพระ",
        "name_en": "Ban Phra",
        "zip_codes": [
            25230
        ],
        "district_id": 2501
    },
    {
        "id": 250109,
        "name_th": "โคกไม้ลาย",
        "name_en": "Khok Mai Lai",
        "zip_codes": [
            25230
        ],
        "district_id": 2501
    },
    {
        "id": 250110,
        "name_th": "ไม้เค็ด",
        "name_en": "Mai Khet",
        "zip_codes": [
            25230
        ],
        "district_id": 2501
    },
    {
        "id": 250111,
        "name_th": "ดงขี้เหล็ก",
        "name_en": "Dong Khilek",
        "zip_codes": [
            25000
        ],
        "district_id": 2501
    },
    {
        "id": 250112,
        "name_th": "เนินหอม",
        "name_en": "Noen Hom",
        "zip_codes": [
            25230
        ],
        "district_id": 2501
    },
    {
        "id": 250113,
        "name_th": "โนนห้อม",
        "name_en": "Non Hom",
        "zip_codes": [
            25000
        ],
        "district_id": 2501
    },
    {
        "id": 250201,
        "name_th": "กบินทร์",
        "name_en": "Kabin",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250202,
        "name_th": "เมืองเก่า",
        "name_en": "Mueang Kao",
        "zip_codes": [
            25240
        ],
        "district_id": 2502
    },
    {
        "id": 250203,
        "name_th": "วังดาล",
        "name_en": "Wang Dan",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250204,
        "name_th": "นนทรี",
        "name_en": "Nonsi",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250205,
        "name_th": "ย่านรี",
        "name_en": "Yan Ri",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250206,
        "name_th": "วังตะเคียน",
        "name_en": "Wang Takhian",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250207,
        "name_th": "หาดนางแก้ว",
        "name_en": "Hat Nang Kaeo",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250208,
        "name_th": "ลาดตะเคียน",
        "name_en": "Lat Takhian",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250209,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250210,
        "name_th": "บ่อทอง",
        "name_en": "Bo Thong",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250211,
        "name_th": "หนองกี่",
        "name_en": "Nong Ki",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250212,
        "name_th": "นาแขม",
        "name_en": "Na Khaem",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250213,
        "name_th": "เขาไม้แก้ว",
        "name_en": "Khao Mai Kaeo",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250214,
        "name_th": "วังท่าช้าง",
        "name_en": "Wang Tha Chang",
        "zip_codes": [
            25110
        ],
        "district_id": 2502
    },
    {
        "id": 250301,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            25220
        ],
        "district_id": 2503
    },
    {
        "id": 250302,
        "name_th": "สำพันตา",
        "name_en": "Sam Phan Ta",
        "zip_codes": [
            25220
        ],
        "district_id": 2503
    },
    {
        "id": 250303,
        "name_th": "สะพานหิน",
        "name_en": "Saphan Hin",
        "zip_codes": [
            25220
        ],
        "district_id": 2503
    },
    {
        "id": 250304,
        "name_th": "ทุ่งโพธิ์",
        "name_en": "Thung Pho",
        "zip_codes": [
            25220
        ],
        "district_id": 2503
    },
    {
        "id": 250305,
        "name_th": "แก่งดินสอ",
        "name_en": "Kaeng Din So",
        "zip_codes": [
            25220
        ],
        "district_id": 2503
    },
    {
        "id": 250306,
        "name_th": "บุพราหมณ์",
        "name_en": "Bu Phram",
        "zip_codes": [
            25220
        ],
        "district_id": 2503
    },
    {
        "id": 250601,
        "name_th": "บ้านสร้าง",
        "name_en": "Ban Sang",
        "zip_codes": [
            25150
        ],
        "district_id": 2506
    },
    {
        "id": 250602,
        "name_th": "บางกระเบา",
        "name_en": "Bang Krabao",
        "zip_codes": [
            25150
        ],
        "district_id": 2506
    },
    {
        "id": 250603,
        "name_th": "บางเตย",
        "name_en": "Bang Toei",
        "zip_codes": [
            25150
        ],
        "district_id": 2506
    },
    {
        "id": 250604,
        "name_th": "บางยาง",
        "name_en": "Bang Yang",
        "zip_codes": [
            25150
        ],
        "district_id": 2506
    },
    {
        "id": 250605,
        "name_th": "บางแตน",
        "name_en": "Bang Taen",
        "zip_codes": [
            25150
        ],
        "district_id": 2506
    },
    {
        "id": 250606,
        "name_th": "บางพลวง",
        "name_en": "Bang Phluang",
        "zip_codes": [
            25150
        ],
        "district_id": 2506
    },
    {
        "id": 250607,
        "name_th": "บางปลาร้า",
        "name_en": "Bang Pla Ra",
        "zip_codes": [
            25150
        ],
        "district_id": 2506
    },
    {
        "id": 250608,
        "name_th": "บางขาม",
        "name_en": "Bang Kham",
        "zip_codes": [
            25150
        ],
        "district_id": 2506
    },
    {
        "id": 250609,
        "name_th": "กระทุ่มแพ้ว",
        "name_en": "Krathum Phaeo",
        "zip_codes": [
            25150
        ],
        "district_id": 2506
    },
    {
        "id": 250701,
        "name_th": "ประจันตคาม",
        "name_en": "Prachantakham",
        "zip_codes": [
            25130
        ],
        "district_id": 2507
    },
    {
        "id": 250702,
        "name_th": "เกาะลอย",
        "name_en": "Ko Loi",
        "zip_codes": [
            25130
        ],
        "district_id": 2507
    },
    {
        "id": 250703,
        "name_th": "บ้านหอย",
        "name_en": "Ban Hoi",
        "zip_codes": [
            25130
        ],
        "district_id": 2507
    },
    {
        "id": 250704,
        "name_th": "หนองแสง",
        "name_en": "Nong Saeng",
        "zip_codes": [
            25130
        ],
        "district_id": 2507
    },
    {
        "id": 250705,
        "name_th": "ดงบัง",
        "name_en": "Dong Bang",
        "zip_codes": [
            25130
        ],
        "district_id": 2507
    },
    {
        "id": 250706,
        "name_th": "คำโตนด",
        "name_en": "Kham Tanot",
        "zip_codes": [
            25130
        ],
        "district_id": 2507
    },
    {
        "id": 250707,
        "name_th": "บุฝ้าย",
        "name_en": "Bu Fai",
        "zip_codes": [
            25130
        ],
        "district_id": 2507
    },
    {
        "id": 250708,
        "name_th": "หนองแก้ว",
        "name_en": "Nong Kaeo",
        "zip_codes": [
            25130
        ],
        "district_id": 2507
    },
    {
        "id": 250709,
        "name_th": "โพธิ์งาม",
        "name_en": "Pho Ngam",
        "zip_codes": [
            25130
        ],
        "district_id": 2507
    },
    {
        "id": 250801,
        "name_th": "ศรีมหาโพธิ",
        "name_en": "Si Maha Phot",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250802,
        "name_th": "สัมพันธ์",
        "name_en": "Samphan",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250803,
        "name_th": "บ้านทาม",
        "name_en": "Ban Tham",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250804,
        "name_th": "ท่าตูม",
        "name_en": "Tha Tum",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250805,
        "name_th": "บางกุ้ง",
        "name_en": "Bang Kung",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250806,
        "name_th": "ดงกระทงยาม",
        "name_en": "Dong Krathong Yam",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250807,
        "name_th": "หนองโพรง",
        "name_en": "Nong Phrong",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250808,
        "name_th": "หัวหว้า",
        "name_en": "Hua Wa",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250809,
        "name_th": "หาดยาง",
        "name_en": "Hat Yang",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250810,
        "name_th": "กรอกสมบูรณ์",
        "name_en": "Krok Sombun",
        "zip_codes": [
            25140
        ],
        "district_id": 2508
    },
    {
        "id": 250901,
        "name_th": "โคกปีบ",
        "name_en": "Khok Pip",
        "zip_codes": [
            25190
        ],
        "district_id": 2509
    },
    {
        "id": 250902,
        "name_th": "โคกไทย",
        "name_en": "Khok Thai",
        "zip_codes": [
            25190
        ],
        "district_id": 2509
    },
    {
        "id": 250903,
        "name_th": "คู้ลำพัน",
        "name_en": "Khu Lam Phan",
        "zip_codes": [
            25190
        ],
        "district_id": 2509
    },
    {
        "id": 250904,
        "name_th": "ไผ่ชะเลือด",
        "name_en": "Phai Cha Lueat",
        "zip_codes": [
            25190
        ],
        "district_id": 2509
    },
    {
        "id": 260101,
        "name_th": "นครนายก",
        "name_en": "Nakhon Nayok",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260102,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260103,
        "name_th": "บ้านใหญ่",
        "name_en": "Ban Yai",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260104,
        "name_th": "วังกระโจม",
        "name_en": "Wang Krachom",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260105,
        "name_th": "ท่าทราย",
        "name_en": "Tha Sai",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260106,
        "name_th": "ดอนยอ",
        "name_en": "Don Yo",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260107,
        "name_th": "ศรีจุฬา",
        "name_en": "Si Chula",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260108,
        "name_th": "ดงละคร",
        "name_en": "Dong Lakhon",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260109,
        "name_th": "ศรีนาวา",
        "name_en": "Si Nawa",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260110,
        "name_th": "สาริกา",
        "name_en": "Sarika",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260111,
        "name_th": "หินตั้ง",
        "name_en": "Hin Tang",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260112,
        "name_th": "เขาพระ",
        "name_en": "Khao Phra",
        "zip_codes": [
            26000
        ],
        "district_id": 2601
    },
    {
        "id": 260113,
        "name_th": "พรหมณี",
        "name_en": "Phrommani",
        "zip_codes": [
            26000,
            26001
        ],
        "district_id": 2601
    },
    {
        "id": 260201,
        "name_th": "เกาะหวาย",
        "name_en": "Ko Wai",
        "zip_codes": [
            26130
        ],
        "district_id": 2602
    },
    {
        "id": 260202,
        "name_th": "เกาะโพธิ์",
        "name_en": "Ko Pho",
        "zip_codes": [
            26130
        ],
        "district_id": 2602
    },
    {
        "id": 260203,
        "name_th": "ปากพลี",
        "name_en": "Pak Phli",
        "zip_codes": [
            26130
        ],
        "district_id": 2602
    },
    {
        "id": 260204,
        "name_th": "โคกกรวด",
        "name_en": "Khok Kruat",
        "zip_codes": [
            26130
        ],
        "district_id": 2602
    },
    {
        "id": 260205,
        "name_th": "ท่าเรือ",
        "name_en": "Tha Ruea",
        "zip_codes": [
            26130
        ],
        "district_id": 2602
    },
    {
        "id": 260206,
        "name_th": "หนองแสง",
        "name_en": "Nong Saeng",
        "zip_codes": [
            26130
        ],
        "district_id": 2602
    },
    {
        "id": 260207,
        "name_th": "นาหินลาด",
        "name_en": "Na Hin Lat",
        "zip_codes": [
            26130
        ],
        "district_id": 2602
    },
    {
        "id": 260301,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260302,
        "name_th": "บ้านพร้าว",
        "name_en": "Ban Phrao",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260303,
        "name_th": "บ้านพริก",
        "name_en": "Ban Phrik",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260304,
        "name_th": "อาษา",
        "name_en": "Asa",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260305,
        "name_th": "ทองหลาง",
        "name_en": "Thonglang",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260306,
        "name_th": "บางอ้อ",
        "name_en": "Bang O",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260307,
        "name_th": "พิกุลออก",
        "name_en": "Phikun Ok",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260308,
        "name_th": "ป่าขะ",
        "name_en": "Pa Kha",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260309,
        "name_th": "เขาเพิ่ม",
        "name_en": "Khao Phoem",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260310,
        "name_th": "ศรีกะอาง",
        "name_en": "Si Ka-ang",
        "zip_codes": [
            26110
        ],
        "district_id": 2603
    },
    {
        "id": 260401,
        "name_th": "พระอาจารย์",
        "name_en": "Phra Achan",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260402,
        "name_th": "บึงศาล",
        "name_en": "Bueng San",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260403,
        "name_th": "ศีรษะกระบือ",
        "name_en": "Sisa Krabue",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260404,
        "name_th": "โพธิ์แทน",
        "name_en": "Pho Thaen",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260405,
        "name_th": "บางสมบูรณ์",
        "name_en": "Bang Sombun",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260406,
        "name_th": "ทรายมูล",
        "name_en": "Sai Mun",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260407,
        "name_th": "บางปลากด",
        "name_en": "Bang Pla Kot",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260408,
        "name_th": "บางลูกเสือ",
        "name_en": "Bang Luk Suea",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260409,
        "name_th": "องครักษ์",
        "name_en": "Ongkharak",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260410,
        "name_th": "ชุมพล",
        "name_en": "Chumphon",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 260411,
        "name_th": "คลองใหญ่",
        "name_en": "Khlong Yai",
        "zip_codes": [
            26120
        ],
        "district_id": 2604
    },
    {
        "id": 270101,
        "name_th": "สระแก้ว",
        "name_en": "Sa Kaeo",
        "zip_codes": [
            27000
        ],
        "district_id": 2701
    },
    {
        "id": 270102,
        "name_th": "บ้านแก้ง",
        "name_en": "Ban Kaeng",
        "zip_codes": [
            27000
        ],
        "district_id": 2701
    },
    {
        "id": 270103,
        "name_th": "ศาลาลำดวน",
        "name_en": "Sala Lamduan",
        "zip_codes": [
            27000
        ],
        "district_id": 2701
    },
    {
        "id": 270104,
        "name_th": "โคกปี่ฆ้อง",
        "name_en": "Khok Pi Khong",
        "zip_codes": [
            27000
        ],
        "district_id": 2701
    },
    {
        "id": 270105,
        "name_th": "ท่าแยก",
        "name_en": "Tha Yaek",
        "zip_codes": [
            27000
        ],
        "district_id": 2701
    },
    {
        "id": 270106,
        "name_th": "ท่าเกษม",
        "name_en": "Tha Kasem",
        "zip_codes": [
            27000
        ],
        "district_id": 2701
    },
    {
        "id": 270108,
        "name_th": "สระขวัญ",
        "name_en": "Sa Khwan",
        "zip_codes": [
            27000
        ],
        "district_id": 2701
    },
    {
        "id": 270111,
        "name_th": "หนองบอน",
        "name_en": "Nong Bon",
        "zip_codes": [
            27000
        ],
        "district_id": 2701
    },
    {
        "id": 270201,
        "name_th": "คลองหาด",
        "name_en": "Khlong Hat",
        "zip_codes": [
            27260
        ],
        "district_id": 2702
    },
    {
        "id": 270202,
        "name_th": "ไทยอุดม",
        "name_en": "Thai Udom",
        "zip_codes": [
            27260
        ],
        "district_id": 2702
    },
    {
        "id": 270203,
        "name_th": "ซับมะกรูด",
        "name_en": "Sap Makrut",
        "zip_codes": [
            27260
        ],
        "district_id": 2702
    },
    {
        "id": 270204,
        "name_th": "ไทรเดี่ยว",
        "name_en": "Sai Diao",
        "zip_codes": [
            27260
        ],
        "district_id": 2702
    },
    {
        "id": 270205,
        "name_th": "คลองไก่เถื่อน",
        "name_en": "Khlogn Kai Thuean",
        "zip_codes": [
            27260
        ],
        "district_id": 2702
    },
    {
        "id": 270206,
        "name_th": "เบญจขร",
        "name_en": "Benchakhon",
        "zip_codes": [
            27260
        ],
        "district_id": 2702
    },
    {
        "id": 270207,
        "name_th": "ไทรทอง",
        "name_en": "Sai Thong",
        "zip_codes": [
            27260
        ],
        "district_id": 2702
    },
    {
        "id": 270301,
        "name_th": "ตาพระยา",
        "name_en": "Ta Phraya",
        "zip_codes": [
            27180
        ],
        "district_id": 2703
    },
    {
        "id": 270302,
        "name_th": "ทัพเสด็จ",
        "name_en": "Thap Sadet",
        "zip_codes": [
            27180
        ],
        "district_id": 2703
    },
    {
        "id": 270306,
        "name_th": "ทัพราช",
        "name_en": "Thap Rat",
        "zip_codes": [
            27180
        ],
        "district_id": 2703
    },
    {
        "id": 270307,
        "name_th": "ทัพไทย",
        "name_en": "Thap Thai",
        "zip_codes": [
            27180
        ],
        "district_id": 2703
    },
    {
        "id": 270309,
        "name_th": "โคคลาน",
        "name_en": "Kho Khlan",
        "zip_codes": [
            27180
        ],
        "district_id": 2703
    },
    {
        "id": 270401,
        "name_th": "วังน้ำเย็น",
        "name_en": "Wang Nam Yen",
        "zip_codes": [
            27210
        ],
        "district_id": 2704
    },
    {
        "id": 270403,
        "name_th": "ตาหลังใน",
        "name_en": "Ta Lang Nai",
        "zip_codes": [
            27210
        ],
        "district_id": 2704
    },
    {
        "id": 270405,
        "name_th": "คลองหินปูน",
        "name_en": "Khlong Hin Pun",
        "zip_codes": [
            27210
        ],
        "district_id": 2704
    },
    {
        "id": 270406,
        "name_th": "ทุ่งมหาเจริญ",
        "name_en": "Thung Maha Charoen",
        "zip_codes": [
            27210
        ],
        "district_id": 2704
    },
    {
        "id": 270501,
        "name_th": "วัฒนานคร",
        "name_en": "Watthana Nakhon",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270502,
        "name_th": "ท่าเกวียน",
        "name_en": "Tha Kwian",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270503,
        "name_th": "ผักขะ",
        "name_en": "Phak Kha",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270504,
        "name_th": "โนนหมากเค็ง",
        "name_en": "Non Mak Kheng",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270505,
        "name_th": "หนองน้ำใส",
        "name_en": "Nong Nam Sai",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270506,
        "name_th": "ช่องกุ่ม",
        "name_en": "Chong Kum",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270507,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270508,
        "name_th": "แซร์ออ",
        "name_en": "Sae-o",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270509,
        "name_th": "หนองหมากฝ้าย",
        "name_en": "Nong Mak Fai",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270510,
        "name_th": "หนองตะเคียนบอน",
        "name_en": "Nong Takian Bon",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270511,
        "name_th": "ห้วยโจด",
        "name_en": "Huai Chot",
        "zip_codes": [
            27160
        ],
        "district_id": 2705
    },
    {
        "id": 270601,
        "name_th": "อรัญประเทศ",
        "name_en": "Aranyaprathet",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270602,
        "name_th": "เมืองไผ่",
        "name_en": "Mueang Phai",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270603,
        "name_th": "หันทราย",
        "name_en": "Han Sai",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270604,
        "name_th": "คลองน้ำใส",
        "name_en": "Khlong Nam Sai",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270605,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270606,
        "name_th": "ป่าไร่",
        "name_en": "Pa Rai",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270607,
        "name_th": "ทับพริก",
        "name_en": "Thap Phrik",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270608,
        "name_th": "บ้านใหม่หนองไทร",
        "name_en": "Ban Mai Nong Sai",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270609,
        "name_th": "ผ่านศึก",
        "name_en": "Phan Suek",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270610,
        "name_th": "หนองสังข์",
        "name_en": "Nong Sang",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270611,
        "name_th": "คลองทับจันทร์",
        "name_en": "Khlong Thap Chan",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270612,
        "name_th": "ฟากห้วย",
        "name_en": "Fak Huai",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270613,
        "name_th": "บ้านด่าน",
        "name_en": "Ban Dan",
        "zip_codes": [
            27120
        ],
        "district_id": 2706
    },
    {
        "id": 270701,
        "name_th": "เขาฉกรรจ์",
        "name_en": "Khao Chakan",
        "zip_codes": [
            27000
        ],
        "district_id": 2707
    },
    {
        "id": 270702,
        "name_th": "หนองหว้า",
        "name_en": "Nong Wa",
        "zip_codes": [
            27000
        ],
        "district_id": 2707
    },
    {
        "id": 270703,
        "name_th": "พระเพลิง",
        "name_en": "Phra Phloeng",
        "zip_codes": [
            27000
        ],
        "district_id": 2707
    },
    {
        "id": 270704,
        "name_th": "เขาสามสิบ",
        "name_en": "Khao Sam Sip",
        "zip_codes": [
            27000
        ],
        "district_id": 2707
    },
    {
        "id": 270801,
        "name_th": "โคกสูง",
        "name_en": "Khok Sung",
        "zip_codes": [
            27120
        ],
        "district_id": 2708
    },
    {
        "id": 270802,
        "name_th": "หนองม่วง",
        "name_en": "Nong Muang",
        "zip_codes": [
            27120
        ],
        "district_id": 2708
    },
    {
        "id": 270803,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            27120
        ],
        "district_id": 2708
    },
    {
        "id": 270804,
        "name_th": "โนนหมากมุ่น",
        "name_en": "Non Mak Mun",
        "zip_codes": [
            27120
        ],
        "district_id": 2708
    },
    {
        "id": 270901,
        "name_th": "วังสมบูรณ์",
        "name_en": "Wang Sombun",
        "zip_codes": [
            27250
        ],
        "district_id": 2709
    },
    {
        "id": 270902,
        "name_th": "วังใหม่",
        "name_en": "Wang Mai",
        "zip_codes": [
            27210,
            27250
        ],
        "district_id": 2709
    },
    {
        "id": 270903,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "zip_codes": [
            27250
        ],
        "district_id": 2709
    },
    {
        "id": 300101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300102,
        "name_th": "โพธิ์กลาง",
        "name_en": "Pho Klang",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300103,
        "name_th": "หนองจะบก",
        "name_en": "Nong Chabok",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300104,
        "name_th": "โคกสูง",
        "name_en": "Khok Sung",
        "zip_codes": [
            30310
        ],
        "district_id": 3001
    },
    {
        "id": 300105,
        "name_th": "มะเริง",
        "name_en": "Maroeng",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300106,
        "name_th": "หนองระเวียง",
        "name_en": "Nong Rawiang",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300107,
        "name_th": "ปรุใหญ่",
        "name_en": "Pru Yai",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300108,
        "name_th": "หมื่นไวย",
        "name_en": "Muen Wai",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300109,
        "name_th": "พลกรัง",
        "name_en": "Phon Krang",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300110,
        "name_th": "หนองไผ่ล้อม",
        "name_en": "Nong Phai Lom",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300111,
        "name_th": "หัวทะเล",
        "name_en": "Hua Thale",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300112,
        "name_th": "บ้านเกาะ",
        "name_en": "Ban Ko",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300113,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300114,
        "name_th": "พุดซา",
        "name_en": "Phutsa",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300115,
        "name_th": "บ้านโพธิ์",
        "name_en": "Ban Pho",
        "zip_codes": [
            30310
        ],
        "district_id": 3001
    },
    {
        "id": 300116,
        "name_th": "จอหอ",
        "name_en": "Cho Ho",
        "zip_codes": [
            30310
        ],
        "district_id": 3001
    },
    {
        "id": 300117,
        "name_th": "โคกกรวด",
        "name_en": "Khok Kruat",
        "zip_codes": [
            30280
        ],
        "district_id": 3001
    },
    {
        "id": 300118,
        "name_th": "ไชยมงคล",
        "name_en": "Chai Mongkhon",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300119,
        "name_th": "หนองบัวศาลา",
        "name_en": "Nong Bua Sala",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300120,
        "name_th": "สุรนารี",
        "name_en": "Suranari",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300121,
        "name_th": "สีมุม",
        "name_en": "Si Mum",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300122,
        "name_th": "ตลาด",
        "name_en": "Talat",
        "zip_codes": [
            30310
        ],
        "district_id": 3001
    },
    {
        "id": 300123,
        "name_th": "พะเนา",
        "name_en": "Phanao",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300124,
        "name_th": "หนองกระทุ่ม",
        "name_en": "Nong Krathum",
        "zip_codes": [
            30000
        ],
        "district_id": 3001
    },
    {
        "id": 300125,
        "name_th": "หนองไข่น้ำ",
        "name_en": "Nong Khai Nam",
        "zip_codes": [
            30310
        ],
        "district_id": 3001
    },
    {
        "id": 300201,
        "name_th": "แชะ",
        "name_en": "Chae",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300202,
        "name_th": "เฉลียง",
        "name_en": "Chaliang",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300203,
        "name_th": "ครบุรี",
        "name_en": "Khon Buri",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300204,
        "name_th": "โคกกระชาย",
        "name_en": "Khok Krachai",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300205,
        "name_th": "จระเข้หิน",
        "name_en": "Chorakhe Hin",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300206,
        "name_th": "มาบตะโกเอน",
        "name_en": "Map Tako En",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300207,
        "name_th": "อรพิมพ์",
        "name_en": "Oraphim",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300208,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300209,
        "name_th": "ลำเพียก",
        "name_en": "Lam Phiak",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300210,
        "name_th": "ครบุรีใต้",
        "name_en": "Khon Buri Tai",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300211,
        "name_th": "ตะแบกบาน",
        "name_en": "Tabaek Ban",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300212,
        "name_th": "สระว่านพระยา",
        "name_en": "Sa Wan Phraya",
        "zip_codes": [
            30250
        ],
        "district_id": 3002
    },
    {
        "id": 300301,
        "name_th": "เสิงสาง",
        "name_en": "Soeng Sang",
        "zip_codes": [
            30330
        ],
        "district_id": 3003
    },
    {
        "id": 300302,
        "name_th": "สระตะเคียน",
        "name_en": "Sa Takhian",
        "zip_codes": [
            30330
        ],
        "district_id": 3003
    },
    {
        "id": 300303,
        "name_th": "โนนสมบูรณ์",
        "name_en": "Non Sombun",
        "zip_codes": [
            30330
        ],
        "district_id": 3003
    },
    {
        "id": 300304,
        "name_th": "กุดโบสถ์",
        "name_en": "Kut Bot",
        "zip_codes": [
            30330
        ],
        "district_id": 3003
    },
    {
        "id": 300305,
        "name_th": "สุขไพบูลย์",
        "name_en": "Suk Phaibun",
        "zip_codes": [
            30330
        ],
        "district_id": 3003
    },
    {
        "id": 300306,
        "name_th": "บ้านราษฎร์",
        "name_en": "Ban Rat",
        "zip_codes": [
            30330
        ],
        "district_id": 3003
    },
    {
        "id": 300401,
        "name_th": "เมืองคง",
        "name_en": "Mueang Khong",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300402,
        "name_th": "คูขาด",
        "name_en": "Khu Khat",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300403,
        "name_th": "เทพาลัย",
        "name_en": "Thephalai",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300404,
        "name_th": "ตาจั่น",
        "name_en": "Ta Chan",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300405,
        "name_th": "บ้านปรางค์",
        "name_en": "Ban Prang",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300406,
        "name_th": "หนองมะนาว",
        "name_en": "Nong Manao",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300407,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300408,
        "name_th": "โนนเต็ง",
        "name_en": "Non Teng",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300409,
        "name_th": "ดอนใหญ่",
        "name_en": "Don Yai",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300410,
        "name_th": "ขามสมบูรณ์",
        "name_en": "Kham Sombun",
        "zip_codes": [
            30260
        ],
        "district_id": 3004
    },
    {
        "id": 300501,
        "name_th": "บ้านเหลื่อม",
        "name_en": "Ban Lueam",
        "zip_codes": [
            30350
        ],
        "district_id": 3005
    },
    {
        "id": 300502,
        "name_th": "วังโพธิ์",
        "name_en": "Wang Pho",
        "zip_codes": [
            30350
        ],
        "district_id": 3005
    },
    {
        "id": 300503,
        "name_th": "โคกกระเบื้อง",
        "name_en": "Khok Krabueang",
        "zip_codes": [
            30350
        ],
        "district_id": 3005
    },
    {
        "id": 300504,
        "name_th": "ช่อระกา",
        "name_en": "Cho Raka",
        "zip_codes": [
            30350
        ],
        "district_id": 3005
    },
    {
        "id": 300601,
        "name_th": "จักราช",
        "name_en": "Chakkarat",
        "zip_codes": [
            30230
        ],
        "district_id": 3006
    },
    {
        "id": 300603,
        "name_th": "ทองหลาง",
        "name_en": "Thonglang",
        "zip_codes": [
            30230
        ],
        "district_id": 3006
    },
    {
        "id": 300604,
        "name_th": "สีสุก",
        "name_en": "Si Suk",
        "zip_codes": [
            30230
        ],
        "district_id": 3006
    },
    {
        "id": 300605,
        "name_th": "หนองขาม",
        "name_en": "Nong Kham",
        "zip_codes": [
            30230
        ],
        "district_id": 3006
    },
    {
        "id": 300607,
        "name_th": "หนองพลวง",
        "name_en": "Nong Phluang",
        "zip_codes": [
            30230
        ],
        "district_id": 3006
    },
    {
        "id": 300610,
        "name_th": "ศรีละกอ",
        "name_en": "Si Lako",
        "zip_codes": [
            30230
        ],
        "district_id": 3006
    },
    {
        "id": 300611,
        "name_th": "คลองเมือง",
        "name_en": "Khlong Mueang",
        "zip_codes": [
            30230
        ],
        "district_id": 3006
    },
    {
        "id": 300613,
        "name_th": "หินโคน",
        "name_en": "Hin Khon",
        "zip_codes": [
            30230
        ],
        "district_id": 3006
    },
    {
        "id": 300701,
        "name_th": "กระโทก",
        "name_en": "Krathok",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300702,
        "name_th": "พลับพลา",
        "name_en": "Phlapphla",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300703,
        "name_th": "ท่าอ่าง",
        "name_en": "Tha Ang",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300704,
        "name_th": "ทุ่งอรุณ",
        "name_en": "Thung Arun",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300705,
        "name_th": "ท่าลาดขาว",
        "name_en": "Tha Lat Khao",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300706,
        "name_th": "ท่าจะหลุง",
        "name_en": "Tha Chalung",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300707,
        "name_th": "ท่าเยี่ยม",
        "name_en": "Tha Yiam",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300708,
        "name_th": "โชคชัย",
        "name_en": "Chok Chai",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300709,
        "name_th": "ละลมใหม่พัฒนา",
        "name_en": "Lalom Mai Phatthana",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300710,
        "name_th": "ด่านเกวียน",
        "name_en": "Dan Kwian",
        "zip_codes": [
            30190
        ],
        "district_id": 3007
    },
    {
        "id": 300801,
        "name_th": "กุดพิมาน",
        "name_en": "Kut Phiman",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300802,
        "name_th": "ด่านขุนทด",
        "name_en": "Dan Khun Thot",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300803,
        "name_th": "ด่านนอก",
        "name_en": "Dan Nok",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300804,
        "name_th": "ด่านใน",
        "name_en": "Dan Nai",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300805,
        "name_th": "ตะเคียน",
        "name_en": "Takhian",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300806,
        "name_th": "บ้านเก่า",
        "name_en": "Ban Kao",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300807,
        "name_th": "บ้านแปรง",
        "name_en": "Ban Praeng",
        "zip_codes": [
            36220
        ],
        "district_id": 3008
    },
    {
        "id": 300808,
        "name_th": "พันชนะ",
        "name_en": "Phan Chana",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300809,
        "name_th": "สระจรเข้",
        "name_en": "Sa Chorakhe",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300810,
        "name_th": "หนองกราด",
        "name_en": "Nong Krat",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300811,
        "name_th": "หนองบัวตะเกียด",
        "name_en": "Nong Bua Takiat",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300812,
        "name_th": "หนองบัวละคร",
        "name_en": "Nong Bua Lakhon",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300813,
        "name_th": "หินดาด",
        "name_en": "Hin Dat",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300815,
        "name_th": "ห้วยบง",
        "name_en": "Huai Bong",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300817,
        "name_th": "โนนเมืองพัฒนา",
        "name_en": "Non Mueang Phatthana",
        "zip_codes": [
            30210
        ],
        "district_id": 3008
    },
    {
        "id": 300818,
        "name_th": "หนองไทร",
        "name_en": "Nong Sai",
        "zip_codes": [
            36220
        ],
        "district_id": 3008
    },
    {
        "id": 300901,
        "name_th": "โนนไทย",
        "name_en": "Non Thai",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 300902,
        "name_th": "ด่านจาก",
        "name_en": "Dan Chak",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 300903,
        "name_th": "กำปัง",
        "name_en": "Kampang",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 300904,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 300905,
        "name_th": "ค้างพลู",
        "name_en": "Khang Phu",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 300906,
        "name_th": "บ้านวัง",
        "name_en": "Ban Wang",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 300907,
        "name_th": "บัลลังก์",
        "name_en": "Banlang",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 300908,
        "name_th": "สายออ",
        "name_en": "Sai O",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 300909,
        "name_th": "ถนนโพธิ์",
        "name_en": "Thanon Pho",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 300914,
        "name_th": "มะค่า",
        "name_en": "Makha",
        "zip_codes": [
            30220
        ],
        "district_id": 3009
    },
    {
        "id": 301001,
        "name_th": "โนนสูง",
        "name_en": "Non Sung",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301002,
        "name_th": "ใหม่",
        "name_en": "Mai",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301003,
        "name_th": "โตนด",
        "name_en": "Tanot",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301004,
        "name_th": "บิง",
        "name_en": "Bing",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301005,
        "name_th": "ดอนชมพู",
        "name_en": "Don Chomphu",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301006,
        "name_th": "ธารปราสาท",
        "name_en": "Than Prasat",
        "zip_codes": [
            30420
        ],
        "district_id": 3010
    },
    {
        "id": 301007,
        "name_th": "หลุมข้าว",
        "name_en": "Lum Khao",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301008,
        "name_th": "มะค่า",
        "name_en": "Makha",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301009,
        "name_th": "พลสงคราม",
        "name_en": "Phon Songkhram",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301010,
        "name_th": "จันอัด",
        "name_en": "Chan At",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301011,
        "name_th": "ขามเฒ่า",
        "name_en": "Kham Thao",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301012,
        "name_th": "ด่านคล้า",
        "name_en": "Dan Khla",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301013,
        "name_th": "ลำคอหงษ์",
        "name_en": "Lam Kho Hong",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301014,
        "name_th": "เมืองปราสาท",
        "name_en": "Mueang Prasat",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301015,
        "name_th": "ดอนหวาย",
        "name_en": "Don Wai",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301016,
        "name_th": "ลำมูล",
        "name_en": "Lam Mun",
        "zip_codes": [
            30160
        ],
        "district_id": 3010
    },
    {
        "id": 301101,
        "name_th": "ขามสะแกแสง",
        "name_en": "Kham Sakaesaeng",
        "zip_codes": [
            30290
        ],
        "district_id": 3011
    },
    {
        "id": 301102,
        "name_th": "โนนเมือง",
        "name_en": "Non Mueang",
        "zip_codes": [
            30290
        ],
        "district_id": 3011
    },
    {
        "id": 301103,
        "name_th": "เมืองนาท",
        "name_en": "Mueang Nat",
        "zip_codes": [
            30290
        ],
        "district_id": 3011
    },
    {
        "id": 301104,
        "name_th": "ชีวึก",
        "name_en": "Chiwuek",
        "zip_codes": [
            30290
        ],
        "district_id": 3011
    },
    {
        "id": 301105,
        "name_th": "พะงาด",
        "name_en": "Pha-ngat",
        "zip_codes": [
            30290
        ],
        "district_id": 3011
    },
    {
        "id": 301106,
        "name_th": "หนองหัวฟาน",
        "name_en": "Nong Hua Fan",
        "zip_codes": [
            30290
        ],
        "district_id": 3011
    },
    {
        "id": 301107,
        "name_th": "เมืองเกษตร",
        "name_en": "Mueang Kaset",
        "zip_codes": [
            30290
        ],
        "district_id": 3011
    },
    {
        "id": 301201,
        "name_th": "บัวใหญ่",
        "name_en": "Bua Yai",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301203,
        "name_th": "ห้วยยาง",
        "name_en": "Huai Yang",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301204,
        "name_th": "เสมาใหญ่",
        "name_en": "Sema Yai",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301206,
        "name_th": "ดอนตะหนิน",
        "name_en": "Don Tanin",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301207,
        "name_th": "หนองบัวสะอาด",
        "name_en": "Nong Bua Sa-at",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301208,
        "name_th": "โนนทองหลาง",
        "name_en": "Non Thonglang",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301214,
        "name_th": "กุดจอก",
        "name_en": "Kut Chok",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301215,
        "name_th": "ด่านช้าง",
        "name_en": "Dan Chang",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301220,
        "name_th": "ขุนทอง",
        "name_en": "Khun Thong",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301224,
        "name_th": "หนองแจ้งใหญ่",
        "name_en": "Nong Chaeng Yai",
        "zip_codes": [
            30120
        ],
        "district_id": 3012
    },
    {
        "id": 301301,
        "name_th": "ประทาย",
        "name_en": "Prathai",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301303,
        "name_th": "กระทุ่มราย",
        "name_en": "Krathum Rai",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301304,
        "name_th": "วังไม้แดง",
        "name_en": "Wang Mai Daeng",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301306,
        "name_th": "ตลาดไทร",
        "name_en": "Talat Sai",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301307,
        "name_th": "หนองพลวง",
        "name_en": "Nong Phluang",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301308,
        "name_th": "หนองค่าย",
        "name_en": "Nong Khai",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301309,
        "name_th": "หันห้วยทราย",
        "name_en": "Han Huai Sai",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301310,
        "name_th": "ดอนมัน",
        "name_en": "Don Man",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301313,
        "name_th": "นางรำ",
        "name_en": "Nang Ram",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301314,
        "name_th": "โนนเพ็ด",
        "name_en": "Non Phet",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301315,
        "name_th": "ทุ่งสว่าง",
        "name_en": "Thung Sawang",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301317,
        "name_th": "โคกกลาง",
        "name_en": "Khok Klang",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301318,
        "name_th": "เมืองโดน",
        "name_en": "Mueang Don",
        "zip_codes": [
            30180
        ],
        "district_id": 3013
    },
    {
        "id": 301401,
        "name_th": "เมืองปัก",
        "name_en": "Mueang Pak",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301402,
        "name_th": "ตะคุ",
        "name_en": "Takhu",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301403,
        "name_th": "โคกไทย",
        "name_en": "Khok Thai",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301404,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301405,
        "name_th": "ตะขบ",
        "name_en": "Takhop",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301406,
        "name_th": "นกออก",
        "name_en": "Nok Ok",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301407,
        "name_th": "ดอน",
        "name_en": "Don",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301409,
        "name_th": "ตูม",
        "name_en": "Tum",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301410,
        "name_th": "งิ้ว",
        "name_en": "Ngio",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301411,
        "name_th": "สะแกราช",
        "name_en": "Sakae Rat",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301412,
        "name_th": "ลำนางแก้ว",
        "name_en": "Lam Nang Kaeo",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301416,
        "name_th": "ภูหลวง",
        "name_en": "Phu Luang",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301417,
        "name_th": "ธงชัยเหนือ",
        "name_en": "Thong Chai Nuea",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301418,
        "name_th": "สุขเกษม",
        "name_en": "Suk Kasem",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301419,
        "name_th": "เกษมทรัพย์",
        "name_en": "Kasem Sap",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301420,
        "name_th": "บ่อปลาทอง",
        "name_en": "Bo Pla Thong",
        "zip_codes": [
            30150
        ],
        "district_id": 3014
    },
    {
        "id": 301501,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301502,
        "name_th": "สัมฤทธิ์",
        "name_en": "Samrit",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301503,
        "name_th": "โบสถ์",
        "name_en": "Bot",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301504,
        "name_th": "กระเบื้องใหญ่",
        "name_en": "Krabueang Yai",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301505,
        "name_th": "ท่าหลวง",
        "name_en": "Tha Luang",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301506,
        "name_th": "รังกาใหญ่",
        "name_en": "Rang Ka Yai",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301507,
        "name_th": "ชีวาน",
        "name_en": "Chiwan",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301508,
        "name_th": "นิคมสร้างตนเอง",
        "name_en": "Nikhom Sang Ton-eng Phimai",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301509,
        "name_th": "กระชอน",
        "name_en": "Krachon",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301510,
        "name_th": "ดงใหญ่",
        "name_en": "Dong Yai",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301511,
        "name_th": "ธารละหลอด",
        "name_en": "Than Lalot",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301512,
        "name_th": "หนองระเวียง",
        "name_en": "Nong Rawiang",
        "zip_codes": [
            30110
        ],
        "district_id": 3015
    },
    {
        "id": 301601,
        "name_th": "ห้วยแถลง",
        "name_en": "Huai Thalaeng",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301602,
        "name_th": "ทับสวาย",
        "name_en": "Thap Sawai",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301603,
        "name_th": "เมืองพลับพลา",
        "name_en": "Mueang Phlapphla",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301604,
        "name_th": "หลุ่งตะเคียน",
        "name_en": "Lung Takhian",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301605,
        "name_th": "หินดาด",
        "name_en": "Hin Dat",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301606,
        "name_th": "งิ้ว",
        "name_en": "Ngio",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301607,
        "name_th": "กงรถ",
        "name_en": "Kong Rot",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301608,
        "name_th": "หลุ่งประดู่",
        "name_en": "Lung Pradu",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301609,
        "name_th": "ตะโก",
        "name_en": "Tako",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301610,
        "name_th": "ห้วยแคน",
        "name_en": "Huai Khaen",
        "zip_codes": [
            30240
        ],
        "district_id": 3016
    },
    {
        "id": 301701,
        "name_th": "ชุมพวง",
        "name_en": "Chum Phuang",
        "zip_codes": [
            30270
        ],
        "district_id": 3017
    },
    {
        "id": 301702,
        "name_th": "ประสุข",
        "name_en": "Prasuk",
        "zip_codes": [
            30270
        ],
        "district_id": 3017
    },
    {
        "id": 301703,
        "name_th": "ท่าลาด",
        "name_en": "Tha Lat",
        "zip_codes": [
            30270
        ],
        "district_id": 3017
    },
    {
        "id": 301704,
        "name_th": "สาหร่าย",
        "name_en": "Sarai",
        "zip_codes": [
            30270
        ],
        "district_id": 3017
    },
    {
        "id": 301705,
        "name_th": "ตลาดไทร",
        "name_en": "Talat Sai",
        "zip_codes": [
            30270
        ],
        "district_id": 3017
    },
    {
        "id": 301710,
        "name_th": "โนนรัง",
        "name_en": "Non Rang",
        "zip_codes": [
            30270
        ],
        "district_id": 3017
    },
    {
        "id": 301714,
        "name_th": "หนองหลัก",
        "name_en": "Nong Lak",
        "zip_codes": [
            30270
        ],
        "district_id": 3017
    },
    {
        "id": 301716,
        "name_th": "โนนตูม",
        "name_en": "Non Tum",
        "zip_codes": [
            30270
        ],
        "district_id": 3017
    },
    {
        "id": 301717,
        "name_th": "โนนยอ",
        "name_en": "Non Yo",
        "zip_codes": [
            30270
        ],
        "district_id": 3017
    },
    {
        "id": 301801,
        "name_th": "สูงเนิน",
        "name_en": "Sung Noen",
        "zip_codes": [
            30170
        ],
        "district_id": 3018
    },
    {
        "id": 301802,
        "name_th": "เสมา",
        "name_en": "Sema",
        "zip_codes": [
            30170
        ],
        "district_id": 3018
    },
    {
        "id": 301803,
        "name_th": "โคราช",
        "name_en": "Khorat",
        "zip_codes": [
            30170
        ],
        "district_id": 3018
    },
    {
        "id": 301804,
        "name_th": "บุ่งขี้เหล็ก",
        "name_en": "Bung Khilek",
        "zip_codes": [
            30170
        ],
        "district_id": 3018
    },
    {
        "id": 301805,
        "name_th": "โนนค่า",
        "name_en": "Non Kha",
        "zip_codes": [
            30170
        ],
        "district_id": 3018
    },
    {
        "id": 301806,
        "name_th": "โค้งยาง",
        "name_en": "Khong Yang",
        "zip_codes": [
            30170
        ],
        "district_id": 3018
    },
    {
        "id": 301807,
        "name_th": "มะเกลือเก่า",
        "name_en": "Makluea Kao",
        "zip_codes": [
            30170
        ],
        "district_id": 3018
    },
    {
        "id": 301808,
        "name_th": "มะเกลือใหม่",
        "name_en": "Makluea Mai",
        "zip_codes": [
            30170
        ],
        "district_id": 3018
    },
    {
        "id": 301809,
        "name_th": "นากลาง",
        "name_en": "Na Klang",
        "zip_codes": [
            30380
        ],
        "district_id": 3018
    },
    {
        "id": 301810,
        "name_th": "หนองตะไก้",
        "name_en": "Nong Takai",
        "zip_codes": [
            30380
        ],
        "district_id": 3018
    },
    {
        "id": 301811,
        "name_th": "กุดจิก",
        "name_en": "Kut Chik",
        "zip_codes": [
            30380
        ],
        "district_id": 3018
    },
    {
        "id": 301901,
        "name_th": "ขามทะเลสอ",
        "name_en": "Kham Thale So",
        "zip_codes": [
            30280
        ],
        "district_id": 3019
    },
    {
        "id": 301902,
        "name_th": "โป่งแดง",
        "name_en": "Pong Daeng",
        "zip_codes": [
            30280
        ],
        "district_id": 3019
    },
    {
        "id": 301903,
        "name_th": "พันดุง",
        "name_en": "Phan Dung",
        "zip_codes": [
            30280
        ],
        "district_id": 3019
    },
    {
        "id": 301904,
        "name_th": "หนองสรวง",
        "name_en": "Nong Suang",
        "zip_codes": [
            30280
        ],
        "district_id": 3019
    },
    {
        "id": 301905,
        "name_th": "บึงอ้อ",
        "name_en": "Bueng O",
        "zip_codes": [
            30280
        ],
        "district_id": 3019
    },
    {
        "id": 302001,
        "name_th": "สีคิ้ว",
        "name_en": "Sikhio",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302002,
        "name_th": "บ้านหัน",
        "name_en": "Ban Han",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302003,
        "name_th": "กฤษณา",
        "name_en": "Kritsana",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302004,
        "name_th": "ลาดบัวขาว",
        "name_en": "Lat Bua Khao",
        "zip_codes": [
            30340
        ],
        "district_id": 3020
    },
    {
        "id": 302005,
        "name_th": "หนองหญ้าขาว",
        "name_en": "Nong Ya Khao",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302006,
        "name_th": "กุดน้อย",
        "name_en": "Kut Noi",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302007,
        "name_th": "หนองน้ำใส",
        "name_en": "Nong Nam Sai",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302008,
        "name_th": "วังโรงใหญ่",
        "name_en": "Wang Rong Yai",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302009,
        "name_th": "มิตรภาพ",
        "name_en": "Mittraphap",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302010,
        "name_th": "คลองไผ่",
        "name_en": "Khlong Phai",
        "zip_codes": [
            30340
        ],
        "district_id": 3020
    },
    {
        "id": 302011,
        "name_th": "ดอนเมือง",
        "name_en": "Don Mueang",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302012,
        "name_th": "หนองบัวน้อย",
        "name_en": "Nong Bua Noi",
        "zip_codes": [
            30140
        ],
        "district_id": 3020
    },
    {
        "id": 302101,
        "name_th": "ปากช่อง",
        "name_en": "Pak Chong",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302102,
        "name_th": "กลางดง",
        "name_en": "Klang Dong",
        "zip_codes": [
            30320
        ],
        "district_id": 3021
    },
    {
        "id": 302103,
        "name_th": "จันทึก",
        "name_en": "Chanthuek",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302104,
        "name_th": "วังกะทะ",
        "name_en": "Wang Katha",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302105,
        "name_th": "หมูสี",
        "name_en": "Mu Si",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302106,
        "name_th": "หนองสาหร่าย",
        "name_en": "Nong Sarai",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302107,
        "name_th": "ขนงพระ",
        "name_en": "Khanong Phra",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302108,
        "name_th": "โป่งตาลอง",
        "name_en": "Pong Talong",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302109,
        "name_th": "คลองม่วง",
        "name_en": "Khlong Muang",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302110,
        "name_th": "หนองน้ำแดง",
        "name_en": "Nong Nam Daeng",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302111,
        "name_th": "วังไทร",
        "name_en": "Wang Sai",
        "zip_codes": [
            30130
        ],
        "district_id": 3021
    },
    {
        "id": 302112,
        "name_th": "พญาเย็น",
        "name_en": "Phaya Yen",
        "zip_codes": [
            30320
        ],
        "district_id": 3021
    },
    {
        "id": 302201,
        "name_th": "หนองบุนนาก",
        "name_en": "Nong Bunnak",
        "zip_codes": [
            30410
        ],
        "district_id": 3022
    },
    {
        "id": 302202,
        "name_th": "สารภี",
        "name_en": "Saraphi",
        "zip_codes": [
            30410
        ],
        "district_id": 3022
    },
    {
        "id": 302203,
        "name_th": "ไทยเจริญ",
        "name_en": "Thai Charoen",
        "zip_codes": [
            30410
        ],
        "district_id": 3022
    },
    {
        "id": 302204,
        "name_th": "หนองหัวแรต",
        "name_en": "Nong Hua Raet",
        "zip_codes": [
            30410
        ],
        "district_id": 3022
    },
    {
        "id": 302205,
        "name_th": "แหลมทอง",
        "name_en": "Laem Thong",
        "zip_codes": [
            30410
        ],
        "district_id": 3022
    },
    {
        "id": 302206,
        "name_th": "หนองตะไก้",
        "name_en": "Nong Takai",
        "zip_codes": [
            30410
        ],
        "district_id": 3022
    },
    {
        "id": 302207,
        "name_th": "ลุงเขว้า",
        "name_en": "Lung Khwao",
        "zip_codes": [
            30410
        ],
        "district_id": 3022
    },
    {
        "id": 302208,
        "name_th": "หนองไม้ไผ่",
        "name_en": "Nong Mai Phai",
        "zip_codes": [
            30410
        ],
        "district_id": 3022
    },
    {
        "id": 302209,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            30410
        ],
        "district_id": 3022
    },
    {
        "id": 302301,
        "name_th": "แก้งสนามนาง",
        "name_en": "Kaeng Sanam Nang",
        "zip_codes": [
            30440
        ],
        "district_id": 3023
    },
    {
        "id": 302302,
        "name_th": "โนนสำราญ",
        "name_en": "Non Samran",
        "zip_codes": [
            30440
        ],
        "district_id": 3023
    },
    {
        "id": 302303,
        "name_th": "บึงพะไล",
        "name_en": "Bueng Phalai",
        "zip_codes": [
            30440
        ],
        "district_id": 3023
    },
    {
        "id": 302304,
        "name_th": "สีสุก",
        "name_en": "Si Suk",
        "zip_codes": [
            30440
        ],
        "district_id": 3023
    },
    {
        "id": 302305,
        "name_th": "บึงสำโรง",
        "name_en": "Bueng Samrong",
        "zip_codes": [
            30440
        ],
        "district_id": 3023
    },
    {
        "id": 302401,
        "name_th": "โนนแดง",
        "name_en": "Non Daeng",
        "zip_codes": [
            30360
        ],
        "district_id": 3024
    },
    {
        "id": 302402,
        "name_th": "โนนตาเถร",
        "name_en": "Non Ta Then",
        "zip_codes": [
            30360
        ],
        "district_id": 3024
    },
    {
        "id": 302403,
        "name_th": "สำพะเนียง",
        "name_en": "Lam Phaniang",
        "zip_codes": [
            30360
        ],
        "district_id": 3024
    },
    {
        "id": 302404,
        "name_th": "วังหิน",
        "name_en": "Wang Hin",
        "zip_codes": [
            30360
        ],
        "district_id": 3024
    },
    {
        "id": 302405,
        "name_th": "ดอนยาวใหญ่",
        "name_en": "Don Yao Yai",
        "zip_codes": [
            30360
        ],
        "district_id": 3024
    },
    {
        "id": 302501,
        "name_th": "วังน้ำเขียว",
        "name_en": "Wang Nam Khiao",
        "zip_codes": [
            30370
        ],
        "district_id": 3025
    },
    {
        "id": 302502,
        "name_th": "วังหมี",
        "name_en": "Wang Mi",
        "zip_codes": [
            30370
        ],
        "district_id": 3025
    },
    {
        "id": 302503,
        "name_th": "ระเริง",
        "name_en": "Raroeng",
        "zip_codes": [
            30150
        ],
        "district_id": 3025
    },
    {
        "id": 302504,
        "name_th": "อุดมทรัพย์",
        "name_en": "Udom Sap",
        "zip_codes": [
            30370
        ],
        "district_id": 3025
    },
    {
        "id": 302505,
        "name_th": "ไทยสามัคคี",
        "name_en": "Thai Samakkhi",
        "zip_codes": [
            30370
        ],
        "district_id": 3025
    },
    {
        "id": 302601,
        "name_th": "สำนักตะคร้อ",
        "name_en": "Samnak Takhro",
        "zip_codes": [
            30210
        ],
        "district_id": 3026
    },
    {
        "id": 302602,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            30210
        ],
        "district_id": 3026
    },
    {
        "id": 302603,
        "name_th": "บึงปรือ",
        "name_en": "Bueng Prue",
        "zip_codes": [
            30210
        ],
        "district_id": 3026
    },
    {
        "id": 302604,
        "name_th": "วังยายทอง",
        "name_en": "Wang Yai Thong",
        "zip_codes": [
            30210
        ],
        "district_id": 3026
    },
    {
        "id": 302701,
        "name_th": "เมืองยาง",
        "name_en": "Mueang Yang",
        "zip_codes": [
            30270
        ],
        "district_id": 3027
    },
    {
        "id": 302702,
        "name_th": "กระเบื้องนอก",
        "name_en": "Krabueang Nok",
        "zip_codes": [
            30270
        ],
        "district_id": 3027
    },
    {
        "id": 302703,
        "name_th": "ละหานปลาค้าว",
        "name_en": "Lahan Pla Khao",
        "zip_codes": [
            30270
        ],
        "district_id": 3027
    },
    {
        "id": 302704,
        "name_th": "โนนอุดม",
        "name_en": "Non Udom",
        "zip_codes": [
            30270
        ],
        "district_id": 3027
    },
    {
        "id": 302801,
        "name_th": "สระพระ",
        "name_en": "Sa Phra",
        "zip_codes": [
            30220
        ],
        "district_id": 3028
    },
    {
        "id": 302802,
        "name_th": "มาบกราด",
        "name_en": "Map Krat",
        "zip_codes": [
            30220
        ],
        "district_id": 3028
    },
    {
        "id": 302803,
        "name_th": "พังเทียม",
        "name_en": "Phang Thiam",
        "zip_codes": [
            30220
        ],
        "district_id": 3028
    },
    {
        "id": 302804,
        "name_th": "ทัพรั้ง",
        "name_en": "Thap Rang",
        "zip_codes": [
            30220
        ],
        "district_id": 3028
    },
    {
        "id": 302805,
        "name_th": "หนองหอย",
        "name_en": "Nong Hoi",
        "zip_codes": [
            30220
        ],
        "district_id": 3028
    },
    {
        "id": 302901,
        "name_th": "ขุย",
        "name_en": "Khui",
        "zip_codes": [
            30270
        ],
        "district_id": 3029
    },
    {
        "id": 302902,
        "name_th": "บ้านยาง",
        "name_en": "Ban Yang",
        "zip_codes": [
            30270
        ],
        "district_id": 3029
    },
    {
        "id": 302903,
        "name_th": "ช่องแมว",
        "name_en": "Chong Maeo",
        "zip_codes": [
            30270
        ],
        "district_id": 3029
    },
    {
        "id": 302904,
        "name_th": "ไพล",
        "name_en": "Phlai",
        "zip_codes": [
            30270
        ],
        "district_id": 3029
    },
    {
        "id": 303001,
        "name_th": "เมืองพะไล",
        "name_en": "Mueang Phalai",
        "zip_codes": [
            30120
        ],
        "district_id": 3030
    },
    {
        "id": 303002,
        "name_th": "โนนจาน",
        "name_en": "Non Chan",
        "zip_codes": [
            30120
        ],
        "district_id": 3030
    },
    {
        "id": 303003,
        "name_th": "บัวลาย",
        "name_en": "Bua Lai",
        "zip_codes": [
            30120
        ],
        "district_id": 3030
    },
    {
        "id": 303004,
        "name_th": "หนองหว้า",
        "name_en": "Nong Wa",
        "zip_codes": [
            30120
        ],
        "district_id": 3030
    },
    {
        "id": 303101,
        "name_th": "สีดา",
        "name_en": "Sida",
        "zip_codes": [
            30430
        ],
        "district_id": 3031
    },
    {
        "id": 303102,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            30430
        ],
        "district_id": 3031
    },
    {
        "id": 303103,
        "name_th": "โนนประดู่",
        "name_en": "Non Pladu",
        "zip_codes": [
            30430
        ],
        "district_id": 3031
    },
    {
        "id": 303104,
        "name_th": "สามเมือง",
        "name_en": "Sam Mueang",
        "zip_codes": [
            30430
        ],
        "district_id": 3031
    },
    {
        "id": 303105,
        "name_th": "หนองตาดใหญ่",
        "name_en": "Nong Tat Yai",
        "zip_codes": [
            30430
        ],
        "district_id": 3031
    },
    {
        "id": 303201,
        "name_th": "ช้างทอง",
        "name_en": "Chang Thong",
        "zip_codes": [
            30230
        ],
        "district_id": 3032
    },
    {
        "id": 303202,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            30230
        ],
        "district_id": 3032
    },
    {
        "id": 303203,
        "name_th": "พระพุทธ",
        "name_en": "Phra Phut",
        "zip_codes": [
            30230
        ],
        "district_id": 3032
    },
    {
        "id": 303204,
        "name_th": "หนองงูเหลือม",
        "name_en": "Nong Ngu Lueam",
        "zip_codes": [
            30000
        ],
        "district_id": 3032
    },
    {
        "id": 303205,
        "name_th": "หนองยาง",
        "name_en": "Nong Yang",
        "zip_codes": [
            30230
        ],
        "district_id": 3032
    },
    {
        "id": 310101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310102,
        "name_th": "อิสาณ",
        "name_en": "Isan",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310103,
        "name_th": "เสม็ด",
        "name_en": "Samet",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310104,
        "name_th": "บ้านบัว",
        "name_en": "Ban Bua",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310105,
        "name_th": "สะแกโพรง",
        "name_en": "Sakae Phrong",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310106,
        "name_th": "สวายจีก",
        "name_en": "Sawai Chik",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310108,
        "name_th": "บ้านยาง",
        "name_en": "Ban Yang",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310112,
        "name_th": "พระครู",
        "name_en": "Phra Khru",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310113,
        "name_th": "ถลุงเหล็ก",
        "name_en": "Thalung Lek",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310114,
        "name_th": "หนองตาด",
        "name_en": "Nong Tat",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310117,
        "name_th": "ลุมปุ๊ก",
        "name_en": "Lumpuk",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310118,
        "name_th": "สองห้อง",
        "name_en": "Song Hong",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310119,
        "name_th": "บัวทอง",
        "name_en": "Bua Thong",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310120,
        "name_th": "ชุมเห็ด",
        "name_en": "Chum Het",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310122,
        "name_th": "หลักเขต",
        "name_en": "Lak Khet",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310125,
        "name_th": "สะแกซำ",
        "name_en": "Sakae Sam",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310126,
        "name_th": "กลันทา",
        "name_en": "Kalantha",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310127,
        "name_th": "กระสัง",
        "name_en": "Krasang",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310128,
        "name_th": "เมืองฝาง",
        "name_en": "Mueang Fang",
        "zip_codes": [
            31000
        ],
        "district_id": 3101
    },
    {
        "id": 310201,
        "name_th": "คูเมือง",
        "name_en": "Khu Mueang",
        "zip_codes": [
            31190
        ],
        "district_id": 3102
    },
    {
        "id": 310202,
        "name_th": "ปะเคียบ",
        "name_en": "Pakhiap",
        "zip_codes": [
            31190
        ],
        "district_id": 3102
    },
    {
        "id": 310203,
        "name_th": "บ้านแพ",
        "name_en": "Ban Phae",
        "zip_codes": [
            31190
        ],
        "district_id": 3102
    },
    {
        "id": 310204,
        "name_th": "พรสำราญ",
        "name_en": "Phon Samran",
        "zip_codes": [
            31190
        ],
        "district_id": 3102
    },
    {
        "id": 310205,
        "name_th": "หินเหล็กไฟ",
        "name_en": "Hin Lek Fai",
        "zip_codes": [
            31190
        ],
        "district_id": 3102
    },
    {
        "id": 310206,
        "name_th": "ตูมใหญ่",
        "name_en": "Tum Yai",
        "zip_codes": [
            31190
        ],
        "district_id": 3102
    },
    {
        "id": 310207,
        "name_th": "หนองขมาร",
        "name_en": "Nong Khaman",
        "zip_codes": [
            31190
        ],
        "district_id": 3102
    },
    {
        "id": 310301,
        "name_th": "กระสัง",
        "name_en": "Krasang",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310302,
        "name_th": "ลำดวน",
        "name_en": "Lamduan",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310303,
        "name_th": "สองชั้น",
        "name_en": "Song Chan",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310304,
        "name_th": "สูงเนิน",
        "name_en": "Sung Noen",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310305,
        "name_th": "หนองเต็ง",
        "name_en": "Nong Teng",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310306,
        "name_th": "เมืองไผ่",
        "name_en": "Mueang Phai",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310307,
        "name_th": "ชุมแสง",
        "name_en": "Chum Saeng",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310308,
        "name_th": "บ้านปรือ",
        "name_en": "Ban Prue",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310309,
        "name_th": "ห้วยสำราญ",
        "name_en": "Huai Samran",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310310,
        "name_th": "กันทรารมย์",
        "name_en": "Kanthararom",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310311,
        "name_th": "ศรีภูมิ",
        "name_en": "Si Phum",
        "zip_codes": [
            31160
        ],
        "district_id": 3103
    },
    {
        "id": 310401,
        "name_th": "นางรอง",
        "name_en": "Nang Rong",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310403,
        "name_th": "สะเดา",
        "name_en": "Sadao",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310405,
        "name_th": "ชุมแสง",
        "name_en": "Chum Saeng",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310406,
        "name_th": "หนองโบสถ์",
        "name_en": "Nong Bot",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310408,
        "name_th": "หนองกง",
        "name_en": "Nong Kong",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310413,
        "name_th": "ถนนหัก",
        "name_en": "Thanon Hak",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310414,
        "name_th": "หนองไทร",
        "name_en": "Nong Sai",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310415,
        "name_th": "ก้านเหลือง",
        "name_en": "Kan Lueang",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310416,
        "name_th": "บ้านสิงห์",
        "name_en": "Ban Sing",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310417,
        "name_th": "ลำไทรโยง",
        "name_en": "Lam Sai Yong",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310418,
        "name_th": "ทรัพย์พระยา",
        "name_en": "Sap Phraya",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310424,
        "name_th": "หนองยายพิมพ์",
        "name_en": "Nong Yai Phim",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310425,
        "name_th": "หัวถนน",
        "name_en": "Hua Thanon",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310426,
        "name_th": "ทุ่งแสงทอง",
        "name_en": "Thung Saeng Thong",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310427,
        "name_th": "หนองโสน",
        "name_en": "Nong Sano",
        "zip_codes": [
            31110
        ],
        "district_id": 3104
    },
    {
        "id": 310501,
        "name_th": "หนองกี่",
        "name_en": "Nong Ki",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310502,
        "name_th": "เย้ยปราสาท",
        "name_en": "Yoei Prasat",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310503,
        "name_th": "เมืองไผ่",
        "name_en": "Mueang Phai",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310504,
        "name_th": "ดอนอะราง",
        "name_en": "Don Arang",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310505,
        "name_th": "โคกสว่าง",
        "name_en": "Khok Sawang",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310506,
        "name_th": "ทุ่งกระตาดพัฒนา",
        "name_en": "Thung Kratat Phatthana",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310507,
        "name_th": "ทุ่งกระเต็น",
        "name_en": "Thung Kraten",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310508,
        "name_th": "ท่าโพธิ์ชัย",
        "name_en": "Tha Pho Chai",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310509,
        "name_th": "โคกสูง",
        "name_en": "Khok Sung",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310510,
        "name_th": "บุกระสัง",
        "name_en": "Bu Krasang",
        "zip_codes": [
            31210
        ],
        "district_id": 3105
    },
    {
        "id": 310601,
        "name_th": "ละหานทราย",
        "name_en": "Lahan Sai",
        "zip_codes": [
            31170
        ],
        "district_id": 3106
    },
    {
        "id": 310603,
        "name_th": "ตาจง",
        "name_en": "Ta Chong",
        "zip_codes": [
            31170
        ],
        "district_id": 3106
    },
    {
        "id": 310604,
        "name_th": "สำโรงใหม่",
        "name_en": "Samrong Mai",
        "zip_codes": [
            31170
        ],
        "district_id": 3106
    },
    {
        "id": 310607,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            31170
        ],
        "district_id": 3106
    },
    {
        "id": 310610,
        "name_th": "หนองตะครอง",
        "name_en": "Nong Takhrong",
        "zip_codes": [
            31170
        ],
        "district_id": 3106
    },
    {
        "id": 310611,
        "name_th": "โคกว่าน",
        "name_en": "Khok Wan",
        "zip_codes": [
            31170
        ],
        "district_id": 3106
    },
    {
        "id": 310701,
        "name_th": "ประโคนชัย",
        "name_en": "Prakhon Chai",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310702,
        "name_th": "แสลงโทน",
        "name_en": "Salaeng Thon",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310703,
        "name_th": "บ้านไทร",
        "name_en": "Ban Sai",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310705,
        "name_th": "ละเวี้ย",
        "name_en": "Lawia",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310706,
        "name_th": "จรเข้มาก",
        "name_en": "Chorakhe Mak",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310707,
        "name_th": "ปังกู",
        "name_en": "Pang Ku",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310708,
        "name_th": "โคกย่าง",
        "name_en": "Khok Yang",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310710,
        "name_th": "โคกม้า",
        "name_en": "Khok Ma",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310713,
        "name_th": "ไพศาล",
        "name_en": "Phaisan",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310714,
        "name_th": "ตะโกตาพิ",
        "name_en": "Tako Taphi",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310715,
        "name_th": "เขาคอก",
        "name_en": "Khao Khok",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310716,
        "name_th": "หนองบอน",
        "name_en": "Bong Bon",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310718,
        "name_th": "โคกมะขาม",
        "name_en": "Khok Makham",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310719,
        "name_th": "โคกตูม",
        "name_en": "Khok Tum",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310720,
        "name_th": "ประทัดบุ",
        "name_en": "Prathat Bu",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310721,
        "name_th": "สี่เหลี่ยม",
        "name_en": "Si Liam",
        "zip_codes": [
            31140
        ],
        "district_id": 3107
    },
    {
        "id": 310801,
        "name_th": "บ้านกรวด",
        "name_en": "Ban Kruat",
        "zip_codes": [
            31180
        ],
        "district_id": 3108
    },
    {
        "id": 310802,
        "name_th": "โนนเจริญ",
        "name_en": "Non Charoen",
        "zip_codes": [
            31180
        ],
        "district_id": 3108
    },
    {
        "id": 310803,
        "name_th": "หนองไม้งาม",
        "name_en": "Nong Mai Ngam",
        "zip_codes": [
            31180
        ],
        "district_id": 3108
    },
    {
        "id": 310804,
        "name_th": "ปราสาท",
        "name_en": "Prasat",
        "zip_codes": [
            31180
        ],
        "district_id": 3108
    },
    {
        "id": 310805,
        "name_th": "สายตะกู",
        "name_en": "Sai Taku",
        "zip_codes": [
            31180
        ],
        "district_id": 3108
    },
    {
        "id": 310806,
        "name_th": "หินลาด",
        "name_en": "Hin Lat",
        "zip_codes": [
            31180
        ],
        "district_id": 3108
    },
    {
        "id": 310807,
        "name_th": "บึงเจริญ",
        "name_en": "Bueng Charoen",
        "zip_codes": [
            31180
        ],
        "district_id": 3108
    },
    {
        "id": 310808,
        "name_th": "จันทบเพชร",
        "name_en": "Chanthop Phet",
        "zip_codes": [
            31180
        ],
        "district_id": 3108
    },
    {
        "id": 310809,
        "name_th": "เขาดินเหนือ",
        "name_en": "Khao Din Nuea",
        "zip_codes": [
            31180
        ],
        "district_id": 3108
    },
    {
        "id": 310901,
        "name_th": "พุทไธสง",
        "name_en": "Phutthaisong",
        "zip_codes": [
            31120
        ],
        "district_id": 3109
    },
    {
        "id": 310902,
        "name_th": "มะเฟือง",
        "name_en": "Mafueang",
        "zip_codes": [
            31120
        ],
        "district_id": 3109
    },
    {
        "id": 310903,
        "name_th": "บ้านจาน",
        "name_en": "Ban Chan",
        "zip_codes": [
            31120
        ],
        "district_id": 3109
    },
    {
        "id": 310906,
        "name_th": "บ้านเป้า",
        "name_en": "Ban Pao",
        "zip_codes": [
            31120
        ],
        "district_id": 3109
    },
    {
        "id": 310907,
        "name_th": "บ้านแวง",
        "name_en": "Ban Waeng",
        "zip_codes": [
            31120
        ],
        "district_id": 3109
    },
    {
        "id": 310909,
        "name_th": "บ้านยาง",
        "name_en": "Ban Yang",
        "zip_codes": [
            31120
        ],
        "district_id": 3109
    },
    {
        "id": 310910,
        "name_th": "หายโศก",
        "name_en": "Hai Sok",
        "zip_codes": [
            31120
        ],
        "district_id": 3109
    },
    {
        "id": 311001,
        "name_th": "ลำปลายมาศ",
        "name_en": "Lam Plai Mat",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311002,
        "name_th": "หนองคู",
        "name_en": "Nong Khu",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311003,
        "name_th": "แสลงพัน",
        "name_en": "Salaeng Phan",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311004,
        "name_th": "ทะเมนชัย",
        "name_en": "Thamen Chai",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311005,
        "name_th": "ตลาดโพธิ์",
        "name_en": "Talat Pho",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311006,
        "name_th": "หนองกะทิง",
        "name_en": "Nong Kathing",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311007,
        "name_th": "โคกกลาง",
        "name_en": "Khok Klang",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311008,
        "name_th": "โคกสะอาด",
        "name_en": "Khok Sa-at",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311009,
        "name_th": "เมืองแฝก",
        "name_en": "Mueang Faek",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311010,
        "name_th": "บ้านยาง",
        "name_en": "Ban Yang",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311011,
        "name_th": "ผไทรินทร์",
        "name_en": "Phathairin",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311012,
        "name_th": "โคกล่าม",
        "name_en": "Khok Lam",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311013,
        "name_th": "หินโคน",
        "name_en": "Hin Khon",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311014,
        "name_th": "หนองบัวโคก",
        "name_en": "Nong Bua Khok",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311015,
        "name_th": "บุโพธิ์",
        "name_en": "Bu Pho",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311016,
        "name_th": "หนองโดน",
        "name_en": "Nong Don",
        "zip_codes": [
            31130
        ],
        "district_id": 3110
    },
    {
        "id": 311101,
        "name_th": "สตึก",
        "name_en": "Satuek",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311102,
        "name_th": "นิคม",
        "name_en": "Nikhom",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311103,
        "name_th": "ทุ่งวัง",
        "name_en": "Thung Wang",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311104,
        "name_th": "เมืองแก",
        "name_en": "Mueang Kae",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311105,
        "name_th": "หนองใหญ่",
        "name_en": "Nong Yai",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311106,
        "name_th": "ร่อนทอง",
        "name_en": "Ron Thong",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311109,
        "name_th": "ดอนมนต์",
        "name_en": "Don Mon",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311110,
        "name_th": "ชุมแสง",
        "name_en": "Chum Saeng",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311111,
        "name_th": "ท่าม่วง",
        "name_en": "Tha Muang",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311112,
        "name_th": "สะแก",
        "name_en": "Sakae",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311114,
        "name_th": "สนามชัย",
        "name_en": "Sanam Chai",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311115,
        "name_th": "กระสัง",
        "name_en": "Krasang",
        "zip_codes": [
            31150
        ],
        "district_id": 3111
    },
    {
        "id": 311201,
        "name_th": "ปะคำ",
        "name_en": "Pakham",
        "zip_codes": [
            31220
        ],
        "district_id": 3112
    },
    {
        "id": 311202,
        "name_th": "ไทยเจริญ",
        "name_en": "Thai Charoen",
        "zip_codes": [
            31220
        ],
        "district_id": 3112
    },
    {
        "id": 311203,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            31220
        ],
        "district_id": 3112
    },
    {
        "id": 311204,
        "name_th": "โคกมะม่วง",
        "name_en": "Khok Mamuang",
        "zip_codes": [
            31220
        ],
        "district_id": 3112
    },
    {
        "id": 311205,
        "name_th": "หูทำนบ",
        "name_en": "Hu Thamnop",
        "zip_codes": [
            31220
        ],
        "district_id": 3112
    },
    {
        "id": 311301,
        "name_th": "นาโพธิ์",
        "name_en": "Na Pho",
        "zip_codes": [
            31230
        ],
        "district_id": 3113
    },
    {
        "id": 311302,
        "name_th": "บ้านคู",
        "name_en": "Ban Khu",
        "zip_codes": [
            31230
        ],
        "district_id": 3113
    },
    {
        "id": 311303,
        "name_th": "บ้านดู่",
        "name_en": "Ban Du",
        "zip_codes": [
            31230
        ],
        "district_id": 3113
    },
    {
        "id": 311304,
        "name_th": "ดอนกอก",
        "name_en": "Don Kok",
        "zip_codes": [
            31230
        ],
        "district_id": 3113
    },
    {
        "id": 311305,
        "name_th": "ศรีสว่าง",
        "name_en": "Si Sawang",
        "zip_codes": [
            31230
        ],
        "district_id": 3113
    },
    {
        "id": 311401,
        "name_th": "สระแก้ว",
        "name_en": "Sa Kaeo",
        "zip_codes": [
            31240
        ],
        "district_id": 3114
    },
    {
        "id": 311402,
        "name_th": "ห้วยหิน",
        "name_en": "Huai Hin",
        "zip_codes": [
            31240
        ],
        "district_id": 3114
    },
    {
        "id": 311403,
        "name_th": "ไทยสามัคคี",
        "name_en": "Thai Samakkhi",
        "zip_codes": [
            31240
        ],
        "district_id": 3114
    },
    {
        "id": 311404,
        "name_th": "หนองชัยศรี",
        "name_en": "Nong Chai Si",
        "zip_codes": [
            31240
        ],
        "district_id": 3114
    },
    {
        "id": 311405,
        "name_th": "เสาเดียว",
        "name_en": "Sao Diao",
        "zip_codes": [
            31240
        ],
        "district_id": 3114
    },
    {
        "id": 311406,
        "name_th": "เมืองฝ้าย",
        "name_en": "Mueang Fai",
        "zip_codes": [
            31240
        ],
        "district_id": 3114
    },
    {
        "id": 311407,
        "name_th": "สระทอง",
        "name_en": "Sa Thong",
        "zip_codes": [
            31240
        ],
        "district_id": 3114
    },
    {
        "id": 311501,
        "name_th": "จันดุม",
        "name_en": "Chan Dum",
        "zip_codes": [
            31250
        ],
        "district_id": 3115
    },
    {
        "id": 311502,
        "name_th": "โคกขมิ้น",
        "name_en": "Khok Khamin",
        "zip_codes": [
            31250
        ],
        "district_id": 3115
    },
    {
        "id": 311503,
        "name_th": "ป่าชัน",
        "name_en": "Pa Chan",
        "zip_codes": [
            31250
        ],
        "district_id": 3115
    },
    {
        "id": 311504,
        "name_th": "สะเดา",
        "name_en": "Sadao",
        "zip_codes": [
            31250
        ],
        "district_id": 3115
    },
    {
        "id": 311505,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            31250
        ],
        "district_id": 3115
    },
    {
        "id": 311601,
        "name_th": "ห้วยราช",
        "name_en": "Huai Rat",
        "zip_codes": [
            31000
        ],
        "district_id": 3116
    },
    {
        "id": 311602,
        "name_th": "สามแวง",
        "name_en": "Sam Waeng",
        "zip_codes": [
            31000
        ],
        "district_id": 3116
    },
    {
        "id": 311603,
        "name_th": "ตาเสา",
        "name_en": "Ta Sao",
        "zip_codes": [
            31000
        ],
        "district_id": 3116
    },
    {
        "id": 311604,
        "name_th": "บ้านตะโก",
        "name_en": "Ban Tako",
        "zip_codes": [
            31000
        ],
        "district_id": 3116
    },
    {
        "id": 311605,
        "name_th": "สนวน",
        "name_en": "Sanuan",
        "zip_codes": [
            31000
        ],
        "district_id": 3116
    },
    {
        "id": 311606,
        "name_th": "โคกเหล็ก",
        "name_en": "Khok Lek",
        "zip_codes": [
            31000
        ],
        "district_id": 3116
    },
    {
        "id": 311607,
        "name_th": "เมืองโพธิ์",
        "name_en": "Mueang Pho",
        "zip_codes": [
            31000
        ],
        "district_id": 3116
    },
    {
        "id": 311608,
        "name_th": "ห้วยราชา",
        "name_en": "Huai Racha",
        "zip_codes": [
            31000
        ],
        "district_id": 3116
    },
    {
        "id": 311701,
        "name_th": "โนนสุวรรณ",
        "name_en": "Non Suwan",
        "zip_codes": [
            31110
        ],
        "district_id": 3117
    },
    {
        "id": 311702,
        "name_th": "ทุ่งจังหัน",
        "name_en": "Thung Changhan",
        "zip_codes": [
            31110
        ],
        "district_id": 3117
    },
    {
        "id": 311703,
        "name_th": "โกรกแก้ว",
        "name_en": "Krok Kaeo",
        "zip_codes": [
            31110
        ],
        "district_id": 3117
    },
    {
        "id": 311704,
        "name_th": "ดงอีจาน",
        "name_en": "Dong I Chan",
        "zip_codes": [
            31110
        ],
        "district_id": 3117
    },
    {
        "id": 311801,
        "name_th": "ชำนิ",
        "name_en": "Chamni",
        "zip_codes": [
            31110
        ],
        "district_id": 3118
    },
    {
        "id": 311802,
        "name_th": "หนองปล่อง",
        "name_en": "Nong Plong",
        "zip_codes": [
            31110
        ],
        "district_id": 3118
    },
    {
        "id": 311803,
        "name_th": "เมืองยาง",
        "name_en": "Mueang Yang",
        "zip_codes": [
            31110
        ],
        "district_id": 3118
    },
    {
        "id": 311804,
        "name_th": "ช่อผกา",
        "name_en": "Cho Phaka",
        "zip_codes": [
            31110
        ],
        "district_id": 3118
    },
    {
        "id": 311805,
        "name_th": "ละลวด",
        "name_en": "Laluat",
        "zip_codes": [
            31110
        ],
        "district_id": 3118
    },
    {
        "id": 311806,
        "name_th": "โคกสนวน",
        "name_en": "Khok Sanuan",
        "zip_codes": [
            31110
        ],
        "district_id": 3118
    },
    {
        "id": 311901,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            31120
        ],
        "district_id": 3119
    },
    {
        "id": 311902,
        "name_th": "ทองหลาง",
        "name_en": "Thonglang",
        "zip_codes": [
            31120
        ],
        "district_id": 3119
    },
    {
        "id": 311903,
        "name_th": "แดงใหญ่",
        "name_en": "Daeng Yai",
        "zip_codes": [
            31120
        ],
        "district_id": 3119
    },
    {
        "id": 311904,
        "name_th": "กู่สวนแตง",
        "name_en": "Ku Suan Taeng",
        "zip_codes": [
            31120
        ],
        "district_id": 3119
    },
    {
        "id": 311905,
        "name_th": "หนองเยือง",
        "name_en": "Nong Yueang",
        "zip_codes": [
            31120
        ],
        "district_id": 3119
    },
    {
        "id": 312001,
        "name_th": "โนนดินแดง",
        "name_en": "Non Din Daeng",
        "zip_codes": [
            31260
        ],
        "district_id": 3120
    },
    {
        "id": 312002,
        "name_th": "ส้มป่อย",
        "name_en": "Som Poi",
        "zip_codes": [
            31260
        ],
        "district_id": 3120
    },
    {
        "id": 312003,
        "name_th": "ลำนางรอง",
        "name_en": "Lam Nang Rong",
        "zip_codes": [
            31260
        ],
        "district_id": 3120
    },
    {
        "id": 312101,
        "name_th": "บ้านด่าน",
        "name_en": "Ban Dan",
        "zip_codes": [
            31000
        ],
        "district_id": 3121
    },
    {
        "id": 312102,
        "name_th": "ปราสาท",
        "name_en": "Prasat",
        "zip_codes": [
            31000
        ],
        "district_id": 3121
    },
    {
        "id": 312103,
        "name_th": "วังเหนือ",
        "name_en": "Wang Nuea",
        "zip_codes": [
            31000
        ],
        "district_id": 3121
    },
    {
        "id": 312104,
        "name_th": "โนนขวาง",
        "name_en": "Non Khwang",
        "zip_codes": [
            31000
        ],
        "district_id": 3121
    },
    {
        "id": 312201,
        "name_th": "แคนดง",
        "name_en": "Khaen Dong",
        "zip_codes": [
            31150
        ],
        "district_id": 3122
    },
    {
        "id": 312202,
        "name_th": "ดงพลอง",
        "name_en": "Dong Phlong",
        "zip_codes": [
            31150
        ],
        "district_id": 3122
    },
    {
        "id": 312203,
        "name_th": "สระบัว",
        "name_en": "Sa Bua",
        "zip_codes": [
            31150
        ],
        "district_id": 3122
    },
    {
        "id": 312204,
        "name_th": "หัวฝาย",
        "name_en": "Hua Fai",
        "zip_codes": [
            31150
        ],
        "district_id": 3122
    },
    {
        "id": 312301,
        "name_th": "เจริญสุข",
        "name_en": "Charoen Suk",
        "zip_codes": [
            31110
        ],
        "district_id": 3123
    },
    {
        "id": 312302,
        "name_th": "ตาเป๊ก",
        "name_en": "Ta Pek",
        "zip_codes": [
            31110
        ],
        "district_id": 3123
    },
    {
        "id": 312303,
        "name_th": "อีสานเขต",
        "name_en": "Isan Khet",
        "zip_codes": [
            31110
        ],
        "district_id": 3123
    },
    {
        "id": 312304,
        "name_th": "ถาวร",
        "name_en": "Thawon",
        "zip_codes": [
            31170
        ],
        "district_id": 3123
    },
    {
        "id": 312305,
        "name_th": "ยายแย้มวัฒนา",
        "name_en": "Yai Yaem Watthana",
        "zip_codes": [
            31170
        ],
        "district_id": 3123
    },
    {
        "id": 320101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320102,
        "name_th": "ตั้งใจ",
        "name_en": "Tang Chai",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320103,
        "name_th": "เพี้ยราม",
        "name_en": "Phia Ram",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320104,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320105,
        "name_th": "ท่าสว่าง",
        "name_en": "Tha Sawang",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320106,
        "name_th": "สลักได",
        "name_en": "Salakdai",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320107,
        "name_th": "ตาอ็อง",
        "name_en": "Ta Ong",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320109,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320110,
        "name_th": "แกใหญ่",
        "name_en": "Kae Yai",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320111,
        "name_th": "นอกเมือง",
        "name_en": "Nok Mueang",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320112,
        "name_th": "คอโค",
        "name_en": "Kho Kho",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320113,
        "name_th": "สวาย",
        "name_en": "Sawai",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320114,
        "name_th": "เฉนียง",
        "name_en": "Chaniang",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320116,
        "name_th": "เทนมีย์",
        "name_en": "Thenmi",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320118,
        "name_th": "นาบัว",
        "name_en": "Na Bua",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320119,
        "name_th": "เมืองที",
        "name_en": "Mueang Thi",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320120,
        "name_th": "ราม",
        "name_en": "Ram",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320121,
        "name_th": "บุฤาษี",
        "name_en": "Bu Ruesi",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320122,
        "name_th": "ตระแสง",
        "name_en": "Trasaeng",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320125,
        "name_th": "แสลงพันธ์",
        "name_en": "Salaeng Phan",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320126,
        "name_th": "กาเกาะ",
        "name_en": "Ka Ko",
        "zip_codes": [
            32000
        ],
        "district_id": 3201
    },
    {
        "id": 320201,
        "name_th": "ชุมพลบุรี",
        "name_en": "Chumphon Buri",
        "zip_codes": [
            32190
        ],
        "district_id": 3202
    },
    {
        "id": 320202,
        "name_th": "นาหนองไผ่",
        "name_en": "Na Nong Phai",
        "zip_codes": [
            32190
        ],
        "district_id": 3202
    },
    {
        "id": 320203,
        "name_th": "ไพรขลา",
        "name_en": "Phrai Khla",
        "zip_codes": [
            32190
        ],
        "district_id": 3202
    },
    {
        "id": 320204,
        "name_th": "ศรีณรงค์",
        "name_en": "Si Narong",
        "zip_codes": [
            32190
        ],
        "district_id": 3202
    },
    {
        "id": 320205,
        "name_th": "ยะวึก",
        "name_en": "Yawuek",
        "zip_codes": [
            32190
        ],
        "district_id": 3202
    },
    {
        "id": 320206,
        "name_th": "เมืองบัว",
        "name_en": "Mueang Bua",
        "zip_codes": [
            32190
        ],
        "district_id": 3202
    },
    {
        "id": 320207,
        "name_th": "สระขุด",
        "name_en": "Sa Khut",
        "zip_codes": [
            32190
        ],
        "district_id": 3202
    },
    {
        "id": 320208,
        "name_th": "กระเบื้อง",
        "name_en": "Krabueang",
        "zip_codes": [
            32190
        ],
        "district_id": 3202
    },
    {
        "id": 320209,
        "name_th": "หนองเรือ",
        "name_en": "Nong Ruea",
        "zip_codes": [
            32190
        ],
        "district_id": 3202
    },
    {
        "id": 320301,
        "name_th": "ท่าตูม",
        "name_en": "Tha Tum",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320302,
        "name_th": "กระโพ",
        "name_en": "Krapho",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320303,
        "name_th": "พรมเทพ",
        "name_en": "Phrom Thep",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320304,
        "name_th": "โพนครก",
        "name_en": "Phon Khrok",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320305,
        "name_th": "เมืองแก",
        "name_en": "Mueang Kae",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320306,
        "name_th": "บะ",
        "name_en": "Ba",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320307,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320308,
        "name_th": "บัวโคก",
        "name_en": "Bua Khok",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320309,
        "name_th": "หนองเมธี",
        "name_en": "Nong Methi",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320310,
        "name_th": "ทุ่งกุลา",
        "name_en": "Thung Kula",
        "zip_codes": [
            32120
        ],
        "district_id": 3203
    },
    {
        "id": 320401,
        "name_th": "จอมพระ",
        "name_en": "Chom Phra",
        "zip_codes": [
            32180
        ],
        "district_id": 3204
    },
    {
        "id": 320402,
        "name_th": "เมืองลีง",
        "name_en": "Mueang Ling",
        "zip_codes": [
            32180
        ],
        "district_id": 3204
    },
    {
        "id": 320403,
        "name_th": "กระหาด",
        "name_en": "Krahat",
        "zip_codes": [
            32180
        ],
        "district_id": 3204
    },
    {
        "id": 320404,
        "name_th": "บุแกรง",
        "name_en": "Bu Kraeng",
        "zip_codes": [
            32180
        ],
        "district_id": 3204
    },
    {
        "id": 320405,
        "name_th": "หนองสนิท",
        "name_en": "Nong Sanit",
        "zip_codes": [
            32180
        ],
        "district_id": 3204
    },
    {
        "id": 320406,
        "name_th": "บ้านผือ",
        "name_en": "Ban Phue",
        "zip_codes": [
            32180
        ],
        "district_id": 3204
    },
    {
        "id": 320407,
        "name_th": "ลุ่มระวี",
        "name_en": "Lum Rawi",
        "zip_codes": [
            32180
        ],
        "district_id": 3204
    },
    {
        "id": 320408,
        "name_th": "ชุมแสง",
        "name_en": "Chum Saeng",
        "zip_codes": [
            32180
        ],
        "district_id": 3204
    },
    {
        "id": 320409,
        "name_th": "เป็นสุข",
        "name_en": "Pen Suk",
        "zip_codes": [
            32180
        ],
        "district_id": 3204
    },
    {
        "id": 320501,
        "name_th": "กังแอน",
        "name_en": "Kang Aen",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320502,
        "name_th": "ทมอ",
        "name_en": "Thamo",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320503,
        "name_th": "ไพล",
        "name_en": "Phlai",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320504,
        "name_th": "ปรือ",
        "name_en": "Prue",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320505,
        "name_th": "ทุ่งมน",
        "name_en": "Thung Mon",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320506,
        "name_th": "ตาเบา",
        "name_en": "Ta Bao",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320507,
        "name_th": "หนองใหญ่",
        "name_en": "Nong Yai",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320508,
        "name_th": "โคกยาง",
        "name_en": "Khok Yang",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320509,
        "name_th": "โคกสะอาด",
        "name_en": "Khok Sa-at",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320510,
        "name_th": "บ้านไทร",
        "name_en": "Ban Sai",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320511,
        "name_th": "โชคนาสาม",
        "name_en": "Chok Na Sam",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320512,
        "name_th": "เชื้อเพลิง",
        "name_en": "Chuea Phloeng",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320513,
        "name_th": "ปราสาททนง",
        "name_en": "Prasat Thanong",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320514,
        "name_th": "ตานี",
        "name_en": "Tani",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320515,
        "name_th": "บ้านพลวง",
        "name_en": "Ban Phluang",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320516,
        "name_th": "กันตวจระมวล",
        "name_en": "Kantuat Ramuan",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320517,
        "name_th": "สมุด",
        "name_en": "Samut",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320518,
        "name_th": "ประทัดบุ",
        "name_en": "Prathat Bu",
        "zip_codes": [
            32140
        ],
        "district_id": 3205
    },
    {
        "id": 320601,
        "name_th": "กาบเชิง",
        "name_en": "Kap Choeng",
        "zip_codes": [
            32210
        ],
        "district_id": 3206
    },
    {
        "id": 320604,
        "name_th": "คูตัน",
        "name_en": "Khu Tan",
        "zip_codes": [
            32210
        ],
        "district_id": 3206
    },
    {
        "id": 320605,
        "name_th": "ด่าน",
        "name_en": "Dan",
        "zip_codes": [
            32210
        ],
        "district_id": 3206
    },
    {
        "id": 320606,
        "name_th": "แนงมุด",
        "name_en": "Naeng Mut",
        "zip_codes": [
            32210
        ],
        "district_id": 3206
    },
    {
        "id": 320607,
        "name_th": "โคกตะเคียน",
        "name_en": "Khok Takhian",
        "zip_codes": [
            32210
        ],
        "district_id": 3206
    },
    {
        "id": 320610,
        "name_th": "ตะเคียน",
        "name_en": "Takhian",
        "zip_codes": [
            32210
        ],
        "district_id": 3206
    },
    {
        "id": 320701,
        "name_th": "รัตนบุรี",
        "name_en": "Rattanaburi",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320702,
        "name_th": "ธาตุ",
        "name_en": "That",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320703,
        "name_th": "แก",
        "name_en": "Kae",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320704,
        "name_th": "ดอนแรด",
        "name_en": "Don Raet",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320705,
        "name_th": "หนองบัวทอง",
        "name_en": "Nong Bua Thong",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320706,
        "name_th": "หนองบัวบาน",
        "name_en": "Nong Bua Ban",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320709,
        "name_th": "ไผ่",
        "name_en": "Phai",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320711,
        "name_th": "เบิด",
        "name_en": "Boet",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320713,
        "name_th": "น้ำเขียว",
        "name_en": "Nam Khiao",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320714,
        "name_th": "กุดขาคีม",
        "name_en": "Kut Kha Khim",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320715,
        "name_th": "ยางสว่าง",
        "name_en": "Yang Sawang",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320716,
        "name_th": "ทับใหญ่",
        "name_en": "Thap Yai",
        "zip_codes": [
            32130
        ],
        "district_id": 3207
    },
    {
        "id": 320801,
        "name_th": "สนม",
        "name_en": "Sanom",
        "zip_codes": [
            32160
        ],
        "district_id": 3208
    },
    {
        "id": 320802,
        "name_th": "โพนโก",
        "name_en": "Phon Ko",
        "zip_codes": [
            32160
        ],
        "district_id": 3208
    },
    {
        "id": 320803,
        "name_th": "หนองระฆัง",
        "name_en": "Nong Rakhang",
        "zip_codes": [
            32160
        ],
        "district_id": 3208
    },
    {
        "id": 320804,
        "name_th": "นานวน",
        "name_en": "Na Nuan",
        "zip_codes": [
            32160
        ],
        "district_id": 3208
    },
    {
        "id": 320805,
        "name_th": "แคน",
        "name_en": "Khaen",
        "zip_codes": [
            32160
        ],
        "district_id": 3208
    },
    {
        "id": 320806,
        "name_th": "หัวงัว",
        "name_en": "Hua Ngua",
        "zip_codes": [
            32160
        ],
        "district_id": 3208
    },
    {
        "id": 320807,
        "name_th": "หนองอียอ",
        "name_en": "Nong I Yo",
        "zip_codes": [
            32160
        ],
        "district_id": 3208
    },
    {
        "id": 320901,
        "name_th": "ระแงง",
        "name_en": "Ra-ngaeng",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320902,
        "name_th": "ตรึม",
        "name_en": "Truem",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320903,
        "name_th": "จารพัต",
        "name_en": "Charaphat",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320904,
        "name_th": "ยาง",
        "name_en": "Yang",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320905,
        "name_th": "แตล",
        "name_en": "Taen",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320906,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320907,
        "name_th": "คาละแมะ",
        "name_en": "Khalamae",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320908,
        "name_th": "หนองเหล็ก",
        "name_en": "Nong Lek",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320909,
        "name_th": "หนองขวาว",
        "name_en": "Nong Khwao",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320910,
        "name_th": "ช่างปี่",
        "name_en": "Chang Pi",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320911,
        "name_th": "กุดหวาย",
        "name_en": "Kut Wai",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320912,
        "name_th": "ขวาวใหญ่",
        "name_en": "Khwao Yai",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320913,
        "name_th": "นารุ่ง",
        "name_en": "Na Rung",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320914,
        "name_th": "ตรมไพร",
        "name_en": "Trom Phrai",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 320915,
        "name_th": "ผักไหม",
        "name_en": "Phak Mai",
        "zip_codes": [
            32110
        ],
        "district_id": 3209
    },
    {
        "id": 321001,
        "name_th": "สังขะ",
        "name_en": "Sangkha",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321002,
        "name_th": "ขอนแตก",
        "name_en": "Khon Taek",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321006,
        "name_th": "ดม",
        "name_en": "Dom",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321007,
        "name_th": "พระแก้ว",
        "name_en": "Phra Kaeo",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321008,
        "name_th": "บ้านจารย์",
        "name_en": "Ban Chan",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321009,
        "name_th": "กระเทียม",
        "name_en": "Krathiam",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321010,
        "name_th": "สะกาด",
        "name_en": "Sakat",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321011,
        "name_th": "ตาตุม",
        "name_en": "Ta Tum",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321012,
        "name_th": "ทับทัน",
        "name_en": "Thap Than",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321013,
        "name_th": "ตาคง",
        "name_en": "Ta Khong",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321015,
        "name_th": "บ้านชบ",
        "name_en": "Ban Chop",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321017,
        "name_th": "เทพรักษา",
        "name_en": "Thep Raksa",
        "zip_codes": [
            32150
        ],
        "district_id": 3210
    },
    {
        "id": 321101,
        "name_th": "ลำดวน",
        "name_en": "Lamduan",
        "zip_codes": [
            32220
        ],
        "district_id": 3211
    },
    {
        "id": 321102,
        "name_th": "โชคเหนือ",
        "name_en": "Chok Nuea",
        "zip_codes": [
            32220
        ],
        "district_id": 3211
    },
    {
        "id": 321103,
        "name_th": "อู่โลก",
        "name_en": "U Lok",
        "zip_codes": [
            32220
        ],
        "district_id": 3211
    },
    {
        "id": 321104,
        "name_th": "ตรำดม",
        "name_en": "Tram Dom",
        "zip_codes": [
            32220
        ],
        "district_id": 3211
    },
    {
        "id": 321105,
        "name_th": "ตระเปียงเตีย",
        "name_en": "Tra Priang Tia",
        "zip_codes": [
            32220
        ],
        "district_id": 3211
    },
    {
        "id": 321201,
        "name_th": "สำโรงทาบ",
        "name_en": "Samrong Thap",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321202,
        "name_th": "หนองไผ่ล้อม",
        "name_en": "Nong Phai Lom",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321203,
        "name_th": "กระออม",
        "name_en": "Kra-om",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321204,
        "name_th": "หนองฮะ",
        "name_en": "Nong Ha",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321205,
        "name_th": "ศรีสุข",
        "name_en": "Si Suk",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321206,
        "name_th": "เกาะแก้ว",
        "name_en": "Ko Kaeo",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321207,
        "name_th": "หมื่นศรี",
        "name_en": "Muen Si",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321208,
        "name_th": "เสม็จ",
        "name_en": "Samet",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321209,
        "name_th": "สะโน",
        "name_en": "Sano",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321210,
        "name_th": "ประดู่",
        "name_en": "Pradu",
        "zip_codes": [
            32170
        ],
        "district_id": 3212
    },
    {
        "id": 321301,
        "name_th": "บัวเชด",
        "name_en": "Buachet",
        "zip_codes": [
            32230
        ],
        "district_id": 3213
    },
    {
        "id": 321302,
        "name_th": "สะเดา",
        "name_en": "Sadao",
        "zip_codes": [
            32230
        ],
        "district_id": 3213
    },
    {
        "id": 321303,
        "name_th": "จรัส",
        "name_en": "Charat",
        "zip_codes": [
            32230
        ],
        "district_id": 3213
    },
    {
        "id": 321304,
        "name_th": "ตาวัง",
        "name_en": "Ta Wang",
        "zip_codes": [
            32230
        ],
        "district_id": 3213
    },
    {
        "id": 321305,
        "name_th": "อาโพน",
        "name_en": "A Phon",
        "zip_codes": [
            32230
        ],
        "district_id": 3213
    },
    {
        "id": 321306,
        "name_th": "สำเภาลูน",
        "name_en": "Samphao Lun",
        "zip_codes": [
            32230
        ],
        "district_id": 3213
    },
    {
        "id": 321401,
        "name_th": "บักได",
        "name_en": "Bak Dai",
        "zip_codes": [
            32140
        ],
        "district_id": 3214
    },
    {
        "id": 321402,
        "name_th": "โคกกลาง",
        "name_en": "Khok Klang",
        "zip_codes": [
            32140
        ],
        "district_id": 3214
    },
    {
        "id": 321403,
        "name_th": "จีกแดก",
        "name_en": "Chik Daek",
        "zip_codes": [
            32140
        ],
        "district_id": 3214
    },
    {
        "id": 321404,
        "name_th": "ตาเมียง",
        "name_en": "Ta Miang",
        "zip_codes": [
            32140
        ],
        "district_id": 3214
    },
    {
        "id": 321501,
        "name_th": "ณรงค์",
        "name_en": "Narong",
        "zip_codes": [
            32150
        ],
        "district_id": 3215
    },
    {
        "id": 321502,
        "name_th": "แจนแวน",
        "name_en": "Chaenwaen",
        "zip_codes": [
            32150
        ],
        "district_id": 3215
    },
    {
        "id": 321503,
        "name_th": "ตรวจ",
        "name_en": "Truat",
        "zip_codes": [
            32150
        ],
        "district_id": 3215
    },
    {
        "id": 321504,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            32150
        ],
        "district_id": 3215
    },
    {
        "id": 321505,
        "name_th": "ศรีสุข",
        "name_en": "Si Suk",
        "zip_codes": [
            32150
        ],
        "district_id": 3215
    },
    {
        "id": 321601,
        "name_th": "เขวาสินรินทร์",
        "name_en": "Khwao Sinrin",
        "zip_codes": [
            32000
        ],
        "district_id": 3216
    },
    {
        "id": 321602,
        "name_th": "บึง",
        "name_en": "Bueng",
        "zip_codes": [
            32000
        ],
        "district_id": 3216
    },
    {
        "id": 321603,
        "name_th": "ตากูก",
        "name_en": "Ta Kuk",
        "zip_codes": [
            32000
        ],
        "district_id": 3216
    },
    {
        "id": 321604,
        "name_th": "ปราสาททอง",
        "name_en": "Prasat Thong",
        "zip_codes": [
            32000
        ],
        "district_id": 3216
    },
    {
        "id": 321605,
        "name_th": "บ้านแร่",
        "name_en": "Ban Rae",
        "zip_codes": [
            32000
        ],
        "district_id": 3216
    },
    {
        "id": 321701,
        "name_th": "หนองหลวง",
        "name_en": "Nong Luang",
        "zip_codes": [
            32130
        ],
        "district_id": 3217
    },
    {
        "id": 321702,
        "name_th": "คำผง",
        "name_en": "Kham Phong",
        "zip_codes": [
            32130
        ],
        "district_id": 3217
    },
    {
        "id": 321703,
        "name_th": "โนน",
        "name_en": "Non",
        "zip_codes": [
            32130
        ],
        "district_id": 3217
    },
    {
        "id": 321704,
        "name_th": "ระเวียง",
        "name_en": "Rawiang",
        "zip_codes": [
            32130
        ],
        "district_id": 3217
    },
    {
        "id": 321705,
        "name_th": "หนองเทพ",
        "name_en": "Nong Thep",
        "zip_codes": [
            32130
        ],
        "district_id": 3217
    },
    {
        "id": 330101,
        "name_th": "เมืองเหนือ",
        "name_en": "Mueang Nuea",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330102,
        "name_th": "เมืองใต้",
        "name_en": "Mueang Tai",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330103,
        "name_th": "คูซอด",
        "name_en": "Khu Sot",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330104,
        "name_th": "ซำ",
        "name_en": "Sam",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330105,
        "name_th": "จาน",
        "name_en": "Chan",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330106,
        "name_th": "ตะดอบ",
        "name_en": "Tadop",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330107,
        "name_th": "หนองครก",
        "name_en": "Nong Khrok",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330111,
        "name_th": "โพนข่า",
        "name_en": "Phon Kha",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330112,
        "name_th": "โพนค้อ",
        "name_en": "Phon Kho",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330115,
        "name_th": "โพนเขวา",
        "name_en": "Phon Khwao",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330116,
        "name_th": "หญ้าปล้อง",
        "name_en": "Ya Plong",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330118,
        "name_th": "ทุ่ม",
        "name_en": "Thum",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330119,
        "name_th": "หนองไฮ",
        "name_en": "Nong Hai",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330121,
        "name_th": "หนองแก้ว",
        "name_en": "Nong Kaeo",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330122,
        "name_th": "น้ำคำ",
        "name_en": "Nam Kham",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330123,
        "name_th": "โพธิ์",
        "name_en": "Pho",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330124,
        "name_th": "หมากเขียบ",
        "name_en": "Mak Khiap",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330127,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            33000
        ],
        "district_id": 3301
    },
    {
        "id": 330201,
        "name_th": "ยางชุมน้อย",
        "name_en": "Yang Chum Noi",
        "zip_codes": [
            33190
        ],
        "district_id": 3302
    },
    {
        "id": 330202,
        "name_th": "ลิ้นฟ้า",
        "name_en": "Lin Fa",
        "zip_codes": [
            33190
        ],
        "district_id": 3302
    },
    {
        "id": 330203,
        "name_th": "คอนกาม",
        "name_en": "Khon Kam",
        "zip_codes": [
            33190
        ],
        "district_id": 3302
    },
    {
        "id": 330204,
        "name_th": "โนนคูณ",
        "name_en": "Non Khun",
        "zip_codes": [
            33190
        ],
        "district_id": 3302
    },
    {
        "id": 330205,
        "name_th": "กุดเมืองฮาม",
        "name_en": "Kut Mueang Ham",
        "zip_codes": [
            33190
        ],
        "district_id": 3302
    },
    {
        "id": 330206,
        "name_th": "บึงบอน",
        "name_en": "Bueng Bon",
        "zip_codes": [
            33190
        ],
        "district_id": 3302
    },
    {
        "id": 330207,
        "name_th": "ยางชุมใหญ่",
        "name_en": "Yang Chum Yai",
        "zip_codes": [
            33190
        ],
        "district_id": 3302
    },
    {
        "id": 330301,
        "name_th": "ดูน",
        "name_en": "Dun",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330302,
        "name_th": "โนนสัง",
        "name_en": "Non Sang",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330303,
        "name_th": "หนองหัวช้าง",
        "name_en": "Nong Hua Chang",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330304,
        "name_th": "ยาง",
        "name_en": "Yang",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330305,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330306,
        "name_th": "หนองแก้ว",
        "name_en": "Nong Kaeo",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330307,
        "name_th": "ทาม",
        "name_en": "Tham",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330308,
        "name_th": "ละทาย",
        "name_en": "Lathai",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330309,
        "name_th": "เมืองน้อย",
        "name_en": "Mueang Noi",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330310,
        "name_th": "อีปาด",
        "name_en": "I Pat",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330311,
        "name_th": "บัวน้อย",
        "name_en": "Bua Noi",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330312,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330313,
        "name_th": "ดู่",
        "name_en": "Du",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330314,
        "name_th": "ผักแพว",
        "name_en": "Phak Phaeo",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330315,
        "name_th": "จาน",
        "name_en": "Chan",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330320,
        "name_th": "คำเนียม",
        "name_en": "Kham Niam",
        "zip_codes": [
            33130
        ],
        "district_id": 3303
    },
    {
        "id": 330401,
        "name_th": "บึงมะลู",
        "name_en": "Bueng Malu",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330402,
        "name_th": "กุดเสลา",
        "name_en": "Kut Salao",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330403,
        "name_th": "เมือง",
        "name_en": "Mueang",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330405,
        "name_th": "สังเม็ก",
        "name_en": "Sang Mek",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330406,
        "name_th": "น้ำอ้อม",
        "name_en": "Nam Om",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330407,
        "name_th": "ละลาย",
        "name_en": "Lalai",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330408,
        "name_th": "รุง",
        "name_en": "Rung",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330409,
        "name_th": "ตระกาจ",
        "name_en": "Trakat",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330411,
        "name_th": "จานใหญ่",
        "name_en": "Chan Yai",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330412,
        "name_th": "ภูเงิน",
        "name_en": "Phu Ngoen",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330413,
        "name_th": "ชำ",
        "name_en": "Cham",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330414,
        "name_th": "กระแชง",
        "name_en": "Krachaeng",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330415,
        "name_th": "โนนสำราญ",
        "name_en": "Non Samran",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330416,
        "name_th": "หนองหญ้าลาด",
        "name_en": "Nong Ya Lat",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330419,
        "name_th": "เสาธงชัย",
        "name_en": "Sao Thong Chai",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330420,
        "name_th": "ขนุน",
        "name_en": "Khanun",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330421,
        "name_th": "สวนกล้วย",
        "name_en": "Suan Kluai",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330423,
        "name_th": "เวียงเหนือ",
        "name_en": "Wiang Nuea",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330424,
        "name_th": "ทุ่งใหญ่",
        "name_en": "Thung Yai",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330425,
        "name_th": "ภูผาหมอก",
        "name_en": "Phu Pha Mok",
        "zip_codes": [
            33110
        ],
        "district_id": 3304
    },
    {
        "id": 330501,
        "name_th": "กันทรารมย์",
        "name_en": "Kanthararom",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330502,
        "name_th": "จะกง",
        "name_en": "Chakong",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330503,
        "name_th": "ใจดี",
        "name_en": "Chai Di",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330504,
        "name_th": "ดองกำเม็ด",
        "name_en": "Dong Kam Met",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330505,
        "name_th": "โสน",
        "name_en": "Sano",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330506,
        "name_th": "ปรือใหญ่",
        "name_en": "Prue Yai",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330507,
        "name_th": "สะเดาใหญ่",
        "name_en": "Sadao Yai",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330508,
        "name_th": "ตาอุด",
        "name_en": "Ta Ut",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330509,
        "name_th": "ห้วยเหนือ",
        "name_en": "Huai Nuea",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330510,
        "name_th": "ห้วยใต้",
        "name_en": "Huai Tai",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330511,
        "name_th": "หัวเสือ",
        "name_en": "Hua Suea",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330513,
        "name_th": "ตะเคียน",
        "name_en": "Takhian",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330515,
        "name_th": "นิคมพัฒนา",
        "name_en": "Nikhom Phatthana",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330517,
        "name_th": "โคกเพชร",
        "name_en": "Khok Phet",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330518,
        "name_th": "ปราสาท",
        "name_en": "Prasat",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330521,
        "name_th": "สำโรงตาเจ็น",
        "name_en": "Samrong Ta Chen",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330522,
        "name_th": "ห้วยสำราญ",
        "name_en": "Huai Samran",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330524,
        "name_th": "กฤษณา",
        "name_en": "Kritsana",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330525,
        "name_th": "ลมศักดิ์",
        "name_en": "Lom Sak",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330526,
        "name_th": "หนองฉลอง",
        "name_en": "Nong Chalong",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330527,
        "name_th": "ศรีตระกูล",
        "name_en": "Si Trakun",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330528,
        "name_th": "ศรีสะอาด",
        "name_en": "Si Sa-at",
        "zip_codes": [
            33140
        ],
        "district_id": 3305
    },
    {
        "id": 330601,
        "name_th": "ไพรบึง",
        "name_en": "Phrai Bueng",
        "zip_codes": [
            33180
        ],
        "district_id": 3306
    },
    {
        "id": 330602,
        "name_th": "ดินแดง",
        "name_en": "Din Daeng",
        "zip_codes": [
            33180
        ],
        "district_id": 3306
    },
    {
        "id": 330603,
        "name_th": "ปราสาทเยอ",
        "name_en": "Prasat Yoe",
        "zip_codes": [
            33180
        ],
        "district_id": 3306
    },
    {
        "id": 330604,
        "name_th": "สำโรงพลัน",
        "name_en": "Samrong Phlan",
        "zip_codes": [
            33180
        ],
        "district_id": 3306
    },
    {
        "id": 330605,
        "name_th": "สุขสวัสดิ์",
        "name_en": "Suk Sawat",
        "zip_codes": [
            33180
        ],
        "district_id": 3306
    },
    {
        "id": 330606,
        "name_th": "โนนปูน",
        "name_en": "Non Pun",
        "zip_codes": [
            33180
        ],
        "district_id": 3306
    },
    {
        "id": 330701,
        "name_th": "พิมาย",
        "name_en": "Phimai",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330702,
        "name_th": "กู่",
        "name_en": "Ku",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330703,
        "name_th": "หนองเชียงทูน",
        "name_en": "Nong Chiang Thun",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330704,
        "name_th": "ตูม",
        "name_en": "Tum",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330705,
        "name_th": "สมอ",
        "name_en": "Samo",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330706,
        "name_th": "โพธิ์ศรี",
        "name_en": "Pho Si",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330707,
        "name_th": "สำโรงปราสาท",
        "name_en": "Samrong Prasat",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330708,
        "name_th": "ดู่",
        "name_en": "Du",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330709,
        "name_th": "สวาย",
        "name_en": "Sawai",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330710,
        "name_th": "พิมายเหนือ",
        "name_en": "Phimai Nuea",
        "zip_codes": [
            33170
        ],
        "district_id": 3307
    },
    {
        "id": 330801,
        "name_th": "สิ",
        "name_en": "Si",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330802,
        "name_th": "บักดอง",
        "name_en": "Bak Dong",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330803,
        "name_th": "พราน",
        "name_en": "Phran",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330804,
        "name_th": "โพธิ์วงศ์",
        "name_en": "Pho Wong",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330805,
        "name_th": "ไพร",
        "name_en": "Phrai",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330806,
        "name_th": "กระหวัน",
        "name_en": "Krawan",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330807,
        "name_th": "ขุนหาญ",
        "name_en": "Khun Han",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330808,
        "name_th": "โนนสูง",
        "name_en": "Non Sung",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330809,
        "name_th": "กันทรอม",
        "name_en": "Kanthrom",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330810,
        "name_th": "ภูฝ้าย",
        "name_en": "Phu Fai",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330811,
        "name_th": "โพธิ์กระสังข์",
        "name_en": "Pho Krasang",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330812,
        "name_th": "ห้วยจันทร์",
        "name_en": "Huai Chan",
        "zip_codes": [
            33150
        ],
        "district_id": 3308
    },
    {
        "id": 330901,
        "name_th": "เมืองคง",
        "name_en": "Mueang Khong",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330902,
        "name_th": "เมืองแคน",
        "name_en": "Mueang Khaen",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330903,
        "name_th": "หนองแค",
        "name_en": "Nong Khae",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330906,
        "name_th": "จิกสังข์ทอง",
        "name_en": "Chik Sang Thong",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330907,
        "name_th": "ด่าน",
        "name_en": "Dan",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330908,
        "name_th": "ดู่",
        "name_en": "Du",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330909,
        "name_th": "หนองอึ่ง",
        "name_en": "Nong Ueng",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330910,
        "name_th": "บัวหุ่ง",
        "name_en": "Bua Hung",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330911,
        "name_th": "ไผ่",
        "name_en": "Phai",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330912,
        "name_th": "ส้มป่อย",
        "name_en": "Som Poi",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330913,
        "name_th": "หนองหมี",
        "name_en": "Nong Mi",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330914,
        "name_th": "หว้านคำ",
        "name_en": "Wan Kham",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 330915,
        "name_th": "สร้างปี่",
        "name_en": "Sang Pi",
        "zip_codes": [
            33160
        ],
        "district_id": 3309
    },
    {
        "id": 331001,
        "name_th": "กำแพง",
        "name_en": "Kamphaeng",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331002,
        "name_th": "อี่หล่ำ",
        "name_en": "I Lam",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331003,
        "name_th": "ก้านเหลือง",
        "name_en": "Kan Lueang",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331004,
        "name_th": "ทุ่งไชย",
        "name_en": "Thung Chai",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331005,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331006,
        "name_th": "แขม",
        "name_en": "Khaem",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331007,
        "name_th": "หนองไฮ",
        "name_en": "Nong Hai",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331008,
        "name_th": "ขะยูง",
        "name_en": "Khayung",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331010,
        "name_th": "ตาเกษ",
        "name_en": "Ta Ket",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331011,
        "name_th": "หัวช้าง",
        "name_en": "Hua Chang",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331012,
        "name_th": "รังแร้ง",
        "name_en": "Rang Raeng",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331014,
        "name_th": "แต้",
        "name_en": "Tae",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331015,
        "name_th": "แข้",
        "name_en": "Khae",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331016,
        "name_th": "โพธิ์ชัย",
        "name_en": "Pho Chai",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331017,
        "name_th": "ปะอาว",
        "name_en": "Pa Ao",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331018,
        "name_th": "หนองห้าง",
        "name_en": "Nong Hang",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331022,
        "name_th": "สระกำแพงใหญ่",
        "name_en": "Sa Kamphaeng Yai",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331024,
        "name_th": "โคกหล่าม",
        "name_en": "Khok Lam",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331025,
        "name_th": "โคกจาน",
        "name_en": "Khok Chan",
        "zip_codes": [
            33120
        ],
        "district_id": 3310
    },
    {
        "id": 331101,
        "name_th": "เป๊าะ",
        "name_en": "Po",
        "zip_codes": [
            33220
        ],
        "district_id": 3311
    },
    {
        "id": 331102,
        "name_th": "บึงบูรพ์",
        "name_en": "Bueng Bun",
        "zip_codes": [
            33220
        ],
        "district_id": 3311
    },
    {
        "id": 331201,
        "name_th": "ห้วยทับทัน",
        "name_en": "Huai Thap Than",
        "zip_codes": [
            33210
        ],
        "district_id": 3312
    },
    {
        "id": 331202,
        "name_th": "เมืองหลวง",
        "name_en": "Mueang Luang",
        "zip_codes": [
            33210
        ],
        "district_id": 3312
    },
    {
        "id": 331203,
        "name_th": "กล้วยกว้าง",
        "name_en": "Kluai Kwang",
        "zip_codes": [
            33210
        ],
        "district_id": 3312
    },
    {
        "id": 331204,
        "name_th": "ผักไหม",
        "name_en": "Phak Mai",
        "zip_codes": [
            33210
        ],
        "district_id": 3312
    },
    {
        "id": 331205,
        "name_th": "จานแสนไชย",
        "name_en": "Chan Saen Chai",
        "zip_codes": [
            33210
        ],
        "district_id": 3312
    },
    {
        "id": 331206,
        "name_th": "ปราสาท",
        "name_en": "Prasat",
        "zip_codes": [
            33210
        ],
        "district_id": 3312
    },
    {
        "id": 331301,
        "name_th": "โนนค้อ",
        "name_en": "Non Kho",
        "zip_codes": [
            33250
        ],
        "district_id": 3313
    },
    {
        "id": 331302,
        "name_th": "บก",
        "name_en": "Bok",
        "zip_codes": [
            33250
        ],
        "district_id": 3313
    },
    {
        "id": 331303,
        "name_th": "โพธิ์",
        "name_en": "Pho",
        "zip_codes": [
            33250
        ],
        "district_id": 3313
    },
    {
        "id": 331304,
        "name_th": "หนองกุง",
        "name_en": "Nong Kung",
        "zip_codes": [
            33250
        ],
        "district_id": 3313
    },
    {
        "id": 331305,
        "name_th": "เหล่ากวาง",
        "name_en": "Lao Kwang",
        "zip_codes": [
            33250
        ],
        "district_id": 3313
    },
    {
        "id": 331401,
        "name_th": "ศรีแก้ว",
        "name_en": "Si Kaeo",
        "zip_codes": [
            33240
        ],
        "district_id": 3314
    },
    {
        "id": 331402,
        "name_th": "พิงพวย",
        "name_en": "Phing Phuai",
        "zip_codes": [
            33240
        ],
        "district_id": 3314
    },
    {
        "id": 331403,
        "name_th": "สระเยาว์",
        "name_en": "Sa Yao",
        "zip_codes": [
            33240
        ],
        "district_id": 3314
    },
    {
        "id": 331404,
        "name_th": "ตูม",
        "name_en": "Tum",
        "zip_codes": [
            33240
        ],
        "district_id": 3314
    },
    {
        "id": 331405,
        "name_th": "เสื่องข้าว",
        "name_en": "Sueang Khao",
        "zip_codes": [
            33240
        ],
        "district_id": 3314
    },
    {
        "id": 331406,
        "name_th": "ศรีโนนงาม",
        "name_en": "Si Non Ngam",
        "zip_codes": [
            33240
        ],
        "district_id": 3314
    },
    {
        "id": 331407,
        "name_th": "สะพุง",
        "name_en": "Saphung",
        "zip_codes": [
            33240
        ],
        "district_id": 3314
    },
    {
        "id": 331501,
        "name_th": "น้ำเกลี้ยง",
        "name_en": "Nam Kliang",
        "zip_codes": [
            33130
        ],
        "district_id": 3315
    },
    {
        "id": 331502,
        "name_th": "ละเอาะ",
        "name_en": "La-o",
        "zip_codes": [
            33130
        ],
        "district_id": 3315
    },
    {
        "id": 331503,
        "name_th": "ตองปิด",
        "name_en": "Tong Pit",
        "zip_codes": [
            33130
        ],
        "district_id": 3315
    },
    {
        "id": 331504,
        "name_th": "เขิน",
        "name_en": "Khoen",
        "zip_codes": [
            33130
        ],
        "district_id": 3315
    },
    {
        "id": 331505,
        "name_th": "รุ่งระวี",
        "name_en": "Rung Rawi",
        "zip_codes": [
            33130
        ],
        "district_id": 3315
    },
    {
        "id": 331506,
        "name_th": "คูบ",
        "name_en": "Khup",
        "zip_codes": [
            33130
        ],
        "district_id": 3315
    },
    {
        "id": 331601,
        "name_th": "บุสูง",
        "name_en": "Bu Sung",
        "zip_codes": [
            33270
        ],
        "district_id": 3316
    },
    {
        "id": 331602,
        "name_th": "ธาตุ",
        "name_en": "That",
        "zip_codes": [
            33270
        ],
        "district_id": 3316
    },
    {
        "id": 331603,
        "name_th": "ดวนใหญ่",
        "name_en": "Duan Yai",
        "zip_codes": [
            33270
        ],
        "district_id": 3316
    },
    {
        "id": 331604,
        "name_th": "บ่อแก้ว",
        "name_en": "Bo Kaeo",
        "zip_codes": [
            33270
        ],
        "district_id": 3316
    },
    {
        "id": 331605,
        "name_th": "ศรีสำราญ",
        "name_en": "Si Samran",
        "zip_codes": [
            33270
        ],
        "district_id": 3316
    },
    {
        "id": 331606,
        "name_th": "ทุ่งสว่าง",
        "name_en": "Thung Sawang",
        "zip_codes": [
            33270
        ],
        "district_id": 3316
    },
    {
        "id": 331607,
        "name_th": "วังหิน",
        "name_en": "Wang Hin",
        "zip_codes": [
            33270
        ],
        "district_id": 3316
    },
    {
        "id": 331608,
        "name_th": "โพนยาง",
        "name_en": "Phon Yang",
        "zip_codes": [
            33270
        ],
        "district_id": 3316
    },
    {
        "id": 331701,
        "name_th": "โคกตาล",
        "name_en": "Khok Tan",
        "zip_codes": [
            33140
        ],
        "district_id": 3317
    },
    {
        "id": 331702,
        "name_th": "ห้วยตามอญ",
        "name_en": "Huai Ta Mon",
        "zip_codes": [
            33140
        ],
        "district_id": 3317
    },
    {
        "id": 331703,
        "name_th": "ห้วยตึ๊กชู",
        "name_en": "Huai Tuekchu",
        "zip_codes": [
            33140
        ],
        "district_id": 3317
    },
    {
        "id": 331704,
        "name_th": "ละลม",
        "name_en": "Lalom",
        "zip_codes": [
            33140
        ],
        "district_id": 3317
    },
    {
        "id": 331705,
        "name_th": "ตะเคียนราม",
        "name_en": "Takhian Ram",
        "zip_codes": [
            33140
        ],
        "district_id": 3317
    },
    {
        "id": 331706,
        "name_th": "ดงรัก",
        "name_en": "Dong Rak",
        "zip_codes": [
            33140
        ],
        "district_id": 3317
    },
    {
        "id": 331707,
        "name_th": "ไพรพัฒนา",
        "name_en": "Phrai Phatthana",
        "zip_codes": [
            33140
        ],
        "district_id": 3317
    },
    {
        "id": 331801,
        "name_th": "เมืองจันทร์",
        "name_en": "Mueang Chan",
        "zip_codes": [
            33120
        ],
        "district_id": 3318
    },
    {
        "id": 331802,
        "name_th": "ตาโกน",
        "name_en": "Ta Kon",
        "zip_codes": [
            33120
        ],
        "district_id": 3318
    },
    {
        "id": 331803,
        "name_th": "หนองใหญ่",
        "name_en": "Nong Yai",
        "zip_codes": [
            33120
        ],
        "district_id": 3318
    },
    {
        "id": 331901,
        "name_th": "เสียว",
        "name_en": "Siao",
        "zip_codes": [
            33110
        ],
        "district_id": 3319
    },
    {
        "id": 331902,
        "name_th": "หนองหว้า",
        "name_en": "Nong Wa",
        "zip_codes": [
            33110
        ],
        "district_id": 3319
    },
    {
        "id": 331903,
        "name_th": "หนองงูเหลือม",
        "name_en": "Nong Ngu Lueam",
        "zip_codes": [
            33110
        ],
        "district_id": 3319
    },
    {
        "id": 331904,
        "name_th": "หนองฮาง",
        "name_en": "Nong Hang",
        "zip_codes": [
            33110
        ],
        "district_id": 3319
    },
    {
        "id": 331905,
        "name_th": "ท่าคล้อ",
        "name_en": "Tha Khlo",
        "zip_codes": [
            33110
        ],
        "district_id": 3319
    },
    {
        "id": 332001,
        "name_th": "พยุห์",
        "name_en": "Phayu",
        "zip_codes": [
            33230
        ],
        "district_id": 3320
    },
    {
        "id": 332002,
        "name_th": "พรหมสวัสดิ์",
        "name_en": "Phrom Sawat",
        "zip_codes": [
            33230
        ],
        "district_id": 3320
    },
    {
        "id": 332003,
        "name_th": "ตำแย",
        "name_en": "Tamyae",
        "zip_codes": [
            33230
        ],
        "district_id": 3320
    },
    {
        "id": 332004,
        "name_th": "โนนเพ็ก",
        "name_en": "Nong Phek",
        "zip_codes": [
            33230
        ],
        "district_id": 3320
    },
    {
        "id": 332005,
        "name_th": "หนองค้า",
        "name_en": "Nong Kha",
        "zip_codes": [
            33230
        ],
        "district_id": 3320
    },
    {
        "id": 332101,
        "name_th": "โดด",
        "name_en": "Dot",
        "zip_codes": [
            33120
        ],
        "district_id": 3321
    },
    {
        "id": 332102,
        "name_th": "เสียว",
        "name_en": "Siao",
        "zip_codes": [
            33120
        ],
        "district_id": 3321
    },
    {
        "id": 332103,
        "name_th": "หนองม้า",
        "name_en": "Nong Ma",
        "zip_codes": [
            33120
        ],
        "district_id": 3321
    },
    {
        "id": 332104,
        "name_th": "ผือใหญ่",
        "name_en": "Phue Yai",
        "zip_codes": [
            33120
        ],
        "district_id": 3321
    },
    {
        "id": 332105,
        "name_th": "อีเซ",
        "name_en": "I Se",
        "zip_codes": [
            33120
        ],
        "district_id": 3321
    },
    {
        "id": 332201,
        "name_th": "กุง",
        "name_en": "Kung",
        "zip_codes": [
            33160
        ],
        "district_id": 3322
    },
    {
        "id": 332202,
        "name_th": "คลีกลิ้ง",
        "name_en": "Khli Kling",
        "zip_codes": [
            33160
        ],
        "district_id": 3322
    },
    {
        "id": 332203,
        "name_th": "หนองบัวดง",
        "name_en": "Nong Bua Dong",
        "zip_codes": [
            33160
        ],
        "district_id": 3322
    },
    {
        "id": 332204,
        "name_th": "โจดม่วง",
        "name_en": "Chot Muang",
        "zip_codes": [
            33160
        ],
        "district_id": 3322
    },
    {
        "id": 340101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340104,
        "name_th": "หัวเรือ",
        "name_en": "Hua Ruea",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340105,
        "name_th": "หนองขอน",
        "name_en": "Nong Khon",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340107,
        "name_th": "ปทุม",
        "name_en": "Pathum",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340108,
        "name_th": "ขามใหญ่",
        "name_en": "Kham Yai",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340109,
        "name_th": "แจระแม",
        "name_en": "Chaeramae",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340111,
        "name_th": "หนองบ่อ",
        "name_en": "Nong Bo",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340112,
        "name_th": "ไร่น้อย",
        "name_en": "Rai Noi",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340113,
        "name_th": "กระโสบ",
        "name_en": "Krasop",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340116,
        "name_th": "กุดลาด",
        "name_en": "Kut Lat",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340119,
        "name_th": "ขี้เหล็ก",
        "name_en": "Khilek",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340120,
        "name_th": "ปะอาว",
        "name_en": "Pa-ao",
        "zip_codes": [
            34000
        ],
        "district_id": 3401
    },
    {
        "id": 340201,
        "name_th": "นาคำ",
        "name_en": "Na Kham",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340202,
        "name_th": "แก้งกอก",
        "name_en": "Kaeng Kok",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340203,
        "name_th": "เอือดใหญ่",
        "name_en": "Ueat Yai",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340204,
        "name_th": "วาริน",
        "name_en": "Warin",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340205,
        "name_th": "ลาดควาย",
        "name_en": "Lat Khwai",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340206,
        "name_th": "สงยาง",
        "name_en": "Song Yang",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340207,
        "name_th": "ตะบ่าย",
        "name_en": "Tabai",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340208,
        "name_th": "คำไหล",
        "name_en": "Kham Lai",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340209,
        "name_th": "หนามแท่ง",
        "name_en": "Nam Thaeng",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340210,
        "name_th": "นาเลิน",
        "name_en": "Na Loen",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340211,
        "name_th": "ดอนใหญ่",
        "name_en": "Don Yai",
        "zip_codes": [
            34250
        ],
        "district_id": 3402
    },
    {
        "id": 340301,
        "name_th": "โขงเจียม",
        "name_en": "Khong Chiam",
        "zip_codes": [
            34220
        ],
        "district_id": 3403
    },
    {
        "id": 340302,
        "name_th": "ห้วยยาง",
        "name_en": "Huai Yang",
        "zip_codes": [
            34220
        ],
        "district_id": 3403
    },
    {
        "id": 340303,
        "name_th": "นาโพธิ์กลาง",
        "name_en": "Na Pho Klang",
        "zip_codes": [
            34220
        ],
        "district_id": 3403
    },
    {
        "id": 340304,
        "name_th": "หนองแสงใหญ่",
        "name_en": "Nong Saeng Yai",
        "zip_codes": [
            34220
        ],
        "district_id": 3403
    },
    {
        "id": 340305,
        "name_th": "ห้วยไผ่",
        "name_en": "Huai Phai",
        "zip_codes": [
            34220
        ],
        "district_id": 3403
    },
    {
        "id": 340401,
        "name_th": "เขื่องใน",
        "name_en": "Khueang Nai",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340402,
        "name_th": "สร้างถ่อ",
        "name_en": "Sang Tho",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340403,
        "name_th": "ค้อทอง",
        "name_en": "Kho Thong",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340404,
        "name_th": "ก่อเอ้",
        "name_en": "Ko E",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340405,
        "name_th": "หัวดอน",
        "name_en": "Hua Don",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340406,
        "name_th": "ชีทวน",
        "name_en": "Chi Thuan",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340407,
        "name_th": "ท่าไห",
        "name_en": "Tha Hai",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340408,
        "name_th": "นาคำใหญ่",
        "name_en": "Na Kham Yai",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340409,
        "name_th": "แดงหม้อ",
        "name_en": "Daeng Mo",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340410,
        "name_th": "ธาตุน้อย",
        "name_en": "That Noi",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340411,
        "name_th": "บ้านไทย",
        "name_en": "Ban Thai",
        "zip_codes": [
            34320
        ],
        "district_id": 3404
    },
    {
        "id": 340412,
        "name_th": "บ้านกอก",
        "name_en": "Ban Kok",
        "zip_codes": [
            34320
        ],
        "district_id": 3404
    },
    {
        "id": 340413,
        "name_th": "กลางใหญ่",
        "name_en": "Klang Yai",
        "zip_codes": [
            34320
        ],
        "district_id": 3404
    },
    {
        "id": 340414,
        "name_th": "โนนรัง",
        "name_en": "Non Rang",
        "zip_codes": [
            34320
        ],
        "district_id": 3404
    },
    {
        "id": 340415,
        "name_th": "ยางขี้นก",
        "name_en": "Yang Khi Nok",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340416,
        "name_th": "ศรีสุข",
        "name_en": "Si Suk",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340417,
        "name_th": "สหธาตุ",
        "name_en": "Sahathat",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340418,
        "name_th": "หนองเหล่า",
        "name_en": "Nong Lao",
        "zip_codes": [
            34150
        ],
        "district_id": 3404
    },
    {
        "id": 340501,
        "name_th": "เขมราฐ",
        "name_en": "Khemarat",
        "zip_codes": [
            34170
        ],
        "district_id": 3405
    },
    {
        "id": 340503,
        "name_th": "ขามป้อม",
        "name_en": "Kham Pom",
        "zip_codes": [
            34170
        ],
        "district_id": 3405
    },
    {
        "id": 340504,
        "name_th": "เจียด",
        "name_en": "Chiat",
        "zip_codes": [
            34170
        ],
        "district_id": 3405
    },
    {
        "id": 340507,
        "name_th": "หนองผือ",
        "name_en": "Nong Phue",
        "zip_codes": [
            34170
        ],
        "district_id": 3405
    },
    {
        "id": 340508,
        "name_th": "นาแวง",
        "name_en": "Na Waeng",
        "zip_codes": [
            34170
        ],
        "district_id": 3405
    },
    {
        "id": 340510,
        "name_th": "แก้งเหนือ",
        "name_en": "Kaeng Nuea",
        "zip_codes": [
            34170
        ],
        "district_id": 3405
    },
    {
        "id": 340511,
        "name_th": "หนองนกทา",
        "name_en": "Nong Nok Tha",
        "zip_codes": [
            34170
        ],
        "district_id": 3405
    },
    {
        "id": 340512,
        "name_th": "หนองสิม",
        "name_en": "Nong Sim",
        "zip_codes": [
            34170
        ],
        "district_id": 3405
    },
    {
        "id": 340513,
        "name_th": "หัวนา",
        "name_en": "Hua Na",
        "zip_codes": [
            34170
        ],
        "district_id": 3405
    },
    {
        "id": 340701,
        "name_th": "เมืองเดช",
        "name_en": "Mueang Det",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340702,
        "name_th": "นาส่วง",
        "name_en": "Na Suang",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340704,
        "name_th": "นาเจริญ",
        "name_en": "Na Charoen",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340706,
        "name_th": "ทุ่งเทิง",
        "name_en": "Thung Thoeng",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340708,
        "name_th": "สมสะอาด",
        "name_en": "Som Sa-at",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340709,
        "name_th": "กุดประทาย",
        "name_en": "Kut Prathai",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340710,
        "name_th": "ตบหู",
        "name_en": "Top Hu",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340711,
        "name_th": "กลาง",
        "name_en": "Klang",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340712,
        "name_th": "แก้ง",
        "name_en": "Kaeng",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340713,
        "name_th": "ท่าโพธิ์ศรี",
        "name_en": "Tha Pho Si",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340715,
        "name_th": "บัวงาม",
        "name_en": "Bua Ngam",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340716,
        "name_th": "คำครั่ง",
        "name_en": "Kham Khrang",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340717,
        "name_th": "นากระแซง",
        "name_en": "Na Krasaeng",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340720,
        "name_th": "โพนงาม",
        "name_en": "Phon Ngam",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340721,
        "name_th": "ป่าโมง",
        "name_en": "Pa Mong",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340723,
        "name_th": "โนนสมบูรณ์",
        "name_en": "Non Sombun",
        "zip_codes": [
            34160
        ],
        "district_id": 3407
    },
    {
        "id": 340801,
        "name_th": "นาจะหลวย",
        "name_en": "Na Chaluai",
        "zip_codes": [
            34280
        ],
        "district_id": 3408
    },
    {
        "id": 340802,
        "name_th": "โนนสมบูรณ์",
        "name_en": "Non Sombun",
        "zip_codes": [
            34280
        ],
        "district_id": 3408
    },
    {
        "id": 340803,
        "name_th": "พรสวรรค์",
        "name_en": "Phon Sawan",
        "zip_codes": [
            34280
        ],
        "district_id": 3408
    },
    {
        "id": 340804,
        "name_th": "บ้านตูม",
        "name_en": "Ban Tum",
        "zip_codes": [
            34280
        ],
        "district_id": 3408
    },
    {
        "id": 340805,
        "name_th": "โสกแสง",
        "name_en": "Sok Saeng",
        "zip_codes": [
            34280
        ],
        "district_id": 3408
    },
    {
        "id": 340806,
        "name_th": "โนนสวรรค์",
        "name_en": "Non Sawan",
        "zip_codes": [
            34280
        ],
        "district_id": 3408
    },
    {
        "id": 340901,
        "name_th": "โซง",
        "name_en": "Song",
        "zip_codes": [
            34260
        ],
        "district_id": 3409
    },
    {
        "id": 340903,
        "name_th": "ยาง",
        "name_en": "Yang",
        "zip_codes": [
            34260
        ],
        "district_id": 3409
    },
    {
        "id": 340904,
        "name_th": "โดมประดิษฐ์",
        "name_en": "Dom Pradit",
        "zip_codes": [
            34260
        ],
        "district_id": 3409
    },
    {
        "id": 340906,
        "name_th": "บุเปือย",
        "name_en": "Bu Pueai",
        "zip_codes": [
            34260
        ],
        "district_id": 3409
    },
    {
        "id": 340907,
        "name_th": "สีวิเชียร",
        "name_en": "Si Wichian",
        "zip_codes": [
            34260
        ],
        "district_id": 3409
    },
    {
        "id": 340909,
        "name_th": "ยางใหญ่",
        "name_en": "Yang Yai",
        "zip_codes": [
            34260
        ],
        "district_id": 3409
    },
    {
        "id": 340911,
        "name_th": "เก่าขาม",
        "name_en": "Kao Kham",
        "zip_codes": [
            34260
        ],
        "district_id": 3409
    },
    {
        "id": 341001,
        "name_th": "โพนงาม",
        "name_en": "Phon Ngam",
        "zip_codes": [
            34230
        ],
        "district_id": 3410
    },
    {
        "id": 341002,
        "name_th": "ห้วยข่า",
        "name_en": "Huai Kha",
        "zip_codes": [
            34230
        ],
        "district_id": 3410
    },
    {
        "id": 341003,
        "name_th": "คอแลน",
        "name_en": "Kho Laen",
        "zip_codes": [
            34230
        ],
        "district_id": 3410
    },
    {
        "id": 341004,
        "name_th": "นาโพธิ์",
        "name_en": "Na Pho",
        "zip_codes": [
            34230
        ],
        "district_id": 3410
    },
    {
        "id": 341005,
        "name_th": "หนองสะโน",
        "name_en": "Nong Sano",
        "zip_codes": [
            34230
        ],
        "district_id": 3410
    },
    {
        "id": 341006,
        "name_th": "โนนค้อ",
        "name_en": "Non Kho",
        "zip_codes": [
            34230
        ],
        "district_id": 3410
    },
    {
        "id": 341007,
        "name_th": "บัวงาม",
        "name_en": "Bua Ngam",
        "zip_codes": [
            34230
        ],
        "district_id": 3410
    },
    {
        "id": 341008,
        "name_th": "บ้านแมด",
        "name_en": "Ban Maet",
        "zip_codes": [
            34230
        ],
        "district_id": 3410
    },
    {
        "id": 341101,
        "name_th": "ขุหลุ",
        "name_en": "Khulu",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341102,
        "name_th": "กระเดียน",
        "name_en": "Kradian",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341103,
        "name_th": "เกษม",
        "name_en": "Kasem",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341104,
        "name_th": "กุศกร",
        "name_en": "Kutsakon",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341105,
        "name_th": "ขามเปี้ย",
        "name_en": "Kham Pia",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341106,
        "name_th": "คอนสาย",
        "name_en": "Khon Sai",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341107,
        "name_th": "โคกจาน",
        "name_en": "Khok Chan",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341108,
        "name_th": "นาพิน",
        "name_en": "Na Phin",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341109,
        "name_th": "นาสะไม",
        "name_en": "Na Samai",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341110,
        "name_th": "โนนกุง",
        "name_en": "Non Kung",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341111,
        "name_th": "ตระการ",
        "name_en": "Trakan",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341112,
        "name_th": "ตากแดด",
        "name_en": "Tak Daet",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341113,
        "name_th": "ไหล่ทุ่ง",
        "name_en": "Lai Thung",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341114,
        "name_th": "เป้า",
        "name_en": "Pao",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341115,
        "name_th": "เซเป็ด",
        "name_en": "Se Pet",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341116,
        "name_th": "สะพือ",
        "name_en": "Saphue",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341117,
        "name_th": "หนองเต่า",
        "name_en": "Nong Tao",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341118,
        "name_th": "ถ้ำแข้",
        "name_en": "Tham Khae",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341119,
        "name_th": "ท่าหลวง",
        "name_en": "Tha Luang",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341120,
        "name_th": "ห้วยฝ้ายพัฒนา",
        "name_en": "Huai Fai Phatthana",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341121,
        "name_th": "กุดยาลวน",
        "name_en": "Kut Ya Luan",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341122,
        "name_th": "บ้านแดง",
        "name_en": "Ban Daeng",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341123,
        "name_th": "คำเจริญ",
        "name_en": "Kham Charoen",
        "zip_codes": [
            34130
        ],
        "district_id": 3411
    },
    {
        "id": 341201,
        "name_th": "ข้าวปุ้น",
        "name_en": "Khao Pun",
        "zip_codes": [
            34270
        ],
        "district_id": 3412
    },
    {
        "id": 341202,
        "name_th": "โนนสวาง",
        "name_en": "Non Sawang",
        "zip_codes": [
            34270
        ],
        "district_id": 3412
    },
    {
        "id": 341203,
        "name_th": "แก่งเค็ง",
        "name_en": "Kaeng Kheng",
        "zip_codes": [
            34270
        ],
        "district_id": 3412
    },
    {
        "id": 341204,
        "name_th": "กาบิน",
        "name_en": "Ka Bin",
        "zip_codes": [
            34270
        ],
        "district_id": 3412
    },
    {
        "id": 341205,
        "name_th": "หนองทันน้ำ",
        "name_en": "Nong Than Nam",
        "zip_codes": [
            34270
        ],
        "district_id": 3412
    },
    {
        "id": 341401,
        "name_th": "ม่วงสามสิบ",
        "name_en": "Muang Sam Sip",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341402,
        "name_th": "เหล่าบก",
        "name_en": "Lao Bok",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341403,
        "name_th": "ดุมใหญ่",
        "name_en": "Dum Yai",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341404,
        "name_th": "หนองช้างใหญ่",
        "name_en": "Nong Chang Yai",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341405,
        "name_th": "หนองเมือง",
        "name_en": "Nong Mueang",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341406,
        "name_th": "เตย",
        "name_en": "Toei",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341407,
        "name_th": "ยางสักกระโพหลุ่ม",
        "name_en": "Yang Sak Krapho Lum",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341408,
        "name_th": "หนองไข่นก",
        "name_en": "Nong Khai Nok",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341409,
        "name_th": "หนองเหล่า",
        "name_en": "Nong Lao",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341410,
        "name_th": "หนองฮาง",
        "name_en": "Nong Hang",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341411,
        "name_th": "ยางโยภาพ",
        "name_en": "Yang Yo Phap",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341412,
        "name_th": "ไผ่ใหญ่",
        "name_en": "Phai Yai",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341413,
        "name_th": "นาเลิง",
        "name_en": "Na Loeng",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341414,
        "name_th": "โพนแพง",
        "name_en": "Phon Phaeng",
        "zip_codes": [
            34140
        ],
        "district_id": 3414
    },
    {
        "id": 341501,
        "name_th": "วารินชำราบ",
        "name_en": "Warin Chamrap",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341502,
        "name_th": "ธาตุ",
        "name_en": "That",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341504,
        "name_th": "ท่าลาด",
        "name_en": "Tha Lat",
        "zip_codes": [
            34310
        ],
        "district_id": 3415
    },
    {
        "id": 341505,
        "name_th": "โนนโหนน",
        "name_en": "Non Non",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341507,
        "name_th": "คูเมือง",
        "name_en": "Khu Mueang",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341508,
        "name_th": "สระสมิง",
        "name_en": "Sa Saming",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341510,
        "name_th": "คำน้ำแซบ",
        "name_en": "Kham Nam Saep",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341511,
        "name_th": "บุ่งหวาย",
        "name_en": "Bung Wai",
        "zip_codes": [
            34310
        ],
        "district_id": 3415
    },
    {
        "id": 341515,
        "name_th": "คำขวาง",
        "name_en": "Kham Khwang",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341516,
        "name_th": "โพธิ์ใหญ่",
        "name_en": "Pho Yai",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341518,
        "name_th": "แสนสุข",
        "name_en": "Saen Suk",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341520,
        "name_th": "หนองกินเพล",
        "name_en": "Nong Kin Phen",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341521,
        "name_th": "โนนผึ้ง",
        "name_en": "Non Phueng",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341522,
        "name_th": "เมืองศรีไค",
        "name_en": "Mueang Si Khai",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341524,
        "name_th": "ห้วยขะยุง",
        "name_en": "Huai Khayung",
        "zip_codes": [
            34310
        ],
        "district_id": 3415
    },
    {
        "id": 341526,
        "name_th": "บุ่งไหม",
        "name_en": "Bung Mai",
        "zip_codes": [
            34190
        ],
        "district_id": 3415
    },
    {
        "id": 341901,
        "name_th": "พิบูล",
        "name_en": "Phibun",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341902,
        "name_th": "กุดชมภู",
        "name_en": "Kut Chomphu",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341904,
        "name_th": "ดอนจิก",
        "name_en": "Don Chik",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341905,
        "name_th": "ทรายมูล",
        "name_en": "Sai Mun",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341906,
        "name_th": "นาโพธิ์",
        "name_en": "Na Pho",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341907,
        "name_th": "โนนกลาง",
        "name_en": "Non Klang",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341909,
        "name_th": "โพธิ์ไทร",
        "name_en": "Pho Sai",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341910,
        "name_th": "โพธิ์ศรี",
        "name_en": "Pho Si",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341911,
        "name_th": "ระเว",
        "name_en": "Rawe",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341912,
        "name_th": "ไร่ใต้",
        "name_en": "Rai Tai",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341913,
        "name_th": "หนองบัวฮี",
        "name_en": "Nong Bua Hi",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341914,
        "name_th": "อ่างศิลา",
        "name_en": "Ang Sila",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341918,
        "name_th": "โนนกาหลง",
        "name_en": "Non Kalong",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 341919,
        "name_th": "บ้านแขม",
        "name_en": "Ban Khaem",
        "zip_codes": [
            34110
        ],
        "district_id": 3419
    },
    {
        "id": 342001,
        "name_th": "ตาลสุม",
        "name_en": "Tan Sum",
        "zip_codes": [
            34330
        ],
        "district_id": 3420
    },
    {
        "id": 342002,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            34330
        ],
        "district_id": 3420
    },
    {
        "id": 342003,
        "name_th": "จิกเทิง",
        "name_en": "Chik Thoeng",
        "zip_codes": [
            34330
        ],
        "district_id": 3420
    },
    {
        "id": 342004,
        "name_th": "หนองกุง",
        "name_en": "Nong Kung",
        "zip_codes": [
            34330
        ],
        "district_id": 3420
    },
    {
        "id": 342005,
        "name_th": "นาคาย",
        "name_en": "Na Khai",
        "zip_codes": [
            34330
        ],
        "district_id": 3420
    },
    {
        "id": 342006,
        "name_th": "คำหว้า",
        "name_en": "Kham Wa",
        "zip_codes": [
            34330
        ],
        "district_id": 3420
    },
    {
        "id": 342101,
        "name_th": "โพธิ์ไทร",
        "name_en": "Pho Sai",
        "zip_codes": [
            34340
        ],
        "district_id": 3421
    },
    {
        "id": 342102,
        "name_th": "ม่วงใหญ่",
        "name_en": "Muang Yai",
        "zip_codes": [
            34340
        ],
        "district_id": 3421
    },
    {
        "id": 342103,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            34340
        ],
        "district_id": 3421
    },
    {
        "id": 342104,
        "name_th": "สองคอน",
        "name_en": "Song Khon",
        "zip_codes": [
            34340
        ],
        "district_id": 3421
    },
    {
        "id": 342105,
        "name_th": "สารภี",
        "name_en": "Saraphi",
        "zip_codes": [
            34340
        ],
        "district_id": 3421
    },
    {
        "id": 342106,
        "name_th": "เหล่างาม",
        "name_en": "Lao Ngam",
        "zip_codes": [
            34340
        ],
        "district_id": 3421
    },
    {
        "id": 342201,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            34360
        ],
        "district_id": 3422
    },
    {
        "id": 342202,
        "name_th": "โคกก่อง",
        "name_en": "Khok Kong",
        "zip_codes": [
            34360
        ],
        "district_id": 3422
    },
    {
        "id": 342203,
        "name_th": "หนองไฮ",
        "name_en": "Nong Hai",
        "zip_codes": [
            34360
        ],
        "district_id": 3422
    },
    {
        "id": 342204,
        "name_th": "ค้อน้อย",
        "name_en": "Kho Noi",
        "zip_codes": [
            34360
        ],
        "district_id": 3422
    },
    {
        "id": 342205,
        "name_th": "โนนกาเล็น",
        "name_en": "Non Ka Len",
        "zip_codes": [
            34360
        ],
        "district_id": 3422
    },
    {
        "id": 342206,
        "name_th": "โคกสว่าง",
        "name_en": "Khok Sawang",
        "zip_codes": [
            34360
        ],
        "district_id": 3422
    },
    {
        "id": 342207,
        "name_th": "โนนกลาง",
        "name_en": "Non Klang",
        "zip_codes": [
            34360
        ],
        "district_id": 3422
    },
    {
        "id": 342208,
        "name_th": "บอน",
        "name_en": "Bon",
        "zip_codes": [
            34360
        ],
        "district_id": 3422
    },
    {
        "id": 342209,
        "name_th": "ขามป้อม",
        "name_en": "Kham Pom",
        "zip_codes": [
            34360
        ],
        "district_id": 3422
    },
    {
        "id": 342401,
        "name_th": "ดอนมดแดง",
        "name_en": "Don Mot Daeng",
        "zip_codes": [
            34000
        ],
        "district_id": 3424
    },
    {
        "id": 342402,
        "name_th": "เหล่าแดง",
        "name_en": "Lao Daeng",
        "zip_codes": [
            34000
        ],
        "district_id": 3424
    },
    {
        "id": 342403,
        "name_th": "ท่าเมือง",
        "name_en": "Tha Muaeng",
        "zip_codes": [
            34000
        ],
        "district_id": 3424
    },
    {
        "id": 342404,
        "name_th": "คำไฮใหญ่",
        "name_en": "Kham Hai Yai",
        "zip_codes": [
            34000
        ],
        "district_id": 3424
    },
    {
        "id": 342501,
        "name_th": "คันไร่",
        "name_en": "Khan Rai",
        "zip_codes": [
            34350
        ],
        "district_id": 3425
    },
    {
        "id": 342502,
        "name_th": "ช่องเม็ก",
        "name_en": "Chong Mek",
        "zip_codes": [
            34350
        ],
        "district_id": 3425
    },
    {
        "id": 342503,
        "name_th": "โนนก่อ",
        "name_en": "Non Ko",
        "zip_codes": [
            34350
        ],
        "district_id": 3425
    },
    {
        "id": 342504,
        "name_th": "นิคมสร้างตนเองลำโดมน้อย",
        "name_en": "Nikhom Sang Ton-eng Lam Dom Noi",
        "zip_codes": [
            34350
        ],
        "district_id": 3425
    },
    {
        "id": 342505,
        "name_th": "ฝางคำ",
        "name_en": "Fang Kham",
        "zip_codes": [
            34350
        ],
        "district_id": 3425
    },
    {
        "id": 342506,
        "name_th": "คำเขื่อนแก้ว",
        "name_en": "Kham Khuean Kaeo",
        "zip_codes": [
            34350
        ],
        "district_id": 3425
    },
    {
        "id": 342602,
        "name_th": "หนองอ้ม",
        "name_en": "Nong Om",
        "zip_codes": [
            34160
        ],
        "district_id": 3426
    },
    {
        "id": 342603,
        "name_th": "นาเกษม",
        "name_en": "Na Kasem",
        "zip_codes": [
            34160
        ],
        "district_id": 3426
    },
    {
        "id": 342604,
        "name_th": "กุดเรือ",
        "name_en": "Kut Ruea",
        "zip_codes": [
            34160
        ],
        "district_id": 3426
    },
    {
        "id": 342605,
        "name_th": "โคกชำแระ",
        "name_en": "Khok Chamrae",
        "zip_codes": [
            34160
        ],
        "district_id": 3426
    },
    {
        "id": 342606,
        "name_th": "นาห่อม",
        "name_en": "Na Hom",
        "zip_codes": [
            34160
        ],
        "district_id": 3426
    },
    {
        "id": 342901,
        "name_th": "นาเยีย",
        "name_en": "Na Yia",
        "zip_codes": [
            34160
        ],
        "district_id": 3429
    },
    {
        "id": 342902,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            34160
        ],
        "district_id": 3429
    },
    {
        "id": 342903,
        "name_th": "นาเรือง",
        "name_en": "Na Rueang",
        "zip_codes": [
            34160
        ],
        "district_id": 3429
    },
    {
        "id": 343001,
        "name_th": "นาตาล",
        "name_en": "Na Tan",
        "zip_codes": [
            34170
        ],
        "district_id": 3430
    },
    {
        "id": 343002,
        "name_th": "พะลาน",
        "name_en": "Phalan",
        "zip_codes": [
            34170
        ],
        "district_id": 3430
    },
    {
        "id": 343003,
        "name_th": "กองโพน",
        "name_en": "Kong Phon",
        "zip_codes": [
            34170
        ],
        "district_id": 3430
    },
    {
        "id": 343004,
        "name_th": "พังเคน",
        "name_en": "Phang Khen",
        "zip_codes": [
            34170
        ],
        "district_id": 3430
    },
    {
        "id": 343101,
        "name_th": "เหล่าเสือโก้ก",
        "name_en": "Lao Suea Kok",
        "zip_codes": [
            34000
        ],
        "district_id": 3431
    },
    {
        "id": 343102,
        "name_th": "โพนเมือง",
        "name_en": "Phon Mueang",
        "zip_codes": [
            34000
        ],
        "district_id": 3431
    },
    {
        "id": 343103,
        "name_th": "แพงใหญ่",
        "name_en": "Phaeng Yai",
        "zip_codes": [
            34000
        ],
        "district_id": 3431
    },
    {
        "id": 343104,
        "name_th": "หนองบก",
        "name_en": "Nong Bok",
        "zip_codes": [
            34000
        ],
        "district_id": 3431
    },
    {
        "id": 343201,
        "name_th": "แก่งโดม",
        "name_en": "Kaeng Dom",
        "zip_codes": [
            34190
        ],
        "district_id": 3432
    },
    {
        "id": 343202,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            34190
        ],
        "district_id": 3432
    },
    {
        "id": 343203,
        "name_th": "บุ่งมะแลง",
        "name_en": "Bung Malaeng",
        "zip_codes": [
            34190
        ],
        "district_id": 3432
    },
    {
        "id": 343204,
        "name_th": "สว่าง",
        "name_en": "Sawang",
        "zip_codes": [
            34190
        ],
        "district_id": 3432
    },
    {
        "id": 343301,
        "name_th": "ตาเกา",
        "name_en": "Ta Kao",
        "zip_codes": [
            34260
        ],
        "district_id": 3433
    },
    {
        "id": 343302,
        "name_th": "ไพบูลย์",
        "name_en": "Phaibun",
        "zip_codes": [
            34260
        ],
        "district_id": 3433
    },
    {
        "id": 343303,
        "name_th": "ขี้เหล็ก",
        "name_en": "Khilek",
        "zip_codes": [
            34260
        ],
        "district_id": 3433
    },
    {
        "id": 343304,
        "name_th": "โคกสะอาด",
        "name_en": "Khok Sa-at",
        "zip_codes": [
            34260
        ],
        "district_id": 3433
    },
    {
        "id": 350101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350102,
        "name_th": "น้ำคำใหญ่",
        "name_en": "Nam Kham Yai",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350103,
        "name_th": "ตาดทอง",
        "name_en": "Tat Thong",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350104,
        "name_th": "สำราญ",
        "name_en": "Samran",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350105,
        "name_th": "ค้อเหนือ",
        "name_en": "Kho Nuea",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350106,
        "name_th": "ดู่ทุ่ง",
        "name_en": "Du Thung",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350107,
        "name_th": "เดิด",
        "name_en": "Doet",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350108,
        "name_th": "ขั้นไดใหญ่",
        "name_en": "Khan Dai Yai",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350109,
        "name_th": "ทุ่งแต้",
        "name_en": "Thung Tae",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350110,
        "name_th": "สิงห์",
        "name_en": "Sing",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350111,
        "name_th": "นาสะไมย์",
        "name_en": "Na Samai",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350112,
        "name_th": "เขื่องคำ",
        "name_en": "Khueang Kham",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350113,
        "name_th": "หนองหิน",
        "name_en": "Nong Hin",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350114,
        "name_th": "หนองคู",
        "name_en": "Nong Khu",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350115,
        "name_th": "ขุมเงิน",
        "name_en": "Khum Ngoen",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350116,
        "name_th": "ทุ่งนางโอก",
        "name_en": "Thung Nang Ok",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350117,
        "name_th": "หนองเรือ",
        "name_en": "Nong Ruea",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350118,
        "name_th": "หนองเป็ด",
        "name_en": "Nong Pet",
        "zip_codes": [
            35000
        ],
        "district_id": 3501
    },
    {
        "id": 350201,
        "name_th": "ทรายมูล",
        "name_en": "Sai Mun",
        "zip_codes": [
            35170
        ],
        "district_id": 3502
    },
    {
        "id": 350202,
        "name_th": "ดู่ลาด",
        "name_en": "Du Lat",
        "zip_codes": [
            35170
        ],
        "district_id": 3502
    },
    {
        "id": 350203,
        "name_th": "ดงมะไฟ",
        "name_en": "Dong Mafai",
        "zip_codes": [
            35170
        ],
        "district_id": 3502
    },
    {
        "id": 350204,
        "name_th": "นาเวียง",
        "name_en": "Na Wiang",
        "zip_codes": [
            35170
        ],
        "district_id": 3502
    },
    {
        "id": 350205,
        "name_th": "ไผ่",
        "name_en": "Phai",
        "zip_codes": [
            35170
        ],
        "district_id": 3502
    },
    {
        "id": 350301,
        "name_th": "กุดชุม",
        "name_en": "Kut Chum",
        "zip_codes": [
            35140
        ],
        "district_id": 3503
    },
    {
        "id": 350302,
        "name_th": "โนนเปือย",
        "name_en": "Non Pueai",
        "zip_codes": [
            35140
        ],
        "district_id": 3503
    },
    {
        "id": 350303,
        "name_th": "กำแมด",
        "name_en": "Kammaet",
        "zip_codes": [
            35140
        ],
        "district_id": 3503
    },
    {
        "id": 350304,
        "name_th": "นาโส่",
        "name_en": "Na So",
        "zip_codes": [
            35140
        ],
        "district_id": 3503
    },
    {
        "id": 350305,
        "name_th": "ห้วยแก้ง",
        "name_en": "Huai Kaeng",
        "zip_codes": [
            35140
        ],
        "district_id": 3503
    },
    {
        "id": 350306,
        "name_th": "หนองหมี",
        "name_en": "Nong Mi",
        "zip_codes": [
            35140
        ],
        "district_id": 3503
    },
    {
        "id": 350307,
        "name_th": "โพนงาม",
        "name_en": "Phon Ngam",
        "zip_codes": [
            35140
        ],
        "district_id": 3503
    },
    {
        "id": 350308,
        "name_th": "คำน้ำสร้าง",
        "name_en": "Kham Nam Sang",
        "zip_codes": [
            35140
        ],
        "district_id": 3503
    },
    {
        "id": 350309,
        "name_th": "หนองแหน",
        "name_en": "Nong Nae",
        "zip_codes": [
            35140
        ],
        "district_id": 3503
    },
    {
        "id": 350401,
        "name_th": "ลุมพุก",
        "name_en": "Lumphuk",
        "zip_codes": [
            35110
        ],
        "district_id": 3504
    },
    {
        "id": 350402,
        "name_th": "ย่อ",
        "name_en": "Yo",
        "zip_codes": [
            35110
        ],
        "district_id": 3504
    },
    {
        "id": 350403,
        "name_th": "สงเปือย",
        "name_en": "Song Pueai",
        "zip_codes": [
            35110
        ],
        "district_id": 3504
    },
    {
        "id": 350404,
        "name_th": "โพนทัน",
        "name_en": "Phon Than",
        "zip_codes": [
            35110
        ],
        "district_id": 3504
    },
    {
        "id": 350405,
        "name_th": "ทุ่งมน",
        "name_en": "Thung Mon",
        "zip_codes": [
            35110
        ],
        "district_id": 3504
    },
    {
        "id": 350406,
        "name_th": "นาคำ",
        "name_en": "Na Kham",
        "zip_codes": [
            35180
        ],
        "district_id": 3504
    },
    {
        "id": 350407,
        "name_th": "ดงแคนใหญ่",
        "name_en": "Dong Khaen Yai",
        "zip_codes": [
            35180
        ],
        "district_id": 3504
    },
    {
        "id": 350408,
        "name_th": "กู่จาน",
        "name_en": "Ku Chan",
        "zip_codes": [
            35110
        ],
        "district_id": 3504
    },
    {
        "id": 350409,
        "name_th": "นาแก",
        "name_en": "Na Kae",
        "zip_codes": [
            35180
        ],
        "district_id": 3504
    },
    {
        "id": 350410,
        "name_th": "กุดกุง",
        "name_en": "Kut Kung",
        "zip_codes": [
            35110
        ],
        "district_id": 3504
    },
    {
        "id": 350411,
        "name_th": "เหล่าไฮ",
        "name_en": "Lao Hai",
        "zip_codes": [
            35110
        ],
        "district_id": 3504
    },
    {
        "id": 350412,
        "name_th": "แคนน้อย",
        "name_en": "Khaen Noi",
        "zip_codes": [
            35180
        ],
        "district_id": 3504
    },
    {
        "id": 350413,
        "name_th": "ดงเจริญ",
        "name_en": "Dong Charoen",
        "zip_codes": [
            35110
        ],
        "district_id": 3504
    },
    {
        "id": 350501,
        "name_th": "โพธิ์ไทร",
        "name_en": "Pho Sai",
        "zip_codes": [
            35150
        ],
        "district_id": 3505
    },
    {
        "id": 350502,
        "name_th": "กระจาย",
        "name_en": "Krachai",
        "zip_codes": [
            35150
        ],
        "district_id": 3505
    },
    {
        "id": 350503,
        "name_th": "โคกนาโก",
        "name_en": "Khok Na Ko",
        "zip_codes": [
            35150
        ],
        "district_id": 3505
    },
    {
        "id": 350504,
        "name_th": "เชียงเพ็ง",
        "name_en": "Chiang Pheng",
        "zip_codes": [
            35150
        ],
        "district_id": 3505
    },
    {
        "id": 350505,
        "name_th": "ศรีฐาน",
        "name_en": "Si Than",
        "zip_codes": [
            35150
        ],
        "district_id": 3505
    },
    {
        "id": 350601,
        "name_th": "ฟ้าหยาด",
        "name_en": "Fa Yat",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350602,
        "name_th": "หัวเมือง",
        "name_en": "Hua Mueang",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350603,
        "name_th": "คูเมือง",
        "name_en": "Khu Mueang",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350604,
        "name_th": "ผือฮี",
        "name_en": "Phue Hi",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350605,
        "name_th": "บากเรือ",
        "name_en": "Bak Ruea",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350606,
        "name_th": "ม่วง",
        "name_en": "Muang",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350607,
        "name_th": "โนนทราย",
        "name_en": "Non Sai",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350608,
        "name_th": "บึงแก",
        "name_en": "Bueng Kae",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350609,
        "name_th": "พระเสาร์",
        "name_en": "Phra Sao",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350610,
        "name_th": "สงยาง",
        "name_en": "Song Yang",
        "zip_codes": [
            35130
        ],
        "district_id": 3506
    },
    {
        "id": 350701,
        "name_th": "ฟ้าห่วน",
        "name_en": "Fa Huan",
        "zip_codes": [
            35160
        ],
        "district_id": 3507
    },
    {
        "id": 350702,
        "name_th": "กุดน้ำใส",
        "name_en": "Kut Nam Sai",
        "zip_codes": [
            35160
        ],
        "district_id": 3507
    },
    {
        "id": 350703,
        "name_th": "น้ำอ้อม",
        "name_en": "Nam Om",
        "zip_codes": [
            35160
        ],
        "district_id": 3507
    },
    {
        "id": 350704,
        "name_th": "ค้อวัง",
        "name_en": "Kho Wang",
        "zip_codes": [
            35160
        ],
        "district_id": 3507
    },
    {
        "id": 350802,
        "name_th": "บุ่งค้า",
        "name_en": "Bung Kha",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350803,
        "name_th": "สวาท",
        "name_en": "Sawat",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350805,
        "name_th": "ห้องแซง",
        "name_en": "Hong Saeng",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350806,
        "name_th": "สามัคคี",
        "name_en": "Samakkhi",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350807,
        "name_th": "กุดเชียงหมี",
        "name_en": "Kut Chiang Mi",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350810,
        "name_th": "สามแยก",
        "name_en": "Sam Yaek",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350811,
        "name_th": "กุดแห่",
        "name_en": "Kut Hae",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350812,
        "name_th": "โคกสำราญ",
        "name_en": "Khok Samran",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350813,
        "name_th": "สร้างมิ่ง",
        "name_en": "Sang Ming",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350814,
        "name_th": "ศรีแก้ว",
        "name_en": "Si Kaeo",
        "zip_codes": [
            35120
        ],
        "district_id": 3508
    },
    {
        "id": 350901,
        "name_th": "ไทยเจริญ",
        "name_en": "Thai Charoen",
        "zip_codes": [
            35120
        ],
        "district_id": 3509
    },
    {
        "id": 350902,
        "name_th": "น้ำคำ",
        "name_en": "Nam Kham",
        "zip_codes": [
            35120
        ],
        "district_id": 3509
    },
    {
        "id": 350903,
        "name_th": "ส้มผ่อ",
        "name_en": "Som Pho",
        "zip_codes": [
            35120
        ],
        "district_id": 3509
    },
    {
        "id": 350904,
        "name_th": "คำเตย",
        "name_en": "Kham Toei",
        "zip_codes": [
            35120
        ],
        "district_id": 3509
    },
    {
        "id": 350905,
        "name_th": "คำไผ่",
        "name_en": "Kham Phai",
        "zip_codes": [
            35120
        ],
        "district_id": 3509
    },
    {
        "id": 360101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360102,
        "name_th": "รอบเมือง",
        "name_en": "Rop Mueang",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360103,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360104,
        "name_th": "นาฝาย",
        "name_en": "Na Fai",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360105,
        "name_th": "บ้านค่าย",
        "name_en": "Ban Khai",
        "zip_codes": [
            36240
        ],
        "district_id": 3601
    },
    {
        "id": 360106,
        "name_th": "กุดตุ้ม",
        "name_en": "Kut Tum",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360107,
        "name_th": "ชีลอง",
        "name_en": "Chi Long",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360108,
        "name_th": "บ้านเล่า",
        "name_en": "Ban Lao",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360109,
        "name_th": "นาเสียว",
        "name_en": "Na Siao",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360110,
        "name_th": "หนองนาแซง",
        "name_en": "Nong Na Saeng",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360111,
        "name_th": "ลาดใหญ่",
        "name_en": "Lat Yai",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360112,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            36240
        ],
        "district_id": 3601
    },
    {
        "id": 360113,
        "name_th": "ท่าหินโงม",
        "name_en": "Tha Hin Ngom",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360114,
        "name_th": "ห้วยต้อน",
        "name_en": "Huai Ton",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360115,
        "name_th": "ห้วยบง",
        "name_en": "Huai Bong",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360116,
        "name_th": "โนนสำราญ",
        "name_en": "Non Samran",
        "zip_codes": [
            36240
        ],
        "district_id": 3601
    },
    {
        "id": 360117,
        "name_th": "โคกสูง",
        "name_en": "Khok Sung",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360118,
        "name_th": "บุ่งคล้า",
        "name_en": "Bung Khla",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360119,
        "name_th": "ซับสีทอง",
        "name_en": "Sap Si Thong",
        "zip_codes": [
            36000
        ],
        "district_id": 3601
    },
    {
        "id": 360201,
        "name_th": "บ้านเขว้า",
        "name_en": "Ban Khwao",
        "zip_codes": [
            36170
        ],
        "district_id": 3602
    },
    {
        "id": 360202,
        "name_th": "ตลาดแร้ง",
        "name_en": "Talat Raeng",
        "zip_codes": [
            36170
        ],
        "district_id": 3602
    },
    {
        "id": 360203,
        "name_th": "ลุ่มลำชี",
        "name_en": "Lum Lam Chi",
        "zip_codes": [
            36170
        ],
        "district_id": 3602
    },
    {
        "id": 360204,
        "name_th": "ชีบน",
        "name_en": "Chi Bon",
        "zip_codes": [
            36170
        ],
        "district_id": 3602
    },
    {
        "id": 360205,
        "name_th": "ภูแลนคา",
        "name_en": "Phu Laen Kha",
        "zip_codes": [
            36170
        ],
        "district_id": 3602
    },
    {
        "id": 360206,
        "name_th": "โนนแดง",
        "name_en": "Non Daeng",
        "zip_codes": [
            36170
        ],
        "district_id": 3602
    },
    {
        "id": 360301,
        "name_th": "คอนสวรรค์",
        "name_en": "Khon Sawan",
        "zip_codes": [
            36140
        ],
        "district_id": 3603
    },
    {
        "id": 360302,
        "name_th": "ยางหวาย",
        "name_en": "Yang Wai",
        "zip_codes": [
            36140
        ],
        "district_id": 3603
    },
    {
        "id": 360303,
        "name_th": "ช่องสามหมอ",
        "name_en": "Chong Sam Mo",
        "zip_codes": [
            36140
        ],
        "district_id": 3603
    },
    {
        "id": 360304,
        "name_th": "โนนสะอาด",
        "name_en": "Non Sa-at",
        "zip_codes": [
            36140
        ],
        "district_id": 3603
    },
    {
        "id": 360305,
        "name_th": "ห้วยไร่",
        "name_en": "Huai Rai",
        "zip_codes": [
            36140
        ],
        "district_id": 3603
    },
    {
        "id": 360306,
        "name_th": "บ้านโสก",
        "name_en": "Ban Sok",
        "zip_codes": [
            36140
        ],
        "district_id": 3603
    },
    {
        "id": 360307,
        "name_th": "โคกมั่งงอย",
        "name_en": "Khok Mang Ngoi",
        "zip_codes": [
            36140
        ],
        "district_id": 3603
    },
    {
        "id": 360308,
        "name_th": "หนองขาม",
        "name_en": "Nong Kham",
        "zip_codes": [
            36140
        ],
        "district_id": 3603
    },
    {
        "id": 360309,
        "name_th": "ศรีสำราญ",
        "name_en": "Si Samran",
        "zip_codes": [
            36140
        ],
        "district_id": 3603
    },
    {
        "id": 360401,
        "name_th": "บ้านยาง",
        "name_en": "Ban Yang",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360402,
        "name_th": "บ้านหัน",
        "name_en": "Ban Han",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360403,
        "name_th": "บ้านเดื่อ",
        "name_en": "Ban Duea",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360404,
        "name_th": "บ้านเป้า",
        "name_en": "Ban Pao",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360405,
        "name_th": "กุดเลาะ",
        "name_en": "Kut Lo",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360406,
        "name_th": "โนนกอก",
        "name_en": "Non Kok",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360407,
        "name_th": "สระโพนทอง",
        "name_en": "Sa Phon Thong",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360408,
        "name_th": "หนองข่า",
        "name_en": "Nong Kha",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360409,
        "name_th": "หนองโพนงาม",
        "name_en": "Nong Phon Ngam",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360410,
        "name_th": "บ้านบัว",
        "name_en": "Ban Bua",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360412,
        "name_th": "โนนทอง",
        "name_en": "Non Thong",
        "zip_codes": [
            36120
        ],
        "district_id": 3604
    },
    {
        "id": 360501,
        "name_th": "หนองบัวแดง",
        "name_en": "Nong Bua Daeng",
        "zip_codes": [
            36210
        ],
        "district_id": 3605
    },
    {
        "id": 360502,
        "name_th": "กุดชุมแสง",
        "name_en": "Kut Chum Saeng",
        "zip_codes": [
            36210
        ],
        "district_id": 3605
    },
    {
        "id": 360503,
        "name_th": "ถ้ำวัวแดง",
        "name_en": "Tham Wua Daeng",
        "zip_codes": [
            36210
        ],
        "district_id": 3605
    },
    {
        "id": 360504,
        "name_th": "นางแดด",
        "name_en": "Nang Daet",
        "zip_codes": [
            36210
        ],
        "district_id": 3605
    },
    {
        "id": 360507,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            36210
        ],
        "district_id": 3605
    },
    {
        "id": 360508,
        "name_th": "คูเมือง",
        "name_en": "Khu Mueang",
        "zip_codes": [
            36210
        ],
        "district_id": 3605
    },
    {
        "id": 360509,
        "name_th": "ท่าใหญ่",
        "name_en": "Tha Yai",
        "zip_codes": [
            36210
        ],
        "district_id": 3605
    },
    {
        "id": 360511,
        "name_th": "วังชมภู",
        "name_en": "Wang Chomphu",
        "zip_codes": [
            36210
        ],
        "district_id": 3605
    },
    {
        "id": 360601,
        "name_th": "บ้านกอก",
        "name_en": "Ban Kok",
        "zip_codes": [
            36130
        ],
        "district_id": 3606
    },
    {
        "id": 360602,
        "name_th": "หนองบัวบาน",
        "name_en": "Nong Bua Ban",
        "zip_codes": [
            36130
        ],
        "district_id": 3606
    },
    {
        "id": 360603,
        "name_th": "บ้านขาม",
        "name_en": "Ban Kham",
        "zip_codes": [
            36130
        ],
        "district_id": 3606
    },
    {
        "id": 360605,
        "name_th": "กุดน้ำใส",
        "name_en": "Kut Nam Sai",
        "zip_codes": [
            36130
        ],
        "district_id": 3606
    },
    {
        "id": 360606,
        "name_th": "หนองโดน",
        "name_en": "Nong Don",
        "zip_codes": [
            36130
        ],
        "district_id": 3606
    },
    {
        "id": 360607,
        "name_th": "ละหาน",
        "name_en": "Lahan",
        "zip_codes": [
            36130
        ],
        "district_id": 3606
    },
    {
        "id": 360610,
        "name_th": "หนองบัวใหญ่",
        "name_en": "Nong Bua Yai",
        "zip_codes": [
            36130
        ],
        "district_id": 3606
    },
    {
        "id": 360611,
        "name_th": "หนองบัวโคก",
        "name_en": "Nong Bua Khok",
        "zip_codes": [
            36220
        ],
        "district_id": 3606
    },
    {
        "id": 360613,
        "name_th": "ส้มป่อย",
        "name_en": "Som Poi",
        "zip_codes": [
            36130
        ],
        "district_id": 3606
    },
    {
        "id": 360701,
        "name_th": "บ้านชวน",
        "name_en": "Ban Chuan",
        "zip_codes": [
            36160
        ],
        "district_id": 3607
    },
    {
        "id": 360702,
        "name_th": "บ้านเพชร",
        "name_en": "Ban Phet",
        "zip_codes": [
            36160
        ],
        "district_id": 3607
    },
    {
        "id": 360703,
        "name_th": "บ้านตาล",
        "name_en": "Ban Tan",
        "zip_codes": [
            36220
        ],
        "district_id": 3607
    },
    {
        "id": 360704,
        "name_th": "หัวทะเล",
        "name_en": "Hua Thale",
        "zip_codes": [
            36220
        ],
        "district_id": 3607
    },
    {
        "id": 360705,
        "name_th": "โคกเริงรมย์",
        "name_en": "Khok Roeng Rom",
        "zip_codes": [
            36160
        ],
        "district_id": 3607
    },
    {
        "id": 360706,
        "name_th": "เกาะมะนาว",
        "name_en": "Ko Manao",
        "zip_codes": [
            36160
        ],
        "district_id": 3607
    },
    {
        "id": 360707,
        "name_th": "โคกเพชรพัฒนา",
        "name_en": "Khok Phet Phatthana",
        "zip_codes": [
            36160
        ],
        "district_id": 3607
    },
    {
        "id": 360801,
        "name_th": "หนองบัวระเหว",
        "name_en": "Nong Bua Rawe",
        "zip_codes": [
            36250
        ],
        "district_id": 3608
    },
    {
        "id": 360802,
        "name_th": "วังตะเฆ่",
        "name_en": "Wang Takhe",
        "zip_codes": [
            36250
        ],
        "district_id": 3608
    },
    {
        "id": 360803,
        "name_th": "ห้วยแย้",
        "name_en": "Huai Yae",
        "zip_codes": [
            36250
        ],
        "district_id": 3608
    },
    {
        "id": 360804,
        "name_th": "โคกสะอาด",
        "name_en": "Khok Sa-at",
        "zip_codes": [
            36250
        ],
        "district_id": 3608
    },
    {
        "id": 360805,
        "name_th": "โสกปลาดุก",
        "name_en": "Sok Pla Duk",
        "zip_codes": [
            36250
        ],
        "district_id": 3608
    },
    {
        "id": 360901,
        "name_th": "วะตะแบก",
        "name_en": "Wa Tabaek",
        "zip_codes": [
            36230
        ],
        "district_id": 3609
    },
    {
        "id": 360902,
        "name_th": "ห้วยยายจิ๋ว",
        "name_en": "Huai Yai Chio",
        "zip_codes": [
            36230
        ],
        "district_id": 3609
    },
    {
        "id": 360903,
        "name_th": "นายางกลัก",
        "name_en": "Na yang Klak",
        "zip_codes": [
            36230
        ],
        "district_id": 3609
    },
    {
        "id": 360904,
        "name_th": "บ้านไร่",
        "name_en": "Ban Rai",
        "zip_codes": [
            36230
        ],
        "district_id": 3609
    },
    {
        "id": 360905,
        "name_th": "โป่งนก",
        "name_en": "Pong Nok",
        "zip_codes": [
            36230
        ],
        "district_id": 3609
    },
    {
        "id": 361001,
        "name_th": "ผักปัง",
        "name_en": "Phak Pang",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361002,
        "name_th": "กวางโจน",
        "name_en": "Kwang Chon",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361003,
        "name_th": "หนองคอนไทย",
        "name_en": "Nong Khon Thai",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361004,
        "name_th": "บ้านแก้ง",
        "name_en": "Ban Kaeng",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361005,
        "name_th": "กุดยม",
        "name_en": "Kut Yom",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361006,
        "name_th": "บ้านเพชร",
        "name_en": "Ban Phet",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361007,
        "name_th": "โคกสะอาด",
        "name_en": "Khok Sa-at",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361008,
        "name_th": "หนองตูม",
        "name_en": "Nong Tum",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361009,
        "name_th": "โอโล",
        "name_en": "Olo",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361010,
        "name_th": "ธาตุทอง",
        "name_en": "That Thong",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361011,
        "name_th": "บ้านดอน",
        "name_en": "Ban Don",
        "zip_codes": [
            36110
        ],
        "district_id": 3610
    },
    {
        "id": 361101,
        "name_th": "บ้านแท่น",
        "name_en": "Ban Thaen",
        "zip_codes": [
            36190
        ],
        "district_id": 3611
    },
    {
        "id": 361102,
        "name_th": "สามสวน",
        "name_en": "Sam Suan",
        "zip_codes": [
            36190
        ],
        "district_id": 3611
    },
    {
        "id": 361103,
        "name_th": "สระพัง",
        "name_en": "Sa Phang",
        "zip_codes": [
            36190
        ],
        "district_id": 3611
    },
    {
        "id": 361104,
        "name_th": "บ้านเต่า",
        "name_en": "Ban Tao",
        "zip_codes": [
            36190
        ],
        "district_id": 3611
    },
    {
        "id": 361105,
        "name_th": "หนองคู",
        "name_en": "Nong Khu",
        "zip_codes": [
            36190
        ],
        "district_id": 3611
    },
    {
        "id": 361201,
        "name_th": "ช่องสามหมอ",
        "name_en": "Chong Sam Mo",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361202,
        "name_th": "หนองขาม",
        "name_en": "Nong Kham",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361203,
        "name_th": "นาหนองทุ่ม",
        "name_en": "Na Nong Thum",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361204,
        "name_th": "บ้านแก้ง",
        "name_en": "Ban Kaeng",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361205,
        "name_th": "หนองสังข์",
        "name_en": "Nong Sang",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361206,
        "name_th": "หลุบคา",
        "name_en": "Lup Kha",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361207,
        "name_th": "โคกกุง",
        "name_en": "Khok Kung",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361208,
        "name_th": "เก่าย่าดี",
        "name_en": "Kao Ya Di",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361209,
        "name_th": "ท่ามะไฟหวาน",
        "name_en": "Tha Mafai Wan",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361210,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            36150
        ],
        "district_id": 3612
    },
    {
        "id": 361301,
        "name_th": "คอนสาร",
        "name_en": "Khon San",
        "zip_codes": [
            36180
        ],
        "district_id": 3613
    },
    {
        "id": 361302,
        "name_th": "ทุ่งพระ",
        "name_en": "Thung Phra",
        "zip_codes": [
            36180
        ],
        "district_id": 3613
    },
    {
        "id": 361303,
        "name_th": "โนนคูณ",
        "name_en": "Non Khun",
        "zip_codes": [
            36180
        ],
        "district_id": 3613
    },
    {
        "id": 361304,
        "name_th": "ห้วยยาง",
        "name_en": "Huai Yang",
        "zip_codes": [
            36180
        ],
        "district_id": 3613
    },
    {
        "id": 361305,
        "name_th": "ทุ่งลุยลาย",
        "name_en": "Thung Luilai",
        "zip_codes": [
            36180
        ],
        "district_id": 3613
    },
    {
        "id": 361306,
        "name_th": "ดงบัง",
        "name_en": "Dong Bang",
        "zip_codes": [
            36180
        ],
        "district_id": 3613
    },
    {
        "id": 361307,
        "name_th": "ทุ่งนาเลา",
        "name_en": "Thung Na Lao",
        "zip_codes": [
            36180
        ],
        "district_id": 3613
    },
    {
        "id": 361308,
        "name_th": "ดงกลาง",
        "name_en": "Dong Klang",
        "zip_codes": [
            36180
        ],
        "district_id": 3613
    },
    {
        "id": 361401,
        "name_th": "บ้านเจียง",
        "name_en": "Ban Chiang",
        "zip_codes": [
            36260
        ],
        "district_id": 3614
    },
    {
        "id": 361402,
        "name_th": "เจาทอง",
        "name_en": "Chao Thong",
        "zip_codes": [
            36260
        ],
        "district_id": 3614
    },
    {
        "id": 361403,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "zip_codes": [
            36260
        ],
        "district_id": 3614
    },
    {
        "id": 361404,
        "name_th": "แหลมทอง",
        "name_en": "Laem Thong",
        "zip_codes": [
            36260
        ],
        "district_id": 3614
    },
    {
        "id": 361501,
        "name_th": "หนองฉิม",
        "name_en": "Nong Chim",
        "zip_codes": [
            36130
        ],
        "district_id": 3615
    },
    {
        "id": 361502,
        "name_th": "ตาเนิน",
        "name_en": "Ta Noen",
        "zip_codes": [
            36130
        ],
        "district_id": 3615
    },
    {
        "id": 361503,
        "name_th": "กะฮาด",
        "name_en": "Kahat",
        "zip_codes": [
            36130
        ],
        "district_id": 3615
    },
    {
        "id": 361504,
        "name_th": "รังงาม",
        "name_en": "Rang Ngam",
        "zip_codes": [
            36130
        ],
        "district_id": 3615
    },
    {
        "id": 361601,
        "name_th": "ซับใหญ่",
        "name_en": "Sap Yai",
        "zip_codes": [
            36130
        ],
        "district_id": 3616
    },
    {
        "id": 361602,
        "name_th": "ท่ากูบ",
        "name_en": "Tha Kup",
        "zip_codes": [
            36130
        ],
        "district_id": 3616
    },
    {
        "id": 361603,
        "name_th": "ตะโกทอง",
        "name_en": "Tako Thong",
        "zip_codes": [
            36130
        ],
        "district_id": 3616
    },
    {
        "id": 370101,
        "name_th": "บุ่ง",
        "name_en": "Bung",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370102,
        "name_th": "ไก่คำ",
        "name_en": "Kai Kham",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370103,
        "name_th": "นาจิก",
        "name_en": "Na Chik",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370104,
        "name_th": "ปลาค้าว",
        "name_en": "Pla Khao",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370105,
        "name_th": "เหล่าพรวน",
        "name_en": "Lao Phruan",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370106,
        "name_th": "สร้างนกทา",
        "name_en": "Sang Nok Tha",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370107,
        "name_th": "คึมใหญ่",
        "name_en": "Khuem Yai",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370108,
        "name_th": "นาผือ",
        "name_en": "Na Phue",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370109,
        "name_th": "น้ำปลีก",
        "name_en": "Nam Plik",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370110,
        "name_th": "นาวัง",
        "name_en": "Na Wang",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370111,
        "name_th": "นาหมอม้า",
        "name_en": "Na Mo Ma",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370112,
        "name_th": "โนนโพธิ์",
        "name_en": "Non Pho",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370113,
        "name_th": "โนนหนามแท่ง",
        "name_en": "Non Nam Thaeng",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370114,
        "name_th": "ห้วยไร่",
        "name_en": "Huai Rai",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370115,
        "name_th": "หนองมะแซว",
        "name_en": "Nong Masaeo",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370116,
        "name_th": "กุดปลาดุก",
        "name_en": "Kut Pla Duk",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370117,
        "name_th": "ดอนเมย",
        "name_en": "Don Moei",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370118,
        "name_th": "นายม",
        "name_en": "Na Yom",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370119,
        "name_th": "นาแต้",
        "name_en": "Na Tae",
        "zip_codes": [
            37000
        ],
        "district_id": 3701
    },
    {
        "id": 370201,
        "name_th": "ชานุมาน",
        "name_en": "Chanuman",
        "zip_codes": [
            37210
        ],
        "district_id": 3702
    },
    {
        "id": 370202,
        "name_th": "โคกสาร",
        "name_en": "Khok San",
        "zip_codes": [
            37210
        ],
        "district_id": 3702
    },
    {
        "id": 370203,
        "name_th": "คำเขื่อนแก้ว",
        "name_en": "Kham Khuean Kaeo",
        "zip_codes": [
            37210
        ],
        "district_id": 3702
    },
    {
        "id": 370204,
        "name_th": "โคกก่ง",
        "name_en": "Khok Kong",
        "zip_codes": [
            37210
        ],
        "district_id": 3702
    },
    {
        "id": 370205,
        "name_th": "ป่าก่อ",
        "name_en": "Pa Ko",
        "zip_codes": [
            37210
        ],
        "district_id": 3702
    },
    {
        "id": 370301,
        "name_th": "หนองข่า",
        "name_en": "Nong Kha",
        "zip_codes": [
            37110
        ],
        "district_id": 3703
    },
    {
        "id": 370302,
        "name_th": "คำโพน",
        "name_en": "Kham Phon",
        "zip_codes": [
            37110
        ],
        "district_id": 3703
    },
    {
        "id": 370303,
        "name_th": "นาหว้า",
        "name_en": "Na Wa",
        "zip_codes": [
            37110
        ],
        "district_id": 3703
    },
    {
        "id": 370304,
        "name_th": "ลือ",
        "name_en": "Lue",
        "zip_codes": [
            37110
        ],
        "district_id": 3703
    },
    {
        "id": 370305,
        "name_th": "ห้วย",
        "name_en": "Huai",
        "zip_codes": [
            37110
        ],
        "district_id": 3703
    },
    {
        "id": 370306,
        "name_th": "โนนงาม",
        "name_en": "Non Ngam",
        "zip_codes": [
            37110
        ],
        "district_id": 3703
    },
    {
        "id": 370307,
        "name_th": "นาป่าแซง",
        "name_en": "Na Pa Saeng",
        "zip_codes": [
            37110
        ],
        "district_id": 3703
    },
    {
        "id": 370401,
        "name_th": "พนา",
        "name_en": "Phana",
        "zip_codes": [
            37180
        ],
        "district_id": 3704
    },
    {
        "id": 370402,
        "name_th": "จานลาน",
        "name_en": "Chan Lan",
        "zip_codes": [
            37180
        ],
        "district_id": 3704
    },
    {
        "id": 370403,
        "name_th": "ไม้กลอน",
        "name_en": "Mai Klon",
        "zip_codes": [
            37180
        ],
        "district_id": 3704
    },
    {
        "id": 370404,
        "name_th": "พระเหลา",
        "name_en": "Phra Lao",
        "zip_codes": [
            37180
        ],
        "district_id": 3704
    },
    {
        "id": 370501,
        "name_th": "เสนางคนิคม",
        "name_en": "Senangkhanikhom",
        "zip_codes": [
            37290
        ],
        "district_id": 3705
    },
    {
        "id": 370502,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            37290
        ],
        "district_id": 3705
    },
    {
        "id": 370503,
        "name_th": "ไร่สีสุก",
        "name_en": "Rai Si Suk",
        "zip_codes": [
            37290
        ],
        "district_id": 3705
    },
    {
        "id": 370504,
        "name_th": "นาเวียง",
        "name_en": "Na Wiang",
        "zip_codes": [
            37290
        ],
        "district_id": 3705
    },
    {
        "id": 370505,
        "name_th": "หนองไฮ",
        "name_en": "Nong Hai",
        "zip_codes": [
            37290
        ],
        "district_id": 3705
    },
    {
        "id": 370506,
        "name_th": "หนองสามสี",
        "name_en": "Nong Sam Si",
        "zip_codes": [
            37290
        ],
        "district_id": 3705
    },
    {
        "id": 370601,
        "name_th": "หัวตะพาน",
        "name_en": "Hua Taphan",
        "zip_codes": [
            37240
        ],
        "district_id": 3706
    },
    {
        "id": 370602,
        "name_th": "คำพระ",
        "name_en": "Kham Phra",
        "zip_codes": [
            37240
        ],
        "district_id": 3706
    },
    {
        "id": 370603,
        "name_th": "เค็งใหญ่",
        "name_en": "Kheng Yai",
        "zip_codes": [
            37240
        ],
        "district_id": 3706
    },
    {
        "id": 370604,
        "name_th": "หนองแก้ว",
        "name_en": "Nong Kaeo",
        "zip_codes": [
            37240
        ],
        "district_id": 3706
    },
    {
        "id": 370605,
        "name_th": "โพนเมืองน้อย",
        "name_en": "Phon Mueang Noi",
        "zip_codes": [
            37240
        ],
        "district_id": 3706
    },
    {
        "id": 370606,
        "name_th": "สร้างถ่อน้อย",
        "name_en": "Sang Tho Noi",
        "zip_codes": [
            37240
        ],
        "district_id": 3706
    },
    {
        "id": 370607,
        "name_th": "จิกดู่",
        "name_en": "Chik Du",
        "zip_codes": [
            37240
        ],
        "district_id": 3706
    },
    {
        "id": 370608,
        "name_th": "รัตนวารี",
        "name_en": "Rattanawari",
        "zip_codes": [
            37240
        ],
        "district_id": 3706
    },
    {
        "id": 370701,
        "name_th": "อำนาจ",
        "name_en": "amnat",
        "zip_codes": [
            37120
        ],
        "district_id": 3707
    },
    {
        "id": 370702,
        "name_th": "ดงมะยาง",
        "name_en": "Dong Mayang",
        "zip_codes": [
            37120
        ],
        "district_id": 3707
    },
    {
        "id": 370703,
        "name_th": "เปือย",
        "name_en": "Pueai",
        "zip_codes": [
            37120
        ],
        "district_id": 3707
    },
    {
        "id": 370704,
        "name_th": "ดงบัง",
        "name_en": "Dong Bang",
        "zip_codes": [
            37120
        ],
        "district_id": 3707
    },
    {
        "id": 370705,
        "name_th": "ไร่ขี",
        "name_en": "Rai Khi",
        "zip_codes": [
            37120
        ],
        "district_id": 3707
    },
    {
        "id": 370706,
        "name_th": "แมด",
        "name_en": "Maet",
        "zip_codes": [
            37120
        ],
        "district_id": 3707
    },
    {
        "id": 370707,
        "name_th": "โคกกลาง",
        "name_en": "Khok Klang",
        "zip_codes": [
            37120
        ],
        "district_id": 3707
    },
    {
        "id": 380101,
        "name_th": "บึงกาฬ",
        "name_en": "Bueng Kan",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380102,
        "name_th": "โนนสมบูรณ์",
        "name_en": "Non Sombun",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380103,
        "name_th": "โนนสว่าง",
        "name_en": "Non Sawang",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380104,
        "name_th": "หอคำ",
        "name_en": "Ho Kham",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380105,
        "name_th": "หนองเลิง",
        "name_en": "Nong Loeng",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380106,
        "name_th": "โคกก่อง",
        "name_en": "Khok Kong",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380107,
        "name_th": "นาสวรรค์",
        "name_en": "Na Sawan",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380108,
        "name_th": "ไคสี",
        "name_en": "Khai Si",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380109,
        "name_th": "ชัยพร",
        "name_en": "Chaiyaphon",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380110,
        "name_th": "วิศิษฐ์",
        "name_en": "Wisit",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380111,
        "name_th": "คำนาดี",
        "name_en": "Kham Na Di",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380112,
        "name_th": "โป่งเปือย",
        "name_en": "Pong Pueai",
        "zip_codes": [
            38000
        ],
        "district_id": 3801
    },
    {
        "id": 380201,
        "name_th": "ศรีชมภู",
        "name_en": "Si Chomphu",
        "zip_codes": [
            38180
        ],
        "district_id": 3802
    },
    {
        "id": 380202,
        "name_th": "ดอนหญ้านาง",
        "name_en": "Don Ya Nang",
        "zip_codes": [
            38180
        ],
        "district_id": 3802
    },
    {
        "id": 380203,
        "name_th": "พรเจริญ",
        "name_en": "Phon Charoen",
        "zip_codes": [
            38180
        ],
        "district_id": 3802
    },
    {
        "id": 380204,
        "name_th": "หนองหัวช้าง",
        "name_en": "Nong Hua Chang",
        "zip_codes": [
            38180
        ],
        "district_id": 3802
    },
    {
        "id": 380205,
        "name_th": "วังชมภู",
        "name_en": "Wang Chomphu",
        "zip_codes": [
            38180
        ],
        "district_id": 3802
    },
    {
        "id": 380206,
        "name_th": "ป่าแฝก",
        "name_en": "Pa Faek",
        "zip_codes": [
            38180
        ],
        "district_id": 3802
    },
    {
        "id": 380207,
        "name_th": "ศรีสำราญ",
        "name_en": "Si Samran",
        "zip_codes": [
            38180
        ],
        "district_id": 3802
    },
    {
        "id": 380301,
        "name_th": "โซ่",
        "name_en": "So",
        "zip_codes": [
            38170
        ],
        "district_id": 3803
    },
    {
        "id": 380302,
        "name_th": "หนองพันทา",
        "name_en": "Nong Phan Tha",
        "zip_codes": [
            38170
        ],
        "district_id": 3803
    },
    {
        "id": 380303,
        "name_th": "ศรีชมภู",
        "name_en": "Si Chomphu",
        "zip_codes": [
            38170
        ],
        "district_id": 3803
    },
    {
        "id": 380304,
        "name_th": "คำแก้ว",
        "name_en": "Kham Kaeo",
        "zip_codes": [
            38170
        ],
        "district_id": 3803
    },
    {
        "id": 380305,
        "name_th": "บัวตูม",
        "name_en": "Bua Tum",
        "zip_codes": [
            38170
        ],
        "district_id": 3803
    },
    {
        "id": 380306,
        "name_th": "ถ้ำเจริญ",
        "name_en": "Tham Charoen",
        "zip_codes": [
            38170
        ],
        "district_id": 3803
    },
    {
        "id": 380307,
        "name_th": "เหล่าทอง",
        "name_en": "Lao Thong",
        "zip_codes": [
            38170
        ],
        "district_id": 3803
    },
    {
        "id": 380401,
        "name_th": "เซกา",
        "name_en": "Seka",
        "zip_codes": [
            38150
        ],
        "district_id": 3804
    },
    {
        "id": 380402,
        "name_th": "ซาง",
        "name_en": "Sang",
        "zip_codes": [
            38150
        ],
        "district_id": 3804
    },
    {
        "id": 380403,
        "name_th": "ท่ากกแดง",
        "name_en": "Tha Kok Daeng",
        "zip_codes": [
            38150
        ],
        "district_id": 3804
    },
    {
        "id": 380404,
        "name_th": "บ้านต้อง",
        "name_en": "Ban Tong",
        "zip_codes": [
            38150
        ],
        "district_id": 3804
    },
    {
        "id": 380405,
        "name_th": "ป่งไฮ",
        "name_en": "Pong Hai",
        "zip_codes": [
            38150
        ],
        "district_id": 3804
    },
    {
        "id": 380406,
        "name_th": "น้ำจั้น",
        "name_en": "Nam Chan",
        "zip_codes": [
            38150
        ],
        "district_id": 3804
    },
    {
        "id": 380407,
        "name_th": "ท่าสะอาด",
        "name_en": "Tha Sa-at",
        "zip_codes": [
            38150
        ],
        "district_id": 3804
    },
    {
        "id": 380408,
        "name_th": "หนองทุ่ม",
        "name_en": "Nong Thum",
        "zip_codes": [
            38150
        ],
        "district_id": 3804
    },
    {
        "id": 380409,
        "name_th": "โสกก่าม",
        "name_en": "Sok Kam",
        "zip_codes": [
            38150
        ],
        "district_id": 3804
    },
    {
        "id": 380501,
        "name_th": "ปากคาด",
        "name_en": "Pak Khat",
        "zip_codes": [
            38190
        ],
        "district_id": 3805
    },
    {
        "id": 380502,
        "name_th": "หนองยอง",
        "name_en": "Nong Yong",
        "zip_codes": [
            38190
        ],
        "district_id": 3805
    },
    {
        "id": 380503,
        "name_th": "นากั้ง",
        "name_en": "Na Kang",
        "zip_codes": [
            38190
        ],
        "district_id": 3805
    },
    {
        "id": 380504,
        "name_th": "โนนศิลา",
        "name_en": "Non Sila",
        "zip_codes": [
            38190
        ],
        "district_id": 3805
    },
    {
        "id": 380505,
        "name_th": "สมสนุก",
        "name_en": "Som Sanuk",
        "zip_codes": [
            38190
        ],
        "district_id": 3805
    },
    {
        "id": 380506,
        "name_th": "นาดง",
        "name_en": "Na Dong",
        "zip_codes": [
            38190
        ],
        "district_id": 3805
    },
    {
        "id": 380601,
        "name_th": "บึงโขงหลง",
        "name_en": "Bueng Khong Long",
        "zip_codes": [
            38220
        ],
        "district_id": 3806
    },
    {
        "id": 380602,
        "name_th": "โพธิ์หมากแข้ง",
        "name_en": "Pho Mak Khaeng",
        "zip_codes": [
            38220
        ],
        "district_id": 3806
    },
    {
        "id": 380603,
        "name_th": "ดงบัง",
        "name_en": "Dong Bang",
        "zip_codes": [
            38220
        ],
        "district_id": 3806
    },
    {
        "id": 380604,
        "name_th": "ท่าดอกคำ",
        "name_en": "Tha Dok Kham",
        "zip_codes": [
            38220
        ],
        "district_id": 3806
    },
    {
        "id": 380701,
        "name_th": "ศรีวิไล",
        "name_en": "Si Wilai",
        "zip_codes": [
            38210
        ],
        "district_id": 3807
    },
    {
        "id": 380702,
        "name_th": "ชุมภูพร",
        "name_en": "Chumphu Phon",
        "zip_codes": [
            38210
        ],
        "district_id": 3807
    },
    {
        "id": 380703,
        "name_th": "นาแสง",
        "name_en": "Na Saeng",
        "zip_codes": [
            38210
        ],
        "district_id": 3807
    },
    {
        "id": 380704,
        "name_th": "นาสะแบง",
        "name_en": "Na Sabaeng",
        "zip_codes": [
            38210
        ],
        "district_id": 3807
    },
    {
        "id": 380705,
        "name_th": "นาสิงห์",
        "name_en": "Na Sing",
        "zip_codes": [
            38210
        ],
        "district_id": 3807
    },
    {
        "id": 380801,
        "name_th": "บุ่งคล้า",
        "name_en": "Bung Khla",
        "zip_codes": [
            38000
        ],
        "district_id": 3808
    },
    {
        "id": 380802,
        "name_th": "หนองเดิ่น",
        "name_en": "Nong Doen",
        "zip_codes": [
            38000
        ],
        "district_id": 3808
    },
    {
        "id": 380803,
        "name_th": "โคกกว้าง",
        "name_en": "Khok Kwang",
        "zip_codes": [
            38000
        ],
        "district_id": 3808
    },
    {
        "id": 390101,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390102,
        "name_th": "หนองภัยศูนย์",
        "name_en": "Nong Phai Sun",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390103,
        "name_th": "โพธิ์ชัย",
        "name_en": "Pho Chai",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390104,
        "name_th": "หนองสวรรค์",
        "name_en": "Nong Sawan",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390105,
        "name_th": "หัวนา",
        "name_en": "Hua Na",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390106,
        "name_th": "บ้านขาม",
        "name_en": "Ban Kham",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390107,
        "name_th": "นามะเฟือง",
        "name_en": "Na Mafueang",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390108,
        "name_th": "บ้านพร้าว",
        "name_en": "Ban Phrao",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390109,
        "name_th": "โนนขมิ้น",
        "name_en": "Non Khamin",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390110,
        "name_th": "ลำภู",
        "name_en": "Lumphu",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390111,
        "name_th": "กุดจิก",
        "name_en": "Kut Chik",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390112,
        "name_th": "โนนทัน",
        "name_en": "Non Than",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390113,
        "name_th": "นาคำไฮ",
        "name_en": "Na Kham Hai",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390114,
        "name_th": "ป่าไม้งาม",
        "name_en": "Pa Mai Ngam",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390115,
        "name_th": "หนองหว้า",
        "name_en": "Nong Wa",
        "zip_codes": [
            39000
        ],
        "district_id": 3901
    },
    {
        "id": 390201,
        "name_th": "นากลาง",
        "name_en": "Na Klang",
        "zip_codes": [
            39170
        ],
        "district_id": 3902
    },
    {
        "id": 390202,
        "name_th": "ด่านช้าง",
        "name_en": "Dan Chang",
        "zip_codes": [
            39170
        ],
        "district_id": 3902
    },
    {
        "id": 390205,
        "name_th": "กุดดินจี่",
        "name_en": "Kut Din Chi",
        "zip_codes": [
            39350
        ],
        "district_id": 3902
    },
    {
        "id": 390206,
        "name_th": "ฝั่งแดง",
        "name_en": "Fang Daeng",
        "zip_codes": [
            39170
        ],
        "district_id": 3902
    },
    {
        "id": 390207,
        "name_th": "เก่ากลอย",
        "name_en": "Kao Kloi",
        "zip_codes": [
            39350
        ],
        "district_id": 3902
    },
    {
        "id": 390209,
        "name_th": "โนนเมือง",
        "name_en": "Non Mueang",
        "zip_codes": [
            39170
        ],
        "district_id": 3902
    },
    {
        "id": 390210,
        "name_th": "อุทัยสวรรค์",
        "name_en": "Uthai Sawan",
        "zip_codes": [
            39170
        ],
        "district_id": 3902
    },
    {
        "id": 390211,
        "name_th": "ดงสวรรค์",
        "name_en": "Dong Sawan",
        "zip_codes": [
            39350
        ],
        "district_id": 3902
    },
    {
        "id": 390213,
        "name_th": "กุดแห่",
        "name_en": "Kut Hae",
        "zip_codes": [
            39170
        ],
        "district_id": 3902
    },
    {
        "id": 390301,
        "name_th": "โนนสัง",
        "name_en": "Non Sang",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390302,
        "name_th": "บ้านถิ่น",
        "name_en": "Ban Thin",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390303,
        "name_th": "หนองเรือ",
        "name_en": "Nong Ruea",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390304,
        "name_th": "กุดดู่",
        "name_en": "Kut Du",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390305,
        "name_th": "บ้านค้อ",
        "name_en": "Ban Kho",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390306,
        "name_th": "โนนเมือง",
        "name_en": "Non Mueang",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390307,
        "name_th": "โคกใหญ่",
        "name_en": "Khok Yai",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390308,
        "name_th": "โคกม่วง",
        "name_en": "Khok Muang",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390309,
        "name_th": "นิคมพัฒนา",
        "name_en": "Nikhom Phatthana",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390310,
        "name_th": "ปางกู่",
        "name_en": "Pang Ku",
        "zip_codes": [
            39140
        ],
        "district_id": 3903
    },
    {
        "id": 390401,
        "name_th": "เมืองใหม่",
        "name_en": "Mueang Mai",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390402,
        "name_th": "ศรีบุญเรือง",
        "name_en": "Si Bun Rueang",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390403,
        "name_th": "หนองบัวใต้",
        "name_en": "Nong Bua Tai",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390404,
        "name_th": "กุดสะเทียน",
        "name_en": "Kut Sathian",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390405,
        "name_th": "นากอก",
        "name_en": "Na Kok",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390406,
        "name_th": "โนนสะอาด",
        "name_en": "Non Sa-at",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390407,
        "name_th": "ยางหล่อ",
        "name_en": "Yang Lo",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390408,
        "name_th": "โนนม่วง",
        "name_en": "Non Muang",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390409,
        "name_th": "หนองกุงแก้ว",
        "name_en": "Nong Kung Kaeo",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390410,
        "name_th": "หนองแก",
        "name_en": "Nong Kae",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390411,
        "name_th": "ทรายทอง",
        "name_en": "Sai Thong",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390412,
        "name_th": "หันนางาม",
        "name_en": "Han Na Ngam",
        "zip_codes": [
            39180
        ],
        "district_id": 3904
    },
    {
        "id": 390501,
        "name_th": "นาสี",
        "name_en": "Na Si",
        "zip_codes": [
            39270
        ],
        "district_id": 3905
    },
    {
        "id": 390502,
        "name_th": "บ้านโคก",
        "name_en": "Ban Khok",
        "zip_codes": [
            39270
        ],
        "district_id": 3905
    },
    {
        "id": 390503,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            39270
        ],
        "district_id": 3905
    },
    {
        "id": 390504,
        "name_th": "นาด่าน",
        "name_en": "Na Dan",
        "zip_codes": [
            39270
        ],
        "district_id": 3905
    },
    {
        "id": 390505,
        "name_th": "ดงมะไฟ",
        "name_en": "Dong Mafai",
        "zip_codes": [
            39270
        ],
        "district_id": 3905
    },
    {
        "id": 390506,
        "name_th": "สุวรรณคูหา",
        "name_en": "Suwannakhuha",
        "zip_codes": [
            39270
        ],
        "district_id": 3905
    },
    {
        "id": 390507,
        "name_th": "บุญทัน",
        "name_en": "Bun Than",
        "zip_codes": [
            39270
        ],
        "district_id": 3905
    },
    {
        "id": 390508,
        "name_th": "กุดผึ้ง",
        "name_en": "Kut Phueng",
        "zip_codes": [
            39270
        ],
        "district_id": 3905
    },
    {
        "id": 390601,
        "name_th": "นาเหล่า",
        "name_en": "Na Lao",
        "zip_codes": [
            39170
        ],
        "district_id": 3906
    },
    {
        "id": 390602,
        "name_th": "นาแก",
        "name_en": "Na Kae",
        "zip_codes": [
            39170
        ],
        "district_id": 3906
    },
    {
        "id": 390603,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "zip_codes": [
            39170
        ],
        "district_id": 3906
    },
    {
        "id": 390604,
        "name_th": "วังปลาป้อม",
        "name_en": "Wang Pla Pom",
        "zip_codes": [
            39170
        ],
        "district_id": 3906
    },
    {
        "id": 390605,
        "name_th": "เทพคีรี",
        "name_en": "Thep Khiri",
        "zip_codes": [
            39170
        ],
        "district_id": 3906
    },
    {
        "id": 400101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            40000,
            40002
        ],
        "district_id": 4001
    },
    {
        "id": 400102,
        "name_th": "สำราญ",
        "name_en": "Samran",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400103,
        "name_th": "โคกสี",
        "name_en": "Khok Si",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400104,
        "name_th": "ท่าพระ",
        "name_en": "Tha Phra",
        "zip_codes": [
            40260
        ],
        "district_id": 4001
    },
    {
        "id": 400105,
        "name_th": "บ้านทุ่ม",
        "name_en": "Ban Thum",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400106,
        "name_th": "เมืองเก่า",
        "name_en": "Mueang Kao",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400107,
        "name_th": "พระลับ",
        "name_en": "Phra Lap",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400108,
        "name_th": "สาวะถี",
        "name_en": "Sawathi",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400109,
        "name_th": "บ้านหว้า",
        "name_en": "Ban Wa",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400110,
        "name_th": "บ้านค้อ",
        "name_en": "Ban Kho",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400111,
        "name_th": "แดงใหญ่",
        "name_en": "Daeng Yai",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400112,
        "name_th": "ดอนช้าง",
        "name_en": "Don Chang",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400113,
        "name_th": "ดอนหัน",
        "name_en": "Don Han",
        "zip_codes": [
            40260
        ],
        "district_id": 4001
    },
    {
        "id": 400114,
        "name_th": "ศิลา",
        "name_en": "Sila",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400115,
        "name_th": "บ้านเป็ด",
        "name_en": "Ban Pet",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400116,
        "name_th": "หนองตูม",
        "name_en": "Nong Tum",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400117,
        "name_th": "บึงเนียม",
        "name_en": "Bueng Niam",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400118,
        "name_th": "โนนท่อน",
        "name_en": "Non Thon",
        "zip_codes": [
            40000
        ],
        "district_id": 4001
    },
    {
        "id": 400201,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            40270
        ],
        "district_id": 4002
    },
    {
        "id": 400202,
        "name_th": "ป่าหวายนั่ง",
        "name_en": "Pa Wai Nang",
        "zip_codes": [
            40270
        ],
        "district_id": 4002
    },
    {
        "id": 400203,
        "name_th": "โนนฆ้อง",
        "name_en": "Non Khong",
        "zip_codes": [
            40270
        ],
        "district_id": 4002
    },
    {
        "id": 400204,
        "name_th": "บ้านเหล่า",
        "name_en": "Ban Lao",
        "zip_codes": [
            40270
        ],
        "district_id": 4002
    },
    {
        "id": 400205,
        "name_th": "ป่ามะนาว",
        "name_en": "Pa Manao",
        "zip_codes": [
            40270
        ],
        "district_id": 4002
    },
    {
        "id": 400206,
        "name_th": "บ้านฝาง",
        "name_en": "Ban Fang",
        "zip_codes": [
            40270
        ],
        "district_id": 4002
    },
    {
        "id": 400207,
        "name_th": "โคกงาม",
        "name_en": "Khok Ngam",
        "zip_codes": [
            40270
        ],
        "district_id": 4002
    },
    {
        "id": 400301,
        "name_th": "พระยืน",
        "name_en": "Phra Yuen",
        "zip_codes": [
            40320
        ],
        "district_id": 4003
    },
    {
        "id": 400302,
        "name_th": "พระบุ",
        "name_en": "Phra Bu",
        "zip_codes": [
            40320
        ],
        "district_id": 4003
    },
    {
        "id": 400303,
        "name_th": "บ้านโต้น",
        "name_en": "Ban Ton",
        "zip_codes": [
            40320
        ],
        "district_id": 4003
    },
    {
        "id": 400304,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            40320
        ],
        "district_id": 4003
    },
    {
        "id": 400305,
        "name_th": "ขามป้อม",
        "name_en": "Kham Pom",
        "zip_codes": [
            40320
        ],
        "district_id": 4003
    },
    {
        "id": 400401,
        "name_th": "หนองเรือ",
        "name_en": "Nong Ruea",
        "zip_codes": [
            40210
        ],
        "district_id": 4004
    },
    {
        "id": 400402,
        "name_th": "บ้านเม็ง",
        "name_en": "Ban Meng",
        "zip_codes": [
            40210
        ],
        "district_id": 4004
    },
    {
        "id": 400403,
        "name_th": "บ้านกง",
        "name_en": "Ban Kong",
        "zip_codes": [
            40240
        ],
        "district_id": 4004
    },
    {
        "id": 400404,
        "name_th": "ยางคำ",
        "name_en": "Yang Kham",
        "zip_codes": [
            40240
        ],
        "district_id": 4004
    },
    {
        "id": 400405,
        "name_th": "จระเข้",
        "name_en": "Chorakhe",
        "zip_codes": [
            40240
        ],
        "district_id": 4004
    },
    {
        "id": 400406,
        "name_th": "โนนทอง",
        "name_en": "Non Thong",
        "zip_codes": [
            40210
        ],
        "district_id": 4004
    },
    {
        "id": 400407,
        "name_th": "กุดกว้าง",
        "name_en": "Kut Kwang",
        "zip_codes": [
            40210
        ],
        "district_id": 4004
    },
    {
        "id": 400408,
        "name_th": "โนนทัน",
        "name_en": "Non Than",
        "zip_codes": [
            40210
        ],
        "district_id": 4004
    },
    {
        "id": 400409,
        "name_th": "โนนสะอาด",
        "name_en": "Non Sa-at",
        "zip_codes": [
            40210
        ],
        "district_id": 4004
    },
    {
        "id": 400410,
        "name_th": "บ้านผือ",
        "name_en": "Ban Phue",
        "zip_codes": [
            40240
        ],
        "district_id": 4004
    },
    {
        "id": 400501,
        "name_th": "ชุมแพ",
        "name_en": "Chum Phae",
        "zip_codes": [
            40130
        ],
        "district_id": 4005
    },
    {
        "id": 400502,
        "name_th": "โนนหัน",
        "name_en": "Non Han",
        "zip_codes": [
            40290
        ],
        "district_id": 4005
    },
    {
        "id": 400503,
        "name_th": "นาหนองทุ่ม",
        "name_en": "Na Nong Thum",
        "zip_codes": [
            40290
        ],
        "district_id": 4005
    },
    {
        "id": 400504,
        "name_th": "โนนอุดม",
        "name_en": "Non Udom",
        "zip_codes": [
            40130
        ],
        "district_id": 4005
    },
    {
        "id": 400505,
        "name_th": "ขัวเรียง",
        "name_en": "Khua Riang",
        "zip_codes": [
            40130
        ],
        "district_id": 4005
    },
    {
        "id": 400506,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            40130
        ],
        "district_id": 4005
    },
    {
        "id": 400507,
        "name_th": "ไชยสอ",
        "name_en": "Chai So",
        "zip_codes": [
            40130
        ],
        "district_id": 4005
    },
    {
        "id": 400508,
        "name_th": "วังหินลาด",
        "name_en": "Wang Hin Lat",
        "zip_codes": [
            40130
        ],
        "district_id": 4005
    },
    {
        "id": 400509,
        "name_th": "นาเพียง",
        "name_en": "Na Phiang",
        "zip_codes": [
            40130
        ],
        "district_id": 4005
    },
    {
        "id": 400510,
        "name_th": "หนองเขียด",
        "name_en": "Nong Khiat",
        "zip_codes": [
            40290
        ],
        "district_id": 4005
    },
    {
        "id": 400511,
        "name_th": "หนองเสาเล้า",
        "name_en": "Nong Sao Lao",
        "zip_codes": [
            40130
        ],
        "district_id": 4005
    },
    {
        "id": 400512,
        "name_th": "โนนสะอาด",
        "name_en": "Non Sa-at",
        "zip_codes": [
            40290
        ],
        "district_id": 4005
    },
    {
        "id": 400601,
        "name_th": "สีชมพู",
        "name_en": "Si Chomphu",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400602,
        "name_th": "ศรีสุข",
        "name_en": "Si Suk",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400603,
        "name_th": "นาจาน",
        "name_en": "Na Chan",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400604,
        "name_th": "วังเพิ่ม",
        "name_en": "Wang Phoem",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400605,
        "name_th": "ซำยาง",
        "name_en": "Sam Yang",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400606,
        "name_th": "หนองแดง",
        "name_en": "Nong Daeng",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400607,
        "name_th": "ดงลาน",
        "name_en": "Dong Lan",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400608,
        "name_th": "บริบูรณ์",
        "name_en": "Boribun",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400609,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400610,
        "name_th": "ภูห่าน",
        "name_en": "Phu Han",
        "zip_codes": [
            40220
        ],
        "district_id": 4006
    },
    {
        "id": 400701,
        "name_th": "น้ำพอง",
        "name_en": "Nam Phong",
        "zip_codes": [
            40140,
            40310
        ],
        "district_id": 4007
    },
    {
        "id": 400702,
        "name_th": "วังชัย",
        "name_en": "Wang Chai",
        "zip_codes": [
            40140
        ],
        "district_id": 4007
    },
    {
        "id": 400703,
        "name_th": "หนองกุง",
        "name_en": "Nong Kung",
        "zip_codes": [
            40140
        ],
        "district_id": 4007
    },
    {
        "id": 400704,
        "name_th": "บัวใหญ่",
        "name_en": "Bua Yai",
        "zip_codes": [
            40140
        ],
        "district_id": 4007
    },
    {
        "id": 400705,
        "name_th": "สะอาด",
        "name_en": "Sa-at",
        "zip_codes": [
            40310
        ],
        "district_id": 4007
    },
    {
        "id": 400706,
        "name_th": "ม่วงหวาน",
        "name_en": "Muang Wan",
        "zip_codes": [
            40310
        ],
        "district_id": 4007
    },
    {
        "id": 400707,
        "name_th": "บ้านขาม",
        "name_en": "Ban Kham",
        "zip_codes": [
            40140
        ],
        "district_id": 4007
    },
    {
        "id": 400708,
        "name_th": "บัวเงิน",
        "name_en": "Bua Ngoen",
        "zip_codes": [
            40140
        ],
        "district_id": 4007
    },
    {
        "id": 400709,
        "name_th": "ทรายมูล",
        "name_en": "Sai Mun",
        "zip_codes": [
            40140
        ],
        "district_id": 4007
    },
    {
        "id": 400710,
        "name_th": "ท่ากระเสริม",
        "name_en": "Tha Krasoem",
        "zip_codes": [
            40140
        ],
        "district_id": 4007
    },
    {
        "id": 400711,
        "name_th": "พังทุย",
        "name_en": "Phang Thui",
        "zip_codes": [
            40140
        ],
        "district_id": 4007
    },
    {
        "id": 400712,
        "name_th": "กุดน้ำใส",
        "name_en": "Kut Nam Sai",
        "zip_codes": [
            40310
        ],
        "district_id": 4007
    },
    {
        "id": 400801,
        "name_th": "โคกสูง",
        "name_en": "Khok Sung",
        "zip_codes": [
            40250
        ],
        "district_id": 4008
    },
    {
        "id": 400802,
        "name_th": "บ้านดง",
        "name_en": "Ban Dong",
        "zip_codes": [
            40250
        ],
        "district_id": 4008
    },
    {
        "id": 400803,
        "name_th": "เขื่อนอุบลรัตน์",
        "name_en": "Khuean Ubolratana",
        "zip_codes": [
            40250
        ],
        "district_id": 4008
    },
    {
        "id": 400804,
        "name_th": "นาคำ",
        "name_en": "Na Kham",
        "zip_codes": [
            40250
        ],
        "district_id": 4008
    },
    {
        "id": 400805,
        "name_th": "ศรีสุขสำราญ",
        "name_en": "Si Suk Samran",
        "zip_codes": [
            40250
        ],
        "district_id": 4008
    },
    {
        "id": 400806,
        "name_th": "ทุ่งโป่ง",
        "name_en": "Thung Pong",
        "zip_codes": [
            40250
        ],
        "district_id": 4008
    },
    {
        "id": 400901,
        "name_th": "หนองโก",
        "name_en": "Nong Ko",
        "zip_codes": [
            40170
        ],
        "district_id": 4009
    },
    {
        "id": 400902,
        "name_th": "หนองกุงใหญ่",
        "name_en": "Nong Kung Yai",
        "zip_codes": [
            40170
        ],
        "district_id": 4009
    },
    {
        "id": 400905,
        "name_th": "ห้วยโจด",
        "name_en": "Huai Chot",
        "zip_codes": [
            40170
        ],
        "district_id": 4009
    },
    {
        "id": 400906,
        "name_th": "ห้วยยาง",
        "name_en": "Huai Yang",
        "zip_codes": [
            40170
        ],
        "district_id": 4009
    },
    {
        "id": 400907,
        "name_th": "บ้านฝาง",
        "name_en": "Ban Fang",
        "zip_codes": [
            40170
        ],
        "district_id": 4009
    },
    {
        "id": 400909,
        "name_th": "ดูนสาด",
        "name_en": "Dun Sat",
        "zip_codes": [
            40170
        ],
        "district_id": 4009
    },
    {
        "id": 400910,
        "name_th": "หนองโน",
        "name_en": "Nong No",
        "zip_codes": [
            40170
        ],
        "district_id": 4009
    },
    {
        "id": 400911,
        "name_th": "น้ำอ้อม",
        "name_en": "Nam Om",
        "zip_codes": [
            40170
        ],
        "district_id": 4009
    },
    {
        "id": 400912,
        "name_th": "หัวนาคำ",
        "name_en": "Hua Na Kham",
        "zip_codes": [
            40170
        ],
        "district_id": 4009
    },
    {
        "id": 401001,
        "name_th": "บ้านไผ่",
        "name_en": "Ban Phai",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401002,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401005,
        "name_th": "เมืองเพีย",
        "name_en": "Mueang Phia",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401009,
        "name_th": "บ้านลาน",
        "name_en": "Ban Lan",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401010,
        "name_th": "แคนเหนือ",
        "name_en": "Khaen Nuea",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401011,
        "name_th": "ภูเหล็ก",
        "name_en": "Phu Lek",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401013,
        "name_th": "ป่าปอ",
        "name_en": "Pa Po",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401014,
        "name_th": "หินตั้ง",
        "name_en": "Hin Tang",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401016,
        "name_th": "หนองน้ำใส",
        "name_en": "Nong Nam Sai",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401017,
        "name_th": "หัวหนอง",
        "name_en": "Hua Nong",
        "zip_codes": [
            40110
        ],
        "district_id": 4010
    },
    {
        "id": 401101,
        "name_th": "เปือยน้อย",
        "name_en": "Pueai Noi",
        "zip_codes": [
            40340
        ],
        "district_id": 4011
    },
    {
        "id": 401102,
        "name_th": "วังม่วง",
        "name_en": "Wang Muang",
        "zip_codes": [
            40340
        ],
        "district_id": 4011
    },
    {
        "id": 401103,
        "name_th": "ขามป้อม",
        "name_en": "Kham Pom",
        "zip_codes": [
            40340
        ],
        "district_id": 4011
    },
    {
        "id": 401104,
        "name_th": "สระแก้ว",
        "name_en": "Sa Kaeo",
        "zip_codes": [
            40340
        ],
        "district_id": 4011
    },
    {
        "id": 401201,
        "name_th": "เมืองพล",
        "name_en": "Mueang Phon",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401203,
        "name_th": "โจดหนองแก",
        "name_en": "Chot Nong Kae",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401204,
        "name_th": "เก่างิ้ว",
        "name_en": "Kao Ngio",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401205,
        "name_th": "หนองมะเขือ",
        "name_en": "Nong Makhuea",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401206,
        "name_th": "หนองแวงโสกพระ",
        "name_en": "Nong Waeng Sok Phra",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401207,
        "name_th": "เพ็กใหญ่",
        "name_en": "Phek Yai",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401208,
        "name_th": "โคกสง่า",
        "name_en": "Khok Sa-nga",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401209,
        "name_th": "หนองแวงนางเบ้า",
        "name_en": "Nong Waeng Nang Bao",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401210,
        "name_th": "ลอมคอม",
        "name_en": "Lom Khom",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401211,
        "name_th": "โนนข่า",
        "name_en": "Non Kha",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401212,
        "name_th": "โสกนกเต็น",
        "name_en": "Sok Nok Ten",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401213,
        "name_th": "หัวทุ่ง",
        "name_en": "Hua Thung",
        "zip_codes": [
            40120
        ],
        "district_id": 4012
    },
    {
        "id": 401301,
        "name_th": "คอนฉิม",
        "name_en": "Khon Chim",
        "zip_codes": [
            40330
        ],
        "district_id": 4013
    },
    {
        "id": 401302,
        "name_th": "ใหม่นาเพียง",
        "name_en": "Mai Na Phiang",
        "zip_codes": [
            40330
        ],
        "district_id": 4013
    },
    {
        "id": 401303,
        "name_th": "โนนทอง",
        "name_en": "Non Thong",
        "zip_codes": [
            40330
        ],
        "district_id": 4013
    },
    {
        "id": 401304,
        "name_th": "แวงใหญ่",
        "name_en": "Waeng Yai",
        "zip_codes": [
            40330
        ],
        "district_id": 4013
    },
    {
        "id": 401305,
        "name_th": "โนนสะอาด",
        "name_en": "Non Sa-at",
        "zip_codes": [
            40330
        ],
        "district_id": 4013
    },
    {
        "id": 401401,
        "name_th": "แวงน้อย",
        "name_en": "Waeng Noi",
        "zip_codes": [
            40230
        ],
        "district_id": 4014
    },
    {
        "id": 401402,
        "name_th": "ก้านเหลือง",
        "name_en": "Kan Lueang",
        "zip_codes": [
            40230
        ],
        "district_id": 4014
    },
    {
        "id": 401403,
        "name_th": "ท่านางแนว",
        "name_en": "Tha Nang Naeo",
        "zip_codes": [
            40230
        ],
        "district_id": 4014
    },
    {
        "id": 401404,
        "name_th": "ละหานนา",
        "name_en": "Lahan Na",
        "zip_codes": [
            40230
        ],
        "district_id": 4014
    },
    {
        "id": 401405,
        "name_th": "ท่าวัด",
        "name_en": "Tha Wat",
        "zip_codes": [
            40230
        ],
        "district_id": 4014
    },
    {
        "id": 401406,
        "name_th": "ทางขวาง",
        "name_en": "Thang Khwang",
        "zip_codes": [
            40230
        ],
        "district_id": 4014
    },
    {
        "id": 401501,
        "name_th": "หนองสองห้อง",
        "name_en": "Nong Song Hong",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401502,
        "name_th": "คึมชาด",
        "name_en": "Khuemchat",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401503,
        "name_th": "โนนธาตุ",
        "name_en": "Non That",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401504,
        "name_th": "ตะกั่วป่า",
        "name_en": "Takua Pa",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401505,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401506,
        "name_th": "หนองเม็ก",
        "name_en": "Nong Mek",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401507,
        "name_th": "ดอนดู่",
        "name_en": "Don Du",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401508,
        "name_th": "ดงเค็ง",
        "name_en": "Dong Kheng",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401509,
        "name_th": "หันโจด",
        "name_en": "Han Chot",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401510,
        "name_th": "ดอนดั่ง",
        "name_en": "Don Dang",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401511,
        "name_th": "วังหิน",
        "name_en": "Wang Hin",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401512,
        "name_th": "หนองไผ่ล้อม",
        "name_en": "Nong Phai Lom",
        "zip_codes": [
            40190
        ],
        "district_id": 4015
    },
    {
        "id": 401601,
        "name_th": "บ้านเรือ",
        "name_en": "Ban Ruea",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401604,
        "name_th": "หว้าทอง",
        "name_en": "Wa Thong",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401605,
        "name_th": "กุดขอนแก่น",
        "name_en": "Kut Khon Kaen",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401606,
        "name_th": "นาชุมแสง",
        "name_en": "Na Chum Saeng",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401607,
        "name_th": "นาหว้า",
        "name_en": "Na Wa",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401610,
        "name_th": "หนองกุงธนสาร",
        "name_en": "Nong Kung Thanasan",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401612,
        "name_th": "หนองกุงเซิน",
        "name_en": "Nong Kung Soen",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401613,
        "name_th": "สงเปือย",
        "name_en": "Song Pueai",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401614,
        "name_th": "ทุ่งชมพู",
        "name_en": "Thung Chomphu",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401616,
        "name_th": "ดินดำ",
        "name_en": "Din Dam",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401617,
        "name_th": "ภูเวียง",
        "name_en": "Phu Wiang",
        "zip_codes": [
            40150
        ],
        "district_id": 4016
    },
    {
        "id": 401701,
        "name_th": "กุดเค้า",
        "name_en": "Kut Khao",
        "zip_codes": [
            40160
        ],
        "district_id": 4017
    },
    {
        "id": 401702,
        "name_th": "สวนหม่อน",
        "name_en": "Suan Mon",
        "zip_codes": [
            40160
        ],
        "district_id": 4017
    },
    {
        "id": 401703,
        "name_th": "หนองแปน",
        "name_en": "Nong Paen",
        "zip_codes": [
            40160
        ],
        "district_id": 4017
    },
    {
        "id": 401704,
        "name_th": "โพนเพ็ก",
        "name_en": "Phon Phek",
        "zip_codes": [
            40160
        ],
        "district_id": 4017
    },
    {
        "id": 401705,
        "name_th": "คำแคน",
        "name_en": "Kham Khaen",
        "zip_codes": [
            40160
        ],
        "district_id": 4017
    },
    {
        "id": 401706,
        "name_th": "นาข่า",
        "name_en": "Na Kha",
        "zip_codes": [
            40160
        ],
        "district_id": 4017
    },
    {
        "id": 401707,
        "name_th": "นางาม",
        "name_en": "Na Ngam",
        "zip_codes": [
            40160
        ],
        "district_id": 4017
    },
    {
        "id": 401710,
        "name_th": "ท่าศาลา",
        "name_en": "Tha Sala",
        "zip_codes": [
            40160
        ],
        "district_id": 4017
    },
    {
        "id": 401801,
        "name_th": "ชนบท",
        "name_en": "Chonnabot",
        "zip_codes": [
            40180
        ],
        "district_id": 4018
    },
    {
        "id": 401802,
        "name_th": "กุดเพียขอม",
        "name_en": "Kut Phia Khom",
        "zip_codes": [
            40180
        ],
        "district_id": 4018
    },
    {
        "id": 401803,
        "name_th": "วังแสง",
        "name_en": "Wang Saeng",
        "zip_codes": [
            40180
        ],
        "district_id": 4018
    },
    {
        "id": 401804,
        "name_th": "ห้วยแก",
        "name_en": "Huai Kae",
        "zip_codes": [
            40180
        ],
        "district_id": 4018
    },
    {
        "id": 401805,
        "name_th": "บ้านแท่น",
        "name_en": "Ban Thaen",
        "zip_codes": [
            40180
        ],
        "district_id": 4018
    },
    {
        "id": 401806,
        "name_th": "ศรีบุญเรือง",
        "name_en": "Si Bun Rueang",
        "zip_codes": [
            40180
        ],
        "district_id": 4018
    },
    {
        "id": 401807,
        "name_th": "โนนพะยอม",
        "name_en": "Non Phayom",
        "zip_codes": [
            40180
        ],
        "district_id": 4018
    },
    {
        "id": 401808,
        "name_th": "ปอแดง",
        "name_en": "Po Daeng",
        "zip_codes": [
            40180
        ],
        "district_id": 4018
    },
    {
        "id": 401901,
        "name_th": "เขาสวนกวาง",
        "name_en": "Khao Suan Kwang",
        "zip_codes": [
            40280
        ],
        "district_id": 4019
    },
    {
        "id": 401902,
        "name_th": "ดงเมืองแอม",
        "name_en": "Dong Mueang Aem",
        "zip_codes": [
            40280
        ],
        "district_id": 4019
    },
    {
        "id": 401903,
        "name_th": "นางิ้ว",
        "name_en": "Na Ngio",
        "zip_codes": [
            40280
        ],
        "district_id": 4019
    },
    {
        "id": 401904,
        "name_th": "โนนสมบูรณ์",
        "name_en": "Non Sombun",
        "zip_codes": [
            40280
        ],
        "district_id": 4019
    },
    {
        "id": 401905,
        "name_th": "คำม่วง",
        "name_en": "Kham Muang",
        "zip_codes": [
            40280
        ],
        "district_id": 4019
    },
    {
        "id": 402001,
        "name_th": "โนนคอม",
        "name_en": "Non Khom",
        "zip_codes": [
            40350
        ],
        "district_id": 4020
    },
    {
        "id": 402002,
        "name_th": "นาฝาย",
        "name_en": "Na Fai",
        "zip_codes": [
            40350
        ],
        "district_id": 4020
    },
    {
        "id": 402003,
        "name_th": "ภูผาม่าน",
        "name_en": "Phu Pha Man",
        "zip_codes": [
            40350
        ],
        "district_id": 4020
    },
    {
        "id": 402004,
        "name_th": "วังสวาบ",
        "name_en": "Wang Sawap",
        "zip_codes": [
            40350
        ],
        "district_id": 4020
    },
    {
        "id": 402005,
        "name_th": "ห้วยม่วง",
        "name_en": "huai Muang",
        "zip_codes": [
            40350
        ],
        "district_id": 4020
    },
    {
        "id": 402101,
        "name_th": "กระนวน",
        "name_en": "Kranuan",
        "zip_codes": [
            40170
        ],
        "district_id": 4021
    },
    {
        "id": 402102,
        "name_th": "คำแมด",
        "name_en": "Kham Maet",
        "zip_codes": [
            40170
        ],
        "district_id": 4021
    },
    {
        "id": 402103,
        "name_th": "บ้านโนน",
        "name_en": "Ban Non",
        "zip_codes": [
            40170
        ],
        "district_id": 4021
    },
    {
        "id": 402104,
        "name_th": "คูคำ",
        "name_en": "Khu Kham",
        "zip_codes": [
            40170
        ],
        "district_id": 4021
    },
    {
        "id": 402105,
        "name_th": "ห้วยเตย",
        "name_en": "Huai Toei",
        "zip_codes": [
            40170
        ],
        "district_id": 4021
    },
    {
        "id": 402201,
        "name_th": "บ้านโคก",
        "name_en": "Ban Khok",
        "zip_codes": [
            40160
        ],
        "district_id": 4022
    },
    {
        "id": 402202,
        "name_th": "โพธิ์ไชย",
        "name_en": "Pho Chai",
        "zip_codes": [
            40160
        ],
        "district_id": 4022
    },
    {
        "id": 402203,
        "name_th": "ซับสมบูรณ์",
        "name_en": "Sap Sombun",
        "zip_codes": [
            40160
        ],
        "district_id": 4022
    },
    {
        "id": 402204,
        "name_th": "นาแพง",
        "name_en": "Na Phaeng",
        "zip_codes": [
            40160
        ],
        "district_id": 4022
    },
    {
        "id": 402301,
        "name_th": "กุดธาตุ",
        "name_en": "Kut That",
        "zip_codes": [
            40150
        ],
        "district_id": 4023
    },
    {
        "id": 402302,
        "name_th": "บ้านโคก",
        "name_en": "Ban Khok",
        "zip_codes": [
            40150
        ],
        "district_id": 4023
    },
    {
        "id": 402303,
        "name_th": "ขนวน",
        "name_en": "Khanuan",
        "zip_codes": [
            40150
        ],
        "district_id": 4023
    },
    {
        "id": 402401,
        "name_th": "บ้านแฮด",
        "name_en": "Ban Haet",
        "zip_codes": [
            40110
        ],
        "district_id": 4024
    },
    {
        "id": 402402,
        "name_th": "โคกสำราญ",
        "name_en": "Khok Samran",
        "zip_codes": [
            40110
        ],
        "district_id": 4024
    },
    {
        "id": 402403,
        "name_th": "โนนสมบูรณ์",
        "name_en": "Non Sombun",
        "zip_codes": [
            40110
        ],
        "district_id": 4024
    },
    {
        "id": 402404,
        "name_th": "หนองแซง",
        "name_en": "Nong Saeng",
        "zip_codes": [
            40110
        ],
        "district_id": 4024
    },
    {
        "id": 402501,
        "name_th": "โนนศิลา",
        "name_en": "Non Sila",
        "zip_codes": [
            40110
        ],
        "district_id": 4025
    },
    {
        "id": 402502,
        "name_th": "หนองปลาหมอ",
        "name_en": "Nong Pla Mo",
        "zip_codes": [
            40110
        ],
        "district_id": 4025
    },
    {
        "id": 402503,
        "name_th": "บ้านหัน",
        "name_en": "Ban Han",
        "zip_codes": [
            40110
        ],
        "district_id": 4025
    },
    {
        "id": 402504,
        "name_th": "เปือยใหญ่",
        "name_en": "Pueai Yai",
        "zip_codes": [
            40110
        ],
        "district_id": 4025
    },
    {
        "id": 402505,
        "name_th": "โนนแดง",
        "name_en": "Non Daeng",
        "zip_codes": [
            40110
        ],
        "district_id": 4025
    },
    {
        "id": 402901,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            40150
        ],
        "district_id": 4029
    },
    {
        "id": 402902,
        "name_th": "เมืองเก่าพัฒนา",
        "name_en": "Mueang Kao Phatthana",
        "zip_codes": [
            40150
        ],
        "district_id": 4029
    },
    {
        "id": 402903,
        "name_th": "เขาน้อย",
        "name_en": "Khao Noi",
        "zip_codes": [
            40150
        ],
        "district_id": 4029
    },
    {
        "id": 410101,
        "name_th": "หมากแข้ง",
        "name_en": "Mak Khaeng",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410102,
        "name_th": "นิคมสงเคราะห์",
        "name_en": "Nikhom Songkhro",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410103,
        "name_th": "บ้านขาว",
        "name_en": "Ban Khao",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410104,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410105,
        "name_th": "บ้านตาด",
        "name_en": "Ban Tat",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410106,
        "name_th": "โนนสูง",
        "name_en": "Non Sung",
        "zip_codes": [
            41330
        ],
        "district_id": 4101
    },
    {
        "id": 410107,
        "name_th": "หมูม่น",
        "name_en": "Mu Mon",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410108,
        "name_th": "เชียงยืน",
        "name_en": "Chiang Yuen",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410109,
        "name_th": "หนองนาคำ",
        "name_en": "Nong Na Kham",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410110,
        "name_th": "กุดสระ",
        "name_en": "Kut Sa",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410111,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410112,
        "name_th": "บ้านเลื่อม",
        "name_en": "Ban Lueam",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410113,
        "name_th": "เชียงพิณ",
        "name_en": "Chiang Phin",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410114,
        "name_th": "สามพร้าว",
        "name_en": "Sam Phrao",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410115,
        "name_th": "หนองไฮ",
        "name_en": "Nong Hai",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410116,
        "name_th": "นาข่า",
        "name_en": "Na Kha",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410117,
        "name_th": "บ้านจั่น",
        "name_en": "Ban Chan",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410118,
        "name_th": "หนองขอนกว้าง",
        "name_en": "Nong Khon Kwang",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410119,
        "name_th": "โคกสะอาด",
        "name_en": "Khok Sa-at",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410120,
        "name_th": "นากว้าง",
        "name_en": "Na Kwang",
        "zip_codes": [
            41000
        ],
        "district_id": 4101
    },
    {
        "id": 410121,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            41330
        ],
        "district_id": 4101
    },
    {
        "id": 410201,
        "name_th": "กุดจับ",
        "name_en": "Kut Chap",
        "zip_codes": [
            41250
        ],
        "district_id": 4102
    },
    {
        "id": 410202,
        "name_th": "ปะโค",
        "name_en": "Pa Kho",
        "zip_codes": [
            41250
        ],
        "district_id": 4102
    },
    {
        "id": 410203,
        "name_th": "ขอนยูง",
        "name_en": "Khon Yung",
        "zip_codes": [
            41250
        ],
        "district_id": 4102
    },
    {
        "id": 410204,
        "name_th": "เชียงเพ็ง",
        "name_en": "Chiang Pheng",
        "zip_codes": [
            41250
        ],
        "district_id": 4102
    },
    {
        "id": 410205,
        "name_th": "สร้างก่อ",
        "name_en": "Sang Ko",
        "zip_codes": [
            41250
        ],
        "district_id": 4102
    },
    {
        "id": 410206,
        "name_th": "เมืองเพีย",
        "name_en": "Mueang Phia",
        "zip_codes": [
            41250
        ],
        "district_id": 4102
    },
    {
        "id": 410207,
        "name_th": "ตาลเลียน",
        "name_en": "Tan Lian",
        "zip_codes": [
            41250
        ],
        "district_id": 4102
    },
    {
        "id": 410301,
        "name_th": "หมากหญ้า",
        "name_en": "Mak Ya",
        "zip_codes": [
            41360
        ],
        "district_id": 4103
    },
    {
        "id": 410302,
        "name_th": "หนองอ้อ",
        "name_en": "Nong O",
        "zip_codes": [
            41220
        ],
        "district_id": 4103
    },
    {
        "id": 410303,
        "name_th": "อูบมุง",
        "name_en": "Up Mung",
        "zip_codes": [
            41220
        ],
        "district_id": 4103
    },
    {
        "id": 410304,
        "name_th": "กุดหมากไฟ",
        "name_en": "Kut Mak Fai",
        "zip_codes": [
            41220
        ],
        "district_id": 4103
    },
    {
        "id": 410305,
        "name_th": "น้ำพ่น",
        "name_en": "Nam Phon",
        "zip_codes": [
            41360
        ],
        "district_id": 4103
    },
    {
        "id": 410306,
        "name_th": "หนองบัวบาน",
        "name_en": "Nong Bua Ban",
        "zip_codes": [
            41360
        ],
        "district_id": 4103
    },
    {
        "id": 410307,
        "name_th": "โนนหวาย",
        "name_en": "Non Wai",
        "zip_codes": [
            41220
        ],
        "district_id": 4103
    },
    {
        "id": 410308,
        "name_th": "หนองวัวซอ",
        "name_en": "Nong Wua So",
        "zip_codes": [
            41360
        ],
        "district_id": 4103
    },
    {
        "id": 410401,
        "name_th": "ตูมใต้",
        "name_en": "Tum Tai",
        "zip_codes": [
            41110
        ],
        "district_id": 4104
    },
    {
        "id": 410402,
        "name_th": "พันดอน",
        "name_en": "Phan Don",
        "zip_codes": [
            41370
        ],
        "district_id": 4104
    },
    {
        "id": 410403,
        "name_th": "เวียงคำ",
        "name_en": "Wiang Kham",
        "zip_codes": [
            41110
        ],
        "district_id": 4104
    },
    {
        "id": 410404,
        "name_th": "แชแล",
        "name_en": "Chaelae",
        "zip_codes": [
            41110
        ],
        "district_id": 4104
    },
    {
        "id": 410406,
        "name_th": "เชียงแหว",
        "name_en": "Chiang Wae",
        "zip_codes": [
            41110
        ],
        "district_id": 4104
    },
    {
        "id": 410407,
        "name_th": "ห้วยเกิ้ง",
        "name_en": "Huai Koeng",
        "zip_codes": [
            41110
        ],
        "district_id": 4104
    },
    {
        "id": 410409,
        "name_th": "เสอเพลอ",
        "name_en": "Soephloe",
        "zip_codes": [
            41370
        ],
        "district_id": 4104
    },
    {
        "id": 410410,
        "name_th": "สีออ",
        "name_en": "Si O",
        "zip_codes": [
            41110
        ],
        "district_id": 4104
    },
    {
        "id": 410411,
        "name_th": "ปะโค",
        "name_en": "Pakho",
        "zip_codes": [
            41370
        ],
        "district_id": 4104
    },
    {
        "id": 410413,
        "name_th": "ผาสุก",
        "name_en": "Pha Suk",
        "zip_codes": [
            41370
        ],
        "district_id": 4104
    },
    {
        "id": 410414,
        "name_th": "ท่าลี่",
        "name_en": "Tha Li",
        "zip_codes": [
            41110
        ],
        "district_id": 4104
    },
    {
        "id": 410415,
        "name_th": "กุมภวาปี",
        "name_en": "Kumphawapi",
        "zip_codes": [
            41110
        ],
        "district_id": 4104
    },
    {
        "id": 410416,
        "name_th": "หนองหว้า",
        "name_en": "Nong Wa",
        "zip_codes": [
            41110
        ],
        "district_id": 4104
    },
    {
        "id": 410501,
        "name_th": "โนนสะอาด",
        "name_en": "Non Sa-at",
        "zip_codes": [
            41240
        ],
        "district_id": 4105
    },
    {
        "id": 410502,
        "name_th": "บุ่งแก้ว",
        "name_en": "Bung Kaeo",
        "zip_codes": [
            41240
        ],
        "district_id": 4105
    },
    {
        "id": 410503,
        "name_th": "โพธิ์ศรีสำราญ",
        "name_en": "Pho Si Samran",
        "zip_codes": [
            41240
        ],
        "district_id": 4105
    },
    {
        "id": 410504,
        "name_th": "ทมนางาม",
        "name_en": "Thom Na Ngam",
        "zip_codes": [
            41240
        ],
        "district_id": 4105
    },
    {
        "id": 410505,
        "name_th": "หนองกุงศรี",
        "name_en": "Nong Kung Si",
        "zip_codes": [
            41240
        ],
        "district_id": 4105
    },
    {
        "id": 410506,
        "name_th": "โคกกลาง",
        "name_en": "Khok Klang",
        "zip_codes": [
            41240
        ],
        "district_id": 4105
    },
    {
        "id": 410601,
        "name_th": "หนองหาน",
        "name_en": "Nong Han",
        "zip_codes": [
            41130
        ],
        "district_id": 4106
    },
    {
        "id": 410602,
        "name_th": "หนองเม็ก",
        "name_en": "Nong Mek",
        "zip_codes": [
            41130
        ],
        "district_id": 4106
    },
    {
        "id": 410605,
        "name_th": "พังงู",
        "name_en": "Phang Ngu",
        "zip_codes": [
            41130
        ],
        "district_id": 4106
    },
    {
        "id": 410606,
        "name_th": "สะแบง",
        "name_en": "Sabaeng",
        "zip_codes": [
            41130
        ],
        "district_id": 4106
    },
    {
        "id": 410607,
        "name_th": "สร้อยพร้าว",
        "name_en": "Soi Phrao",
        "zip_codes": [
            41130
        ],
        "district_id": 4106
    },
    {
        "id": 410609,
        "name_th": "บ้านเชียง",
        "name_en": "Ban Chiang",
        "zip_codes": [
            41320
        ],
        "district_id": 4106
    },
    {
        "id": 410610,
        "name_th": "บ้านยา",
        "name_en": "Ban Ya",
        "zip_codes": [
            41320
        ],
        "district_id": 4106
    },
    {
        "id": 410611,
        "name_th": "โพนงาม",
        "name_en": "Phon Ngam",
        "zip_codes": [
            41130
        ],
        "district_id": 4106
    },
    {
        "id": 410612,
        "name_th": "ผักตบ",
        "name_en": "Phak Top",
        "zip_codes": [
            41130
        ],
        "district_id": 4106
    },
    {
        "id": 410614,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            41130
        ],
        "district_id": 4106
    },
    {
        "id": 410617,
        "name_th": "ดอนหายโศก",
        "name_en": "Don Hai Sok",
        "zip_codes": [
            41130
        ],
        "district_id": 4106
    },
    {
        "id": 410618,
        "name_th": "หนองสระปลา",
        "name_en": "Nong Sa Pla",
        "zip_codes": [
            41320
        ],
        "district_id": 4106
    },
    {
        "id": 410701,
        "name_th": "ทุ่งฝน",
        "name_en": "Thung Fon",
        "zip_codes": [
            41310
        ],
        "district_id": 4107
    },
    {
        "id": 410702,
        "name_th": "ทุ่งใหญ่",
        "name_en": "Thung Yai",
        "zip_codes": [
            41310
        ],
        "district_id": 4107
    },
    {
        "id": 410703,
        "name_th": "นาชุมแสง",
        "name_en": "Na Chum Saeng",
        "zip_codes": [
            41310
        ],
        "district_id": 4107
    },
    {
        "id": 410704,
        "name_th": "นาทม",
        "name_en": "Na Thom",
        "zip_codes": [
            41310
        ],
        "district_id": 4107
    },
    {
        "id": 410801,
        "name_th": "ไชยวาน",
        "name_en": "Chai Wan",
        "zip_codes": [
            41290
        ],
        "district_id": 4108
    },
    {
        "id": 410802,
        "name_th": "หนองหลัก",
        "name_en": "Nong Lak",
        "zip_codes": [
            41290
        ],
        "district_id": 4108
    },
    {
        "id": 410803,
        "name_th": "คำเลาะ",
        "name_en": "Kham Lo",
        "zip_codes": [
            41290
        ],
        "district_id": 4108
    },
    {
        "id": 410804,
        "name_th": "โพนสูง",
        "name_en": "Phon Sung",
        "zip_codes": [
            41290
        ],
        "district_id": 4108
    },
    {
        "id": 410901,
        "name_th": "ศรีธาตุ",
        "name_en": "Si That",
        "zip_codes": [
            41230
        ],
        "district_id": 4109
    },
    {
        "id": 410902,
        "name_th": "จำปี",
        "name_en": "Champi",
        "zip_codes": [
            41230
        ],
        "district_id": 4109
    },
    {
        "id": 410903,
        "name_th": "บ้านโปร่ง",
        "name_en": "Ban Prong",
        "zip_codes": [
            41230
        ],
        "district_id": 4109
    },
    {
        "id": 410904,
        "name_th": "หัวนาคำ",
        "name_en": "Hua Na Kham",
        "zip_codes": [
            41230
        ],
        "district_id": 4109
    },
    {
        "id": 410905,
        "name_th": "หนองนกเขียน",
        "name_en": "Nong Nok Khian",
        "zip_codes": [
            41230
        ],
        "district_id": 4109
    },
    {
        "id": 410906,
        "name_th": "นายูง",
        "name_en": "Na Yung",
        "zip_codes": [
            41230
        ],
        "district_id": 4109
    },
    {
        "id": 410907,
        "name_th": "ตาดทอง",
        "name_en": "Tat Thong",
        "zip_codes": [
            41230
        ],
        "district_id": 4109
    },
    {
        "id": 411001,
        "name_th": "หนองกุงทับม้า",
        "name_en": "Nong Kung Thap Ma",
        "zip_codes": [
            41280
        ],
        "district_id": 4110
    },
    {
        "id": 411002,
        "name_th": "หนองหญ้าไซ",
        "name_en": "Nong Ya Sai",
        "zip_codes": [
            41280
        ],
        "district_id": 4110
    },
    {
        "id": 411003,
        "name_th": "บะยาว",
        "name_en": "Ba Yao",
        "zip_codes": [
            41280
        ],
        "district_id": 4110
    },
    {
        "id": 411004,
        "name_th": "ผาสุก",
        "name_en": "Phasuk",
        "zip_codes": [
            41280
        ],
        "district_id": 4110
    },
    {
        "id": 411005,
        "name_th": "คำโคกสูง",
        "name_en": "Kham Khok Sung",
        "zip_codes": [
            41280
        ],
        "district_id": 4110
    },
    {
        "id": 411006,
        "name_th": "วังสามหมอ",
        "name_en": "Wang Sam Mo",
        "zip_codes": [
            41280
        ],
        "district_id": 4110
    },
    {
        "id": 411101,
        "name_th": "ศรีสุทโธ",
        "name_en": "Si Suttho",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411102,
        "name_th": "บ้านดุง",
        "name_en": "Ban Dung",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411103,
        "name_th": "ดงเย็น",
        "name_en": "Dong Yen",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411104,
        "name_th": "โพนสูง",
        "name_en": "Phon Sung",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411105,
        "name_th": "อ้อมกอ",
        "name_en": "Om Ko",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411106,
        "name_th": "บ้านจันทน์",
        "name_en": "Ban Chan",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411107,
        "name_th": "บ้านชัย",
        "name_en": "Ban Chai",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411108,
        "name_th": "นาไหม",
        "name_en": "Na Mai",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411109,
        "name_th": "ถ่อนนาลับ",
        "name_en": "Thon Na Lap",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411110,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411111,
        "name_th": "บ้านม่วง",
        "name_en": "Ban Muang",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411112,
        "name_th": "บ้านตาด",
        "name_en": "Ban Tat",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411113,
        "name_th": "นาคำ",
        "name_en": "Na Kham",
        "zip_codes": [
            41190
        ],
        "district_id": 4111
    },
    {
        "id": 411701,
        "name_th": "บ้านผือ",
        "name_en": "Ban Phue",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411702,
        "name_th": "หายโศก",
        "name_en": "Hai Sok",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411703,
        "name_th": "เขือน้ำ",
        "name_en": "Khuea Nam",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411704,
        "name_th": "คำบง",
        "name_en": "Kham Bong",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411705,
        "name_th": "โนนทอง",
        "name_en": "Non Thong",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411706,
        "name_th": "ข้าวสาร",
        "name_en": "Khao San",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411707,
        "name_th": "จำปาโมง",
        "name_en": "Champa Mong",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411708,
        "name_th": "กลางใหญ่",
        "name_en": "Klang Yai",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411709,
        "name_th": "เมืองพาน",
        "name_en": "Mueang Phan",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411710,
        "name_th": "คำด้วง",
        "name_en": "Kham Duang",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411711,
        "name_th": "หนองหัวคู",
        "name_en": "Nong Hua Khu",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411712,
        "name_th": "บ้านค้อ",
        "name_en": "Ban Kho",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411713,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            41160
        ],
        "district_id": 4117
    },
    {
        "id": 411801,
        "name_th": "นางัว",
        "name_en": "Na Ngua",
        "zip_codes": [
            41210
        ],
        "district_id": 4118
    },
    {
        "id": 411802,
        "name_th": "น้ำโสม",
        "name_en": "Nam Som",
        "zip_codes": [
            41210
        ],
        "district_id": 4118
    },
    {
        "id": 411805,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            41210
        ],
        "district_id": 4118
    },
    {
        "id": 411806,
        "name_th": "บ้านหยวก",
        "name_en": "Ban Yuak",
        "zip_codes": [
            41210
        ],
        "district_id": 4118
    },
    {
        "id": 411807,
        "name_th": "โสมเยี่ยม",
        "name_en": "Som Yiam",
        "zip_codes": [
            41210
        ],
        "district_id": 4118
    },
    {
        "id": 411810,
        "name_th": "ศรีสำราญ",
        "name_en": "Si Samran",
        "zip_codes": [
            41210
        ],
        "district_id": 4118
    },
    {
        "id": 411812,
        "name_th": "สามัคคี",
        "name_en": "Samakkhi",
        "zip_codes": [
            41210
        ],
        "district_id": 4118
    },
    {
        "id": 411901,
        "name_th": "เพ็ญ",
        "name_en": "Phen",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411902,
        "name_th": "บ้านธาตุ",
        "name_en": "Ban That",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411903,
        "name_th": "นาพู่",
        "name_en": "Na Phu",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411904,
        "name_th": "เชียงหวาง",
        "name_en": "Chiang Wang",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411905,
        "name_th": "สุมเส้า",
        "name_en": "Sum Sao",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411906,
        "name_th": "นาบัว",
        "name_en": "Na Bua",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411907,
        "name_th": "บ้านเหล่า",
        "name_en": "Ban Lao",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411908,
        "name_th": "จอมศรี",
        "name_en": "Chom Si",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411909,
        "name_th": "เตาไห",
        "name_en": "Tao Hai",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411910,
        "name_th": "โคกกลาง",
        "name_en": "Khok Klang",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 411911,
        "name_th": "สร้างแป้น",
        "name_en": "Sang Paen",
        "zip_codes": [
            41150
        ],
        "district_id": 4119
    },
    {
        "id": 412001,
        "name_th": "สร้างคอม",
        "name_en": "Sang Khom",
        "zip_codes": [
            41260
        ],
        "district_id": 4120
    },
    {
        "id": 412002,
        "name_th": "เชียงดา",
        "name_en": "Chiang Da",
        "zip_codes": [
            41260
        ],
        "district_id": 4120
    },
    {
        "id": 412003,
        "name_th": "บ้านยวด",
        "name_en": "Ban Yuat",
        "zip_codes": [
            41260
        ],
        "district_id": 4120
    },
    {
        "id": 412004,
        "name_th": "บ้านโคก",
        "name_en": "Ban Khok",
        "zip_codes": [
            41260
        ],
        "district_id": 4120
    },
    {
        "id": 412005,
        "name_th": "นาสะอาด",
        "name_en": "Na Sa-at",
        "zip_codes": [
            41260
        ],
        "district_id": 4120
    },
    {
        "id": 412006,
        "name_th": "บ้านหินโงม",
        "name_en": "Bang Hin Ngom",
        "zip_codes": [
            41260
        ],
        "district_id": 4120
    },
    {
        "id": 412101,
        "name_th": "หนองแสง",
        "name_en": "Nong Saeng",
        "zip_codes": [
            41340
        ],
        "district_id": 4121
    },
    {
        "id": 412102,
        "name_th": "แสงสว่าง",
        "name_en": "Saeng Sawang",
        "zip_codes": [
            41340
        ],
        "district_id": 4121
    },
    {
        "id": 412103,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            41340
        ],
        "district_id": 4121
    },
    {
        "id": 412104,
        "name_th": "ทับกุง",
        "name_en": "Thap Kung",
        "zip_codes": [
            41340
        ],
        "district_id": 4121
    },
    {
        "id": 412201,
        "name_th": "นายูง",
        "name_en": "Na Yung",
        "zip_codes": [
            41380
        ],
        "district_id": 4122
    },
    {
        "id": 412202,
        "name_th": "บ้านก้อง",
        "name_en": "Ban Kong",
        "zip_codes": [
            41380
        ],
        "district_id": 4122
    },
    {
        "id": 412203,
        "name_th": "นาแค",
        "name_en": "Na Khae",
        "zip_codes": [
            41380
        ],
        "district_id": 4122
    },
    {
        "id": 412204,
        "name_th": "โนนทอง",
        "name_en": "Non Thong",
        "zip_codes": [
            41380
        ],
        "district_id": 4122
    },
    {
        "id": 412301,
        "name_th": "บ้านแดง",
        "name_en": "Ban Daeng",
        "zip_codes": [
            41130
        ],
        "district_id": 4123
    },
    {
        "id": 412302,
        "name_th": "นาทราย",
        "name_en": "Na Sai",
        "zip_codes": [
            41130
        ],
        "district_id": 4123
    },
    {
        "id": 412303,
        "name_th": "ดอนกลอย",
        "name_en": "Don Kloi",
        "zip_codes": [
            41130
        ],
        "district_id": 4123
    },
    {
        "id": 412401,
        "name_th": "บ้านจีต",
        "name_en": "Ban Chit",
        "zip_codes": [
            41130
        ],
        "district_id": 4124
    },
    {
        "id": 412402,
        "name_th": "โนนทองอินทร์",
        "name_en": "Non Thong In",
        "zip_codes": [
            41130
        ],
        "district_id": 4124
    },
    {
        "id": 412403,
        "name_th": "ค้อใหญ่",
        "name_en": "Kho Yai",
        "zip_codes": [
            41130
        ],
        "district_id": 4124
    },
    {
        "id": 412404,
        "name_th": "คอนสาย",
        "name_en": "Khon Sai",
        "zip_codes": [
            41130
        ],
        "district_id": 4124
    },
    {
        "id": 412501,
        "name_th": "นาม่วง",
        "name_en": "Na Muang",
        "zip_codes": [
            41110
        ],
        "district_id": 4125
    },
    {
        "id": 412502,
        "name_th": "ห้วยสามพาด",
        "name_en": "Huai Sam Phat",
        "zip_codes": [
            41110
        ],
        "district_id": 4125
    },
    {
        "id": 412503,
        "name_th": "อุ่มจาน",
        "name_en": "Um Chan",
        "zip_codes": [
            41110
        ],
        "district_id": 4125
    },
    {
        "id": 420101,
        "name_th": "กุดป่อง",
        "name_en": "Kut Pong",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420102,
        "name_th": "เมือง",
        "name_en": "Mueang",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420103,
        "name_th": "นาอ้อ",
        "name_en": "Na O",
        "zip_codes": [
            42100
        ],
        "district_id": 4201
    },
    {
        "id": 420104,
        "name_th": "กกดู่",
        "name_en": "Kok Du",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420105,
        "name_th": "น้ำหมาน",
        "name_en": "Nam Man",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420106,
        "name_th": "เสี้ยว",
        "name_en": "Siao",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420107,
        "name_th": "นาอาน",
        "name_en": "Na An",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420108,
        "name_th": "นาโป่ง",
        "name_en": "Na Pong",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420109,
        "name_th": "นาดินดำ",
        "name_en": "Na Din Dam",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420110,
        "name_th": "น้ำสวย",
        "name_en": "Nam Suai",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420111,
        "name_th": "ชัยพฤกษ์",
        "name_en": "Chaiyaphruek",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420112,
        "name_th": "นาแขม",
        "name_en": "Na Khaem",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420113,
        "name_th": "ศรีสองรัก",
        "name_en": "Si Song Rak",
        "zip_codes": [
            42100
        ],
        "district_id": 4201
    },
    {
        "id": 420114,
        "name_th": "กกทอง",
        "name_en": "Kok Thong",
        "zip_codes": [
            42000
        ],
        "district_id": 4201
    },
    {
        "id": 420201,
        "name_th": "นาด้วง",
        "name_en": "Na Duang",
        "zip_codes": [
            42210
        ],
        "district_id": 4202
    },
    {
        "id": 420202,
        "name_th": "นาดอกคำ",
        "name_en": "Na Dok Kham",
        "zip_codes": [
            42210
        ],
        "district_id": 4202
    },
    {
        "id": 420203,
        "name_th": "ท่าสะอาด",
        "name_en": "Tha Sa-at",
        "zip_codes": [
            42210
        ],
        "district_id": 4202
    },
    {
        "id": 420204,
        "name_th": "ท่าสวรรค์",
        "name_en": "Tha Sawan",
        "zip_codes": [
            42210
        ],
        "district_id": 4202
    },
    {
        "id": 420301,
        "name_th": "เชียงคาน",
        "name_en": "Chiang Khan",
        "zip_codes": [
            42110
        ],
        "district_id": 4203
    },
    {
        "id": 420302,
        "name_th": "ธาตุ",
        "name_en": "That",
        "zip_codes": [
            42110
        ],
        "district_id": 4203
    },
    {
        "id": 420303,
        "name_th": "นาซ่าว",
        "name_en": "Na Sao",
        "zip_codes": [
            42110
        ],
        "district_id": 4203
    },
    {
        "id": 420304,
        "name_th": "เขาแก้ว",
        "name_en": "Khao Kaeo",
        "zip_codes": [
            42110
        ],
        "district_id": 4203
    },
    {
        "id": 420305,
        "name_th": "ปากตม",
        "name_en": "Pak Tom",
        "zip_codes": [
            42110
        ],
        "district_id": 4203
    },
    {
        "id": 420306,
        "name_th": "บุฮม",
        "name_en": "Bu Hom",
        "zip_codes": [
            42110
        ],
        "district_id": 4203
    },
    {
        "id": 420307,
        "name_th": "จอมศรี",
        "name_en": "Chom Si",
        "zip_codes": [
            42110
        ],
        "district_id": 4203
    },
    {
        "id": 420308,
        "name_th": "หาดทรายขาว",
        "name_en": "Hat Sai Khao",
        "zip_codes": [
            42110
        ],
        "district_id": 4203
    },
    {
        "id": 420401,
        "name_th": "ปากชม",
        "name_en": "Pak Chom",
        "zip_codes": [
            42150
        ],
        "district_id": 4204
    },
    {
        "id": 420402,
        "name_th": "เชียงกลม",
        "name_en": "Chiang Klom",
        "zip_codes": [
            42150
        ],
        "district_id": 4204
    },
    {
        "id": 420403,
        "name_th": "หาดคัมภีร์",
        "name_en": "Hat Khamphi",
        "zip_codes": [
            42150
        ],
        "district_id": 4204
    },
    {
        "id": 420404,
        "name_th": "ห้วยบ่อซืน",
        "name_en": "Huai Bo Suen",
        "zip_codes": [
            42150
        ],
        "district_id": 4204
    },
    {
        "id": 420405,
        "name_th": "ห้วยพิชัย",
        "name_en": "Huai Phichai",
        "zip_codes": [
            42150
        ],
        "district_id": 4204
    },
    {
        "id": 420406,
        "name_th": "ชมเจริญ",
        "name_en": "Chom Charoen",
        "zip_codes": [
            42150
        ],
        "district_id": 4204
    },
    {
        "id": 420501,
        "name_th": "ด่านซ้าย",
        "name_en": "Dan Sai",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420502,
        "name_th": "ปากหมัน",
        "name_en": "Pak Man",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420503,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420504,
        "name_th": "โคกงาม",
        "name_en": "Khok Ngam",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420505,
        "name_th": "โพนสูง",
        "name_en": "Phon Sung",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420506,
        "name_th": "อิปุ่ม",
        "name_en": "Ipum",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420507,
        "name_th": "กกสะทอน",
        "name_en": "Kok Sathon",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420508,
        "name_th": "โป่ง",
        "name_en": "Pong",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420509,
        "name_th": "วังยาว",
        "name_en": "Wang Yao",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420510,
        "name_th": "นาหอ",
        "name_en": "Na Ho",
        "zip_codes": [
            42120
        ],
        "district_id": 4205
    },
    {
        "id": 420601,
        "name_th": "นาแห้ว",
        "name_en": "Na Haeo",
        "zip_codes": [
            42170
        ],
        "district_id": 4206
    },
    {
        "id": 420602,
        "name_th": "แสงภา",
        "name_en": "Saeng Pha",
        "zip_codes": [
            42170
        ],
        "district_id": 4206
    },
    {
        "id": 420603,
        "name_th": "นาพึง",
        "name_en": "Na Phueng",
        "zip_codes": [
            42170
        ],
        "district_id": 4206
    },
    {
        "id": 420604,
        "name_th": "นามาลา",
        "name_en": "Na Ma La",
        "zip_codes": [
            42170
        ],
        "district_id": 4206
    },
    {
        "id": 420605,
        "name_th": "เหล่ากอหก",
        "name_en": "Lao Ko Hok",
        "zip_codes": [
            42170
        ],
        "district_id": 4206
    },
    {
        "id": 420701,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            42160
        ],
        "district_id": 4207
    },
    {
        "id": 420702,
        "name_th": "ท่าศาลา",
        "name_en": "Tha Sala",
        "zip_codes": [
            42160
        ],
        "district_id": 4207
    },
    {
        "id": 420703,
        "name_th": "ร่องจิก",
        "name_en": "Rong Chik",
        "zip_codes": [
            42160
        ],
        "district_id": 4207
    },
    {
        "id": 420704,
        "name_th": "ปลาบ่า",
        "name_en": "Pla Ba",
        "zip_codes": [
            42160
        ],
        "district_id": 4207
    },
    {
        "id": 420705,
        "name_th": "ลาดค่าง",
        "name_en": "Lat Khang",
        "zip_codes": [
            42160
        ],
        "district_id": 4207
    },
    {
        "id": 420706,
        "name_th": "สานตม",
        "name_en": "San Tom",
        "zip_codes": [
            42160
        ],
        "district_id": 4207
    },
    {
        "id": 420801,
        "name_th": "ท่าลี่",
        "name_en": "Tha Li",
        "zip_codes": [
            42140
        ],
        "district_id": 4208
    },
    {
        "id": 420802,
        "name_th": "หนองผือ",
        "name_en": "Nong Phue",
        "zip_codes": [
            42140
        ],
        "district_id": 4208
    },
    {
        "id": 420803,
        "name_th": "อาฮี",
        "name_en": "Ahi",
        "zip_codes": [
            42140
        ],
        "district_id": 4208
    },
    {
        "id": 420804,
        "name_th": "น้ำแคม",
        "name_en": "Nam Khaem",
        "zip_codes": [
            42140
        ],
        "district_id": 4208
    },
    {
        "id": 420805,
        "name_th": "โคกใหญ่",
        "name_en": "Khok Yai",
        "zip_codes": [
            42140
        ],
        "district_id": 4208
    },
    {
        "id": 420806,
        "name_th": "น้ำทูน",
        "name_en": "Nam Thun",
        "zip_codes": [
            42140
        ],
        "district_id": 4208
    },
    {
        "id": 420901,
        "name_th": "วังสะพุง",
        "name_en": "Wang Saphung",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 420902,
        "name_th": "ทรายขาว",
        "name_en": "Sai Khao",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 420903,
        "name_th": "หนองหญ้าปล้อง",
        "name_en": "Nong Ya Plong",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 420904,
        "name_th": "หนองงิ้ว",
        "name_en": "Nong Ngio",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 420905,
        "name_th": "ปากปวน",
        "name_en": "Pak Puan",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 420906,
        "name_th": "ผาน้อย",
        "name_en": "Pha Noi",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 420910,
        "name_th": "ผาบิ้ง",
        "name_en": "Pha Bing",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 420911,
        "name_th": "เขาหลวง",
        "name_en": "Khao Luang",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 420912,
        "name_th": "โคกขมิ้น",
        "name_en": "Khok Khamin",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 420913,
        "name_th": "ศรีสงคราม",
        "name_en": "Si Songkhram",
        "zip_codes": [
            42130
        ],
        "district_id": 4209
    },
    {
        "id": 421001,
        "name_th": "ศรีฐาน",
        "name_en": "Si Than",
        "zip_codes": [
            42180
        ],
        "district_id": 4210
    },
    {
        "id": 421005,
        "name_th": "ผานกเค้า",
        "name_en": "Pha Nok Khao",
        "zip_codes": [
            42180
        ],
        "district_id": 4210
    },
    {
        "id": 421007,
        "name_th": "ภูกระดึง",
        "name_en": "Phu Kradueng",
        "zip_codes": [
            42180
        ],
        "district_id": 4210
    },
    {
        "id": 421010,
        "name_th": "ห้วยส้ม",
        "name_en": "Huai Som",
        "zip_codes": [
            42180
        ],
        "district_id": 4210
    },
    {
        "id": 421101,
        "name_th": "ภูหอ",
        "name_en": "Phu Ho",
        "zip_codes": [
            42230
        ],
        "district_id": 4211
    },
    {
        "id": 421102,
        "name_th": "หนองคัน",
        "name_en": "Nong Khan",
        "zip_codes": [
            42230
        ],
        "district_id": 4211
    },
    {
        "id": 421104,
        "name_th": "ห้วยสีเสียด",
        "name_en": "Huai Sisiat",
        "zip_codes": [
            42230
        ],
        "district_id": 4211
    },
    {
        "id": 421105,
        "name_th": "เลยวังไสย์",
        "name_en": "Loei Wang Sai",
        "zip_codes": [
            42230
        ],
        "district_id": 4211
    },
    {
        "id": 421106,
        "name_th": "แก่งศรีภูมิ",
        "name_en": "Kaeng Si Phum",
        "zip_codes": [
            42230
        ],
        "district_id": 4211
    },
    {
        "id": 421201,
        "name_th": "ผาขาว",
        "name_en": "Pha Khao",
        "zip_codes": [
            42240
        ],
        "district_id": 4212
    },
    {
        "id": 421202,
        "name_th": "ท่าช้างคล้อง",
        "name_en": "Tha Chang Khlong",
        "zip_codes": [
            42240
        ],
        "district_id": 4212
    },
    {
        "id": 421203,
        "name_th": "โนนปอแดง",
        "name_en": "Non Po Daeng",
        "zip_codes": [
            42240
        ],
        "district_id": 4212
    },
    {
        "id": 421204,
        "name_th": "โนนป่าซาง",
        "name_en": "Non Pa Sang",
        "zip_codes": [
            42240
        ],
        "district_id": 4212
    },
    {
        "id": 421205,
        "name_th": "บ้านเพิ่ม",
        "name_en": "Ban Phoem",
        "zip_codes": [
            42240
        ],
        "district_id": 4212
    },
    {
        "id": 421301,
        "name_th": "เอราวัณ",
        "name_en": "Erawan",
        "zip_codes": [
            42220
        ],
        "district_id": 4213
    },
    {
        "id": 421302,
        "name_th": "ผาอินทร์แปลง",
        "name_en": "Pha In Plaeng",
        "zip_codes": [
            42220
        ],
        "district_id": 4213
    },
    {
        "id": 421303,
        "name_th": "ผาสามยอด",
        "name_en": "Pha Sam Yot",
        "zip_codes": [
            42220
        ],
        "district_id": 4213
    },
    {
        "id": 421304,
        "name_th": "ทรัพย์ไพวัลย์",
        "name_en": "Sap Phaiwan",
        "zip_codes": [
            42220
        ],
        "district_id": 4213
    },
    {
        "id": 421401,
        "name_th": "หนองหิน",
        "name_en": "Nong Hin",
        "zip_codes": [
            42190
        ],
        "district_id": 4214
    },
    {
        "id": 421402,
        "name_th": "ตาดข่า",
        "name_en": "Tat Kha",
        "zip_codes": [
            42190
        ],
        "district_id": 4214
    },
    {
        "id": 421403,
        "name_th": "ปวนพุ",
        "name_en": "Puan Phu",
        "zip_codes": [
            42190
        ],
        "district_id": 4214
    },
    {
        "id": 430101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430102,
        "name_th": "มีชัย",
        "name_en": "Mi Chai",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430103,
        "name_th": "โพธิ์ชัย",
        "name_en": "Pho Chai",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430104,
        "name_th": "กวนวัน",
        "name_en": "Kuan Wan",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430105,
        "name_th": "เวียงคุก",
        "name_en": "Wiang Khuk",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430106,
        "name_th": "วัดธาตุ",
        "name_en": "Wat That",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430107,
        "name_th": "หาดคำ",
        "name_en": "Hat Kham",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430108,
        "name_th": "หินโงม",
        "name_en": "Hin Ngom",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430109,
        "name_th": "บ้านเดื่อ",
        "name_en": "Ban Duea",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430110,
        "name_th": "ค่ายบกหวาน",
        "name_en": "Khai Bok Wan",
        "zip_codes": [
            43100
        ],
        "district_id": 4301
    },
    {
        "id": 430111,
        "name_th": "โพนสว่าง",
        "name_en": "Phon Sawang",
        "zip_codes": [
            43100
        ],
        "district_id": 4301
    },
    {
        "id": 430113,
        "name_th": "พระธาตุบังพวน",
        "name_en": "Phra That Bang Phuan",
        "zip_codes": [
            43100
        ],
        "district_id": 4301
    },
    {
        "id": 430116,
        "name_th": "หนองกอมเกาะ",
        "name_en": "Nong Kom Ko",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430117,
        "name_th": "ปะโค",
        "name_en": "Pa Kho",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430118,
        "name_th": "เมืองหมี",
        "name_en": "Mueang Mi",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430119,
        "name_th": "สีกาย",
        "name_en": "Si Kai",
        "zip_codes": [
            43000
        ],
        "district_id": 4301
    },
    {
        "id": 430201,
        "name_th": "ท่าบ่อ",
        "name_en": "Tha Bo",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430202,
        "name_th": "น้ำโมง",
        "name_en": "Nam Mong",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430203,
        "name_th": "กองนาง",
        "name_en": "Kong Nang",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430204,
        "name_th": "โคกคอน",
        "name_en": "Khok Khon",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430205,
        "name_th": "บ้านเดื่อ",
        "name_en": "Ban Duea",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430206,
        "name_th": "บ้านถ่อน",
        "name_en": "Ban Thon",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430207,
        "name_th": "บ้านว่าน",
        "name_en": "Ban Wan",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430208,
        "name_th": "นาข่า",
        "name_en": "Na Kha",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430209,
        "name_th": "โพนสา",
        "name_en": "Phon Sa",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430210,
        "name_th": "หนองนาง",
        "name_en": "Nong Nang",
        "zip_codes": [
            43110
        ],
        "district_id": 4302
    },
    {
        "id": 430501,
        "name_th": "จุมพล",
        "name_en": "Chumphon",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430502,
        "name_th": "วัดหลวง",
        "name_en": "Wat Luang",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430503,
        "name_th": "กุดบง",
        "name_en": "Kut Bong",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430504,
        "name_th": "ชุมช้าง",
        "name_en": "Chum Chang",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430506,
        "name_th": "ทุ่งหลวง",
        "name_en": "Thung Luang",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430507,
        "name_th": "เหล่าต่างคำ",
        "name_en": "Lao Tang Kham",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430508,
        "name_th": "นาหนัง",
        "name_en": "Na Nang",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430509,
        "name_th": "เซิม",
        "name_en": "Soem",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430513,
        "name_th": "บ้านโพธิ์",
        "name_en": "Ban Pho",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430521,
        "name_th": "บ้านผือ",
        "name_en": "Ban Phue",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430522,
        "name_th": "สร้างนางขาว",
        "name_en": "Sang Nang Khao",
        "zip_codes": [
            43120
        ],
        "district_id": 4305
    },
    {
        "id": 430701,
        "name_th": "พานพร้าว",
        "name_en": "Phan Phrao",
        "zip_codes": [
            43130
        ],
        "district_id": 4307
    },
    {
        "id": 430703,
        "name_th": "บ้านหม้อ",
        "name_en": "Ban Mo",
        "zip_codes": [
            43130
        ],
        "district_id": 4307
    },
    {
        "id": 430704,
        "name_th": "พระพุทธบาท",
        "name_en": "Phra Phutthabat",
        "zip_codes": [
            43130
        ],
        "district_id": 4307
    },
    {
        "id": 430705,
        "name_th": "หนองปลาปาก",
        "name_en": "Nong Pla Pak",
        "zip_codes": [
            43130
        ],
        "district_id": 4307
    },
    {
        "id": 430801,
        "name_th": "แก้งไก่",
        "name_en": "Kaeng Kai",
        "zip_codes": [
            43160
        ],
        "district_id": 4308
    },
    {
        "id": 430802,
        "name_th": "ผาตั้ง",
        "name_en": "Pha Tang",
        "zip_codes": [
            43160
        ],
        "district_id": 4308
    },
    {
        "id": 430803,
        "name_th": "บ้านม่วง",
        "name_en": "Ban Muang",
        "zip_codes": [
            43160
        ],
        "district_id": 4308
    },
    {
        "id": 430804,
        "name_th": "นางิ้ว",
        "name_en": "Na Ngio",
        "zip_codes": [
            43160
        ],
        "district_id": 4308
    },
    {
        "id": 430805,
        "name_th": "สังคม",
        "name_en": "Sangkhom",
        "zip_codes": [
            43160
        ],
        "district_id": 4308
    },
    {
        "id": 431401,
        "name_th": "สระใคร",
        "name_en": "Sakhrai",
        "zip_codes": [
            43100
        ],
        "district_id": 4314
    },
    {
        "id": 431402,
        "name_th": "คอกช้าง",
        "name_en": "Khok Chang",
        "zip_codes": [
            43100
        ],
        "district_id": 4314
    },
    {
        "id": 431403,
        "name_th": "บ้านฝาง",
        "name_en": "Ban Fang",
        "zip_codes": [
            43100
        ],
        "district_id": 4314
    },
    {
        "id": 431501,
        "name_th": "เฝ้าไร่",
        "name_en": "Fao Rai",
        "zip_codes": [
            43230
        ],
        "district_id": 4315
    },
    {
        "id": 431502,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            43230
        ],
        "district_id": 4315
    },
    {
        "id": 431503,
        "name_th": "หนองหลวง",
        "name_en": "Nong Luang",
        "zip_codes": [
            43230
        ],
        "district_id": 4315
    },
    {
        "id": 431504,
        "name_th": "วังหลวง",
        "name_en": "wang Luang",
        "zip_codes": [
            43230
        ],
        "district_id": 4315
    },
    {
        "id": 431505,
        "name_th": "อุดมพร",
        "name_en": "Udom Phon",
        "zip_codes": [
            43230
        ],
        "district_id": 4315
    },
    {
        "id": 431601,
        "name_th": "รัตนวาปี",
        "name_en": "Rattanawapi",
        "zip_codes": [
            43120
        ],
        "district_id": 4316
    },
    {
        "id": 431602,
        "name_th": "นาทับไฮ",
        "name_en": "Na Thap Hai",
        "zip_codes": [
            43120
        ],
        "district_id": 4316
    },
    {
        "id": 431603,
        "name_th": "บ้านต้อน",
        "name_en": "Ban Ton",
        "zip_codes": [
            43120
        ],
        "district_id": 4316
    },
    {
        "id": 431604,
        "name_th": "พระบาทนาสิงห์",
        "name_en": "Phra Bat Na Sing",
        "zip_codes": [
            43120
        ],
        "district_id": 4316
    },
    {
        "id": 431605,
        "name_th": "โพนแพง",
        "name_en": "Phon Phaeng",
        "zip_codes": [
            43120
        ],
        "district_id": 4316
    },
    {
        "id": 431701,
        "name_th": "โพธิ์ตาก",
        "name_en": "Pho Tak",
        "zip_codes": [
            43130
        ],
        "district_id": 4317
    },
    {
        "id": 431702,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            43130
        ],
        "district_id": 4317
    },
    {
        "id": 431703,
        "name_th": "ด่านศรีสุข",
        "name_en": "Dan Si Suk",
        "zip_codes": [
            43130
        ],
        "district_id": 4317
    },
    {
        "id": 440101,
        "name_th": "ตลาด",
        "name_en": "Talat",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440102,
        "name_th": "เขวา",
        "name_en": "Khwao",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440103,
        "name_th": "ท่าตูม",
        "name_en": "Tha Tum",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440104,
        "name_th": "แวงน่าง",
        "name_en": "Waeng Nang",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440105,
        "name_th": "โคกก่อ",
        "name_en": "Khok Ko",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440106,
        "name_th": "ดอนหว่าน",
        "name_en": "Don Wan",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440107,
        "name_th": "เกิ้ง",
        "name_en": "Koeng",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440108,
        "name_th": "แก่งเลิงจาน",
        "name_en": "Kaeng Loeng Chan",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440109,
        "name_th": "ท่าสองคอน",
        "name_en": "Tha Song Khon",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440110,
        "name_th": "ลาดพัฒนา",
        "name_en": "Lat Phatthana",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440111,
        "name_th": "หนองปลิง",
        "name_en": "Nong Pling",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440112,
        "name_th": "ห้วยแอ่ง",
        "name_en": "Huai Aeng",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440113,
        "name_th": "หนองโน",
        "name_en": "Nong No",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440114,
        "name_th": "บัวค้อ",
        "name_en": "Bua Kho",
        "zip_codes": [
            44000
        ],
        "district_id": 4401
    },
    {
        "id": 440201,
        "name_th": "แกดำ",
        "name_en": "Kae Dam",
        "zip_codes": [
            44190
        ],
        "district_id": 4402
    },
    {
        "id": 440202,
        "name_th": "วังแสง",
        "name_en": "Wang Saeng",
        "zip_codes": [
            44190
        ],
        "district_id": 4402
    },
    {
        "id": 440203,
        "name_th": "มิตรภาพ",
        "name_en": "Mittraphap",
        "zip_codes": [
            44190
        ],
        "district_id": 4402
    },
    {
        "id": 440204,
        "name_th": "หนองกุง",
        "name_en": "Nong Kung",
        "zip_codes": [
            44190
        ],
        "district_id": 4402
    },
    {
        "id": 440205,
        "name_th": "โนนภิบาล",
        "name_en": "Non Phiban",
        "zip_codes": [
            44190
        ],
        "district_id": 4402
    },
    {
        "id": 440301,
        "name_th": "หัวขวาง",
        "name_en": "Hua Khwang",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440302,
        "name_th": "ยางน้อย",
        "name_en": "Yang Noi",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440303,
        "name_th": "วังยาว",
        "name_en": "Wang Yao",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440304,
        "name_th": "เขวาไร่",
        "name_en": "Khwao Rai",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440305,
        "name_th": "แพง",
        "name_en": "Phaeng",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440306,
        "name_th": "แก้งแก",
        "name_en": "Kaeng Kae",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440307,
        "name_th": "หนองเหล็ก",
        "name_en": "Nong Lek",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440308,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440309,
        "name_th": "เหล่า",
        "name_en": "Lao",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440310,
        "name_th": "เขื่อน",
        "name_en": "Khuean",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440311,
        "name_th": "หนองบอน",
        "name_en": "Nong Bon",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440312,
        "name_th": "โพนงาม",
        "name_en": "Phon Ngam",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440313,
        "name_th": "ยางท่าแจ้ง",
        "name_en": "Yang Tha Chaeng",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440314,
        "name_th": "แห่ใต้",
        "name_en": "Hae Tai",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440315,
        "name_th": "หนองกุงสวรรค์",
        "name_en": "Nong Kung Sawan",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440316,
        "name_th": "เลิงใต้",
        "name_en": "Loeng Tai",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440317,
        "name_th": "ดอนกลาง",
        "name_en": "Don Klang",
        "zip_codes": [
            44140
        ],
        "district_id": 4403
    },
    {
        "id": 440401,
        "name_th": "โคกพระ",
        "name_en": "Khok Phra",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440402,
        "name_th": "คันธารราษฎร์",
        "name_en": "Khanthararat",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440403,
        "name_th": "มะค่า",
        "name_en": "Makha",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440404,
        "name_th": "ท่าขอนยาง",
        "name_en": "Tha Khon Yang",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440405,
        "name_th": "นาสีนวน",
        "name_en": "Na Si Nuan",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440406,
        "name_th": "ขามเรียง",
        "name_en": "Kham Riang",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440407,
        "name_th": "เขวาใหญ่",
        "name_en": "Khwao Yai",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440408,
        "name_th": "ศรีสุข",
        "name_en": "Si Suk",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440409,
        "name_th": "กุดใส้จ่อ",
        "name_en": "Kut Sai Cho",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440410,
        "name_th": "ขามเฒ่าพัฒนา",
        "name_en": "Kham Thao Phatthana",
        "zip_codes": [
            44150
        ],
        "district_id": 4404
    },
    {
        "id": 440501,
        "name_th": "เชียงยืน",
        "name_en": "Chiang Yuen",
        "zip_codes": [
            44160
        ],
        "district_id": 4405
    },
    {
        "id": 440503,
        "name_th": "หนองซอน",
        "name_en": "Nong Son",
        "zip_codes": [
            44160
        ],
        "district_id": 4405
    },
    {
        "id": 440505,
        "name_th": "ดอนเงิน",
        "name_en": "Don Ngoen",
        "zip_codes": [
            44160
        ],
        "district_id": 4405
    },
    {
        "id": 440506,
        "name_th": "กู่ทอง",
        "name_en": "Ku Thong",
        "zip_codes": [
            44160
        ],
        "district_id": 4405
    },
    {
        "id": 440507,
        "name_th": "นาทอง",
        "name_en": "Na Thong",
        "zip_codes": [
            44160
        ],
        "district_id": 4405
    },
    {
        "id": 440508,
        "name_th": "เสือเฒ่า",
        "name_en": "Suea Thao",
        "zip_codes": [
            44160
        ],
        "district_id": 4405
    },
    {
        "id": 440511,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            44160
        ],
        "district_id": 4405
    },
    {
        "id": 440512,
        "name_th": "เหล่าบัวบาน",
        "name_en": "Lao Bua Ban",
        "zip_codes": [
            44160
        ],
        "district_id": 4405
    },
    {
        "id": 440601,
        "name_th": "บรบือ",
        "name_en": "Borabue",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440602,
        "name_th": "บ่อใหญ่",
        "name_en": "Bo Yai",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440604,
        "name_th": "วังไชย",
        "name_en": "Wang Chai",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440605,
        "name_th": "หนองม่วง",
        "name_en": "Nong Muang",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440606,
        "name_th": "กำพี้",
        "name_en": "Kam Phi",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440607,
        "name_th": "โนนราษี",
        "name_en": "Non Rasi",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440608,
        "name_th": "โนนแดง",
        "name_en": "Non Daeng",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440610,
        "name_th": "หนองจิก",
        "name_en": "Nong Chik",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440611,
        "name_th": "บัวมาศ",
        "name_en": "Bua Mat",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440613,
        "name_th": "หนองคูขาด",
        "name_en": "Nong Khu Khat",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440615,
        "name_th": "วังใหม่",
        "name_en": "Wang Mai",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440616,
        "name_th": "ยาง",
        "name_en": "Yang",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440618,
        "name_th": "หนองสิม",
        "name_en": "Nong Sim",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440619,
        "name_th": "หนองโก",
        "name_en": "Nong Ko",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440620,
        "name_th": "ดอนงัว",
        "name_en": "Don Ngua",
        "zip_codes": [
            44130
        ],
        "district_id": 4406
    },
    {
        "id": 440701,
        "name_th": "นาเชือก",
        "name_en": "Na Chueak",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440702,
        "name_th": "สำโรง",
        "name_en": "Samrong",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440703,
        "name_th": "หนองแดง",
        "name_en": "Nong Daeng",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440704,
        "name_th": "เขวาไร่",
        "name_en": "Khwao Rai",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440705,
        "name_th": "หนองโพธิ์",
        "name_en": "Nong Pho",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440706,
        "name_th": "ปอพาน",
        "name_en": "Po Phan",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440707,
        "name_th": "หนองเม็ก",
        "name_en": "Nong Mek",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440708,
        "name_th": "หนองเรือ",
        "name_en": "Nong Ruea",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440709,
        "name_th": "หนองกุง",
        "name_en": "Nong Kung",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440710,
        "name_th": "สันป่าตอง",
        "name_en": "San Pa Tong",
        "zip_codes": [
            44170
        ],
        "district_id": 4407
    },
    {
        "id": 440801,
        "name_th": "ปะหลาน",
        "name_en": "Palan",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440802,
        "name_th": "ก้ามปู",
        "name_en": "Kham Pu",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440803,
        "name_th": "เวียงสะอาด",
        "name_en": "Wiang Sa-at",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440804,
        "name_th": "เม็กดำ",
        "name_en": "Mek Dam",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440805,
        "name_th": "นาสีนวล",
        "name_en": "Na Si Nuan",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440809,
        "name_th": "ราษฎร์เจริญ",
        "name_en": "Rat Charoen",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440810,
        "name_th": "หนองบัวแก้ว",
        "name_en": "Nong Bua Kaeo",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440812,
        "name_th": "เมืองเตา",
        "name_en": "Mueang Tao",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440815,
        "name_th": "ลานสะแก",
        "name_en": "Lan Sakae",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440816,
        "name_th": "เวียงชัย",
        "name_en": "Wiang Chai",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440817,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440818,
        "name_th": "ราษฎร์พัฒนา",
        "name_en": "Rat Phatthana",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440819,
        "name_th": "เมืองเสือ",
        "name_en": "Mueang Suea",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440820,
        "name_th": "ภารแอ่น",
        "name_en": "Phan Aen",
        "zip_codes": [
            44110
        ],
        "district_id": 4408
    },
    {
        "id": 440901,
        "name_th": "หนองแสง",
        "name_en": "Nong Saeng",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440902,
        "name_th": "ขามป้อม",
        "name_en": "Kham Pom",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440903,
        "name_th": "เสือโก้ก",
        "name_en": "Suea Kok",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440904,
        "name_th": "ดงใหญ่",
        "name_en": "Dong Yai",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440905,
        "name_th": "โพธิ์ชัย",
        "name_en": "Pho Chai",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440906,
        "name_th": "หัวเรือ",
        "name_en": "Hua Ruea",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440907,
        "name_th": "แคน",
        "name_en": "Khaen",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440908,
        "name_th": "งัวบา",
        "name_en": "Ngua Ba",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440909,
        "name_th": "นาข่า",
        "name_en": "Na Kha",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440910,
        "name_th": "บ้านหวาย",
        "name_en": "Ban Wai",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440911,
        "name_th": "หนองไฮ",
        "name_en": "Nong Hai",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440912,
        "name_th": "ประชาพัฒนา",
        "name_en": "Pracha Phatthana",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440913,
        "name_th": "หนองทุ่ม",
        "name_en": "Nong Thum",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440914,
        "name_th": "หนองแสน",
        "name_en": "Nong Saen",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 440915,
        "name_th": "โคกสีทองหลาง",
        "name_en": "Khok Si Thonglang",
        "zip_codes": [
            44120
        ],
        "district_id": 4409
    },
    {
        "id": 441001,
        "name_th": "นาดูน",
        "name_en": "Na Dun",
        "zip_codes": [
            44180
        ],
        "district_id": 4410
    },
    {
        "id": 441002,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            44180
        ],
        "district_id": 4410
    },
    {
        "id": 441003,
        "name_th": "หนองคู",
        "name_en": "Nong Khu",
        "zip_codes": [
            44180
        ],
        "district_id": 4410
    },
    {
        "id": 441004,
        "name_th": "ดงบัง",
        "name_en": "Dong Bang",
        "zip_codes": [
            44180
        ],
        "district_id": 4410
    },
    {
        "id": 441005,
        "name_th": "ดงดวน",
        "name_en": "Dong Duan",
        "zip_codes": [
            44180
        ],
        "district_id": 4410
    },
    {
        "id": 441006,
        "name_th": "หัวดง",
        "name_en": "Hua Dong",
        "zip_codes": [
            44180
        ],
        "district_id": 4410
    },
    {
        "id": 441007,
        "name_th": "ดงยาง",
        "name_en": "Dong Yang",
        "zip_codes": [
            44180
        ],
        "district_id": 4410
    },
    {
        "id": 441008,
        "name_th": "กู่สันตรัตน์",
        "name_en": "Ku Santarat",
        "zip_codes": [
            44180
        ],
        "district_id": 4410
    },
    {
        "id": 441009,
        "name_th": "พระธาตุ",
        "name_en": "Phra That",
        "zip_codes": [
            44180
        ],
        "district_id": 4410
    },
    {
        "id": 441101,
        "name_th": "ยางสีสุราช",
        "name_en": "Yang Si Surat",
        "zip_codes": [
            44210
        ],
        "district_id": 4411
    },
    {
        "id": 441102,
        "name_th": "นาภู",
        "name_en": "Na Phu",
        "zip_codes": [
            44210
        ],
        "district_id": 4411
    },
    {
        "id": 441103,
        "name_th": "แวงดง",
        "name_en": "Waeng Dong",
        "zip_codes": [
            44210
        ],
        "district_id": 4411
    },
    {
        "id": 441104,
        "name_th": "บ้านกู่",
        "name_en": "Ban Ku",
        "zip_codes": [
            44210
        ],
        "district_id": 4411
    },
    {
        "id": 441105,
        "name_th": "ดงเมือง",
        "name_en": "Dong Mueang",
        "zip_codes": [
            44210
        ],
        "district_id": 4411
    },
    {
        "id": 441106,
        "name_th": "สร้างแซ่ง",
        "name_en": "Sang Saeng",
        "zip_codes": [
            44210
        ],
        "district_id": 4411
    },
    {
        "id": 441107,
        "name_th": "หนองบัวสันตุ",
        "name_en": "Nong Bua Santu",
        "zip_codes": [
            44210
        ],
        "district_id": 4411
    },
    {
        "id": 441201,
        "name_th": "กุดรัง",
        "name_en": "Kut Rang",
        "zip_codes": [
            44130
        ],
        "district_id": 4412
    },
    {
        "id": 441202,
        "name_th": "นาโพธิ์",
        "name_en": "Na Pho",
        "zip_codes": [
            44130
        ],
        "district_id": 4412
    },
    {
        "id": 441203,
        "name_th": "เลิงแฝก",
        "name_en": "Loeng Faek",
        "zip_codes": [
            44130
        ],
        "district_id": 4412
    },
    {
        "id": 441204,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            44130
        ],
        "district_id": 4412
    },
    {
        "id": 441205,
        "name_th": "ห้วยเตย",
        "name_en": "Huai Toei",
        "zip_codes": [
            44130
        ],
        "district_id": 4412
    },
    {
        "id": 441301,
        "name_th": "ชื่นชม",
        "name_en": "Chuen Chom",
        "zip_codes": [
            44160
        ],
        "district_id": 4413
    },
    {
        "id": 441302,
        "name_th": "กุดปลาดุก",
        "name_en": "Kut Pla Duk",
        "zip_codes": [
            44160
        ],
        "district_id": 4413
    },
    {
        "id": 441303,
        "name_th": "เหล่าดอกไม้",
        "name_en": "Lao Dok Mai",
        "zip_codes": [
            44160
        ],
        "district_id": 4413
    },
    {
        "id": 441304,
        "name_th": "หนองกุง",
        "name_en": "Nong Kung",
        "zip_codes": [
            44160
        ],
        "district_id": 4413
    },
    {
        "id": 450101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450102,
        "name_th": "รอบเมือง",
        "name_en": "Rop Mueang",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450103,
        "name_th": "เหนือเมือง",
        "name_en": "Nuea Mueang",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450104,
        "name_th": "ขอนแก่น",
        "name_en": "Khon Kaen",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450105,
        "name_th": "นาโพธิ์",
        "name_en": "Na Pho",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450106,
        "name_th": "สะอาดสมบูรณ์",
        "name_en": "Sa-at Sombun",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450108,
        "name_th": "สีแก้ว",
        "name_en": "Si Kaeo",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450109,
        "name_th": "ปอภาร",
        "name_en": "Po Phan",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450110,
        "name_th": "โนนรัง",
        "name_en": "Non Rang",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450117,
        "name_th": "หนองแก้ว",
        "name_en": "Nong Kaeo",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450118,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450120,
        "name_th": "ดงลาน",
        "name_en": "Dong Lan",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450123,
        "name_th": "แคนใหญ่",
        "name_en": "Khaen Yai",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450124,
        "name_th": "โนนตาล",
        "name_en": "Non Tan",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450125,
        "name_th": "เมืองทอง",
        "name_en": "Mueang Thong",
        "zip_codes": [
            45000
        ],
        "district_id": 4501
    },
    {
        "id": 450201,
        "name_th": "เกษตรวิสัย",
        "name_en": "Kaset Wisai",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450202,
        "name_th": "เมืองบัว",
        "name_en": "Mueang Bua",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450203,
        "name_th": "เหล่าหลวง",
        "name_en": "Lao Luang",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450204,
        "name_th": "สิงห์โคก",
        "name_en": "Sing Khok",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450205,
        "name_th": "ดงครั่งใหญ่",
        "name_en": "Dong Khrang Yai",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450206,
        "name_th": "บ้านฝาง",
        "name_en": "Ban Fang",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450207,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450208,
        "name_th": "กำแพง",
        "name_en": "Kamphaeng",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450209,
        "name_th": "กู่กาสิงห์",
        "name_en": "Ku Ka Sing",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450210,
        "name_th": "น้ำอ้อม",
        "name_en": "Nam Om",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450211,
        "name_th": "โนนสว่าง",
        "name_en": "Non Sawang",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450212,
        "name_th": "ทุ่งทอง",
        "name_en": "Thung Thong",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450213,
        "name_th": "ดงครั่งน้อย",
        "name_en": "Dong Khrang Noi",
        "zip_codes": [
            45150
        ],
        "district_id": 4502
    },
    {
        "id": 450301,
        "name_th": "บัวแดง",
        "name_en": "Bua Daeng",
        "zip_codes": [
            45190
        ],
        "district_id": 4503
    },
    {
        "id": 450302,
        "name_th": "ดอกล้ำ",
        "name_en": "Dok Lam",
        "zip_codes": [
            45190
        ],
        "district_id": 4503
    },
    {
        "id": 450303,
        "name_th": "หนองแคน",
        "name_en": "Nong Khaen",
        "zip_codes": [
            45190
        ],
        "district_id": 4503
    },
    {
        "id": 450304,
        "name_th": "โพนสูง",
        "name_en": "Phon Sung",
        "zip_codes": [
            45190
        ],
        "district_id": 4503
    },
    {
        "id": 450305,
        "name_th": "โนนสวรรค์",
        "name_en": "Non Sawan",
        "zip_codes": [
            45190
        ],
        "district_id": 4503
    },
    {
        "id": 450306,
        "name_th": "สระบัว",
        "name_en": "Sa Bua",
        "zip_codes": [
            45190
        ],
        "district_id": 4503
    },
    {
        "id": 450307,
        "name_th": "โนนสง่า",
        "name_en": "Non Sa-nga",
        "zip_codes": [
            45190
        ],
        "district_id": 4503
    },
    {
        "id": 450308,
        "name_th": "ขี้เหล็ก",
        "name_en": "Khilek",
        "zip_codes": [
            45190
        ],
        "district_id": 4503
    },
    {
        "id": 450401,
        "name_th": "หัวช้าง",
        "name_en": "Hua Chang",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450402,
        "name_th": "หนองผือ",
        "name_en": "Nong Phue",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450403,
        "name_th": "เมืองหงส์",
        "name_en": "Mueang Hong",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450404,
        "name_th": "โคกล่าม",
        "name_en": "Khok Lam",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450405,
        "name_th": "น้ำใส",
        "name_en": "Nam Sai",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450406,
        "name_th": "ดงแดง",
        "name_en": "Dong Daeng",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450407,
        "name_th": "ดงกลาง",
        "name_en": "Dong Klang",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450408,
        "name_th": "ป่าสังข์",
        "name_en": "Pa Sang",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450409,
        "name_th": "อีง่อง",
        "name_en": "I Ngong",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450410,
        "name_th": "ลิ้นฟ้า",
        "name_en": "Lin Fa",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450411,
        "name_th": "ดู่น้อย",
        "name_en": "Du Noi",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450412,
        "name_th": "ศรีโคตร",
        "name_en": "Si Khot",
        "zip_codes": [
            45180
        ],
        "district_id": 4504
    },
    {
        "id": 450501,
        "name_th": "นิเวศน์",
        "name_en": "Niwet",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450502,
        "name_th": "ธงธานี",
        "name_en": "Thong Thani",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450503,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450504,
        "name_th": "ธวัชบุรี",
        "name_en": "Thawat Buri",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450506,
        "name_th": "อุ่มเม้า",
        "name_en": "Um Mao",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450507,
        "name_th": "มะอึ",
        "name_en": "Ma-ue",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450510,
        "name_th": "เขวาทุ่ง",
        "name_en": "Khwao Thung",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450515,
        "name_th": "ไพศาล",
        "name_en": "Phaisan",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450517,
        "name_th": "เมืองน้อย",
        "name_en": "Mueang Noi",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450520,
        "name_th": "บึงนคร",
        "name_en": "Bueng Nakhon",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450522,
        "name_th": "ราชธานี",
        "name_en": "Ratchathani",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450524,
        "name_th": "หนองพอก",
        "name_en": "Nong Phok",
        "zip_codes": [
            45170
        ],
        "district_id": 4505
    },
    {
        "id": 450601,
        "name_th": "พนมไพร",
        "name_en": "Phanom Phrai",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450602,
        "name_th": "แสนสุข",
        "name_en": "Saen Suk",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450603,
        "name_th": "กุดน้ำใส",
        "name_en": "Kut Nam Sai",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450604,
        "name_th": "หนองทัพไทย",
        "name_en": "Nong Thap Thai",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450605,
        "name_th": "โพธิ์ใหญ่",
        "name_en": "Pho Yai",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450606,
        "name_th": "วารีสวัสดิ์",
        "name_en": "Wari Sawat",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450607,
        "name_th": "โคกสว่าง",
        "name_en": "Khok Sawang",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450611,
        "name_th": "โพธิ์ชัย",
        "name_en": "Pho Chai",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450612,
        "name_th": "นานวล",
        "name_en": "Na Nuan",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450613,
        "name_th": "คำไฮ",
        "name_en": "Kham Hai",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450614,
        "name_th": "สระแก้ว",
        "name_en": "Sa Kaeo",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450615,
        "name_th": "ค้อใหญ่",
        "name_en": "Kho Yai",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450617,
        "name_th": "ชานุวรรณ",
        "name_en": "Chanuwan",
        "zip_codes": [
            45140
        ],
        "district_id": 4506
    },
    {
        "id": 450701,
        "name_th": "แวง",
        "name_en": "Waeng",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450702,
        "name_th": "โคกกกม่วง",
        "name_en": "Khok Kok Muang",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450703,
        "name_th": "นาอุดม",
        "name_en": "Na Udom",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450704,
        "name_th": "สว่าง",
        "name_en": "Sawang",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450705,
        "name_th": "หนองใหญ่",
        "name_en": "Nong Yai",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450706,
        "name_th": "โพธิ์ทอง",
        "name_en": "Pho Thong",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450707,
        "name_th": "โนนชัยศรี",
        "name_en": "Non Chai Si",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450708,
        "name_th": "โพธิ์ศรีสว่าง",
        "name_en": "Pho Si Sawang",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450709,
        "name_th": "อุ่มเม่า",
        "name_en": "Um Mao",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450710,
        "name_th": "คำนาดี",
        "name_en": "Na Di",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450711,
        "name_th": "พรมสวรรค์",
        "name_en": "Phrom Sawan",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450712,
        "name_th": "สระนกแก้ว",
        "name_en": "Sa Nok Kaeo",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450713,
        "name_th": "วังสามัคคี",
        "name_en": "Wang Samakkhi",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450714,
        "name_th": "โคกสูง",
        "name_en": "Khok Sung",
        "zip_codes": [
            45110
        ],
        "district_id": 4507
    },
    {
        "id": 450801,
        "name_th": "ขามเปี้ย",
        "name_en": "Kham Pia",
        "zip_codes": [
            45230
        ],
        "district_id": 4508
    },
    {
        "id": 450802,
        "name_th": "เชียงใหม่",
        "name_en": "Chiang Mai",
        "zip_codes": [
            45230
        ],
        "district_id": 4508
    },
    {
        "id": 450803,
        "name_th": "บัวคำ",
        "name_en": "Bua Kham",
        "zip_codes": [
            45230
        ],
        "district_id": 4508
    },
    {
        "id": 450804,
        "name_th": "อัคคะคำ",
        "name_en": "Akkha Kham",
        "zip_codes": [
            45230
        ],
        "district_id": 4508
    },
    {
        "id": 450805,
        "name_th": "สะอาด",
        "name_en": "Sa-at",
        "zip_codes": [
            45230
        ],
        "district_id": 4508
    },
    {
        "id": 450806,
        "name_th": "คำพอุง",
        "name_en": "Kham Pha-ung",
        "zip_codes": [
            45230
        ],
        "district_id": 4508
    },
    {
        "id": 450807,
        "name_th": "หนองตาไก้",
        "name_en": "Nong Ta Kai",
        "zip_codes": [
            45230
        ],
        "district_id": 4508
    },
    {
        "id": 450808,
        "name_th": "ดอนโอง",
        "name_en": "Don Ong",
        "zip_codes": [
            45230
        ],
        "district_id": 4508
    },
    {
        "id": 450809,
        "name_th": "โพธิ์ศรี",
        "name_en": "Pho Si",
        "zip_codes": [
            45230
        ],
        "district_id": 4508
    },
    {
        "id": 450901,
        "name_th": "หนองพอก",
        "name_en": "Nong Phok",
        "zip_codes": [
            45210
        ],
        "district_id": 4509
    },
    {
        "id": 450902,
        "name_th": "บึงงาม",
        "name_en": "Bueng Ngam",
        "zip_codes": [
            45210
        ],
        "district_id": 4509
    },
    {
        "id": 450903,
        "name_th": "ภูเขาทอง",
        "name_en": "Phukhao Thong",
        "zip_codes": [
            45210
        ],
        "district_id": 4509
    },
    {
        "id": 450904,
        "name_th": "กกโพธิ์",
        "name_en": "Kok Pho",
        "zip_codes": [
            45210
        ],
        "district_id": 4509
    },
    {
        "id": 450905,
        "name_th": "โคกสว่าง",
        "name_en": "Khok Sawang",
        "zip_codes": [
            45210
        ],
        "district_id": 4509
    },
    {
        "id": 450906,
        "name_th": "หนองขุ่นใหญ่",
        "name_en": "Nong Khun Yai",
        "zip_codes": [
            45210
        ],
        "district_id": 4509
    },
    {
        "id": 450907,
        "name_th": "รอบเมือง",
        "name_en": "Rop Mueang",
        "zip_codes": [
            45210
        ],
        "district_id": 4509
    },
    {
        "id": 450908,
        "name_th": "ผาน้ำย้อย",
        "name_en": "Pha Nam Yoi",
        "zip_codes": [
            45210
        ],
        "district_id": 4509
    },
    {
        "id": 450909,
        "name_th": "ท่าสีดา",
        "name_en": "Tha Sida",
        "zip_codes": [
            45210
        ],
        "district_id": 4509
    },
    {
        "id": 451001,
        "name_th": "กลาง",
        "name_en": "Klang",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451002,
        "name_th": "นางาม",
        "name_en": "Na Ngam",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451003,
        "name_th": "เมืองไพร",
        "name_en": "Mueang Phrai",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451004,
        "name_th": "นาแซง",
        "name_en": "Na Saeng",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451005,
        "name_th": "นาเมือง",
        "name_en": "Na Mueang",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451006,
        "name_th": "วังหลวง",
        "name_en": "wang Luang",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451007,
        "name_th": "ท่าม่วง",
        "name_en": "Tha Muang",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451008,
        "name_th": "ขวาว",
        "name_en": "Khwao",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451009,
        "name_th": "โพธิ์ทอง",
        "name_en": "Pho Thong",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451010,
        "name_th": "ภูเงิน",
        "name_en": "Phu Ngoen",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451011,
        "name_th": "เกาะแก้ว",
        "name_en": "Ko Kaeo",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451012,
        "name_th": "นาเลิง",
        "name_en": "Na Loeng",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451013,
        "name_th": "เหล่าน้อย",
        "name_en": "Lao Noi",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451014,
        "name_th": "ศรีวิลัย",
        "name_en": "Si Wilai",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451015,
        "name_th": "หนองหลวง",
        "name_en": "Nong Luang",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451016,
        "name_th": "พรสวรรค์",
        "name_en": "Phon Sawan",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451017,
        "name_th": "ขวัญเมือง",
        "name_en": "Khwan Mueang",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451018,
        "name_th": "บึงเกลือ",
        "name_en": "Bueng Kluea",
        "zip_codes": [
            45120
        ],
        "district_id": 4510
    },
    {
        "id": 451101,
        "name_th": "สระคู",
        "name_en": "Sa Khu",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451102,
        "name_th": "ดอกไม้",
        "name_en": "Dok Mai",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451103,
        "name_th": "นาใหญ่",
        "name_en": "Na Yai",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451104,
        "name_th": "หินกอง",
        "name_en": "Hin Kong",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451105,
        "name_th": "เมืองทุ่ง",
        "name_en": "Mueang Thung",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451106,
        "name_th": "หัวโทน",
        "name_en": "Hua Thon",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451107,
        "name_th": "บ่อพันขัน",
        "name_en": "Bo Phan Khan",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451108,
        "name_th": "ทุ่งหลวง",
        "name_en": "Thung Luang",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451109,
        "name_th": "หัวช้าง",
        "name_en": "Hua Chang",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451110,
        "name_th": "น้ำคำ",
        "name_en": "Nam Kham",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451111,
        "name_th": "ห้วยหินลาด",
        "name_en": "Huai Hin Lat",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451112,
        "name_th": "ช้างเผือก",
        "name_en": "Chang Phueak",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451113,
        "name_th": "ทุ่งกุลา",
        "name_en": "Thung Kula",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451114,
        "name_th": "ทุ่งศรีเมือง",
        "name_en": "Thung Si Mueang",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451115,
        "name_th": "จำปาขัน",
        "name_en": "Champa Khan",
        "zip_codes": [
            45130
        ],
        "district_id": 4511
    },
    {
        "id": 451201,
        "name_th": "หนองผือ",
        "name_en": "Nong Phue",
        "zip_codes": [
            45220
        ],
        "district_id": 4512
    },
    {
        "id": 451202,
        "name_th": "หนองหิน",
        "name_en": "Nong Hin",
        "zip_codes": [
            45220
        ],
        "district_id": 4512
    },
    {
        "id": 451203,
        "name_th": "คูเมือง",
        "name_en": "Khu Mueang",
        "zip_codes": [
            45220
        ],
        "district_id": 4512
    },
    {
        "id": 451204,
        "name_th": "กกกุง",
        "name_en": "Kok Kung",
        "zip_codes": [
            45220
        ],
        "district_id": 4512
    },
    {
        "id": 451205,
        "name_th": "เมืองสรวง",
        "name_en": "Mueang Suang",
        "zip_codes": [
            45220
        ],
        "district_id": 4512
    },
    {
        "id": 451301,
        "name_th": "โพนทราย",
        "name_en": "Phon Sai",
        "zip_codes": [
            45240
        ],
        "district_id": 4513
    },
    {
        "id": 451302,
        "name_th": "สามขา",
        "name_en": "Sam Kha",
        "zip_codes": [
            45240
        ],
        "district_id": 4513
    },
    {
        "id": 451303,
        "name_th": "ศรีสว่าง",
        "name_en": "Si Sawang",
        "zip_codes": [
            45240
        ],
        "district_id": 4513
    },
    {
        "id": 451304,
        "name_th": "ยางคำ",
        "name_en": "Yang Kham",
        "zip_codes": [
            45240
        ],
        "district_id": 4513
    },
    {
        "id": 451305,
        "name_th": "ท่าหาดยาว",
        "name_en": "Tha Hat Yao",
        "zip_codes": [
            45240
        ],
        "district_id": 4513
    },
    {
        "id": 451401,
        "name_th": "อาจสามารถ",
        "name_en": "At Samat",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451402,
        "name_th": "โพนเมือง",
        "name_en": "Phon Mueang",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451403,
        "name_th": "บ้านแจ้ง",
        "name_en": "Ban Chaeng",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451404,
        "name_th": "หน่อม",
        "name_en": "Nom",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451405,
        "name_th": "หนองหมื่นถ่าน",
        "name_en": "Nong Muen Than",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451406,
        "name_th": "หนองขาม",
        "name_en": "Nong Kham",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451407,
        "name_th": "โหรา",
        "name_en": "Hora",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451408,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451409,
        "name_th": "ขี้เหล็ก",
        "name_en": "Khilek",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451410,
        "name_th": "บ้านดู่",
        "name_en": "Ban Du",
        "zip_codes": [
            45160
        ],
        "district_id": 4514
    },
    {
        "id": 451501,
        "name_th": "เมยวดี",
        "name_en": "Moei Wadi",
        "zip_codes": [
            45250
        ],
        "district_id": 4515
    },
    {
        "id": 451502,
        "name_th": "ชุมพร",
        "name_en": "Chumphon",
        "zip_codes": [
            45250
        ],
        "district_id": 4515
    },
    {
        "id": 451503,
        "name_th": "บุ่งเลิศ",
        "name_en": "Bung Loet",
        "zip_codes": [
            45250
        ],
        "district_id": 4515
    },
    {
        "id": 451504,
        "name_th": "ชมสะอาด",
        "name_en": "Chom Sa-at",
        "zip_codes": [
            45250
        ],
        "district_id": 4515
    },
    {
        "id": 451601,
        "name_th": "โพธิ์ทอง",
        "name_en": "Pho Thong",
        "zip_codes": [
            45000
        ],
        "district_id": 4516
    },
    {
        "id": 451602,
        "name_th": "ศรีสมเด็จ",
        "name_en": "Si Somdet",
        "zip_codes": [
            45000
        ],
        "district_id": 4516
    },
    {
        "id": 451603,
        "name_th": "เมืองเปลือย",
        "name_en": "Mueang Plueai",
        "zip_codes": [
            45000
        ],
        "district_id": 4516
    },
    {
        "id": 451604,
        "name_th": "หนองใหญ่",
        "name_en": "Nong Yai",
        "zip_codes": [
            45000
        ],
        "district_id": 4516
    },
    {
        "id": 451605,
        "name_th": "สวนจิก",
        "name_en": "Suan Chik",
        "zip_codes": [
            45280
        ],
        "district_id": 4516
    },
    {
        "id": 451606,
        "name_th": "โพธิ์สัย",
        "name_en": "Pho Sai",
        "zip_codes": [
            45280
        ],
        "district_id": 4516
    },
    {
        "id": 451607,
        "name_th": "หนองแวงควง",
        "name_en": "Nong Waeng Khuang",
        "zip_codes": [
            45000
        ],
        "district_id": 4516
    },
    {
        "id": 451608,
        "name_th": "บ้านบาก",
        "name_en": "Ban Bak",
        "zip_codes": [
            45000
        ],
        "district_id": 4516
    },
    {
        "id": 451701,
        "name_th": "ดินดำ",
        "name_en": "Din Dam",
        "zip_codes": [
            45000
        ],
        "district_id": 4517
    },
    {
        "id": 451702,
        "name_th": "ปาฝา",
        "name_en": "Pa Fa",
        "zip_codes": [
            45000
        ],
        "district_id": 4517
    },
    {
        "id": 451703,
        "name_th": "ม่วงลาด",
        "name_en": "Muang Lat",
        "zip_codes": [
            45000
        ],
        "district_id": 4517
    },
    {
        "id": 451704,
        "name_th": "จังหาร",
        "name_en": "Changhan",
        "zip_codes": [
            45000
        ],
        "district_id": 4517
    },
    {
        "id": 451705,
        "name_th": "ดงสิงห์",
        "name_en": "Dong Sing",
        "zip_codes": [
            45000
        ],
        "district_id": 4517
    },
    {
        "id": 451706,
        "name_th": "ยางใหญ่",
        "name_en": "Yang Yai",
        "zip_codes": [
            45000
        ],
        "district_id": 4517
    },
    {
        "id": 451707,
        "name_th": "ผักแว่น",
        "name_en": "Phak Waen",
        "zip_codes": [
            45000
        ],
        "district_id": 4517
    },
    {
        "id": 451708,
        "name_th": "แสนชาติ",
        "name_en": "Saen Chat",
        "zip_codes": [
            45000
        ],
        "district_id": 4517
    },
    {
        "id": 451801,
        "name_th": "เชียงขวัญ",
        "name_en": "Chiang Khwan",
        "zip_codes": [
            45000
        ],
        "district_id": 4518
    },
    {
        "id": 451802,
        "name_th": "พลับพลา",
        "name_en": "Phlapphla",
        "zip_codes": [
            45170
        ],
        "district_id": 4518
    },
    {
        "id": 451803,
        "name_th": "พระธาตุ",
        "name_en": "Phra That",
        "zip_codes": [
            45000
        ],
        "district_id": 4518
    },
    {
        "id": 451804,
        "name_th": "พระเจ้า",
        "name_en": "Phra Chao",
        "zip_codes": [
            45000
        ],
        "district_id": 4518
    },
    {
        "id": 451805,
        "name_th": "หมูม้น",
        "name_en": "Mu Mon",
        "zip_codes": [
            45170
        ],
        "district_id": 4518
    },
    {
        "id": 451806,
        "name_th": "บ้านเขือง",
        "name_en": "Ban Khueang",
        "zip_codes": [
            45000
        ],
        "district_id": 4518
    },
    {
        "id": 451901,
        "name_th": "หนองฮี",
        "name_en": "Nong Hi",
        "zip_codes": [
            45140
        ],
        "district_id": 4519
    },
    {
        "id": 451902,
        "name_th": "สาวแห",
        "name_en": "Sao Hae",
        "zip_codes": [
            45140
        ],
        "district_id": 4519
    },
    {
        "id": 451903,
        "name_th": "ดูกอึ่ง",
        "name_en": "Duk Ueng",
        "zip_codes": [
            45140
        ],
        "district_id": 4519
    },
    {
        "id": 451904,
        "name_th": "เด่นราษฎร์",
        "name_en": "Den Rat",
        "zip_codes": [
            45140
        ],
        "district_id": 4519
    },
    {
        "id": 452001,
        "name_th": "ทุ่งเขาหลวง",
        "name_en": "Thung Khao Luang",
        "zip_codes": [
            45170
        ],
        "district_id": 4520
    },
    {
        "id": 452002,
        "name_th": "เทอดไทย",
        "name_en": "Thoet Thai",
        "zip_codes": [
            45170
        ],
        "district_id": 4520
    },
    {
        "id": 452003,
        "name_th": "บึงงาม",
        "name_en": "Bueng Ngam",
        "zip_codes": [
            45170
        ],
        "district_id": 4520
    },
    {
        "id": 452004,
        "name_th": "มะบ้า",
        "name_en": "Maba",
        "zip_codes": [
            45170
        ],
        "district_id": 4520
    },
    {
        "id": 452005,
        "name_th": "เหล่า",
        "name_en": "Lao",
        "zip_codes": [
            45170
        ],
        "district_id": 4520
    },
    {
        "id": 460101,
        "name_th": "กาฬสินธุ์",
        "name_en": "Kalasin",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460102,
        "name_th": "เหนือ",
        "name_en": "Nuea",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460103,
        "name_th": "หลุบ",
        "name_en": "Lup",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460104,
        "name_th": "ไผ่",
        "name_en": "Phai",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460105,
        "name_th": "ลำปาว",
        "name_en": "Lam Pao",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460106,
        "name_th": "ลำพาน",
        "name_en": "Lam Phan",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460107,
        "name_th": "เชียงเครือ",
        "name_en": "Chiang Khruea",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460108,
        "name_th": "บึงวิชัย",
        "name_en": "Bueng Wichai",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460109,
        "name_th": "ห้วยโพธิ์",
        "name_en": "Huai Pho",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460111,
        "name_th": "ภูปอ",
        "name_en": "Phu Po",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460113,
        "name_th": "ภูดิน",
        "name_en": "Phu Din",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460115,
        "name_th": "หนองกุง",
        "name_en": "Nong Kung",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460116,
        "name_th": "กลางหมื่น",
        "name_en": "Klang Muen",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460117,
        "name_th": "ขมิ้น",
        "name_en": "Khamin",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460119,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460120,
        "name_th": "นาจารย์",
        "name_en": "Na Chan",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460121,
        "name_th": "ลำคลอง",
        "name_en": "Lam Khlong",
        "zip_codes": [
            46000
        ],
        "district_id": 4601
    },
    {
        "id": 460201,
        "name_th": "นามน",
        "name_en": "Na Mon",
        "zip_codes": [
            46230
        ],
        "district_id": 4602
    },
    {
        "id": 460202,
        "name_th": "ยอดแกง",
        "name_en": "Yot Kaeng",
        "zip_codes": [
            46230
        ],
        "district_id": 4602
    },
    {
        "id": 460203,
        "name_th": "สงเปลือย",
        "name_en": "Song Plueai",
        "zip_codes": [
            46230
        ],
        "district_id": 4602
    },
    {
        "id": 460204,
        "name_th": "หลักเหลี่ยม",
        "name_en": "Lak Liam",
        "zip_codes": [
            46230
        ],
        "district_id": 4602
    },
    {
        "id": 460205,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            46230
        ],
        "district_id": 4602
    },
    {
        "id": 460301,
        "name_th": "กมลาไสย",
        "name_en": "Kamalasai",
        "zip_codes": [
            46130
        ],
        "district_id": 4603
    },
    {
        "id": 460302,
        "name_th": "หลักเมือง",
        "name_en": "Lak Mueang",
        "zip_codes": [
            46130
        ],
        "district_id": 4603
    },
    {
        "id": 460303,
        "name_th": "โพนงาม",
        "name_en": "Phon Ngam",
        "zip_codes": [
            46130
        ],
        "district_id": 4603
    },
    {
        "id": 460304,
        "name_th": "ดงลิง",
        "name_en": "Dong Ling",
        "zip_codes": [
            46130
        ],
        "district_id": 4603
    },
    {
        "id": 460305,
        "name_th": "ธัญญา",
        "name_en": "Thanya",
        "zip_codes": [
            46130
        ],
        "district_id": 4603
    },
    {
        "id": 460308,
        "name_th": "หนองแปน",
        "name_en": "Nong Paen",
        "zip_codes": [
            46130
        ],
        "district_id": 4603
    },
    {
        "id": 460310,
        "name_th": "เจ้าท่า",
        "name_en": "Chao Tha",
        "zip_codes": [
            46130
        ],
        "district_id": 4603
    },
    {
        "id": 460311,
        "name_th": "โคกสมบูรณ์",
        "name_en": "Khok Sombun",
        "zip_codes": [
            46130
        ],
        "district_id": 4603
    },
    {
        "id": 460401,
        "name_th": "ร่องคำ",
        "name_en": "Rong Kham",
        "zip_codes": [
            46210
        ],
        "district_id": 4604
    },
    {
        "id": 460402,
        "name_th": "สามัคคี",
        "name_en": "Samakkhi",
        "zip_codes": [
            46210
        ],
        "district_id": 4604
    },
    {
        "id": 460403,
        "name_th": "เหล่าอ้อย",
        "name_en": "Lao Oi",
        "zip_codes": [
            46210
        ],
        "district_id": 4604
    },
    {
        "id": 460501,
        "name_th": "บัวขาว",
        "name_en": "Bua Khao",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460502,
        "name_th": "แจนแลน",
        "name_en": "Chaen Laen",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460503,
        "name_th": "เหล่าใหญ่",
        "name_en": "Lao Yai",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460504,
        "name_th": "จุมจัง",
        "name_en": "Chum Chang",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460505,
        "name_th": "เหล่าไฮงาม",
        "name_en": "Lao Hai Ngam",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460506,
        "name_th": "กุดหว้า",
        "name_en": "Kut Wa",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460507,
        "name_th": "สามขา",
        "name_en": "Sam Kha",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460508,
        "name_th": "นาขาม",
        "name_en": "Na Kham",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460509,
        "name_th": "หนองห้าง",
        "name_en": "Nong Hang",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460510,
        "name_th": "นาโก",
        "name_en": "Na Ko",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460511,
        "name_th": "สมสะอาด",
        "name_en": "Som Sa-at",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460512,
        "name_th": "กุดค้าว",
        "name_en": "Kut Khao",
        "zip_codes": [
            46110
        ],
        "district_id": 4605
    },
    {
        "id": 460601,
        "name_th": "คุ้มเก่า",
        "name_en": "Khum Kao",
        "zip_codes": [
            46160
        ],
        "district_id": 4606
    },
    {
        "id": 460602,
        "name_th": "สงเปลือย",
        "name_en": "Song Plueai",
        "zip_codes": [
            46160
        ],
        "district_id": 4606
    },
    {
        "id": 460603,
        "name_th": "หนองผือ",
        "name_en": "Nong Phue",
        "zip_codes": [
            46160
        ],
        "district_id": 4606
    },
    {
        "id": 460606,
        "name_th": "กุดสิมคุ้มใหม่",
        "name_en": "Kut Sim Khum Mai",
        "zip_codes": [
            46160
        ],
        "district_id": 4606
    },
    {
        "id": 460608,
        "name_th": "สระพังทอง",
        "name_en": "Sa Phang Thong",
        "zip_codes": [
            46160
        ],
        "district_id": 4606
    },
    {
        "id": 460611,
        "name_th": "กุดปลาค้าว",
        "name_en": "Kut Pla Khao",
        "zip_codes": [
            46160
        ],
        "district_id": 4606
    },
    {
        "id": 460701,
        "name_th": "ยางตลาด",
        "name_en": "Yang Talat",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460702,
        "name_th": "หัวงัว",
        "name_en": "Hua Ngua",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460703,
        "name_th": "อุ่มเม่า",
        "name_en": "Um Mao",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460704,
        "name_th": "บัวบาน",
        "name_en": "Bua Ban",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460705,
        "name_th": "เว่อ",
        "name_en": "Woe",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460706,
        "name_th": "อิตื้อ",
        "name_en": "Itue",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460707,
        "name_th": "หัวนาคำ",
        "name_en": "Hua Na Kham",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460708,
        "name_th": "หนองอิเฒ่า",
        "name_en": "Nong I Thao",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460709,
        "name_th": "ดอนสมบูรณ์",
        "name_en": "Don Sombun",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460710,
        "name_th": "นาเชือก",
        "name_en": "Na Chueak",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460711,
        "name_th": "คลองขาม",
        "name_en": "Khlong Kham",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460712,
        "name_th": "เขาพระนอน",
        "name_en": "Khao Phra Non",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460713,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460714,
        "name_th": "โนนสูง",
        "name_en": "Non Sung",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460715,
        "name_th": "หนองตอกแป้น",
        "name_en": "Nong Tok Paen",
        "zip_codes": [
            46120
        ],
        "district_id": 4607
    },
    {
        "id": 460801,
        "name_th": "ห้วยเม็ก",
        "name_en": "Huai Mek",
        "zip_codes": [
            46170
        ],
        "district_id": 4608
    },
    {
        "id": 460802,
        "name_th": "คำใหญ่",
        "name_en": "Kham Yai",
        "zip_codes": [
            46170
        ],
        "district_id": 4608
    },
    {
        "id": 460803,
        "name_th": "กุดโดน",
        "name_en": "Kut Don",
        "zip_codes": [
            46170
        ],
        "district_id": 4608
    },
    {
        "id": 460804,
        "name_th": "บึงนาเรียง",
        "name_en": "Bueng Na Riang",
        "zip_codes": [
            46170
        ],
        "district_id": 4608
    },
    {
        "id": 460805,
        "name_th": "หัวหิน",
        "name_en": "Hua Hin",
        "zip_codes": [
            46170
        ],
        "district_id": 4608
    },
    {
        "id": 460806,
        "name_th": "พิมูล",
        "name_en": "Phimun",
        "zip_codes": [
            46170
        ],
        "district_id": 4608
    },
    {
        "id": 460807,
        "name_th": "คำเหมือดแก้ว",
        "name_en": "Kham Mueat Kaeo",
        "zip_codes": [
            46170
        ],
        "district_id": 4608
    },
    {
        "id": 460808,
        "name_th": "โนนสะอาด",
        "name_en": "Non Sa-at",
        "zip_codes": [
            46170
        ],
        "district_id": 4608
    },
    {
        "id": 460809,
        "name_th": "ทรายทอง",
        "name_en": "Sai Thong",
        "zip_codes": [
            46170
        ],
        "district_id": 4608
    },
    {
        "id": 460901,
        "name_th": "ภูสิงห์",
        "name_en": "Phu Sing",
        "zip_codes": [
            46140
        ],
        "district_id": 4609
    },
    {
        "id": 460902,
        "name_th": "สหัสขันธ์",
        "name_en": "Sahatsakhan",
        "zip_codes": [
            46140
        ],
        "district_id": 4609
    },
    {
        "id": 460903,
        "name_th": "นามะเขือ",
        "name_en": "Na Makhuea",
        "zip_codes": [
            46140
        ],
        "district_id": 4609
    },
    {
        "id": 460904,
        "name_th": "โนนศิลา",
        "name_en": "Non Sila",
        "zip_codes": [
            46140
        ],
        "district_id": 4609
    },
    {
        "id": 460905,
        "name_th": "นิคม",
        "name_en": "Nikhom",
        "zip_codes": [
            46140
        ],
        "district_id": 4609
    },
    {
        "id": 460906,
        "name_th": "โนนแหลมทอง",
        "name_en": "Non Laem Thong",
        "zip_codes": [
            46140
        ],
        "district_id": 4609
    },
    {
        "id": 460907,
        "name_th": "โนนบุรี",
        "name_en": "Non Buri",
        "zip_codes": [
            46140
        ],
        "district_id": 4609
    },
    {
        "id": 460908,
        "name_th": "โนนน้ำเกลี้ยง",
        "name_en": "Non Nam Kliang",
        "zip_codes": [
            46140
        ],
        "district_id": 4609
    },
    {
        "id": 461001,
        "name_th": "ทุ่งคลอง",
        "name_en": "Thung Khlong",
        "zip_codes": [
            46180
        ],
        "district_id": 4610
    },
    {
        "id": 461002,
        "name_th": "โพน",
        "name_en": "Phon",
        "zip_codes": [
            46180
        ],
        "district_id": 4610
    },
    {
        "id": 461005,
        "name_th": "ดินจี่",
        "name_en": "Din Chi",
        "zip_codes": [
            46180
        ],
        "district_id": 4610
    },
    {
        "id": 461006,
        "name_th": "นาบอน",
        "name_en": "Na Bon",
        "zip_codes": [
            46180
        ],
        "district_id": 4610
    },
    {
        "id": 461007,
        "name_th": "นาทัน",
        "name_en": "Na Than",
        "zip_codes": [
            46180
        ],
        "district_id": 4610
    },
    {
        "id": 461009,
        "name_th": "เนินยาง",
        "name_en": "Noen Yang",
        "zip_codes": [
            46180
        ],
        "district_id": 4610
    },
    {
        "id": 461101,
        "name_th": "ท่าคันโท",
        "name_en": "Tha Khantho",
        "zip_codes": [
            46190
        ],
        "district_id": 4611
    },
    {
        "id": 461102,
        "name_th": "กุงเก่า",
        "name_en": "Kung Kao",
        "zip_codes": [
            46190
        ],
        "district_id": 4611
    },
    {
        "id": 461103,
        "name_th": "ยางอู้ม",
        "name_en": "Yang Um",
        "zip_codes": [
            46190
        ],
        "district_id": 4611
    },
    {
        "id": 461104,
        "name_th": "กุดจิก",
        "name_en": "Kut Chik",
        "zip_codes": [
            46190
        ],
        "district_id": 4611
    },
    {
        "id": 461105,
        "name_th": "นาตาล",
        "name_en": "Na Tan",
        "zip_codes": [
            46190
        ],
        "district_id": 4611
    },
    {
        "id": 461106,
        "name_th": "ดงสมบูรณ์",
        "name_en": "Dong Sombun",
        "zip_codes": [
            46190
        ],
        "district_id": 4611
    },
    {
        "id": 461201,
        "name_th": "หนองกุงศรี",
        "name_en": "Nong Kung Si",
        "zip_codes": [
            46220
        ],
        "district_id": 4612
    },
    {
        "id": 461202,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            46220
        ],
        "district_id": 4612
    },
    {
        "id": 461203,
        "name_th": "โคกเครือ",
        "name_en": "Khok Khruea",
        "zip_codes": [
            46220
        ],
        "district_id": 4612
    },
    {
        "id": 461204,
        "name_th": "หนองสรวง",
        "name_en": "Nong Suang",
        "zip_codes": [
            46220
        ],
        "district_id": 4612
    },
    {
        "id": 461205,
        "name_th": "เสาเล้า",
        "name_en": "Sao Lao",
        "zip_codes": [
            46220
        ],
        "district_id": 4612
    },
    {
        "id": 461206,
        "name_th": "หนองใหญ่",
        "name_en": "Nong Yai",
        "zip_codes": [
            46220
        ],
        "district_id": 4612
    },
    {
        "id": 461207,
        "name_th": "ดงมูล",
        "name_en": "Dong Mun",
        "zip_codes": [
            46220
        ],
        "district_id": 4612
    },
    {
        "id": 461208,
        "name_th": "ลำหนองแสน",
        "name_en": "Lam Nong Saen",
        "zip_codes": [
            46220
        ],
        "district_id": 4612
    },
    {
        "id": 461209,
        "name_th": "หนองหิน",
        "name_en": "Nong Hin",
        "zip_codes": [
            46220
        ],
        "district_id": 4612
    },
    {
        "id": 461301,
        "name_th": "สมเด็จ",
        "name_en": "Somdet",
        "zip_codes": [
            46150
        ],
        "district_id": 4613
    },
    {
        "id": 461302,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            46150
        ],
        "district_id": 4613
    },
    {
        "id": 461303,
        "name_th": "แซงบาดาล",
        "name_en": "Saeng Badan",
        "zip_codes": [
            46150
        ],
        "district_id": 4613
    },
    {
        "id": 461304,
        "name_th": "มหาไชย",
        "name_en": "Maha Chai",
        "zip_codes": [
            46150
        ],
        "district_id": 4613
    },
    {
        "id": 461305,
        "name_th": "หมูม่น",
        "name_en": "Mu Mon",
        "zip_codes": [
            46150
        ],
        "district_id": 4613
    },
    {
        "id": 461306,
        "name_th": "ผาเสวย",
        "name_en": "Pha Sawoei",
        "zip_codes": [
            46150
        ],
        "district_id": 4613
    },
    {
        "id": 461307,
        "name_th": "ศรีสมเด็จ",
        "name_en": "Si Somdet",
        "zip_codes": [
            46150
        ],
        "district_id": 4613
    },
    {
        "id": 461308,
        "name_th": "ลำห้วยหลัว",
        "name_en": "Lam Huai Lua",
        "zip_codes": [
            46150
        ],
        "district_id": 4613
    },
    {
        "id": 461401,
        "name_th": "คำบง",
        "name_en": "Kham Bong",
        "zip_codes": [
            46240
        ],
        "district_id": 4614
    },
    {
        "id": 461402,
        "name_th": "ไค้นุ่น",
        "name_en": "Khai Nun",
        "zip_codes": [
            46240
        ],
        "district_id": 4614
    },
    {
        "id": 461403,
        "name_th": "นิคมห้วยผึ้ง",
        "name_en": "Nikhom Huai Phueng",
        "zip_codes": [
            46240
        ],
        "district_id": 4614
    },
    {
        "id": 461404,
        "name_th": "หนองอีบุตร",
        "name_en": "Nong I But",
        "zip_codes": [
            46240
        ],
        "district_id": 4614
    },
    {
        "id": 461501,
        "name_th": "สำราญ",
        "name_en": "Samran",
        "zip_codes": [
            46180
        ],
        "district_id": 4615
    },
    {
        "id": 461502,
        "name_th": "สำราญใต้",
        "name_en": "Samran Tai",
        "zip_codes": [
            46180
        ],
        "district_id": 4615
    },
    {
        "id": 461503,
        "name_th": "คำสร้างเที่ยง",
        "name_en": "Kham Sang Thiang",
        "zip_codes": [
            46180
        ],
        "district_id": 4615
    },
    {
        "id": 461504,
        "name_th": "หนองช้าง",
        "name_en": "Nong Chang",
        "zip_codes": [
            46180
        ],
        "district_id": 4615
    },
    {
        "id": 461601,
        "name_th": "นาคู",
        "name_en": "Na Khu",
        "zip_codes": [
            46160
        ],
        "district_id": 4616
    },
    {
        "id": 461602,
        "name_th": "สายนาวัง",
        "name_en": "Sai Na Wang",
        "zip_codes": [
            46160
        ],
        "district_id": 4616
    },
    {
        "id": 461603,
        "name_th": "โนนนาจาน",
        "name_en": "Non Na Chan",
        "zip_codes": [
            46160
        ],
        "district_id": 4616
    },
    {
        "id": 461604,
        "name_th": "บ่อแก้ว",
        "name_en": "Bo Kaeo",
        "zip_codes": [
            46160
        ],
        "district_id": 4616
    },
    {
        "id": 461605,
        "name_th": "ภูแล่นช้าง",
        "name_en": "Phu Laen Chang",
        "zip_codes": [
            46160
        ],
        "district_id": 4616
    },
    {
        "id": 461701,
        "name_th": "ดอนจาน",
        "name_en": "Don Chan",
        "zip_codes": [
            46000
        ],
        "district_id": 4617
    },
    {
        "id": 461702,
        "name_th": "สะอาดไชยศรี",
        "name_en": "Sa-at Chai Si",
        "zip_codes": [
            46000
        ],
        "district_id": 4617
    },
    {
        "id": 461703,
        "name_th": "ดงพยุง",
        "name_en": "Dong Phayung",
        "zip_codes": [
            46000
        ],
        "district_id": 4617
    },
    {
        "id": 461704,
        "name_th": "ม่วงนา",
        "name_en": "Muang Na",
        "zip_codes": [
            46000
        ],
        "district_id": 4617
    },
    {
        "id": 461705,
        "name_th": "นาจำปา",
        "name_en": "Na Champa",
        "zip_codes": [
            46000
        ],
        "district_id": 4617
    },
    {
        "id": 461801,
        "name_th": "ฆ้องชัยพัฒนา",
        "name_en": "Khong Chai Phatthana",
        "zip_codes": [
            46130
        ],
        "district_id": 4618
    },
    {
        "id": 461802,
        "name_th": "เหล่ากลาง",
        "name_en": "Lao Klang",
        "zip_codes": [
            46130
        ],
        "district_id": 4618
    },
    {
        "id": 461803,
        "name_th": "โคกสะอาด",
        "name_en": "Khok Sa-at",
        "zip_codes": [
            46130
        ],
        "district_id": 4618
    },
    {
        "id": 461804,
        "name_th": "โนนศิลาเลิง",
        "name_en": "Non Sila Loeng",
        "zip_codes": [
            46130
        ],
        "district_id": 4618
    },
    {
        "id": 461805,
        "name_th": "ลำชี",
        "name_en": "Lam Chi",
        "zip_codes": [
            46130
        ],
        "district_id": 4618
    },
    {
        "id": 470101,
        "name_th": "ธาตุเชิงชุม",
        "name_en": "That Choeng Chum",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470102,
        "name_th": "ขมิ้น",
        "name_en": "Khamin",
        "zip_codes": [
            47220
        ],
        "district_id": 4701
    },
    {
        "id": 470103,
        "name_th": "งิ้วด่อน",
        "name_en": "Ngio Don",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470104,
        "name_th": "โนนหอม",
        "name_en": "Non Hom",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470106,
        "name_th": "เชียงเครือ",
        "name_en": "Chiang Khruea",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470107,
        "name_th": "ท่าแร่",
        "name_en": "Tha Rae",
        "zip_codes": [
            47230
        ],
        "district_id": 4701
    },
    {
        "id": 470109,
        "name_th": "ม่วงลาย",
        "name_en": "Muang Lai",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470111,
        "name_th": "ดงชน",
        "name_en": "Dong Chon",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470112,
        "name_th": "ห้วยยาง",
        "name_en": "Huai Yang",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470113,
        "name_th": "พังขว้าง",
        "name_en": "Phang Khwang",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470115,
        "name_th": "ดงมะไฟ",
        "name_en": "Dong Mafai",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470116,
        "name_th": "ธาตุนาเวง",
        "name_en": "That Na Weng",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470117,
        "name_th": "เหล่าปอแดง",
        "name_en": "Lao Po Daeng",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470118,
        "name_th": "หนองลาด",
        "name_en": "Nong Lat",
        "zip_codes": [
            47220
        ],
        "district_id": 4701
    },
    {
        "id": 470120,
        "name_th": "ฮางโฮง",
        "name_en": "Hang Hong",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470121,
        "name_th": "โคกก่อง",
        "name_en": "Khok Kong",
        "zip_codes": [
            47000
        ],
        "district_id": 4701
    },
    {
        "id": 470201,
        "name_th": "กุสุมาลย์",
        "name_en": "Kusuman",
        "zip_codes": [
            47210
        ],
        "district_id": 4702
    },
    {
        "id": 470202,
        "name_th": "นาโพธิ์",
        "name_en": "Na Pho",
        "zip_codes": [
            47210
        ],
        "district_id": 4702
    },
    {
        "id": 470203,
        "name_th": "นาเพียง",
        "name_en": "Na Phiang",
        "zip_codes": [
            47230
        ],
        "district_id": 4702
    },
    {
        "id": 470204,
        "name_th": "โพธิไพศาล",
        "name_en": "Phothiphaisan",
        "zip_codes": [
            47210
        ],
        "district_id": 4702
    },
    {
        "id": 470205,
        "name_th": "อุ่มจาน",
        "name_en": "Um Chan",
        "zip_codes": [
            47230
        ],
        "district_id": 4702
    },
    {
        "id": 470301,
        "name_th": "กุดบาก",
        "name_en": "Kut Bak",
        "zip_codes": [
            47180
        ],
        "district_id": 4703
    },
    {
        "id": 470303,
        "name_th": "นาม่อง",
        "name_en": "Na Mong",
        "zip_codes": [
            47180
        ],
        "district_id": 4703
    },
    {
        "id": 470305,
        "name_th": "กุดไห",
        "name_en": "Kut Hai",
        "zip_codes": [
            47180
        ],
        "district_id": 4703
    },
    {
        "id": 470401,
        "name_th": "พรรณา",
        "name_en": "Phanna",
        "zip_codes": [
            47130
        ],
        "district_id": 4704
    },
    {
        "id": 470402,
        "name_th": "วังยาง",
        "name_en": "Wang Yang",
        "zip_codes": [
            47130
        ],
        "district_id": 4704
    },
    {
        "id": 470403,
        "name_th": "พอกน้อย",
        "name_en": "Phok Noi",
        "zip_codes": [
            47220
        ],
        "district_id": 4704
    },
    {
        "id": 470404,
        "name_th": "นาหัวบ่อ",
        "name_en": "Na Hua Bo",
        "zip_codes": [
            47220
        ],
        "district_id": 4704
    },
    {
        "id": 470405,
        "name_th": "ไร่",
        "name_en": "Rai",
        "zip_codes": [
            47130
        ],
        "district_id": 4704
    },
    {
        "id": 470406,
        "name_th": "ช้างมิ่ง",
        "name_en": "Chang Ming",
        "zip_codes": [
            47130
        ],
        "district_id": 4704
    },
    {
        "id": 470407,
        "name_th": "นาใน",
        "name_en": "Na Nai",
        "zip_codes": [
            47130
        ],
        "district_id": 4704
    },
    {
        "id": 470408,
        "name_th": "สว่าง",
        "name_en": "Sawang",
        "zip_codes": [
            47130
        ],
        "district_id": 4704
    },
    {
        "id": 470409,
        "name_th": "บะฮี",
        "name_en": "Ba Hi",
        "zip_codes": [
            47130
        ],
        "district_id": 4704
    },
    {
        "id": 470410,
        "name_th": "เชิงชุม",
        "name_en": "Choeng Chum",
        "zip_codes": [
            47130
        ],
        "district_id": 4704
    },
    {
        "id": 470501,
        "name_th": "พังโคน",
        "name_en": "Phang Khon",
        "zip_codes": [
            47160
        ],
        "district_id": 4705
    },
    {
        "id": 470502,
        "name_th": "ม่วงไข่",
        "name_en": "Muang Khai",
        "zip_codes": [
            47160
        ],
        "district_id": 4705
    },
    {
        "id": 470503,
        "name_th": "แร่",
        "name_en": "Rae",
        "zip_codes": [
            47160
        ],
        "district_id": 4705
    },
    {
        "id": 470504,
        "name_th": "ไฮหย่อง",
        "name_en": "Hai Yong",
        "zip_codes": [
            47160
        ],
        "district_id": 4705
    },
    {
        "id": 470505,
        "name_th": "ต้นผึ้ง",
        "name_en": "Ton Phueng",
        "zip_codes": [
            47160
        ],
        "district_id": 4705
    },
    {
        "id": 470601,
        "name_th": "วาริชภูมิ",
        "name_en": "Waritchaphum",
        "zip_codes": [
            47150
        ],
        "district_id": 4706
    },
    {
        "id": 470602,
        "name_th": "ปลาโหล",
        "name_en": "Pla Lo",
        "zip_codes": [
            47150
        ],
        "district_id": 4706
    },
    {
        "id": 470603,
        "name_th": "หนองลาด",
        "name_en": "Nong Lat",
        "zip_codes": [
            47150
        ],
        "district_id": 4706
    },
    {
        "id": 470604,
        "name_th": "คำบ่อ",
        "name_en": "Kham Bo",
        "zip_codes": [
            47150
        ],
        "district_id": 4706
    },
    {
        "id": 470605,
        "name_th": "ค้อเขียว",
        "name_en": "Kho Khiao",
        "zip_codes": [
            47150
        ],
        "district_id": 4706
    },
    {
        "id": 470701,
        "name_th": "นิคมน้ำอูน",
        "name_en": "Nikhom Nam Un",
        "zip_codes": [
            47270
        ],
        "district_id": 4707
    },
    {
        "id": 470702,
        "name_th": "หนองปลิง",
        "name_en": "Nong Pling",
        "zip_codes": [
            47270
        ],
        "district_id": 4707
    },
    {
        "id": 470703,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            47270
        ],
        "district_id": 4707
    },
    {
        "id": 470704,
        "name_th": "สุวรรณคาม",
        "name_en": "Suwannakham",
        "zip_codes": [
            47270
        ],
        "district_id": 4707
    },
    {
        "id": 470801,
        "name_th": "วานรนิวาส",
        "name_en": "Wanon Niwat",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470802,
        "name_th": "เดื่อศรีคันไชย",
        "name_en": "Duea Si Khan Chai",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470803,
        "name_th": "ขัวก่าย",
        "name_en": "Khua Kai",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470804,
        "name_th": "หนองสนม",
        "name_en": "Nong Sanom",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470805,
        "name_th": "คูสะคาม",
        "name_en": "Khu Sakham",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470806,
        "name_th": "ธาตุ",
        "name_en": "That",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470807,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470808,
        "name_th": "ศรีวิชัย",
        "name_en": "Si Wichai",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470809,
        "name_th": "นาซอ",
        "name_en": "Na So",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470810,
        "name_th": "อินทร์แปลง",
        "name_en": "In Plaeng",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470811,
        "name_th": "นาคำ",
        "name_en": "Na Kham",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470812,
        "name_th": "คอนสวรรค์",
        "name_en": "Khon Sawan",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470813,
        "name_th": "กุดเรือคำ",
        "name_en": "Kut Ruea Kham",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470814,
        "name_th": "หนองแวงใต้",
        "name_en": "Nong Waeng Tai",
        "zip_codes": [
            47120
        ],
        "district_id": 4708
    },
    {
        "id": 470901,
        "name_th": "คำตากล้า",
        "name_en": "Kham Ta Kla",
        "zip_codes": [
            47250
        ],
        "district_id": 4709
    },
    {
        "id": 470902,
        "name_th": "หนองบัวสิม",
        "name_en": "Nong Bua Sim",
        "zip_codes": [
            47250
        ],
        "district_id": 4709
    },
    {
        "id": 470903,
        "name_th": "นาแต้",
        "name_en": "Na Tae",
        "zip_codes": [
            47250
        ],
        "district_id": 4709
    },
    {
        "id": 470904,
        "name_th": "แพด",
        "name_en": "Phaet",
        "zip_codes": [
            47250
        ],
        "district_id": 4709
    },
    {
        "id": 471001,
        "name_th": "ม่วง",
        "name_en": "Muang",
        "zip_codes": [
            47140
        ],
        "district_id": 4710
    },
    {
        "id": 471002,
        "name_th": "มาย",
        "name_en": "Mai",
        "zip_codes": [
            47140
        ],
        "district_id": 4710
    },
    {
        "id": 471003,
        "name_th": "ดงหม้อทอง",
        "name_en": "Dong Mo Thong",
        "zip_codes": [
            47140
        ],
        "district_id": 4710
    },
    {
        "id": 471004,
        "name_th": "ดงเหนือ",
        "name_en": "Dong Nuea",
        "zip_codes": [
            47140
        ],
        "district_id": 4710
    },
    {
        "id": 471005,
        "name_th": "ดงหม้อทองใต้",
        "name_en": "Dong Mo Thong Tai",
        "zip_codes": [
            47140
        ],
        "district_id": 4710
    },
    {
        "id": 471006,
        "name_th": "ห้วยหลัว",
        "name_en": "Huai Lua",
        "zip_codes": [
            47140
        ],
        "district_id": 4710
    },
    {
        "id": 471007,
        "name_th": "โนนสะอาด",
        "name_en": "Non Sa-at",
        "zip_codes": [
            47140
        ],
        "district_id": 4710
    },
    {
        "id": 471008,
        "name_th": "หนองกวั่ง",
        "name_en": "Nong Kwang",
        "zip_codes": [
            47140
        ],
        "district_id": 4710
    },
    {
        "id": 471009,
        "name_th": "บ่อแก้ว",
        "name_en": "Bo Kaeo",
        "zip_codes": [
            47140
        ],
        "district_id": 4710
    },
    {
        "id": 471101,
        "name_th": "อากาศ",
        "name_en": "Akat",
        "zip_codes": [
            47170
        ],
        "district_id": 4711
    },
    {
        "id": 471102,
        "name_th": "โพนแพง",
        "name_en": "Phon Phaeng",
        "zip_codes": [
            47170
        ],
        "district_id": 4711
    },
    {
        "id": 471103,
        "name_th": "วาใหญ่",
        "name_en": "Wa Yai",
        "zip_codes": [
            47170
        ],
        "district_id": 4711
    },
    {
        "id": 471104,
        "name_th": "โพนงาม",
        "name_en": "Phon Ngam",
        "zip_codes": [
            47170
        ],
        "district_id": 4711
    },
    {
        "id": 471105,
        "name_th": "ท่าก้อน",
        "name_en": "Tha Kon",
        "zip_codes": [
            47170
        ],
        "district_id": 4711
    },
    {
        "id": 471106,
        "name_th": "นาฮี",
        "name_en": "Na Hi",
        "zip_codes": [
            47170
        ],
        "district_id": 4711
    },
    {
        "id": 471107,
        "name_th": "บะหว้า",
        "name_en": "Ba Wa",
        "zip_codes": [
            47170
        ],
        "district_id": 4711
    },
    {
        "id": 471108,
        "name_th": "สามัคคีพัฒนา",
        "name_en": "Samakkhi Phatthana",
        "zip_codes": [
            47170
        ],
        "district_id": 4711
    },
    {
        "id": 471201,
        "name_th": "สว่างแดนดิน",
        "name_en": "Sawang Daen Din",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471203,
        "name_th": "คำสะอาด",
        "name_en": "Kham Sa-at",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471204,
        "name_th": "บ้านต้าย",
        "name_en": "Ban Tai",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471206,
        "name_th": "บงเหนือ",
        "name_en": "Bong Nuea",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471207,
        "name_th": "โพนสูง",
        "name_en": "Phon Sung",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471208,
        "name_th": "โคกสี",
        "name_en": "Khok Si",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471210,
        "name_th": "หนองหลวง",
        "name_en": "Nong Luang",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471211,
        "name_th": "บงใต้",
        "name_en": "Bong Tai",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471212,
        "name_th": "ค้อใต้",
        "name_en": "Kho Tai",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471213,
        "name_th": "พันนา",
        "name_en": "Phan Na",
        "zip_codes": [
            47240
        ],
        "district_id": 4712
    },
    {
        "id": 471214,
        "name_th": "แวง",
        "name_en": "Waeng",
        "zip_codes": [
            47240
        ],
        "district_id": 4712
    },
    {
        "id": 471215,
        "name_th": "ทรายมูล",
        "name_en": "Sai Mun",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471216,
        "name_th": "ตาลโกน",
        "name_en": "Tan Kon",
        "zip_codes": [
            47240
        ],
        "district_id": 4712
    },
    {
        "id": 471217,
        "name_th": "ตาลเนิ้ง",
        "name_en": "Tan Noeng",
        "zip_codes": [
            47240
        ],
        "district_id": 4712
    },
    {
        "id": 471220,
        "name_th": "ธาตุทอง",
        "name_en": "That Thong",
        "zip_codes": [
            47240
        ],
        "district_id": 4712
    },
    {
        "id": 471221,
        "name_th": "บ้านถ่อน",
        "name_en": "Ban Thon",
        "zip_codes": [
            47110
        ],
        "district_id": 4712
    },
    {
        "id": 471301,
        "name_th": "ส่องดาว",
        "name_en": "Song Dao",
        "zip_codes": [
            47190
        ],
        "district_id": 4713
    },
    {
        "id": 471302,
        "name_th": "ท่าศิลา",
        "name_en": "Tha Sila",
        "zip_codes": [
            47190
        ],
        "district_id": 4713
    },
    {
        "id": 471303,
        "name_th": "วัฒนา",
        "name_en": "Watthana",
        "zip_codes": [
            47190
        ],
        "district_id": 4713
    },
    {
        "id": 471304,
        "name_th": "ปทุมวาปี",
        "name_en": "Pathum Wapi",
        "zip_codes": [
            47190
        ],
        "district_id": 4713
    },
    {
        "id": 471401,
        "name_th": "เต่างอย",
        "name_en": "Tao Ngoi",
        "zip_codes": [
            47260
        ],
        "district_id": 4714
    },
    {
        "id": 471402,
        "name_th": "บึงทวาย",
        "name_en": "Bueng Thawai",
        "zip_codes": [
            47260
        ],
        "district_id": 4714
    },
    {
        "id": 471403,
        "name_th": "นาตาล",
        "name_en": "Na Tan",
        "zip_codes": [
            47260
        ],
        "district_id": 4714
    },
    {
        "id": 471404,
        "name_th": "จันทร์เพ็ญ",
        "name_en": "Chan Phen",
        "zip_codes": [
            47260
        ],
        "district_id": 4714
    },
    {
        "id": 471501,
        "name_th": "ตองโขบ",
        "name_en": "Tong Khop",
        "zip_codes": [
            47280
        ],
        "district_id": 4715
    },
    {
        "id": 471502,
        "name_th": "เหล่าโพนค้อ",
        "name_en": "Lao Phon Kho",
        "zip_codes": [
            47280
        ],
        "district_id": 4715
    },
    {
        "id": 471503,
        "name_th": "ด่านม่วงคำ",
        "name_en": "Dan Muang Kham",
        "zip_codes": [
            47280
        ],
        "district_id": 4715
    },
    {
        "id": 471504,
        "name_th": "แมดนาท่ม",
        "name_en": "Maet Na Thom",
        "zip_codes": [
            47280
        ],
        "district_id": 4715
    },
    {
        "id": 471601,
        "name_th": "บ้านเหล่า",
        "name_en": "Ban Lao",
        "zip_codes": [
            47290
        ],
        "district_id": 4716
    },
    {
        "id": 471602,
        "name_th": "เจริญศิลป์",
        "name_en": "Charoen Sin",
        "zip_codes": [
            47290
        ],
        "district_id": 4716
    },
    {
        "id": 471603,
        "name_th": "ทุ่งแก",
        "name_en": "Thung Kae",
        "zip_codes": [
            47290
        ],
        "district_id": 4716
    },
    {
        "id": 471604,
        "name_th": "โคกศิลา",
        "name_en": "Khok Sila",
        "zip_codes": [
            47290
        ],
        "district_id": 4716
    },
    {
        "id": 471605,
        "name_th": "หนองแปน",
        "name_en": "Nong Paen",
        "zip_codes": [
            47290
        ],
        "district_id": 4716
    },
    {
        "id": 471701,
        "name_th": "บ้านโพน",
        "name_en": "Ban Phon",
        "zip_codes": [
            47230
        ],
        "district_id": 4717
    },
    {
        "id": 471702,
        "name_th": "นาแก้ว",
        "name_en": "Na Kaeo",
        "zip_codes": [
            47230
        ],
        "district_id": 4717
    },
    {
        "id": 471703,
        "name_th": "นาตงวัฒนา",
        "name_en": "Na Tong Watthana",
        "zip_codes": [
            47230
        ],
        "district_id": 4717
    },
    {
        "id": 471704,
        "name_th": "บ้านแป้น",
        "name_en": "Ban Paen",
        "zip_codes": [
            47230
        ],
        "district_id": 4717
    },
    {
        "id": 471705,
        "name_th": "เชียงสือ",
        "name_en": "Chiang Sue",
        "zip_codes": [
            47230
        ],
        "district_id": 4717
    },
    {
        "id": 471801,
        "name_th": "สร้างค้อ",
        "name_en": "Sang Kho",
        "zip_codes": [
            47180
        ],
        "district_id": 4718
    },
    {
        "id": 471802,
        "name_th": "หลุบเลา",
        "name_en": "Lup Lao",
        "zip_codes": [
            47180
        ],
        "district_id": 4718
    },
    {
        "id": 471803,
        "name_th": "โคกภู",
        "name_en": "Khok Phu",
        "zip_codes": [
            47180
        ],
        "district_id": 4718
    },
    {
        "id": 471804,
        "name_th": "กกปลาซิว",
        "name_en": "Kok Pla Sio",
        "zip_codes": [
            47180
        ],
        "district_id": 4718
    },
    {
        "id": 480101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480102,
        "name_th": "หนองแสง",
        "name_en": "Nong Saeng",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480103,
        "name_th": "นาทราย",
        "name_en": "Na Sai",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480104,
        "name_th": "นาราชควาย",
        "name_en": "Na Rat Khwai",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480105,
        "name_th": "กุรุคุ",
        "name_en": "Kurukhu",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480106,
        "name_th": "บ้านผึ้ง",
        "name_en": "Ban Phueng",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480107,
        "name_th": "อาจสามารถ",
        "name_en": "At Samat",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480108,
        "name_th": "ขามเฒ่า",
        "name_en": "Kham Thao",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480109,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480110,
        "name_th": "ท่าค้อ",
        "name_en": "Tha Kho",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480111,
        "name_th": "คำเตย",
        "name_en": "Kham Toei",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480112,
        "name_th": "หนองญาติ",
        "name_en": "Nong Yat",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480113,
        "name_th": "ดงขวาง",
        "name_en": "Dong Khwang",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480114,
        "name_th": "วังตามัว",
        "name_en": "Wang Ta Mua",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480115,
        "name_th": "โพธิ์ตาก",
        "name_en": "Pho Tak",
        "zip_codes": [
            48000
        ],
        "district_id": 4801
    },
    {
        "id": 480201,
        "name_th": "ปลาปาก",
        "name_en": "Pla Pak",
        "zip_codes": [
            48160
        ],
        "district_id": 4802
    },
    {
        "id": 480202,
        "name_th": "หนองฮี",
        "name_en": "Nong Hi",
        "zip_codes": [
            48160
        ],
        "district_id": 4802
    },
    {
        "id": 480203,
        "name_th": "กุตาไก้",
        "name_en": "Kutakai",
        "zip_codes": [
            48160
        ],
        "district_id": 4802
    },
    {
        "id": 480204,
        "name_th": "โคกสว่าง",
        "name_en": "Khok Sawang",
        "zip_codes": [
            48160
        ],
        "district_id": 4802
    },
    {
        "id": 480205,
        "name_th": "โคกสูง",
        "name_en": "Khok Sung",
        "zip_codes": [
            48160
        ],
        "district_id": 4802
    },
    {
        "id": 480206,
        "name_th": "มหาชัย",
        "name_en": "Maha Chai",
        "zip_codes": [
            48160
        ],
        "district_id": 4802
    },
    {
        "id": 480207,
        "name_th": "นามะเขือ",
        "name_en": "Na Makhuea",
        "zip_codes": [
            48160
        ],
        "district_id": 4802
    },
    {
        "id": 480208,
        "name_th": "หนองเทาใหญ่",
        "name_en": "Nong Thao Yai",
        "zip_codes": [
            48160
        ],
        "district_id": 4802
    },
    {
        "id": 480301,
        "name_th": "ท่าอุเทน",
        "name_en": "Tha Uthen",
        "zip_codes": [
            48120
        ],
        "district_id": 4803
    },
    {
        "id": 480302,
        "name_th": "โนนตาล",
        "name_en": "Non Tan",
        "zip_codes": [
            48120
        ],
        "district_id": 4803
    },
    {
        "id": 480303,
        "name_th": "ท่าจำปา",
        "name_en": "Tha Champa",
        "zip_codes": [
            48120
        ],
        "district_id": 4803
    },
    {
        "id": 480304,
        "name_th": "ไชยบุรี",
        "name_en": "Chaiburi",
        "zip_codes": [
            48120
        ],
        "district_id": 4803
    },
    {
        "id": 480305,
        "name_th": "พนอม",
        "name_en": "Phanom",
        "zip_codes": [
            48120
        ],
        "district_id": 4803
    },
    {
        "id": 480306,
        "name_th": "พะทาย",
        "name_en": "Phathai",
        "zip_codes": [
            48120
        ],
        "district_id": 4803
    },
    {
        "id": 480311,
        "name_th": "เวินพระบาท",
        "name_en": "Woen Phrabat",
        "zip_codes": [
            48120
        ],
        "district_id": 4803
    },
    {
        "id": 480312,
        "name_th": "รามราช",
        "name_en": "Ram Rat",
        "zip_codes": [
            48120
        ],
        "district_id": 4803
    },
    {
        "id": 480314,
        "name_th": "หนองเทา",
        "name_en": "Nong Thao",
        "zip_codes": [
            48120
        ],
        "district_id": 4803
    },
    {
        "id": 480401,
        "name_th": "บ้านแพง",
        "name_en": "Ban Phaeng",
        "zip_codes": [
            48140
        ],
        "district_id": 4804
    },
    {
        "id": 480402,
        "name_th": "ไผ่ล้อม",
        "name_en": "Phai Lom",
        "zip_codes": [
            48140
        ],
        "district_id": 4804
    },
    {
        "id": 480403,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            48140
        ],
        "district_id": 4804
    },
    {
        "id": 480404,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            48140
        ],
        "district_id": 4804
    },
    {
        "id": 480408,
        "name_th": "นางัว",
        "name_en": "Na Ngua",
        "zip_codes": [
            48140
        ],
        "district_id": 4804
    },
    {
        "id": 480409,
        "name_th": "นาเข",
        "name_en": "Na Khe",
        "zip_codes": [
            48140
        ],
        "district_id": 4804
    },
    {
        "id": 480501,
        "name_th": "ธาตุพนม",
        "name_en": "That Phanom",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480502,
        "name_th": "ฝั่งแดง",
        "name_en": "Fang Daeng",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480503,
        "name_th": "โพนแพง",
        "name_en": "Phon Phaeng",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480504,
        "name_th": "พระกลางทุ่ง",
        "name_en": "Phra Klang Thung",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480505,
        "name_th": "นาถ่อน",
        "name_en": "Na Thon",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480506,
        "name_th": "แสนพัน",
        "name_en": "Saen Phan",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480507,
        "name_th": "ดอนนางหงส์",
        "name_en": "Don Nang Hong",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480508,
        "name_th": "น้ำก่ำ",
        "name_en": "Nam Kam",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480509,
        "name_th": "อุ่มเหม้า",
        "name_en": "Um Mao",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480510,
        "name_th": "นาหนาด",
        "name_en": "Na Nat",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480511,
        "name_th": "กุดฉิม",
        "name_en": "Kut Chim",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480512,
        "name_th": "ธาตุพนมเหนือ",
        "name_en": "That Phanom Nuea",
        "zip_codes": [
            48110
        ],
        "district_id": 4805
    },
    {
        "id": 480601,
        "name_th": "เรณู",
        "name_en": "Renu",
        "zip_codes": [
            48170
        ],
        "district_id": 4806
    },
    {
        "id": 480602,
        "name_th": "โพนทอง",
        "name_en": "Phon Thong",
        "zip_codes": [
            48170
        ],
        "district_id": 4806
    },
    {
        "id": 480603,
        "name_th": "ท่าลาด",
        "name_en": "Tha Lat",
        "zip_codes": [
            48170
        ],
        "district_id": 4806
    },
    {
        "id": 480604,
        "name_th": "นางาม",
        "name_en": "Na Ngam",
        "zip_codes": [
            48170
        ],
        "district_id": 4806
    },
    {
        "id": 480605,
        "name_th": "โคกหินแฮ่",
        "name_en": "Khok Hin Hae",
        "zip_codes": [
            48170
        ],
        "district_id": 4806
    },
    {
        "id": 480607,
        "name_th": "หนองย่างชิ้น",
        "name_en": "Nong Yang Chin",
        "zip_codes": [
            48170
        ],
        "district_id": 4806
    },
    {
        "id": 480608,
        "name_th": "เรณูใต้",
        "name_en": "Renu Tai",
        "zip_codes": [
            48170
        ],
        "district_id": 4806
    },
    {
        "id": 480609,
        "name_th": "นาขาม",
        "name_en": "Na Kham",
        "zip_codes": [
            48170
        ],
        "district_id": 4806
    },
    {
        "id": 480701,
        "name_th": "นาแก",
        "name_en": "Na Kae",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480702,
        "name_th": "พระซอง",
        "name_en": "Phra Song",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480703,
        "name_th": "หนองสังข์",
        "name_en": "Nong Sang",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480704,
        "name_th": "นาคู่",
        "name_en": "Na Khu",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480705,
        "name_th": "พิมาน",
        "name_en": "Phiman",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480706,
        "name_th": "พุ่มแก",
        "name_en": "Phum Kae",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480707,
        "name_th": "ก้านเหลือง",
        "name_en": "Kan Lueang",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480708,
        "name_th": "หนองบ่อ",
        "name_en": "Nong Bo",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480709,
        "name_th": "นาเลียง",
        "name_en": "Na Liang",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480712,
        "name_th": "บ้านแก้ง",
        "name_en": "Ban Kaeng",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480713,
        "name_th": "คำพี้",
        "name_en": "Ham Phi",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480715,
        "name_th": "สีชมพู",
        "name_en": "Si Chomphu",
        "zip_codes": [
            48130
        ],
        "district_id": 4807
    },
    {
        "id": 480801,
        "name_th": "ศรีสงคราม",
        "name_en": "Si Songkhram",
        "zip_codes": [
            48150
        ],
        "district_id": 4808
    },
    {
        "id": 480802,
        "name_th": "นาเดื่อ",
        "name_en": "Na Duea",
        "zip_codes": [
            48150
        ],
        "district_id": 4808
    },
    {
        "id": 480803,
        "name_th": "บ้านเอื้อง",
        "name_en": "Ban Ueang",
        "zip_codes": [
            48150
        ],
        "district_id": 4808
    },
    {
        "id": 480804,
        "name_th": "สามผง",
        "name_en": "sam Phong",
        "zip_codes": [
            48150
        ],
        "district_id": 4808
    },
    {
        "id": 480805,
        "name_th": "ท่าบ่อสงคราม",
        "name_en": "Tha Bo Songkhram",
        "zip_codes": [
            48150
        ],
        "district_id": 4808
    },
    {
        "id": 480806,
        "name_th": "บ้านข่า",
        "name_en": "Ban Kha",
        "zip_codes": [
            48150
        ],
        "district_id": 4808
    },
    {
        "id": 480807,
        "name_th": "นาคำ",
        "name_en": "Na Kham",
        "zip_codes": [
            48150
        ],
        "district_id": 4808
    },
    {
        "id": 480808,
        "name_th": "โพนสว่าง",
        "name_en": "Phon Sawang",
        "zip_codes": [
            48150
        ],
        "district_id": 4808
    },
    {
        "id": 480809,
        "name_th": "หาดแพง",
        "name_en": "Hat Phaeng",
        "zip_codes": [
            48150
        ],
        "district_id": 4808
    },
    {
        "id": 480901,
        "name_th": "นาหว้า",
        "name_en": "Na Wa",
        "zip_codes": [
            48180
        ],
        "district_id": 4809
    },
    {
        "id": 480902,
        "name_th": "นางัว",
        "name_en": "Na Ngua",
        "zip_codes": [
            48180
        ],
        "district_id": 4809
    },
    {
        "id": 480903,
        "name_th": "บ้านเสียว",
        "name_en": "Ban Siao",
        "zip_codes": [
            48180
        ],
        "district_id": 4809
    },
    {
        "id": 480904,
        "name_th": "นาคูณใหญ่",
        "name_en": "Na Khun Yai",
        "zip_codes": [
            48180
        ],
        "district_id": 4809
    },
    {
        "id": 480905,
        "name_th": "เหล่าพัฒนา",
        "name_en": "Lao Phatthana",
        "zip_codes": [
            48180
        ],
        "district_id": 4809
    },
    {
        "id": 480906,
        "name_th": "ท่าเรือ",
        "name_en": "Tha Ruea",
        "zip_codes": [
            48180
        ],
        "district_id": 4809
    },
    {
        "id": 481001,
        "name_th": "โพนสวรรค์",
        "name_en": "Phon Sawan",
        "zip_codes": [
            48190
        ],
        "district_id": 4810
    },
    {
        "id": 481002,
        "name_th": "นาหัวบ่อ",
        "name_en": "Na Hua Bo",
        "zip_codes": [
            48190
        ],
        "district_id": 4810
    },
    {
        "id": 481003,
        "name_th": "นาขมิ้น",
        "name_en": "Na Khamin",
        "zip_codes": [
            48190
        ],
        "district_id": 4810
    },
    {
        "id": 481004,
        "name_th": "โพนบก",
        "name_en": "Phon Bok",
        "zip_codes": [
            48190
        ],
        "district_id": 4810
    },
    {
        "id": 481005,
        "name_th": "บ้านค้อ",
        "name_en": "Ban Kho",
        "zip_codes": [
            48190
        ],
        "district_id": 4810
    },
    {
        "id": 481006,
        "name_th": "โพนจาน",
        "name_en": "Phon Chan",
        "zip_codes": [
            48190
        ],
        "district_id": 4810
    },
    {
        "id": 481007,
        "name_th": "นาใน",
        "name_en": "Na Nai",
        "zip_codes": [
            48190
        ],
        "district_id": 4810
    },
    {
        "id": 481101,
        "name_th": "นาทม",
        "name_en": "Na Thom",
        "zip_codes": [
            48140
        ],
        "district_id": 4811
    },
    {
        "id": 481102,
        "name_th": "หนองซน",
        "name_en": "Nong Son",
        "zip_codes": [
            48140
        ],
        "district_id": 4811
    },
    {
        "id": 481103,
        "name_th": "ดอนเตย",
        "name_en": "Don Toei",
        "zip_codes": [
            48140
        ],
        "district_id": 4811
    },
    {
        "id": 481201,
        "name_th": "วังยาง",
        "name_en": "Wang Yang",
        "zip_codes": [
            48130
        ],
        "district_id": 4812
    },
    {
        "id": 481202,
        "name_th": "โคกสี",
        "name_en": "Khok Si",
        "zip_codes": [
            48130
        ],
        "district_id": 4812
    },
    {
        "id": 481203,
        "name_th": "ยอดชาด",
        "name_en": "Yot Chat",
        "zip_codes": [
            48130
        ],
        "district_id": 4812
    },
    {
        "id": 481204,
        "name_th": "หนองโพธิ์",
        "name_en": "Nong Pho",
        "zip_codes": [
            48130
        ],
        "district_id": 4812
    },
    {
        "id": 490101,
        "name_th": "มุกดาหาร",
        "name_en": "Mukdahan",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490102,
        "name_th": "ศรีบุญเรือง",
        "name_en": "Si Bun Rueang",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490103,
        "name_th": "บ้านโคก",
        "name_en": "Ban Khok",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490104,
        "name_th": "บางทรายใหญ่",
        "name_en": "Bang Sai Yai",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490105,
        "name_th": "โพนทราย",
        "name_en": "Phon Sai",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490106,
        "name_th": "ผึ่งแดด",
        "name_en": "Phueng Daet",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490107,
        "name_th": "นาโสก",
        "name_en": "Na Sok",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490108,
        "name_th": "นาสีนวน",
        "name_en": "Na Si Nuan",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490109,
        "name_th": "คำป่าหลาย",
        "name_en": "Kham Pa Lai",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490110,
        "name_th": "คำอาฮวน",
        "name_en": "Kham Ahuan",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490111,
        "name_th": "ดงเย็น",
        "name_en": "Dong Yen",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490112,
        "name_th": "ดงมอน",
        "name_en": "Dong Mon",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490113,
        "name_th": "กุดแข้",
        "name_en": "Kut Khae",
        "zip_codes": [
            49000
        ],
        "district_id": 4901
    },
    {
        "id": 490201,
        "name_th": "นิคมคำสร้อย",
        "name_en": "Nikhom Kham Soi",
        "zip_codes": [
            49130
        ],
        "district_id": 4902
    },
    {
        "id": 490202,
        "name_th": "นากอก",
        "name_en": "Na Kok",
        "zip_codes": [
            49130
        ],
        "district_id": 4902
    },
    {
        "id": 490203,
        "name_th": "หนองแวง",
        "name_en": "Nong Waeng",
        "zip_codes": [
            49130
        ],
        "district_id": 4902
    },
    {
        "id": 490204,
        "name_th": "กกแดง",
        "name_en": "Kok Daeng",
        "zip_codes": [
            49130
        ],
        "district_id": 4902
    },
    {
        "id": 490205,
        "name_th": "นาอุดม",
        "name_en": "Na Udom",
        "zip_codes": [
            49130
        ],
        "district_id": 4902
    },
    {
        "id": 490206,
        "name_th": "โชคชัย",
        "name_en": "Chok Chai",
        "zip_codes": [
            49130
        ],
        "district_id": 4902
    },
    {
        "id": 490207,
        "name_th": "ร่มเกล้า",
        "name_en": "Rom Klao",
        "zip_codes": [
            49130
        ],
        "district_id": 4902
    },
    {
        "id": 490301,
        "name_th": "ดอนตาล",
        "name_en": "Don Tan",
        "zip_codes": [
            49120
        ],
        "district_id": 4903
    },
    {
        "id": 490302,
        "name_th": "โพธิ์ไทร",
        "name_en": "Pho Sai",
        "zip_codes": [
            49120
        ],
        "district_id": 4903
    },
    {
        "id": 490303,
        "name_th": "ป่าไร่",
        "name_en": "Pa Rai",
        "zip_codes": [
            49120
        ],
        "district_id": 4903
    },
    {
        "id": 490304,
        "name_th": "เหล่าหมี",
        "name_en": "Lao Mi",
        "zip_codes": [
            49120
        ],
        "district_id": 4903
    },
    {
        "id": 490305,
        "name_th": "บ้านบาก",
        "name_en": "Ban Bak",
        "zip_codes": [
            49120
        ],
        "district_id": 4903
    },
    {
        "id": 490306,
        "name_th": "นาสะเม็ง",
        "name_en": "Na Sameng",
        "zip_codes": [
            49120
        ],
        "district_id": 4903
    },
    {
        "id": 490307,
        "name_th": "บ้านแก้ง",
        "name_en": "Ban Kaeng",
        "zip_codes": [
            49120
        ],
        "district_id": 4903
    },
    {
        "id": 490401,
        "name_th": "ดงหลวง",
        "name_en": "Dong Luang",
        "zip_codes": [
            49140
        ],
        "district_id": 4904
    },
    {
        "id": 490402,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            49140
        ],
        "district_id": 4904
    },
    {
        "id": 490403,
        "name_th": "กกตูม",
        "name_en": "Kok Tum",
        "zip_codes": [
            49140
        ],
        "district_id": 4904
    },
    {
        "id": 490404,
        "name_th": "หนองแคน",
        "name_en": "Nong Khaen",
        "zip_codes": [
            49140
        ],
        "district_id": 4904
    },
    {
        "id": 490405,
        "name_th": "ชะโนดน้อย",
        "name_en": "Chanot Noi",
        "zip_codes": [
            49140
        ],
        "district_id": 4904
    },
    {
        "id": 490406,
        "name_th": "พังแดง",
        "name_en": "Phang Daeng",
        "zip_codes": [
            49140
        ],
        "district_id": 4904
    },
    {
        "id": 490503,
        "name_th": "บ้านซ่ง",
        "name_en": "Ban Song",
        "zip_codes": [
            49110
        ],
        "district_id": 4905
    },
    {
        "id": 490504,
        "name_th": "คำชะอี",
        "name_en": "Kham Cha-i",
        "zip_codes": [
            49110
        ],
        "district_id": 4905
    },
    {
        "id": 490505,
        "name_th": "หนองเอี่ยน",
        "name_en": "Nong Ian",
        "zip_codes": [
            49110
        ],
        "district_id": 4905
    },
    {
        "id": 490506,
        "name_th": "บ้านค้อ",
        "name_en": "Ban Kho",
        "zip_codes": [
            49110
        ],
        "district_id": 4905
    },
    {
        "id": 490507,
        "name_th": "บ้านเหล่า",
        "name_en": "Ban Lao",
        "zip_codes": [
            49110
        ],
        "district_id": 4905
    },
    {
        "id": 490508,
        "name_th": "โพนงาม",
        "name_en": "Phon Ngam",
        "zip_codes": [
            49110
        ],
        "district_id": 4905
    },
    {
        "id": 490511,
        "name_th": "เหล่าสร้างถ่อ",
        "name_en": "Lao Sang Tho",
        "zip_codes": [
            49110
        ],
        "district_id": 4905
    },
    {
        "id": 490512,
        "name_th": "คำบก",
        "name_en": "Kham Bok",
        "zip_codes": [
            49110
        ],
        "district_id": 4905
    },
    {
        "id": 490514,
        "name_th": "น้ำเที่ยง",
        "name_en": "Nam Thiang",
        "zip_codes": [
            49110
        ],
        "district_id": 4905
    },
    {
        "id": 490601,
        "name_th": "หว้านใหญ่",
        "name_en": "Wan Yai",
        "zip_codes": [
            49150
        ],
        "district_id": 4906
    },
    {
        "id": 490602,
        "name_th": "ป่งขาม",
        "name_en": "Pong Kham",
        "zip_codes": [
            49150
        ],
        "district_id": 4906
    },
    {
        "id": 490603,
        "name_th": "บางทรายน้อย",
        "name_en": "Bang Sai Noi",
        "zip_codes": [
            49150
        ],
        "district_id": 4906
    },
    {
        "id": 490604,
        "name_th": "ชะโนด",
        "name_en": "Chanot",
        "zip_codes": [
            49150
        ],
        "district_id": 4906
    },
    {
        "id": 490605,
        "name_th": "ดงหมู",
        "name_en": "Dong Mu",
        "zip_codes": [
            49150
        ],
        "district_id": 4906
    },
    {
        "id": 490701,
        "name_th": "หนองสูง",
        "name_en": "Nong Sung",
        "zip_codes": [
            49160
        ],
        "district_id": 4907
    },
    {
        "id": 490702,
        "name_th": "โนนยาง",
        "name_en": "Non Yang",
        "zip_codes": [
            49160
        ],
        "district_id": 4907
    },
    {
        "id": 490703,
        "name_th": "ภูวง",
        "name_en": "Phu Wong",
        "zip_codes": [
            49160
        ],
        "district_id": 4907
    },
    {
        "id": 490704,
        "name_th": "บ้านเป้า",
        "name_en": "Ban Pao",
        "zip_codes": [
            49160
        ],
        "district_id": 4907
    },
    {
        "id": 490705,
        "name_th": "หนองสูงใต้",
        "name_en": "Nong Sung Tai",
        "zip_codes": [
            49160
        ],
        "district_id": 4907
    },
    {
        "id": 490706,
        "name_th": "หนองสูงเหนือ",
        "name_en": "Nong Sung Nuea",
        "zip_codes": [
            49160
        ],
        "district_id": 4907
    },
    {
        "id": 500101,
        "name_th": "ศรีภูมิ",
        "name_en": "Si Phum",
        "zip_codes": [
            50200
        ],
        "district_id": 5001
    },
    {
        "id": 500102,
        "name_th": "พระสิงห์",
        "name_en": "Phra Sing",
        "zip_codes": [
            50200
        ],
        "district_id": 5001
    },
    {
        "id": 500103,
        "name_th": "หายยา",
        "name_en": "Hai Ya",
        "zip_codes": [
            50100
        ],
        "district_id": 5001
    },
    {
        "id": 500104,
        "name_th": "ช้างม่อย",
        "name_en": "Chang Moi",
        "zip_codes": [
            50300
        ],
        "district_id": 5001
    },
    {
        "id": 500105,
        "name_th": "ช้างคลาน",
        "name_en": "Chang Khlan",
        "zip_codes": [
            50100
        ],
        "district_id": 5001
    },
    {
        "id": 500106,
        "name_th": "วัดเกต",
        "name_en": "Wat Ket",
        "zip_codes": [
            50000
        ],
        "district_id": 5001
    },
    {
        "id": 500107,
        "name_th": "ช้างเผือก",
        "name_en": "Chang Phueak",
        "zip_codes": [
            50300
        ],
        "district_id": 5001
    },
    {
        "id": 500108,
        "name_th": "สุเทพ",
        "name_en": "Suthep",
        "zip_codes": [
            50200
        ],
        "district_id": 5001
    },
    {
        "id": 500109,
        "name_th": "แม่เหียะ",
        "name_en": "Mae Hia",
        "zip_codes": [
            50100
        ],
        "district_id": 5001
    },
    {
        "id": 500110,
        "name_th": "ป่าแดด",
        "name_en": "Pa Daet",
        "zip_codes": [
            50100
        ],
        "district_id": 5001
    },
    {
        "id": 500111,
        "name_th": "หนองหอย",
        "name_en": "Nong Hoi",
        "zip_codes": [
            50000
        ],
        "district_id": 5001
    },
    {
        "id": 500112,
        "name_th": "ท่าศาลา",
        "name_en": "Tha Sala",
        "zip_codes": [
            50000
        ],
        "district_id": 5001
    },
    {
        "id": 500113,
        "name_th": "หนองป่าครั่ง",
        "name_en": "Nong Pa Khrang",
        "zip_codes": [
            50000
        ],
        "district_id": 5001
    },
    {
        "id": 500114,
        "name_th": "ฟ้าฮ่าม",
        "name_en": "Fa Ham",
        "zip_codes": [
            50000
        ],
        "district_id": 5001
    },
    {
        "id": 500115,
        "name_th": "ป่าตัน",
        "name_en": "Pa Tan",
        "zip_codes": [
            50300
        ],
        "district_id": 5001
    },
    {
        "id": 500116,
        "name_th": "สันผีเสื้อ",
        "name_en": "San Phi Suea",
        "zip_codes": [
            50290,
            50300
        ],
        "district_id": 5001
    },
    {
        "id": 500203,
        "name_th": "บ้านหลวง",
        "name_en": "Ban Luang",
        "zip_codes": [
            50160
        ],
        "district_id": 5002
    },
    {
        "id": 500204,
        "name_th": "ข่วงเปา",
        "name_en": "Khuang Pao",
        "zip_codes": [
            50160
        ],
        "district_id": 5002
    },
    {
        "id": 500205,
        "name_th": "สบเตี๊ยะ",
        "name_en": "Sop Tia",
        "zip_codes": [
            50160
        ],
        "district_id": 5002
    },
    {
        "id": 500206,
        "name_th": "บ้านแปะ",
        "name_en": "Ban Pae",
        "zip_codes": [
            50240
        ],
        "district_id": 5002
    },
    {
        "id": 500207,
        "name_th": "ดอยแก้ว",
        "name_en": "Doi Kaeo",
        "zip_codes": [
            50160
        ],
        "district_id": 5002
    },
    {
        "id": 500209,
        "name_th": "แม่สอย",
        "name_en": "Mae Soi",
        "zip_codes": [
            50160,
            50240
        ],
        "district_id": 5002
    },
    {
        "id": 500301,
        "name_th": "ช่างเคิ่ง",
        "name_en": "Chang Khoeng",
        "zip_codes": [
            50270
        ],
        "district_id": 5003
    },
    {
        "id": 500302,
        "name_th": "ท่าผา",
        "name_en": "The Pha",
        "zip_codes": [
            50270
        ],
        "district_id": 5003
    },
    {
        "id": 500303,
        "name_th": "บ้านทับ",
        "name_en": "Ban Thap",
        "zip_codes": [
            50270
        ],
        "district_id": 5003
    },
    {
        "id": 500304,
        "name_th": "แม่ศึก",
        "name_en": "Mae Suek",
        "zip_codes": [
            50270
        ],
        "district_id": 5003
    },
    {
        "id": 500305,
        "name_th": "แม่นาจร",
        "name_en": "Mae Na Chon",
        "zip_codes": [
            50270
        ],
        "district_id": 5003
    },
    {
        "id": 500307,
        "name_th": "ปางหินฝน",
        "name_en": "Pang Hin Fon",
        "zip_codes": [
            50270
        ],
        "district_id": 5003
    },
    {
        "id": 500308,
        "name_th": "กองแขก",
        "name_en": "Kong Khaek",
        "zip_codes": [
            50270
        ],
        "district_id": 5003
    },
    {
        "id": 500401,
        "name_th": "เชียงดาว",
        "name_en": "Chiang Dao",
        "zip_codes": [
            50170
        ],
        "district_id": 5004
    },
    {
        "id": 500402,
        "name_th": "เมืองนะ",
        "name_en": "Mueang Na",
        "zip_codes": [
            50170
        ],
        "district_id": 5004
    },
    {
        "id": 500403,
        "name_th": "เมืองงาย",
        "name_en": "Mueang Ngai",
        "zip_codes": [
            50170
        ],
        "district_id": 5004
    },
    {
        "id": 500404,
        "name_th": "แม่นะ",
        "name_en": "Mae Na",
        "zip_codes": [
            50170
        ],
        "district_id": 5004
    },
    {
        "id": 500405,
        "name_th": "เมืองคอง",
        "name_en": "Mueang Khong",
        "zip_codes": [
            50170
        ],
        "district_id": 5004
    },
    {
        "id": 500406,
        "name_th": "ปิงโค้ง",
        "name_en": "Ping Khong",
        "zip_codes": [
            50170
        ],
        "district_id": 5004
    },
    {
        "id": 500407,
        "name_th": "ทุ่งข้าวพวง",
        "name_en": "Thung Khao Phuang",
        "zip_codes": [
            50170
        ],
        "district_id": 5004
    },
    {
        "id": 500501,
        "name_th": "เชิงดอย",
        "name_en": "Choeng Doi",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500502,
        "name_th": "สันปูเลย",
        "name_en": "San Pu Loei",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500503,
        "name_th": "ลวงเหนือ",
        "name_en": "Luang Nuea",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500504,
        "name_th": "ป่าป้อง",
        "name_en": "Pa Pong",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500505,
        "name_th": "สง่าบ้าน",
        "name_en": "Sa-nga Ban",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500506,
        "name_th": "ป่าลาน",
        "name_en": "Pa Lan",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500507,
        "name_th": "ตลาดขวัญ",
        "name_en": "Talat Khwan",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500508,
        "name_th": "สำราญราษฎร์",
        "name_en": "Samran Rat",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500509,
        "name_th": "แม่คือ",
        "name_en": "Mae Khue",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500510,
        "name_th": "ตลาดใหญ่",
        "name_en": "Talat Yai",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500511,
        "name_th": "แม่ฮ้อยเงิน",
        "name_en": "Mae Hoi Ngoen",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500512,
        "name_th": "แม่โป่ง",
        "name_en": "Mae Pong",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500513,
        "name_th": "ป่าเมี่ยง",
        "name_en": "Pa Miang",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500514,
        "name_th": "เทพเสด็จ",
        "name_en": "Thep Sadet",
        "zip_codes": [
            50220
        ],
        "district_id": 5005
    },
    {
        "id": 500601,
        "name_th": "สันมหาพน",
        "name_en": "San Maha Phon",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500602,
        "name_th": "แม่แตง",
        "name_en": "Mae Taeng",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500603,
        "name_th": "ขี้เหล็ก",
        "name_en": "Khilek",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500604,
        "name_th": "ช่อแล",
        "name_en": "Cho Lae",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500605,
        "name_th": "แม่หอพระ",
        "name_en": "Mae Ho Phra",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500606,
        "name_th": "สบเปิง",
        "name_en": "Sop Poeng",
        "zip_codes": [
            50150,
            50330
        ],
        "district_id": 5006
    },
    {
        "id": 500607,
        "name_th": "บ้านเป้า",
        "name_en": "Ban Pao",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500608,
        "name_th": "สันป่ายาง",
        "name_en": "San Pa Yang",
        "zip_codes": [
            50330
        ],
        "district_id": 5006
    },
    {
        "id": 500609,
        "name_th": "ป่าแป๋",
        "name_en": "Pa Pae",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500610,
        "name_th": "เมืองก๋าย",
        "name_en": "Mueang Kai",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500611,
        "name_th": "บ้านช้าง",
        "name_en": "Ban Chang",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500612,
        "name_th": "กื้ดช้าง",
        "name_en": "Kuet Chang",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500613,
        "name_th": "อินทขิล",
        "name_en": "Inthakhin",
        "zip_codes": [
            50150
        ],
        "district_id": 5006
    },
    {
        "id": 500701,
        "name_th": "ริมใต้",
        "name_en": "Rim Tai",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500702,
        "name_th": "ริมเหนือ",
        "name_en": "Rim Nuea",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500703,
        "name_th": "สันโป่ง",
        "name_en": "San Pong",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500704,
        "name_th": "ขี้เหล็ก",
        "name_en": "Khilek",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500705,
        "name_th": "สะลวง",
        "name_en": "Saluang",
        "zip_codes": [
            50330
        ],
        "district_id": 5007
    },
    {
        "id": 500706,
        "name_th": "ห้วยทราย",
        "name_en": "Huai Sai",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500707,
        "name_th": "แม่แรม",
        "name_en": "Mae Raem",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500708,
        "name_th": "โป่งแยง",
        "name_en": "Pong Yaeng",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500709,
        "name_th": "แม่สา",
        "name_en": "Mae Sa",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500710,
        "name_th": "ดอนแก้ว",
        "name_en": "Don Kaeo",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500711,
        "name_th": "เหมืองแก้ว",
        "name_en": "Mueang Kaeo",
        "zip_codes": [
            50180
        ],
        "district_id": 5007
    },
    {
        "id": 500801,
        "name_th": "สะเมิงใต้",
        "name_en": "Samoeng Tai",
        "zip_codes": [
            50250
        ],
        "district_id": 5008
    },
    {
        "id": 500802,
        "name_th": "สะเมิงเหนือ",
        "name_en": "Samoeng Nuea",
        "zip_codes": [
            50250
        ],
        "district_id": 5008
    },
    {
        "id": 500803,
        "name_th": "แม่สาบ",
        "name_en": "Mae Sap",
        "zip_codes": [
            50250
        ],
        "district_id": 5008
    },
    {
        "id": 500804,
        "name_th": "บ่อแก้ว",
        "name_en": "Bo Kaeo",
        "zip_codes": [
            50250
        ],
        "district_id": 5008
    },
    {
        "id": 500805,
        "name_th": "ยั้งเมิน",
        "name_en": "Yang Moen",
        "zip_codes": [
            50250
        ],
        "district_id": 5008
    },
    {
        "id": 500901,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            50110
        ],
        "district_id": 5009
    },
    {
        "id": 500903,
        "name_th": "ม่อนปิ่น",
        "name_en": "Mon Pin",
        "zip_codes": [
            50110
        ],
        "district_id": 5009
    },
    {
        "id": 500904,
        "name_th": "แม่งอน",
        "name_en": "Mae Ngon",
        "zip_codes": [
            50320
        ],
        "district_id": 5009
    },
    {
        "id": 500905,
        "name_th": "แม่สูน",
        "name_en": "Mae Sun",
        "zip_codes": [
            50110
        ],
        "district_id": 5009
    },
    {
        "id": 500906,
        "name_th": "สันทราย",
        "name_en": "San Sai",
        "zip_codes": [
            50110
        ],
        "district_id": 5009
    },
    {
        "id": 500910,
        "name_th": "แม่คะ",
        "name_en": "Mae Kha",
        "zip_codes": [
            50110
        ],
        "district_id": 5009
    },
    {
        "id": 500911,
        "name_th": "แม่ข่า",
        "name_en": "Mae Kha",
        "zip_codes": [
            50320
        ],
        "district_id": 5009
    },
    {
        "id": 500912,
        "name_th": "โป่งน้ำร้อน",
        "name_en": "Pong Nam Ron",
        "zip_codes": [
            50110
        ],
        "district_id": 5009
    },
    {
        "id": 501001,
        "name_th": "แม่อาย",
        "name_en": "Mae Ai",
        "zip_codes": [
            50280
        ],
        "district_id": 5010
    },
    {
        "id": 501002,
        "name_th": "แม่สาว",
        "name_en": "Mae Sao",
        "zip_codes": [
            50280
        ],
        "district_id": 5010
    },
    {
        "id": 501003,
        "name_th": "สันต้นหมื้อ",
        "name_en": "San Ton Mue",
        "zip_codes": [
            50280
        ],
        "district_id": 5010
    },
    {
        "id": 501004,
        "name_th": "แม่นาวาง",
        "name_en": "Mae Na Wang",
        "zip_codes": [
            50280
        ],
        "district_id": 5010
    },
    {
        "id": 501005,
        "name_th": "ท่าตอน",
        "name_en": "Tha Ton",
        "zip_codes": [
            50280
        ],
        "district_id": 5010
    },
    {
        "id": 501006,
        "name_th": "บ้านหลวง",
        "name_en": "Ban Luang",
        "zip_codes": [
            50280
        ],
        "district_id": 5010
    },
    {
        "id": 501007,
        "name_th": "มะลิกา",
        "name_en": "Malika",
        "zip_codes": [
            50280
        ],
        "district_id": 5010
    },
    {
        "id": 501101,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501102,
        "name_th": "ทุ่งหลวง",
        "name_en": "Thung Luang",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501103,
        "name_th": "ป่าตุ้ม",
        "name_en": "Pa Tum",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501104,
        "name_th": "ป่าไหน่",
        "name_en": "Pa Nai",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501105,
        "name_th": "สันทราย",
        "name_en": "San Sai",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501106,
        "name_th": "บ้านโป่ง",
        "name_en": "Ban Pong",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501107,
        "name_th": "น้ำแพร่",
        "name_en": "Nam Phrae",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501108,
        "name_th": "เขื่อนผาก",
        "name_en": "Khuean Phak",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501109,
        "name_th": "แม่แวน",
        "name_en": "Mae Waen",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501110,
        "name_th": "แม่ปั๋ง",
        "name_en": "Mae Pang",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501111,
        "name_th": "โหล่งขอด",
        "name_en": "Long Khot",
        "zip_codes": [
            50190
        ],
        "district_id": 5011
    },
    {
        "id": 501201,
        "name_th": "ยุหว่า",
        "name_en": "Yu Wa",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501202,
        "name_th": "สันกลาง",
        "name_en": "San Klang",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501203,
        "name_th": "ท่าวังพร้าว",
        "name_en": "Tha Wang Phrao",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501204,
        "name_th": "มะขามหลวง",
        "name_en": "Makham Luang",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501205,
        "name_th": "แม่ก๊า",
        "name_en": "Mae Ka",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501206,
        "name_th": "บ้านแม",
        "name_en": "Ban Mae",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501207,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501208,
        "name_th": "ทุ่งสะโตก",
        "name_en": "Thung Satok",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501210,
        "name_th": "ทุ่งต้อม",
        "name_en": "Thung Tom",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501214,
        "name_th": "น้ำบ่อหลวง",
        "name_en": "Nam Bo Luang",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501215,
        "name_th": "มะขุนหวาน",
        "name_en": "Makhun Wan",
        "zip_codes": [
            50120
        ],
        "district_id": 5012
    },
    {
        "id": 501301,
        "name_th": "สันกำแพง",
        "name_en": "San Kamphaeng",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501302,
        "name_th": "ทรายมูล",
        "name_en": "Sai Mun",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501303,
        "name_th": "ร้องวัวแดง",
        "name_en": "Rong Wua Daeng",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501304,
        "name_th": "บวกค้าง",
        "name_en": "Buak Khang",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501305,
        "name_th": "แช่ช้าง",
        "name_en": "Chae Chang",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501306,
        "name_th": "ออนใต้",
        "name_en": "On Tai",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501310,
        "name_th": "แม่ปูคา",
        "name_en": "Mae Pu Kha",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501311,
        "name_th": "ห้วยทราย",
        "name_en": "Huai Sai",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501312,
        "name_th": "ต้นเปา",
        "name_en": "Ton Pao",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501313,
        "name_th": "สันกลาง",
        "name_en": "San Klang",
        "zip_codes": [
            50130
        ],
        "district_id": 5013
    },
    {
        "id": 501401,
        "name_th": "สันทรายหลวง",
        "name_en": "San Sai Luang",
        "zip_codes": [
            50210
        ],
        "district_id": 5014
    },
    {
        "id": 501402,
        "name_th": "สันทรายน้อย",
        "name_en": "San Sai Noi",
        "zip_codes": [
            50210
        ],
        "district_id": 5014
    },
    {
        "id": 501403,
        "name_th": "สันพระเนตร",
        "name_en": "San Phra Net",
        "zip_codes": [
            50210
        ],
        "district_id": 5014
    },
    {
        "id": 501404,
        "name_th": "สันนาเม็ง",
        "name_en": "San Na Meng",
        "zip_codes": [
            50210
        ],
        "district_id": 5014
    },
    {
        "id": 501405,
        "name_th": "สันป่าเปา",
        "name_en": "San Pa Pao",
        "zip_codes": [
            50210
        ],
        "district_id": 5014
    },
    {
        "id": 501406,
        "name_th": "หนองแหย่ง",
        "name_en": "Nong Yaeng",
        "zip_codes": [
            50210
        ],
        "district_id": 5014
    },
    {
        "id": 501407,
        "name_th": "หนองจ๊อม",
        "name_en": "Nong Chom",
        "zip_codes": [
            50210,
            50290
        ],
        "district_id": 5014
    },
    {
        "id": 501408,
        "name_th": "หนองหาร",
        "name_en": "Nong Han",
        "zip_codes": [
            50290
        ],
        "district_id": 5014
    },
    {
        "id": 501409,
        "name_th": "แม่แฝก",
        "name_en": "Mae Faek",
        "zip_codes": [
            50290
        ],
        "district_id": 5014
    },
    {
        "id": 501410,
        "name_th": "แม่แฝกใหม่",
        "name_en": "Mae Faek Mai",
        "zip_codes": [
            50290
        ],
        "district_id": 5014
    },
    {
        "id": 501411,
        "name_th": "เมืองเล็น",
        "name_en": "Mueang Len",
        "zip_codes": [
            50210
        ],
        "district_id": 5014
    },
    {
        "id": 501412,
        "name_th": "ป่าไผ่",
        "name_en": "Pa Phai",
        "zip_codes": [
            50210
        ],
        "district_id": 5014
    },
    {
        "id": 501501,
        "name_th": "หางดง",
        "name_en": "Hang Dong",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501502,
        "name_th": "หนองแก๋ว",
        "name_en": "Nong Kaeo",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501503,
        "name_th": "หารแก้ว",
        "name_en": "Han Kaeo",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501504,
        "name_th": "หนองตอง",
        "name_en": "Nong Tong",
        "zip_codes": [
            50340
        ],
        "district_id": 5015
    },
    {
        "id": 501505,
        "name_th": "ขุนคง",
        "name_en": "Khun Khong",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501506,
        "name_th": "สบแม่ข่า",
        "name_en": "Sop Mae Kha",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501507,
        "name_th": "บ้านแหวน",
        "name_en": "Ban Waen",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501508,
        "name_th": "สันผักหวาน",
        "name_en": "San Phak Wan",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501509,
        "name_th": "หนองควาย",
        "name_en": "Nong Khwai",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501510,
        "name_th": "บ้านปง",
        "name_en": "Ban Pong",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501511,
        "name_th": "น้ำแพร่",
        "name_en": "Nam Phrae",
        "zip_codes": [
            50230
        ],
        "district_id": 5015
    },
    {
        "id": 501601,
        "name_th": "หางดง",
        "name_en": "Hang Dong",
        "zip_codes": [
            50240
        ],
        "district_id": 5016
    },
    {
        "id": 501602,
        "name_th": "ฮอด",
        "name_en": "Hot",
        "zip_codes": [
            50240
        ],
        "district_id": 5016
    },
    {
        "id": 501603,
        "name_th": "บ้านตาล",
        "name_en": "Ban Tan",
        "zip_codes": [
            50240
        ],
        "district_id": 5016
    },
    {
        "id": 501604,
        "name_th": "บ่อหลวง",
        "name_en": "Bo Luang",
        "zip_codes": [
            50240
        ],
        "district_id": 5016
    },
    {
        "id": 501605,
        "name_th": "บ่อสลี",
        "name_en": "Bo Sali",
        "zip_codes": [
            50240
        ],
        "district_id": 5016
    },
    {
        "id": 501606,
        "name_th": "นาคอเรือ",
        "name_en": "Na Kho Ruea",
        "zip_codes": [
            50240
        ],
        "district_id": 5016
    },
    {
        "id": 501701,
        "name_th": "ดอยเต่า",
        "name_en": "Doi Tao",
        "zip_codes": [
            50260
        ],
        "district_id": 5017
    },
    {
        "id": 501702,
        "name_th": "ท่าเดื่อ",
        "name_en": "Tha Duea",
        "zip_codes": [
            50260
        ],
        "district_id": 5017
    },
    {
        "id": 501703,
        "name_th": "มืดกา",
        "name_en": "Muet Ka",
        "zip_codes": [
            50260
        ],
        "district_id": 5017
    },
    {
        "id": 501704,
        "name_th": "บ้านแอ่น",
        "name_en": "Ban Aen",
        "zip_codes": [
            50260
        ],
        "district_id": 5017
    },
    {
        "id": 501705,
        "name_th": "บงตัน",
        "name_en": "Bong Tan",
        "zip_codes": [
            50260
        ],
        "district_id": 5017
    },
    {
        "id": 501706,
        "name_th": "โปงทุ่ง",
        "name_en": "Pong Thung",
        "zip_codes": [
            50260
        ],
        "district_id": 5017
    },
    {
        "id": 501801,
        "name_th": "อมก๋อย",
        "name_en": "Omkoi",
        "zip_codes": [
            50310
        ],
        "district_id": 5018
    },
    {
        "id": 501802,
        "name_th": "ยางเปียง",
        "name_en": "Yang Piang",
        "zip_codes": [
            50310
        ],
        "district_id": 5018
    },
    {
        "id": 501803,
        "name_th": "แม่ตื่น",
        "name_en": "Mae Tuen",
        "zip_codes": [
            50310
        ],
        "district_id": 5018
    },
    {
        "id": 501804,
        "name_th": "ม่อนจอง",
        "name_en": "Mon Chong",
        "zip_codes": [
            50310
        ],
        "district_id": 5018
    },
    {
        "id": 501805,
        "name_th": "สบโขง",
        "name_en": "Sop Khong",
        "zip_codes": [
            50310
        ],
        "district_id": 5018
    },
    {
        "id": 501806,
        "name_th": "นาเกียน",
        "name_en": "Na Kian",
        "zip_codes": [
            50310
        ],
        "district_id": 5018
    },
    {
        "id": 501901,
        "name_th": "ยางเนิ้ง",
        "name_en": "Yang Noeng",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501902,
        "name_th": "สารภี",
        "name_en": "Saraphi",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501903,
        "name_th": "ชมภู",
        "name_en": "Chomphu",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501904,
        "name_th": "ไชยสถาน",
        "name_en": "Chai Sathan",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501905,
        "name_th": "ขัวมุง",
        "name_en": "Khua Mung",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501906,
        "name_th": "หนองแฝก",
        "name_en": "Nong Faek",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501907,
        "name_th": "หนองผึ้ง",
        "name_en": "Nong Phueng",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501908,
        "name_th": "ท่ากว้าง",
        "name_en": "Tha Kwang",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501909,
        "name_th": "ดอนแก้ว",
        "name_en": "Don Kaeo",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501910,
        "name_th": "ท่าวังตาล",
        "name_en": "Tha Wang Tan",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501911,
        "name_th": "สันทราย",
        "name_en": "San Sai",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 501912,
        "name_th": "ป่าบง",
        "name_en": "Pa Bong",
        "zip_codes": [
            50140
        ],
        "district_id": 5019
    },
    {
        "id": 502001,
        "name_th": "เมืองแหง",
        "name_en": "Mueang Haeng",
        "zip_codes": [
            50350
        ],
        "district_id": 5020
    },
    {
        "id": 502002,
        "name_th": "เปียงหลวง",
        "name_en": "Piang Luang",
        "zip_codes": [
            50350
        ],
        "district_id": 5020
    },
    {
        "id": 502003,
        "name_th": "แสนไห",
        "name_en": "Saen Hai",
        "zip_codes": [
            50350
        ],
        "district_id": 5020
    },
    {
        "id": 502101,
        "name_th": "ปงตำ",
        "name_en": "Pong Tam",
        "zip_codes": [
            50320
        ],
        "district_id": 5021
    },
    {
        "id": 502102,
        "name_th": "ศรีดงเย็น",
        "name_en": "Si Dong Yen",
        "zip_codes": [
            50320
        ],
        "district_id": 5021
    },
    {
        "id": 502103,
        "name_th": "แม่ทะลบ",
        "name_en": "Mae Thalop",
        "zip_codes": [
            50320
        ],
        "district_id": 5021
    },
    {
        "id": 502104,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            50320
        ],
        "district_id": 5021
    },
    {
        "id": 502201,
        "name_th": "บ้านกาด",
        "name_en": "Ban Kat",
        "zip_codes": [
            50360
        ],
        "district_id": 5022
    },
    {
        "id": 502202,
        "name_th": "ทุ่งปี๊",
        "name_en": "Thung Pi",
        "zip_codes": [
            50360
        ],
        "district_id": 5022
    },
    {
        "id": 502203,
        "name_th": "ทุ่งรวงทอง",
        "name_en": "Thung Ruang Thong",
        "zip_codes": [
            50360
        ],
        "district_id": 5022
    },
    {
        "id": 502204,
        "name_th": "แม่วิน",
        "name_en": "Mae Win",
        "zip_codes": [
            50360
        ],
        "district_id": 5022
    },
    {
        "id": 502205,
        "name_th": "ดอนเปา",
        "name_en": "Don Pao",
        "zip_codes": [
            50360
        ],
        "district_id": 5022
    },
    {
        "id": 502301,
        "name_th": "ออนเหนือ",
        "name_en": "On Nuea",
        "zip_codes": [
            50130
        ],
        "district_id": 5023
    },
    {
        "id": 502302,
        "name_th": "ออนกลาง",
        "name_en": "On Klang",
        "zip_codes": [
            50130
        ],
        "district_id": 5023
    },
    {
        "id": 502303,
        "name_th": "บ้านสหกรณ์",
        "name_en": "Ban Sahakon",
        "zip_codes": [
            50130
        ],
        "district_id": 5023
    },
    {
        "id": 502304,
        "name_th": "ห้วยแก้ว",
        "name_en": "Huai Kaeo",
        "zip_codes": [
            50130
        ],
        "district_id": 5023
    },
    {
        "id": 502305,
        "name_th": "แม่ทา",
        "name_en": "Mae Tha",
        "zip_codes": [
            50130
        ],
        "district_id": 5023
    },
    {
        "id": 502306,
        "name_th": "ทาเหนือ",
        "name_en": "Tha Nuea",
        "zip_codes": [
            50130
        ],
        "district_id": 5023
    },
    {
        "id": 502401,
        "name_th": "ดอยหล่อ",
        "name_en": "Doi Lo",
        "zip_codes": [
            50160
        ],
        "district_id": 5024
    },
    {
        "id": 502402,
        "name_th": "สองแคว",
        "name_en": "Song Khwae",
        "zip_codes": [
            50160
        ],
        "district_id": 5024
    },
    {
        "id": 502403,
        "name_th": "ยางคราม",
        "name_en": "Yang Khram",
        "zip_codes": [
            50160
        ],
        "district_id": 5024
    },
    {
        "id": 502404,
        "name_th": "สันติสุข",
        "name_en": "Santi Suk",
        "zip_codes": [
            50160
        ],
        "district_id": 5024
    },
    {
        "id": 502501,
        "name_th": "บ้านจันทร์",
        "name_en": "Ban Chan",
        "zip_codes": [
            58130
        ],
        "district_id": 5025
    },
    {
        "id": 502502,
        "name_th": "แม่แดด",
        "name_en": "Mae Daet",
        "zip_codes": [
            58130
        ],
        "district_id": 5025
    },
    {
        "id": 502503,
        "name_th": "แจ่มหลวง",
        "name_en": "Chaem Luang",
        "zip_codes": [
            58130
        ],
        "district_id": 5025
    },
    {
        "id": 510101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510102,
        "name_th": "เหมืองง่า",
        "name_en": "Mueang Nga",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510103,
        "name_th": "อุโมงค์",
        "name_en": "Umong",
        "zip_codes": [
            51150
        ],
        "district_id": 5101
    },
    {
        "id": 510104,
        "name_th": "หนองช้างคืน",
        "name_en": "Nong Chang Khuen",
        "zip_codes": [
            51150
        ],
        "district_id": 5101
    },
    {
        "id": 510105,
        "name_th": "ประตูป่า",
        "name_en": "Pratu Pa",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510106,
        "name_th": "ริมปิง",
        "name_en": "Rim Ping",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510107,
        "name_th": "ต้นธง",
        "name_en": "Ton Thong",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510108,
        "name_th": "บ้านแป้น",
        "name_en": "Ban Paen",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510109,
        "name_th": "เหมืองจี้",
        "name_en": "Mueang Chi",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510110,
        "name_th": "ป่าสัก",
        "name_en": "Pa Sak",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510111,
        "name_th": "เวียงยอง",
        "name_en": "Wiang Yong",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510112,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510113,
        "name_th": "มะเขือแจ้",
        "name_en": "Makhuea Chae",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510116,
        "name_th": "ศรีบัวบาน",
        "name_en": "Si Bua Ban",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510117,
        "name_th": "หนองหนาม",
        "name_en": "Nong Nam",
        "zip_codes": [
            51000
        ],
        "district_id": 5101
    },
    {
        "id": 510201,
        "name_th": "ทาปลาดุก",
        "name_en": "Tha Pla Duk",
        "zip_codes": [
            51140
        ],
        "district_id": 5102
    },
    {
        "id": 510202,
        "name_th": "ทาสบเส้า",
        "name_en": "Tha Sop Sao",
        "zip_codes": [
            51140
        ],
        "district_id": 5102
    },
    {
        "id": 510203,
        "name_th": "ทากาศ",
        "name_en": "Tha Kat",
        "zip_codes": [
            51170
        ],
        "district_id": 5102
    },
    {
        "id": 510204,
        "name_th": "ทาขุมเงิน",
        "name_en": "Tha Khum Ngoen",
        "zip_codes": [
            51170
        ],
        "district_id": 5102
    },
    {
        "id": 510205,
        "name_th": "ทาทุ่งหลวง",
        "name_en": "Tha Thung Luang",
        "zip_codes": [
            51170
        ],
        "district_id": 5102
    },
    {
        "id": 510206,
        "name_th": "ทาแม่ลอบ",
        "name_en": "Tha Mae Lop",
        "zip_codes": [
            51170
        ],
        "district_id": 5102
    },
    {
        "id": 510301,
        "name_th": "บ้านโฮ่ง",
        "name_en": "Ban Hong",
        "zip_codes": [
            51130
        ],
        "district_id": 5103
    },
    {
        "id": 510302,
        "name_th": "ป่าพลู",
        "name_en": "Pa Phlu",
        "zip_codes": [
            51130
        ],
        "district_id": 5103
    },
    {
        "id": 510303,
        "name_th": "เหล่ายาว",
        "name_en": "Lao Yao",
        "zip_codes": [
            51130
        ],
        "district_id": 5103
    },
    {
        "id": 510304,
        "name_th": "ศรีเตี้ย",
        "name_en": "Si Tia",
        "zip_codes": [
            51130
        ],
        "district_id": 5103
    },
    {
        "id": 510305,
        "name_th": "หนองปลาสะวาย",
        "name_en": "Nong Pla Sawai",
        "zip_codes": [
            51130
        ],
        "district_id": 5103
    },
    {
        "id": 510401,
        "name_th": "ลี้",
        "name_en": "Li",
        "zip_codes": [
            51110
        ],
        "district_id": 5104
    },
    {
        "id": 510402,
        "name_th": "แม่ตืน",
        "name_en": "Mae Tuen",
        "zip_codes": [
            51110
        ],
        "district_id": 5104
    },
    {
        "id": 510403,
        "name_th": "นาทราย",
        "name_en": "Na Sai",
        "zip_codes": [
            51110
        ],
        "district_id": 5104
    },
    {
        "id": 510404,
        "name_th": "ดงดำ",
        "name_en": "Dong Dam",
        "zip_codes": [
            51110
        ],
        "district_id": 5104
    },
    {
        "id": 510405,
        "name_th": "ก้อ",
        "name_en": "Ko",
        "zip_codes": [
            51110
        ],
        "district_id": 5104
    },
    {
        "id": 510406,
        "name_th": "แม่ลาน",
        "name_en": "Mae Lan",
        "zip_codes": [
            51110
        ],
        "district_id": 5104
    },
    {
        "id": 510408,
        "name_th": "ป่าไผ่",
        "name_en": "Pha Phai",
        "zip_codes": [
            51110
        ],
        "district_id": 5104
    },
    {
        "id": 510409,
        "name_th": "ศรีวิชัย",
        "name_en": "Si Wichai",
        "zip_codes": [
            51110
        ],
        "district_id": 5104
    },
    {
        "id": 510501,
        "name_th": "ทุ่งหัวช้าง",
        "name_en": "Thung Hua Chang",
        "zip_codes": [
            51160
        ],
        "district_id": 5105
    },
    {
        "id": 510502,
        "name_th": "บ้านปวง",
        "name_en": "Ban Puang",
        "zip_codes": [
            51160
        ],
        "district_id": 5105
    },
    {
        "id": 510503,
        "name_th": "ตะเคียนปม",
        "name_en": "Takhian Pom",
        "zip_codes": [
            51160
        ],
        "district_id": 5105
    },
    {
        "id": 510601,
        "name_th": "ปากบ่อง",
        "name_en": "Pak Bong",
        "zip_codes": [
            51120
        ],
        "district_id": 5106
    },
    {
        "id": 510602,
        "name_th": "ป่าซาง",
        "name_en": "Pa Sang",
        "zip_codes": [
            51120
        ],
        "district_id": 5106
    },
    {
        "id": 510603,
        "name_th": "แม่แรง",
        "name_en": "Mae Raeng",
        "zip_codes": [
            51120
        ],
        "district_id": 5106
    },
    {
        "id": 510604,
        "name_th": "ม่วงน้อย",
        "name_en": "Muang Noi",
        "zip_codes": [
            51120
        ],
        "district_id": 5106
    },
    {
        "id": 510605,
        "name_th": "บ้านเรือน",
        "name_en": "Ban Ruean",
        "zip_codes": [
            51120
        ],
        "district_id": 5106
    },
    {
        "id": 510606,
        "name_th": "มะกอก",
        "name_en": "Makok",
        "zip_codes": [
            51120
        ],
        "district_id": 5106
    },
    {
        "id": 510607,
        "name_th": "ท่าตุ้ม",
        "name_en": "Tha Tum",
        "zip_codes": [
            51120
        ],
        "district_id": 5106
    },
    {
        "id": 510608,
        "name_th": "น้ำดิบ",
        "name_en": "Nam Dip",
        "zip_codes": [
            51120
        ],
        "district_id": 5106
    },
    {
        "id": 510611,
        "name_th": "นครเจดีย์",
        "name_en": "Nakhon Chedi",
        "zip_codes": [
            51120
        ],
        "district_id": 5106
    },
    {
        "id": 510701,
        "name_th": "บ้านธิ",
        "name_en": "Ban Thi",
        "zip_codes": [
            51180
        ],
        "district_id": 5107
    },
    {
        "id": 510702,
        "name_th": "ห้วยยาบ",
        "name_en": "Huai Yap",
        "zip_codes": [
            51180
        ],
        "district_id": 5107
    },
    {
        "id": 510801,
        "name_th": "หนองล่อง",
        "name_en": "Nong Long",
        "zip_codes": [
            51120
        ],
        "district_id": 5108
    },
    {
        "id": 510802,
        "name_th": "หนองยวง",
        "name_en": "Nong Yuang",
        "zip_codes": [
            51120
        ],
        "district_id": 5108
    },
    {
        "id": 510803,
        "name_th": "วังผาง",
        "name_en": "Wang Phang",
        "zip_codes": [
            51120
        ],
        "district_id": 5108
    },
    {
        "id": 520101,
        "name_th": "เวียงเหนือ",
        "name_en": "Wiang Nuea",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520102,
        "name_th": "หัวเวียง",
        "name_en": "Hua Wiang",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520103,
        "name_th": "สวนดอก",
        "name_en": "Suan Dok",
        "zip_codes": [
            52100
        ],
        "district_id": 5201
    },
    {
        "id": 520104,
        "name_th": "สบตุ๋ย",
        "name_en": "Sop Tui",
        "zip_codes": [
            52100
        ],
        "district_id": 5201
    },
    {
        "id": 520105,
        "name_th": "พระบาท",
        "name_en": "Phra Bat",
        "zip_codes": [
            52000,
            52220
        ],
        "district_id": 5201
    },
    {
        "id": 520106,
        "name_th": "ชมพู",
        "name_en": "Chomphu",
        "zip_codes": [
            52100
        ],
        "district_id": 5201
    },
    {
        "id": 520107,
        "name_th": "กล้วยแพะ",
        "name_en": "Kluai Phae",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520108,
        "name_th": "ปงแสนทอง",
        "name_en": "Pong Saen Thong",
        "zip_codes": [
            52100
        ],
        "district_id": 5201
    },
    {
        "id": 520109,
        "name_th": "บ้านแลง",
        "name_en": "Ban Laeng",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520110,
        "name_th": "บ้านเสด็จ",
        "name_en": "Ban Sadet",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520111,
        "name_th": "พิชัย",
        "name_en": "Phichai",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520112,
        "name_th": "ทุ่งฝาย",
        "name_en": "Thung Fai",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520113,
        "name_th": "บ้านเอื้อม",
        "name_en": "Ban Ueam",
        "zip_codes": [
            52100
        ],
        "district_id": 5201
    },
    {
        "id": 520114,
        "name_th": "บ้านเป้า",
        "name_en": "Ban Pao",
        "zip_codes": [
            52100
        ],
        "district_id": 5201
    },
    {
        "id": 520115,
        "name_th": "บ้านค่า",
        "name_en": "Ban Kha",
        "zip_codes": [
            52100
        ],
        "district_id": 5201
    },
    {
        "id": 520116,
        "name_th": "บ่อแฮ้ว",
        "name_en": "Bo Haeo",
        "zip_codes": [
            52100
        ],
        "district_id": 5201
    },
    {
        "id": 520117,
        "name_th": "ต้นธงชัย",
        "name_en": "Ton Thong Chai",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520118,
        "name_th": "นิคมพัฒนา",
        "name_en": "Nikhom Phatthana",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520119,
        "name_th": "บุญนาคพัฒนา",
        "name_en": "Bunnak Phatthana",
        "zip_codes": [
            52000
        ],
        "district_id": 5201
    },
    {
        "id": 520201,
        "name_th": "บ้านดง",
        "name_en": "Ban Dong",
        "zip_codes": [
            52000,
            52220
        ],
        "district_id": 5202
    },
    {
        "id": 520202,
        "name_th": "นาสัก",
        "name_en": "Na Sak",
        "zip_codes": [
            52220
        ],
        "district_id": 5202
    },
    {
        "id": 520203,
        "name_th": "จางเหนือ",
        "name_en": "Chang Nuea",
        "zip_codes": [
            52220
        ],
        "district_id": 5202
    },
    {
        "id": 520204,
        "name_th": "แม่เมาะ",
        "name_en": "Mae Mo",
        "zip_codes": [
            52220
        ],
        "district_id": 5202
    },
    {
        "id": 520205,
        "name_th": "สบป้าด",
        "name_en": "Sop Pat",
        "zip_codes": [
            52220
        ],
        "district_id": 5202
    },
    {
        "id": 520301,
        "name_th": "ลำปางหลวง",
        "name_en": "Lampang Luang",
        "zip_codes": [
            52130
        ],
        "district_id": 5203
    },
    {
        "id": 520302,
        "name_th": "นาแก้ว",
        "name_en": "Na Kaeo",
        "zip_codes": [
            52130
        ],
        "district_id": 5203
    },
    {
        "id": 520303,
        "name_th": "ไหล่หิน",
        "name_en": "Lai Hin",
        "zip_codes": [
            52130
        ],
        "district_id": 5203
    },
    {
        "id": 520304,
        "name_th": "วังพร้าว",
        "name_en": "Wang Phrao",
        "zip_codes": [
            52130
        ],
        "district_id": 5203
    },
    {
        "id": 520305,
        "name_th": "ศาลา",
        "name_en": "Sala",
        "zip_codes": [
            52130
        ],
        "district_id": 5203
    },
    {
        "id": 520306,
        "name_th": "เกาะคา",
        "name_en": "Ko Kha",
        "zip_codes": [
            52130
        ],
        "district_id": 5203
    },
    {
        "id": 520307,
        "name_th": "นาแส่ง",
        "name_en": "Na Saeng",
        "zip_codes": [
            52130
        ],
        "district_id": 5203
    },
    {
        "id": 520308,
        "name_th": "ท่าผา",
        "name_en": "Tha Pha",
        "zip_codes": [
            52130
        ],
        "district_id": 5203
    },
    {
        "id": 520309,
        "name_th": "ใหม่พัฒนา",
        "name_en": "Mai Phatthana",
        "zip_codes": [
            52130
        ],
        "district_id": 5203
    },
    {
        "id": 520401,
        "name_th": "ทุ่งงาม",
        "name_en": "Thung Ngam",
        "zip_codes": [
            52210
        ],
        "district_id": 5204
    },
    {
        "id": 520402,
        "name_th": "เสริมขวา",
        "name_en": "Soem Khwa",
        "zip_codes": [
            52210
        ],
        "district_id": 5204
    },
    {
        "id": 520403,
        "name_th": "เสริมซ้าย",
        "name_en": "Soem Sai",
        "zip_codes": [
            52210
        ],
        "district_id": 5204
    },
    {
        "id": 520404,
        "name_th": "เสริมกลาง",
        "name_en": "Soem Klang",
        "zip_codes": [
            52210
        ],
        "district_id": 5204
    },
    {
        "id": 520501,
        "name_th": "หลวงเหนือ",
        "name_en": "Luang Nuea",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520502,
        "name_th": "หลวงใต้",
        "name_en": "Luang Tai",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520503,
        "name_th": "บ้านโป่ง",
        "name_en": "Ban Pong",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520504,
        "name_th": "บ้านร้อง",
        "name_en": "Ban Rong",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520505,
        "name_th": "ปงเตา",
        "name_en": "Pong Tao",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520506,
        "name_th": "นาแก",
        "name_en": "Na Kae",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520507,
        "name_th": "บ้านอ้อน",
        "name_en": "Ban On",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520508,
        "name_th": "บ้านแหง",
        "name_en": "Ban Haeng",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520509,
        "name_th": "บ้านหวด",
        "name_en": "Ban Huat",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520510,
        "name_th": "แม่ตีบ",
        "name_en": "Mae Tip",
        "zip_codes": [
            52110
        ],
        "district_id": 5205
    },
    {
        "id": 520601,
        "name_th": "แจ้ห่ม",
        "name_en": "Chae Hom",
        "zip_codes": [
            52120
        ],
        "district_id": 5206
    },
    {
        "id": 520602,
        "name_th": "บ้านสา",
        "name_en": "Ban Sa",
        "zip_codes": [
            52120
        ],
        "district_id": 5206
    },
    {
        "id": 520603,
        "name_th": "ปงดอน",
        "name_en": "Pong Don",
        "zip_codes": [
            52120
        ],
        "district_id": 5206
    },
    {
        "id": 520604,
        "name_th": "แม่สุก",
        "name_en": "Mae Suk",
        "zip_codes": [
            52120
        ],
        "district_id": 5206
    },
    {
        "id": 520605,
        "name_th": "เมืองมาย",
        "name_en": "Mueang Mai",
        "zip_codes": [
            52120
        ],
        "district_id": 5206
    },
    {
        "id": 520606,
        "name_th": "ทุ่งผึ้ง",
        "name_en": "Thung Phueng",
        "zip_codes": [
            52120
        ],
        "district_id": 5206
    },
    {
        "id": 520607,
        "name_th": "วิเชตนคร",
        "name_en": "Wichet Nakhon",
        "zip_codes": [
            52120
        ],
        "district_id": 5206
    },
    {
        "id": 520701,
        "name_th": "ทุ่งฮั้ว",
        "name_en": "Thung Hua",
        "zip_codes": [
            52140
        ],
        "district_id": 5207
    },
    {
        "id": 520702,
        "name_th": "วังเหนือ",
        "name_en": "Wang Nuea",
        "zip_codes": [
            52140
        ],
        "district_id": 5207
    },
    {
        "id": 520703,
        "name_th": "วังใต้",
        "name_en": "Wang Tai",
        "zip_codes": [
            52140
        ],
        "district_id": 5207
    },
    {
        "id": 520704,
        "name_th": "ร่องเคาะ",
        "name_en": "Rong Kho",
        "zip_codes": [
            52140
        ],
        "district_id": 5207
    },
    {
        "id": 520705,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "zip_codes": [
            52140
        ],
        "district_id": 5207
    },
    {
        "id": 520706,
        "name_th": "วังซ้าย",
        "name_en": "Wang Sai",
        "zip_codes": [
            52140
        ],
        "district_id": 5207
    },
    {
        "id": 520707,
        "name_th": "วังแก้ว",
        "name_en": "Wang Kaeo",
        "zip_codes": [
            52140
        ],
        "district_id": 5207
    },
    {
        "id": 520708,
        "name_th": "วังทรายคำ",
        "name_en": "Wang Sai Kham",
        "zip_codes": [
            52140
        ],
        "district_id": 5207
    },
    {
        "id": 520801,
        "name_th": "ล้อมแรด",
        "name_en": "Lom Raet",
        "zip_codes": [
            52160
        ],
        "district_id": 5208
    },
    {
        "id": 520802,
        "name_th": "แม่วะ",
        "name_en": "Mae Wa",
        "zip_codes": [
            52230
        ],
        "district_id": 5208
    },
    {
        "id": 520803,
        "name_th": "แม่ปะ",
        "name_en": "Mae Pa",
        "zip_codes": [
            52160
        ],
        "district_id": 5208
    },
    {
        "id": 520804,
        "name_th": "แม่มอก",
        "name_en": "Mae Mok",
        "zip_codes": [
            52160
        ],
        "district_id": 5208
    },
    {
        "id": 520805,
        "name_th": "เวียงมอก",
        "name_en": "Wiang Mok",
        "zip_codes": [
            52160
        ],
        "district_id": 5208
    },
    {
        "id": 520806,
        "name_th": "นาโป่ง",
        "name_en": "Na Pong",
        "zip_codes": [
            52160
        ],
        "district_id": 5208
    },
    {
        "id": 520807,
        "name_th": "แม่ถอด",
        "name_en": "Mae Thot",
        "zip_codes": [
            52160
        ],
        "district_id": 5208
    },
    {
        "id": 520808,
        "name_th": "เถินบุรี",
        "name_en": "Thoen Buri",
        "zip_codes": [
            52160
        ],
        "district_id": 5208
    },
    {
        "id": 520901,
        "name_th": "แม่พริก",
        "name_en": "Mae Phrik",
        "zip_codes": [
            52180
        ],
        "district_id": 5209
    },
    {
        "id": 520902,
        "name_th": "ผาปัง",
        "name_en": "Pha Pang",
        "zip_codes": [
            52180
        ],
        "district_id": 5209
    },
    {
        "id": 520903,
        "name_th": "แม่ปุ",
        "name_en": "Mae Pu",
        "zip_codes": [
            52180
        ],
        "district_id": 5209
    },
    {
        "id": 520904,
        "name_th": "พระบาทวังตวง",
        "name_en": "Phra Bat Wang Tuang",
        "zip_codes": [
            52180,
            52230
        ],
        "district_id": 5209
    },
    {
        "id": 521001,
        "name_th": "แม่ทะ",
        "name_en": "Mae Tha",
        "zip_codes": [
            52150,
            52220
        ],
        "district_id": 5210
    },
    {
        "id": 521002,
        "name_th": "นาครัว",
        "name_en": "Na Khrua",
        "zip_codes": [
            52150
        ],
        "district_id": 5210
    },
    {
        "id": 521003,
        "name_th": "ป่าตัน",
        "name_en": "Pa Tan",
        "zip_codes": [
            52150
        ],
        "district_id": 5210
    },
    {
        "id": 521004,
        "name_th": "บ้านกิ่ว",
        "name_en": "Ban Kio",
        "zip_codes": [
            52150
        ],
        "district_id": 5210
    },
    {
        "id": 521005,
        "name_th": "บ้านบอม",
        "name_en": "Ban Bom",
        "zip_codes": [
            52150
        ],
        "district_id": 5210
    },
    {
        "id": 521006,
        "name_th": "น้ำโจ้",
        "name_en": "Nam Cho",
        "zip_codes": [
            52150
        ],
        "district_id": 5210
    },
    {
        "id": 521007,
        "name_th": "ดอนไฟ",
        "name_en": "Don Fai",
        "zip_codes": [
            52150
        ],
        "district_id": 5210
    },
    {
        "id": 521008,
        "name_th": "หัวเสือ",
        "name_en": "Hua Suea",
        "zip_codes": [
            52150
        ],
        "district_id": 5210
    },
    {
        "id": 521010,
        "name_th": "วังเงิน",
        "name_en": "Wang Ngoen",
        "zip_codes": [
            52150
        ],
        "district_id": 5210
    },
    {
        "id": 521011,
        "name_th": "สันดอนแก้ว",
        "name_en": "San Don Kaeo",
        "zip_codes": [
            52150
        ],
        "district_id": 5210
    },
    {
        "id": 521101,
        "name_th": "สบปราบ",
        "name_en": "Sop Prap",
        "zip_codes": [
            52170
        ],
        "district_id": 5211
    },
    {
        "id": 521102,
        "name_th": "สมัย",
        "name_en": "Samai",
        "zip_codes": [
            52170
        ],
        "district_id": 5211
    },
    {
        "id": 521103,
        "name_th": "แม่กัวะ",
        "name_en": "Mae Kua",
        "zip_codes": [
            52170
        ],
        "district_id": 5211
    },
    {
        "id": 521104,
        "name_th": "นายาง",
        "name_en": "Na Yang",
        "zip_codes": [
            52170
        ],
        "district_id": 5211
    },
    {
        "id": 521201,
        "name_th": "ห้างฉัตร",
        "name_en": "Hang Chat",
        "zip_codes": [
            52190
        ],
        "district_id": 5212
    },
    {
        "id": 521202,
        "name_th": "หนองหล่ม",
        "name_en": "Nong Lom",
        "zip_codes": [
            52190
        ],
        "district_id": 5212
    },
    {
        "id": 521203,
        "name_th": "เมืองยาว",
        "name_en": "Mueang Yao",
        "zip_codes": [
            52190
        ],
        "district_id": 5212
    },
    {
        "id": 521204,
        "name_th": "ปงยางคก",
        "name_en": "Pong Yang Khok",
        "zip_codes": [
            52190
        ],
        "district_id": 5212
    },
    {
        "id": 521205,
        "name_th": "เวียงตาล",
        "name_en": "Wiang Tan",
        "zip_codes": [
            52190
        ],
        "district_id": 5212
    },
    {
        "id": 521206,
        "name_th": "แม่สัน",
        "name_en": "Mae San",
        "zip_codes": [
            52190
        ],
        "district_id": 5212
    },
    {
        "id": 521207,
        "name_th": "วอแก้ว",
        "name_en": "Wo Kaeo",
        "zip_codes": [
            52190
        ],
        "district_id": 5212
    },
    {
        "id": 521301,
        "name_th": "เมืองปาน",
        "name_en": "Mueang Pan",
        "zip_codes": [
            52240
        ],
        "district_id": 5213
    },
    {
        "id": 521302,
        "name_th": "บ้านขอ",
        "name_en": "Ban Kho",
        "zip_codes": [
            52240
        ],
        "district_id": 5213
    },
    {
        "id": 521303,
        "name_th": "ทุ่งกว๋าว",
        "name_en": "Thung Kwao",
        "zip_codes": [
            52240
        ],
        "district_id": 5213
    },
    {
        "id": 521304,
        "name_th": "แจ้ซ้อน",
        "name_en": "Chae Son",
        "zip_codes": [
            52240
        ],
        "district_id": 5213
    },
    {
        "id": 521305,
        "name_th": "หัวเมือง",
        "name_en": "Hua Mueang",
        "zip_codes": [
            52240
        ],
        "district_id": 5213
    },
    {
        "id": 530101,
        "name_th": "ท่าอิฐ",
        "name_en": "Tha It",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530102,
        "name_th": "ท่าเสา",
        "name_en": "Tha Sao",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530103,
        "name_th": "บ้านเกาะ",
        "name_en": "Ban Ko",
        "zip_codes": [
            53000,
            53170
        ],
        "district_id": 5301
    },
    {
        "id": 530104,
        "name_th": "ป่าเซ่า",
        "name_en": "Pa Sao",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530105,
        "name_th": "คุ้งตะเภา",
        "name_en": "Khung Taphao",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530106,
        "name_th": "วังกะพี้",
        "name_en": "Wang Kaphi",
        "zip_codes": [
            53170
        ],
        "district_id": 5301
    },
    {
        "id": 530107,
        "name_th": "หาดกรวด",
        "name_en": "Hat Kruat",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530108,
        "name_th": "น้ำริด",
        "name_en": "Nam Rit",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530109,
        "name_th": "งิ้วงาม",
        "name_en": "Ngio Ngam",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530110,
        "name_th": "บ้านด่านนาขาม",
        "name_en": "Ban Dan Na Kham",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530111,
        "name_th": "บ้านด่าน",
        "name_en": "Ban Dan",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530112,
        "name_th": "ผาจุก",
        "name_en": "Pha Chuk",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530113,
        "name_th": "วังดิน",
        "name_en": "Wang Din",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530114,
        "name_th": "แสนตอ",
        "name_en": "Saen To",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530115,
        "name_th": "หาดงิ้ว",
        "name_en": "Hat Ngio",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530116,
        "name_th": "ขุนฝาง",
        "name_en": "Khun Fang",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530117,
        "name_th": "ถ้ำฉลอง",
        "name_en": "Tham Chalong",
        "zip_codes": [
            53000
        ],
        "district_id": 5301
    },
    {
        "id": 530201,
        "name_th": "วังแดง",
        "name_en": "Wang Daeng",
        "zip_codes": [
            53140
        ],
        "district_id": 5302
    },
    {
        "id": 530202,
        "name_th": "บ้านแก่ง",
        "name_en": "Ban Kaeng",
        "zip_codes": [
            53140
        ],
        "district_id": 5302
    },
    {
        "id": 530203,
        "name_th": "หาดสองแคว",
        "name_en": "Hat Song Khwae",
        "zip_codes": [
            53140
        ],
        "district_id": 5302
    },
    {
        "id": 530204,
        "name_th": "น้ำอ่าง",
        "name_en": "Nam Ang",
        "zip_codes": [
            53140
        ],
        "district_id": 5302
    },
    {
        "id": 530205,
        "name_th": "ข่อยสูง",
        "name_en": "Khoi Sung",
        "zip_codes": [
            53140
        ],
        "district_id": 5302
    },
    {
        "id": 530301,
        "name_th": "ท่าปลา",
        "name_en": "Tha Pla",
        "zip_codes": [
            53150
        ],
        "district_id": 5303
    },
    {
        "id": 530302,
        "name_th": "หาดล้า",
        "name_en": "Hat La",
        "zip_codes": [
            53150,
            53190
        ],
        "district_id": 5303
    },
    {
        "id": 530303,
        "name_th": "ผาเลือด",
        "name_en": "Pha Lueat",
        "zip_codes": [
            53190
        ],
        "district_id": 5303
    },
    {
        "id": 530304,
        "name_th": "จริม",
        "name_en": "Chalim",
        "zip_codes": [
            53150
        ],
        "district_id": 5303
    },
    {
        "id": 530305,
        "name_th": "น้ำหมัน",
        "name_en": "Nam Man",
        "zip_codes": [
            53150
        ],
        "district_id": 5303
    },
    {
        "id": 530307,
        "name_th": "นางพญา",
        "name_en": "Nang Phaya",
        "zip_codes": [
            53150
        ],
        "district_id": 5303
    },
    {
        "id": 530308,
        "name_th": "ร่วมจิต",
        "name_en": "Ruam Chit",
        "zip_codes": [
            53190
        ],
        "district_id": 5303
    },
    {
        "id": 530401,
        "name_th": "แสนตอ",
        "name_en": "Saen To",
        "zip_codes": [
            53110
        ],
        "district_id": 5304
    },
    {
        "id": 530402,
        "name_th": "บ้านฝาย",
        "name_en": "Ban Fai",
        "zip_codes": [
            53110
        ],
        "district_id": 5304
    },
    {
        "id": 530403,
        "name_th": "เด่นเหล็ก",
        "name_en": "Den Lek",
        "zip_codes": [
            53110
        ],
        "district_id": 5304
    },
    {
        "id": 530404,
        "name_th": "น้ำไคร้",
        "name_en": "Nam Khrai",
        "zip_codes": [
            53110
        ],
        "district_id": 5304
    },
    {
        "id": 530405,
        "name_th": "น้ำไผ่",
        "name_en": "Nam Phai",
        "zip_codes": [
            53110
        ],
        "district_id": 5304
    },
    {
        "id": 530406,
        "name_th": "ห้วยมุ่น",
        "name_en": "Huai Mun",
        "zip_codes": [
            53110
        ],
        "district_id": 5304
    },
    {
        "id": 530407,
        "name_th": "ท่าแฝก",
        "name_en": "Tha Faek",
        "zip_codes": [
            53110
        ],
        "district_id": 5304
    },
    {
        "id": 530501,
        "name_th": "ฟากท่า",
        "name_en": "Fak Tha",
        "zip_codes": [
            53160
        ],
        "district_id": 5305
    },
    {
        "id": 530502,
        "name_th": "สองคอน",
        "name_en": "Song Khon",
        "zip_codes": [
            53160
        ],
        "district_id": 5305
    },
    {
        "id": 530503,
        "name_th": "บ้านเสี้ยว",
        "name_en": "Ban Siao",
        "zip_codes": [
            53160
        ],
        "district_id": 5305
    },
    {
        "id": 530504,
        "name_th": "สองห้อง",
        "name_en": "Song Hong",
        "zip_codes": [
            53160
        ],
        "district_id": 5305
    },
    {
        "id": 530601,
        "name_th": "ม่วงเจ็ดต้น",
        "name_en": "Muang Chet Ton",
        "zip_codes": [
            53180
        ],
        "district_id": 5306
    },
    {
        "id": 530602,
        "name_th": "บ้านโคก",
        "name_en": "Ban Khok",
        "zip_codes": [
            53180
        ],
        "district_id": 5306
    },
    {
        "id": 530603,
        "name_th": "นาขุม",
        "name_en": "Na Khum",
        "zip_codes": [
            53180
        ],
        "district_id": 5306
    },
    {
        "id": 530604,
        "name_th": "บ่อเบี้ย",
        "name_en": "Bo Bia",
        "zip_codes": [
            53180
        ],
        "district_id": 5306
    },
    {
        "id": 530701,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            53120
        ],
        "district_id": 5307
    },
    {
        "id": 530702,
        "name_th": "บ้านดารา",
        "name_en": "Ban Dara",
        "zip_codes": [
            53220
        ],
        "district_id": 5307
    },
    {
        "id": 530703,
        "name_th": "ไร่อ้อย",
        "name_en": "Rai Oi",
        "zip_codes": [
            53120
        ],
        "district_id": 5307
    },
    {
        "id": 530704,
        "name_th": "ท่าสัก",
        "name_en": "Tha Sak",
        "zip_codes": [
            53220
        ],
        "district_id": 5307
    },
    {
        "id": 530705,
        "name_th": "คอรุม",
        "name_en": "Kho Rum",
        "zip_codes": [
            53120
        ],
        "district_id": 5307
    },
    {
        "id": 530706,
        "name_th": "บ้านหม้อ",
        "name_en": "Ban Mo",
        "zip_codes": [
            53120
        ],
        "district_id": 5307
    },
    {
        "id": 530707,
        "name_th": "ท่ามะเฟือง",
        "name_en": "Tha Mafueang",
        "zip_codes": [
            53120
        ],
        "district_id": 5307
    },
    {
        "id": 530708,
        "name_th": "บ้านโคน",
        "name_en": "Ban Khon",
        "zip_codes": [
            53120
        ],
        "district_id": 5307
    },
    {
        "id": 530709,
        "name_th": "พญาแมน",
        "name_en": "Phaya Maen",
        "zip_codes": [
            53120
        ],
        "district_id": 5307
    },
    {
        "id": 530710,
        "name_th": "นาอิน",
        "name_en": "Na In",
        "zip_codes": [
            53120
        ],
        "district_id": 5307
    },
    {
        "id": 530711,
        "name_th": "นายาง",
        "name_en": "Na Yang",
        "zip_codes": [
            53120
        ],
        "district_id": 5307
    },
    {
        "id": 530801,
        "name_th": "ศรีพนมมาศ",
        "name_en": "Si Phanom Mat",
        "zip_codes": [
            53130
        ],
        "district_id": 5308
    },
    {
        "id": 530802,
        "name_th": "แม่พูล",
        "name_en": "Mae Phun",
        "zip_codes": [
            53130
        ],
        "district_id": 5308
    },
    {
        "id": 530803,
        "name_th": "นานกกก",
        "name_en": "Na Nok Kok",
        "zip_codes": [
            53130
        ],
        "district_id": 5308
    },
    {
        "id": 530804,
        "name_th": "ฝายหลวง",
        "name_en": "Fai Luang",
        "zip_codes": [
            53130
        ],
        "district_id": 5308
    },
    {
        "id": 530805,
        "name_th": "ชัยจุมพล",
        "name_en": "Chai Chumphon",
        "zip_codes": [
            53130
        ],
        "district_id": 5308
    },
    {
        "id": 530806,
        "name_th": "ไผ่ล้อม",
        "name_en": "Phai Lom",
        "zip_codes": [
            53210
        ],
        "district_id": 5308
    },
    {
        "id": 530807,
        "name_th": "ทุ่งยั้ง",
        "name_en": "Thung Yang",
        "zip_codes": [
            53210
        ],
        "district_id": 5308
    },
    {
        "id": 530808,
        "name_th": "ด่านแม่คำมัน",
        "name_en": "Dan Mae Kham Man",
        "zip_codes": [
            53210
        ],
        "district_id": 5308
    },
    {
        "id": 530901,
        "name_th": "ผักขวง",
        "name_en": "Phak Khuang",
        "zip_codes": [
            53230
        ],
        "district_id": 5309
    },
    {
        "id": 530902,
        "name_th": "บ่อทอง",
        "name_en": "Bo Thong",
        "zip_codes": [
            53230
        ],
        "district_id": 5309
    },
    {
        "id": 530903,
        "name_th": "ป่าคาย",
        "name_en": "Pa Khai",
        "zip_codes": [
            53230
        ],
        "district_id": 5309
    },
    {
        "id": 530904,
        "name_th": "น้ำพี้",
        "name_en": "Nam Phi",
        "zip_codes": [
            53230
        ],
        "district_id": 5309
    },
    {
        "id": 540101,
        "name_th": "ในเวียง",
        "name_en": "Nai Wiang",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540102,
        "name_th": "นาจักร",
        "name_en": "Na Chak",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540103,
        "name_th": "น้ำชำ",
        "name_en": "Nam Cham",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540104,
        "name_th": "ป่าแดง",
        "name_en": "Pa Daeng",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540105,
        "name_th": "ทุ่งโฮ้ง",
        "name_en": "Thung Hong",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540106,
        "name_th": "เหมืองหม้อ",
        "name_en": "Mueang Mo",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540107,
        "name_th": "วังธง",
        "name_en": "Wang Thong",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540108,
        "name_th": "แม่หล่าย",
        "name_en": "Mae Lai",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540109,
        "name_th": "ห้วยม้า",
        "name_en": "Huai Ma",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540110,
        "name_th": "ป่าแมต",
        "name_en": "Pa Maet",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540111,
        "name_th": "บ้านถิ่น",
        "name_en": "Ban Thin",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540112,
        "name_th": "สวนเขื่อน",
        "name_en": "Suan Khuean",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540113,
        "name_th": "วังหงส์",
        "name_en": "Wang Hong",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540114,
        "name_th": "แม่คำมี",
        "name_en": "Mae Kham Mi",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540115,
        "name_th": "ทุ่งกวาว",
        "name_en": "Thung Kwao",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540116,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540117,
        "name_th": "แม่ยม",
        "name_en": "Mae Yom",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540118,
        "name_th": "ช่อแฮ",
        "name_en": "Cho Hae",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540119,
        "name_th": "ร่องฟอง",
        "name_en": "Rong Fong",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540120,
        "name_th": "กาญจนา",
        "name_en": "Kanchana",
        "zip_codes": [
            54000
        ],
        "district_id": 5401
    },
    {
        "id": 540201,
        "name_th": "ร้องกวาง",
        "name_en": "Rong Kwang",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540204,
        "name_th": "ร้องเข็ม",
        "name_en": "Rong Khem",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540205,
        "name_th": "น้ำเลา",
        "name_en": "Nam Lao",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540206,
        "name_th": "บ้านเวียง",
        "name_en": "Ban Wiang",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540207,
        "name_th": "ทุ่งศรี",
        "name_en": "Thung Si",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540208,
        "name_th": "แม่ยางตาล",
        "name_en": "Mae Yang Tan",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540209,
        "name_th": "แม่ยางฮ่อ",
        "name_en": "Mae Yang Ho",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540210,
        "name_th": "ไผ่โทน",
        "name_en": "Phai Thon",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540213,
        "name_th": "ห้วยโรง",
        "name_en": "Huai Rong",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540214,
        "name_th": "แม่ทราย",
        "name_en": "Mae Sai",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540215,
        "name_th": "แม่ยางร้อง",
        "name_en": "Mae Yang Rong",
        "zip_codes": [
            54140
        ],
        "district_id": 5402
    },
    {
        "id": 540301,
        "name_th": "ห้วยอ้อ",
        "name_en": "Huai O",
        "zip_codes": [
            54150
        ],
        "district_id": 5403
    },
    {
        "id": 540302,
        "name_th": "บ้านปิน",
        "name_en": "Ban Pin",
        "zip_codes": [
            54150
        ],
        "district_id": 5403
    },
    {
        "id": 540303,
        "name_th": "ต้าผามอก",
        "name_en": "Ta Pha Mok",
        "zip_codes": [
            54150
        ],
        "district_id": 5403
    },
    {
        "id": 540304,
        "name_th": "เวียงต้า",
        "name_en": "Wiang Ta",
        "zip_codes": [
            54150
        ],
        "district_id": 5403
    },
    {
        "id": 540305,
        "name_th": "ปากกาง",
        "name_en": "Pak Kang",
        "zip_codes": [
            54150
        ],
        "district_id": 5403
    },
    {
        "id": 540306,
        "name_th": "หัวทุ่ง",
        "name_en": "Hua Thung",
        "zip_codes": [
            54150
        ],
        "district_id": 5403
    },
    {
        "id": 540307,
        "name_th": "ทุ่งแล้ง",
        "name_en": "Thung Laeng",
        "zip_codes": [
            54150
        ],
        "district_id": 5403
    },
    {
        "id": 540308,
        "name_th": "บ่อเหล็กลอง",
        "name_en": "Bo Lek Long",
        "zip_codes": [
            54150
        ],
        "district_id": 5403
    },
    {
        "id": 540309,
        "name_th": "แม่ปาน",
        "name_en": "Mae Pan",
        "zip_codes": [
            54150
        ],
        "district_id": 5403
    },
    {
        "id": 540401,
        "name_th": "สูงเม่น",
        "name_en": "Sung Men",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540402,
        "name_th": "น้ำชำ",
        "name_en": "Nam Cham",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540403,
        "name_th": "หัวฝาย",
        "name_en": "Hua Fai",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540404,
        "name_th": "ดอนมูล",
        "name_en": "Don Mun",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540405,
        "name_th": "บ้านเหล่า",
        "name_en": "Ban Lao",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540406,
        "name_th": "บ้านกวาง",
        "name_en": "Ban Kwang",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540407,
        "name_th": "บ้านปง",
        "name_en": "Ban Pong",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540408,
        "name_th": "บ้านกาศ",
        "name_en": "Ban Kat",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540409,
        "name_th": "ร่องกาศ",
        "name_en": "Rong Kat",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540410,
        "name_th": "สบสาย",
        "name_en": "Sop Sai",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540411,
        "name_th": "เวียงทอง",
        "name_en": "Wiang Thong",
        "zip_codes": [
            54000
        ],
        "district_id": 5404
    },
    {
        "id": 540412,
        "name_th": "พระหลวง",
        "name_en": "Phra Luang",
        "zip_codes": [
            54130
        ],
        "district_id": 5404
    },
    {
        "id": 540501,
        "name_th": "เด่นชัย",
        "name_en": "Den Chai",
        "zip_codes": [
            54110
        ],
        "district_id": 5405
    },
    {
        "id": 540502,
        "name_th": "แม่จั๊วะ",
        "name_en": "Mae Chua",
        "zip_codes": [
            54110
        ],
        "district_id": 5405
    },
    {
        "id": 540503,
        "name_th": "ไทรย้อย",
        "name_en": "Sai Yoi",
        "zip_codes": [
            54110
        ],
        "district_id": 5405
    },
    {
        "id": 540504,
        "name_th": "ห้วยไร่",
        "name_en": "Huai Rai",
        "zip_codes": [
            54110
        ],
        "district_id": 5405
    },
    {
        "id": 540505,
        "name_th": "ปงป่าหวาย",
        "name_en": "Pong Pa Wai",
        "zip_codes": [
            54110
        ],
        "district_id": 5405
    },
    {
        "id": 540601,
        "name_th": "บ้านหนุน",
        "name_en": "Ban Nun",
        "zip_codes": [
            54120
        ],
        "district_id": 5406
    },
    {
        "id": 540602,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            54120
        ],
        "district_id": 5406
    },
    {
        "id": 540603,
        "name_th": "ห้วยหม้าย",
        "name_en": "Huai Mai",
        "zip_codes": [
            54120
        ],
        "district_id": 5406
    },
    {
        "id": 540604,
        "name_th": "เตาปูน",
        "name_en": "Tao Pun",
        "zip_codes": [
            54120
        ],
        "district_id": 5406
    },
    {
        "id": 540605,
        "name_th": "หัวเมือง",
        "name_en": "Hua Mueang",
        "zip_codes": [
            54120
        ],
        "district_id": 5406
    },
    {
        "id": 540606,
        "name_th": "สะเอียบ",
        "name_en": "Sa-iap",
        "zip_codes": [
            54120
        ],
        "district_id": 5406
    },
    {
        "id": 540607,
        "name_th": "แดนชุมพล",
        "name_en": "Daen Chumphon",
        "zip_codes": [
            54120
        ],
        "district_id": 5406
    },
    {
        "id": 540608,
        "name_th": "ทุ่งน้าว",
        "name_en": "Thung Nao",
        "zip_codes": [
            54120
        ],
        "district_id": 5406
    },
    {
        "id": 540701,
        "name_th": "วังชิ้น",
        "name_en": "Wang Chin",
        "zip_codes": [
            54160
        ],
        "district_id": 5407
    },
    {
        "id": 540702,
        "name_th": "สรอย",
        "name_en": "Soi",
        "zip_codes": [
            54160
        ],
        "district_id": 5407
    },
    {
        "id": 540703,
        "name_th": "แม่ป้าก",
        "name_en": "Mae Pak",
        "zip_codes": [
            54160
        ],
        "district_id": 5407
    },
    {
        "id": 540704,
        "name_th": "นาพูน",
        "name_en": "Na Phun",
        "zip_codes": [
            54160
        ],
        "district_id": 5407
    },
    {
        "id": 540705,
        "name_th": "แม่พุง",
        "name_en": "Mae Phung",
        "zip_codes": [
            54160
        ],
        "district_id": 5407
    },
    {
        "id": 540706,
        "name_th": "ป่าสัก",
        "name_en": "Pa Sak",
        "zip_codes": [
            54160
        ],
        "district_id": 5407
    },
    {
        "id": 540707,
        "name_th": "แม่เกิ๋ง",
        "name_en": "Mae Koeng",
        "zip_codes": [
            54160
        ],
        "district_id": 5407
    },
    {
        "id": 540801,
        "name_th": "แม่คำมี",
        "name_en": "Mae Kham Mi",
        "zip_codes": [
            54170
        ],
        "district_id": 5408
    },
    {
        "id": 540802,
        "name_th": "หนองม่วงไข่",
        "name_en": "Nong Muang Khai",
        "zip_codes": [
            54170
        ],
        "district_id": 5408
    },
    {
        "id": 540803,
        "name_th": "น้ำรัด",
        "name_en": "Nam Rat",
        "zip_codes": [
            54170
        ],
        "district_id": 5408
    },
    {
        "id": 540804,
        "name_th": "วังหลวง",
        "name_en": "wang Luang",
        "zip_codes": [
            54170
        ],
        "district_id": 5408
    },
    {
        "id": 540805,
        "name_th": "ตำหนักธรรม",
        "name_en": "Tamnak Tham",
        "zip_codes": [
            54170
        ],
        "district_id": 5408
    },
    {
        "id": 540806,
        "name_th": "ทุ่งแค้ว",
        "name_en": "Thung Khaeo",
        "zip_codes": [
            54170
        ],
        "district_id": 5408
    },
    {
        "id": 550101,
        "name_th": "ในเวียง",
        "name_en": "Nai Wiang",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550102,
        "name_th": "บ่อ",
        "name_en": "Bo",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550103,
        "name_th": "ผาสิงห์",
        "name_en": "Pha Sing",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550104,
        "name_th": "ไชยสถาน",
        "name_en": "Chai Sathan",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550105,
        "name_th": "ถืมตอง",
        "name_en": "Thuem Tong",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550106,
        "name_th": "เรือง",
        "name_en": "Rueang",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550107,
        "name_th": "นาซาว",
        "name_en": "Na Sao",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550108,
        "name_th": "ดู่ใต้",
        "name_en": "Du Tai",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550109,
        "name_th": "กองควาย",
        "name_en": "Kong Khwai",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550116,
        "name_th": "บ่อสวก",
        "name_en": "Bo Suak",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550117,
        "name_th": "สะเนียน",
        "name_en": "Sanian",
        "zip_codes": [
            55000
        ],
        "district_id": 5501
    },
    {
        "id": 550202,
        "name_th": "หนองแดง",
        "name_en": "Nong Daeng",
        "zip_codes": [
            55170
        ],
        "district_id": 5502
    },
    {
        "id": 550203,
        "name_th": "หมอเมือง",
        "name_en": "Mo Mueang",
        "zip_codes": [
            55170
        ],
        "district_id": 5502
    },
    {
        "id": 550204,
        "name_th": "น้ำพาง",
        "name_en": "Nam Phang",
        "zip_codes": [
            55170
        ],
        "district_id": 5502
    },
    {
        "id": 550205,
        "name_th": "น้ำปาย",
        "name_en": "Nam Pai",
        "zip_codes": [
            55170
        ],
        "district_id": 5502
    },
    {
        "id": 550206,
        "name_th": "แม่จริม",
        "name_en": "Mae Charim",
        "zip_codes": [
            55170
        ],
        "district_id": 5502
    },
    {
        "id": 550301,
        "name_th": "บ้านฟ้า",
        "name_en": "Ban Fa",
        "zip_codes": [
            55190
        ],
        "district_id": 5503
    },
    {
        "id": 550302,
        "name_th": "ป่าคาหลวง",
        "name_en": "Pa Kha Luang",
        "zip_codes": [
            55190
        ],
        "district_id": 5503
    },
    {
        "id": 550303,
        "name_th": "สวด",
        "name_en": "Suat",
        "zip_codes": [
            55190
        ],
        "district_id": 5503
    },
    {
        "id": 550304,
        "name_th": "บ้านพี้",
        "name_en": "Ban Phi",
        "zip_codes": [
            55190
        ],
        "district_id": 5503
    },
    {
        "id": 550401,
        "name_th": "นาน้อย",
        "name_en": "Na Noi",
        "zip_codes": [
            55150
        ],
        "district_id": 5504
    },
    {
        "id": 550402,
        "name_th": "เชียงของ",
        "name_en": "Chiang Khong",
        "zip_codes": [
            55150
        ],
        "district_id": 5504
    },
    {
        "id": 550403,
        "name_th": "ศรีษะเกษ",
        "name_en": "Sisa Ket",
        "zip_codes": [
            55150
        ],
        "district_id": 5504
    },
    {
        "id": 550404,
        "name_th": "สถาน",
        "name_en": "Sathan",
        "zip_codes": [
            55150
        ],
        "district_id": 5504
    },
    {
        "id": 550405,
        "name_th": "สันทะ",
        "name_en": "Santha",
        "zip_codes": [
            55150
        ],
        "district_id": 5504
    },
    {
        "id": 550406,
        "name_th": "บัวใหญ่",
        "name_en": "Bua Yai",
        "zip_codes": [
            55150
        ],
        "district_id": 5504
    },
    {
        "id": 550407,
        "name_th": "น้ำตก",
        "name_en": "Nam Tok",
        "zip_codes": [
            55150
        ],
        "district_id": 5504
    },
    {
        "id": 550501,
        "name_th": "ปัว",
        "name_en": "Pua",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550502,
        "name_th": "แงง",
        "name_en": "Ngaeng",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550503,
        "name_th": "สถาน",
        "name_en": "Sathan",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550504,
        "name_th": "ศิลาแลง",
        "name_en": "Sila Laeng",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550505,
        "name_th": "ศิลาเพชร",
        "name_en": "Sila Phet",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550506,
        "name_th": "อวน",
        "name_en": "Uan",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550509,
        "name_th": "ไชยวัฒนา",
        "name_en": "Chai Watthana",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550510,
        "name_th": "เจดีย์ชัย",
        "name_en": "Chedi Chai",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550511,
        "name_th": "ภูคา",
        "name_en": "Phu Kha",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550512,
        "name_th": "สกาด",
        "name_en": "Sakat",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550513,
        "name_th": "ป่ากลาง",
        "name_en": "Pa Klang",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550514,
        "name_th": "วรนคร",
        "name_en": "Woranakhon",
        "zip_codes": [
            55120
        ],
        "district_id": 5505
    },
    {
        "id": 550601,
        "name_th": "ริม",
        "name_en": "Rim",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550602,
        "name_th": "ป่าคา",
        "name_en": "Pa Kha",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550603,
        "name_th": "ผาตอ",
        "name_en": "Pha To",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550604,
        "name_th": "ยม",
        "name_en": "Yom",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550605,
        "name_th": "ตาลชุม",
        "name_en": "Tan Chum",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550606,
        "name_th": "ศรีภูมิ",
        "name_en": "Si Phum",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550607,
        "name_th": "จอมพระ",
        "name_en": "Chom Phra",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550608,
        "name_th": "แสนทอง",
        "name_en": "Saen Thong",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550609,
        "name_th": "ท่าวังผา",
        "name_en": "Tha Wang Pha",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550610,
        "name_th": "ผาทอง",
        "name_en": "Pha Thong",
        "zip_codes": [
            55140
        ],
        "district_id": 5506
    },
    {
        "id": 550701,
        "name_th": "กลางเวียง",
        "name_en": "Klang Wiang",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550702,
        "name_th": "ขึ่ง",
        "name_en": "Khueng",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550703,
        "name_th": "ไหล่น่าน",
        "name_en": "Lai Nan",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550704,
        "name_th": "ตาลชุม",
        "name_en": "Tan Chum",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550705,
        "name_th": "นาเหลือง",
        "name_en": "Na Lueang",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550706,
        "name_th": "ส้าน",
        "name_en": "San",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550707,
        "name_th": "น้ำมวบ",
        "name_en": "Nam Muap",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550708,
        "name_th": "น้ำปั้ว",
        "name_en": "Nam Pua",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550709,
        "name_th": "ยาบหัวนา",
        "name_en": "Yap Hua Na",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550710,
        "name_th": "ปงสนุก",
        "name_en": "Pong Sanuk",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550711,
        "name_th": "อ่ายนาไลย",
        "name_en": "Ai Na Lai",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550712,
        "name_th": "ส้านนาหนองใหม่",
        "name_en": "San Na Nong Mai",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550713,
        "name_th": "แม่ขะนิง",
        "name_en": "Mae Khaning",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550714,
        "name_th": "แม่สาคร",
        "name_en": "Mae Sakhon",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550715,
        "name_th": "จอมจันทร์",
        "name_en": "Chom Chan",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550716,
        "name_th": "แม่สา",
        "name_en": "Mae Sa",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550717,
        "name_th": "ทุ่งศรีทอง",
        "name_en": "Thung Si Thong",
        "zip_codes": [
            55110
        ],
        "district_id": 5507
    },
    {
        "id": 550801,
        "name_th": "ปอน",
        "name_en": "Pon",
        "zip_codes": [
            55130
        ],
        "district_id": 5508
    },
    {
        "id": 550802,
        "name_th": "งอบ",
        "name_en": "Ngop",
        "zip_codes": [
            55130
        ],
        "district_id": 5508
    },
    {
        "id": 550803,
        "name_th": "และ",
        "name_en": "Lae",
        "zip_codes": [
            55130
        ],
        "district_id": 5508
    },
    {
        "id": 550804,
        "name_th": "ทุ่งช้าง",
        "name_en": "Thung Chang",
        "zip_codes": [
            55130
        ],
        "district_id": 5508
    },
    {
        "id": 550901,
        "name_th": "เชียงกลาง",
        "name_en": "Chiang Klang",
        "zip_codes": [
            55160
        ],
        "district_id": 5509
    },
    {
        "id": 550902,
        "name_th": "เปือ",
        "name_en": "Puea",
        "zip_codes": [
            55160
        ],
        "district_id": 5509
    },
    {
        "id": 550903,
        "name_th": "เชียงคาน",
        "name_en": "Chiang Khan",
        "zip_codes": [
            55160
        ],
        "district_id": 5509
    },
    {
        "id": 550904,
        "name_th": "พระธาตุ",
        "name_en": "Phra That",
        "zip_codes": [
            55160
        ],
        "district_id": 5509
    },
    {
        "id": 550908,
        "name_th": "พญาแก้ว",
        "name_en": "Phaya Kaeo",
        "zip_codes": [
            55160
        ],
        "district_id": 5509
    },
    {
        "id": 550909,
        "name_th": "พระพุทธบาท",
        "name_en": "Phra Phutthabat",
        "zip_codes": [
            55160
        ],
        "district_id": 5509
    },
    {
        "id": 551001,
        "name_th": "นาทะนุง",
        "name_en": "Na Thanung",
        "zip_codes": [
            55180
        ],
        "district_id": 5510
    },
    {
        "id": 551002,
        "name_th": "บ่อแก้ว",
        "name_en": "Bo Kaeo",
        "zip_codes": [
            55180
        ],
        "district_id": 5510
    },
    {
        "id": 551003,
        "name_th": "เมืองลี",
        "name_en": "Mueang Li",
        "zip_codes": [
            55180
        ],
        "district_id": 5510
    },
    {
        "id": 551004,
        "name_th": "ปิงหลวง",
        "name_en": "Ping Luang",
        "zip_codes": [
            55180
        ],
        "district_id": 5510
    },
    {
        "id": 551101,
        "name_th": "ดู่พงษ์",
        "name_en": "Du Phong",
        "zip_codes": [
            55210
        ],
        "district_id": 5511
    },
    {
        "id": 551102,
        "name_th": "ป่าแลวหลวง",
        "name_en": "Pa Laeo Luang",
        "zip_codes": [
            55210
        ],
        "district_id": 5511
    },
    {
        "id": 551103,
        "name_th": "พงษ์",
        "name_en": "Phong",
        "zip_codes": [
            55210
        ],
        "district_id": 5511
    },
    {
        "id": 551201,
        "name_th": "บ่อเกลือเหนือ",
        "name_en": "Bo Kluea Nuea",
        "zip_codes": [
            55220
        ],
        "district_id": 5512
    },
    {
        "id": 551202,
        "name_th": "บ่อเกลือใต้",
        "name_en": "Bo Kluea Tai",
        "zip_codes": [
            55220
        ],
        "district_id": 5512
    },
    {
        "id": 551204,
        "name_th": "ภูฟ้า",
        "name_en": "Phu Fa",
        "zip_codes": [
            55220
        ],
        "district_id": 5512
    },
    {
        "id": 551205,
        "name_th": "ดงพญา",
        "name_en": "Dong Phaya",
        "zip_codes": [
            55220
        ],
        "district_id": 5512
    },
    {
        "id": 551301,
        "name_th": "นาไร่หลวง",
        "name_en": "Na Rai Luang",
        "zip_codes": [
            55160
        ],
        "district_id": 5513
    },
    {
        "id": 551302,
        "name_th": "ชนแดน",
        "name_en": "Chon Daen",
        "zip_codes": [
            55160
        ],
        "district_id": 5513
    },
    {
        "id": 551303,
        "name_th": "ยอด",
        "name_en": "Yot",
        "zip_codes": [
            55160
        ],
        "district_id": 5513
    },
    {
        "id": 551401,
        "name_th": "ม่วงตึ๊ด",
        "name_en": "Muang Tuet",
        "zip_codes": [
            55000
        ],
        "district_id": 5514
    },
    {
        "id": 551402,
        "name_th": "นาปัง",
        "name_en": "Na Pang",
        "zip_codes": [
            55000
        ],
        "district_id": 5514
    },
    {
        "id": 551403,
        "name_th": "น้ำแก่น",
        "name_en": "Nam Kaen",
        "zip_codes": [
            55000
        ],
        "district_id": 5514
    },
    {
        "id": 551404,
        "name_th": "น้ำเกี๋ยน",
        "name_en": "Nam Kian",
        "zip_codes": [
            55000
        ],
        "district_id": 5514
    },
    {
        "id": 551405,
        "name_th": "เมืองจัง",
        "name_en": "Mueang Chang",
        "zip_codes": [
            55000
        ],
        "district_id": 5514
    },
    {
        "id": 551406,
        "name_th": "ท่าน้าว",
        "name_en": "Tha Nao",
        "zip_codes": [
            55000
        ],
        "district_id": 5514
    },
    {
        "id": 551407,
        "name_th": "ฝายแก้ว",
        "name_en": "Fai Kaeo",
        "zip_codes": [
            55000
        ],
        "district_id": 5514
    },
    {
        "id": 551501,
        "name_th": "ห้วยโก๋น",
        "name_en": "Huai Kon",
        "zip_codes": [
            55130
        ],
        "district_id": 5515
    },
    {
        "id": 551502,
        "name_th": "ขุนน่าน",
        "name_en": "Khun Nan",
        "zip_codes": [
            55220
        ],
        "district_id": 5515
    },
    {
        "id": 560101,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560102,
        "name_th": "แม่ต๋ำ",
        "name_en": "Mae Tam",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560104,
        "name_th": "แม่นาเรือ",
        "name_en": "Mae Na Ruea",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560105,
        "name_th": "บ้านตุ่น",
        "name_en": "Ban Tun",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560106,
        "name_th": "บ้านต๊ำ",
        "name_en": "Ban Tam",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560107,
        "name_th": "บ้านต๋อม",
        "name_en": "Ban Tom",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560108,
        "name_th": "แม่ปืม",
        "name_en": "Mae Puem",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560110,
        "name_th": "แม่กา",
        "name_en": "Mae Ka",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560111,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560112,
        "name_th": "จำป่าหวาย",
        "name_en": "Cham Pa Wai",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560113,
        "name_th": "ท่าวังทอง",
        "name_en": "Tha Wang Thong",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560114,
        "name_th": "แม่ใส",
        "name_en": "Mae Sai",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560115,
        "name_th": "บ้านสาง",
        "name_en": "Ban Sang",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560116,
        "name_th": "ท่าจำปี",
        "name_en": "Tha Champi",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560118,
        "name_th": "สันป่าม่วง",
        "name_en": "San Pa Muang",
        "zip_codes": [
            56000
        ],
        "district_id": 5601
    },
    {
        "id": 560201,
        "name_th": "ห้วยข้าวก่ำ",
        "name_en": "Huai Khao Kam",
        "zip_codes": [
            56150
        ],
        "district_id": 5602
    },
    {
        "id": 560202,
        "name_th": "จุน",
        "name_en": "Chun",
        "zip_codes": [
            56150
        ],
        "district_id": 5602
    },
    {
        "id": 560203,
        "name_th": "ลอ",
        "name_en": "Lo",
        "zip_codes": [
            56150
        ],
        "district_id": 5602
    },
    {
        "id": 560204,
        "name_th": "หงส์หิน",
        "name_en": "Hong Hin",
        "zip_codes": [
            56150
        ],
        "district_id": 5602
    },
    {
        "id": 560205,
        "name_th": "ทุ่งรวงทอง",
        "name_en": "Thung Ruang Thong",
        "zip_codes": [
            56150
        ],
        "district_id": 5602
    },
    {
        "id": 560206,
        "name_th": "ห้วยยางขาม",
        "name_en": "Huai Yang Kham",
        "zip_codes": [
            56150
        ],
        "district_id": 5602
    },
    {
        "id": 560207,
        "name_th": "พระธาตุขิงแกง",
        "name_en": "Phra That Khing Kaeng",
        "zip_codes": [
            56150
        ],
        "district_id": 5602
    },
    {
        "id": 560301,
        "name_th": "หย่วน",
        "name_en": "Yuan",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560306,
        "name_th": "น้ำแวน",
        "name_en": "Nam Waen",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560307,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560308,
        "name_th": "ฝายกวาง",
        "name_en": "Fai Kwang",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560309,
        "name_th": "เจดีย์คำ",
        "name_en": "Chedi Kham",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560310,
        "name_th": "ร่มเย็น",
        "name_en": "Rom Yen",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560311,
        "name_th": "เชียงบาน",
        "name_en": "Chiang Ban",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560312,
        "name_th": "แม่ลาว",
        "name_en": "Mae Lao",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560313,
        "name_th": "อ่างทอง",
        "name_en": "Ang Thong",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560314,
        "name_th": "ทุ่งผาสุข",
        "name_en": "Thung Pha Suk",
        "zip_codes": [
            56110
        ],
        "district_id": 5603
    },
    {
        "id": 560401,
        "name_th": "เชียงม่วน",
        "name_en": "Chiang Muan",
        "zip_codes": [
            56160
        ],
        "district_id": 5604
    },
    {
        "id": 560402,
        "name_th": "บ้านมาง",
        "name_en": "Ban Mang",
        "zip_codes": [
            56160
        ],
        "district_id": 5604
    },
    {
        "id": 560403,
        "name_th": "สระ",
        "name_en": "Sa",
        "zip_codes": [
            56160
        ],
        "district_id": 5604
    },
    {
        "id": 560501,
        "name_th": "ดอกคำใต้",
        "name_en": "Dok Kham Tai",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560502,
        "name_th": "ดอนศรีชุม",
        "name_en": "Don Si Chum",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560503,
        "name_th": "บ้านถ้ำ",
        "name_en": "Ban Tham",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560504,
        "name_th": "บ้านปิน",
        "name_en": "Ban Pin",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560505,
        "name_th": "ห้วยลาน",
        "name_en": "Huai Lan",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560506,
        "name_th": "สันโค้ง",
        "name_en": "San Khong",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560507,
        "name_th": "ป่าซาง",
        "name_en": "Pa Sang",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560508,
        "name_th": "หนองหล่ม",
        "name_en": "Nong Lom",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560509,
        "name_th": "ดงสุวรรณ",
        "name_en": "Dong Suwan",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560510,
        "name_th": "บุญเกิด",
        "name_en": "Bun Koet",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560511,
        "name_th": "สว่างอารมณ์",
        "name_en": "Sawang Arom",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560512,
        "name_th": "คือเวียง",
        "name_en": "Khue Wiang",
        "zip_codes": [
            56120
        ],
        "district_id": 5605
    },
    {
        "id": 560601,
        "name_th": "ปง",
        "name_en": "Pong",
        "zip_codes": [
            56140
        ],
        "district_id": 5606
    },
    {
        "id": 560602,
        "name_th": "ควร",
        "name_en": "Khuan",
        "zip_codes": [
            56140
        ],
        "district_id": 5606
    },
    {
        "id": 560603,
        "name_th": "ออย",
        "name_en": "Oi",
        "zip_codes": [
            56140
        ],
        "district_id": 5606
    },
    {
        "id": 560604,
        "name_th": "งิม",
        "name_en": "Ngim",
        "zip_codes": [
            56140
        ],
        "district_id": 5606
    },
    {
        "id": 560605,
        "name_th": "ผาช้างน้อย",
        "name_en": "Pha Chang Noi",
        "zip_codes": [
            56140
        ],
        "district_id": 5606
    },
    {
        "id": 560606,
        "name_th": "นาปรัง",
        "name_en": "Na Prang",
        "zip_codes": [
            56140
        ],
        "district_id": 5606
    },
    {
        "id": 560607,
        "name_th": "ขุนควร",
        "name_en": "Khun Khuan",
        "zip_codes": [
            56140
        ],
        "district_id": 5606
    },
    {
        "id": 560701,
        "name_th": "แม่ใจ",
        "name_en": "Mae Chai",
        "zip_codes": [
            56130
        ],
        "district_id": 5607
    },
    {
        "id": 560702,
        "name_th": "ศรีถ้อย",
        "name_en": "Si Thoi",
        "zip_codes": [
            56130
        ],
        "district_id": 5607
    },
    {
        "id": 560703,
        "name_th": "แม่สุก",
        "name_en": "Mae Suk",
        "zip_codes": [
            56130
        ],
        "district_id": 5607
    },
    {
        "id": 560704,
        "name_th": "ป่าแฝก",
        "name_en": "Pa Faek",
        "zip_codes": [
            56130
        ],
        "district_id": 5607
    },
    {
        "id": 560705,
        "name_th": "บ้านเหล่า",
        "name_en": "Ban Lao",
        "zip_codes": [
            56130
        ],
        "district_id": 5607
    },
    {
        "id": 560706,
        "name_th": "เจริญราษฎร์",
        "name_en": "Charoen Rat",
        "zip_codes": [
            56130
        ],
        "district_id": 5607
    },
    {
        "id": 560801,
        "name_th": "ภูซาง",
        "name_en": "Phu Sang",
        "zip_codes": [
            56110
        ],
        "district_id": 5608
    },
    {
        "id": 560802,
        "name_th": "ป่าสัก",
        "name_en": "Pa Sak",
        "zip_codes": [
            56110
        ],
        "district_id": 5608
    },
    {
        "id": 560803,
        "name_th": "ทุ่งกล้วย",
        "name_en": "Thung Kluai",
        "zip_codes": [
            56110
        ],
        "district_id": 5608
    },
    {
        "id": 560804,
        "name_th": "เชียงแรง",
        "name_en": "Chiang Raeng",
        "zip_codes": [
            56110
        ],
        "district_id": 5608
    },
    {
        "id": 560805,
        "name_th": "สบบง",
        "name_en": "Sop Bong",
        "zip_codes": [
            56110
        ],
        "district_id": 5608
    },
    {
        "id": 560901,
        "name_th": "ห้วยแก้ว",
        "name_en": "Huai Kaeo",
        "zip_codes": [
            56000
        ],
        "district_id": 5609
    },
    {
        "id": 560902,
        "name_th": "ดงเจน",
        "name_en": "Dong Chen",
        "zip_codes": [
            56000
        ],
        "district_id": 5609
    },
    {
        "id": 560903,
        "name_th": "แม่อิง",
        "name_en": "Mae Ing",
        "zip_codes": [
            56000
        ],
        "district_id": 5609
    },
    {
        "id": 570101,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570102,
        "name_th": "รอบเวียง",
        "name_en": "Rop Wiang",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570103,
        "name_th": "บ้านดู่",
        "name_en": "Ban Du",
        "zip_codes": [
            57100
        ],
        "district_id": 5701
    },
    {
        "id": 570104,
        "name_th": "นางแล",
        "name_en": "Nang Lae",
        "zip_codes": [
            57100
        ],
        "district_id": 5701
    },
    {
        "id": 570105,
        "name_th": "แม่ข้าวต้ม",
        "name_en": "Mae Khao Tom",
        "zip_codes": [
            57100
        ],
        "district_id": 5701
    },
    {
        "id": 570106,
        "name_th": "แม่ยาว",
        "name_en": "Mae Yao",
        "zip_codes": [
            57100
        ],
        "district_id": 5701
    },
    {
        "id": 570107,
        "name_th": "สันทราย",
        "name_en": "San Sai",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570111,
        "name_th": "แม่กรณ์",
        "name_en": "Mae Kon",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570112,
        "name_th": "ห้วยชมภู",
        "name_en": "Huai Chomphu",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570113,
        "name_th": "ห้วยสัก",
        "name_en": "Huai Sak",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570114,
        "name_th": "ริมกก",
        "name_en": "Rim Kok",
        "zip_codes": [
            57100
        ],
        "district_id": 5701
    },
    {
        "id": 570115,
        "name_th": "ดอยลาน",
        "name_en": "Doi Lan",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570116,
        "name_th": "ป่าอ้อดอนชัย",
        "name_en": "Pa O Don Chai",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570118,
        "name_th": "ท่าสาย",
        "name_en": "Tha Sai",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570120,
        "name_th": "ดอยฮาง",
        "name_en": "Doi Hang",
        "zip_codes": [
            57000
        ],
        "district_id": 5701
    },
    {
        "id": 570121,
        "name_th": "ท่าสุด",
        "name_en": "Tha Sut",
        "zip_codes": [
            57100
        ],
        "district_id": 5701
    },
    {
        "id": 570202,
        "name_th": "เวียงชัย",
        "name_en": "Wiang Chai",
        "zip_codes": [
            57210
        ],
        "district_id": 5702
    },
    {
        "id": 570203,
        "name_th": "ผางาม",
        "name_en": "Pha Ngam",
        "zip_codes": [
            57210
        ],
        "district_id": 5702
    },
    {
        "id": 570204,
        "name_th": "เวียงเหนือ",
        "name_en": "Wiang Nuea",
        "zip_codes": [
            57210
        ],
        "district_id": 5702
    },
    {
        "id": 570206,
        "name_th": "ดอนศิลา",
        "name_en": "Don Sila",
        "zip_codes": [
            57210
        ],
        "district_id": 5702
    },
    {
        "id": 570208,
        "name_th": "เมืองชุม",
        "name_en": "Mueang Chum",
        "zip_codes": [
            57210
        ],
        "district_id": 5702
    },
    {
        "id": 570301,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            57140
        ],
        "district_id": 5703
    },
    {
        "id": 570302,
        "name_th": "สถาน",
        "name_en": "Sathan",
        "zip_codes": [
            57140
        ],
        "district_id": 5703
    },
    {
        "id": 570303,
        "name_th": "ครึ่ง",
        "name_en": "Khrueng",
        "zip_codes": [
            57140
        ],
        "district_id": 5703
    },
    {
        "id": 570304,
        "name_th": "บุญเรือง",
        "name_en": "Bun Rueang",
        "zip_codes": [
            57140
        ],
        "district_id": 5703
    },
    {
        "id": 570305,
        "name_th": "ห้วยซ้อ",
        "name_en": "Huai So",
        "zip_codes": [
            57140
        ],
        "district_id": 5703
    },
    {
        "id": 570308,
        "name_th": "ศรีดอนชัย",
        "name_en": "Si Don Chai",
        "zip_codes": [
            57140
        ],
        "district_id": 5703
    },
    {
        "id": 570310,
        "name_th": "ริมโขง",
        "name_en": "Rim Khong",
        "zip_codes": [
            57140
        ],
        "district_id": 5703
    },
    {
        "id": 570401,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            57160
        ],
        "district_id": 5704
    },
    {
        "id": 570402,
        "name_th": "งิ้ว",
        "name_en": "Ngio",
        "zip_codes": [
            57160,
            57230
        ],
        "district_id": 5704
    },
    {
        "id": 570403,
        "name_th": "ปล้อง",
        "name_en": "Plong",
        "zip_codes": [
            57230
        ],
        "district_id": 5704
    },
    {
        "id": 570404,
        "name_th": "แม่ลอย",
        "name_en": "Mae Loi",
        "zip_codes": [
            57230
        ],
        "district_id": 5704
    },
    {
        "id": 570405,
        "name_th": "เชียงเคี่ยน",
        "name_en": "Chiang Khian",
        "zip_codes": [
            57230
        ],
        "district_id": 5704
    },
    {
        "id": 570409,
        "name_th": "ตับเต่า",
        "name_en": "Tap Tao",
        "zip_codes": [
            57160
        ],
        "district_id": 5704
    },
    {
        "id": 570410,
        "name_th": "หงาว",
        "name_en": "Ngao",
        "zip_codes": [
            57160
        ],
        "district_id": 5704
    },
    {
        "id": 570411,
        "name_th": "สันทรายงาม",
        "name_en": "San Sai Ngam",
        "zip_codes": [
            57160
        ],
        "district_id": 5704
    },
    {
        "id": 570412,
        "name_th": "ศรีดอนไชย",
        "name_en": "Si Don Chai",
        "zip_codes": [
            57230
        ],
        "district_id": 5704
    },
    {
        "id": 570413,
        "name_th": "หนองแรด",
        "name_en": "Nong Raet",
        "zip_codes": [
            57230
        ],
        "district_id": 5704
    },
    {
        "id": 570501,
        "name_th": "สันมะเค็ด",
        "name_en": "San Makhet",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570502,
        "name_th": "แม่อ้อ",
        "name_en": "Mae O",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570503,
        "name_th": "ธารทอง",
        "name_en": "Than Thong",
        "zip_codes": [
            57250
        ],
        "district_id": 5705
    },
    {
        "id": 570504,
        "name_th": "สันติสุข",
        "name_en": "Santi Suk",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570505,
        "name_th": "ดอยงาม",
        "name_en": "Doi Ngam",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570506,
        "name_th": "หัวง้ม",
        "name_en": "Hua Ngom",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570507,
        "name_th": "เจริญเมือง",
        "name_en": "Charoen Mueang",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570508,
        "name_th": "ป่าหุ่ง",
        "name_en": "Pa Hung",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570509,
        "name_th": "ม่วงคำ",
        "name_en": "Muang Kham",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570510,
        "name_th": "ทรายขาว",
        "name_en": "Sai Khao",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570511,
        "name_th": "สันกลาง",
        "name_en": "San Klang",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570512,
        "name_th": "แม่เย็น",
        "name_en": "Mae Yen",
        "zip_codes": [
            57280
        ],
        "district_id": 5705
    },
    {
        "id": 570513,
        "name_th": "เมืองพาน",
        "name_en": "Mueang Phan",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570514,
        "name_th": "ทานตะวัน",
        "name_en": "Than Tawan",
        "zip_codes": [
            57280
        ],
        "district_id": 5705
    },
    {
        "id": 570515,
        "name_th": "เวียงห้าว",
        "name_en": "Wiang Hao",
        "zip_codes": [
            57120
        ],
        "district_id": 5705
    },
    {
        "id": 570601,
        "name_th": "ป่าแดด",
        "name_en": "Pa Daet",
        "zip_codes": [
            57190
        ],
        "district_id": 5706
    },
    {
        "id": 570602,
        "name_th": "ป่าแงะ",
        "name_en": "Pa Ngae",
        "zip_codes": [
            57190
        ],
        "district_id": 5706
    },
    {
        "id": 570603,
        "name_th": "สันมะค่า",
        "name_en": "San Makha",
        "zip_codes": [
            57190
        ],
        "district_id": 5706
    },
    {
        "id": 570605,
        "name_th": "โรงช้าง",
        "name_en": "Rong Chang",
        "zip_codes": [
            57190
        ],
        "district_id": 5706
    },
    {
        "id": 570606,
        "name_th": "ศรีโพธิ์เงิน",
        "name_en": "Si Pho Ngoen",
        "zip_codes": [
            57190
        ],
        "district_id": 5706
    },
    {
        "id": 570701,
        "name_th": "แม่จัน",
        "name_en": "Mae Chan",
        "zip_codes": [
            57110
        ],
        "district_id": 5707
    },
    {
        "id": 570702,
        "name_th": "จันจว้า",
        "name_en": "Chan Chwa",
        "zip_codes": [
            57270
        ],
        "district_id": 5707
    },
    {
        "id": 570703,
        "name_th": "แม่คำ",
        "name_en": "Mae Kham",
        "zip_codes": [
            57240
        ],
        "district_id": 5707
    },
    {
        "id": 570704,
        "name_th": "ป่าซาง",
        "name_en": "Pa Sang",
        "zip_codes": [
            57110
        ],
        "district_id": 5707
    },
    {
        "id": 570705,
        "name_th": "สันทราย",
        "name_en": "San Sai",
        "zip_codes": [
            57110
        ],
        "district_id": 5707
    },
    {
        "id": 570706,
        "name_th": "ท่าข้าวเปลือก",
        "name_en": "Tha Khao Plueak",
        "zip_codes": [
            57110
        ],
        "district_id": 5707
    },
    {
        "id": 570708,
        "name_th": "ป่าตึง",
        "name_en": "Pa Tueng",
        "zip_codes": [
            57110
        ],
        "district_id": 5707
    },
    {
        "id": 570710,
        "name_th": "แม่ไร่",
        "name_en": "Mae Rai",
        "zip_codes": [
            57240
        ],
        "district_id": 5707
    },
    {
        "id": 570711,
        "name_th": "ศรีค้ำ",
        "name_en": "Si Kham",
        "zip_codes": [
            57110
        ],
        "district_id": 5707
    },
    {
        "id": 570712,
        "name_th": "จันจว้าใต้",
        "name_en": "Chan Chwa Tai",
        "zip_codes": [
            57270
        ],
        "district_id": 5707
    },
    {
        "id": 570713,
        "name_th": "จอมสวรรค์",
        "name_en": "Chom Sawan",
        "zip_codes": [
            57110
        ],
        "district_id": 5707
    },
    {
        "id": 570801,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            57150
        ],
        "district_id": 5708
    },
    {
        "id": 570802,
        "name_th": "ป่าสัก",
        "name_en": "Pa Sak",
        "zip_codes": [
            57150
        ],
        "district_id": 5708
    },
    {
        "id": 570803,
        "name_th": "บ้านแซว",
        "name_en": "Ban Saeo",
        "zip_codes": [
            57150
        ],
        "district_id": 5708
    },
    {
        "id": 570804,
        "name_th": "ศรีดอนมูล",
        "name_en": "Si Don Mun",
        "zip_codes": [
            57150
        ],
        "district_id": 5708
    },
    {
        "id": 570805,
        "name_th": "แม่เงิน",
        "name_en": "Mae Ngoen",
        "zip_codes": [
            57150
        ],
        "district_id": 5708
    },
    {
        "id": 570806,
        "name_th": "โยนก",
        "name_en": "Yonok",
        "zip_codes": [
            57150
        ],
        "district_id": 5708
    },
    {
        "id": 570901,
        "name_th": "แม่สาย",
        "name_en": "Mae Sai",
        "zip_codes": [
            57130
        ],
        "district_id": 5709
    },
    {
        "id": 570902,
        "name_th": "ห้วยไคร้",
        "name_en": "Huai Khrai",
        "zip_codes": [
            57220
        ],
        "district_id": 5709
    },
    {
        "id": 570903,
        "name_th": "เกาะช้าง",
        "name_en": "Ko Chang",
        "zip_codes": [
            57130
        ],
        "district_id": 5709
    },
    {
        "id": 570904,
        "name_th": "โป่งผา",
        "name_en": "Pong Pha",
        "zip_codes": [
            57130
        ],
        "district_id": 5709
    },
    {
        "id": 570905,
        "name_th": "ศรีเมืองชุม",
        "name_en": "Si Mueang Chum",
        "zip_codes": [
            57130
        ],
        "district_id": 5709
    },
    {
        "id": 570906,
        "name_th": "เวียงพางคำ",
        "name_en": "Wiang Phang Kham",
        "zip_codes": [
            57130
        ],
        "district_id": 5709
    },
    {
        "id": 570908,
        "name_th": "บ้านด้าย",
        "name_en": "Ban Dai",
        "zip_codes": [
            57220
        ],
        "district_id": 5709
    },
    {
        "id": 570909,
        "name_th": "โป่งงาม",
        "name_en": "Pong Ngam",
        "zip_codes": [
            57130
        ],
        "district_id": 5709
    },
    {
        "id": 571001,
        "name_th": "แม่สรวย",
        "name_en": "Mae Suai",
        "zip_codes": [
            57180
        ],
        "district_id": 5710
    },
    {
        "id": 571002,
        "name_th": "ป่าแดด",
        "name_en": "Pa Daet",
        "zip_codes": [
            57180
        ],
        "district_id": 5710
    },
    {
        "id": 571003,
        "name_th": "แม่พริก",
        "name_en": "Mae Phrik",
        "zip_codes": [
            57180
        ],
        "district_id": 5710
    },
    {
        "id": 571004,
        "name_th": "ศรีถ้อย",
        "name_en": "Si Thoi",
        "zip_codes": [
            57180
        ],
        "district_id": 5710
    },
    {
        "id": 571005,
        "name_th": "ท่าก๊อ",
        "name_en": "Tha Ko",
        "zip_codes": [
            57180
        ],
        "district_id": 5710
    },
    {
        "id": 571006,
        "name_th": "วาวี",
        "name_en": "Wawi",
        "zip_codes": [
            57180
        ],
        "district_id": 5710
    },
    {
        "id": 571007,
        "name_th": "เจดีย์หลวง",
        "name_en": "Chedi Luang",
        "zip_codes": [
            57180
        ],
        "district_id": 5710
    },
    {
        "id": 571101,
        "name_th": "สันสลี",
        "name_en": "San Sali",
        "zip_codes": [
            57170
        ],
        "district_id": 5711
    },
    {
        "id": 571102,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            57170
        ],
        "district_id": 5711
    },
    {
        "id": 571103,
        "name_th": "บ้านโป่ง",
        "name_en": "Ban Pong",
        "zip_codes": [
            57170
        ],
        "district_id": 5711
    },
    {
        "id": 571104,
        "name_th": "ป่างิ้ว",
        "name_en": "Pa Ngio",
        "zip_codes": [
            57170
        ],
        "district_id": 5711
    },
    {
        "id": 571105,
        "name_th": "เวียงกาหลง",
        "name_en": "Wiang Ka Long",
        "zip_codes": [
            57260
        ],
        "district_id": 5711
    },
    {
        "id": 571106,
        "name_th": "แม่เจดีย์",
        "name_en": "Mae Chedi",
        "zip_codes": [
            57260
        ],
        "district_id": 5711
    },
    {
        "id": 571107,
        "name_th": "แม่เจดีย์ใหม่",
        "name_en": "Mae Chedi Mai",
        "zip_codes": [
            57260
        ],
        "district_id": 5711
    },
    {
        "id": 571201,
        "name_th": "แม่เปา",
        "name_en": "Mae Pao",
        "zip_codes": [
            57290
        ],
        "district_id": 5712
    },
    {
        "id": 571202,
        "name_th": "แม่ต๋ำ",
        "name_en": "Mae Tam",
        "zip_codes": [
            57290
        ],
        "district_id": 5712
    },
    {
        "id": 571203,
        "name_th": "ไม้ยา",
        "name_en": "Mai Ya",
        "zip_codes": [
            57290
        ],
        "district_id": 5712
    },
    {
        "id": 571204,
        "name_th": "เม็งราย",
        "name_en": "Mengrai",
        "zip_codes": [
            57290
        ],
        "district_id": 5712
    },
    {
        "id": 571205,
        "name_th": "ตาดควัน",
        "name_en": "Tat Khwan",
        "zip_codes": [
            57290
        ],
        "district_id": 5712
    },
    {
        "id": 571301,
        "name_th": "ม่วงยาย",
        "name_en": "Muang Yai",
        "zip_codes": [
            57310
        ],
        "district_id": 5713
    },
    {
        "id": 571302,
        "name_th": "ปอ",
        "name_en": "Po",
        "zip_codes": [
            57310
        ],
        "district_id": 5713
    },
    {
        "id": 571303,
        "name_th": "หล่ายงาว",
        "name_en": "Lai Ngao",
        "zip_codes": [
            57310
        ],
        "district_id": 5713
    },
    {
        "id": 571304,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            57310
        ],
        "district_id": 5713
    },
    {
        "id": 571401,
        "name_th": "ต้า",
        "name_en": "Ta",
        "zip_codes": [
            57340
        ],
        "district_id": 5714
    },
    {
        "id": 571402,
        "name_th": "ป่าตาล",
        "name_en": "Pa Tan",
        "zip_codes": [
            57340
        ],
        "district_id": 5714
    },
    {
        "id": 571403,
        "name_th": "ยางฮอม",
        "name_en": "Yang Hom",
        "zip_codes": [
            57340
        ],
        "district_id": 5714
    },
    {
        "id": 571501,
        "name_th": "เทอดไทย",
        "name_en": "Thoet Thai",
        "zip_codes": [
            57240
        ],
        "district_id": 5715
    },
    {
        "id": 571502,
        "name_th": "แม่สลองใน",
        "name_en": "Mae Salong Nai",
        "zip_codes": [
            57110
        ],
        "district_id": 5715
    },
    {
        "id": 571503,
        "name_th": "แม่สลองนอก",
        "name_en": "Mae Salong Nok",
        "zip_codes": [
            57110
        ],
        "district_id": 5715
    },
    {
        "id": 571504,
        "name_th": "แม่ฟ้าหลวง",
        "name_en": "Mae Fa Luang",
        "zip_codes": [
            57240
        ],
        "district_id": 5715
    },
    {
        "id": 571601,
        "name_th": "ดงมะดะ",
        "name_en": "Dong Mada",
        "zip_codes": [
            57250
        ],
        "district_id": 5716
    },
    {
        "id": 571602,
        "name_th": "จอมหมอกแก้ว",
        "name_en": "Chom Mok Kaeo",
        "zip_codes": [
            57250
        ],
        "district_id": 5716
    },
    {
        "id": 571603,
        "name_th": "บัวสลี",
        "name_en": "Bua Sali",
        "zip_codes": [
            57250
        ],
        "district_id": 5716
    },
    {
        "id": 571604,
        "name_th": "ป่าก่อดำ",
        "name_en": "Pa Ko Dam",
        "zip_codes": [
            57250
        ],
        "district_id": 5716
    },
    {
        "id": 571605,
        "name_th": "โป่งแพร่",
        "name_en": "Pong Phrae",
        "zip_codes": [
            57000
        ],
        "district_id": 5716
    },
    {
        "id": 571701,
        "name_th": "ทุ่งก่อ",
        "name_en": "Thung Ko",
        "zip_codes": [
            57210
        ],
        "district_id": 5717
    },
    {
        "id": 571702,
        "name_th": "ดงมหาวัน",
        "name_en": "Dong Maha Wan",
        "zip_codes": [
            57210
        ],
        "district_id": 5717
    },
    {
        "id": 571703,
        "name_th": "ป่าซาง",
        "name_en": "Pa Sang",
        "zip_codes": [
            57210
        ],
        "district_id": 5717
    },
    {
        "id": 571801,
        "name_th": "ปงน้อย",
        "name_en": "Pong Noi",
        "zip_codes": [
            57110
        ],
        "district_id": 5718
    },
    {
        "id": 571802,
        "name_th": "โชคชัย",
        "name_en": "Chok Chai",
        "zip_codes": [
            57110
        ],
        "district_id": 5718
    },
    {
        "id": 571803,
        "name_th": "หนองป่าก่อ",
        "name_en": "Nong Pa Ko",
        "zip_codes": [
            57110
        ],
        "district_id": 5718
    },
    {
        "id": 580101,
        "name_th": "จองคำ",
        "name_en": "Chong Kham",
        "zip_codes": [
            58000
        ],
        "district_id": 5801
    },
    {
        "id": 580102,
        "name_th": "ห้วยโป่ง",
        "name_en": "Huai Pong",
        "zip_codes": [
            58000
        ],
        "district_id": 5801
    },
    {
        "id": 580103,
        "name_th": "ผาบ่อง",
        "name_en": "Pha Bong",
        "zip_codes": [
            58000
        ],
        "district_id": 5801
    },
    {
        "id": 580104,
        "name_th": "ปางหมู",
        "name_en": "Pang Mu",
        "zip_codes": [
            58000
        ],
        "district_id": 5801
    },
    {
        "id": 580105,
        "name_th": "หมอกจำแป่",
        "name_en": "Mok Champae",
        "zip_codes": [
            58000
        ],
        "district_id": 5801
    },
    {
        "id": 580106,
        "name_th": "ห้วยผา",
        "name_en": "Huai Pha",
        "zip_codes": [
            58000
        ],
        "district_id": 5801
    },
    {
        "id": 580109,
        "name_th": "ห้วยปูลิง",
        "name_en": "Huai Pu Ling",
        "zip_codes": [
            58000
        ],
        "district_id": 5801
    },
    {
        "id": 580201,
        "name_th": "ขุนยวม",
        "name_en": "Khun Yuam",
        "zip_codes": [
            58140
        ],
        "district_id": 5802
    },
    {
        "id": 580202,
        "name_th": "แม่เงา",
        "name_en": "Mae Ngao",
        "zip_codes": [
            58140
        ],
        "district_id": 5802
    },
    {
        "id": 580203,
        "name_th": "เมืองปอน",
        "name_en": "Mueang Pon",
        "zip_codes": [
            58140
        ],
        "district_id": 5802
    },
    {
        "id": 580204,
        "name_th": "แม่ยวมน้อย",
        "name_en": "Mae Yuam Noi",
        "zip_codes": [
            58140
        ],
        "district_id": 5802
    },
    {
        "id": 580205,
        "name_th": "แม่กิ๊",
        "name_en": "Mae Ki",
        "zip_codes": [
            58140
        ],
        "district_id": 5802
    },
    {
        "id": 580206,
        "name_th": "แม่อูคอ",
        "name_en": "Mae Ukho",
        "zip_codes": [
            58140
        ],
        "district_id": 5802
    },
    {
        "id": 580301,
        "name_th": "เวียงใต้",
        "name_en": "Wiang Tai",
        "zip_codes": [
            58130
        ],
        "district_id": 5803
    },
    {
        "id": 580302,
        "name_th": "เวียงเหนือ",
        "name_en": "Wiang Nuea",
        "zip_codes": [
            58130
        ],
        "district_id": 5803
    },
    {
        "id": 580303,
        "name_th": "แม่นาเติง",
        "name_en": "Mae Na Toeng",
        "zip_codes": [
            58130
        ],
        "district_id": 5803
    },
    {
        "id": 580304,
        "name_th": "แม่ฮี้",
        "name_en": "Mae Hi",
        "zip_codes": [
            58130
        ],
        "district_id": 5803
    },
    {
        "id": 580305,
        "name_th": "ทุ่งยาว",
        "name_en": "Thung Yao",
        "zip_codes": [
            58130
        ],
        "district_id": 5803
    },
    {
        "id": 580306,
        "name_th": "เมืองแปง",
        "name_en": "Mueang Paeng",
        "zip_codes": [
            58130
        ],
        "district_id": 5803
    },
    {
        "id": 580307,
        "name_th": "โป่งสา",
        "name_en": "Pong Sa",
        "zip_codes": [
            58130
        ],
        "district_id": 5803
    },
    {
        "id": 580401,
        "name_th": "บ้านกาศ",
        "name_en": "Ban Kat",
        "zip_codes": [
            58110
        ],
        "district_id": 5804
    },
    {
        "id": 580402,
        "name_th": "แม่สะเรียง",
        "name_en": "Mae Sariang",
        "zip_codes": [
            58110
        ],
        "district_id": 5804
    },
    {
        "id": 580403,
        "name_th": "แม่คง",
        "name_en": "Mae Khong",
        "zip_codes": [
            58110
        ],
        "district_id": 5804
    },
    {
        "id": 580404,
        "name_th": "แม่เหาะ",
        "name_en": "Mae Ho",
        "zip_codes": [
            58110
        ],
        "district_id": 5804
    },
    {
        "id": 580405,
        "name_th": "แม่ยวม",
        "name_en": "Mae Yuam",
        "zip_codes": [
            58110
        ],
        "district_id": 5804
    },
    {
        "id": 580406,
        "name_th": "เสาหิน",
        "name_en": "Sao Hin",
        "zip_codes": [
            58110
        ],
        "district_id": 5804
    },
    {
        "id": 580408,
        "name_th": "ป่าแป๋",
        "name_en": "Pa Pae",
        "zip_codes": [
            58110
        ],
        "district_id": 5804
    },
    {
        "id": 580501,
        "name_th": "แม่ลาน้อย",
        "name_en": "Mae La Noi",
        "zip_codes": [
            58120
        ],
        "district_id": 5805
    },
    {
        "id": 580502,
        "name_th": "แม่ลาหลวง",
        "name_en": "Mae La Luang",
        "zip_codes": [
            58120
        ],
        "district_id": 5805
    },
    {
        "id": 580503,
        "name_th": "ท่าผาปุ้ม",
        "name_en": "Tha Pha Pum",
        "zip_codes": [
            58120
        ],
        "district_id": 5805
    },
    {
        "id": 580504,
        "name_th": "แม่โถ",
        "name_en": "Mae Tho",
        "zip_codes": [
            58120
        ],
        "district_id": 5805
    },
    {
        "id": 580505,
        "name_th": "ห้วยห้อม",
        "name_en": "Huai Hom",
        "zip_codes": [
            58120
        ],
        "district_id": 5805
    },
    {
        "id": 580506,
        "name_th": "แม่นาจาง",
        "name_en": "Mae Na Chang",
        "zip_codes": [
            58120
        ],
        "district_id": 5805
    },
    {
        "id": 580507,
        "name_th": "สันติคีรี",
        "name_en": "Santi Khiri",
        "zip_codes": [
            58120
        ],
        "district_id": 5805
    },
    {
        "id": 580508,
        "name_th": "ขุนแม่ลาน้อย",
        "name_en": "Khun Mae La Noi",
        "zip_codes": [
            58120
        ],
        "district_id": 5805
    },
    {
        "id": 580601,
        "name_th": "สบเมย",
        "name_en": "Sop Moei",
        "zip_codes": [
            58110
        ],
        "district_id": 5806
    },
    {
        "id": 580602,
        "name_th": "แม่คะตวน",
        "name_en": "Mae Khatuan",
        "zip_codes": [
            58110
        ],
        "district_id": 5806
    },
    {
        "id": 580603,
        "name_th": "กองก๋อย",
        "name_en": "Kong Koi",
        "zip_codes": [
            58110
        ],
        "district_id": 5806
    },
    {
        "id": 580604,
        "name_th": "แม่สวด",
        "name_en": "Mae Suat",
        "zip_codes": [
            58110
        ],
        "district_id": 5806
    },
    {
        "id": 580605,
        "name_th": "ป่าโปง",
        "name_en": "Pa Pong",
        "zip_codes": [
            58110
        ],
        "district_id": 5806
    },
    {
        "id": 580606,
        "name_th": "แม่สามแลบ",
        "name_en": "Mae Sam Laep",
        "zip_codes": [
            58110
        ],
        "district_id": 5806
    },
    {
        "id": 580701,
        "name_th": "สบป่อง",
        "name_en": "Sop Pong",
        "zip_codes": [
            58150
        ],
        "district_id": 5807
    },
    {
        "id": 580702,
        "name_th": "ปางมะผ้า",
        "name_en": "Pang Mapha",
        "zip_codes": [
            58150
        ],
        "district_id": 5807
    },
    {
        "id": 580703,
        "name_th": "ถ้ำลอด",
        "name_en": "Tham Lot",
        "zip_codes": [
            58150
        ],
        "district_id": 5807
    },
    {
        "id": 580704,
        "name_th": "นาปู่ป้อม",
        "name_en": "Na Pu Pom",
        "zip_codes": [
            58150
        ],
        "district_id": 5807
    },
    {
        "id": 600101,
        "name_th": "ปากน้ำโพ",
        "name_en": "Pak Nam Pho",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600102,
        "name_th": "กลางแดด",
        "name_en": "Klang Daet",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600103,
        "name_th": "เกรียงไกร",
        "name_en": "Kriangkrai",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600104,
        "name_th": "แควใหญ่",
        "name_en": "Khwae Yai",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600105,
        "name_th": "ตะเคียนเลื่อน",
        "name_en": "Takhian Luean",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600106,
        "name_th": "นครสวรรค์ตก",
        "name_en": "Nakhon Sawan Tok",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600107,
        "name_th": "นครสวรรค์ออก",
        "name_en": "Nakhon Sawan Ok",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600108,
        "name_th": "บางพระหลวง",
        "name_en": "Bang Phra Luang",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600109,
        "name_th": "บางม่วง",
        "name_en": "Bang Muang",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600110,
        "name_th": "บ้านมะเกลือ",
        "name_en": "Ban Makluea",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600111,
        "name_th": "บ้านแก่ง",
        "name_en": "Ban Kaeng",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600112,
        "name_th": "พระนอน",
        "name_en": "Phra Non",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600113,
        "name_th": "วัดไทร",
        "name_en": "Wat Sai",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600114,
        "name_th": "หนองกรด",
        "name_en": "Nong Krot",
        "zip_codes": [
            60240
        ],
        "district_id": 6001
    },
    {
        "id": 600115,
        "name_th": "หนองกระโดน",
        "name_en": "Nong Kradon",
        "zip_codes": [
            60240
        ],
        "district_id": 6001
    },
    {
        "id": 600116,
        "name_th": "หนองปลิง",
        "name_en": "Nong Pling",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600117,
        "name_th": "บึงเสนาท",
        "name_en": "Bueng Senat",
        "zip_codes": [
            60000
        ],
        "district_id": 6001
    },
    {
        "id": 600201,
        "name_th": "โกรกพระ",
        "name_en": "Krok Phra",
        "zip_codes": [
            60170
        ],
        "district_id": 6002
    },
    {
        "id": 600202,
        "name_th": "ยางตาล",
        "name_en": "Yang Tan",
        "zip_codes": [
            60170
        ],
        "district_id": 6002
    },
    {
        "id": 600203,
        "name_th": "บางมะฝ่อ",
        "name_en": "Bang Mafo",
        "zip_codes": [
            60170
        ],
        "district_id": 6002
    },
    {
        "id": 600204,
        "name_th": "บางประมุง",
        "name_en": "Bang Pramung",
        "zip_codes": [
            60170
        ],
        "district_id": 6002
    },
    {
        "id": 600205,
        "name_th": "นากลาง",
        "name_en": "Na Klang",
        "zip_codes": [
            60170
        ],
        "district_id": 6002
    },
    {
        "id": 600206,
        "name_th": "ศาลาแดง",
        "name_en": "Sala Daeng",
        "zip_codes": [
            60170
        ],
        "district_id": 6002
    },
    {
        "id": 600207,
        "name_th": "เนินกว้าว",
        "name_en": "Noen Kwao",
        "zip_codes": [
            60170
        ],
        "district_id": 6002
    },
    {
        "id": 600208,
        "name_th": "เนินศาลา",
        "name_en": "Noen Sala",
        "zip_codes": [
            60170
        ],
        "district_id": 6002
    },
    {
        "id": 600209,
        "name_th": "หาดสูง",
        "name_en": "Hat Sung",
        "zip_codes": [
            60170
        ],
        "district_id": 6002
    },
    {
        "id": 600301,
        "name_th": "ชุมแสง",
        "name_en": "Chum Saeng",
        "zip_codes": [
            60120
        ],
        "district_id": 6003
    },
    {
        "id": 600302,
        "name_th": "ทับกฤช",
        "name_en": "Thap Krit",
        "zip_codes": [
            60250
        ],
        "district_id": 6003
    },
    {
        "id": 600303,
        "name_th": "พิกุล",
        "name_en": "Phikun",
        "zip_codes": [
            60120
        ],
        "district_id": 6003
    },
    {
        "id": 600304,
        "name_th": "เกยไชย",
        "name_en": "Koei Chai",
        "zip_codes": [
            60120
        ],
        "district_id": 6003
    },
    {
        "id": 600305,
        "name_th": "ท่าไม้",
        "name_en": "Tha Mai",
        "zip_codes": [
            60120
        ],
        "district_id": 6003
    },
    {
        "id": 600306,
        "name_th": "บางเคียน",
        "name_en": "Bang Khian",
        "zip_codes": [
            60120
        ],
        "district_id": 6003
    },
    {
        "id": 600307,
        "name_th": "หนองกระเจา",
        "name_en": "Nong Krachao",
        "zip_codes": [
            60120
        ],
        "district_id": 6003
    },
    {
        "id": 600308,
        "name_th": "พันลาน",
        "name_en": "Phan Lan",
        "zip_codes": [
            60250
        ],
        "district_id": 6003
    },
    {
        "id": 600309,
        "name_th": "โคกหม้อ",
        "name_en": "Khok Mo",
        "zip_codes": [
            60120
        ],
        "district_id": 6003
    },
    {
        "id": 600310,
        "name_th": "ไผ่สิงห์",
        "name_en": "Phai Sing",
        "zip_codes": [
            60120
        ],
        "district_id": 6003
    },
    {
        "id": 600311,
        "name_th": "ฆะมัง",
        "name_en": "Khamang",
        "zip_codes": [
            60120
        ],
        "district_id": 6003
    },
    {
        "id": 600312,
        "name_th": "ทับกฤชใต้",
        "name_en": "Thap Krit Tai",
        "zip_codes": [
            60250
        ],
        "district_id": 6003
    },
    {
        "id": 600401,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            60110
        ],
        "district_id": 6004
    },
    {
        "id": 600402,
        "name_th": "หนองกลับ",
        "name_en": "Nong Klap",
        "zip_codes": [
            60110
        ],
        "district_id": 6004
    },
    {
        "id": 600403,
        "name_th": "ธารทหาร",
        "name_en": "Than Thahan",
        "zip_codes": [
            60110
        ],
        "district_id": 6004
    },
    {
        "id": 600404,
        "name_th": "ห้วยร่วม",
        "name_en": "Huai Ruam",
        "zip_codes": [
            60110
        ],
        "district_id": 6004
    },
    {
        "id": 600405,
        "name_th": "ห้วยถั่วใต้",
        "name_en": "Huai Thua Tai",
        "zip_codes": [
            60110
        ],
        "district_id": 6004
    },
    {
        "id": 600406,
        "name_th": "ห้วยถั่วเหนือ",
        "name_en": "Huai Thua Nuea",
        "zip_codes": [
            60110
        ],
        "district_id": 6004
    },
    {
        "id": 600407,
        "name_th": "ห้วยใหญ่",
        "name_en": "Huai Yai",
        "zip_codes": [
            60110
        ],
        "district_id": 6004
    },
    {
        "id": 600408,
        "name_th": "ทุ่งทอง",
        "name_en": "Thung Thong",
        "zip_codes": [
            60110
        ],
        "district_id": 6004
    },
    {
        "id": 600409,
        "name_th": "วังบ่อ",
        "name_en": "Wang Bo",
        "zip_codes": [
            60110
        ],
        "district_id": 6004
    },
    {
        "id": 600501,
        "name_th": "ท่างิ้ว",
        "name_en": "Tha Ngio",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600502,
        "name_th": "บางตาหงาย",
        "name_en": "Bang Ta Ngai",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600503,
        "name_th": "หูกวาง",
        "name_en": "Hu Kwang",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600504,
        "name_th": "อ่างทอง",
        "name_en": "Ang Thong",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600505,
        "name_th": "บ้านแดน",
        "name_en": "Ban Daen",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600506,
        "name_th": "บางแก้ว",
        "name_en": "Bang Kaeo",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600507,
        "name_th": "ตาขีด",
        "name_en": "Ta Khit",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600508,
        "name_th": "ตาสัง",
        "name_en": "Ta Sang",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600509,
        "name_th": "ด่านช้าง",
        "name_en": "Dan Chang",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600510,
        "name_th": "หนองกรด",
        "name_en": "Nong Krot",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600511,
        "name_th": "หนองตางู",
        "name_en": "Nong Ta Ngu",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600512,
        "name_th": "บึงปลาทู",
        "name_en": "Bueng Pla Thu",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600513,
        "name_th": "เจริญผล",
        "name_en": "Charoen Phon",
        "zip_codes": [
            60180
        ],
        "district_id": 6005
    },
    {
        "id": 600601,
        "name_th": "มหาโพธิ",
        "name_en": "Maha Phot",
        "zip_codes": [
            60230
        ],
        "district_id": 6006
    },
    {
        "id": 600602,
        "name_th": "เก้าเลี้ยว",
        "name_en": "Kao Liao",
        "zip_codes": [
            60230
        ],
        "district_id": 6006
    },
    {
        "id": 600603,
        "name_th": "หนองเต่า",
        "name_en": "Nong Tao",
        "zip_codes": [
            60230
        ],
        "district_id": 6006
    },
    {
        "id": 600604,
        "name_th": "เขาดิน",
        "name_en": "Khao Din",
        "zip_codes": [
            60230
        ],
        "district_id": 6006
    },
    {
        "id": 600605,
        "name_th": "หัวดง",
        "name_en": "Hua Dong",
        "zip_codes": [
            60230
        ],
        "district_id": 6006
    },
    {
        "id": 600701,
        "name_th": "ตาคลี",
        "name_en": "Takhli",
        "zip_codes": [
            60140
        ],
        "district_id": 6007
    },
    {
        "id": 600702,
        "name_th": "ช่องแค",
        "name_en": "Chong Khae",
        "zip_codes": [
            60210
        ],
        "district_id": 6007
    },
    {
        "id": 600703,
        "name_th": "จันเสน",
        "name_en": "Chan Sen",
        "zip_codes": [
            60260
        ],
        "district_id": 6007
    },
    {
        "id": 600704,
        "name_th": "ห้วยหอม",
        "name_en": "Huai Hom",
        "zip_codes": [
            60210
        ],
        "district_id": 6007
    },
    {
        "id": 600705,
        "name_th": "หัวหวาย",
        "name_en": "Hua Wai",
        "zip_codes": [
            60140
        ],
        "district_id": 6007
    },
    {
        "id": 600706,
        "name_th": "หนองโพ",
        "name_en": "Nong Pho",
        "zip_codes": [
            60140
        ],
        "district_id": 6007
    },
    {
        "id": 600707,
        "name_th": "หนองหม้อ",
        "name_en": "Nong Mo",
        "zip_codes": [
            60140
        ],
        "district_id": 6007
    },
    {
        "id": 600708,
        "name_th": "สร้อยทอง",
        "name_en": "Soi Thong",
        "zip_codes": [
            60210
        ],
        "district_id": 6007
    },
    {
        "id": 600709,
        "name_th": "ลาดทิพรส",
        "name_en": "Lat Thippharot",
        "zip_codes": [
            60260
        ],
        "district_id": 6007
    },
    {
        "id": 600710,
        "name_th": "พรหมนิมิต",
        "name_en": "Phrom Nimit",
        "zip_codes": [
            60210
        ],
        "district_id": 6007
    },
    {
        "id": 600801,
        "name_th": "ท่าตะโก",
        "name_en": "Tha Tako",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600802,
        "name_th": "พนมรอก",
        "name_en": "Phanom Rok",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600803,
        "name_th": "หัวถนน",
        "name_en": "Hua Thanon",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600804,
        "name_th": "สายลำโพง",
        "name_en": "Sai Lamphong",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600805,
        "name_th": "วังมหากร",
        "name_en": "Wang Mahakon",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600806,
        "name_th": "ดอนคา",
        "name_en": "Don Kha",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600807,
        "name_th": "ทำนบ",
        "name_en": "Thamnop",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600808,
        "name_th": "วังใหญ่",
        "name_en": "Wang Yai",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600809,
        "name_th": "พนมเศษ",
        "name_en": "Phanom Set",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600810,
        "name_th": "หนองหลวง",
        "name_en": "Nong Luang",
        "zip_codes": [
            60160
        ],
        "district_id": 6008
    },
    {
        "id": 600901,
        "name_th": "โคกเดื่อ",
        "name_en": "Khok Duea",
        "zip_codes": [
            60220
        ],
        "district_id": 6009
    },
    {
        "id": 600902,
        "name_th": "สำโรงชัย",
        "name_en": "Samrong Chai",
        "zip_codes": [
            60220
        ],
        "district_id": 6009
    },
    {
        "id": 600903,
        "name_th": "วังน้ำลัด",
        "name_en": "Wang Nam Lat",
        "zip_codes": [
            60220
        ],
        "district_id": 6009
    },
    {
        "id": 600904,
        "name_th": "ตะคร้อ",
        "name_en": "Takhro",
        "zip_codes": [
            60220
        ],
        "district_id": 6009
    },
    {
        "id": 600905,
        "name_th": "โพธิ์ประสาท",
        "name_en": "Pho Prasat",
        "zip_codes": [
            60220
        ],
        "district_id": 6009
    },
    {
        "id": 600906,
        "name_th": "วังข่อย",
        "name_en": "Wang Khoi",
        "zip_codes": [
            60220
        ],
        "district_id": 6009
    },
    {
        "id": 600907,
        "name_th": "นาขอม",
        "name_en": "Na Khom",
        "zip_codes": [
            60220
        ],
        "district_id": 6009
    },
    {
        "id": 600908,
        "name_th": "ไพศาลี",
        "name_en": "Phaisali",
        "zip_codes": [
            60220
        ],
        "district_id": 6009
    },
    {
        "id": 601001,
        "name_th": "พยุหะ",
        "name_en": "Phayuha",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601002,
        "name_th": "เนินมะกอก",
        "name_en": "Noen Makok",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601003,
        "name_th": "นิคมเขาบ่อแก้ว",
        "name_en": "Nikhom Khao Bo Kaeo",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601004,
        "name_th": "ม่วงหัก",
        "name_en": "Muang Hak",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601005,
        "name_th": "ยางขาว",
        "name_en": "Yang Khao",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601006,
        "name_th": "ย่านมัทรี",
        "name_en": "Yan Matsi",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601007,
        "name_th": "เขาทอง",
        "name_en": "Khao Thong",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601008,
        "name_th": "ท่าน้ำอ้อย",
        "name_en": "Tha Nam Oi",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601009,
        "name_th": "น้ำทรง",
        "name_en": "Nam Song",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601010,
        "name_th": "เขากะลา",
        "name_en": "Khao Kala",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601011,
        "name_th": "สระทะเล",
        "name_en": "Sa Thale",
        "zip_codes": [
            60130
        ],
        "district_id": 6010
    },
    {
        "id": 601101,
        "name_th": "ลาดยาว",
        "name_en": "Lat Yao",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601102,
        "name_th": "ห้วยน้ำหอม",
        "name_en": "Huai Nam Hom",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601103,
        "name_th": "วังม้า",
        "name_en": "Wang Ma",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601104,
        "name_th": "วังเมือง",
        "name_en": "Wang Mueang",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601105,
        "name_th": "สร้อยละคร",
        "name_en": "Soi Lakhon",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601106,
        "name_th": "มาบแก",
        "name_en": "Map Kae",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601107,
        "name_th": "หนองยาว",
        "name_en": "Nong Yao",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601108,
        "name_th": "หนองนมวัว",
        "name_en": "Nong Nom Wua",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601109,
        "name_th": "บ้านไร่",
        "name_en": "Ban Rai",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601110,
        "name_th": "เนินขี้เหล็ก",
        "name_en": "Noen Khilek",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601116,
        "name_th": "ศาลเจ้าไก่ต่อ",
        "name_en": "San Chao Kai to",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601117,
        "name_th": "สระแก้ว",
        "name_en": "Sa Kaeo",
        "zip_codes": [
            60150
        ],
        "district_id": 6011
    },
    {
        "id": 601201,
        "name_th": "ตากฟ้า",
        "name_en": "Tak Fa",
        "zip_codes": [
            60190
        ],
        "district_id": 6012
    },
    {
        "id": 601202,
        "name_th": "ลำพยนต์",
        "name_en": "Lam Phayon",
        "zip_codes": [
            60190
        ],
        "district_id": 6012
    },
    {
        "id": 601203,
        "name_th": "สุขสำราญ",
        "name_en": "Suk Samran",
        "zip_codes": [
            60190
        ],
        "district_id": 6012
    },
    {
        "id": 601204,
        "name_th": "หนองพิกุล",
        "name_en": "Nong Phikun",
        "zip_codes": [
            60190
        ],
        "district_id": 6012
    },
    {
        "id": 601205,
        "name_th": "พุนกยูง",
        "name_en": "Phu Nok Yung",
        "zip_codes": [
            60190
        ],
        "district_id": 6012
    },
    {
        "id": 601206,
        "name_th": "อุดมธัญญา",
        "name_en": "Udom Thanya",
        "zip_codes": [
            60190
        ],
        "district_id": 6012
    },
    {
        "id": 601207,
        "name_th": "เขาชายธง",
        "name_en": "Khao Chai Thong",
        "zip_codes": [
            60190
        ],
        "district_id": 6012
    },
    {
        "id": 601301,
        "name_th": "แม่วงก์",
        "name_en": "Mae Wong",
        "zip_codes": [
            60150
        ],
        "district_id": 6013
    },
    {
        "id": 601303,
        "name_th": "แม่เล่ย์",
        "name_en": "Mae Le",
        "zip_codes": [
            60150
        ],
        "district_id": 6013
    },
    {
        "id": 601304,
        "name_th": "วังซ่าน",
        "name_en": "Wang San",
        "zip_codes": [
            60150
        ],
        "district_id": 6013
    },
    {
        "id": 601305,
        "name_th": "เขาชนกัน",
        "name_en": "Khao Chon Kan",
        "zip_codes": [
            60150
        ],
        "district_id": 6013
    },
    {
        "id": 601401,
        "name_th": "แม่เปิน",
        "name_en": "Mae Poen",
        "zip_codes": [
            60150
        ],
        "district_id": 6014
    },
    {
        "id": 601501,
        "name_th": "ชุมตาบง",
        "name_en": "Chum Ta Bong",
        "zip_codes": [
            60150
        ],
        "district_id": 6015
    },
    {
        "id": 601502,
        "name_th": "ปางสวรรค์",
        "name_en": "Pang Sawan",
        "zip_codes": [
            60150
        ],
        "district_id": 6015
    },
    {
        "id": 610101,
        "name_th": "อุทัยใหม่",
        "name_en": "Uthai Mai",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610102,
        "name_th": "น้ำซึม",
        "name_en": "Nam Suem",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610103,
        "name_th": "สะแกกรัง",
        "name_en": "Sakae Krang",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610104,
        "name_th": "ดอนขวาง",
        "name_en": "Don Khwang",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610105,
        "name_th": "หาดทนง",
        "name_en": "Hat Thanong",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610106,
        "name_th": "เกาะเทโพ",
        "name_en": "Ko Thepho",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610107,
        "name_th": "ท่าซุง",
        "name_en": "Tha Sung",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610108,
        "name_th": "หนองแก",
        "name_en": "Nong Kae",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610109,
        "name_th": "โนนเหล็ก",
        "name_en": "Non Lek",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610110,
        "name_th": "หนองเต่า",
        "name_en": "Nong Tao",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610111,
        "name_th": "หนองไผ่แบน",
        "name_en": "Nong Phai Baen",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610112,
        "name_th": "หนองพังค่า",
        "name_en": "Nong Phang Kha",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610113,
        "name_th": "ทุ่งใหญ่",
        "name_en": "Thung Yai",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610114,
        "name_th": "เนินแจง",
        "name_en": "Noen Chaeng",
        "zip_codes": [
            61000
        ],
        "district_id": 6101
    },
    {
        "id": 610201,
        "name_th": "ทัพทัน",
        "name_en": "Thap Than",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610202,
        "name_th": "ทุ่งนาไทย",
        "name_en": "Thung Na Thai",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610203,
        "name_th": "เขาขี้ฝอย",
        "name_en": "Khao Khi Foi",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610204,
        "name_th": "หนองหญ้าปล้อง",
        "name_en": "Nong Ya Plong",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610205,
        "name_th": "โคกหม้อ",
        "name_en": "Khok Mo",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610206,
        "name_th": "หนองยายดา",
        "name_en": "Nong Yai Da",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610207,
        "name_th": "หนองกลางดง",
        "name_en": "Nong Klang Dong",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610208,
        "name_th": "หนองกระทุ่ม",
        "name_en": "Nong Krathum",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610209,
        "name_th": "หนองสระ",
        "name_en": "Nong Sa",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610210,
        "name_th": "ตลุกดู่",
        "name_en": "Taluk Du",
        "zip_codes": [
            61120
        ],
        "district_id": 6102
    },
    {
        "id": 610301,
        "name_th": "สว่างอารมณ์",
        "name_en": "Sawang Arom",
        "zip_codes": [
            61150
        ],
        "district_id": 6103
    },
    {
        "id": 610302,
        "name_th": "หนองหลวง",
        "name_en": "Nong Luang",
        "zip_codes": [
            61150
        ],
        "district_id": 6103
    },
    {
        "id": 610303,
        "name_th": "พลวงสองนาง",
        "name_en": "Phluang Song Nang",
        "zip_codes": [
            61150
        ],
        "district_id": 6103
    },
    {
        "id": 610304,
        "name_th": "ไผ่เขียว",
        "name_en": "Phai Khiao",
        "zip_codes": [
            61150
        ],
        "district_id": 6103
    },
    {
        "id": 610305,
        "name_th": "บ่อยาง",
        "name_en": "Bo Yang",
        "zip_codes": [
            61150
        ],
        "district_id": 6103
    },
    {
        "id": 610401,
        "name_th": "หนองฉาง",
        "name_en": "Nong Chang",
        "zip_codes": [
            61110
        ],
        "district_id": 6104
    },
    {
        "id": 610402,
        "name_th": "หนองยาง",
        "name_en": "Nong Yang",
        "zip_codes": [
            61110
        ],
        "district_id": 6104
    },
    {
        "id": 610403,
        "name_th": "หนองนางนวล",
        "name_en": "Nong Nang Nuan",
        "zip_codes": [
            61110
        ],
        "district_id": 6104
    },
    {
        "id": 610404,
        "name_th": "หนองสรวง",
        "name_en": "Nong Suang",
        "zip_codes": [
            61110
        ],
        "district_id": 6104
    },
    {
        "id": 610405,
        "name_th": "บ้านเก่า",
        "name_en": "Ban Kao",
        "zip_codes": [
            61110
        ],
        "district_id": 6104
    },
    {
        "id": 610406,
        "name_th": "อุทัยเก่า",
        "name_en": "Utai Kao",
        "zip_codes": [
            61110
        ],
        "district_id": 6104
    },
    {
        "id": 610407,
        "name_th": "ทุ่งโพ",
        "name_en": "Thung Pho",
        "zip_codes": [
            61110
        ],
        "district_id": 6104
    },
    {
        "id": 610408,
        "name_th": "ทุ่งพง",
        "name_en": "Thung Phong",
        "zip_codes": [
            61110
        ],
        "district_id": 6104
    },
    {
        "id": 610409,
        "name_th": "เขาบางแกรก",
        "name_en": "Khao Bang Kraek",
        "zip_codes": [
            61170
        ],
        "district_id": 6104
    },
    {
        "id": 610410,
        "name_th": "เขากวางทอง",
        "name_en": "Khao Kwang Thong",
        "zip_codes": [
            61110
        ],
        "district_id": 6104
    },
    {
        "id": 610501,
        "name_th": "หนองขาหย่าง",
        "name_en": "Nong Khayang",
        "zip_codes": [
            61130
        ],
        "district_id": 6105
    },
    {
        "id": 610502,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            61130
        ],
        "district_id": 6105
    },
    {
        "id": 610503,
        "name_th": "ดอนกลอย",
        "name_en": "Don Kloi",
        "zip_codes": [
            61130
        ],
        "district_id": 6105
    },
    {
        "id": 610504,
        "name_th": "ห้วยรอบ",
        "name_en": "Huai Rop",
        "zip_codes": [
            61130
        ],
        "district_id": 6105
    },
    {
        "id": 610505,
        "name_th": "ทุ่งพึ่ง",
        "name_en": "Thung Phueng",
        "zip_codes": [
            61130
        ],
        "district_id": 6105
    },
    {
        "id": 610506,
        "name_th": "ท่าโพ",
        "name_en": "Tha Pho",
        "zip_codes": [
            61130
        ],
        "district_id": 6105
    },
    {
        "id": 610507,
        "name_th": "หมกแถว",
        "name_en": "Mok Thaeo",
        "zip_codes": [
            61130
        ],
        "district_id": 6105
    },
    {
        "id": 610508,
        "name_th": "หลุมเข้า",
        "name_en": "Lum Khao",
        "zip_codes": [
            61130
        ],
        "district_id": 6105
    },
    {
        "id": 610509,
        "name_th": "ดงขวาง",
        "name_en": "Dong Khwang",
        "zip_codes": [
            61130
        ],
        "district_id": 6105
    },
    {
        "id": 610601,
        "name_th": "บ้านไร่",
        "name_en": "Ban Rai",
        "zip_codes": [
            61140
        ],
        "district_id": 6106
    },
    {
        "id": 610602,
        "name_th": "ทัพหลวง",
        "name_en": "Thap Luang",
        "zip_codes": [
            61140
        ],
        "district_id": 6106
    },
    {
        "id": 610603,
        "name_th": "ห้วยแห้ง",
        "name_en": "Huai Haeng",
        "zip_codes": [
            61140
        ],
        "district_id": 6106
    },
    {
        "id": 610604,
        "name_th": "คอกควาย",
        "name_en": "Khok Khwai",
        "zip_codes": [
            61140
        ],
        "district_id": 6106
    },
    {
        "id": 610605,
        "name_th": "วังหิน",
        "name_en": "Wang Hin",
        "zip_codes": [
            61180
        ],
        "district_id": 6106
    },
    {
        "id": 610606,
        "name_th": "เมืองการุ้ง",
        "name_en": "Muang Ka Rung",
        "zip_codes": [
            61180
        ],
        "district_id": 6106
    },
    {
        "id": 610607,
        "name_th": "แก่นมะกรูด",
        "name_en": "Kaen Makrut",
        "zip_codes": [
            61140
        ],
        "district_id": 6106
    },
    {
        "id": 610609,
        "name_th": "หนองจอก",
        "name_en": "Nong Chok",
        "zip_codes": [
            61180
        ],
        "district_id": 6106
    },
    {
        "id": 610610,
        "name_th": "หูช้าง",
        "name_en": "Hu Chang",
        "zip_codes": [
            61180
        ],
        "district_id": 6106
    },
    {
        "id": 610611,
        "name_th": "บ้านบึง",
        "name_en": "Ban Bueng",
        "zip_codes": [
            61140
        ],
        "district_id": 6106
    },
    {
        "id": 610612,
        "name_th": "บ้านใหม่คลองเคียน",
        "name_en": "Ban Mai Khlong Khian",
        "zip_codes": [
            61180
        ],
        "district_id": 6106
    },
    {
        "id": 610613,
        "name_th": "หนองบ่มกล้วย",
        "name_en": "Nong Bom Kluai",
        "zip_codes": [
            61180
        ],
        "district_id": 6106
    },
    {
        "id": 610614,
        "name_th": "เจ้าวัด",
        "name_en": "Chao Wat",
        "zip_codes": [
            61140
        ],
        "district_id": 6106
    },
    {
        "id": 610701,
        "name_th": "ลานสัก",
        "name_en": "Lan Sak",
        "zip_codes": [
            61160
        ],
        "district_id": 6107
    },
    {
        "id": 610702,
        "name_th": "ประดู่ยืน",
        "name_en": "Pradu Yuen",
        "zip_codes": [
            61160
        ],
        "district_id": 6107
    },
    {
        "id": 610703,
        "name_th": "ป่าอ้อ",
        "name_en": "Pa O",
        "zip_codes": [
            61160
        ],
        "district_id": 6107
    },
    {
        "id": 610704,
        "name_th": "ระบำ",
        "name_en": "Rabam",
        "zip_codes": [
            61160
        ],
        "district_id": 6107
    },
    {
        "id": 610705,
        "name_th": "น้ำรอบ",
        "name_en": "Nam Rop",
        "zip_codes": [
            61160
        ],
        "district_id": 6107
    },
    {
        "id": 610706,
        "name_th": "ทุ่งนางาม",
        "name_en": "Thung Na Ngam",
        "zip_codes": [
            61160
        ],
        "district_id": 6107
    },
    {
        "id": 610801,
        "name_th": "สุขฤทัย",
        "name_en": "Suk Ruethai",
        "zip_codes": [
            61170
        ],
        "district_id": 6108
    },
    {
        "id": 610802,
        "name_th": "ทองหลาง",
        "name_en": "Thong Lang",
        "zip_codes": [
            61170
        ],
        "district_id": 6108
    },
    {
        "id": 610803,
        "name_th": "ห้วยคต",
        "name_en": "Huai Khot",
        "zip_codes": [
            61170
        ],
        "district_id": 6108
    },
    {
        "id": 620101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620102,
        "name_th": "ไตรตรึงษ์",
        "name_en": "Trai Trueng",
        "zip_codes": [
            62160
        ],
        "district_id": 6201
    },
    {
        "id": 620103,
        "name_th": "อ่างทอง",
        "name_en": "Ang Thong",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620104,
        "name_th": "นาบ่อคำ",
        "name_en": "Na Bo Kham",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620105,
        "name_th": "นครชุม",
        "name_en": "Nakhon Chum",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620106,
        "name_th": "ทรงธรรม",
        "name_en": "Song Tham",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620107,
        "name_th": "ลานดอกไม้",
        "name_en": "Lan Dokmai",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620110,
        "name_th": "หนองปลิง",
        "name_en": "Nong Pling",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620111,
        "name_th": "คณฑี",
        "name_en": "Khonthi",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620112,
        "name_th": "นิคมทุ่งโพธิ์ทะเล",
        "name_en": "Nikhom Thung Pho Thale",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620113,
        "name_th": "เทพนคร",
        "name_en": "Thep Nakhon",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620114,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620115,
        "name_th": "ท่าขุนราม",
        "name_en": "Tha Khun Ram",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620117,
        "name_th": "คลองแม่ลาย",
        "name_en": "Khlong Mae Lai",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620118,
        "name_th": "ธำมรงค์",
        "name_en": "Thammarong",
        "zip_codes": [
            62160
        ],
        "district_id": 6201
    },
    {
        "id": 620119,
        "name_th": "สระแก้ว",
        "name_en": "Sa Kaeo",
        "zip_codes": [
            62000
        ],
        "district_id": 6201
    },
    {
        "id": 620201,
        "name_th": "ไทรงาม",
        "name_en": "Sai Ngam",
        "zip_codes": [
            62150
        ],
        "district_id": 6202
    },
    {
        "id": 620202,
        "name_th": "หนองคล้า",
        "name_en": "Nong Khla",
        "zip_codes": [
            62150
        ],
        "district_id": 6202
    },
    {
        "id": 620203,
        "name_th": "หนองทอง",
        "name_en": "Nong Thong",
        "zip_codes": [
            62150
        ],
        "district_id": 6202
    },
    {
        "id": 620204,
        "name_th": "หนองไม้กอง",
        "name_en": "Nong Mai Kong",
        "zip_codes": [
            62150
        ],
        "district_id": 6202
    },
    {
        "id": 620205,
        "name_th": "มหาชัย",
        "name_en": "Maha Chai",
        "zip_codes": [
            62150
        ],
        "district_id": 6202
    },
    {
        "id": 620206,
        "name_th": "พานทอง",
        "name_en": "Phan Thong",
        "zip_codes": [
            62150
        ],
        "district_id": 6202
    },
    {
        "id": 620207,
        "name_th": "หนองแม่แตง",
        "name_en": "Nong Mae Taeng",
        "zip_codes": [
            62150
        ],
        "district_id": 6202
    },
    {
        "id": 620301,
        "name_th": "คลองน้ำไหล",
        "name_en": "Khlong Nam Lai",
        "zip_codes": [
            62180
        ],
        "district_id": 6203
    },
    {
        "id": 620302,
        "name_th": "โป่งน้ำร้อน",
        "name_en": "Pong Nam Ron",
        "zip_codes": [
            62180
        ],
        "district_id": 6203
    },
    {
        "id": 620303,
        "name_th": "คลองลานพัฒนา",
        "name_en": "Khlong Lan Phatthana",
        "zip_codes": [
            62180
        ],
        "district_id": 6203
    },
    {
        "id": 620304,
        "name_th": "สักงาม",
        "name_en": "Sak Ngam",
        "zip_codes": [
            62180
        ],
        "district_id": 6203
    },
    {
        "id": 620403,
        "name_th": "ยางสูง",
        "name_en": "Yang Sung",
        "zip_codes": [
            62130
        ],
        "district_id": 6204
    },
    {
        "id": 620404,
        "name_th": "ป่าพุทรา",
        "name_en": "Pa Phutsa",
        "zip_codes": [
            62130
        ],
        "district_id": 6204
    },
    {
        "id": 620405,
        "name_th": "แสนตอ",
        "name_en": "Saen To",
        "zip_codes": [
            62130
        ],
        "district_id": 6204
    },
    {
        "id": 620406,
        "name_th": "สลกบาตร",
        "name_en": "Salokbat",
        "zip_codes": [
            62140
        ],
        "district_id": 6204
    },
    {
        "id": 620407,
        "name_th": "บ่อถ้ำ",
        "name_en": "Bo Tham",
        "zip_codes": [
            62140
        ],
        "district_id": 6204
    },
    {
        "id": 620408,
        "name_th": "ดอนแตง",
        "name_en": "Don Taeng",
        "zip_codes": [
            62140
        ],
        "district_id": 6204
    },
    {
        "id": 620409,
        "name_th": "วังชะพลู",
        "name_en": "Wang Chaphlu",
        "zip_codes": [
            62140
        ],
        "district_id": 6204
    },
    {
        "id": 620410,
        "name_th": "โค้งไผ่",
        "name_en": "Khong Phai",
        "zip_codes": [
            62140
        ],
        "district_id": 6204
    },
    {
        "id": 620411,
        "name_th": "ปางมะค่า",
        "name_en": "Pang Makha",
        "zip_codes": [
            62140
        ],
        "district_id": 6204
    },
    {
        "id": 620412,
        "name_th": "วังหามแห",
        "name_en": "Wang Ham Hae",
        "zip_codes": [
            62140
        ],
        "district_id": 6204
    },
    {
        "id": 620413,
        "name_th": "เกาะตาล",
        "name_en": "Ko Tan",
        "zip_codes": [
            62130
        ],
        "district_id": 6204
    },
    {
        "id": 620501,
        "name_th": "คลองขลุง",
        "name_en": "Khlong Khlung",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620502,
        "name_th": "ท่ามะเขือ",
        "name_en": "Tha Makhuea",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620504,
        "name_th": "ท่าพุทรา",
        "name_en": "Tha Phutsa",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620505,
        "name_th": "แม่ลาด",
        "name_en": "Mae Lat",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620506,
        "name_th": "วังยาง",
        "name_en": "Wang Yang",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620507,
        "name_th": "วังแขม",
        "name_en": "Wang Khaem",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620508,
        "name_th": "หัวถนน",
        "name_en": "Hua Thanon",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620509,
        "name_th": "วังไทร",
        "name_en": "Wang Sai",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620513,
        "name_th": "วังบัว",
        "name_en": "Wang Bua",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620516,
        "name_th": "คลองสมบูรณ์",
        "name_en": "Khlong Sombun",
        "zip_codes": [
            62120
        ],
        "district_id": 6205
    },
    {
        "id": 620601,
        "name_th": "พรานกระต่าย",
        "name_en": "Phran Kratai",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620602,
        "name_th": "หนองหัววัว",
        "name_en": "Nong Hua Wua",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620603,
        "name_th": "ท่าไม้",
        "name_en": "Tha Mai",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620604,
        "name_th": "วังควง",
        "name_en": "Wang Khuang",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620605,
        "name_th": "วังตะแบก",
        "name_en": "Wang Tabaek",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620606,
        "name_th": "เขาคีริส",
        "name_en": "Khao Khirit",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620607,
        "name_th": "คุยบ้านโอง",
        "name_en": "Khui Ban Ong",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620608,
        "name_th": "คลองพิไกร",
        "name_en": "Khlong Phikrai",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620609,
        "name_th": "ถ้ำกระต่ายทอง",
        "name_en": "Tham Kratai Thong",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620610,
        "name_th": "ห้วยยั้ง",
        "name_en": "Huai Yang",
        "zip_codes": [
            62110
        ],
        "district_id": 6206
    },
    {
        "id": 620701,
        "name_th": "ลานกระบือ",
        "name_en": "Lan Krabue",
        "zip_codes": [
            62170
        ],
        "district_id": 6207
    },
    {
        "id": 620702,
        "name_th": "ช่องลม",
        "name_en": "Chong Lom",
        "zip_codes": [
            62170
        ],
        "district_id": 6207
    },
    {
        "id": 620703,
        "name_th": "หนองหลวง",
        "name_en": "Nong Luang",
        "zip_codes": [
            62170
        ],
        "district_id": 6207
    },
    {
        "id": 620704,
        "name_th": "โนนพลวง",
        "name_en": "Non Phluang",
        "zip_codes": [
            62170
        ],
        "district_id": 6207
    },
    {
        "id": 620705,
        "name_th": "ประชาสุขสันต์",
        "name_en": "Pracha Suk San",
        "zip_codes": [
            62170
        ],
        "district_id": 6207
    },
    {
        "id": 620706,
        "name_th": "บึงทับแรต",
        "name_en": "Bueng Thap Raet",
        "zip_codes": [
            62170
        ],
        "district_id": 6207
    },
    {
        "id": 620707,
        "name_th": "จันทิมา",
        "name_en": "Chanthima",
        "zip_codes": [
            62170
        ],
        "district_id": 6207
    },
    {
        "id": 620801,
        "name_th": "ทุ่งทราย",
        "name_en": "Thung Sai",
        "zip_codes": [
            62190
        ],
        "district_id": 6208
    },
    {
        "id": 620802,
        "name_th": "ทุ่งทอง",
        "name_en": "Thung Thong",
        "zip_codes": [
            62190
        ],
        "district_id": 6208
    },
    {
        "id": 620803,
        "name_th": "ถาวรวัฒนา",
        "name_en": "Thawon Watthana",
        "zip_codes": [
            62190
        ],
        "district_id": 6208
    },
    {
        "id": 620901,
        "name_th": "โพธิ์ทอง",
        "name_en": "Pho Thong",
        "zip_codes": [
            62120
        ],
        "district_id": 6209
    },
    {
        "id": 620902,
        "name_th": "หินดาต",
        "name_en": "Hin Dat",
        "zip_codes": [
            62120
        ],
        "district_id": 6209
    },
    {
        "id": 620903,
        "name_th": "ปางตาไว",
        "name_en": "Pang Ta Wai",
        "zip_codes": [
            62120
        ],
        "district_id": 6209
    },
    {
        "id": 621001,
        "name_th": "บึงสามัคคี",
        "name_en": "Bueng Samakkhi",
        "zip_codes": [
            62210
        ],
        "district_id": 6210
    },
    {
        "id": 621002,
        "name_th": "วังชะโอน",
        "name_en": "Wang Cha-on",
        "zip_codes": [
            62210
        ],
        "district_id": 6210
    },
    {
        "id": 621003,
        "name_th": "ระหาน",
        "name_en": "Rahan",
        "zip_codes": [
            62210
        ],
        "district_id": 6210
    },
    {
        "id": 621004,
        "name_th": "เทพนิมิต",
        "name_en": "Thep Nimit",
        "zip_codes": [
            62210
        ],
        "district_id": 6210
    },
    {
        "id": 621101,
        "name_th": "โกสัมพี",
        "name_en": "Kosamphi",
        "zip_codes": [
            62000
        ],
        "district_id": 6211
    },
    {
        "id": 621102,
        "name_th": "เพชรชมภู",
        "name_en": "Phet Chomphu",
        "zip_codes": [
            62000
        ],
        "district_id": 6211
    },
    {
        "id": 621103,
        "name_th": "ลานดอกไม้ตก",
        "name_en": "Lan Dokmai Tok",
        "zip_codes": [
            62000
        ],
        "district_id": 6211
    },
    {
        "id": 630101,
        "name_th": "ระแหง",
        "name_en": "Rahaeng",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630102,
        "name_th": "หนองหลวง",
        "name_en": "Nong Luang",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630103,
        "name_th": "เชียงเงิน",
        "name_en": "Chiang Ngoen",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630104,
        "name_th": "หัวเดียด",
        "name_en": "Hua Diat",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630105,
        "name_th": "หนองบัวเหนือ",
        "name_en": "Nong Bua Nuea",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630106,
        "name_th": "ไม้งาม",
        "name_en": "Mai Ngam",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630107,
        "name_th": "โป่งแดง",
        "name_en": "Pong Daeng",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630108,
        "name_th": "น้ำรึม",
        "name_en": "Nam Ruem",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630109,
        "name_th": "วังหิน",
        "name_en": "Wang Hin",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630111,
        "name_th": "แม่ท้อ",
        "name_en": "Mae Tho",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630112,
        "name_th": "ป่ามะม่วง",
        "name_en": "Pa Mamuang",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630113,
        "name_th": "หนองบัวใต้",
        "name_en": "Nong Bua Tai",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630114,
        "name_th": "วังประจบ",
        "name_en": "Wang Prachop",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630115,
        "name_th": "ตลุกกลางทุ่ง",
        "name_en": "Taluk Klang Thung",
        "zip_codes": [
            63000
        ],
        "district_id": 6301
    },
    {
        "id": 630201,
        "name_th": "ตากออก",
        "name_en": "Tak Ok",
        "zip_codes": [
            63120
        ],
        "district_id": 6302
    },
    {
        "id": 630202,
        "name_th": "สมอโคน",
        "name_en": "Samo Khon",
        "zip_codes": [
            63120
        ],
        "district_id": 6302
    },
    {
        "id": 630203,
        "name_th": "แม่สลิด",
        "name_en": "Mae Salit",
        "zip_codes": [
            63120
        ],
        "district_id": 6302
    },
    {
        "id": 630204,
        "name_th": "ตากตก",
        "name_en": "Tak Tok",
        "zip_codes": [
            63120
        ],
        "district_id": 6302
    },
    {
        "id": 630205,
        "name_th": "เกาะตะเภา",
        "name_en": "Ko Taphao",
        "zip_codes": [
            63120
        ],
        "district_id": 6302
    },
    {
        "id": 630206,
        "name_th": "ทุ่งกระเชาะ",
        "name_en": "Thung Kracho",
        "zip_codes": [
            63120
        ],
        "district_id": 6302
    },
    {
        "id": 630207,
        "name_th": "ท้องฟ้า",
        "name_en": "Thong Fa",
        "zip_codes": [
            63120
        ],
        "district_id": 6302
    },
    {
        "id": 630301,
        "name_th": "สามเงา",
        "name_en": "Sam Ngao",
        "zip_codes": [
            63130
        ],
        "district_id": 6303
    },
    {
        "id": 630302,
        "name_th": "วังหมัน",
        "name_en": "Wang Man",
        "zip_codes": [
            63130
        ],
        "district_id": 6303
    },
    {
        "id": 630303,
        "name_th": "ยกกระบัตร",
        "name_en": "Yokkrabat",
        "zip_codes": [
            63130
        ],
        "district_id": 6303
    },
    {
        "id": 630304,
        "name_th": "ย่านรี",
        "name_en": "Yan Ri",
        "zip_codes": [
            63130
        ],
        "district_id": 6303
    },
    {
        "id": 630305,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            63130
        ],
        "district_id": 6303
    },
    {
        "id": 630306,
        "name_th": "วังจันทร์",
        "name_en": "Wang Chan",
        "zip_codes": [
            63130
        ],
        "district_id": 6303
    },
    {
        "id": 630401,
        "name_th": "แม่ระมาด",
        "name_en": "Mae Ramat",
        "zip_codes": [
            63140
        ],
        "district_id": 6304
    },
    {
        "id": 630402,
        "name_th": "แม่จะเรา",
        "name_en": "Mae Charao",
        "zip_codes": [
            63140
        ],
        "district_id": 6304
    },
    {
        "id": 630403,
        "name_th": "ขะเนจื้อ",
        "name_en": "Khane Chue",
        "zip_codes": [
            63140
        ],
        "district_id": 6304
    },
    {
        "id": 630404,
        "name_th": "แม่ตื่น",
        "name_en": "Mae Tuen",
        "zip_codes": [
            63140
        ],
        "district_id": 6304
    },
    {
        "id": 630405,
        "name_th": "สามหมื่น",
        "name_en": "Sam Muen",
        "zip_codes": [
            63140
        ],
        "district_id": 6304
    },
    {
        "id": 630406,
        "name_th": "พระธาตุ",
        "name_en": "Phra That",
        "zip_codes": [
            63140
        ],
        "district_id": 6304
    },
    {
        "id": 630501,
        "name_th": "ท่าสองยาง",
        "name_en": "Tha Song Yang",
        "zip_codes": [
            63150
        ],
        "district_id": 6305
    },
    {
        "id": 630502,
        "name_th": "แม่ต้าน",
        "name_en": "Mae Tan",
        "zip_codes": [
            63150
        ],
        "district_id": 6305
    },
    {
        "id": 630503,
        "name_th": "แม่สอง",
        "name_en": "Mae Song",
        "zip_codes": [
            63150
        ],
        "district_id": 6305
    },
    {
        "id": 630504,
        "name_th": "แม่หละ",
        "name_en": "Mae La",
        "zip_codes": [
            63150
        ],
        "district_id": 6305
    },
    {
        "id": 630505,
        "name_th": "แม่วะหลวง",
        "name_en": "Mae Wa Luang",
        "zip_codes": [
            63150
        ],
        "district_id": 6305
    },
    {
        "id": 630506,
        "name_th": "แม่อุสุ",
        "name_en": "Mae U-su",
        "zip_codes": [
            63150
        ],
        "district_id": 6305
    },
    {
        "id": 630601,
        "name_th": "แม่สอด",
        "name_en": "Mae Sot",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630602,
        "name_th": "แม่กุ",
        "name_en": "Mae Ku",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630603,
        "name_th": "พะวอ",
        "name_en": "Phawo",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630604,
        "name_th": "แม่ตาว",
        "name_en": "Mae Tao",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630605,
        "name_th": "แม่กาษา",
        "name_en": "Mae Kasa",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630606,
        "name_th": "ท่าสายลวด",
        "name_en": "Tha Sai Luat",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630607,
        "name_th": "แม่ปะ",
        "name_en": "Mae Pa",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630608,
        "name_th": "มหาวัน",
        "name_en": "Maha Wan",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630609,
        "name_th": "ด่านแม่ละเมา",
        "name_en": "Dan Mae Lamao",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630610,
        "name_th": "พระธาตุผาแดง",
        "name_en": "Phra That Pha Daeng",
        "zip_codes": [
            63110
        ],
        "district_id": 6306
    },
    {
        "id": 630701,
        "name_th": "พบพระ",
        "name_en": "Phop Phra",
        "zip_codes": [
            63160
        ],
        "district_id": 6307
    },
    {
        "id": 630702,
        "name_th": "ช่องแคบ",
        "name_en": "Chong Khaep",
        "zip_codes": [
            63160
        ],
        "district_id": 6307
    },
    {
        "id": 630703,
        "name_th": "คีรีราษฎร์",
        "name_en": "Khiri Rat",
        "zip_codes": [
            63160
        ],
        "district_id": 6307
    },
    {
        "id": 630704,
        "name_th": "วาเล่ย์",
        "name_en": "Wale",
        "zip_codes": [
            63160
        ],
        "district_id": 6307
    },
    {
        "id": 630705,
        "name_th": "รวมไทยพัฒนา",
        "name_en": "Ruam Thai Phatthana",
        "zip_codes": [
            63160
        ],
        "district_id": 6307
    },
    {
        "id": 630801,
        "name_th": "อุ้มผาง",
        "name_en": "Umphang",
        "zip_codes": [
            63170
        ],
        "district_id": 6308
    },
    {
        "id": 630802,
        "name_th": "หนองหลวง",
        "name_en": "Nong Luang",
        "zip_codes": [
            63170
        ],
        "district_id": 6308
    },
    {
        "id": 630803,
        "name_th": "โมโกร",
        "name_en": "Mokro",
        "zip_codes": [
            63170
        ],
        "district_id": 6308
    },
    {
        "id": 630804,
        "name_th": "แม่จัน",
        "name_en": "Mae Chan",
        "zip_codes": [
            63170
        ],
        "district_id": 6308
    },
    {
        "id": 630805,
        "name_th": "แม่ละมุ้ง",
        "name_en": "Mae Lamung",
        "zip_codes": [
            63170
        ],
        "district_id": 6308
    },
    {
        "id": 630806,
        "name_th": "แม่กลอง",
        "name_en": "Mae Klong",
        "zip_codes": [
            63170
        ],
        "district_id": 6308
    },
    {
        "id": 630901,
        "name_th": "เชียงทอง",
        "name_en": "Chiang Thong",
        "zip_codes": [
            63180
        ],
        "district_id": 6309
    },
    {
        "id": 630902,
        "name_th": "นาโบสถ์",
        "name_en": "Na Bot",
        "zip_codes": [
            63180
        ],
        "district_id": 6309
    },
    {
        "id": 630903,
        "name_th": "ประดาง",
        "name_en": "Pradang",
        "zip_codes": [
            63180
        ],
        "district_id": 6309
    },
    {
        "id": 640101,
        "name_th": "ธานี",
        "name_en": "Thani",
        "zip_codes": [
            64000
        ],
        "district_id": 6401
    },
    {
        "id": 640102,
        "name_th": "บ้านสวน",
        "name_en": "Ban Suan",
        "zip_codes": [
            64220
        ],
        "district_id": 6401
    },
    {
        "id": 640103,
        "name_th": "เมืองเก่า",
        "name_en": "Mueang Kao",
        "zip_codes": [
            64210
        ],
        "district_id": 6401
    },
    {
        "id": 640104,
        "name_th": "ปากแคว",
        "name_en": "Pak Khwae",
        "zip_codes": [
            64000
        ],
        "district_id": 6401
    },
    {
        "id": 640105,
        "name_th": "ยางซ้าย",
        "name_en": "Yang Sai",
        "zip_codes": [
            64000
        ],
        "district_id": 6401
    },
    {
        "id": 640106,
        "name_th": "บ้านกล้วย",
        "name_en": "Ban Kluai",
        "zip_codes": [
            64000,
            64210
        ],
        "district_id": 6401
    },
    {
        "id": 640107,
        "name_th": "บ้านหลุม",
        "name_en": "Ban Lum",
        "zip_codes": [
            64000
        ],
        "district_id": 6401
    },
    {
        "id": 640108,
        "name_th": "ตาลเตี้ย",
        "name_en": "Tan Tia",
        "zip_codes": [
            64220
        ],
        "district_id": 6401
    },
    {
        "id": 640109,
        "name_th": "ปากพระ",
        "name_en": "Pak Phra",
        "zip_codes": [
            64000
        ],
        "district_id": 6401
    },
    {
        "id": 640110,
        "name_th": "วังทองแดง",
        "name_en": "Wang Thong Daeng",
        "zip_codes": [
            64210
        ],
        "district_id": 6401
    },
    {
        "id": 640201,
        "name_th": "ลานหอย",
        "name_en": "Lan Hoi",
        "zip_codes": [
            64140
        ],
        "district_id": 6402
    },
    {
        "id": 640202,
        "name_th": "บ้านด่าน",
        "name_en": "Ban Dan",
        "zip_codes": [
            64140
        ],
        "district_id": 6402
    },
    {
        "id": 640203,
        "name_th": "วังตะคร้อ",
        "name_en": "Wang Takhro",
        "zip_codes": [
            64140
        ],
        "district_id": 6402
    },
    {
        "id": 640204,
        "name_th": "วังน้ำขาว",
        "name_en": "Wang Nam Khao",
        "zip_codes": [
            64140
        ],
        "district_id": 6402
    },
    {
        "id": 640205,
        "name_th": "ตลิ่งชัน",
        "name_en": "Taling Chan",
        "zip_codes": [
            64140
        ],
        "district_id": 6402
    },
    {
        "id": 640206,
        "name_th": "หนองหญ้าปล้อง",
        "name_en": "Nong Ya Plong",
        "zip_codes": [
            64140
        ],
        "district_id": 6402
    },
    {
        "id": 640207,
        "name_th": "วังลึก",
        "name_en": "Wang Luek",
        "zip_codes": [
            64140
        ],
        "district_id": 6402
    },
    {
        "id": 640301,
        "name_th": "โตนด",
        "name_en": "Tanot",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640302,
        "name_th": "ทุ่งหลวง",
        "name_en": "Thung Luang",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640303,
        "name_th": "บ้านป้อม",
        "name_en": "Ban Pom",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640304,
        "name_th": "สามพวง",
        "name_en": "Sam Phuang",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640305,
        "name_th": "ศรีคีรีมาศ",
        "name_en": "Si Khiri Mat",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640306,
        "name_th": "หนองจิก",
        "name_en": "Nong Chik",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640307,
        "name_th": "นาเชิงคีรี",
        "name_en": "Na Choeng Khiri",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640308,
        "name_th": "หนองกระดิ่ง",
        "name_en": "Nong Krading",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640309,
        "name_th": "บ้านน้ำพุ",
        "name_en": "Ban Nam Phu",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640310,
        "name_th": "ทุ่งยางเมือง",
        "name_en": "Thung Yang Mueang",
        "zip_codes": [
            64160
        ],
        "district_id": 6403
    },
    {
        "id": 640401,
        "name_th": "กง",
        "name_en": "Kong",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640402,
        "name_th": "บ้านกร่าง",
        "name_en": "Ban Krang",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640403,
        "name_th": "ไกรนอก",
        "name_en": "Krai Nok",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640404,
        "name_th": "ไกรกลาง",
        "name_en": "Krai Klang",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640405,
        "name_th": "ไกรใน",
        "name_en": "Krai Nai",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640406,
        "name_th": "ดงเดือย",
        "name_en": "Dong Dueai",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640407,
        "name_th": "ป่าแฝก",
        "name_en": "Pa Faek",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640408,
        "name_th": "กกแรต",
        "name_en": "Kok Raet",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640409,
        "name_th": "ท่าฉนวน",
        "name_en": "Tha Chanuan",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640410,
        "name_th": "หนองตูม",
        "name_en": "Nong Tum",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640411,
        "name_th": "บ้านใหม่สุขเกษม",
        "name_en": "Ban Mai Suk Kasem",
        "zip_codes": [
            64170
        ],
        "district_id": 6404
    },
    {
        "id": 640501,
        "name_th": "หาดเสี้ยว",
        "name_en": "Hat Siao",
        "zip_codes": [
            64130
        ],
        "district_id": 6405
    },
    {
        "id": 640502,
        "name_th": "ป่างิ้ว",
        "name_en": "Pa Ngio",
        "zip_codes": [
            64130
        ],
        "district_id": 6405
    },
    {
        "id": 640503,
        "name_th": "แม่สำ",
        "name_en": "Mae Sam",
        "zip_codes": [
            64130
        ],
        "district_id": 6405
    },
    {
        "id": 640504,
        "name_th": "แม่สิน",
        "name_en": "Mae Sin",
        "zip_codes": [
            64130
        ],
        "district_id": 6405
    },
    {
        "id": 640505,
        "name_th": "บ้านตึก",
        "name_en": "Ban Tuek",
        "zip_codes": [
            64130
        ],
        "district_id": 6405
    },
    {
        "id": 640506,
        "name_th": "หนองอ้อ",
        "name_en": "Nong O",
        "zip_codes": [
            64130
        ],
        "district_id": 6405
    },
    {
        "id": 640507,
        "name_th": "ท่าชัย",
        "name_en": "Tha Chai",
        "zip_codes": [
            64190
        ],
        "district_id": 6405
    },
    {
        "id": 640508,
        "name_th": "ศรีสัชนาลัย",
        "name_en": "Si Satchanalai",
        "zip_codes": [
            64190
        ],
        "district_id": 6405
    },
    {
        "id": 640509,
        "name_th": "ดงคู่",
        "name_en": "Dong Khu",
        "zip_codes": [
            64130
        ],
        "district_id": 6405
    },
    {
        "id": 640510,
        "name_th": "บ้านแก่ง",
        "name_en": "Ban Kaeng",
        "zip_codes": [
            64130
        ],
        "district_id": 6405
    },
    {
        "id": 640511,
        "name_th": "สารจิตร",
        "name_en": "San Chit",
        "zip_codes": [
            64130
        ],
        "district_id": 6405
    },
    {
        "id": 640601,
        "name_th": "คลองตาล",
        "name_en": "Khlong Tan",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640602,
        "name_th": "วังลึก",
        "name_en": "Wang Luek",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640603,
        "name_th": "สามเรือน",
        "name_en": "Sam Ruean",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640604,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640605,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640606,
        "name_th": "นาขุนไกร",
        "name_en": "Na Khun Krai",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640607,
        "name_th": "เกาะตาเลี้ยง",
        "name_en": "Ko Ta Liang",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640608,
        "name_th": "วัดเกาะ",
        "name_en": "Wat Ko",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640609,
        "name_th": "บ้านไร่",
        "name_en": "Ban Rai",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640610,
        "name_th": "ทับผึ้ง",
        "name_en": "Thap Phueng",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640611,
        "name_th": "บ้านซ่าน",
        "name_en": "Ban San",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640612,
        "name_th": "วังใหญ่",
        "name_en": "Wang Yai",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640613,
        "name_th": "ราวต้นจันทร์",
        "name_en": "Rao Ton Chan",
        "zip_codes": [
            64120
        ],
        "district_id": 6406
    },
    {
        "id": 640701,
        "name_th": "เมืองสวรรคโลก",
        "name_en": "Mueang Sawankhalok",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640702,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640703,
        "name_th": "คลองกระจง",
        "name_en": "Khlong Krachong",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640704,
        "name_th": "วังพิณพาทย์",
        "name_en": "Wang Phinphat",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640705,
        "name_th": "วังไม้ขอน",
        "name_en": "Wang Mai Khon",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640706,
        "name_th": "ย่านยาว",
        "name_en": "Yan Yao",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640707,
        "name_th": "นาทุ่ง",
        "name_en": "Na Thung",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640708,
        "name_th": "คลองยาง",
        "name_en": "Khlong Yang",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640709,
        "name_th": "เมืองบางยม",
        "name_en": "Mueang Bang Yom",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640710,
        "name_th": "ท่าทอง",
        "name_en": "Tha Tong",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640711,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640712,
        "name_th": "ป่ากุมเกาะ",
        "name_en": "Pa Kum Ko",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640713,
        "name_th": "เมืองบางขลัง",
        "name_en": "Mueang Bang Khlang",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640714,
        "name_th": "หนองกลับ",
        "name_en": "Nong Klap",
        "zip_codes": [
            64110
        ],
        "district_id": 6407
    },
    {
        "id": 640801,
        "name_th": "ศรีนคร",
        "name_en": "Si Nakhon",
        "zip_codes": [
            64180
        ],
        "district_id": 6408
    },
    {
        "id": 640802,
        "name_th": "นครเดิฐ",
        "name_en": "Nakhon Doet",
        "zip_codes": [
            64180
        ],
        "district_id": 6408
    },
    {
        "id": 640803,
        "name_th": "น้ำขุม",
        "name_en": "Nam Khum",
        "zip_codes": [
            64180
        ],
        "district_id": 6408
    },
    {
        "id": 640804,
        "name_th": "คลองมะพลับ",
        "name_en": "Khlong Maphlap",
        "zip_codes": [
            64180
        ],
        "district_id": 6408
    },
    {
        "id": 640805,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            64180
        ],
        "district_id": 6408
    },
    {
        "id": 640901,
        "name_th": "บ้านใหม่ไชยมงคล",
        "name_en": "Ban Mai Chai Mongkhon",
        "zip_codes": [
            64230
        ],
        "district_id": 6409
    },
    {
        "id": 640902,
        "name_th": "ไทยชนะศึก",
        "name_en": "Thai Chana Suek",
        "zip_codes": [
            64150
        ],
        "district_id": 6409
    },
    {
        "id": 640903,
        "name_th": "ทุ่งเสลี่ยม",
        "name_en": "Thung Saliam",
        "zip_codes": [
            64150
        ],
        "district_id": 6409
    },
    {
        "id": 640904,
        "name_th": "กลางดง",
        "name_en": "Klang Dong",
        "zip_codes": [
            64150
        ],
        "district_id": 6409
    },
    {
        "id": 640905,
        "name_th": "เขาแก้วศรีสมบูรณ์",
        "name_en": "Khao Kaeo Si Sombun",
        "zip_codes": [
            64230
        ],
        "district_id": 6409
    },
    {
        "id": 650101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650102,
        "name_th": "วังน้ำคู้",
        "name_en": "Wang Nam Khu",
        "zip_codes": [
            65230
        ],
        "district_id": 6501
    },
    {
        "id": 650103,
        "name_th": "วัดจันทร์",
        "name_en": "Wat Chan",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650104,
        "name_th": "วัดพริก",
        "name_en": "Wat Phrik",
        "zip_codes": [
            65230
        ],
        "district_id": 6501
    },
    {
        "id": 650105,
        "name_th": "ท่าทอง",
        "name_en": "Tha Thong",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650106,
        "name_th": "ท่าโพธิ์",
        "name_en": "Tha Pho",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650107,
        "name_th": "สมอแข",
        "name_en": "Samo Khae",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650108,
        "name_th": "ดอนทอง",
        "name_en": "Don Thong",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650109,
        "name_th": "บ้านป่า",
        "name_en": "Ban Pa",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650110,
        "name_th": "ปากโทก",
        "name_en": "Pak Thok",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650111,
        "name_th": "หัวรอ",
        "name_en": "Hua Ro",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650112,
        "name_th": "จอมทอง",
        "name_en": "Chom Thong",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650113,
        "name_th": "บ้านกร่าง",
        "name_en": "Ban Krang",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650114,
        "name_th": "บ้านคลอง",
        "name_en": "Ban Khlong",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650115,
        "name_th": "พลายชุมพล",
        "name_en": "Phlai Chumphon",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650116,
        "name_th": "มะขามสูง",
        "name_en": "Makham Sung",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650117,
        "name_th": "อรัญญิก",
        "name_en": "Aranyik",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650118,
        "name_th": "บึงพระ",
        "name_en": "Bueng Phra",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650119,
        "name_th": "ไผ่ขอดอน",
        "name_en": "Phai Kho Don",
        "zip_codes": [
            65000
        ],
        "district_id": 6501
    },
    {
        "id": 650120,
        "name_th": "งิ้วงาม",
        "name_en": "Ngio Ngam",
        "zip_codes": [
            65230
        ],
        "district_id": 6501
    },
    {
        "id": 650201,
        "name_th": "นครไทย",
        "name_en": "Nakhon Thai",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650202,
        "name_th": "หนองกะท้าว",
        "name_en": "Nong Kathao",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650203,
        "name_th": "บ้านแยง",
        "name_en": "Ban Yaeng",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650204,
        "name_th": "เนินเพิ่ม",
        "name_en": "Noen Phoem",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650205,
        "name_th": "นาบัว",
        "name_en": "Na Bua",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650206,
        "name_th": "นครชุม",
        "name_en": "Nakhon Chum",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650207,
        "name_th": "น้ำกุ่ม",
        "name_en": "Nam Kum",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650208,
        "name_th": "ยางโกลน",
        "name_en": "Yang Klon",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650209,
        "name_th": "บ่อโพธิ์",
        "name_en": "Bo Pho",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650210,
        "name_th": "บ้านพร้าว",
        "name_en": "Ban Phrao",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650211,
        "name_th": "ห้วยเฮี้ย",
        "name_en": "Huai Hia",
        "zip_codes": [
            65120
        ],
        "district_id": 6502
    },
    {
        "id": 650301,
        "name_th": "ป่าแดง",
        "name_en": "Pa Daeng",
        "zip_codes": [
            65170
        ],
        "district_id": 6503
    },
    {
        "id": 650302,
        "name_th": "ชาติตระการ",
        "name_en": "Chat Trakan",
        "zip_codes": [
            65170
        ],
        "district_id": 6503
    },
    {
        "id": 650303,
        "name_th": "สวนเมี่ยง",
        "name_en": "Suan Miang",
        "zip_codes": [
            65170
        ],
        "district_id": 6503
    },
    {
        "id": 650304,
        "name_th": "บ้านดง",
        "name_en": "Ban Dong",
        "zip_codes": [
            65170
        ],
        "district_id": 6503
    },
    {
        "id": 650305,
        "name_th": "บ่อภาค",
        "name_en": "Bo Phak",
        "zip_codes": [
            65170
        ],
        "district_id": 6503
    },
    {
        "id": 650306,
        "name_th": "ท่าสะแก",
        "name_en": "Tha Sakae",
        "zip_codes": [
            65170
        ],
        "district_id": 6503
    },
    {
        "id": 650401,
        "name_th": "บางระกำ",
        "name_en": "Bang Rakam",
        "zip_codes": [
            65140
        ],
        "district_id": 6504
    },
    {
        "id": 650402,
        "name_th": "ปลักแรด",
        "name_en": "Plak Raet",
        "zip_codes": [
            65140
        ],
        "district_id": 6504
    },
    {
        "id": 650403,
        "name_th": "พันเสา",
        "name_en": "Phan Sao",
        "zip_codes": [
            65140
        ],
        "district_id": 6504
    },
    {
        "id": 650404,
        "name_th": "วังอิทก",
        "name_en": "Wang Ithok",
        "zip_codes": [
            65140
        ],
        "district_id": 6504
    },
    {
        "id": 650405,
        "name_th": "บึงกอก",
        "name_en": "Bueng Kok",
        "zip_codes": [
            65140
        ],
        "district_id": 6504
    },
    {
        "id": 650406,
        "name_th": "หนองกุลา",
        "name_en": "Nong Kula",
        "zip_codes": [
            65140
        ],
        "district_id": 6504
    },
    {
        "id": 650407,
        "name_th": "ชุมแสงสงคราม",
        "name_en": "Chum Saeng Songkhram",
        "zip_codes": [
            65240
        ],
        "district_id": 6504
    },
    {
        "id": 650408,
        "name_th": "นิคมพัฒนา",
        "name_en": "Nikhom Phatthana",
        "zip_codes": [
            65140
        ],
        "district_id": 6504
    },
    {
        "id": 650409,
        "name_th": "บ่อทอง",
        "name_en": "Bo Thong",
        "zip_codes": [
            65140
        ],
        "district_id": 6504
    },
    {
        "id": 650410,
        "name_th": "ท่านางงาม",
        "name_en": "Tha Nang Ngam",
        "zip_codes": [
            65140
        ],
        "district_id": 6504
    },
    {
        "id": 650411,
        "name_th": "คุยม่วง",
        "name_en": "Khui Muang",
        "zip_codes": [
            65240
        ],
        "district_id": 6504
    },
    {
        "id": 650501,
        "name_th": "บางกระทุ่ม",
        "name_en": "Bang Krathum",
        "zip_codes": [
            65110
        ],
        "district_id": 6505
    },
    {
        "id": 650502,
        "name_th": "บ้านไร่",
        "name_en": "Ban Rai",
        "zip_codes": [
            65110
        ],
        "district_id": 6505
    },
    {
        "id": 650503,
        "name_th": "โคกสลุด",
        "name_en": "Khok Salut",
        "zip_codes": [
            65110
        ],
        "district_id": 6505
    },
    {
        "id": 650504,
        "name_th": "สนามคลี",
        "name_en": "Sanam Khli",
        "zip_codes": [
            65110
        ],
        "district_id": 6505
    },
    {
        "id": 650505,
        "name_th": "ท่าตาล",
        "name_en": "Tha Tan",
        "zip_codes": [
            65110
        ],
        "district_id": 6505
    },
    {
        "id": 650506,
        "name_th": "ไผ่ล้อม",
        "name_en": "Phai Lom",
        "zip_codes": [
            65110
        ],
        "district_id": 6505
    },
    {
        "id": 650507,
        "name_th": "นครป่าหมาก",
        "name_en": "Nakhon Pa Mak",
        "zip_codes": [
            65110
        ],
        "district_id": 6505
    },
    {
        "id": 650508,
        "name_th": "เนินกุ่ม",
        "name_en": "Noen Kum",
        "zip_codes": [
            65210
        ],
        "district_id": 6505
    },
    {
        "id": 650509,
        "name_th": "วัดตายม",
        "name_en": "Wat Ta Yom",
        "zip_codes": [
            65210
        ],
        "district_id": 6505
    },
    {
        "id": 650601,
        "name_th": "พรหมพิราม",
        "name_en": "Phrom Phiram",
        "zip_codes": [
            65150
        ],
        "district_id": 6506
    },
    {
        "id": 650602,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            65150
        ],
        "district_id": 6506
    },
    {
        "id": 650603,
        "name_th": "วงฆ้อง",
        "name_en": "Wong Khong",
        "zip_codes": [
            65180
        ],
        "district_id": 6506
    },
    {
        "id": 650604,
        "name_th": "มะตูม",
        "name_en": "Matum",
        "zip_codes": [
            65150
        ],
        "district_id": 6506
    },
    {
        "id": 650605,
        "name_th": "หอกลอง",
        "name_en": "Ho Klong",
        "zip_codes": [
            65150
        ],
        "district_id": 6506
    },
    {
        "id": 650606,
        "name_th": "ศรีภิรมย์",
        "name_en": "Si Phirom",
        "zip_codes": [
            65180
        ],
        "district_id": 6506
    },
    {
        "id": 650607,
        "name_th": "ตลุกเทียม",
        "name_en": "Taluk Thiam",
        "zip_codes": [
            65180
        ],
        "district_id": 6506
    },
    {
        "id": 650608,
        "name_th": "วังวน",
        "name_en": "Wang Won",
        "zip_codes": [
            65150
        ],
        "district_id": 6506
    },
    {
        "id": 650609,
        "name_th": "หนองแขม",
        "name_en": "Nong Khaem",
        "zip_codes": [
            65150
        ],
        "district_id": 6506
    },
    {
        "id": 650610,
        "name_th": "มะต้อง",
        "name_en": "Matong",
        "zip_codes": [
            65180
        ],
        "district_id": 6506
    },
    {
        "id": 650611,
        "name_th": "ทับยายเชียง",
        "name_en": "Thap Yai Chiang",
        "zip_codes": [
            65150
        ],
        "district_id": 6506
    },
    {
        "id": 650612,
        "name_th": "ดงประคำ",
        "name_en": "Dong Prakham",
        "zip_codes": [
            65180
        ],
        "district_id": 6506
    },
    {
        "id": 650701,
        "name_th": "วัดโบสถ์",
        "name_en": "Wat Bot",
        "zip_codes": [
            65160
        ],
        "district_id": 6507
    },
    {
        "id": 650702,
        "name_th": "ท่างาม",
        "name_en": "Tha Ngam",
        "zip_codes": [
            65160
        ],
        "district_id": 6507
    },
    {
        "id": 650703,
        "name_th": "ท้อแท้",
        "name_en": "Thothae",
        "zip_codes": [
            65160
        ],
        "district_id": 6507
    },
    {
        "id": 650704,
        "name_th": "บ้านยาง",
        "name_en": "Ban Yang",
        "zip_codes": [
            65160
        ],
        "district_id": 6507
    },
    {
        "id": 650705,
        "name_th": "หินลาด",
        "name_en": "Hin Lat",
        "zip_codes": [
            65160
        ],
        "district_id": 6507
    },
    {
        "id": 650706,
        "name_th": "คันโช้ง",
        "name_en": "Khan Chong",
        "zip_codes": [
            65160
        ],
        "district_id": 6507
    },
    {
        "id": 650801,
        "name_th": "วังทอง",
        "name_en": "Wang Thong",
        "zip_codes": [
            65130
        ],
        "district_id": 6508
    },
    {
        "id": 650802,
        "name_th": "พันชาลี",
        "name_en": "Phan Chali",
        "zip_codes": [
            65130
        ],
        "district_id": 6508
    },
    {
        "id": 650803,
        "name_th": "แม่ระกา",
        "name_en": "Mae Raka",
        "zip_codes": [
            65130
        ],
        "district_id": 6508
    },
    {
        "id": 650804,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            65220
        ],
        "district_id": 6508
    },
    {
        "id": 650805,
        "name_th": "วังพิกุล",
        "name_en": "Wang Phikun",
        "zip_codes": [
            65130
        ],
        "district_id": 6508
    },
    {
        "id": 650806,
        "name_th": "แก่งโสภา",
        "name_en": "Kaeng Sopha",
        "zip_codes": [
            65220
        ],
        "district_id": 6508
    },
    {
        "id": 650807,
        "name_th": "ท่าหมื่นราม",
        "name_en": "Tha Muen Ram",
        "zip_codes": [
            65130
        ],
        "district_id": 6508
    },
    {
        "id": 650808,
        "name_th": "วังนกแอ่น",
        "name_en": "Wang Nok Aen",
        "zip_codes": [
            65130
        ],
        "district_id": 6508
    },
    {
        "id": 650809,
        "name_th": "หนองพระ",
        "name_en": "Nong Phra",
        "zip_codes": [
            65130
        ],
        "district_id": 6508
    },
    {
        "id": 650810,
        "name_th": "ชัยนาม",
        "name_en": "Chai Nam",
        "zip_codes": [
            65130
        ],
        "district_id": 6508
    },
    {
        "id": 650811,
        "name_th": "ดินทอง",
        "name_en": "Din Thong",
        "zip_codes": [
            65130
        ],
        "district_id": 6508
    },
    {
        "id": 650901,
        "name_th": "ชมพู",
        "name_en": "Chomphu",
        "zip_codes": [
            65190
        ],
        "district_id": 6509
    },
    {
        "id": 650902,
        "name_th": "บ้านมุง",
        "name_en": "Ban Mung",
        "zip_codes": [
            65190
        ],
        "district_id": 6509
    },
    {
        "id": 650903,
        "name_th": "ไทรย้อย",
        "name_en": "Sai Yoi",
        "zip_codes": [
            65190
        ],
        "district_id": 6509
    },
    {
        "id": 650904,
        "name_th": "วังโพรง",
        "name_en": "Wang Phrong",
        "zip_codes": [
            65190
        ],
        "district_id": 6509
    },
    {
        "id": 650905,
        "name_th": "บ้านน้อยซุ้มขี้เหล็ก",
        "name_en": "Ban Noi Sum Khilek",
        "zip_codes": [
            65190
        ],
        "district_id": 6509
    },
    {
        "id": 650906,
        "name_th": "เนินมะปราง",
        "name_en": "Noen Maprang",
        "zip_codes": [
            65190
        ],
        "district_id": 6509
    },
    {
        "id": 650907,
        "name_th": "วังยาง",
        "name_en": "Wang Yang",
        "zip_codes": [
            65190
        ],
        "district_id": 6509
    },
    {
        "id": 660101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660102,
        "name_th": "ไผ่ขวาง",
        "name_en": "Phai Khwang",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660103,
        "name_th": "ย่านยาว",
        "name_en": "Yan Yao",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660104,
        "name_th": "ท่าฬ่อ",
        "name_en": "Tha Lo",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660105,
        "name_th": "ปากทาง",
        "name_en": "Pak Thang",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660106,
        "name_th": "คลองคะเชนทร์",
        "name_en": "Khlong Khachen",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660107,
        "name_th": "โรงช้าง",
        "name_en": "Rong Chang",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660108,
        "name_th": "เมืองเก่า",
        "name_en": "Mueang Kao",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660109,
        "name_th": "ท่าหลวง",
        "name_en": "Tha Luang",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660110,
        "name_th": "บ้านบุ่ง",
        "name_en": "Ban Bung",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660111,
        "name_th": "ฆะมัง",
        "name_en": "Kha Mung",
        "zip_codes": [
            66000,
            66170
        ],
        "district_id": 6601
    },
    {
        "id": 660112,
        "name_th": "ดงป่าคำ",
        "name_en": "Dong Pa Kham",
        "zip_codes": [
            66170
        ],
        "district_id": 6601
    },
    {
        "id": 660113,
        "name_th": "หัวดง",
        "name_en": "Hua Dong",
        "zip_codes": [
            66170
        ],
        "district_id": 6601
    },
    {
        "id": 660115,
        "name_th": "ป่ามะคาบ",
        "name_en": "Pa Makhap",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660119,
        "name_th": "สายคำโห้",
        "name_en": "Sai Kham Ho",
        "zip_codes": [
            66000
        ],
        "district_id": 6601
    },
    {
        "id": 660120,
        "name_th": "ดงกลาง",
        "name_en": "Dong Klang",
        "zip_codes": [
            66170
        ],
        "district_id": 6601
    },
    {
        "id": 660201,
        "name_th": "วังทรายพูน",
        "name_en": "Wang Sai Phun",
        "zip_codes": [
            66180
        ],
        "district_id": 6602
    },
    {
        "id": 660202,
        "name_th": "หนองปลาไหล",
        "name_en": "Nong Pla Lai",
        "zip_codes": [
            66180
        ],
        "district_id": 6602
    },
    {
        "id": 660203,
        "name_th": "หนองพระ",
        "name_en": "Nong Phra",
        "zip_codes": [
            66180
        ],
        "district_id": 6602
    },
    {
        "id": 660204,
        "name_th": "หนองปล้อง",
        "name_en": "Nong Plong",
        "zip_codes": [
            66180
        ],
        "district_id": 6602
    },
    {
        "id": 660301,
        "name_th": "โพธิ์ประทับช้าง",
        "name_en": "Pho Prathap Chang",
        "zip_codes": [
            66190
        ],
        "district_id": 6603
    },
    {
        "id": 660302,
        "name_th": "ไผ่ท่าโพ",
        "name_en": "Phai Tha Pho",
        "zip_codes": [
            66190
        ],
        "district_id": 6603
    },
    {
        "id": 660303,
        "name_th": "วังจิก",
        "name_en": "Wang Chik",
        "zip_codes": [
            66190
        ],
        "district_id": 6603
    },
    {
        "id": 660304,
        "name_th": "ไผ่รอบ",
        "name_en": "Phai Rop",
        "zip_codes": [
            66190
        ],
        "district_id": 6603
    },
    {
        "id": 660305,
        "name_th": "ดงเสือเหลือง",
        "name_en": "Dong Suea Lueang",
        "zip_codes": [
            66190
        ],
        "district_id": 6603
    },
    {
        "id": 660306,
        "name_th": "เนินสว่าง",
        "name_en": "Noen Sawang",
        "zip_codes": [
            66190
        ],
        "district_id": 6603
    },
    {
        "id": 660307,
        "name_th": "ทุ่งใหญ่",
        "name_en": "Thung Yai",
        "zip_codes": [
            66190
        ],
        "district_id": 6603
    },
    {
        "id": 660401,
        "name_th": "ตะพานหิน",
        "name_en": "Taphan Hin",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660402,
        "name_th": "งิ้วราย",
        "name_en": "Ngio Rai",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660403,
        "name_th": "ห้วยเกตุ",
        "name_en": "Huai Ket",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660404,
        "name_th": "ไทรโรงโขน",
        "name_en": "Sai Rong Khon",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660405,
        "name_th": "หนองพยอม",
        "name_en": "Nong Phayom",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660406,
        "name_th": "ทุ่งโพธิ์",
        "name_en": "Thung Pho",
        "zip_codes": [
            66150
        ],
        "district_id": 6604
    },
    {
        "id": 660407,
        "name_th": "ดงตะขบ",
        "name_en": "Dong Takhop",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660408,
        "name_th": "คลองคูณ",
        "name_en": "Khlong Khun",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660409,
        "name_th": "วังสำโรง",
        "name_en": "Wang Samrong",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660410,
        "name_th": "วังหว้า",
        "name_en": "Wang Wa",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660411,
        "name_th": "วังหลุม",
        "name_en": "Wang Lum",
        "zip_codes": [
            66150
        ],
        "district_id": 6604
    },
    {
        "id": 660412,
        "name_th": "ทับหมัน",
        "name_en": "Thap Man",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660413,
        "name_th": "ไผ่หลวง",
        "name_en": "Phai Luang",
        "zip_codes": [
            66110
        ],
        "district_id": 6604
    },
    {
        "id": 660501,
        "name_th": "บางมูลนาก",
        "name_en": "Bang Mun Nak",
        "zip_codes": [
            66120
        ],
        "district_id": 6605
    },
    {
        "id": 660502,
        "name_th": "บางไผ่",
        "name_en": "Bang Phai",
        "zip_codes": [
            66120
        ],
        "district_id": 6605
    },
    {
        "id": 660503,
        "name_th": "หอไกร",
        "name_en": "Ho Krai",
        "zip_codes": [
            66120
        ],
        "district_id": 6605
    },
    {
        "id": 660504,
        "name_th": "เนินมะกอก",
        "name_en": "Noen Makok",
        "zip_codes": [
            66120
        ],
        "district_id": 6605
    },
    {
        "id": 660505,
        "name_th": "วังสำโรง",
        "name_en": "Wang Samrong",
        "zip_codes": [
            66120
        ],
        "district_id": 6605
    },
    {
        "id": 660506,
        "name_th": "ภูมิ",
        "name_en": "Phum",
        "zip_codes": [
            66120
        ],
        "district_id": 6605
    },
    {
        "id": 660507,
        "name_th": "วังกรด",
        "name_en": "Wang Krot",
        "zip_codes": [
            66120
        ],
        "district_id": 6605
    },
    {
        "id": 660508,
        "name_th": "ห้วยเขน",
        "name_en": "Huai Khen",
        "zip_codes": [
            66120
        ],
        "district_id": 6605
    },
    {
        "id": 660509,
        "name_th": "วังตะกู",
        "name_en": "Wang Taku",
        "zip_codes": [
            66210
        ],
        "district_id": 6605
    },
    {
        "id": 660514,
        "name_th": "ลำประดา",
        "name_en": "Lam Prada",
        "zip_codes": [
            66120
        ],
        "district_id": 6605
    },
    {
        "id": 660601,
        "name_th": "โพทะเล",
        "name_en": "Pho Thale",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660602,
        "name_th": "ท้ายน้ำ",
        "name_en": "Thai Nam",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660603,
        "name_th": "ทะนง",
        "name_en": "Thanong",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660604,
        "name_th": "ท่าบัว",
        "name_en": "Tha Bua",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660605,
        "name_th": "ทุ่งน้อย",
        "name_en": "Thung Noi",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660606,
        "name_th": "ท่าขมิ้น",
        "name_en": "Tha Khamin",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660607,
        "name_th": "ท่าเสา",
        "name_en": "Tha Sao",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660608,
        "name_th": "บางคลาน",
        "name_en": "Bang Khlan",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660611,
        "name_th": "ท่านั่ง",
        "name_en": "Tha Nang",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660612,
        "name_th": "บ้านน้อย",
        "name_en": "Ban Noi",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660613,
        "name_th": "วัดขวาง",
        "name_en": "Wat Khwang",
        "zip_codes": [
            66130
        ],
        "district_id": 6606
    },
    {
        "id": 660701,
        "name_th": "สามง่าม",
        "name_en": "Sam Ngam",
        "zip_codes": [
            66140
        ],
        "district_id": 6607
    },
    {
        "id": 660702,
        "name_th": "กำแพงดิน",
        "name_en": "Kamphaeng Din",
        "zip_codes": [
            66220
        ],
        "district_id": 6607
    },
    {
        "id": 660703,
        "name_th": "รังนก",
        "name_en": "Rang Nok",
        "zip_codes": [
            66140
        ],
        "district_id": 6607
    },
    {
        "id": 660706,
        "name_th": "เนินปอ",
        "name_en": "Noen Po",
        "zip_codes": [
            66140
        ],
        "district_id": 6607
    },
    {
        "id": 660707,
        "name_th": "หนองโสน",
        "name_en": "Nong Sano",
        "zip_codes": [
            66140
        ],
        "district_id": 6607
    },
    {
        "id": 660801,
        "name_th": "ทับคล้อ",
        "name_en": "Thap Khlo",
        "zip_codes": [
            66150
        ],
        "district_id": 6608
    },
    {
        "id": 660802,
        "name_th": "เขาทราย",
        "name_en": "Khao Sai",
        "zip_codes": [
            66230
        ],
        "district_id": 6608
    },
    {
        "id": 660803,
        "name_th": "เขาเจ็ดลูก",
        "name_en": "Khao Chet Luk",
        "zip_codes": [
            66230
        ],
        "district_id": 6608
    },
    {
        "id": 660804,
        "name_th": "ท้ายทุ่ง",
        "name_en": "Thai Thung",
        "zip_codes": [
            66150
        ],
        "district_id": 6608
    },
    {
        "id": 660901,
        "name_th": "สากเหล็ก",
        "name_en": "Sak Lek",
        "zip_codes": [
            66160
        ],
        "district_id": 6609
    },
    {
        "id": 660902,
        "name_th": "ท่าเยี่ยม",
        "name_en": "Tha Yiam",
        "zip_codes": [
            66160
        ],
        "district_id": 6609
    },
    {
        "id": 660903,
        "name_th": "คลองทราย",
        "name_en": "Khlong Sai",
        "zip_codes": [
            66160
        ],
        "district_id": 6609
    },
    {
        "id": 660904,
        "name_th": "หนองหญ้าไทร",
        "name_en": "Nong Ya Sai",
        "zip_codes": [
            66160
        ],
        "district_id": 6609
    },
    {
        "id": 660905,
        "name_th": "วังทับไทร",
        "name_en": "Wang Thap Sai",
        "zip_codes": [
            66160
        ],
        "district_id": 6609
    },
    {
        "id": 661001,
        "name_th": "ห้วยแก้ว",
        "name_en": "Huai Kaeo",
        "zip_codes": [
            66130
        ],
        "district_id": 6610
    },
    {
        "id": 661002,
        "name_th": "โพธิ์ไทรงาม",
        "name_en": "Pho Sai Ngam",
        "zip_codes": [
            66130
        ],
        "district_id": 6610
    },
    {
        "id": 661003,
        "name_th": "แหลมรัง",
        "name_en": "Laem Rang",
        "zip_codes": [
            66130
        ],
        "district_id": 6610
    },
    {
        "id": 661004,
        "name_th": "บางลาย",
        "name_en": "Bang Lai",
        "zip_codes": [
            66130
        ],
        "district_id": 6610
    },
    {
        "id": 661005,
        "name_th": "บึงนาราง",
        "name_en": "Bueng Na Rang",
        "zip_codes": [
            66130
        ],
        "district_id": 6610
    },
    {
        "id": 661101,
        "name_th": "วังงิ้วใต้",
        "name_en": "Wang Ngio Tai",
        "zip_codes": [
            66210
        ],
        "district_id": 6611
    },
    {
        "id": 661102,
        "name_th": "วังงิ้ว",
        "name_en": "Wang Ngio",
        "zip_codes": [
            66210
        ],
        "district_id": 6611
    },
    {
        "id": 661103,
        "name_th": "ห้วยร่วม",
        "name_en": "Huai Ruam",
        "zip_codes": [
            66210
        ],
        "district_id": 6611
    },
    {
        "id": 661104,
        "name_th": "ห้วยพุก",
        "name_en": "Huai Phuk",
        "zip_codes": [
            66210
        ],
        "district_id": 6611
    },
    {
        "id": 661105,
        "name_th": "สำนักขุนเณร",
        "name_en": "Samnak Khun Nen",
        "zip_codes": [
            66210
        ],
        "district_id": 6611
    },
    {
        "id": 661201,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            66140
        ],
        "district_id": 6612
    },
    {
        "id": 661202,
        "name_th": "บึงบัว",
        "name_en": "Bueng Bua",
        "zip_codes": [
            66140
        ],
        "district_id": 6612
    },
    {
        "id": 661203,
        "name_th": "วังโมกข์",
        "name_en": "Wang Mok",
        "zip_codes": [
            66140
        ],
        "district_id": 6612
    },
    {
        "id": 661204,
        "name_th": "หนองหลุม",
        "name_en": "Nong Lum",
        "zip_codes": [
            66220
        ],
        "district_id": 6612
    },
    {
        "id": 670101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670102,
        "name_th": "ตะเบาะ",
        "name_en": "Tabo",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670103,
        "name_th": "บ้านโตก",
        "name_en": "Ban Tok",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670104,
        "name_th": "สะเดียง",
        "name_en": "Sadiang",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670105,
        "name_th": "ป่าเลา",
        "name_en": "Pa Lao",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670106,
        "name_th": "นางั่ว",
        "name_en": "Na Ngua",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670107,
        "name_th": "ท่าพล",
        "name_en": "Tha Phon",
        "zip_codes": [
            67250
        ],
        "district_id": 6701
    },
    {
        "id": 670108,
        "name_th": "ดงมูลเหล็ก",
        "name_en": "Dong Mun Lek",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670109,
        "name_th": "บ้านโคก",
        "name_en": "Ban Khok",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670110,
        "name_th": "ชอนไพร",
        "name_en": "Chon Phrai",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670111,
        "name_th": "นาป่า",
        "name_en": "Na Pa",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670112,
        "name_th": "นายม",
        "name_en": "Na Yom",
        "zip_codes": [
            67210
        ],
        "district_id": 6701
    },
    {
        "id": 670113,
        "name_th": "วังชมภู",
        "name_en": "Wang Chomphu",
        "zip_codes": [
            67210
        ],
        "district_id": 6701
    },
    {
        "id": 670114,
        "name_th": "น้ำร้อน",
        "name_en": "Nam Ron",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670115,
        "name_th": "ห้วยสะแก",
        "name_en": "Huai Sakae",
        "zip_codes": [
            67210
        ],
        "district_id": 6701
    },
    {
        "id": 670116,
        "name_th": "ห้วยใหญ่",
        "name_en": "Huai Yai",
        "zip_codes": [
            67000
        ],
        "district_id": 6701
    },
    {
        "id": 670117,
        "name_th": "ระวิง",
        "name_en": "Rawing",
        "zip_codes": [
            67210
        ],
        "district_id": 6701
    },
    {
        "id": 670201,
        "name_th": "ชนแดน",
        "name_en": "Chon Daen",
        "zip_codes": [
            67150
        ],
        "district_id": 6702
    },
    {
        "id": 670202,
        "name_th": "ดงขุย",
        "name_en": "Dong Khui",
        "zip_codes": [
            67190
        ],
        "district_id": 6702
    },
    {
        "id": 670203,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            67150
        ],
        "district_id": 6702
    },
    {
        "id": 670204,
        "name_th": "พุทธบาท",
        "name_en": "Phutthabat",
        "zip_codes": [
            67150
        ],
        "district_id": 6702
    },
    {
        "id": 670205,
        "name_th": "ลาดแค",
        "name_en": "Lat Khae",
        "zip_codes": [
            67150
        ],
        "district_id": 6702
    },
    {
        "id": 670206,
        "name_th": "บ้านกล้วย",
        "name_en": "Ban Kluai",
        "zip_codes": [
            67190
        ],
        "district_id": 6702
    },
    {
        "id": 670208,
        "name_th": "ซับพุทรา",
        "name_en": "Sap Phutsa",
        "zip_codes": [
            67150
        ],
        "district_id": 6702
    },
    {
        "id": 670209,
        "name_th": "ตะกุดไร",
        "name_en": "Takut Rai",
        "zip_codes": [
            67190
        ],
        "district_id": 6702
    },
    {
        "id": 670210,
        "name_th": "ศาลาลาย",
        "name_en": "Sala Lai",
        "zip_codes": [
            67150
        ],
        "district_id": 6702
    },
    {
        "id": 670301,
        "name_th": "หล่มสัก",
        "name_en": "Lom Sak",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670302,
        "name_th": "วัดป่า",
        "name_en": "Wat Pa",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670303,
        "name_th": "ตาลเดี่ยว",
        "name_en": "Tan Diao",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670304,
        "name_th": "ฝายนาแซง",
        "name_en": "Fai Na Saeng",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670305,
        "name_th": "หนองสว่าง",
        "name_en": "Nong Sawang",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670306,
        "name_th": "น้ำเฮี้ย",
        "name_en": "Nam Hia",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670307,
        "name_th": "สักหลง",
        "name_en": "Sak Long",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670308,
        "name_th": "ท่าอิบุญ",
        "name_en": "Tha Ibun",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670309,
        "name_th": "บ้านโสก",
        "name_en": "Ban Sok",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670310,
        "name_th": "บ้านติ้ว",
        "name_en": "Ban Tio",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670311,
        "name_th": "ห้วยไร่",
        "name_en": "Huai Rai",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670312,
        "name_th": "น้ำก้อ",
        "name_en": "Nam Ko",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670313,
        "name_th": "ปากช่อง",
        "name_en": "Pak Chong",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670314,
        "name_th": "น้ำชุน",
        "name_en": "Nam Chun",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670315,
        "name_th": "หนองไขว่",
        "name_en": "Nong Khwai",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670316,
        "name_th": "ลานบ่า",
        "name_en": "Lan Ba",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670317,
        "name_th": "บุ่งคล้า",
        "name_en": "Bung Khla",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670318,
        "name_th": "บุ่งน้ำเต้า",
        "name_en": "Bung Namtao",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670319,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670320,
        "name_th": "ช้างตะลูด",
        "name_en": "Chang Talut",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670321,
        "name_th": "บ้านไร่",
        "name_en": "Ban Rai",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670322,
        "name_th": "ปากดุก",
        "name_en": "Pak Duk",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670323,
        "name_th": "บ้านหวาย",
        "name_en": "Ban Wai",
        "zip_codes": [
            67110
        ],
        "district_id": 6703
    },
    {
        "id": 670401,
        "name_th": "หล่มเก่า",
        "name_en": "Lom Kao",
        "zip_codes": [
            67120
        ],
        "district_id": 6704
    },
    {
        "id": 670402,
        "name_th": "นาซำ",
        "name_en": "Na Sam",
        "zip_codes": [
            67120
        ],
        "district_id": 6704
    },
    {
        "id": 670403,
        "name_th": "หินฮาว",
        "name_en": "Hin Hao",
        "zip_codes": [
            67120
        ],
        "district_id": 6704
    },
    {
        "id": 670404,
        "name_th": "บ้านเนิน",
        "name_en": "Ban Noen",
        "zip_codes": [
            67120
        ],
        "district_id": 6704
    },
    {
        "id": 670405,
        "name_th": "ศิลา",
        "name_en": "Sila",
        "zip_codes": [
            67120
        ],
        "district_id": 6704
    },
    {
        "id": 670406,
        "name_th": "นาแซง",
        "name_en": "Na Saeng",
        "zip_codes": [
            67120
        ],
        "district_id": 6704
    },
    {
        "id": 670407,
        "name_th": "วังบาล",
        "name_en": "Wang Ban",
        "zip_codes": [
            67120
        ],
        "district_id": 6704
    },
    {
        "id": 670408,
        "name_th": "นาเกาะ",
        "name_en": "Na Ko",
        "zip_codes": [
            67120
        ],
        "district_id": 6704
    },
    {
        "id": 670409,
        "name_th": "ตาดกลอย",
        "name_en": "Tat Kloi",
        "zip_codes": [
            67120
        ],
        "district_id": 6704
    },
    {
        "id": 670501,
        "name_th": "ท่าโรง",
        "name_en": "Tha Rong",
        "zip_codes": [
            67130
        ],
        "district_id": 6705
    },
    {
        "id": 670502,
        "name_th": "สระประดู่",
        "name_en": "Sa Pradu",
        "zip_codes": [
            67130
        ],
        "district_id": 6705
    },
    {
        "id": 670503,
        "name_th": "สามแยก",
        "name_en": "Sam Yaek",
        "zip_codes": [
            67130
        ],
        "district_id": 6705
    },
    {
        "id": 670504,
        "name_th": "โคกปรง",
        "name_en": "Khok Prong",
        "zip_codes": [
            67130
        ],
        "district_id": 6705
    },
    {
        "id": 670505,
        "name_th": "น้ำร้อน",
        "name_en": "Nam Ron",
        "zip_codes": [
            67130
        ],
        "district_id": 6705
    },
    {
        "id": 670506,
        "name_th": "บ่อรัง",
        "name_en": "Bo Rang",
        "zip_codes": [
            67130
        ],
        "district_id": 6705
    },
    {
        "id": 670507,
        "name_th": "พุเตย",
        "name_en": "Phu Toei",
        "zip_codes": [
            67180
        ],
        "district_id": 6705
    },
    {
        "id": 670508,
        "name_th": "พุขาม",
        "name_en": "Phu Kham",
        "zip_codes": [
            67180
        ],
        "district_id": 6705
    },
    {
        "id": 670509,
        "name_th": "ภูน้ำหยด",
        "name_en": "Phu Nam Yot",
        "zip_codes": [
            67180
        ],
        "district_id": 6705
    },
    {
        "id": 670510,
        "name_th": "ซับสมบูรณ์",
        "name_en": "Sap Sombun",
        "zip_codes": [
            67180
        ],
        "district_id": 6705
    },
    {
        "id": 670511,
        "name_th": "บึงกระจับ",
        "name_en": "Bueng Krachap",
        "zip_codes": [
            67130
        ],
        "district_id": 6705
    },
    {
        "id": 670512,
        "name_th": "วังใหญ่",
        "name_en": "Wang Yai",
        "zip_codes": [
            67180
        ],
        "district_id": 6705
    },
    {
        "id": 670513,
        "name_th": "ยางสาว",
        "name_en": "Yang Sao",
        "zip_codes": [
            67130
        ],
        "district_id": 6705
    },
    {
        "id": 670514,
        "name_th": "ซับน้อย",
        "name_en": "Sap Noi",
        "zip_codes": [
            67180
        ],
        "district_id": 6705
    },
    {
        "id": 670601,
        "name_th": "ศรีเทพ",
        "name_en": "Si Thep",
        "zip_codes": [
            67170
        ],
        "district_id": 6706
    },
    {
        "id": 670602,
        "name_th": "สระกรวด",
        "name_en": "Sa Kruat",
        "zip_codes": [
            67170
        ],
        "district_id": 6706
    },
    {
        "id": 670603,
        "name_th": "คลองกระจัง",
        "name_en": "Khlong Krachang",
        "zip_codes": [
            67170
        ],
        "district_id": 6706
    },
    {
        "id": 670604,
        "name_th": "นาสนุ่น",
        "name_en": "Na Sanun",
        "zip_codes": [
            67170
        ],
        "district_id": 6706
    },
    {
        "id": 670605,
        "name_th": "โคกสะอาด",
        "name_en": "Khok Sa-at",
        "zip_codes": [
            67170
        ],
        "district_id": 6706
    },
    {
        "id": 670606,
        "name_th": "หนองย่างทอย",
        "name_en": "Nong Yang Thoi",
        "zip_codes": [
            67170
        ],
        "district_id": 6706
    },
    {
        "id": 670607,
        "name_th": "ประดู่งาม",
        "name_en": "Pradu Ngam",
        "zip_codes": [
            67170
        ],
        "district_id": 6706
    },
    {
        "id": 670701,
        "name_th": "กองทูล",
        "name_en": "Kong Thun",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670702,
        "name_th": "นาเฉลียง",
        "name_en": "Na Chaliang",
        "zip_codes": [
            67220
        ],
        "district_id": 6707
    },
    {
        "id": 670703,
        "name_th": "บ้านโภชน์",
        "name_en": "Ban Phot",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670704,
        "name_th": "ท่าแดง",
        "name_en": "Tha Daeng",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670705,
        "name_th": "เพชรละคร",
        "name_en": "Phet Lakhon",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670706,
        "name_th": "บ่อไทย",
        "name_en": "Bo Thai",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670707,
        "name_th": "ห้วยโป่ง",
        "name_en": "Huai Pong",
        "zip_codes": [
            67220
        ],
        "district_id": 6707
    },
    {
        "id": 670708,
        "name_th": "วังท่าดี",
        "name_en": "Wang Tha Di",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670709,
        "name_th": "บัววัฒนา",
        "name_en": "Bua Watthana",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670710,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670711,
        "name_th": "วังโบสถ์",
        "name_en": "Wang Bot",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670712,
        "name_th": "ยางงาม",
        "name_en": "Yang Ngam",
        "zip_codes": [
            67220
        ],
        "district_id": 6707
    },
    {
        "id": 670713,
        "name_th": "ท่าด้วง",
        "name_en": "Tha Duang",
        "zip_codes": [
            67140
        ],
        "district_id": 6707
    },
    {
        "id": 670801,
        "name_th": "ซับสมอทอด",
        "name_en": "Sap Samo Thot",
        "zip_codes": [
            67160
        ],
        "district_id": 6708
    },
    {
        "id": 670802,
        "name_th": "ซับไม้แดง",
        "name_en": "Sap Mai Daeng",
        "zip_codes": [
            67160
        ],
        "district_id": 6708
    },
    {
        "id": 670803,
        "name_th": "หนองแจง",
        "name_en": "Nong Chaeng",
        "zip_codes": [
            67160
        ],
        "district_id": 6708
    },
    {
        "id": 670804,
        "name_th": "กันจุ",
        "name_en": "Kanchu",
        "zip_codes": [
            67160
        ],
        "district_id": 6708
    },
    {
        "id": 670805,
        "name_th": "วังพิกุล",
        "name_en": "Wang Phikun",
        "zip_codes": [
            67230
        ],
        "district_id": 6708
    },
    {
        "id": 670806,
        "name_th": "พญาวัง",
        "name_en": "Phaya Wang",
        "zip_codes": [
            67160
        ],
        "district_id": 6708
    },
    {
        "id": 670807,
        "name_th": "ศรีมงคล",
        "name_en": "Si Mongkhon",
        "zip_codes": [
            67160
        ],
        "district_id": 6708
    },
    {
        "id": 670808,
        "name_th": "สระแก้ว",
        "name_en": "Sa Kaeo",
        "zip_codes": [
            67160
        ],
        "district_id": 6708
    },
    {
        "id": 670809,
        "name_th": "บึงสามพัน",
        "name_en": "Bueng Sam Phan",
        "zip_codes": [
            67160
        ],
        "district_id": 6708
    },
    {
        "id": 670901,
        "name_th": "น้ำหนาว",
        "name_en": "Nam Nao",
        "zip_codes": [
            67260
        ],
        "district_id": 6709
    },
    {
        "id": 670902,
        "name_th": "หลักด่าน",
        "name_en": "Lak Dan",
        "zip_codes": [
            67260
        ],
        "district_id": 6709
    },
    {
        "id": 670903,
        "name_th": "วังกวาง",
        "name_en": "Wang Kwang",
        "zip_codes": [
            67260
        ],
        "district_id": 6709
    },
    {
        "id": 670904,
        "name_th": "โคกมน",
        "name_en": "Khok Mon",
        "zip_codes": [
            67260
        ],
        "district_id": 6709
    },
    {
        "id": 671001,
        "name_th": "วังโป่ง",
        "name_en": "Wang Pong",
        "zip_codes": [
            67240
        ],
        "district_id": 6710
    },
    {
        "id": 671002,
        "name_th": "ท้ายดง",
        "name_en": "Thai Dong",
        "zip_codes": [
            67240
        ],
        "district_id": 6710
    },
    {
        "id": 671003,
        "name_th": "ซับเปิบ",
        "name_en": "Sap Poep",
        "zip_codes": [
            67240
        ],
        "district_id": 6710
    },
    {
        "id": 671004,
        "name_th": "วังหิน",
        "name_en": "Wang Hin",
        "zip_codes": [
            67240
        ],
        "district_id": 6710
    },
    {
        "id": 671005,
        "name_th": "วังศาล",
        "name_en": "Wang San",
        "zip_codes": [
            67240
        ],
        "district_id": 6710
    },
    {
        "id": 671101,
        "name_th": "ทุ่งสมอ",
        "name_en": "Thung Samo",
        "zip_codes": [
            67270
        ],
        "district_id": 6711
    },
    {
        "id": 671102,
        "name_th": "แคมป์สน",
        "name_en": "Khaem Son",
        "zip_codes": [
            67280
        ],
        "district_id": 6711
    },
    {
        "id": 671103,
        "name_th": "เขาค้อ",
        "name_en": "Khao Kho",
        "zip_codes": [
            67270
        ],
        "district_id": 6711
    },
    {
        "id": 671104,
        "name_th": "ริมสีม่วง",
        "name_en": "Rim Si Muang",
        "zip_codes": [
            67270
        ],
        "district_id": 6711
    },
    {
        "id": 671105,
        "name_th": "สะเดาะพง",
        "name_en": "Sado Phong",
        "zip_codes": [
            67270
        ],
        "district_id": 6711
    },
    {
        "id": 671106,
        "name_th": "หนองแม่นา",
        "name_en": "Nong Mae Na",
        "zip_codes": [
            67270
        ],
        "district_id": 6711
    },
    {
        "id": 671107,
        "name_th": "เข็กน้อย",
        "name_en": "Khek Noi",
        "zip_codes": [
            67280
        ],
        "district_id": 6711
    },
    {
        "id": 700101,
        "name_th": "หน้าเมือง",
        "name_en": "Na Mueang",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700102,
        "name_th": "เจดีย์หัก",
        "name_en": "Chedi Hak",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700103,
        "name_th": "ดอนตะโก",
        "name_en": "Don Tako",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700104,
        "name_th": "หนองกลางนา",
        "name_en": "Nong Klang Na",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700105,
        "name_th": "ห้วยไผ่",
        "name_en": "Huai Phai",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700106,
        "name_th": "คุ้งน้ำวน",
        "name_en": "Khung Nam Won",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700107,
        "name_th": "คุ้งกระถิน",
        "name_en": "Khung Krathin",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700108,
        "name_th": "อ่างทอง",
        "name_en": "Ang Thong",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700109,
        "name_th": "โคกหม้อ",
        "name_en": "Khok Mo",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700110,
        "name_th": "สามเรือน",
        "name_en": "Sam Ruean",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700111,
        "name_th": "พิกุลทอง",
        "name_en": "Phikun Thong",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700112,
        "name_th": "น้ำพุ",
        "name_en": "Nam Phu",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700113,
        "name_th": "ดอนแร่",
        "name_en": "Don Rae",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700114,
        "name_th": "หินกอง",
        "name_en": "Hin Kong",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700115,
        "name_th": "เขาแร้ง",
        "name_en": "Khao Raeng",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700116,
        "name_th": "เกาะพลับพลา",
        "name_en": "Ko Phlapphla",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700117,
        "name_th": "หลุมดิน",
        "name_en": "Lum Din",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700118,
        "name_th": "บางป่า",
        "name_en": "Bang Pa",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700119,
        "name_th": "พงสวาย",
        "name_en": "Phong Sawai",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700120,
        "name_th": "คูบัว",
        "name_en": "Khu Bua",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700121,
        "name_th": "ท่าราบ",
        "name_en": "Tha Rap",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700122,
        "name_th": "บ้านไร่",
        "name_en": "Ban Rai",
        "zip_codes": [
            70000
        ],
        "district_id": 7001
    },
    {
        "id": 700201,
        "name_th": "จอมบึง",
        "name_en": "Chom Bueng",
        "zip_codes": [
            70150
        ],
        "district_id": 7002
    },
    {
        "id": 700202,
        "name_th": "ปากช่อง",
        "name_en": "Pak Chong",
        "zip_codes": [
            70150
        ],
        "district_id": 7002
    },
    {
        "id": 700203,
        "name_th": "เบิกไพร",
        "name_en": "Boek Phrai",
        "zip_codes": [
            70150
        ],
        "district_id": 7002
    },
    {
        "id": 700204,
        "name_th": "ด่านทับตะโก",
        "name_en": "Dan Thap Tako",
        "zip_codes": [
            70150
        ],
        "district_id": 7002
    },
    {
        "id": 700205,
        "name_th": "แก้มอ้น",
        "name_en": "Kaem On",
        "zip_codes": [
            70150
        ],
        "district_id": 7002
    },
    {
        "id": 700206,
        "name_th": "รางบัว",
        "name_en": "Rang Bua",
        "zip_codes": [
            70150
        ],
        "district_id": 7002
    },
    {
        "id": 700301,
        "name_th": "สวนผึ้ง",
        "name_en": "Suan Phueng",
        "zip_codes": [
            70180
        ],
        "district_id": 7003
    },
    {
        "id": 700302,
        "name_th": "ป่าหวาย",
        "name_en": "Pa Wai",
        "zip_codes": [
            70180
        ],
        "district_id": 7003
    },
    {
        "id": 700304,
        "name_th": "ท่าเคย",
        "name_en": "Tha Khoei",
        "zip_codes": [
            70180
        ],
        "district_id": 7003
    },
    {
        "id": 700307,
        "name_th": "ตะนาวศรี",
        "name_en": "Tanao Si",
        "zip_codes": [
            70180
        ],
        "district_id": 7003
    },
    {
        "id": 700401,
        "name_th": "ดำเนินสะดวก",
        "name_en": "Damnoen Saduak",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700402,
        "name_th": "ประสาทสิทธิ์",
        "name_en": "Prasat Sit",
        "zip_codes": [
            70210
        ],
        "district_id": 7004
    },
    {
        "id": 700403,
        "name_th": "ศรีสุราษฎร์",
        "name_en": "Si Surat",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700404,
        "name_th": "ตาหลวง",
        "name_en": "Ta Luang",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700405,
        "name_th": "ดอนกรวย",
        "name_en": "Don Kruai",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700406,
        "name_th": "ดอนคลัง",
        "name_en": "Don Khlang",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700407,
        "name_th": "บัวงาม",
        "name_en": "Bua Ngam",
        "zip_codes": [
            70210
        ],
        "district_id": 7004
    },
    {
        "id": 700408,
        "name_th": "บ้านไร่",
        "name_en": "Ban Rai",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700409,
        "name_th": "แพงพวย",
        "name_en": "Phaengphuai",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700410,
        "name_th": "สี่หมื่น",
        "name_en": "Si Muen",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700411,
        "name_th": "ท่านัด",
        "name_en": "Tha Nat",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700412,
        "name_th": "ขุนพิทักษ์",
        "name_en": "Khun Phithak",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700413,
        "name_th": "ดอนไผ่",
        "name_en": "Don Phai",
        "zip_codes": [
            70130
        ],
        "district_id": 7004
    },
    {
        "id": 700501,
        "name_th": "บ้านโป่ง",
        "name_en": "Ban Pong",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700502,
        "name_th": "ท่าผา",
        "name_en": "Tha Pha",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700503,
        "name_th": "กรับใหญ่",
        "name_en": "Krap Yai",
        "zip_codes": [
            70190
        ],
        "district_id": 7005
    },
    {
        "id": 700504,
        "name_th": "ปากแรต",
        "name_en": "Pak Raet",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700505,
        "name_th": "หนองกบ",
        "name_en": "Nong Kop",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700506,
        "name_th": "หนองอ้อ",
        "name_en": "Nong O",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700507,
        "name_th": "ดอนกระเบื้อง",
        "name_en": "Don Krabueang",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700508,
        "name_th": "สวนกล้วย",
        "name_en": "Suan Kluai",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700509,
        "name_th": "นครชุมน์",
        "name_en": "Nakhon Chum",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700510,
        "name_th": "บ้านม่วง",
        "name_en": "Ban Muang",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700511,
        "name_th": "คุ้งพยอม",
        "name_en": "Khung Phayom",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700512,
        "name_th": "หนองปลาหมอ",
        "name_en": "Nong Pla Mo",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700513,
        "name_th": "เขาขลุง",
        "name_en": "Khao Khlung",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700514,
        "name_th": "เบิกไพร",
        "name_en": "Boek Phrai",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700515,
        "name_th": "ลาดบัวขาว",
        "name_en": "Lat Bua Khao",
        "zip_codes": [
            70110
        ],
        "district_id": 7005
    },
    {
        "id": 700601,
        "name_th": "บางแพ",
        "name_en": "Bang Phae",
        "zip_codes": [
            70160
        ],
        "district_id": 7006
    },
    {
        "id": 700602,
        "name_th": "วังเย็น",
        "name_en": "Wang Yen",
        "zip_codes": [
            70160
        ],
        "district_id": 7006
    },
    {
        "id": 700603,
        "name_th": "หัวโพ",
        "name_en": "Hua Pho",
        "zip_codes": [
            70160
        ],
        "district_id": 7006
    },
    {
        "id": 700604,
        "name_th": "วัดแก้ว",
        "name_en": "Wat Kaeo",
        "zip_codes": [
            70160
        ],
        "district_id": 7006
    },
    {
        "id": 700605,
        "name_th": "ดอนใหญ่",
        "name_en": "Don Yai",
        "zip_codes": [
            70160
        ],
        "district_id": 7006
    },
    {
        "id": 700606,
        "name_th": "ดอนคา",
        "name_en": "Don Kha",
        "zip_codes": [
            70160
        ],
        "district_id": 7006
    },
    {
        "id": 700607,
        "name_th": "โพหัก",
        "name_en": "Pho Hak",
        "zip_codes": [
            70160
        ],
        "district_id": 7006
    },
    {
        "id": 700701,
        "name_th": "โพธาราม",
        "name_en": "Photharam",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700702,
        "name_th": "ดอนกระเบื้อง",
        "name_en": "Don Krabueang",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700703,
        "name_th": "หนองโพ",
        "name_en": "Nong Pho",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700704,
        "name_th": "บ้านเลือก",
        "name_en": "Ban Lueak",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700705,
        "name_th": "คลองตาคต",
        "name_en": "Khlong Ta Khot",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700706,
        "name_th": "บ้านฆ้อง",
        "name_en": "Ban Khong",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700707,
        "name_th": "บ้านสิงห์",
        "name_en": "Ban Sing",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700708,
        "name_th": "ดอนทราย",
        "name_en": "Don Sai",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700709,
        "name_th": "เจ็ดเสมียน",
        "name_en": "Chet Samian",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700710,
        "name_th": "คลองข่อย",
        "name_en": "Khlong Khoi",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700711,
        "name_th": "ชำแระ",
        "name_en": "Chamrae",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700712,
        "name_th": "สร้อยฟ้า",
        "name_en": "Soi Fa",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700713,
        "name_th": "ท่าชุมพล",
        "name_en": "Tha Chumphon",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700714,
        "name_th": "บางโตนด",
        "name_en": "Bang Tanot",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700715,
        "name_th": "เตาปูน",
        "name_en": "Tao Pun",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700716,
        "name_th": "นางแก้ว",
        "name_en": "Nang Kaeo",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700717,
        "name_th": "ธรรมเสน",
        "name_en": "Thammasen",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700718,
        "name_th": "เขาชะงุ้ม",
        "name_en": "Khao Cha-ngum",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700719,
        "name_th": "หนองกวาง",
        "name_en": "Nong Kwang",
        "zip_codes": [
            70120
        ],
        "district_id": 7007
    },
    {
        "id": 700801,
        "name_th": "ทุ่งหลวง",
        "name_en": "Thung Luang",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700802,
        "name_th": "วังมะนาว",
        "name_en": "Wang Manao",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700803,
        "name_th": "ดอนทราย",
        "name_en": "Don Sai",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700804,
        "name_th": "หนองกระทุ่ม",
        "name_en": "Nong Krathum",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700805,
        "name_th": "ปากท่อ",
        "name_en": "Pak Tho",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700806,
        "name_th": "ป่าไก่",
        "name_en": "Pa Kai",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700807,
        "name_th": "วัดยางงาม",
        "name_en": "Wat Yang Ngam",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700808,
        "name_th": "อ่างหิน",
        "name_en": "Ang Hin",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700809,
        "name_th": "บ่อกระดาน",
        "name_en": "Bo Kradan",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700810,
        "name_th": "ยางหัก",
        "name_en": "Yang Hak",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700811,
        "name_th": "วันดาว",
        "name_en": "Wan Dao",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700812,
        "name_th": "ห้วยยางโทน",
        "name_en": "Huai Yang Thon",
        "zip_codes": [
            70140
        ],
        "district_id": 7008
    },
    {
        "id": 700901,
        "name_th": "เกาะศาลพระ",
        "name_en": "Ko San Phra",
        "zip_codes": [
            70170
        ],
        "district_id": 7009
    },
    {
        "id": 700902,
        "name_th": "จอมประทัด",
        "name_en": "Chom Prathat",
        "zip_codes": [
            70170
        ],
        "district_id": 7009
    },
    {
        "id": 700903,
        "name_th": "วัดเพลง",
        "name_en": "Wat Phleng",
        "zip_codes": [
            70170
        ],
        "district_id": 7009
    },
    {
        "id": 701001,
        "name_th": "บ้านคา",
        "name_en": "Ban Kha",
        "zip_codes": [
            70180
        ],
        "district_id": 7010
    },
    {
        "id": 701002,
        "name_th": "บ้านบึง",
        "name_en": "Ban Bueng",
        "zip_codes": [
            70180
        ],
        "district_id": 7010
    },
    {
        "id": 701003,
        "name_th": "หนองพันจันทร์",
        "name_en": "Nong Phan Chan",
        "zip_codes": [
            70180
        ],
        "district_id": 7010
    },
    {
        "id": 710101,
        "name_th": "บ้านเหนือ",
        "name_en": "Ban Nuea",
        "zip_codes": [
            71000
        ],
        "district_id": 7101
    },
    {
        "id": 710102,
        "name_th": "บ้านใต้",
        "name_en": "Ban Tai",
        "zip_codes": [
            71000
        ],
        "district_id": 7101
    },
    {
        "id": 710103,
        "name_th": "ปากแพรก",
        "name_en": "Pak Phraek",
        "zip_codes": [
            71000
        ],
        "district_id": 7101
    },
    {
        "id": 710104,
        "name_th": "ท่ามะขาม",
        "name_en": "Tha Makham",
        "zip_codes": [
            71000
        ],
        "district_id": 7101
    },
    {
        "id": 710105,
        "name_th": "แก่งเสี้ยน",
        "name_en": "Kaeng Sian",
        "zip_codes": [
            71000
        ],
        "district_id": 7101
    },
    {
        "id": 710106,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            71190
        ],
        "district_id": 7101
    },
    {
        "id": 710107,
        "name_th": "ลาดหญ้า",
        "name_en": "Lat Ya",
        "zip_codes": [
            71190
        ],
        "district_id": 7101
    },
    {
        "id": 710108,
        "name_th": "วังด้ง",
        "name_en": "Wang Dong",
        "zip_codes": [
            71190
        ],
        "district_id": 7101
    },
    {
        "id": 710109,
        "name_th": "ช่องสะเดา",
        "name_en": "Chong Sadao",
        "zip_codes": [
            71190
        ],
        "district_id": 7101
    },
    {
        "id": 710110,
        "name_th": "หนองหญ้า",
        "name_en": "Nong Ya",
        "zip_codes": [
            71000
        ],
        "district_id": 7101
    },
    {
        "id": 710111,
        "name_th": "เกาะสำโรง",
        "name_en": "Ko Samrong",
        "zip_codes": [
            71000
        ],
        "district_id": 7101
    },
    {
        "id": 710113,
        "name_th": "บ้านเก่า",
        "name_en": "Ban Kao",
        "zip_codes": [
            71000
        ],
        "district_id": 7101
    },
    {
        "id": 710116,
        "name_th": "วังเย็น",
        "name_en": "Wang Yen",
        "zip_codes": [
            71000
        ],
        "district_id": 7101
    },
    {
        "id": 710201,
        "name_th": "ลุ่มสุ่ม",
        "name_en": "Lum Sum",
        "zip_codes": [
            71150
        ],
        "district_id": 7102
    },
    {
        "id": 710202,
        "name_th": "ท่าเสา",
        "name_en": "Tha Sao",
        "zip_codes": [
            71150
        ],
        "district_id": 7102
    },
    {
        "id": 710203,
        "name_th": "สิงห์",
        "name_en": "Sing",
        "zip_codes": [
            71150
        ],
        "district_id": 7102
    },
    {
        "id": 710204,
        "name_th": "ไทรโยค",
        "name_en": "Sai Yok",
        "zip_codes": [
            71150
        ],
        "district_id": 7102
    },
    {
        "id": 710205,
        "name_th": "วังกระแจะ",
        "name_en": "Wang Khrachae",
        "zip_codes": [
            71150
        ],
        "district_id": 7102
    },
    {
        "id": 710206,
        "name_th": "ศรีมงคล",
        "name_en": "Si Mongkhon",
        "zip_codes": [
            71150
        ],
        "district_id": 7102
    },
    {
        "id": 710207,
        "name_th": "บ้องตี้",
        "name_en": "Bongti",
        "zip_codes": [
            71150
        ],
        "district_id": 7102
    },
    {
        "id": 710301,
        "name_th": "บ่อพลอย",
        "name_en": "Bo Phloi",
        "zip_codes": [
            71160
        ],
        "district_id": 7103
    },
    {
        "id": 710302,
        "name_th": "หนองกุ่ม",
        "name_en": "Nong Kum",
        "zip_codes": [
            71160
        ],
        "district_id": 7103
    },
    {
        "id": 710303,
        "name_th": "หนองรี",
        "name_en": "Nong Ri",
        "zip_codes": [
            71220
        ],
        "district_id": 7103
    },
    {
        "id": 710305,
        "name_th": "หลุมรัง",
        "name_en": "Lum Rang",
        "zip_codes": [
            71160
        ],
        "district_id": 7103
    },
    {
        "id": 710308,
        "name_th": "ช่องด่าน",
        "name_en": "Chong Dan",
        "zip_codes": [
            71160
        ],
        "district_id": 7103
    },
    {
        "id": 710309,
        "name_th": "หนองกร่าง",
        "name_en": "Nong Krang",
        "zip_codes": [
            71220
        ],
        "district_id": 7103
    },
    {
        "id": 710401,
        "name_th": "นาสวน",
        "name_en": "Na Suan",
        "zip_codes": [
            71250
        ],
        "district_id": 7104
    },
    {
        "id": 710402,
        "name_th": "ด่านแม่แฉลบ",
        "name_en": "Dan Mae Chalaep",
        "zip_codes": [
            71250
        ],
        "district_id": 7104
    },
    {
        "id": 710403,
        "name_th": "หนองเป็ด",
        "name_en": "Nong Pet",
        "zip_codes": [
            71250
        ],
        "district_id": 7104
    },
    {
        "id": 710404,
        "name_th": "ท่ากระดาน",
        "name_en": "Tha Kradan",
        "zip_codes": [
            71250
        ],
        "district_id": 7104
    },
    {
        "id": 710405,
        "name_th": "เขาโจด",
        "name_en": "Khao Chot",
        "zip_codes": [
            71220
        ],
        "district_id": 7104
    },
    {
        "id": 710406,
        "name_th": "แม่กระบุง",
        "name_en": "Mae Krabung",
        "zip_codes": [
            71250
        ],
        "district_id": 7104
    },
    {
        "id": 710501,
        "name_th": "พงตึก",
        "name_en": "Phong Tuek",
        "zip_codes": [
            71120
        ],
        "district_id": 7105
    },
    {
        "id": 710502,
        "name_th": "ยางม่วง",
        "name_en": "Yang Muang",
        "zip_codes": [
            71120
        ],
        "district_id": 7105
    },
    {
        "id": 710503,
        "name_th": "ดอนชะเอม",
        "name_en": "Don Cha-em",
        "zip_codes": [
            71130
        ],
        "district_id": 7105
    },
    {
        "id": 710504,
        "name_th": "ท่าไม้",
        "name_en": "Tha Mai",
        "zip_codes": [
            71120
        ],
        "district_id": 7105
    },
    {
        "id": 710505,
        "name_th": "ตะคร้ำเอน",
        "name_en": "Takhram En",
        "zip_codes": [
            71130
        ],
        "district_id": 7105
    },
    {
        "id": 710506,
        "name_th": "ท่ามะกา",
        "name_en": "Tha Maka",
        "zip_codes": [
            71120
        ],
        "district_id": 7105
    },
    {
        "id": 710507,
        "name_th": "ท่าเรือ",
        "name_en": "Tha Ruea",
        "zip_codes": [
            71130
        ],
        "district_id": 7105
    },
    {
        "id": 710508,
        "name_th": "โคกตะบอง",
        "name_en": "Khok Tabong",
        "zip_codes": [
            71120
        ],
        "district_id": 7105
    },
    {
        "id": 710509,
        "name_th": "ดอนขมิ้น",
        "name_en": "Don Khamin",
        "zip_codes": [
            71120
        ],
        "district_id": 7105
    },
    {
        "id": 710510,
        "name_th": "อุโลกสี่หมื่น",
        "name_en": "Ulok Si Muen",
        "zip_codes": [
            71130
        ],
        "district_id": 7105
    },
    {
        "id": 710511,
        "name_th": "เขาสามสิบหาบ",
        "name_en": "Khao Sam Sip Hap",
        "zip_codes": [
            71120
        ],
        "district_id": 7105
    },
    {
        "id": 710512,
        "name_th": "พระแท่น",
        "name_en": "Phra Thaen",
        "zip_codes": [
            71130
        ],
        "district_id": 7105
    },
    {
        "id": 710513,
        "name_th": "หวายเหนียว",
        "name_en": "Wai Niao",
        "zip_codes": [
            71120
        ],
        "district_id": 7105
    },
    {
        "id": 710514,
        "name_th": "แสนตอ",
        "name_en": "Saen To",
        "zip_codes": [
            71130
        ],
        "district_id": 7105
    },
    {
        "id": 710515,
        "name_th": "สนามแย้",
        "name_en": "Sanam Yae",
        "zip_codes": [
            70190
        ],
        "district_id": 7105
    },
    {
        "id": 710516,
        "name_th": "ท่าเสา",
        "name_en": "Tha Sao",
        "zip_codes": [
            71120
        ],
        "district_id": 7105
    },
    {
        "id": 710517,
        "name_th": "หนองลาน",
        "name_en": "Nong lan",
        "zip_codes": [
            71130
        ],
        "district_id": 7105
    },
    {
        "id": 710601,
        "name_th": "ท่าม่วง",
        "name_en": "Tha Muang",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710602,
        "name_th": "วังขนาย",
        "name_en": "Wang Khanai",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710603,
        "name_th": "วังศาลา",
        "name_en": "Wang Sala",
        "zip_codes": [
            71110,
            71130
        ],
        "district_id": 7106
    },
    {
        "id": 710604,
        "name_th": "ท่าล้อ",
        "name_en": "Tha Lo",
        "zip_codes": [
            71000,
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710605,
        "name_th": "หนองขาว",
        "name_en": "Nong Khao",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710606,
        "name_th": "ทุ่งทอง",
        "name_en": "Thung Thong",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710607,
        "name_th": "เขาน้อย",
        "name_en": "Khao Noi",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710608,
        "name_th": "ม่วงชุม",
        "name_en": "Muang Chum",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710609,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710610,
        "name_th": "พังตรุ",
        "name_en": "Phang Tru",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710611,
        "name_th": "ท่าตะคร้อ",
        "name_en": "Tha Takro",
        "zip_codes": [
            71130
        ],
        "district_id": 7106
    },
    {
        "id": 710612,
        "name_th": "รางสาลี่",
        "name_en": "Rang Sali",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710613,
        "name_th": "หนองตากยา",
        "name_en": "Nong Tak Ya",
        "zip_codes": [
            71110
        ],
        "district_id": 7106
    },
    {
        "id": 710701,
        "name_th": "ท่าขนุน",
        "name_en": "Tha Khanun",
        "zip_codes": [
            71180
        ],
        "district_id": 7107
    },
    {
        "id": 710702,
        "name_th": "ปิล๊อก",
        "name_en": "Pilok",
        "zip_codes": [
            71180
        ],
        "district_id": 7107
    },
    {
        "id": 710703,
        "name_th": "หินดาด",
        "name_en": "Hin Dat",
        "zip_codes": [
            71180
        ],
        "district_id": 7107
    },
    {
        "id": 710704,
        "name_th": "ลิ่นถิ่น",
        "name_en": "Linthin",
        "zip_codes": [
            71180
        ],
        "district_id": 7107
    },
    {
        "id": 710705,
        "name_th": "ชะแล",
        "name_en": "Chalae",
        "zip_codes": [
            71180
        ],
        "district_id": 7107
    },
    {
        "id": 710706,
        "name_th": "ห้วยเขย่ง",
        "name_en": "Huai Khayeng",
        "zip_codes": [
            71180
        ],
        "district_id": 7107
    },
    {
        "id": 710707,
        "name_th": "สหกรณ์นิคม",
        "name_en": "Sahakon Nikhom",
        "zip_codes": [
            71180
        ],
        "district_id": 7107
    },
    {
        "id": 710801,
        "name_th": "หนองลู",
        "name_en": "Nong Lu",
        "zip_codes": [
            71240
        ],
        "district_id": 7108
    },
    {
        "id": 710802,
        "name_th": "ปรังเผล",
        "name_en": "Prang Phle",
        "zip_codes": [
            71240
        ],
        "district_id": 7108
    },
    {
        "id": 710803,
        "name_th": "ไล่โว่",
        "name_en": "Laiwo",
        "zip_codes": [
            71240
        ],
        "district_id": 7108
    },
    {
        "id": 710901,
        "name_th": "พนมทวน",
        "name_en": "Phanom Thuan",
        "zip_codes": [
            71140
        ],
        "district_id": 7109
    },
    {
        "id": 710902,
        "name_th": "หนองโรง",
        "name_en": "Nong Rong",
        "zip_codes": [
            71140
        ],
        "district_id": 7109
    },
    {
        "id": 710903,
        "name_th": "ทุ่งสมอ",
        "name_en": "Thung Samo",
        "zip_codes": [
            71140
        ],
        "district_id": 7109
    },
    {
        "id": 710904,
        "name_th": "ดอนเจดีย์",
        "name_en": "Don Chedi",
        "zip_codes": [
            71140
        ],
        "district_id": 7109
    },
    {
        "id": 710905,
        "name_th": "พังตรุ",
        "name_en": "Phang Tru",
        "zip_codes": [
            71140
        ],
        "district_id": 7109
    },
    {
        "id": 710906,
        "name_th": "รางหวาย",
        "name_en": "Rang Wai",
        "zip_codes": [
            71170
        ],
        "district_id": 7109
    },
    {
        "id": 710911,
        "name_th": "หนองสาหร่าย",
        "name_en": "Nong Sarai",
        "zip_codes": [
            71140
        ],
        "district_id": 7109
    },
    {
        "id": 710912,
        "name_th": "ดอนตาเพชร",
        "name_en": "Don Ta Phet",
        "zip_codes": [
            71140
        ],
        "district_id": 7109
    },
    {
        "id": 711001,
        "name_th": "เลาขวัญ",
        "name_en": "Lao Khwan",
        "zip_codes": [
            71210
        ],
        "district_id": 7110
    },
    {
        "id": 711002,
        "name_th": "หนองโสน",
        "name_en": "Nong Sano",
        "zip_codes": [
            71210
        ],
        "district_id": 7110
    },
    {
        "id": 711003,
        "name_th": "หนองประดู่",
        "name_en": "Nong Pradu",
        "zip_codes": [
            71210
        ],
        "district_id": 7110
    },
    {
        "id": 711004,
        "name_th": "หนองปลิง",
        "name_en": "Nong Pling",
        "zip_codes": [
            71210
        ],
        "district_id": 7110
    },
    {
        "id": 711005,
        "name_th": "หนองนกแก้ว",
        "name_en": "Nong Nok Kaeo",
        "zip_codes": [
            71210
        ],
        "district_id": 7110
    },
    {
        "id": 711006,
        "name_th": "ทุ่งกระบ่ำ",
        "name_en": "Thung Krabam",
        "zip_codes": [
            71210
        ],
        "district_id": 7110
    },
    {
        "id": 711007,
        "name_th": "หนองฝ้าย",
        "name_en": "Nong Fai",
        "zip_codes": [
            71210
        ],
        "district_id": 7110
    },
    {
        "id": 711101,
        "name_th": "ด่านมะขามเตี้ย",
        "name_en": "Dan Makham Tia",
        "zip_codes": [
            71260
        ],
        "district_id": 7111
    },
    {
        "id": 711102,
        "name_th": "กลอนโด",
        "name_en": "Klon Do",
        "zip_codes": [
            71260
        ],
        "district_id": 7111
    },
    {
        "id": 711103,
        "name_th": "จรเข้เผือก",
        "name_en": "Chorakhe Phueak",
        "zip_codes": [
            71260
        ],
        "district_id": 7111
    },
    {
        "id": 711104,
        "name_th": "หนองไผ่",
        "name_en": "Nong Phai",
        "zip_codes": [
            71260
        ],
        "district_id": 7111
    },
    {
        "id": 711201,
        "name_th": "หนองปรือ",
        "name_en": "Nong Prue",
        "zip_codes": [
            71220
        ],
        "district_id": 7112
    },
    {
        "id": 711202,
        "name_th": "หนองปลาไหล",
        "name_en": "Nong Pla Lai",
        "zip_codes": [
            71220
        ],
        "district_id": 7112
    },
    {
        "id": 711203,
        "name_th": "สมเด็จเจริญ",
        "name_en": "Somdet Charoen",
        "zip_codes": [
            71220
        ],
        "district_id": 7112
    },
    {
        "id": 711301,
        "name_th": "ห้วยกระเจา",
        "name_en": "Huai Krachao",
        "zip_codes": [
            71170
        ],
        "district_id": 7113
    },
    {
        "id": 711302,
        "name_th": "วังไผ่",
        "name_en": "Wang Phai",
        "zip_codes": [
            71170
        ],
        "district_id": 7113
    },
    {
        "id": 711303,
        "name_th": "ดอนแสลบ",
        "name_en": "Don Salaep",
        "zip_codes": [
            71170
        ],
        "district_id": 7113
    },
    {
        "id": 711304,
        "name_th": "สระลงเรือ",
        "name_en": "Sa Long Ruea",
        "zip_codes": [
            71170
        ],
        "district_id": 7113
    },
    {
        "id": 720101,
        "name_th": "ท่าพี่เลี้ยง",
        "name_en": "Tha Phi Liang",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720102,
        "name_th": "รั้วใหญ่",
        "name_en": "Rua Yai",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720103,
        "name_th": "ทับตีเหล็ก",
        "name_en": "Thap Ti Lek",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720104,
        "name_th": "ท่าระหัด",
        "name_en": "Tha Rahat",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720105,
        "name_th": "ไผ่ขวาง",
        "name_en": "Phai Khwang",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720106,
        "name_th": "โคกโคเฒ่า",
        "name_en": "Khok Kho Thao",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720107,
        "name_th": "ดอนตาล",
        "name_en": "Don Tan",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720108,
        "name_th": "ดอนมะสังข์",
        "name_en": "Don Masang",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720109,
        "name_th": "พิหารแดง",
        "name_en": "Phihan Daeng",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720110,
        "name_th": "ดอนกำยาน",
        "name_en": "Don Kamyan",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720111,
        "name_th": "ดอนโพธิ์ทอง",
        "name_en": "Don Pho Thong",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720112,
        "name_th": "บ้านโพธิ์",
        "name_en": "Bang Pho",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720113,
        "name_th": "สระแก้ว",
        "name_en": "Sa Kaeo",
        "zip_codes": [
            72230
        ],
        "district_id": 7201
    },
    {
        "id": 720114,
        "name_th": "ตลิ่งชัน",
        "name_en": "Taling Chan",
        "zip_codes": [
            72230
        ],
        "district_id": 7201
    },
    {
        "id": 720115,
        "name_th": "บางกุ้ง",
        "name_en": "Bang Kung",
        "zip_codes": [
            72210
        ],
        "district_id": 7201
    },
    {
        "id": 720116,
        "name_th": "ศาลาขาว",
        "name_en": "Sala Khao",
        "zip_codes": [
            72210
        ],
        "district_id": 7201
    },
    {
        "id": 720117,
        "name_th": "สวนแตง",
        "name_en": "Suan Taeng",
        "zip_codes": [
            72210
        ],
        "district_id": 7201
    },
    {
        "id": 720118,
        "name_th": "สนามชัย",
        "name_en": "Sanam Chai",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720119,
        "name_th": "โพธิ์พระยา",
        "name_en": "Pho Phraya",
        "zip_codes": [
            72000
        ],
        "district_id": 7201
    },
    {
        "id": 720120,
        "name_th": "สนามคลี",
        "name_en": "Sanam Khli",
        "zip_codes": [
            72230
        ],
        "district_id": 7201
    },
    {
        "id": 720201,
        "name_th": "เขาพระ",
        "name_en": "Khao Phra",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720202,
        "name_th": "เดิมบาง",
        "name_en": "Doem Bang",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720203,
        "name_th": "นางบวช",
        "name_en": "Nang Buat",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720204,
        "name_th": "เขาดิน",
        "name_en": "Khao Din",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720205,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720206,
        "name_th": "ทุ่งคลี",
        "name_en": "Thung Khli",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720207,
        "name_th": "โคกช้าง",
        "name_en": "Khok Chang",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720208,
        "name_th": "หัวเขา",
        "name_en": "Hua Khao",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720209,
        "name_th": "หัวนา",
        "name_en": "Hua Na",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720210,
        "name_th": "บ่อกรุ",
        "name_en": "Bo Kru",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720211,
        "name_th": "วังศรีราช",
        "name_en": "Wang Si Rat",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720212,
        "name_th": "ป่าสะแก",
        "name_en": "Pa Sakae",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720213,
        "name_th": "ยางนอน",
        "name_en": "Yang Non",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720214,
        "name_th": "หนองกระทุ่ม",
        "name_en": "Nong Krathum",
        "zip_codes": [
            72120
        ],
        "district_id": 7202
    },
    {
        "id": 720301,
        "name_th": "หนองมะค่าโมง",
        "name_en": "Nong Makha Mong",
        "zip_codes": [
            72180
        ],
        "district_id": 7203
    },
    {
        "id": 720302,
        "name_th": "ด่านช้าง",
        "name_en": "Dan Chang",
        "zip_codes": [
            72180
        ],
        "district_id": 7203
    },
    {
        "id": 720303,
        "name_th": "ห้วยขมิ้น",
        "name_en": "Huai Khamin",
        "zip_codes": [
            72180
        ],
        "district_id": 7203
    },
    {
        "id": 720304,
        "name_th": "องค์พระ",
        "name_en": "Ong Phra",
        "zip_codes": [
            72180
        ],
        "district_id": 7203
    },
    {
        "id": 720305,
        "name_th": "วังคัน",
        "name_en": "Wang Khan",
        "zip_codes": [
            72180
        ],
        "district_id": 7203
    },
    {
        "id": 720306,
        "name_th": "นิคมกระเสียว",
        "name_en": "Nikhom Krasiao",
        "zip_codes": [
            72180
        ],
        "district_id": 7203
    },
    {
        "id": 720307,
        "name_th": "วังยาว",
        "name_en": "Wang Yao",
        "zip_codes": [
            72180
        ],
        "district_id": 7203
    },
    {
        "id": 720401,
        "name_th": "โคกคราม",
        "name_en": "Khok Khram",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720402,
        "name_th": "บางปลาม้า",
        "name_en": "Bang Pla Ma",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720403,
        "name_th": "ตะค่า",
        "name_en": "Takha",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720404,
        "name_th": "บางใหญ่",
        "name_en": "Bang Yai",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720405,
        "name_th": "กฤษณา",
        "name_en": "Kritsana",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720406,
        "name_th": "สาลี",
        "name_en": "Sali",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720407,
        "name_th": "ไผ่กองดิน",
        "name_en": "Phai Kong Din",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720408,
        "name_th": "องครักษ์",
        "name_en": "Ongkharak",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720409,
        "name_th": "จรเข้ใหญ่",
        "name_en": "Chorakhe Yai",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720410,
        "name_th": "บ้านแหลม",
        "name_en": "Ban Laem",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720411,
        "name_th": "มะขามล้ม",
        "name_en": "Makham Lom",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720412,
        "name_th": "วังน้ำเย็น",
        "name_en": "Wang Nam Yen",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720413,
        "name_th": "วัดโบสถ์",
        "name_en": "Wat Bot",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720414,
        "name_th": "วัดดาว",
        "name_en": "Wat Dao",
        "zip_codes": [
            72150
        ],
        "district_id": 7204
    },
    {
        "id": 720501,
        "name_th": "ศรีประจันต์",
        "name_en": "Si Prachan",
        "zip_codes": [
            72140
        ],
        "district_id": 7205
    },
    {
        "id": 720502,
        "name_th": "บ้านกร่าง",
        "name_en": "Ban Krang",
        "zip_codes": [
            72140
        ],
        "district_id": 7205
    },
    {
        "id": 720503,
        "name_th": "มดแดง",
        "name_en": "Mot Daeng",
        "zip_codes": [
            72140
        ],
        "district_id": 7205
    },
    {
        "id": 720504,
        "name_th": "บางงาม",
        "name_en": "Bang Ngam",
        "zip_codes": [
            72140
        ],
        "district_id": 7205
    },
    {
        "id": 720505,
        "name_th": "ดอนปรู",
        "name_en": "Don Pru",
        "zip_codes": [
            72140
        ],
        "district_id": 7205
    },
    {
        "id": 720506,
        "name_th": "ปลายนา",
        "name_en": "Plai Na",
        "zip_codes": [
            72140
        ],
        "district_id": 7205
    },
    {
        "id": 720507,
        "name_th": "วังหว้า",
        "name_en": "Wang Wa",
        "zip_codes": [
            72140
        ],
        "district_id": 7205
    },
    {
        "id": 720508,
        "name_th": "วังน้ำซับ",
        "name_en": "Wang Nam Sap",
        "zip_codes": [
            72140
        ],
        "district_id": 7205
    },
    {
        "id": 720509,
        "name_th": "วังยาง",
        "name_en": "Wang Yang",
        "zip_codes": [
            72140
        ],
        "district_id": 7205
    },
    {
        "id": 720601,
        "name_th": "ดอนเจดีย์",
        "name_en": "Don Chedi",
        "zip_codes": [
            72170
        ],
        "district_id": 7206
    },
    {
        "id": 720602,
        "name_th": "หนองสาหร่าย",
        "name_en": "Nong Sarai",
        "zip_codes": [
            72170
        ],
        "district_id": 7206
    },
    {
        "id": 720603,
        "name_th": "ไร่รถ",
        "name_en": "Rai Rot",
        "zip_codes": [
            72170
        ],
        "district_id": 7206
    },
    {
        "id": 720604,
        "name_th": "สระกระโจม",
        "name_en": "Sa Krachom",
        "zip_codes": [
            72250
        ],
        "district_id": 7206
    },
    {
        "id": 720605,
        "name_th": "ทะเลบก",
        "name_en": "Thale Bok",
        "zip_codes": [
            72170,
            72250
        ],
        "district_id": 7206
    },
    {
        "id": 720701,
        "name_th": "สองพี่น้อง",
        "name_en": "Song Phi Nong",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720702,
        "name_th": "บางเลน",
        "name_en": "Bang Len",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720703,
        "name_th": "บางตาเถร",
        "name_en": "Bang Ta Then",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720704,
        "name_th": "บางตะเคียน",
        "name_en": "Bang Takhian",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720705,
        "name_th": "บ้านกุ่ม",
        "name_en": "Ban Kum",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720706,
        "name_th": "หัวโพธิ์",
        "name_en": "Hua Pho",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720707,
        "name_th": "บางพลับ",
        "name_en": "Bang Phlap",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720708,
        "name_th": "เนินพระปรางค์",
        "name_en": "Noen Phra Prang",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720709,
        "name_th": "บ้านช้าง",
        "name_en": "Ban Chang",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720710,
        "name_th": "ต้นตาล",
        "name_en": "Ton Tan",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720711,
        "name_th": "ศรีสำราญ",
        "name_en": "Si Samran",
        "zip_codes": [
            72110,
            72190
        ],
        "district_id": 7207
    },
    {
        "id": 720712,
        "name_th": "ทุ่งคอก",
        "name_en": "Thung Khok",
        "zip_codes": [
            72110,
            72190
        ],
        "district_id": 7207
    },
    {
        "id": 720713,
        "name_th": "หนองบ่อ",
        "name_en": "Nong Bo",
        "zip_codes": [
            71170,
            72190
        ],
        "district_id": 7207
    },
    {
        "id": 720714,
        "name_th": "บ่อสุพรรณ",
        "name_en": "Bo Suphan",
        "zip_codes": [
            72190
        ],
        "district_id": 7207
    },
    {
        "id": 720715,
        "name_th": "ดอนมะนาว",
        "name_en": "Don Manao",
        "zip_codes": [
            72110
        ],
        "district_id": 7207
    },
    {
        "id": 720801,
        "name_th": "ย่านยาว",
        "name_en": "Yan Yao",
        "zip_codes": [
            72130
        ],
        "district_id": 7208
    },
    {
        "id": 720802,
        "name_th": "วังลึก",
        "name_en": "Wang Luek",
        "zip_codes": [
            72130
        ],
        "district_id": 7208
    },
    {
        "id": 720803,
        "name_th": "สามชุก",
        "name_en": "Sam Chuk",
        "zip_codes": [
            72130
        ],
        "district_id": 7208
    },
    {
        "id": 720804,
        "name_th": "หนองผักนาก",
        "name_en": "Nong Phak Nak",
        "zip_codes": [
            72130
        ],
        "district_id": 7208
    },
    {
        "id": 720805,
        "name_th": "บ้านสระ",
        "name_en": "Ban Sa",
        "zip_codes": [
            72130
        ],
        "district_id": 7208
    },
    {
        "id": 720806,
        "name_th": "หนองสะเดา",
        "name_en": "Nong Sadao",
        "zip_codes": [
            72130
        ],
        "district_id": 7208
    },
    {
        "id": 720807,
        "name_th": "กระเสียว",
        "name_en": "Krasiao",
        "zip_codes": [
            72130
        ],
        "district_id": 7208
    },
    {
        "id": 720901,
        "name_th": "อู่ทอง",
        "name_en": "U Thong",
        "zip_codes": [
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 720902,
        "name_th": "สระยายโสม",
        "name_en": "Sa Yai Som",
        "zip_codes": [
            72220
        ],
        "district_id": 7209
    },
    {
        "id": 720903,
        "name_th": "จรเข้สามพัน",
        "name_en": "Chorakhe Sam Phan",
        "zip_codes": [
            71170,
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 720904,
        "name_th": "บ้านดอน",
        "name_en": "Ban Don",
        "zip_codes": [
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 720905,
        "name_th": "ยุ้งทะลาย",
        "name_en": "Yung Thalai",
        "zip_codes": [
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 720906,
        "name_th": "ดอนมะเกลือ",
        "name_en": "Don Makluea",
        "zip_codes": [
            72220
        ],
        "district_id": 7209
    },
    {
        "id": 720907,
        "name_th": "หนองโอ่ง",
        "name_en": "Nong Ong",
        "zip_codes": [
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 720908,
        "name_th": "ดอนคา",
        "name_en": "Don Kha",
        "zip_codes": [
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 720909,
        "name_th": "พลับพลาไชย",
        "name_en": "Phlapphla Chai",
        "zip_codes": [
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 720910,
        "name_th": "บ้านโข้ง",
        "name_en": "Ban Khong",
        "zip_codes": [
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 720911,
        "name_th": "เจดีย์",
        "name_en": "Chedi",
        "zip_codes": [
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 720912,
        "name_th": "สระพังลาน",
        "name_en": "Sa Phang Lan",
        "zip_codes": [
            72220
        ],
        "district_id": 7209
    },
    {
        "id": 720913,
        "name_th": "กระจัน",
        "name_en": "Krachan",
        "zip_codes": [
            72160
        ],
        "district_id": 7209
    },
    {
        "id": 721001,
        "name_th": "หนองหญ้าไซ",
        "name_en": "Nong Ya Sai",
        "zip_codes": [
            72240
        ],
        "district_id": 7210
    },
    {
        "id": 721002,
        "name_th": "หนองราชวัตร",
        "name_en": "Nong Ratchawat",
        "zip_codes": [
            72240
        ],
        "district_id": 7210
    },
    {
        "id": 721003,
        "name_th": "หนองโพธิ์",
        "name_en": "Nong Pho",
        "zip_codes": [
            72240
        ],
        "district_id": 7210
    },
    {
        "id": 721004,
        "name_th": "แจงงาม",
        "name_en": "Chaeng Ngam",
        "zip_codes": [
            72240
        ],
        "district_id": 7210
    },
    {
        "id": 721005,
        "name_th": "หนองขาม",
        "name_en": "Nong Kham",
        "zip_codes": [
            72240
        ],
        "district_id": 7210
    },
    {
        "id": 721006,
        "name_th": "ทัพหลวง",
        "name_en": "Thap Luang",
        "zip_codes": [
            72240
        ],
        "district_id": 7210
    },
    {
        "id": 730101,
        "name_th": "พระปฐมเจดีย์",
        "name_en": "Phra Pathom Chedi",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730102,
        "name_th": "บางแขม",
        "name_en": "Bang Khaem",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730103,
        "name_th": "พระประโทน",
        "name_en": "Phra Prathon",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730104,
        "name_th": "ธรรมศาลา",
        "name_en": "Thammasala",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730105,
        "name_th": "ตาก้อง",
        "name_en": "Ta Kong",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730106,
        "name_th": "มาบแค",
        "name_en": "Map Khae",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730107,
        "name_th": "สนามจันทร์",
        "name_en": "Sanam Chan",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730108,
        "name_th": "ดอนยายหอม",
        "name_en": "Don Yai Hom",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730109,
        "name_th": "ถนนขาด",
        "name_en": "Thanon Khat",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730110,
        "name_th": "บ่อพลับ",
        "name_en": "Bo Phlap",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730111,
        "name_th": "นครปฐม",
        "name_en": "Nakhon Pathom",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730112,
        "name_th": "วังตะกู",
        "name_en": "Wang Taku",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730113,
        "name_th": "หนองปากโลง",
        "name_en": "Nong Pak Long",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730114,
        "name_th": "สามควายเผือก",
        "name_en": "Sam Khwai Phueak",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730115,
        "name_th": "ทุ่งน้อย",
        "name_en": "Thung Noi",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730116,
        "name_th": "หนองดินแดง",
        "name_en": "Nong Din Daeng",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730117,
        "name_th": "วังเย็น",
        "name_en": "Wang Yen",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730118,
        "name_th": "โพรงมะเดื่อ",
        "name_en": "Phrong Maduea",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730119,
        "name_th": "ลำพยา",
        "name_en": "Lam Phaya",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730120,
        "name_th": "สระกะเทียม",
        "name_en": "Sra Kathiam",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730121,
        "name_th": "สวนป่าน",
        "name_en": "Suan Pan",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730122,
        "name_th": "ห้วยจรเข้",
        "name_en": "Huai Chorakhe",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730123,
        "name_th": "ทัพหลวง",
        "name_en": "Thap Luang",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730124,
        "name_th": "หนองงูเหลือม",
        "name_en": "Nong Ngu Lueam",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730125,
        "name_th": "บ้านยาง",
        "name_en": "Ban Yang",
        "zip_codes": [
            73000
        ],
        "district_id": 7301
    },
    {
        "id": 730201,
        "name_th": "ทุ่งกระพังโหม",
        "name_en": "Thung Kraphang Hom",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730202,
        "name_th": "กระตีบ",
        "name_en": "Kratip",
        "zip_codes": [
            73180
        ],
        "district_id": 7302
    },
    {
        "id": 730203,
        "name_th": "ทุ่งลูกนก",
        "name_en": "Thung Luk Nok",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730204,
        "name_th": "ห้วยขวาง",
        "name_en": "Huai Khwang",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730205,
        "name_th": "ทุ่งขวาง",
        "name_en": "Thung Khwang",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730206,
        "name_th": "สระสี่มุม",
        "name_en": "Sa Si Mum",
        "zip_codes": [
            73140,
            73180
        ],
        "district_id": 7302
    },
    {
        "id": 730207,
        "name_th": "ทุ่งบัว",
        "name_en": "Thung Bua",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730208,
        "name_th": "ดอนข่อย",
        "name_en": "Don Khoi",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730209,
        "name_th": "สระพัฒนา",
        "name_en": "Sa Phatthana",
        "zip_codes": [
            73180
        ],
        "district_id": 7302
    },
    {
        "id": 730210,
        "name_th": "ห้วยหมอนทอง",
        "name_en": "Huai Mon Thong",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730211,
        "name_th": "ห้วยม่วง",
        "name_en": "huai Muang",
        "zip_codes": [
            73180
        ],
        "district_id": 7302
    },
    {
        "id": 730212,
        "name_th": "กำแพงแสน",
        "name_en": "Kamphaeng Saen",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730213,
        "name_th": "รางพิกุล",
        "name_en": "Rang Phikun",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730214,
        "name_th": "หนองกระทุ่ม",
        "name_en": "Nong Krathum",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730215,
        "name_th": "วังน้ำเขียว",
        "name_en": "Wang Nam Khiao",
        "zip_codes": [
            73140
        ],
        "district_id": 7302
    },
    {
        "id": 730301,
        "name_th": "นครชัยศรี",
        "name_en": "Nakhon Chai Si",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730302,
        "name_th": "บางกระเบา",
        "name_en": "Bang Krabao",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730303,
        "name_th": "วัดแค",
        "name_en": "Wat Khae",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730304,
        "name_th": "ท่าตำหนัก",
        "name_en": "Tha Tamnak",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730305,
        "name_th": "บางแก้ว",
        "name_en": "Bang Kaeo",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730306,
        "name_th": "ท่ากระชับ",
        "name_en": "Tha Krachap",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730307,
        "name_th": "ขุนแก้ว",
        "name_en": "Khun Kaeo",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730308,
        "name_th": "ท่าพระยา",
        "name_en": "Tha Phraya",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730309,
        "name_th": "พะเนียด",
        "name_en": "Phaniat",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730310,
        "name_th": "บางระกำ",
        "name_en": "Bang Rakam",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730311,
        "name_th": "โคกพระเจดีย์",
        "name_en": "Khok Phra Chedi",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730312,
        "name_th": "ศรีษะทอง",
        "name_en": "Sisa Thong",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730313,
        "name_th": "แหลมบัว",
        "name_en": "Laem Bua",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730314,
        "name_th": "ศรีมหาโพธิ์",
        "name_en": "Si Maha Pho",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730315,
        "name_th": "สัมปทวน",
        "name_en": "Sampathuan",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730316,
        "name_th": "วัดสำโรง",
        "name_en": "Wat Samrong",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730317,
        "name_th": "ดอนแฝก",
        "name_en": "Don Faek",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730318,
        "name_th": "ห้วยพลู",
        "name_en": "Huai Phlu",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730319,
        "name_th": "วัดละมุด",
        "name_en": "Wat Lamut",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730320,
        "name_th": "บางพระ",
        "name_en": "Bang Phra",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730321,
        "name_th": "บางแก้วฟ้า",
        "name_en": "Bang Kaeo Fa",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730322,
        "name_th": "ลานตากฟ้า",
        "name_en": "Lan Tak Fa",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730323,
        "name_th": "งิ้วราย",
        "name_en": "Ngio Rai",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730324,
        "name_th": "ไทยาวาส",
        "name_en": "Thaiyawat",
        "zip_codes": [
            73120
        ],
        "district_id": 7303
    },
    {
        "id": 730401,
        "name_th": "สามง่าม",
        "name_en": "Sam Ngam",
        "zip_codes": [
            73150
        ],
        "district_id": 7304
    },
    {
        "id": 730402,
        "name_th": "ห้วยพระ",
        "name_en": "Huai Phra",
        "zip_codes": [
            73150
        ],
        "district_id": 7304
    },
    {
        "id": 730403,
        "name_th": "ลำเหย",
        "name_en": "Lam Hoei",
        "zip_codes": [
            73150
        ],
        "district_id": 7304
    },
    {
        "id": 730404,
        "name_th": "ดอนพุทรา",
        "name_en": "Don Phutsa",
        "zip_codes": [
            73150
        ],
        "district_id": 7304
    },
    {
        "id": 730405,
        "name_th": "บ้านหลวง",
        "name_en": "Ban Luang",
        "zip_codes": [
            73150
        ],
        "district_id": 7304
    },
    {
        "id": 730406,
        "name_th": "ดอนรวก",
        "name_en": "Don Ruak",
        "zip_codes": [
            73150
        ],
        "district_id": 7304
    },
    {
        "id": 730407,
        "name_th": "ห้วยด้วน",
        "name_en": "Huai Duan",
        "zip_codes": [
            73150
        ],
        "district_id": 7304
    },
    {
        "id": 730408,
        "name_th": "ลำลูกบัว",
        "name_en": "Lam Luk Bua",
        "zip_codes": [
            73150
        ],
        "district_id": 7304
    },
    {
        "id": 730501,
        "name_th": "บางเลน",
        "name_en": "Bang Len",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730502,
        "name_th": "บางปลา",
        "name_en": "Bang Pla",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730503,
        "name_th": "บางหลวง",
        "name_en": "Bang Luang",
        "zip_codes": [
            73190
        ],
        "district_id": 7305
    },
    {
        "id": 730504,
        "name_th": "บางภาษี",
        "name_en": "Bang Phasi",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730505,
        "name_th": "บางระกำ",
        "name_en": "Bang Rakam",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730506,
        "name_th": "บางไทรป่า",
        "name_en": "Bang Sai Pa",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730507,
        "name_th": "หินมูล",
        "name_en": "Hin Mun",
        "zip_codes": [
            73190
        ],
        "district_id": 7305
    },
    {
        "id": 730508,
        "name_th": "ไทรงาม",
        "name_en": "Sai Ngam",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730509,
        "name_th": "ดอนตูม",
        "name_en": "Don Tum",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730510,
        "name_th": "นิลเพชร",
        "name_en": "Nin Phet",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730511,
        "name_th": "บัวปากท่า",
        "name_en": "Bua Pak Tha",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730512,
        "name_th": "คลองนกกระทุง",
        "name_en": "Khlong Nok Krathung",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730513,
        "name_th": "นราภิรมย์",
        "name_en": "Naraphirom",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730514,
        "name_th": "ลำพญา",
        "name_en": "Lam Phaya",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730515,
        "name_th": "ไผ่หูช้าง",
        "name_en": "Phai Hu Chang",
        "zip_codes": [
            73130
        ],
        "district_id": 7305
    },
    {
        "id": 730601,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730602,
        "name_th": "ทรงคนอง",
        "name_en": "Song Khanong",
        "zip_codes": [
            73210
        ],
        "district_id": 7306
    },
    {
        "id": 730603,
        "name_th": "หอมเกร็ด",
        "name_en": "Hom Kret",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730604,
        "name_th": "บางกระทึก",
        "name_en": "Bang Krathuek",
        "zip_codes": [
            73210
        ],
        "district_id": 7306
    },
    {
        "id": 730605,
        "name_th": "บางเตย",
        "name_en": "Bang Toei",
        "zip_codes": [
            73210
        ],
        "district_id": 7306
    },
    {
        "id": 730606,
        "name_th": "สามพราน",
        "name_en": "Sam Phran",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730607,
        "name_th": "บางช้าง",
        "name_en": "Bang Chang",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730608,
        "name_th": "ไร่ขิง",
        "name_en": "Rai Khing",
        "zip_codes": [
            73210
        ],
        "district_id": 7306
    },
    {
        "id": 730609,
        "name_th": "ท่าตลาด",
        "name_en": "Tha Talat",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730610,
        "name_th": "กระทุ่มล้ม",
        "name_en": "Krathum Lom",
        "zip_codes": [
            73220
        ],
        "district_id": 7306
    },
    {
        "id": 730611,
        "name_th": "คลองใหม่",
        "name_en": "Khlong Mai",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730612,
        "name_th": "ตลาดจินดา",
        "name_en": "Talat Chinda",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730613,
        "name_th": "คลองจินดา",
        "name_en": "Khlong Chinda",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730614,
        "name_th": "ยายชา",
        "name_en": "Yai Cha",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730615,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            73110
        ],
        "district_id": 7306
    },
    {
        "id": 730616,
        "name_th": "อ้อมใหญ่",
        "name_en": "Om Yai",
        "zip_codes": [
            73160
        ],
        "district_id": 7306
    },
    {
        "id": 730701,
        "name_th": "ศาลายา",
        "name_en": "Salaya",
        "zip_codes": [
            73170
        ],
        "district_id": 7307
    },
    {
        "id": 730702,
        "name_th": "คลองโยง",
        "name_en": "Khlong Yong",
        "zip_codes": [
            73170
        ],
        "district_id": 7307
    },
    {
        "id": 730703,
        "name_th": "มหาสวัสดิ์",
        "name_en": "Maha Sawat",
        "zip_codes": [
            73170
        ],
        "district_id": 7307
    },
    {
        "id": 740101,
        "name_th": "มหาชัย",
        "name_en": "Maha Chai",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740102,
        "name_th": "ท่าฉลอม",
        "name_en": "Tha Chalom",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740103,
        "name_th": "โกรกกราก",
        "name_en": "Krokkrak",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740104,
        "name_th": "บ้านบ่อ",
        "name_en": "Ban Bo",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740105,
        "name_th": "บางโทรัด",
        "name_en": "Bang Tho Rat",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740106,
        "name_th": "กาหลง",
        "name_en": "Kalong",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740107,
        "name_th": "นาโคก",
        "name_en": "Na Khok",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740108,
        "name_th": "ท่าจีน",
        "name_en": "Tha Chin",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740109,
        "name_th": "นาดี",
        "name_en": "Na Di",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740110,
        "name_th": "ท่าทราย",
        "name_en": "Tha Sai",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740111,
        "name_th": "คอกกระบือ",
        "name_en": "Khok Krabue",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740112,
        "name_th": "บางน้ำจืด",
        "name_en": "Bang Nam Chuet",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740113,
        "name_th": "พันท้ายนรสิงห์",
        "name_en": "Phan Thai Norasing",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740114,
        "name_th": "โคกขาม",
        "name_en": "Khok Kham",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740115,
        "name_th": "บ้านเกาะ",
        "name_en": "Ban Ko",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740116,
        "name_th": "บางกระเจ้า",
        "name_en": "Bang Krachao",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740117,
        "name_th": "บางหญ้าแพรก",
        "name_en": "Bang Ya Phraek",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740118,
        "name_th": "ชัยมงคล",
        "name_en": "Chai Mongkon",
        "zip_codes": [
            74000
        ],
        "district_id": 7401
    },
    {
        "id": 740201,
        "name_th": "ตลาดกระทุ่มแบน",
        "name_en": "Talad Krathum Baen",
        "zip_codes": [
            74110
        ],
        "district_id": 7402
    },
    {
        "id": 740202,
        "name_th": "อ้อมน้อย",
        "name_en": "Om Noi",
        "zip_codes": [
            74130
        ],
        "district_id": 7402
    },
    {
        "id": 740203,
        "name_th": "ท่าไม้",
        "name_en": "Tha Mai",
        "zip_codes": [
            74110
        ],
        "district_id": 7402
    },
    {
        "id": 740204,
        "name_th": "สวนหลวง",
        "name_en": "Suan Luang",
        "zip_codes": [
            74110
        ],
        "district_id": 7402
    },
    {
        "id": 740205,
        "name_th": "บางยาง",
        "name_en": "Bang Yang",
        "zip_codes": [
            74110
        ],
        "district_id": 7402
    },
    {
        "id": 740206,
        "name_th": "คลองมะเดื่อ",
        "name_en": "Khlong Maduea",
        "zip_codes": [
            74110
        ],
        "district_id": 7402
    },
    {
        "id": 740207,
        "name_th": "หนองนกไข่",
        "name_en": "Nong Nok Khai",
        "zip_codes": [
            74110
        ],
        "district_id": 7402
    },
    {
        "id": 740208,
        "name_th": "ดอนไก่ดี",
        "name_en": "Don Kai Di",
        "zip_codes": [
            74110
        ],
        "district_id": 7402
    },
    {
        "id": 740209,
        "name_th": "แคราย",
        "name_en": "Khae Rai",
        "zip_codes": [
            74110
        ],
        "district_id": 7402
    },
    {
        "id": 740210,
        "name_th": "ท่าเสา",
        "name_en": "Tha Sao",
        "zip_codes": [
            74110
        ],
        "district_id": 7402
    },
    {
        "id": 740301,
        "name_th": "บ้านแพ้ว",
        "name_en": "Ban Phaeo",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740302,
        "name_th": "หลักสาม",
        "name_en": "Lak Sam",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740303,
        "name_th": "ยกกระบัตร",
        "name_en": "Yokkrabat",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740304,
        "name_th": "โรงเข้",
        "name_en": "Rong Khe",
        "zip_codes": [
            70210,
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740305,
        "name_th": "หนองสองห้อง",
        "name_en": "Nong Song Hong",
        "zip_codes": [
            70210,
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740306,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740307,
        "name_th": "หลักสอง",
        "name_en": "Lak Song",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740308,
        "name_th": "เจ็ดริ้ว",
        "name_en": "Chet Rio",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740309,
        "name_th": "คลองตัน",
        "name_en": "Khlong Tan",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740310,
        "name_th": "อำแพง",
        "name_en": "Amphaeng",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740311,
        "name_th": "สวนส้ม",
        "name_en": "Suan Som",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 740312,
        "name_th": "เกษตรพัฒนา",
        "name_en": "Kaset Phatthana",
        "zip_codes": [
            74120
        ],
        "district_id": 7403
    },
    {
        "id": 750101,
        "name_th": "แม่กลอง",
        "name_en": "Mae Klong",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750102,
        "name_th": "บางขันแตก",
        "name_en": "Bang Khan Taek",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750103,
        "name_th": "ลาดใหญ่",
        "name_en": "Lat Yai",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750104,
        "name_th": "บ้านปรก",
        "name_en": "Ban Prok",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750105,
        "name_th": "บางแก้ว",
        "name_en": "Bang Kaeo",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750106,
        "name_th": "ท้ายหาด",
        "name_en": "Thai Hat",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750107,
        "name_th": "แหลมใหญ่",
        "name_en": "Laem Yai",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750108,
        "name_th": "คลองเขิน",
        "name_en": "Khlong Khoen",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750109,
        "name_th": "คลองโคน",
        "name_en": "Khlong Khon",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750110,
        "name_th": "นางตะเคียน",
        "name_en": "Nang Takian",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750111,
        "name_th": "บางจะเกร็ง",
        "name_en": "Bang Chakreng",
        "zip_codes": [
            75000
        ],
        "district_id": 7501
    },
    {
        "id": 750201,
        "name_th": "กระดังงา",
        "name_en": "Kradangnga",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750202,
        "name_th": "บางสะแก",
        "name_en": "Bang Sakae",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750203,
        "name_th": "บางยี่รงค์",
        "name_en": "Bang Yi Rong",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750204,
        "name_th": "โรงหีบ",
        "name_en": "Rong Hip",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750205,
        "name_th": "บางคนที",
        "name_en": "Bang Khonthi",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750206,
        "name_th": "ดอนมะโนรา",
        "name_en": "Don Manora",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750207,
        "name_th": "บางพรม",
        "name_en": "Bang Phrom",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750208,
        "name_th": "บางกุ้ง",
        "name_en": "Bang Kung",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750209,
        "name_th": "จอมปลวก",
        "name_en": "Chom Pluak",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750210,
        "name_th": "บางนกแขวก",
        "name_en": "Bang Nok Khwaek",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750211,
        "name_th": "ยายแพง",
        "name_en": "Yai Phaeng",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750212,
        "name_th": "บางกระบือ",
        "name_en": "Bang Krabue",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750213,
        "name_th": "บ้านปราโมทย์",
        "name_en": "Ban Pramot",
        "zip_codes": [
            75120
        ],
        "district_id": 7502
    },
    {
        "id": 750301,
        "name_th": "อัมพวา",
        "name_en": "Amphawa",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750302,
        "name_th": "สวนหลวง",
        "name_en": "Suan Luang",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750303,
        "name_th": "ท่าคา",
        "name_en": "Tha Kha",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750304,
        "name_th": "วัดประดู่",
        "name_en": "Wat Pradu",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750305,
        "name_th": "เหมืองใหม่",
        "name_en": "Mueang Mai",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750306,
        "name_th": "บางช้าง",
        "name_en": "Bang Chang",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750307,
        "name_th": "แควอ้อม",
        "name_en": "Khwaae Om",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750308,
        "name_th": "ปลายโพงพาง",
        "name_en": "Plai Phongphang",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750309,
        "name_th": "บางแค",
        "name_en": "Bang Khae",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750310,
        "name_th": "แพรกหนามแดง",
        "name_en": "Phraek Nam Daeng",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750311,
        "name_th": "ยี่สาร",
        "name_en": "Yi San",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 750312,
        "name_th": "บางนางลี่",
        "name_en": "Bang Nang Li",
        "zip_codes": [
            75110
        ],
        "district_id": 7503
    },
    {
        "id": 760101,
        "name_th": "ท่าราบ",
        "name_en": "Tha Rap",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760102,
        "name_th": "คลองกระแชง",
        "name_en": "Khlong Krachaeng",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760103,
        "name_th": "บางจาน",
        "name_en": "Bang Chan",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760104,
        "name_th": "นาพันสาม",
        "name_en": "Na Phan Sam",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760105,
        "name_th": "ธงชัย",
        "name_en": "Thong Chai",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760106,
        "name_th": "บ้านกุ่ม",
        "name_en": "Ban Kum",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760107,
        "name_th": "หนองโสน",
        "name_en": "Nong Sano",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760108,
        "name_th": "ไร่ส้ม",
        "name_en": "Rai Som",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760109,
        "name_th": "เวียงคอย",
        "name_en": "Wiang Khoi",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760110,
        "name_th": "บางจาก",
        "name_en": "Bang Chak",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760111,
        "name_th": "บ้านหม้อ",
        "name_en": "Ban Mo",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760112,
        "name_th": "ต้นมะม่วง",
        "name_en": "Ton Mamuang",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760113,
        "name_th": "ช่องสะแก",
        "name_en": "Chong Sakae",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760114,
        "name_th": "นาวุ้ง",
        "name_en": "Na Wung",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760115,
        "name_th": "สำมะโรง",
        "name_en": "Sam Marong",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760116,
        "name_th": "โพพระ",
        "name_en": "Pho Phra",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760117,
        "name_th": "หาดเจ้าสำราญ",
        "name_en": "Hat Chao Samran",
        "zip_codes": [
            76100
        ],
        "district_id": 7601
    },
    {
        "id": 760118,
        "name_th": "หัวสะพาน",
        "name_en": "Hua Saphan",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760119,
        "name_th": "ต้นมะพร้าว",
        "name_en": "Ton Maphrao",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760120,
        "name_th": "วังตะโก",
        "name_en": "Wang Tako",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760121,
        "name_th": "โพไร่หวาน",
        "name_en": "Pho Rai Wan",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760122,
        "name_th": "ดอนยาง",
        "name_en": "Don Yang",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760123,
        "name_th": "หนองขนาน",
        "name_en": "Nong Khanan",
        "zip_codes": [
            76000,
            76100
        ],
        "district_id": 7601
    },
    {
        "id": 760124,
        "name_th": "หนองพลับ",
        "name_en": "Nong Phlap",
        "zip_codes": [
            76000
        ],
        "district_id": 7601
    },
    {
        "id": 760201,
        "name_th": "เขาย้อย",
        "name_en": "Khao Yoi",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760202,
        "name_th": "สระพัง",
        "name_en": "Sa Phang",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760203,
        "name_th": "บางเค็ม",
        "name_en": "Bang Khem",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760204,
        "name_th": "ทับคาง",
        "name_en": "Thap Khang",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760205,
        "name_th": "หนองปลาไหล",
        "name_en": "Nong Pla Lai",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760206,
        "name_th": "หนองปรง",
        "name_en": "Nong Prong",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760207,
        "name_th": "หนองชุมพล",
        "name_en": "Nong Chumphon",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760208,
        "name_th": "ห้วยโรง",
        "name_en": "Huai Rong",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760209,
        "name_th": "ห้วยท่าช้าง",
        "name_en": "Huai Tha Chang",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760210,
        "name_th": "หนองชุมพลเหนือ",
        "name_en": "Nong Chumphon Nuea",
        "zip_codes": [
            76140
        ],
        "district_id": 7602
    },
    {
        "id": 760301,
        "name_th": "หนองหญ้าปล้อง",
        "name_en": "Nong Ya Plong",
        "zip_codes": [
            76160
        ],
        "district_id": 7603
    },
    {
        "id": 760302,
        "name_th": "ยางน้ำกลัดเหนือ",
        "name_en": "Yang Nam Klat Nuea",
        "zip_codes": [
            76160
        ],
        "district_id": 7603
    },
    {
        "id": 760303,
        "name_th": "ยางน้ำกลัดใต้",
        "name_en": "Yang Nam Klat Tai",
        "zip_codes": [
            76160
        ],
        "district_id": 7603
    },
    {
        "id": 760304,
        "name_th": "ท่าตะคร้อ",
        "name_en": "Tha Ta Khro",
        "zip_codes": [
            76160
        ],
        "district_id": 7603
    },
    {
        "id": 760401,
        "name_th": "ชะอำ",
        "name_en": "Cha-am",
        "zip_codes": [
            76120
        ],
        "district_id": 7604
    },
    {
        "id": 760402,
        "name_th": "บางเก่า",
        "name_en": "Bang Kao",
        "zip_codes": [
            76120
        ],
        "district_id": 7604
    },
    {
        "id": 760403,
        "name_th": "นายาง",
        "name_en": "Na Yang",
        "zip_codes": [
            76120
        ],
        "district_id": 7604
    },
    {
        "id": 760404,
        "name_th": "เขาใหญ่",
        "name_en": "Khao Yai",
        "zip_codes": [
            76120
        ],
        "district_id": 7604
    },
    {
        "id": 760405,
        "name_th": "หนองศาลา",
        "name_en": "Nong Sala",
        "zip_codes": [
            76120
        ],
        "district_id": 7604
    },
    {
        "id": 760406,
        "name_th": "ห้วยทรายเหนือ",
        "name_en": "Huai Sai Nuea",
        "zip_codes": [
            76120
        ],
        "district_id": 7604
    },
    {
        "id": 760407,
        "name_th": "ไร่ใหม่พัฒนา",
        "name_en": "Rai Mai Phatthana",
        "zip_codes": [
            76120
        ],
        "district_id": 7604
    },
    {
        "id": 760408,
        "name_th": "สามพระยา",
        "name_en": "Sam Phraya",
        "zip_codes": [
            76120
        ],
        "district_id": 7604
    },
    {
        "id": 760409,
        "name_th": "ดอนขุนห้วย",
        "name_en": "Don Khun Huai",
        "zip_codes": [
            76120
        ],
        "district_id": 7604
    },
    {
        "id": 760501,
        "name_th": "ท่ายาง",
        "name_en": "Tha Yang",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760502,
        "name_th": "ท่าคอย",
        "name_en": "Tha Khoi",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760503,
        "name_th": "ยางหย่อง",
        "name_en": "Yang Yong",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760504,
        "name_th": "หนองจอก",
        "name_en": "Nong Chok",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760505,
        "name_th": "มาบปลาเค้า",
        "name_en": "Map Pla Khao",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760506,
        "name_th": "ท่าไม้รวก",
        "name_en": "Tha Mai Ruak",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760507,
        "name_th": "วังไคร้",
        "name_en": "Wang Khrai",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760511,
        "name_th": "กลัดหลวง",
        "name_en": "Klat Luang",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760512,
        "name_th": "ปึกเตียน",
        "name_en": "Puek Tian",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760513,
        "name_th": "เขากระปุก",
        "name_en": "Khao Krapuk",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760514,
        "name_th": "ท่าแลง",
        "name_en": "Tha Laeng",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760515,
        "name_th": "บ้านในดง",
        "name_en": "Ban Nai Dong",
        "zip_codes": [
            76130
        ],
        "district_id": 7605
    },
    {
        "id": 760601,
        "name_th": "บ้านลาด",
        "name_en": "Ban Lat",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760602,
        "name_th": "บ้านหาด",
        "name_en": "Ban Hat",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760603,
        "name_th": "บ้านทาน",
        "name_en": "Ban Than",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760604,
        "name_th": "ตำหรุ",
        "name_en": "Tamru",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760605,
        "name_th": "สมอพลือ",
        "name_en": "Samo Phlue",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760606,
        "name_th": "ไร่มะขาม",
        "name_en": "Rai Makham",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760607,
        "name_th": "ท่าเสน",
        "name_en": "Tha Sen",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760608,
        "name_th": "หนองกระเจ็ด",
        "name_en": "Nong Krachet",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760609,
        "name_th": "หนองกะปุ",
        "name_en": "Nong Kapu",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760610,
        "name_th": "ลาดโพธิ์",
        "name_en": "Lat Pho",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760611,
        "name_th": "สะพานไกร",
        "name_en": "Saphan Krai",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760612,
        "name_th": "ไร่โคก",
        "name_en": "Rai Khok",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760613,
        "name_th": "โรงเข้",
        "name_en": "Rong Khe",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760614,
        "name_th": "ไร่สะท้อน",
        "name_en": "Rai Sathon",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760615,
        "name_th": "ห้วยข้อง",
        "name_en": "Huai Khong",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760616,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760617,
        "name_th": "ถ้ำรงค์",
        "name_en": "Tham Rong",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760618,
        "name_th": "ห้วยลึก",
        "name_en": "Huai Luek",
        "zip_codes": [
            76150
        ],
        "district_id": 7606
    },
    {
        "id": 760701,
        "name_th": "บ้านแหลม",
        "name_en": "Ban Laem",
        "zip_codes": [
            76110
        ],
        "district_id": 7607
    },
    {
        "id": 760702,
        "name_th": "บางขุนไทร",
        "name_en": "Bang Khun Sai",
        "zip_codes": [
            76110
        ],
        "district_id": 7607
    },
    {
        "id": 760703,
        "name_th": "ปากทะเล",
        "name_en": "Pak Thale",
        "zip_codes": [
            76110
        ],
        "district_id": 7607
    },
    {
        "id": 760704,
        "name_th": "บางแก้ว",
        "name_en": "Bang Kaeo",
        "zip_codes": [
            76110
        ],
        "district_id": 7607
    },
    {
        "id": 760705,
        "name_th": "แหลมผักเบี้ย",
        "name_en": "Laem Phak Bia",
        "zip_codes": [
            76100
        ],
        "district_id": 7607
    },
    {
        "id": 760706,
        "name_th": "บางตะบูน",
        "name_en": "Bang Tabun",
        "zip_codes": [
            76110
        ],
        "district_id": 7607
    },
    {
        "id": 760707,
        "name_th": "บางตะบูนออก",
        "name_en": "Bang Tabun Ok",
        "zip_codes": [
            76110
        ],
        "district_id": 7607
    },
    {
        "id": 760708,
        "name_th": "บางครก",
        "name_en": "Bang Khrok",
        "zip_codes": [
            76110
        ],
        "district_id": 7607
    },
    {
        "id": 760709,
        "name_th": "ท่าแร้ง",
        "name_en": "Tha Raeng",
        "zip_codes": [
            76110
        ],
        "district_id": 7607
    },
    {
        "id": 760710,
        "name_th": "ท่าแร้งออก",
        "name_en": "Tha Raeng Ok",
        "zip_codes": [
            76110
        ],
        "district_id": 7607
    },
    {
        "id": 760801,
        "name_th": "แก่งกระจาน",
        "name_en": "Kaeng Krachan",
        "zip_codes": [
            76170
        ],
        "district_id": 7608
    },
    {
        "id": 760802,
        "name_th": "สองพี่น้อง",
        "name_en": "Song Phi Nong",
        "zip_codes": [
            76170
        ],
        "district_id": 7608
    },
    {
        "id": 760803,
        "name_th": "วังจันทร์",
        "name_en": "Wang Chan",
        "zip_codes": [
            76170
        ],
        "district_id": 7608
    },
    {
        "id": 760804,
        "name_th": "ป่าเด็ง",
        "name_en": "Pa Deng",
        "zip_codes": [
            76170
        ],
        "district_id": 7608
    },
    {
        "id": 760805,
        "name_th": "พุสวรรค์",
        "name_en": "Phu Sawan",
        "zip_codes": [
            76170
        ],
        "district_id": 7608
    },
    {
        "id": 760806,
        "name_th": "ห้วยแม่เพรียง",
        "name_en": "Huai Mae Phriang",
        "zip_codes": [
            76170
        ],
        "district_id": 7608
    },
    {
        "id": 770101,
        "name_th": "ประจวบคีรีขันธ์",
        "name_en": "Prachuap Khiri Khan",
        "zip_codes": [
            77000
        ],
        "district_id": 7701
    },
    {
        "id": 770102,
        "name_th": "เกาะหลัก",
        "name_en": "Ko Lak",
        "zip_codes": [
            77000
        ],
        "district_id": 7701
    },
    {
        "id": 770103,
        "name_th": "คลองวาฬ",
        "name_en": "Khlong Wan",
        "zip_codes": [
            77000
        ],
        "district_id": 7701
    },
    {
        "id": 770104,
        "name_th": "ห้วยทราย",
        "name_en": "Huai Sai",
        "zip_codes": [
            77000
        ],
        "district_id": 7701
    },
    {
        "id": 770105,
        "name_th": "อ่าวน้อย",
        "name_en": "Ao Noi",
        "zip_codes": [
            77000,
            77210
        ],
        "district_id": 7701
    },
    {
        "id": 770106,
        "name_th": "บ่อนอก",
        "name_en": "Bo Nok",
        "zip_codes": [
            77210
        ],
        "district_id": 7701
    },
    {
        "id": 770201,
        "name_th": "กุยบุรี",
        "name_en": "Kui Buri",
        "zip_codes": [
            77150
        ],
        "district_id": 7702
    },
    {
        "id": 770202,
        "name_th": "กุยเหนือ",
        "name_en": "Kui Nuea",
        "zip_codes": [
            77150
        ],
        "district_id": 7702
    },
    {
        "id": 770203,
        "name_th": "เขาแดง",
        "name_en": "Khao Daeng",
        "zip_codes": [
            77150
        ],
        "district_id": 7702
    },
    {
        "id": 770204,
        "name_th": "ดอนยายหนู",
        "name_en": "Don Yai Nu",
        "zip_codes": [
            77150
        ],
        "district_id": 7702
    },
    {
        "id": 770206,
        "name_th": "สามกระทาย",
        "name_en": "Sam Krathai",
        "zip_codes": [
            77150
        ],
        "district_id": 7702
    },
    {
        "id": 770207,
        "name_th": "หาดขาม",
        "name_en": "Hat Kham",
        "zip_codes": [
            77150
        ],
        "district_id": 7702
    },
    {
        "id": 770301,
        "name_th": "ทับสะแก",
        "name_en": "Thap Sakae",
        "zip_codes": [
            77130
        ],
        "district_id": 7703
    },
    {
        "id": 770302,
        "name_th": "อ่างทอง",
        "name_en": "Ang Thong",
        "zip_codes": [
            77130
        ],
        "district_id": 7703
    },
    {
        "id": 770303,
        "name_th": "นาหูกวาง",
        "name_en": "Na Hu Kwang",
        "zip_codes": [
            77130
        ],
        "district_id": 7703
    },
    {
        "id": 770304,
        "name_th": "เขาล้าน",
        "name_en": "Khao Lan",
        "zip_codes": [
            77130
        ],
        "district_id": 7703
    },
    {
        "id": 770305,
        "name_th": "ห้วยยาง",
        "name_en": "Huai Yang",
        "zip_codes": [
            77130
        ],
        "district_id": 7703
    },
    {
        "id": 770306,
        "name_th": "แสงอรุณ",
        "name_en": "Saeng Arun",
        "zip_codes": [
            77130
        ],
        "district_id": 7703
    },
    {
        "id": 770401,
        "name_th": "กำเนิดนพคุณ",
        "name_en": "Kamnoet Nopphakhun",
        "zip_codes": [
            77140
        ],
        "district_id": 7704
    },
    {
        "id": 770402,
        "name_th": "พงศ์ประศาสน์",
        "name_en": "Phong Prasat",
        "zip_codes": [
            77140
        ],
        "district_id": 7704
    },
    {
        "id": 770403,
        "name_th": "ร่อนทอง",
        "name_en": "Ron Thong",
        "zip_codes": [
            77230
        ],
        "district_id": 7704
    },
    {
        "id": 770404,
        "name_th": "ธงชัย",
        "name_en": "Thong Chai",
        "zip_codes": [
            77190
        ],
        "district_id": 7704
    },
    {
        "id": 770405,
        "name_th": "ชัยเกษม",
        "name_en": "Chai Kasem",
        "zip_codes": [
            77190
        ],
        "district_id": 7704
    },
    {
        "id": 770406,
        "name_th": "ทองมงคล",
        "name_en": "Thong Mongkhon",
        "zip_codes": [
            77230
        ],
        "district_id": 7704
    },
    {
        "id": 770407,
        "name_th": "แม่รำพึง",
        "name_en": "Mae Ramphueng",
        "zip_codes": [
            77140
        ],
        "district_id": 7704
    },
    {
        "id": 770501,
        "name_th": "ปากแพรก",
        "name_en": "Pak Phraek",
        "zip_codes": [
            77170
        ],
        "district_id": 7705
    },
    {
        "id": 770502,
        "name_th": "บางสะพาน",
        "name_en": "Bang Saphan",
        "zip_codes": [
            77170
        ],
        "district_id": 7705
    },
    {
        "id": 770503,
        "name_th": "ทรายทอง",
        "name_en": "Sai Thong",
        "zip_codes": [
            77170
        ],
        "district_id": 7705
    },
    {
        "id": 770504,
        "name_th": "ช้างแรก",
        "name_en": "Chang Raek",
        "zip_codes": [
            77170
        ],
        "district_id": 7705
    },
    {
        "id": 770505,
        "name_th": "ไชยราช",
        "name_en": "Chai Rat",
        "zip_codes": [
            77170
        ],
        "district_id": 7705
    },
    {
        "id": 770601,
        "name_th": "ปราณบุรี",
        "name_en": "Pran Buri",
        "zip_codes": [
            77120
        ],
        "district_id": 7706
    },
    {
        "id": 770602,
        "name_th": "เขาน้อย",
        "name_en": "Khao Noi",
        "zip_codes": [
            77120,
            77160
        ],
        "district_id": 7706
    },
    {
        "id": 770604,
        "name_th": "ปากน้ำปราณ",
        "name_en": "Pak Nam Pran",
        "zip_codes": [
            77220
        ],
        "district_id": 7706
    },
    {
        "id": 770607,
        "name_th": "หนองตาแต้ม",
        "name_en": "Nong Ta Taem",
        "zip_codes": [
            77120
        ],
        "district_id": 7706
    },
    {
        "id": 770608,
        "name_th": "วังก์พง",
        "name_en": "Wang Phong",
        "zip_codes": [
            77120
        ],
        "district_id": 7706
    },
    {
        "id": 770609,
        "name_th": "เขาจ้าว",
        "name_en": "Khao Chao",
        "zip_codes": [
            77120
        ],
        "district_id": 7706
    },
    {
        "id": 770701,
        "name_th": "หัวหิน",
        "name_en": "Hua Hin",
        "zip_codes": [
            77110
        ],
        "district_id": 7707
    },
    {
        "id": 770702,
        "name_th": "หนองแก",
        "name_en": "Nong Kae",
        "zip_codes": [
            77110
        ],
        "district_id": 7707
    },
    {
        "id": 770703,
        "name_th": "หินเหล็กไฟ",
        "name_en": "Hin Lek Fai",
        "zip_codes": [
            77110
        ],
        "district_id": 7707
    },
    {
        "id": 770704,
        "name_th": "หนองพลับ",
        "name_en": "Nong Phlap",
        "zip_codes": [
            77110
        ],
        "district_id": 7707
    },
    {
        "id": 770705,
        "name_th": "ทับใต้",
        "name_en": "Thap Tai",
        "zip_codes": [
            77110
        ],
        "district_id": 7707
    },
    {
        "id": 770706,
        "name_th": "ห้วยสัตว์ใหญ่",
        "name_en": "Huai Sat Yai",
        "zip_codes": [
            77110
        ],
        "district_id": 7707
    },
    {
        "id": 770707,
        "name_th": "บึงนคร",
        "name_en": "Bueng Nakhon",
        "zip_codes": [
            77110
        ],
        "district_id": 7707
    },
    {
        "id": 770801,
        "name_th": "สามร้อยยอด",
        "name_en": "Sam Roi Yot",
        "zip_codes": [
            77120
        ],
        "district_id": 7708
    },
    {
        "id": 770802,
        "name_th": "ศิลาลอย",
        "name_en": "Sila Loi",
        "zip_codes": [
            77180
        ],
        "district_id": 7708
    },
    {
        "id": 770803,
        "name_th": "ไร่เก่า",
        "name_en": "Rai Kao",
        "zip_codes": [
            77180
        ],
        "district_id": 7708
    },
    {
        "id": 770804,
        "name_th": "ศาลาลัย",
        "name_en": "Salalai",
        "zip_codes": [
            77180
        ],
        "district_id": 7708
    },
    {
        "id": 770805,
        "name_th": "ไร่ใหม่",
        "name_en": "Rai Mai",
        "zip_codes": [
            77180
        ],
        "district_id": 7708
    },
    {
        "id": 800101,
        "name_th": "ในเมือง",
        "name_en": "Nai Mueang",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800102,
        "name_th": "ท่าวัง",
        "name_en": "Tha Wang",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800103,
        "name_th": "คลัง",
        "name_en": "Khlang",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800106,
        "name_th": "ท่าไร่",
        "name_en": "Tha Rai",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800107,
        "name_th": "ปากนคร",
        "name_en": "Pak Nakhon",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800108,
        "name_th": "นาทราย",
        "name_en": "Na Sai",
        "zip_codes": [
            80280
        ],
        "district_id": 8001
    },
    {
        "id": 800112,
        "name_th": "กำแพงเซา",
        "name_en": "Kamphaeng Sao",
        "zip_codes": [
            80280
        ],
        "district_id": 8001
    },
    {
        "id": 800113,
        "name_th": "ไชยมนตรี",
        "name_en": "Chai Montri",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800114,
        "name_th": "มะม่วงสองต้น",
        "name_en": "Mamuang Song Ton",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800115,
        "name_th": "นาเคียน",
        "name_en": "Na Khian",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800116,
        "name_th": "ท่างิ้ว",
        "name_en": "Tha Ngio",
        "zip_codes": [
            80280
        ],
        "district_id": 8001
    },
    {
        "id": 800118,
        "name_th": "โพธิ์เสด็จ",
        "name_en": "Pho Sadet",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800119,
        "name_th": "บางจาก",
        "name_en": "Bang Chak",
        "zip_codes": [
            80330
        ],
        "district_id": 8001
    },
    {
        "id": 800120,
        "name_th": "ปากพูน",
        "name_en": "Pak Phun",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800121,
        "name_th": "ท่าซัก",
        "name_en": "Tha Sak",
        "zip_codes": [
            80000
        ],
        "district_id": 8001
    },
    {
        "id": 800122,
        "name_th": "ท่าเรือ",
        "name_en": "Tha Ruea",
        "zip_codes": [
            80000,
            80290
        ],
        "district_id": 8001
    },
    {
        "id": 800201,
        "name_th": "พรหมโลก",
        "name_en": "Phrommalok",
        "zip_codes": [
            80320
        ],
        "district_id": 8002
    },
    {
        "id": 800202,
        "name_th": "บ้านเกาะ",
        "name_en": "Ban Ko",
        "zip_codes": [
            80320
        ],
        "district_id": 8002
    },
    {
        "id": 800203,
        "name_th": "อินคีรี",
        "name_en": "In Khiri",
        "zip_codes": [
            80320
        ],
        "district_id": 8002
    },
    {
        "id": 800204,
        "name_th": "ทอนหงส์",
        "name_en": "Thon Hong",
        "zip_codes": [
            80320
        ],
        "district_id": 8002
    },
    {
        "id": 800205,
        "name_th": "นาเรียง",
        "name_en": "Na Riang",
        "zip_codes": [
            80320
        ],
        "district_id": 8002
    },
    {
        "id": 800301,
        "name_th": "เขาแก้ว",
        "name_en": "Khao Kaeo",
        "zip_codes": [
            80230
        ],
        "district_id": 8003
    },
    {
        "id": 800302,
        "name_th": "ลานสกา",
        "name_en": "Lan Saka",
        "zip_codes": [
            80230
        ],
        "district_id": 8003
    },
    {
        "id": 800303,
        "name_th": "ท่าดี",
        "name_en": "Tha Di",
        "zip_codes": [
            80230
        ],
        "district_id": 8003
    },
    {
        "id": 800304,
        "name_th": "กำโลน",
        "name_en": "Kamlon",
        "zip_codes": [
            80230
        ],
        "district_id": 8003
    },
    {
        "id": 800305,
        "name_th": "ขุนทะเล",
        "name_en": "Khun Thale",
        "zip_codes": [
            80230
        ],
        "district_id": 8003
    },
    {
        "id": 800401,
        "name_th": "ฉวาง",
        "name_en": "Chawang",
        "zip_codes": [
            80150,
            80250
        ],
        "district_id": 8004
    },
    {
        "id": 800403,
        "name_th": "ละอาย",
        "name_en": "La-ai",
        "zip_codes": [
            80250
        ],
        "district_id": 8004
    },
    {
        "id": 800404,
        "name_th": "นาแว",
        "name_en": "Na Wae",
        "zip_codes": [
            80150,
            80260
        ],
        "district_id": 8004
    },
    {
        "id": 800405,
        "name_th": "ไม้เรียง",
        "name_en": "Mai Riang",
        "zip_codes": [
            80150,
            80260
        ],
        "district_id": 8004
    },
    {
        "id": 800406,
        "name_th": "กะเปียด",
        "name_en": "Kapiat",
        "zip_codes": [
            80260
        ],
        "district_id": 8004
    },
    {
        "id": 800407,
        "name_th": "นากะชะ",
        "name_en": "Na Kacha",
        "zip_codes": [
            80150,
            80260
        ],
        "district_id": 8004
    },
    {
        "id": 800409,
        "name_th": "ห้วยปริก",
        "name_en": "Huai Prik",
        "zip_codes": [
            80260
        ],
        "district_id": 8004
    },
    {
        "id": 800410,
        "name_th": "ไสหร้า",
        "name_en": "Sai Ra",
        "zip_codes": [
            80150
        ],
        "district_id": 8004
    },
    {
        "id": 800415,
        "name_th": "นาเขลียง",
        "name_en": "Na Khliang",
        "zip_codes": [
            80260
        ],
        "district_id": 8004
    },
    {
        "id": 800416,
        "name_th": "จันดี",
        "name_en": "Chan Di",
        "zip_codes": [
            80250
        ],
        "district_id": 8004
    },
    {
        "id": 800501,
        "name_th": "พิปูน",
        "name_en": "Phipun",
        "zip_codes": [
            80270
        ],
        "district_id": 8005
    },
    {
        "id": 800502,
        "name_th": "กะทูน",
        "name_en": "Kathun",
        "zip_codes": [
            80270
        ],
        "district_id": 8005
    },
    {
        "id": 800503,
        "name_th": "เขาพระ",
        "name_en": "Khao Phra",
        "zip_codes": [
            80270
        ],
        "district_id": 8005
    },
    {
        "id": 800504,
        "name_th": "ยางค้อม",
        "name_en": "Yang Khom",
        "zip_codes": [
            80270
        ],
        "district_id": 8005
    },
    {
        "id": 800505,
        "name_th": "ควนกลาง",
        "name_en": "Khuan Klang",
        "zip_codes": [
            80270
        ],
        "district_id": 8005
    },
    {
        "id": 800601,
        "name_th": "เชียรใหญ่",
        "name_en": "Chian Yai",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800603,
        "name_th": "ท่าขนาน",
        "name_en": "Tha Khanan",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800604,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800605,
        "name_th": "บ้านเนิน",
        "name_en": "Ban Noen",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800606,
        "name_th": "ไสหมาก",
        "name_en": "Sai Mak",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800607,
        "name_th": "ท้องลำเจียก",
        "name_en": "Thong Lamchiak",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800610,
        "name_th": "เสือหึง",
        "name_en": "Suea Hueng",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800611,
        "name_th": "การะเกด",
        "name_en": "Karaket",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800612,
        "name_th": "เขาพระบาท",
        "name_en": "Khao Phra Bat",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800613,
        "name_th": "แม่เจ้าอยู่หัว",
        "name_en": "Mae chao Yu Hua",
        "zip_codes": [
            80190
        ],
        "district_id": 8006
    },
    {
        "id": 800701,
        "name_th": "ชะอวด",
        "name_en": "Cha-uat",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800702,
        "name_th": "ท่าเสม็ด",
        "name_en": "Tha Samet",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800703,
        "name_th": "ท่าประจะ",
        "name_en": "Tha Pracha",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800704,
        "name_th": "เคร็ง",
        "name_en": "Khreng",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800705,
        "name_th": "วังอ่าง",
        "name_en": "Wang Ang",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800706,
        "name_th": "บ้านตูล",
        "name_en": "Ban Tun",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800707,
        "name_th": "ขอนหาด",
        "name_en": "Khon Hat",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800708,
        "name_th": "เกาะขันธ์",
        "name_en": "Ko Khan",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800709,
        "name_th": "ควนหนองหงษ์",
        "name_en": "Khuan Nong Hong",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800710,
        "name_th": "เขาพระทอง",
        "name_en": "Khao Phra Thong",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800711,
        "name_th": "นางหลง",
        "name_en": "Nong Long",
        "zip_codes": [
            80180
        ],
        "district_id": 8007
    },
    {
        "id": 800801,
        "name_th": "ท่าศาลา",
        "name_en": "Tha Sala",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800802,
        "name_th": "กลาย",
        "name_en": "Klai",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800803,
        "name_th": "ท่าขึ้น",
        "name_en": "Tha Khuen",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800804,
        "name_th": "หัวตะพาน",
        "name_en": "Hua Taphan",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800806,
        "name_th": "สระแก้ว",
        "name_en": "Sa Kaeo",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800807,
        "name_th": "โมคลาน",
        "name_en": "Mokkhalan",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800809,
        "name_th": "ไทยบุรี",
        "name_en": "Thai Buri",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800810,
        "name_th": "ดอนตะโก",
        "name_en": "Don Tako",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800811,
        "name_th": "ตลิ่งชัน",
        "name_en": "Taling Chan",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800813,
        "name_th": "โพธิ์ทอง",
        "name_en": "Pho Thong",
        "zip_codes": [
            80160
        ],
        "district_id": 8008
    },
    {
        "id": 800901,
        "name_th": "ปากแพรก",
        "name_en": "Pak Phraek",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 800902,
        "name_th": "ชะมาย",
        "name_en": "Chamai",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 800903,
        "name_th": "หนองหงส์",
        "name_en": "Nong Hong",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 800904,
        "name_th": "ควนกรด",
        "name_en": "Khuan Krot",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 800905,
        "name_th": "นาไม้ไผ่",
        "name_en": "Na Mai Phai",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 800906,
        "name_th": "นาหลวงเสน",
        "name_en": "Na Luang Sen",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 800907,
        "name_th": "เขาโร",
        "name_en": "Khao Ro",
        "zip_codes": [
            80110,
            80310
        ],
        "district_id": 8009
    },
    {
        "id": 800908,
        "name_th": "กะปาง",
        "name_en": "Kapang",
        "zip_codes": [
            80310
        ],
        "district_id": 8009
    },
    {
        "id": 800909,
        "name_th": "ที่วัง",
        "name_en": "Thi Wang",
        "zip_codes": [
            80110,
            80310
        ],
        "district_id": 8009
    },
    {
        "id": 800910,
        "name_th": "น้ำตก",
        "name_en": "Nam Tok",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 800911,
        "name_th": "ถ้ำใหญ่",
        "name_en": "Tham Yai",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 800912,
        "name_th": "นาโพธิ์",
        "name_en": "Na Pho",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 800913,
        "name_th": "เขาขาว",
        "name_en": "Khao Khao",
        "zip_codes": [
            80110
        ],
        "district_id": 8009
    },
    {
        "id": 801001,
        "name_th": "นาบอน",
        "name_en": "Na Bon",
        "zip_codes": [
            80220
        ],
        "district_id": 8010
    },
    {
        "id": 801002,
        "name_th": "ทุ่งสง",
        "name_en": "Thung Song",
        "zip_codes": [
            80220
        ],
        "district_id": 8010
    },
    {
        "id": 801003,
        "name_th": "แก้วแสน",
        "name_en": "Kaeo Saen",
        "zip_codes": [
            80220,
            80250
        ],
        "district_id": 8010
    },
    {
        "id": 801101,
        "name_th": "ท่ายาง",
        "name_en": "Tha Yang",
        "zip_codes": [
            80240
        ],
        "district_id": 8011
    },
    {
        "id": 801102,
        "name_th": "ทุ่งสัง",
        "name_en": "Thung Sang",
        "zip_codes": [
            80240
        ],
        "district_id": 8011
    },
    {
        "id": 801103,
        "name_th": "ทุ่งใหญ่",
        "name_en": "Thung Yai",
        "zip_codes": [
            80240
        ],
        "district_id": 8011
    },
    {
        "id": 801104,
        "name_th": "กุแหระ",
        "name_en": "Kurae",
        "zip_codes": [
            80240
        ],
        "district_id": 8011
    },
    {
        "id": 801105,
        "name_th": "ปริก",
        "name_en": "Prik",
        "zip_codes": [
            80240
        ],
        "district_id": 8011
    },
    {
        "id": 801106,
        "name_th": "บางรูป",
        "name_en": "Bang Rup",
        "zip_codes": [
            80240
        ],
        "district_id": 8011
    },
    {
        "id": 801107,
        "name_th": "กรุงหยัน",
        "name_en": "Krung Yan",
        "zip_codes": [
            80240
        ],
        "district_id": 8011
    },
    {
        "id": 801201,
        "name_th": "ปากพนัง",
        "name_en": "Pak Phanang",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801202,
        "name_th": "คลองน้อย",
        "name_en": "Khlong Noi",
        "zip_codes": [
            80330
        ],
        "district_id": 8012
    },
    {
        "id": 801203,
        "name_th": "ป่าระกำ",
        "name_en": "Pa Rakam",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801204,
        "name_th": "ชะเมา",
        "name_en": "Chamao",
        "zip_codes": [
            80330
        ],
        "district_id": 8012
    },
    {
        "id": 801205,
        "name_th": "คลองกระบือ",
        "name_en": "Khlong Krabue",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801206,
        "name_th": "เกาะทวด",
        "name_en": "Ko Thuat",
        "zip_codes": [
            80330
        ],
        "district_id": 8012
    },
    {
        "id": 801207,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801208,
        "name_th": "หูล่อง",
        "name_en": "Hu Long",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801209,
        "name_th": "แหลมตะลุมพุก",
        "name_en": "Laem Talumphuk",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801210,
        "name_th": "ปากพนังฝั่งตะวันตก",
        "name_en": "Pak Phanang Fang Tawan Tok",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801211,
        "name_th": "บางศาลา",
        "name_en": "Bang Sala",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801212,
        "name_th": "บางพระ",
        "name_en": "Bang Phra",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801213,
        "name_th": "บางตะพง",
        "name_en": "Bang Taphong",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801214,
        "name_th": "ปากพนังฝั่งตะวันออก",
        "name_en": "Pak Phanang Fang Tawan Ok",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801215,
        "name_th": "บ้านเพิง",
        "name_en": "Ban Phoeng",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801216,
        "name_th": "ท่าพยา",
        "name_en": "Tha Phaya",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801217,
        "name_th": "ปากแพรก",
        "name_en": "Pak Phraek",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801218,
        "name_th": "ขนาบนาก",
        "name_en": "Khanap Nak",
        "zip_codes": [
            80140
        ],
        "district_id": 8012
    },
    {
        "id": 801301,
        "name_th": "ร่อนพิบูลย์",
        "name_en": "Ron Phibun",
        "zip_codes": [
            80130
        ],
        "district_id": 8013
    },
    {
        "id": 801302,
        "name_th": "หินตก",
        "name_en": "Hin Tok",
        "zip_codes": [
            80350
        ],
        "district_id": 8013
    },
    {
        "id": 801303,
        "name_th": "เสาธง",
        "name_en": "Sao Thong",
        "zip_codes": [
            80350
        ],
        "district_id": 8013
    },
    {
        "id": 801304,
        "name_th": "ควนเกย",
        "name_en": "Khuan Koei",
        "zip_codes": [
            80130
        ],
        "district_id": 8013
    },
    {
        "id": 801305,
        "name_th": "ควนพัง",
        "name_en": "Khuan Phang",
        "zip_codes": [
            80130
        ],
        "district_id": 8013
    },
    {
        "id": 801306,
        "name_th": "ควนชุม",
        "name_en": "Khuan Chum",
        "zip_codes": [
            80130
        ],
        "district_id": 8013
    },
    {
        "id": 801401,
        "name_th": "สิชล",
        "name_en": "Sichon",
        "zip_codes": [
            80120
        ],
        "district_id": 8014
    },
    {
        "id": 801402,
        "name_th": "ทุ่งปรัง",
        "name_en": "Thung Prang",
        "zip_codes": [
            80120
        ],
        "district_id": 8014
    },
    {
        "id": 801403,
        "name_th": "ฉลอง",
        "name_en": "Chalong",
        "zip_codes": [
            80120
        ],
        "district_id": 8014
    },
    {
        "id": 801404,
        "name_th": "เสาเภา",
        "name_en": "Sao Phao",
        "zip_codes": [
            80340
        ],
        "district_id": 8014
    },
    {
        "id": 801405,
        "name_th": "เปลี่ยน",
        "name_en": "Plian",
        "zip_codes": [
            80120
        ],
        "district_id": 8014
    },
    {
        "id": 801406,
        "name_th": "สี่ขีด",
        "name_en": "Si Khit",
        "zip_codes": [
            80120
        ],
        "district_id": 8014
    },
    {
        "id": 801407,
        "name_th": "เทพราช",
        "name_en": "Theppharat",
        "zip_codes": [
            80340
        ],
        "district_id": 8014
    },
    {
        "id": 801408,
        "name_th": "เขาน้อย",
        "name_en": "Khao Noi",
        "zip_codes": [
            80120
        ],
        "district_id": 8014
    },
    {
        "id": 801409,
        "name_th": "ทุ่งใส",
        "name_en": "Thung Sai",
        "zip_codes": [
            80120
        ],
        "district_id": 8014
    },
    {
        "id": 801501,
        "name_th": "ขนอม",
        "name_en": "Khanom",
        "zip_codes": [
            80210
        ],
        "district_id": 8015
    },
    {
        "id": 801502,
        "name_th": "ควนทอง",
        "name_en": "Khuan Thong",
        "zip_codes": [
            80210
        ],
        "district_id": 8015
    },
    {
        "id": 801503,
        "name_th": "ท้องเนียน",
        "name_en": "Thong Nian",
        "zip_codes": [
            80210
        ],
        "district_id": 8015
    },
    {
        "id": 801601,
        "name_th": "หัวไทร",
        "name_en": "Hua Sai",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801602,
        "name_th": "หน้าสตน",
        "name_en": "Na Saton",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801603,
        "name_th": "ทรายขาว",
        "name_en": "Sai Khao",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801604,
        "name_th": "แหลม",
        "name_en": "Laem",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801605,
        "name_th": "เขาพังไกร",
        "name_en": "Khao Phang Krai",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801606,
        "name_th": "บ้านราม",
        "name_en": "Ban Ram",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801607,
        "name_th": "บางนบ",
        "name_en": "Bang Nop",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801608,
        "name_th": "ท่าซอม",
        "name_en": "Tha Som",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801609,
        "name_th": "ควนชะลิก",
        "name_en": "Khuan Chalik",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801610,
        "name_th": "รามแก้ว",
        "name_en": "Ram Kaeo",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801611,
        "name_th": "เกาะเพชร",
        "name_en": "Ko Phet",
        "zip_codes": [
            80170
        ],
        "district_id": 8016
    },
    {
        "id": 801701,
        "name_th": "บางขัน",
        "name_en": "Bang Khan",
        "zip_codes": [
            80360
        ],
        "district_id": 8017
    },
    {
        "id": 801702,
        "name_th": "บ้านลำนาว",
        "name_en": "Ban Lam Nao",
        "zip_codes": [
            80360
        ],
        "district_id": 8017
    },
    {
        "id": 801703,
        "name_th": "วังหิน",
        "name_en": "Wang Hin",
        "zip_codes": [
            80360
        ],
        "district_id": 8017
    },
    {
        "id": 801704,
        "name_th": "บ้านนิคม",
        "name_en": "Ban Nikhom",
        "zip_codes": [
            80360
        ],
        "district_id": 8017
    },
    {
        "id": 801801,
        "name_th": "ถ้ำพรรณรา",
        "name_en": "Tham Phannara",
        "zip_codes": [
            80260
        ],
        "district_id": 8018
    },
    {
        "id": 801802,
        "name_th": "คลองเส",
        "name_en": "Khlong Se",
        "zip_codes": [
            80260
        ],
        "district_id": 8018
    },
    {
        "id": 801803,
        "name_th": "ดุสิต",
        "name_en": "Dusit",
        "zip_codes": [
            80260
        ],
        "district_id": 8018
    },
    {
        "id": 801901,
        "name_th": "บ้านควนมุด",
        "name_en": "Ban Khuan Mut",
        "zip_codes": [
            80180
        ],
        "district_id": 8019
    },
    {
        "id": 801902,
        "name_th": "บ้านชะอวด",
        "name_en": "Ban Cha-uat",
        "zip_codes": [
            80180
        ],
        "district_id": 8019
    },
    {
        "id": 801903,
        "name_th": "ควนหนองคว้า",
        "name_en": "Khuan Nong Khwa",
        "zip_codes": [
            80130
        ],
        "district_id": 8019
    },
    {
        "id": 801904,
        "name_th": "ทุ่งโพธิ์",
        "name_en": "Thung Pho",
        "zip_codes": [
            80130
        ],
        "district_id": 8019
    },
    {
        "id": 801905,
        "name_th": "นาหมอบุญ",
        "name_en": "Na Mo Bun",
        "zip_codes": [
            80130
        ],
        "district_id": 8019
    },
    {
        "id": 801906,
        "name_th": "สามตำบล",
        "name_en": "Sam Tambon",
        "zip_codes": [
            80130
        ],
        "district_id": 8019
    },
    {
        "id": 802001,
        "name_th": "นาพรุ",
        "name_en": "Na Phru",
        "zip_codes": [
            80000
        ],
        "district_id": 8020
    },
    {
        "id": 802002,
        "name_th": "นาสาร",
        "name_en": "Na San",
        "zip_codes": [
            80000
        ],
        "district_id": 8020
    },
    {
        "id": 802003,
        "name_th": "ท้ายสำเภา",
        "name_en": "Thai Samphao",
        "zip_codes": [
            80000
        ],
        "district_id": 8020
    },
    {
        "id": 802004,
        "name_th": "ช้างซ้าย",
        "name_en": "Chang Sai",
        "zip_codes": [
            80000
        ],
        "district_id": 8020
    },
    {
        "id": 802101,
        "name_th": "นบพิตำ",
        "name_en": "Nopphitam",
        "zip_codes": [
            80160
        ],
        "district_id": 8021
    },
    {
        "id": 802102,
        "name_th": "กรุงชิง",
        "name_en": "Krung Ching",
        "zip_codes": [
            80160
        ],
        "district_id": 8021
    },
    {
        "id": 802103,
        "name_th": "กะหรอ",
        "name_en": "Kalo",
        "zip_codes": [
            80160
        ],
        "district_id": 8021
    },
    {
        "id": 802104,
        "name_th": "นาเหรง",
        "name_en": "Na Reng",
        "zip_codes": [
            80160
        ],
        "district_id": 8021
    },
    {
        "id": 802201,
        "name_th": "ช้างกลาง",
        "name_en": "Chang Klang",
        "zip_codes": [
            80220,
            80250
        ],
        "district_id": 8022
    },
    {
        "id": 802202,
        "name_th": "หลักช้าง",
        "name_en": "Lak Chang",
        "zip_codes": [
            80250
        ],
        "district_id": 8022
    },
    {
        "id": 802203,
        "name_th": "สวนขัน",
        "name_en": "Suan Khan",
        "zip_codes": [
            80250
        ],
        "district_id": 8022
    },
    {
        "id": 802301,
        "name_th": "เชียรเขา",
        "name_en": "Chian Khao",
        "zip_codes": [
            80190
        ],
        "district_id": 8023
    },
    {
        "id": 802302,
        "name_th": "ดอนตรอ",
        "name_en": "Don Tro",
        "zip_codes": [
            80290
        ],
        "district_id": 8023
    },
    {
        "id": 802303,
        "name_th": "สวนหลวง",
        "name_en": "Suan Luang",
        "zip_codes": [
            80190
        ],
        "district_id": 8023
    },
    {
        "id": 802304,
        "name_th": "ทางพูน",
        "name_en": "Thang Phun",
        "zip_codes": [
            80290,
            80350
        ],
        "district_id": 8023
    },
    {
        "id": 810101,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810102,
        "name_th": "กระบี่ใหญ่",
        "name_en": "Krabi Yai",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810103,
        "name_th": "กระบี่น้อย",
        "name_en": "Krabi Noi",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810105,
        "name_th": "เขาคราม",
        "name_en": "Khao Khram",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810106,
        "name_th": "เขาทอง",
        "name_en": "Khao Thong",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810111,
        "name_th": "ทับปริก",
        "name_en": "Thap Prik",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810115,
        "name_th": "ไสไทย",
        "name_en": "Sai Thai",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810116,
        "name_th": "อ่าวนาง",
        "name_en": "Ao Nang",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810117,
        "name_th": "หนองทะเล",
        "name_en": "Nong Thale",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810118,
        "name_th": "คลองประสงค์",
        "name_en": "Khlong Prasong",
        "zip_codes": [
            81000
        ],
        "district_id": 8101
    },
    {
        "id": 810201,
        "name_th": "เขาพนม",
        "name_en": "Khao Phanom",
        "zip_codes": [
            81140
        ],
        "district_id": 8102
    },
    {
        "id": 810202,
        "name_th": "เขาดิน",
        "name_en": "Khao Din",
        "zip_codes": [
            81140
        ],
        "district_id": 8102
    },
    {
        "id": 810203,
        "name_th": "สินปุน",
        "name_en": "Sin Pun",
        "zip_codes": [
            80240
        ],
        "district_id": 8102
    },
    {
        "id": 810204,
        "name_th": "พรุเตียว",
        "name_en": "Phru Tiao",
        "zip_codes": [
            81140
        ],
        "district_id": 8102
    },
    {
        "id": 810205,
        "name_th": "หน้าเขา",
        "name_en": "Na Khao",
        "zip_codes": [
            81140
        ],
        "district_id": 8102
    },
    {
        "id": 810206,
        "name_th": "โคกหาร",
        "name_en": "Khok Han",
        "zip_codes": [
            80240
        ],
        "district_id": 8102
    },
    {
        "id": 810301,
        "name_th": "เกาะลันตาใหญ่",
        "name_en": "Ko Lanta Yai",
        "zip_codes": [
            81150
        ],
        "district_id": 8103
    },
    {
        "id": 810302,
        "name_th": "เกาะลันตาน้อย",
        "name_en": "Ko Lanta Noi",
        "zip_codes": [
            81150
        ],
        "district_id": 8103
    },
    {
        "id": 810303,
        "name_th": "เกาะกลาง",
        "name_en": "Ko Klang",
        "zip_codes": [
            81120
        ],
        "district_id": 8103
    },
    {
        "id": 810304,
        "name_th": "คลองยาง",
        "name_en": "Khlong Yang",
        "zip_codes": [
            81120
        ],
        "district_id": 8103
    },
    {
        "id": 810305,
        "name_th": "ศาลาด่าน",
        "name_en": "Sala Dan",
        "zip_codes": [
            81150
        ],
        "district_id": 8103
    },
    {
        "id": 810401,
        "name_th": "คลองท่อมใต้",
        "name_en": "Khlong Thom Tai",
        "zip_codes": [
            81120
        ],
        "district_id": 8104
    },
    {
        "id": 810402,
        "name_th": "คลองท่อมเหนือ",
        "name_en": "Khlong Thom Nuea",
        "zip_codes": [
            81120
        ],
        "district_id": 8104
    },
    {
        "id": 810403,
        "name_th": "คลองพน",
        "name_en": "Khlong Phon",
        "zip_codes": [
            81170
        ],
        "district_id": 8104
    },
    {
        "id": 810404,
        "name_th": "ทรายขาว",
        "name_en": "Sai Khao",
        "zip_codes": [
            81170
        ],
        "district_id": 8104
    },
    {
        "id": 810405,
        "name_th": "ห้วยน้ำขาว",
        "name_en": "Huai Nam Khao",
        "zip_codes": [
            81120
        ],
        "district_id": 8104
    },
    {
        "id": 810406,
        "name_th": "พรุดินนา",
        "name_en": "Phru Din Na",
        "zip_codes": [
            81120
        ],
        "district_id": 8104
    },
    {
        "id": 810407,
        "name_th": "เพหลา",
        "name_en": "Phela",
        "zip_codes": [
            81120
        ],
        "district_id": 8104
    },
    {
        "id": 810501,
        "name_th": "อ่าวลึกใต้",
        "name_en": "Ao Luek Tai",
        "zip_codes": [
            81110
        ],
        "district_id": 8105
    },
    {
        "id": 810502,
        "name_th": "แหลมสัก",
        "name_en": "Laem Sak",
        "zip_codes": [
            81110
        ],
        "district_id": 8105
    },
    {
        "id": 810503,
        "name_th": "นาเหนือ",
        "name_en": "Na Nuea",
        "zip_codes": [
            81110
        ],
        "district_id": 8105
    },
    {
        "id": 810504,
        "name_th": "คลองหิน",
        "name_en": "Khlong Hin",
        "zip_codes": [
            81110
        ],
        "district_id": 8105
    },
    {
        "id": 810505,
        "name_th": "อ่าวลึกน้อย",
        "name_en": "Ao Luek Noi",
        "zip_codes": [
            81110
        ],
        "district_id": 8105
    },
    {
        "id": 810506,
        "name_th": "อ่าวลึกเหนือ",
        "name_en": "Ao Luek Nuea",
        "zip_codes": [
            81110
        ],
        "district_id": 8105
    },
    {
        "id": 810507,
        "name_th": "เขาใหญ่",
        "name_en": "Khao Yai",
        "zip_codes": [
            81110
        ],
        "district_id": 8105
    },
    {
        "id": 810508,
        "name_th": "คลองยา",
        "name_en": "Khlong Ya",
        "zip_codes": [
            81110
        ],
        "district_id": 8105
    },
    {
        "id": 810509,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            81110
        ],
        "district_id": 8105
    },
    {
        "id": 810601,
        "name_th": "ปลายพระยา",
        "name_en": "Plai Phraya",
        "zip_codes": [
            81160
        ],
        "district_id": 8106
    },
    {
        "id": 810602,
        "name_th": "เขาเขน",
        "name_en": "Khao Khen",
        "zip_codes": [
            81160
        ],
        "district_id": 8106
    },
    {
        "id": 810603,
        "name_th": "เขาต่อ",
        "name_en": "Khao To",
        "zip_codes": [
            81160
        ],
        "district_id": 8106
    },
    {
        "id": 810604,
        "name_th": "คีรีวง",
        "name_en": "Khiri Wong",
        "zip_codes": [
            81160
        ],
        "district_id": 8106
    },
    {
        "id": 810701,
        "name_th": "ลำทับ",
        "name_en": "Lam Thap",
        "zip_codes": [
            81190
        ],
        "district_id": 8107
    },
    {
        "id": 810702,
        "name_th": "ดินอุดม",
        "name_en": "Din Udom",
        "zip_codes": [
            81190
        ],
        "district_id": 8107
    },
    {
        "id": 810703,
        "name_th": "ทุ่งไทรทอง",
        "name_en": "Thung Sai Thong",
        "zip_codes": [
            81190
        ],
        "district_id": 8107
    },
    {
        "id": 810704,
        "name_th": "ดินแดง",
        "name_en": "Din Daeng",
        "zip_codes": [
            81190
        ],
        "district_id": 8107
    },
    {
        "id": 810801,
        "name_th": "เหนือคลอง",
        "name_en": "Nuea Khlong",
        "zip_codes": [
            81130
        ],
        "district_id": 8108
    },
    {
        "id": 810802,
        "name_th": "เกาะศรีบอยา",
        "name_en": "Ko Siboya",
        "zip_codes": [
            81130
        ],
        "district_id": 8108
    },
    {
        "id": 810803,
        "name_th": "คลองขนาน",
        "name_en": "Khlong Khanan",
        "zip_codes": [
            81130
        ],
        "district_id": 8108
    },
    {
        "id": 810804,
        "name_th": "คลองเขม้า",
        "name_en": "Khlong Khamao",
        "zip_codes": [
            81130
        ],
        "district_id": 8108
    },
    {
        "id": 810805,
        "name_th": "โคกยาง",
        "name_en": "Khok Yang",
        "zip_codes": [
            81130
        ],
        "district_id": 8108
    },
    {
        "id": 810806,
        "name_th": "ตลิ่งชัน",
        "name_en": "Taling Chan",
        "zip_codes": [
            81130
        ],
        "district_id": 8108
    },
    {
        "id": 810807,
        "name_th": "ปกาสัย",
        "name_en": "Pakasai",
        "zip_codes": [
            81130
        ],
        "district_id": 8108
    },
    {
        "id": 810808,
        "name_th": "ห้วยยูง",
        "name_en": "Huai Yung",
        "zip_codes": [
            81130
        ],
        "district_id": 8108
    },
    {
        "id": 820101,
        "name_th": "ท้ายช้าง",
        "name_en": "Thai Chang",
        "zip_codes": [
            82000
        ],
        "district_id": 8201
    },
    {
        "id": 820102,
        "name_th": "นบปริง",
        "name_en": "Nop Pring",
        "zip_codes": [
            82000
        ],
        "district_id": 8201
    },
    {
        "id": 820103,
        "name_th": "ถ้ำน้ำผุด",
        "name_en": "Tham Nam Phut",
        "zip_codes": [
            82000
        ],
        "district_id": 8201
    },
    {
        "id": 820104,
        "name_th": "บางเตย",
        "name_en": "Bang Toei",
        "zip_codes": [
            82000
        ],
        "district_id": 8201
    },
    {
        "id": 820105,
        "name_th": "ตากแดด",
        "name_en": "Tak Daet",
        "zip_codes": [
            82000
        ],
        "district_id": 8201
    },
    {
        "id": 820106,
        "name_th": "สองแพรก",
        "name_en": "Song Phraek",
        "zip_codes": [
            82000
        ],
        "district_id": 8201
    },
    {
        "id": 820107,
        "name_th": "ทุ่งคาโงก",
        "name_en": "Thung Kha Ngok",
        "zip_codes": [
            82000
        ],
        "district_id": 8201
    },
    {
        "id": 820108,
        "name_th": "เกาะปันหยี",
        "name_en": "Ko Panyi",
        "zip_codes": [
            82000
        ],
        "district_id": 8201
    },
    {
        "id": 820109,
        "name_th": "ป่ากอ",
        "name_en": "Pa Ko",
        "zip_codes": [
            82000
        ],
        "district_id": 8201
    },
    {
        "id": 820201,
        "name_th": "เกาะยาวน้อย",
        "name_en": "Ko Yao Noi",
        "zip_codes": [
            82160
        ],
        "district_id": 8202
    },
    {
        "id": 820202,
        "name_th": "เกาะยาวใหญ่",
        "name_en": "Ko yao Yai",
        "zip_codes": [
            82160
        ],
        "district_id": 8202
    },
    {
        "id": 820203,
        "name_th": "พรุใน",
        "name_en": "Phru Nai",
        "zip_codes": [
            83000
        ],
        "district_id": 8202
    },
    {
        "id": 820301,
        "name_th": "กะปง",
        "name_en": "Kapong",
        "zip_codes": [
            82170
        ],
        "district_id": 8203
    },
    {
        "id": 820302,
        "name_th": "ท่านา",
        "name_en": "Tha Na",
        "zip_codes": [
            82170
        ],
        "district_id": 8203
    },
    {
        "id": 820303,
        "name_th": "เหมาะ",
        "name_en": "Mo",
        "zip_codes": [
            82170
        ],
        "district_id": 8203
    },
    {
        "id": 820304,
        "name_th": "เหล",
        "name_en": "Le",
        "zip_codes": [
            82170
        ],
        "district_id": 8203
    },
    {
        "id": 820305,
        "name_th": "รมณีย์",
        "name_en": "Rommani",
        "zip_codes": [
            82170
        ],
        "district_id": 8203
    },
    {
        "id": 820401,
        "name_th": "ถ้ำ",
        "name_en": "Tham",
        "zip_codes": [
            82130
        ],
        "district_id": 8204
    },
    {
        "id": 820402,
        "name_th": "กระโสม",
        "name_en": "Krasom",
        "zip_codes": [
            82130
        ],
        "district_id": 8204
    },
    {
        "id": 820403,
        "name_th": "กะไหล",
        "name_en": "Kalai",
        "zip_codes": [
            82130
        ],
        "district_id": 8204
    },
    {
        "id": 820404,
        "name_th": "ท่าอยู่",
        "name_en": "Tha Yu",
        "zip_codes": [
            82130
        ],
        "district_id": 8204
    },
    {
        "id": 820405,
        "name_th": "หล่อยูง",
        "name_en": "Lo Yung",
        "zip_codes": [
            82140
        ],
        "district_id": 8204
    },
    {
        "id": 820406,
        "name_th": "โคกกลอย",
        "name_en": "Khok Kloi",
        "zip_codes": [
            82140
        ],
        "district_id": 8204
    },
    {
        "id": 820407,
        "name_th": "คลองเคียน",
        "name_en": "Khlong Khian",
        "zip_codes": [
            82130
        ],
        "district_id": 8204
    },
    {
        "id": 820501,
        "name_th": "ตะกั่วป่า",
        "name_en": "Takua Pa",
        "zip_codes": [
            82110
        ],
        "district_id": 8205
    },
    {
        "id": 820502,
        "name_th": "บางนายสี",
        "name_en": "Bang Nai Si",
        "zip_codes": [
            82110
        ],
        "district_id": 8205
    },
    {
        "id": 820503,
        "name_th": "บางไทร",
        "name_en": "Bang Sai",
        "zip_codes": [
            82110
        ],
        "district_id": 8205
    },
    {
        "id": 820504,
        "name_th": "บางม่วง",
        "name_en": "Bang Muang",
        "zip_codes": [
            82110,
            82190
        ],
        "district_id": 8205
    },
    {
        "id": 820505,
        "name_th": "ตำตัว",
        "name_en": "Tam Tua",
        "zip_codes": [
            82110
        ],
        "district_id": 8205
    },
    {
        "id": 820506,
        "name_th": "โคกเคียน",
        "name_en": "Khok Khian",
        "zip_codes": [
            82110
        ],
        "district_id": 8205
    },
    {
        "id": 820507,
        "name_th": "คึกคัก",
        "name_en": "Khuekkhak",
        "zip_codes": [
            82190
        ],
        "district_id": 8205
    },
    {
        "id": 820508,
        "name_th": "เกาะคอเขา",
        "name_en": "Ko Kho Khao",
        "zip_codes": [
            82190
        ],
        "district_id": 8205
    },
    {
        "id": 820601,
        "name_th": "คุระ",
        "name_en": "Khura",
        "zip_codes": [
            82150
        ],
        "district_id": 8206
    },
    {
        "id": 820602,
        "name_th": "บางวัน",
        "name_en": "Bang Wan",
        "zip_codes": [
            82150
        ],
        "district_id": 8206
    },
    {
        "id": 820603,
        "name_th": "เกาะพระทอง",
        "name_en": "Ko Phra Thong",
        "zip_codes": [
            82150
        ],
        "district_id": 8206
    },
    {
        "id": 820605,
        "name_th": "แม่นางขาว",
        "name_en": "Mae Nang Khao",
        "zip_codes": [
            82150
        ],
        "district_id": 8206
    },
    {
        "id": 820701,
        "name_th": "ทับปุด",
        "name_en": "Thap Put",
        "zip_codes": [
            82180
        ],
        "district_id": 8207
    },
    {
        "id": 820702,
        "name_th": "มะรุ่ย",
        "name_en": "Marui",
        "zip_codes": [
            82180
        ],
        "district_id": 8207
    },
    {
        "id": 820703,
        "name_th": "บ่อแสน",
        "name_en": "Bo Saen",
        "zip_codes": [
            82180
        ],
        "district_id": 8207
    },
    {
        "id": 820704,
        "name_th": "ถ้ำทองหลาง",
        "name_en": "Tham Thonglang",
        "zip_codes": [
            82180
        ],
        "district_id": 8207
    },
    {
        "id": 820705,
        "name_th": "โคกเจริญ",
        "name_en": "Khok Charoen",
        "zip_codes": [
            82180
        ],
        "district_id": 8207
    },
    {
        "id": 820706,
        "name_th": "บางเหรียง",
        "name_en": "Bang Riang",
        "zip_codes": [
            82180
        ],
        "district_id": 8207
    },
    {
        "id": 820801,
        "name_th": "ท้ายเหมือง",
        "name_en": "Thai Mueang",
        "zip_codes": [
            82120
        ],
        "district_id": 8208
    },
    {
        "id": 820802,
        "name_th": "นาเตย",
        "name_en": "Na Toei",
        "zip_codes": [
            82120
        ],
        "district_id": 8208
    },
    {
        "id": 820803,
        "name_th": "บางทอง",
        "name_en": "Bang Thong",
        "zip_codes": [
            82120
        ],
        "district_id": 8208
    },
    {
        "id": 820804,
        "name_th": "ทุ่งมะพร้าว",
        "name_en": "Thung Maphrao",
        "zip_codes": [
            82120
        ],
        "district_id": 8208
    },
    {
        "id": 820805,
        "name_th": "ลำภี",
        "name_en": "Lam Phi",
        "zip_codes": [
            82120
        ],
        "district_id": 8208
    },
    {
        "id": 820806,
        "name_th": "ลำแก่น",
        "name_en": "Lam Kaen",
        "zip_codes": [
            82120,
            82210
        ],
        "district_id": 8208
    },
    {
        "id": 830101,
        "name_th": "ตลาดใหญ่",
        "name_en": "Talat Yai",
        "zip_codes": [
            83000
        ],
        "district_id": 8301
    },
    {
        "id": 830102,
        "name_th": "ตลาดเหนือ",
        "name_en": "Talat Nuea",
        "zip_codes": [
            83000
        ],
        "district_id": 8301
    },
    {
        "id": 830103,
        "name_th": "เกาะแก้ว",
        "name_en": "Ko Kaeo",
        "zip_codes": [
            83000
        ],
        "district_id": 8301
    },
    {
        "id": 830104,
        "name_th": "รัษฎา",
        "name_en": "Ratsada",
        "zip_codes": [
            83000
        ],
        "district_id": 8301
    },
    {
        "id": 830105,
        "name_th": "วิชิต",
        "name_en": "Wichit",
        "zip_codes": [
            83000
        ],
        "district_id": 8301
    },
    {
        "id": 830106,
        "name_th": "ฉลอง",
        "name_en": "Chalong",
        "zip_codes": [
            83130
        ],
        "district_id": 8301
    },
    {
        "id": 830107,
        "name_th": "ราไวย์",
        "name_en": "Rawai",
        "zip_codes": [
            83130
        ],
        "district_id": 8301
    },
    {
        "id": 830108,
        "name_th": "กะรน",
        "name_en": "Karon",
        "zip_codes": [
            83100
        ],
        "district_id": 8301
    },
    {
        "id": 830201,
        "name_th": "กะทู้",
        "name_en": "Kathu",
        "zip_codes": [
            83120
        ],
        "district_id": 8302
    },
    {
        "id": 830202,
        "name_th": "ป่าตอง",
        "name_en": "Pa Tong",
        "zip_codes": [
            83150
        ],
        "district_id": 8302
    },
    {
        "id": 830203,
        "name_th": "กมลา",
        "name_en": "Kamala",
        "zip_codes": [
            83150
        ],
        "district_id": 8302
    },
    {
        "id": 830301,
        "name_th": "เทพกระษัตรี",
        "name_en": "Thep Krasatti",
        "zip_codes": [
            83110
        ],
        "district_id": 8303
    },
    {
        "id": 830302,
        "name_th": "ศรีสุนทร",
        "name_en": "Si Sunthon",
        "zip_codes": [
            83110
        ],
        "district_id": 8303
    },
    {
        "id": 830303,
        "name_th": "เชิงทะเล",
        "name_en": "Choeng Thale",
        "zip_codes": [
            83110
        ],
        "district_id": 8303
    },
    {
        "id": 830304,
        "name_th": "ป่าคลอก",
        "name_en": "Pa Khlok",
        "zip_codes": [
            83110
        ],
        "district_id": 8303
    },
    {
        "id": 830305,
        "name_th": "ไม้ขาว",
        "name_en": "Mai Khao",
        "zip_codes": [
            83110
        ],
        "district_id": 8303
    },
    {
        "id": 830306,
        "name_th": "สาคู",
        "name_en": "Sakhu",
        "zip_codes": [
            83110
        ],
        "district_id": 8303
    },
    {
        "id": 840101,
        "name_th": "ตลาด",
        "name_en": "Talat",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840102,
        "name_th": "มะขามเตี้ย",
        "name_en": "Makham Tia",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840103,
        "name_th": "วัดประดู่",
        "name_en": "Wat Pradu",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840104,
        "name_th": "ขุนทะเล",
        "name_en": "Khun Thale",
        "zip_codes": [
            84100
        ],
        "district_id": 8401
    },
    {
        "id": 840105,
        "name_th": "บางใบไม้",
        "name_en": "Bang Bai Mai",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840106,
        "name_th": "บางชนะ",
        "name_en": "Bang Chana",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840107,
        "name_th": "คลองน้อย",
        "name_en": "Khlong Noi",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840108,
        "name_th": "บางไทร",
        "name_en": "Bang Sai",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840109,
        "name_th": "บางโพธิ์",
        "name_en": "Bang Pho",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840110,
        "name_th": "บางกุ้ง",
        "name_en": "Bang Kung",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840111,
        "name_th": "คลองฉนาก",
        "name_en": "Khlong Chanak",
        "zip_codes": [
            84000
        ],
        "district_id": 8401
    },
    {
        "id": 840201,
        "name_th": "ท่าทองใหม่",
        "name_en": "Tha Thong Mai",
        "zip_codes": [
            84290
        ],
        "district_id": 8402
    },
    {
        "id": 840202,
        "name_th": "ท่าทอง",
        "name_en": "Tha Thong",
        "zip_codes": [
            84160
        ],
        "district_id": 8402
    },
    {
        "id": 840203,
        "name_th": "กะแดะ",
        "name_en": "Kadae",
        "zip_codes": [
            84160
        ],
        "district_id": 8402
    },
    {
        "id": 840204,
        "name_th": "ทุ่งกง",
        "name_en": "Thung Kong",
        "zip_codes": [
            84290
        ],
        "district_id": 8402
    },
    {
        "id": 840205,
        "name_th": "กรูด",
        "name_en": "Krut",
        "zip_codes": [
            84160
        ],
        "district_id": 8402
    },
    {
        "id": 840206,
        "name_th": "ช้างซ้าย",
        "name_en": "Chang Sai",
        "zip_codes": [
            84160
        ],
        "district_id": 8402
    },
    {
        "id": 840207,
        "name_th": "พลายวาส",
        "name_en": "Phlai Wat",
        "zip_codes": [
            84160
        ],
        "district_id": 8402
    },
    {
        "id": 840208,
        "name_th": "ป่าร่อน",
        "name_en": "Pa Ron",
        "zip_codes": [
            84160
        ],
        "district_id": 8402
    },
    {
        "id": 840209,
        "name_th": "ตะเคียนทอง",
        "name_en": "Takhian Thong",
        "zip_codes": [
            84160
        ],
        "district_id": 8402
    },
    {
        "id": 840210,
        "name_th": "ช้างขวา",
        "name_en": "Chang Khwa",
        "zip_codes": [
            84160
        ],
        "district_id": 8402
    },
    {
        "id": 840211,
        "name_th": "ท่าอุแท",
        "name_en": "Tha U-thae",
        "zip_codes": [
            84160,
            84340
        ],
        "district_id": 8402
    },
    {
        "id": 840212,
        "name_th": "ทุ่งรัง",
        "name_en": "Thung Rang",
        "zip_codes": [
            84290
        ],
        "district_id": 8402
    },
    {
        "id": 840213,
        "name_th": "คลองสระ",
        "name_en": "Khlong Sa",
        "zip_codes": [
            84160
        ],
        "district_id": 8402
    },
    {
        "id": 840301,
        "name_th": "ดอนสัก",
        "name_en": "Don Sak",
        "zip_codes": [
            84220
        ],
        "district_id": 8403
    },
    {
        "id": 840302,
        "name_th": "ชลคราม",
        "name_en": "Chonlakhram",
        "zip_codes": [
            84160
        ],
        "district_id": 8403
    },
    {
        "id": 840303,
        "name_th": "ไชยคราม",
        "name_en": "Chaiyakhram",
        "zip_codes": [
            84220
        ],
        "district_id": 8403
    },
    {
        "id": 840304,
        "name_th": "ปากแพรก",
        "name_en": "Pak Phraek",
        "zip_codes": [
            84340
        ],
        "district_id": 8403
    },
    {
        "id": 840401,
        "name_th": "อ่างทอง",
        "name_en": "Ang Thong",
        "zip_codes": [
            84140,
            84220
        ],
        "district_id": 8404
    },
    {
        "id": 840402,
        "name_th": "ลิปะน้อย",
        "name_en": "Lipa Noi",
        "zip_codes": [
            84140
        ],
        "district_id": 8404
    },
    {
        "id": 840403,
        "name_th": "ตลิ่งงาม",
        "name_en": "Taling Ngam",
        "zip_codes": [
            84140
        ],
        "district_id": 8404
    },
    {
        "id": 840404,
        "name_th": "หน้าเมือง",
        "name_en": "Na Mueang",
        "zip_codes": [
            84140
        ],
        "district_id": 8404
    },
    {
        "id": 840405,
        "name_th": "มะเร็ต",
        "name_en": "Maret",
        "zip_codes": [
            84310
        ],
        "district_id": 8404
    },
    {
        "id": 840406,
        "name_th": "บ่อผุด",
        "name_en": "Bo Phut",
        "zip_codes": [
            84320
        ],
        "district_id": 8404
    },
    {
        "id": 840407,
        "name_th": "แม่น้ำ",
        "name_en": "Mae Nam",
        "zip_codes": [
            84330
        ],
        "district_id": 8404
    },
    {
        "id": 840501,
        "name_th": "เกาะพะงัน",
        "name_en": "Ko Pha-ngan",
        "zip_codes": [
            84280
        ],
        "district_id": 8405
    },
    {
        "id": 840502,
        "name_th": "บ้านใต้",
        "name_en": "Ban Tai",
        "zip_codes": [
            84280
        ],
        "district_id": 8405
    },
    {
        "id": 840503,
        "name_th": "เกาะเต่า",
        "name_en": "Ko Tao",
        "zip_codes": [
            84360
        ],
        "district_id": 8405
    },
    {
        "id": 840601,
        "name_th": "ตลาดไชยา",
        "name_en": "Talat Chaiya",
        "zip_codes": [
            84110
        ],
        "district_id": 8406
    },
    {
        "id": 840602,
        "name_th": "พุมเรียง",
        "name_en": "Phum Riang",
        "zip_codes": [
            84110
        ],
        "district_id": 8406
    },
    {
        "id": 840603,
        "name_th": "เลม็ด",
        "name_en": "Lamet",
        "zip_codes": [
            84110
        ],
        "district_id": 8406
    },
    {
        "id": 840604,
        "name_th": "เวียง",
        "name_en": "Wiang",
        "zip_codes": [
            84110
        ],
        "district_id": 8406
    },
    {
        "id": 840605,
        "name_th": "ทุ่ง",
        "name_en": "Thung",
        "zip_codes": [
            84110
        ],
        "district_id": 8406
    },
    {
        "id": 840606,
        "name_th": "ป่าเว",
        "name_en": "Pa We",
        "zip_codes": [
            84110
        ],
        "district_id": 8406
    },
    {
        "id": 840607,
        "name_th": "ตะกรบ",
        "name_en": "Takrop",
        "zip_codes": [
            84110
        ],
        "district_id": 8406
    },
    {
        "id": 840608,
        "name_th": "โมถ่าย",
        "name_en": "Mo Thai",
        "zip_codes": [
            84110
        ],
        "district_id": 8406
    },
    {
        "id": 840609,
        "name_th": "ปากหมาก",
        "name_en": "Pak Mak",
        "zip_codes": [
            84110
        ],
        "district_id": 8406
    },
    {
        "id": 840701,
        "name_th": "ท่าชนะ",
        "name_en": "Tha Chana",
        "zip_codes": [
            84170
        ],
        "district_id": 8407
    },
    {
        "id": 840702,
        "name_th": "สมอทอง",
        "name_en": "Samo Thong",
        "zip_codes": [
            84170
        ],
        "district_id": 8407
    },
    {
        "id": 840703,
        "name_th": "ประสงค์",
        "name_en": "Prasong",
        "zip_codes": [
            84170
        ],
        "district_id": 8407
    },
    {
        "id": 840704,
        "name_th": "คันธุลี",
        "name_en": "Khan Thuli",
        "zip_codes": [
            84170
        ],
        "district_id": 8407
    },
    {
        "id": 840705,
        "name_th": "วัง",
        "name_en": "Wang",
        "zip_codes": [
            84170
        ],
        "district_id": 8407
    },
    {
        "id": 840706,
        "name_th": "คลองพา",
        "name_en": "Khlong Pha",
        "zip_codes": [
            84170
        ],
        "district_id": 8407
    },
    {
        "id": 840801,
        "name_th": "ท่าขนอน",
        "name_en": "Tha Khanon",
        "zip_codes": [
            84180
        ],
        "district_id": 8408
    },
    {
        "id": 840802,
        "name_th": "บ้านยาง",
        "name_en": "Ban Yang",
        "zip_codes": [
            84180
        ],
        "district_id": 8408
    },
    {
        "id": 840803,
        "name_th": "น้ำหัก",
        "name_en": "Nam Hak",
        "zip_codes": [
            84180
        ],
        "district_id": 8408
    },
    {
        "id": 840806,
        "name_th": "กะเปา",
        "name_en": "Kapao",
        "zip_codes": [
            84180
        ],
        "district_id": 8408
    },
    {
        "id": 840807,
        "name_th": "ท่ากระดาน",
        "name_en": "Tha Kradan",
        "zip_codes": [
            84180
        ],
        "district_id": 8408
    },
    {
        "id": 840808,
        "name_th": "ย่านยาว",
        "name_en": "Yan Yao",
        "zip_codes": [
            84180
        ],
        "district_id": 8408
    },
    {
        "id": 840809,
        "name_th": "ถ้ำสิงขร",
        "name_en": "Tham Singkhon",
        "zip_codes": [
            84180
        ],
        "district_id": 8408
    },
    {
        "id": 840810,
        "name_th": "บ้านทำเนียบ",
        "name_en": "Ban Thamniap",
        "zip_codes": [
            84180
        ],
        "district_id": 8408
    },
    {
        "id": 840901,
        "name_th": "เขาวง",
        "name_en": "Khao Wong",
        "zip_codes": [
            84230
        ],
        "district_id": 8409
    },
    {
        "id": 840902,
        "name_th": "พะแสง",
        "name_en": "Phasaeng",
        "zip_codes": [
            84230
        ],
        "district_id": 8409
    },
    {
        "id": 840903,
        "name_th": "พรุไทย",
        "name_en": "Phru Thai",
        "zip_codes": [
            84230
        ],
        "district_id": 8409
    },
    {
        "id": 840904,
        "name_th": "เขาพัง",
        "name_en": "Khao Phang",
        "zip_codes": [
            84230
        ],
        "district_id": 8409
    },
    {
        "id": 841001,
        "name_th": "พนม",
        "name_en": "Phanom",
        "zip_codes": [
            84250
        ],
        "district_id": 8410
    },
    {
        "id": 841002,
        "name_th": "ต้นยวน",
        "name_en": "Ton Yuan",
        "zip_codes": [
            84250
        ],
        "district_id": 8410
    },
    {
        "id": 841003,
        "name_th": "คลองศก",
        "name_en": "Khlong Sok",
        "zip_codes": [
            84250
        ],
        "district_id": 8410
    },
    {
        "id": 841004,
        "name_th": "พลูเถื่อน",
        "name_en": "Phlu Thuean",
        "zip_codes": [
            84250
        ],
        "district_id": 8410
    },
    {
        "id": 841005,
        "name_th": "พังกาญจน์",
        "name_en": "Phang Kan",
        "zip_codes": [
            84250
        ],
        "district_id": 8410
    },
    {
        "id": 841006,
        "name_th": "คลองชะอุ่น",
        "name_en": "Khlong Cha-un",
        "zip_codes": [
            84250
        ],
        "district_id": 8410
    },
    {
        "id": 841101,
        "name_th": "ท่าฉาง",
        "name_en": "Tha Chang",
        "zip_codes": [
            84150
        ],
        "district_id": 8411
    },
    {
        "id": 841102,
        "name_th": "ท่าเคย",
        "name_en": "Tha Khoei",
        "zip_codes": [
            84150
        ],
        "district_id": 8411
    },
    {
        "id": 841103,
        "name_th": "คลองไทร",
        "name_en": "Khlong Sai",
        "zip_codes": [
            84150
        ],
        "district_id": 8411
    },
    {
        "id": 841104,
        "name_th": "เขาถ่าน",
        "name_en": "Khao Than",
        "zip_codes": [
            84150
        ],
        "district_id": 8411
    },
    {
        "id": 841105,
        "name_th": "เสวียด",
        "name_en": "Sawiat",
        "zip_codes": [
            84150
        ],
        "district_id": 8411
    },
    {
        "id": 841106,
        "name_th": "ปากฉลุย",
        "name_en": "Pak Chalui",
        "zip_codes": [
            84150
        ],
        "district_id": 8411
    },
    {
        "id": 841201,
        "name_th": "นาสาร",
        "name_en": "Na San",
        "zip_codes": [
            84120
        ],
        "district_id": 8412
    },
    {
        "id": 841202,
        "name_th": "พรุพี",
        "name_en": "Phru Phi",
        "zip_codes": [
            84270
        ],
        "district_id": 8412
    },
    {
        "id": 841203,
        "name_th": "ทุ่งเตา",
        "name_en": "Thung Tao",
        "zip_codes": [
            84120
        ],
        "district_id": 8412
    },
    {
        "id": 841204,
        "name_th": "ลำพูน",
        "name_en": "Lamphun",
        "zip_codes": [
            84120
        ],
        "district_id": 8412
    },
    {
        "id": 841205,
        "name_th": "ท่าชี",
        "name_en": "Tha Chi",
        "zip_codes": [
            84120
        ],
        "district_id": 8412
    },
    {
        "id": 841206,
        "name_th": "ควนศรี",
        "name_en": "Khuan Si",
        "zip_codes": [
            84270
        ],
        "district_id": 8412
    },
    {
        "id": 841207,
        "name_th": "ควนสุบรรณ",
        "name_en": "Khuan Suban",
        "zip_codes": [
            84120,
            84240
        ],
        "district_id": 8412
    },
    {
        "id": 841208,
        "name_th": "คลองปราบ",
        "name_en": "Khlong Prap",
        "zip_codes": [
            84120
        ],
        "district_id": 8412
    },
    {
        "id": 841209,
        "name_th": "น้ำพุ",
        "name_en": "Nam Phu",
        "zip_codes": [
            84120
        ],
        "district_id": 8412
    },
    {
        "id": 841210,
        "name_th": "ทุ่งเตาใหม่",
        "name_en": "Thung Tao Mai",
        "zip_codes": [
            84120
        ],
        "district_id": 8412
    },
    {
        "id": 841211,
        "name_th": "เพิ่มพูนทรัพย์",
        "name_en": "Phoem Phun Sap",
        "zip_codes": [
            84120
        ],
        "district_id": 8412
    },
    {
        "id": 841301,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            84240
        ],
        "district_id": 8413
    },
    {
        "id": 841302,
        "name_th": "ท่าเรือ",
        "name_en": "Tha Ruea",
        "zip_codes": [
            84240
        ],
        "district_id": 8413
    },
    {
        "id": 841303,
        "name_th": "ทรัพย์ทวี",
        "name_en": "Sap Thawi",
        "zip_codes": [
            84240
        ],
        "district_id": 8413
    },
    {
        "id": 841304,
        "name_th": "นาใต้",
        "name_en": "Na Tai",
        "zip_codes": [
            84240
        ],
        "district_id": 8413
    },
    {
        "id": 841401,
        "name_th": "เคียนซา",
        "name_en": "Khian Sa",
        "zip_codes": [
            84260
        ],
        "district_id": 8414
    },
    {
        "id": 841402,
        "name_th": "พ่วงพรมคร",
        "name_en": "Phuang Phrom Khon",
        "zip_codes": [
            84210
        ],
        "district_id": 8414
    },
    {
        "id": 841403,
        "name_th": "เขาตอก",
        "name_en": "Khao Tok",
        "zip_codes": [
            84260
        ],
        "district_id": 8414
    },
    {
        "id": 841404,
        "name_th": "อรัญคามวารี",
        "name_en": "Aranyakham Wari",
        "zip_codes": [
            84260
        ],
        "district_id": 8414
    },
    {
        "id": 841405,
        "name_th": "บ้านเสด็จ",
        "name_en": "Ban Sadet",
        "zip_codes": [
            84260
        ],
        "district_id": 8414
    },
    {
        "id": 841501,
        "name_th": "เวียงสระ",
        "name_en": "Wiang Sa",
        "zip_codes": [
            84190
        ],
        "district_id": 8415
    },
    {
        "id": 841502,
        "name_th": "บ้านส้อง",
        "name_en": "Ban Song",
        "zip_codes": [
            84190
        ],
        "district_id": 8415
    },
    {
        "id": 841503,
        "name_th": "คลองฉนวน",
        "name_en": "Khlong Chanuan",
        "zip_codes": [
            84190
        ],
        "district_id": 8415
    },
    {
        "id": 841504,
        "name_th": "ทุ่งหลวง",
        "name_en": "Thung Luang",
        "zip_codes": [
            84190
        ],
        "district_id": 8415
    },
    {
        "id": 841505,
        "name_th": "เขานิพันธ์",
        "name_en": "Khao Niphan",
        "zip_codes": [
            84190
        ],
        "district_id": 8415
    },
    {
        "id": 841601,
        "name_th": "อิปัน",
        "name_en": "I-pan",
        "zip_codes": [
            84210
        ],
        "district_id": 8416
    },
    {
        "id": 841602,
        "name_th": "สินปุน",
        "name_en": "Sin Pun",
        "zip_codes": [
            84210
        ],
        "district_id": 8416
    },
    {
        "id": 841603,
        "name_th": "บางสวรรค์",
        "name_en": "Bang Sawan",
        "zip_codes": [
            84210
        ],
        "district_id": 8416
    },
    {
        "id": 841604,
        "name_th": "ไทรขึง",
        "name_en": "Sai Khueng",
        "zip_codes": [
            84210
        ],
        "district_id": 8416
    },
    {
        "id": 841605,
        "name_th": "สินเจริญ",
        "name_en": "Sin Charoen",
        "zip_codes": [
            84210
        ],
        "district_id": 8416
    },
    {
        "id": 841606,
        "name_th": "ไทรโสภา",
        "name_en": "Sai Sopha",
        "zip_codes": [
            84210
        ],
        "district_id": 8416
    },
    {
        "id": 841607,
        "name_th": "สาคู",
        "name_en": "Sakhu",
        "zip_codes": [
            84210
        ],
        "district_id": 8416
    },
    {
        "id": 841701,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841702,
        "name_th": "ท่าสะท้อน",
        "name_en": "Tha Sathon",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841703,
        "name_th": "ลีเล็ด",
        "name_en": "Lilet",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841704,
        "name_th": "บางมะเดื่อ",
        "name_en": "Bang Maduea",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841705,
        "name_th": "บางเดือน",
        "name_en": "Bang Duean",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841706,
        "name_th": "ท่าโรงช้าง",
        "name_en": "Tha Rong Chang",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841707,
        "name_th": "กรูด",
        "name_en": "Krut",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841708,
        "name_th": "พุนพิน",
        "name_en": "Phunphin",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841709,
        "name_th": "บางงอน",
        "name_en": "Bang Ngon",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841710,
        "name_th": "ศรีวิชัย",
        "name_en": "Si Wichai",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841711,
        "name_th": "น้ำรอบ",
        "name_en": "Nam Rop",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841712,
        "name_th": "มะลวน",
        "name_en": "Maluan",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841713,
        "name_th": "หัวเตย",
        "name_en": "Hua Toei",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841714,
        "name_th": "หนองไทร",
        "name_en": "Nong Sai",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841715,
        "name_th": "เขาหัวควาย",
        "name_en": "Khao Hua Khwai",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841716,
        "name_th": "ตะปาน",
        "name_en": "Tapan",
        "zip_codes": [
            84130
        ],
        "district_id": 8417
    },
    {
        "id": 841801,
        "name_th": "สองแพรก",
        "name_en": "Song Phraek",
        "zip_codes": [
            84350
        ],
        "district_id": 8418
    },
    {
        "id": 841802,
        "name_th": "ชัยบุรี",
        "name_en": "Chai Buri",
        "zip_codes": [
            84350
        ],
        "district_id": 8418
    },
    {
        "id": 841803,
        "name_th": "คลองน้อย",
        "name_en": "Khlong Noi",
        "zip_codes": [
            84350
        ],
        "district_id": 8418
    },
    {
        "id": 841804,
        "name_th": "ไทรทอง",
        "name_en": "Sai Thong",
        "zip_codes": [
            84350
        ],
        "district_id": 8418
    },
    {
        "id": 841901,
        "name_th": "ตะกุกใต้",
        "name_en": "Takuk Tai",
        "zip_codes": [
            84370
        ],
        "district_id": 8419
    },
    {
        "id": 841902,
        "name_th": "ตะกุกเหนือ",
        "name_en": "Takuk Nuea",
        "zip_codes": [
            84370
        ],
        "district_id": 8419
    },
    {
        "id": 850101,
        "name_th": "เขานิเวศน์",
        "name_en": "Khao Niwet",
        "zip_codes": [
            85000
        ],
        "district_id": 8501
    },
    {
        "id": 850102,
        "name_th": "ราชกรูด",
        "name_en": "Ratchakrut",
        "zip_codes": [
            85000
        ],
        "district_id": 8501
    },
    {
        "id": 850103,
        "name_th": "หงาว",
        "name_en": "Ngao",
        "zip_codes": [
            85000
        ],
        "district_id": 8501
    },
    {
        "id": 850104,
        "name_th": "บางริ้น",
        "name_en": "Bang Rin",
        "zip_codes": [
            85000
        ],
        "district_id": 8501
    },
    {
        "id": 850105,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            85000
        ],
        "district_id": 8501
    },
    {
        "id": 850106,
        "name_th": "บางนอน",
        "name_en": "Bang Non",
        "zip_codes": [
            85000
        ],
        "district_id": 8501
    },
    {
        "id": 850107,
        "name_th": "หาดส้มแป้น",
        "name_en": "Hat Som Paen",
        "zip_codes": [
            85000
        ],
        "district_id": 8501
    },
    {
        "id": 850108,
        "name_th": "ทรายแดง",
        "name_en": "Sai Daeng",
        "zip_codes": [
            85130
        ],
        "district_id": 8501
    },
    {
        "id": 850109,
        "name_th": "เกาะพยาม",
        "name_en": "Ko Phayam",
        "zip_codes": [
            85000
        ],
        "district_id": 8501
    },
    {
        "id": 850201,
        "name_th": "ละอุ่นใต้",
        "name_en": "La-un Tai",
        "zip_codes": [
            85130
        ],
        "district_id": 8502
    },
    {
        "id": 850202,
        "name_th": "ละอุ่นเหนือ",
        "name_en": "La-un Nuea",
        "zip_codes": [
            85130
        ],
        "district_id": 8502
    },
    {
        "id": 850203,
        "name_th": "บางพระใต้",
        "name_en": "Bang Phra Tai",
        "zip_codes": [
            85130
        ],
        "district_id": 8502
    },
    {
        "id": 850204,
        "name_th": "บางพระเหนือ",
        "name_en": "Bang Phra Nuea",
        "zip_codes": [
            85130
        ],
        "district_id": 8502
    },
    {
        "id": 850205,
        "name_th": "บางแก้ว",
        "name_en": "Bang Kaeo",
        "zip_codes": [
            85130
        ],
        "district_id": 8502
    },
    {
        "id": 850206,
        "name_th": "ในวงเหนือ",
        "name_en": "Nai Wong Nuea",
        "zip_codes": [
            85130
        ],
        "district_id": 8502
    },
    {
        "id": 850207,
        "name_th": "ในวงใต้",
        "name_en": "Nai Wong Tai",
        "zip_codes": [
            85130
        ],
        "district_id": 8502
    },
    {
        "id": 850301,
        "name_th": "ม่วงกลวง",
        "name_en": "Muang Kluang",
        "zip_codes": [
            85120
        ],
        "district_id": 8503
    },
    {
        "id": 850302,
        "name_th": "กะเปอร์",
        "name_en": "Kapoe",
        "zip_codes": [
            85120
        ],
        "district_id": 8503
    },
    {
        "id": 850303,
        "name_th": "เชี่ยวเหลียง",
        "name_en": "Chiao Liang",
        "zip_codes": [
            85120
        ],
        "district_id": 8503
    },
    {
        "id": 850304,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            85120
        ],
        "district_id": 8503
    },
    {
        "id": 850305,
        "name_th": "บางหิน",
        "name_en": "Bang Hin",
        "zip_codes": [
            85120
        ],
        "district_id": 8503
    },
    {
        "id": 850401,
        "name_th": "น้ำจืด",
        "name_en": "Nam Chuet",
        "zip_codes": [
            85110
        ],
        "district_id": 8504
    },
    {
        "id": 850402,
        "name_th": "น้ำจืดน้อย",
        "name_en": "Nam Chuet Noi",
        "zip_codes": [
            85110
        ],
        "district_id": 8504
    },
    {
        "id": 850403,
        "name_th": "มะมุ",
        "name_en": "Mamu",
        "zip_codes": [
            85110
        ],
        "district_id": 8504
    },
    {
        "id": 850404,
        "name_th": "ปากจั่น",
        "name_en": "Pak Chan",
        "zip_codes": [
            85110
        ],
        "district_id": 8504
    },
    {
        "id": 850405,
        "name_th": "ลำเลียง",
        "name_en": "Lam Liang",
        "zip_codes": [
            85110
        ],
        "district_id": 8504
    },
    {
        "id": 850406,
        "name_th": "จ.ป.ร.",
        "name_en": "Choporo",
        "zip_codes": [
            85110
        ],
        "district_id": 8504
    },
    {
        "id": 850407,
        "name_th": "บางใหญ่",
        "name_en": "Bang Yai",
        "zip_codes": [
            85110
        ],
        "district_id": 8504
    },
    {
        "id": 850501,
        "name_th": "นาคา",
        "name_en": "Nakha",
        "zip_codes": [
            85120
        ],
        "district_id": 8505
    },
    {
        "id": 850502,
        "name_th": "กำพวน",
        "name_en": "Kamphuan",
        "zip_codes": [
            85120
        ],
        "district_id": 8505
    },
    {
        "id": 860101,
        "name_th": "ท่าตะเภา",
        "name_en": "Tha Taphao",
        "zip_codes": [
            86000
        ],
        "district_id": 8601
    },
    {
        "id": 860102,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            86120
        ],
        "district_id": 8601
    },
    {
        "id": 860103,
        "name_th": "ท่ายาง",
        "name_en": "Tha Yang",
        "zip_codes": [
            86000,
            86120
        ],
        "district_id": 8601
    },
    {
        "id": 860104,
        "name_th": "บางหมาก",
        "name_en": "Bang Mak",
        "zip_codes": [
            86000
        ],
        "district_id": 8601
    },
    {
        "id": 860105,
        "name_th": "นาทุ่ง",
        "name_en": "Na Thung",
        "zip_codes": [
            86000
        ],
        "district_id": 8601
    },
    {
        "id": 860106,
        "name_th": "นาชะอัง",
        "name_en": "Na Cha-ang",
        "zip_codes": [
            86000
        ],
        "district_id": 8601
    },
    {
        "id": 860107,
        "name_th": "ตากแดด",
        "name_en": "Tak Daet",
        "zip_codes": [
            86000,
            86190
        ],
        "district_id": 8601
    },
    {
        "id": 860108,
        "name_th": "บางลึก",
        "name_en": "Bang Luek",
        "zip_codes": [
            86000
        ],
        "district_id": 8601
    },
    {
        "id": 860109,
        "name_th": "หาดพันไกร",
        "name_en": "Hat Phan Krai",
        "zip_codes": [
            86000
        ],
        "district_id": 8601
    },
    {
        "id": 860110,
        "name_th": "วังไผ่",
        "name_en": "Wang Phai",
        "zip_codes": [
            86000,
            86190
        ],
        "district_id": 8601
    },
    {
        "id": 860111,
        "name_th": "วังใหม่",
        "name_en": "Wang Mai",
        "zip_codes": [
            86190
        ],
        "district_id": 8601
    },
    {
        "id": 860112,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            86190
        ],
        "district_id": 8601
    },
    {
        "id": 860113,
        "name_th": "ขุนกระทิง",
        "name_en": "Khun Krathing",
        "zip_codes": [
            86000,
            86190
        ],
        "district_id": 8601
    },
    {
        "id": 860114,
        "name_th": "ทุ่งคา",
        "name_en": "Thung Kha",
        "zip_codes": [
            86100
        ],
        "district_id": 8601
    },
    {
        "id": 860115,
        "name_th": "วิสัยเหนือ",
        "name_en": "Wisai Nuea",
        "zip_codes": [
            86100
        ],
        "district_id": 8601
    },
    {
        "id": 860116,
        "name_th": "หาดทรายรี",
        "name_en": "Hat Sai Ri",
        "zip_codes": [
            86120
        ],
        "district_id": 8601
    },
    {
        "id": 860117,
        "name_th": "ถ้ำสิงห์",
        "name_en": "Tham Sing",
        "zip_codes": [
            86100
        ],
        "district_id": 8601
    },
    {
        "id": 860201,
        "name_th": "ท่าแซะ",
        "name_en": "Tha Sae",
        "zip_codes": [
            86140
        ],
        "district_id": 8602
    },
    {
        "id": 860202,
        "name_th": "คุริง",
        "name_en": "Khuring",
        "zip_codes": [
            86140
        ],
        "district_id": 8602
    },
    {
        "id": 860203,
        "name_th": "สลุย",
        "name_en": "Salui",
        "zip_codes": [
            86140
        ],
        "district_id": 8602
    },
    {
        "id": 860204,
        "name_th": "นากระตาม",
        "name_en": "Na Kratam",
        "zip_codes": [
            86140
        ],
        "district_id": 8602
    },
    {
        "id": 860205,
        "name_th": "รับร่อ",
        "name_en": "Rap Ro",
        "zip_codes": [
            86140,
            86190
        ],
        "district_id": 8602
    },
    {
        "id": 860206,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            86140
        ],
        "district_id": 8602
    },
    {
        "id": 860207,
        "name_th": "หงษ์เจริญ",
        "name_en": "Hong Charoen",
        "zip_codes": [
            86140
        ],
        "district_id": 8602
    },
    {
        "id": 860208,
        "name_th": "หินแก้ว",
        "name_en": "Hin Kaeo",
        "zip_codes": [
            86190
        ],
        "district_id": 8602
    },
    {
        "id": 860209,
        "name_th": "ทรัพย์อนันต์",
        "name_en": "Sap Anan",
        "zip_codes": [
            86140
        ],
        "district_id": 8602
    },
    {
        "id": 860210,
        "name_th": "สองพี่น้อง",
        "name_en": "Song Phi Nong",
        "zip_codes": [
            86140
        ],
        "district_id": 8602
    },
    {
        "id": 860301,
        "name_th": "บางสน",
        "name_en": "Bang Son",
        "zip_codes": [
            86160
        ],
        "district_id": 8603
    },
    {
        "id": 860302,
        "name_th": "ทะเลทรัพย์",
        "name_en": "Thale Sap",
        "zip_codes": [
            86160
        ],
        "district_id": 8603
    },
    {
        "id": 860303,
        "name_th": "สะพลี",
        "name_en": "Saphli",
        "zip_codes": [
            86230
        ],
        "district_id": 8603
    },
    {
        "id": 860304,
        "name_th": "ชุมโค",
        "name_en": "Chum Kho",
        "zip_codes": [
            86160
        ],
        "district_id": 8603
    },
    {
        "id": 860305,
        "name_th": "ดอนยาง",
        "name_en": "Don Yang",
        "zip_codes": [
            86210
        ],
        "district_id": 8603
    },
    {
        "id": 860306,
        "name_th": "ปากคลอง",
        "name_en": "Pak Khlong",
        "zip_codes": [
            86210
        ],
        "district_id": 8603
    },
    {
        "id": 860307,
        "name_th": "เขาไชยราช",
        "name_en": "Khao Chai Rat",
        "zip_codes": [
            86210
        ],
        "district_id": 8603
    },
    {
        "id": 860401,
        "name_th": "หลังสวน",
        "name_en": "Lang Suan",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860402,
        "name_th": "ขันเงิน",
        "name_en": "Khan Ngoen",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860403,
        "name_th": "ท่ามะพลา",
        "name_en": "Tha Maphla",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860404,
        "name_th": "นาขา",
        "name_en": "Na Kha",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860405,
        "name_th": "นาพญา",
        "name_en": "Na Phaya",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860406,
        "name_th": "บ้านควน",
        "name_en": "Ban Khuan",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860407,
        "name_th": "บางมะพร้าว",
        "name_en": "Bang Maphrao",
        "zip_codes": [
            86110,
            86150
        ],
        "district_id": 8604
    },
    {
        "id": 860408,
        "name_th": "บางน้ำจืด",
        "name_en": "Bang Nam Chuet",
        "zip_codes": [
            86150
        ],
        "district_id": 8604
    },
    {
        "id": 860409,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            86150
        ],
        "district_id": 8604
    },
    {
        "id": 860410,
        "name_th": "พ้อแดง",
        "name_en": "Pho Daeng",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860411,
        "name_th": "แหลมทราย",
        "name_en": "Laem Sai",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860412,
        "name_th": "วังตะกอ",
        "name_en": "Wang Tako",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860413,
        "name_th": "หาดยาย",
        "name_en": "Hat yai",
        "zip_codes": [
            86110
        ],
        "district_id": 8604
    },
    {
        "id": 860501,
        "name_th": "ละแม",
        "name_en": "Lamae",
        "zip_codes": [
            86170
        ],
        "district_id": 8605
    },
    {
        "id": 860502,
        "name_th": "ทุ่งหลวง",
        "name_en": "Thung Luang",
        "zip_codes": [
            86170
        ],
        "district_id": 8605
    },
    {
        "id": 860503,
        "name_th": "สวนแตง",
        "name_en": "Suan Taeng",
        "zip_codes": [
            86170
        ],
        "district_id": 8605
    },
    {
        "id": 860504,
        "name_th": "ทุ่งคาวัด",
        "name_en": "Thung Kha Wat",
        "zip_codes": [
            86170
        ],
        "district_id": 8605
    },
    {
        "id": 860601,
        "name_th": "พะโต๊ะ",
        "name_en": "Phato",
        "zip_codes": [
            86180
        ],
        "district_id": 8606
    },
    {
        "id": 860602,
        "name_th": "ปากทรง",
        "name_en": "Pak Song",
        "zip_codes": [
            86180
        ],
        "district_id": 8606
    },
    {
        "id": 860603,
        "name_th": "ปังหวาน",
        "name_en": "Pang Wan",
        "zip_codes": [
            86180
        ],
        "district_id": 8606
    },
    {
        "id": 860604,
        "name_th": "พระรักษ์",
        "name_en": "Phra Rak",
        "zip_codes": [
            86180
        ],
        "district_id": 8606
    },
    {
        "id": 860701,
        "name_th": "นาโพธิ์",
        "name_en": "Na Pho",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860702,
        "name_th": "สวี",
        "name_en": "Sawi",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860703,
        "name_th": "ทุ่งระยะ",
        "name_en": "Thung Raya",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860704,
        "name_th": "ท่าหิน",
        "name_en": "Tha Hin",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860705,
        "name_th": "ปากแพรก",
        "name_en": "Pak Phraek",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860706,
        "name_th": "ด่านสวี",
        "name_en": "Dan Sawi",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860707,
        "name_th": "ครน",
        "name_en": "Khron",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860708,
        "name_th": "วิสัยใต้",
        "name_en": "Wisai Tai",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860709,
        "name_th": "นาสัก",
        "name_en": "Na Sak",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860710,
        "name_th": "เขาทะลุ",
        "name_en": "Khao Thalu",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860711,
        "name_th": "เขาค่าย",
        "name_en": "Khao Khai",
        "zip_codes": [
            86130
        ],
        "district_id": 8607
    },
    {
        "id": 860801,
        "name_th": "ปากตะโก",
        "name_en": "Pak Tako",
        "zip_codes": [
            86220
        ],
        "district_id": 8608
    },
    {
        "id": 860802,
        "name_th": "ทุ่งตะไคร",
        "name_en": "Thung Takhrai",
        "zip_codes": [
            86220
        ],
        "district_id": 8608
    },
    {
        "id": 860803,
        "name_th": "ตะโก",
        "name_en": "Tako",
        "zip_codes": [
            86220
        ],
        "district_id": 8608
    },
    {
        "id": 860804,
        "name_th": "ช่องไม้แก้ว",
        "name_en": "Chong Mai Kaeo",
        "zip_codes": [
            86220
        ],
        "district_id": 8608
    },
    {
        "id": 900101,
        "name_th": "บ่อยาง",
        "name_en": "Bo Yang",
        "zip_codes": [
            90000
        ],
        "district_id": 9001
    },
    {
        "id": 900102,
        "name_th": "เขารูปช้าง",
        "name_en": "Khao Rup Chang",
        "zip_codes": [
            90000
        ],
        "district_id": 9001
    },
    {
        "id": 900103,
        "name_th": "เกาะแต้ว",
        "name_en": "Ko Taeo",
        "zip_codes": [
            90000
        ],
        "district_id": 9001
    },
    {
        "id": 900104,
        "name_th": "พะวง",
        "name_en": "Phawong",
        "zip_codes": [
            90100
        ],
        "district_id": 9001
    },
    {
        "id": 900105,
        "name_th": "ทุ่งหวัง",
        "name_en": "Thung Wang",
        "zip_codes": [
            90000
        ],
        "district_id": 9001
    },
    {
        "id": 900106,
        "name_th": "เกาะยอ",
        "name_en": "Ko Yo",
        "zip_codes": [
            90100
        ],
        "district_id": 9001
    },
    {
        "id": 900201,
        "name_th": "จะทิ้งพระ",
        "name_en": "Chathing Phra",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900202,
        "name_th": "กระดังงา",
        "name_en": "Kradang-nga",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900203,
        "name_th": "สนามชัย",
        "name_en": "Sanam Chai",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900204,
        "name_th": "ดีหลวง",
        "name_en": "Di Luang",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900205,
        "name_th": "ชุมพล",
        "name_en": "Chumphon",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900206,
        "name_th": "คลองรี",
        "name_en": "Khlong Ri",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900207,
        "name_th": "คูขุด",
        "name_en": "Khu Khut",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900208,
        "name_th": "ท่าหิน",
        "name_en": "Tha Hin",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900209,
        "name_th": "วัดจันทร์",
        "name_en": "Wat Chan",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900210,
        "name_th": "บ่อแดง",
        "name_en": "Bo Daeng",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900211,
        "name_th": "บ่อดาน",
        "name_en": "Bo Dan",
        "zip_codes": [
            90190
        ],
        "district_id": 9002
    },
    {
        "id": 900301,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900302,
        "name_th": "ป่าชิง",
        "name_en": "Pa Ching",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900303,
        "name_th": "สะพานไม้แก่น",
        "name_en": "Saphan Mai Kaen",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900304,
        "name_th": "สะกอม",
        "name_en": "Sakom",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900305,
        "name_th": "นาหว้า",
        "name_en": "Na Wa",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900306,
        "name_th": "นาทับ",
        "name_en": "Na Thap",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900307,
        "name_th": "น้ำขาว",
        "name_en": "Nam Khao",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900308,
        "name_th": "ขุนตัดหวาย",
        "name_en": "Khun Tat Wai",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900309,
        "name_th": "ท่าหมอไทร",
        "name_en": "Tha Mo Sai",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900310,
        "name_th": "จะโหนง",
        "name_en": "Chanong",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900311,
        "name_th": "คู",
        "name_en": "Khu",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900312,
        "name_th": "แค",
        "name_en": "Khae",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900313,
        "name_th": "คลองเปียะ",
        "name_en": "Khlong Pia",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900314,
        "name_th": "ตลิ่งชัน",
        "name_en": "Taling Chan",
        "zip_codes": [
            90130
        ],
        "district_id": 9003
    },
    {
        "id": 900401,
        "name_th": "นาทวี",
        "name_en": "Na Thawi",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900402,
        "name_th": "ฉาง",
        "name_en": "Chang",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900403,
        "name_th": "นาหมอศรี",
        "name_en": "Na Mo Si",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900404,
        "name_th": "คลองทราย",
        "name_en": "Khlong Sai",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900405,
        "name_th": "ปลักหนู",
        "name_en": "Plak Nu",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900406,
        "name_th": "ท่าประดู่",
        "name_en": "Tha Pradu",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900407,
        "name_th": "สะท้อน",
        "name_en": "Sathon",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900408,
        "name_th": "ทับช้าง",
        "name_en": "Thap Chang",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900409,
        "name_th": "ประกอบ",
        "name_en": "Prakop",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900410,
        "name_th": "คลองกวาง",
        "name_en": "Khlong Kwang",
        "zip_codes": [
            90160
        ],
        "district_id": 9004
    },
    {
        "id": 900501,
        "name_th": "เทพา",
        "name_en": "Thepha",
        "zip_codes": [
            90150
        ],
        "district_id": 9005
    },
    {
        "id": 900502,
        "name_th": "ปากบาง",
        "name_en": "Pak Bang",
        "zip_codes": [
            90150
        ],
        "district_id": 9005
    },
    {
        "id": 900503,
        "name_th": "เกาะสะบ้า",
        "name_en": "Ko Saba",
        "zip_codes": [
            90150
        ],
        "district_id": 9005
    },
    {
        "id": 900504,
        "name_th": "ลำไพล",
        "name_en": "Lam Phlai",
        "zip_codes": [
            90260
        ],
        "district_id": 9005
    },
    {
        "id": 900505,
        "name_th": "ท่าม่วง",
        "name_en": "Tha Muang",
        "zip_codes": [
            90150,
            90260
        ],
        "district_id": 9005
    },
    {
        "id": 900506,
        "name_th": "วังใหญ่",
        "name_en": "Wang Yai",
        "zip_codes": [
            90260
        ],
        "district_id": 9005
    },
    {
        "id": 900507,
        "name_th": "สะกอม",
        "name_en": "Sakom",
        "zip_codes": [
            90150
        ],
        "district_id": 9005
    },
    {
        "id": 900601,
        "name_th": "สะบ้าย้อย",
        "name_en": "Saba Yoi",
        "zip_codes": [
            90210
        ],
        "district_id": 9006
    },
    {
        "id": 900602,
        "name_th": "ทุ่งพอ",
        "name_en": "Thung Pho",
        "zip_codes": [
            90210
        ],
        "district_id": 9006
    },
    {
        "id": 900603,
        "name_th": "เปียน",
        "name_en": "Pian",
        "zip_codes": [
            90210
        ],
        "district_id": 9006
    },
    {
        "id": 900604,
        "name_th": "บ้านโหนด",
        "name_en": "Ban Not",
        "zip_codes": [
            90210
        ],
        "district_id": 9006
    },
    {
        "id": 900605,
        "name_th": "จะแหน",
        "name_en": "Chanae",
        "zip_codes": [
            90210
        ],
        "district_id": 9006
    },
    {
        "id": 900606,
        "name_th": "คูหา",
        "name_en": "Khuha",
        "zip_codes": [
            90210
        ],
        "district_id": 9006
    },
    {
        "id": 900607,
        "name_th": "เขาแดง",
        "name_en": "Khao Daeng",
        "zip_codes": [
            90210
        ],
        "district_id": 9006
    },
    {
        "id": 900608,
        "name_th": "บาโหย",
        "name_en": "Ba Hoi",
        "zip_codes": [
            90210
        ],
        "district_id": 9006
    },
    {
        "id": 900609,
        "name_th": "ธารคีรี",
        "name_en": "Than Khiri",
        "zip_codes": [
            90210
        ],
        "district_id": 9006
    },
    {
        "id": 900701,
        "name_th": "ระโนด",
        "name_en": "Ranot",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900702,
        "name_th": "คลองแดน",
        "name_en": "Khlong Daen",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900703,
        "name_th": "ตะเครียะ",
        "name_en": "Takhria",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900704,
        "name_th": "ท่าบอน",
        "name_en": "Tha Bon",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900705,
        "name_th": "บ้านใหม่",
        "name_en": "Ban Mai",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900706,
        "name_th": "บ่อตรุ",
        "name_en": "Bo Tru",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900707,
        "name_th": "ปากแตระ",
        "name_en": "Pak Trae",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900708,
        "name_th": "พังยาง",
        "name_en": "Phang Yang",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900709,
        "name_th": "ระวะ",
        "name_en": "Rawa",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900710,
        "name_th": "วัดสน",
        "name_en": "Wat Son",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900711,
        "name_th": "บ้านขาว",
        "name_en": "Ban Khwa",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900712,
        "name_th": "แดนสงวน",
        "name_en": "Daen Sa-nguan",
        "zip_codes": [
            90140
        ],
        "district_id": 9007
    },
    {
        "id": 900801,
        "name_th": "เกาะใหญ่",
        "name_en": "Ko Yai",
        "zip_codes": [
            90270
        ],
        "district_id": 9008
    },
    {
        "id": 900802,
        "name_th": "โรง",
        "name_en": "Rong",
        "zip_codes": [
            90270
        ],
        "district_id": 9008
    },
    {
        "id": 900803,
        "name_th": "เชิงแส",
        "name_en": "Choeng Sae",
        "zip_codes": [
            90270
        ],
        "district_id": 9008
    },
    {
        "id": 900804,
        "name_th": "กระแสสินธุ์",
        "name_en": "Krasae Sin",
        "zip_codes": [
            90270
        ],
        "district_id": 9008
    },
    {
        "id": 900901,
        "name_th": "กำแพงเพชร",
        "name_en": "Kamphaeng Phet",
        "zip_codes": [
            90180
        ],
        "district_id": 9009
    },
    {
        "id": 900902,
        "name_th": "ท่าชะมวง",
        "name_en": "Tha Chamuang",
        "zip_codes": [
            90180
        ],
        "district_id": 9009
    },
    {
        "id": 900903,
        "name_th": "คูหาใต้",
        "name_en": "Khuha Tai",
        "zip_codes": [
            90180
        ],
        "district_id": 9009
    },
    {
        "id": 900904,
        "name_th": "ควนรู",
        "name_en": "Khuan Ru",
        "zip_codes": [
            90180,
            90220
        ],
        "district_id": 9009
    },
    {
        "id": 900909,
        "name_th": "เขาพระ",
        "name_en": "Khao Phra",
        "zip_codes": [
            90180
        ],
        "district_id": 9009
    },
    {
        "id": 901001,
        "name_th": "สะเดา",
        "name_en": "Sadao",
        "zip_codes": [
            90120
        ],
        "district_id": 9010
    },
    {
        "id": 901002,
        "name_th": "ปริก",
        "name_en": "Prik",
        "zip_codes": [
            90120
        ],
        "district_id": 9010
    },
    {
        "id": 901003,
        "name_th": "พังลา",
        "name_en": "Phang La",
        "zip_codes": [
            90170
        ],
        "district_id": 9010
    },
    {
        "id": 901004,
        "name_th": "สำนักแต้ว",
        "name_en": "Samnak Taeo",
        "zip_codes": [
            90120
        ],
        "district_id": 9010
    },
    {
        "id": 901005,
        "name_th": "ทุ่งหมอ",
        "name_en": "Thung Mo",
        "zip_codes": [
            90240
        ],
        "district_id": 9010
    },
    {
        "id": 901006,
        "name_th": "ท่าโพธิ์",
        "name_en": "Tha Pho",
        "zip_codes": [
            90170
        ],
        "district_id": 9010
    },
    {
        "id": 901007,
        "name_th": "ปาดังเบซาร์",
        "name_en": "Padang Besa",
        "zip_codes": [
            90240
        ],
        "district_id": 9010
    },
    {
        "id": 901008,
        "name_th": "สำนักขาม",
        "name_en": "Samnak Kham",
        "zip_codes": [
            90120,
            90320
        ],
        "district_id": 9010
    },
    {
        "id": 901009,
        "name_th": "เขามีเกียรติ",
        "name_en": "Khao Mi Kiat",
        "zip_codes": [
            90170
        ],
        "district_id": 9010
    },
    {
        "id": 901101,
        "name_th": "หาดใหญ่",
        "name_en": "Hat yai",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901102,
        "name_th": "ควนลัง",
        "name_en": "Khuan Lang",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901103,
        "name_th": "คูเต่า",
        "name_en": "Khu Tao",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901104,
        "name_th": "คอหงส์",
        "name_en": "Kho Hong",
        "zip_codes": [
            90110,
            90112
        ],
        "district_id": 9011
    },
    {
        "id": 901105,
        "name_th": "คลองแห",
        "name_en": "Khlong Hae",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901107,
        "name_th": "คลองอู่ตะเภา",
        "name_en": "Khlong U Taphao",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901108,
        "name_th": "ฉลุง",
        "name_en": "Chalung",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901111,
        "name_th": "ทุ่งใหญ่",
        "name_en": "Thung Yai",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901112,
        "name_th": "ทุ่งตำเสา",
        "name_en": "Thung Tam Sao",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901113,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901114,
        "name_th": "น้ำน้อย",
        "name_en": "Nam Noi",
        "zip_codes": [
            90110
        ],
        "district_id": 9011
    },
    {
        "id": 901116,
        "name_th": "บ้านพรุ",
        "name_en": "Ban Phru",
        "zip_codes": [
            90250
        ],
        "district_id": 9011
    },
    {
        "id": 901118,
        "name_th": "พะตง",
        "name_en": "Phatong",
        "zip_codes": [
            90230
        ],
        "district_id": 9011
    },
    {
        "id": 901201,
        "name_th": "นาหม่อม",
        "name_en": "Na Mom",
        "zip_codes": [
            90310
        ],
        "district_id": 9012
    },
    {
        "id": 901202,
        "name_th": "พิจิตร",
        "name_en": "Phichit",
        "zip_codes": [
            90310
        ],
        "district_id": 9012
    },
    {
        "id": 901203,
        "name_th": "ทุ่งขมิ้น",
        "name_en": "Thung Khamin",
        "zip_codes": [
            90310
        ],
        "district_id": 9012
    },
    {
        "id": 901204,
        "name_th": "คลองหรัง",
        "name_en": "Khlong Rang",
        "zip_codes": [
            90310
        ],
        "district_id": 9012
    },
    {
        "id": 901301,
        "name_th": "รัตภูมิ",
        "name_en": "Rattaphum",
        "zip_codes": [
            90220
        ],
        "district_id": 9013
    },
    {
        "id": 901302,
        "name_th": "ควนโส",
        "name_en": "Khuan So",
        "zip_codes": [
            90220
        ],
        "district_id": 9013
    },
    {
        "id": 901303,
        "name_th": "ห้วยลึก",
        "name_en": "Huai Luek",
        "zip_codes": [
            90220
        ],
        "district_id": 9013
    },
    {
        "id": 901304,
        "name_th": "บางเหรียง",
        "name_en": "Bang Riang",
        "zip_codes": [
            90220
        ],
        "district_id": 9013
    },
    {
        "id": 901401,
        "name_th": "บางกล่ำ",
        "name_en": "Bang Klam",
        "zip_codes": [
            90110
        ],
        "district_id": 9014
    },
    {
        "id": 901402,
        "name_th": "ท่าช้าง",
        "name_en": "Tha Chang",
        "zip_codes": [
            90110
        ],
        "district_id": 9014
    },
    {
        "id": 901403,
        "name_th": "แม่ทอม",
        "name_en": "Mae Thom",
        "zip_codes": [
            90110
        ],
        "district_id": 9014
    },
    {
        "id": 901404,
        "name_th": "บ้านหาร",
        "name_en": "Ban Han",
        "zip_codes": [
            90110
        ],
        "district_id": 9014
    },
    {
        "id": 901501,
        "name_th": "ชิงโค",
        "name_en": "Ching Kho",
        "zip_codes": [
            90280
        ],
        "district_id": 9015
    },
    {
        "id": 901502,
        "name_th": "สทิงหม้อ",
        "name_en": "Sathing Mo",
        "zip_codes": [
            90280
        ],
        "district_id": 9015
    },
    {
        "id": 901503,
        "name_th": "ทำนบ",
        "name_en": "Thamnop",
        "zip_codes": [
            90280
        ],
        "district_id": 9015
    },
    {
        "id": 901504,
        "name_th": "รำแดง",
        "name_en": "Ram Daeng",
        "zip_codes": [
            90330
        ],
        "district_id": 9015
    },
    {
        "id": 901505,
        "name_th": "วัดขนุน",
        "name_en": "Wat Khanun",
        "zip_codes": [
            90330
        ],
        "district_id": 9015
    },
    {
        "id": 901506,
        "name_th": "ชะแล้",
        "name_en": "Chalae",
        "zip_codes": [
            90330
        ],
        "district_id": 9015
    },
    {
        "id": 901507,
        "name_th": "ปากรอ",
        "name_en": "Pak Ro",
        "zip_codes": [
            90330
        ],
        "district_id": 9015
    },
    {
        "id": 901508,
        "name_th": "ป่าขาด",
        "name_en": "Pa Khat",
        "zip_codes": [
            90330
        ],
        "district_id": 9015
    },
    {
        "id": 901509,
        "name_th": "หัวเขา",
        "name_en": "Hua Khao",
        "zip_codes": [
            90280
        ],
        "district_id": 9015
    },
    {
        "id": 901510,
        "name_th": "บางเขียด",
        "name_en": "Bang Khiat",
        "zip_codes": [
            90330
        ],
        "district_id": 9015
    },
    {
        "id": 901511,
        "name_th": "ม่วงงาม",
        "name_en": "Muang Ngam",
        "zip_codes": [
            90330
        ],
        "district_id": 9015
    },
    {
        "id": 901601,
        "name_th": "คลองหอยโข่ง",
        "name_en": "Khlong Hoi Khong",
        "zip_codes": [
            90230
        ],
        "district_id": 9016
    },
    {
        "id": 901602,
        "name_th": "ทุ่งลาน",
        "name_en": "Thung Lan",
        "zip_codes": [
            90230
        ],
        "district_id": 9016
    },
    {
        "id": 901603,
        "name_th": "โคกม่วง",
        "name_en": "Khok Muang",
        "zip_codes": [
            90115,
            90230
        ],
        "district_id": 9016
    },
    {
        "id": 901604,
        "name_th": "คลองหลา",
        "name_en": "Khlong La",
        "zip_codes": [
            90110
        ],
        "district_id": 9016
    },
    {
        "id": 910101,
        "name_th": "พิมาน",
        "name_en": "Phiman",
        "zip_codes": [
            91000
        ],
        "district_id": 9101
    },
    {
        "id": 910102,
        "name_th": "คลองขุด",
        "name_en": "Khlong Khut",
        "zip_codes": [
            91000
        ],
        "district_id": 9101
    },
    {
        "id": 910103,
        "name_th": "ควนขัน",
        "name_en": "Khuan Khan",
        "zip_codes": [
            91000
        ],
        "district_id": 9101
    },
    {
        "id": 910104,
        "name_th": "บ้านควน",
        "name_en": "Ban Khuan",
        "zip_codes": [
            91140
        ],
        "district_id": 9101
    },
    {
        "id": 910105,
        "name_th": "ฉลุง",
        "name_en": "Chalung",
        "zip_codes": [
            91140
        ],
        "district_id": 9101
    },
    {
        "id": 910106,
        "name_th": "เกาะสาหร่าย",
        "name_en": "Ko Sarai",
        "zip_codes": [
            91000,
            91110
        ],
        "district_id": 9101
    },
    {
        "id": 910107,
        "name_th": "ตันหยงโป",
        "name_en": "Tanyong Po",
        "zip_codes": [
            91000
        ],
        "district_id": 9101
    },
    {
        "id": 910108,
        "name_th": "เจ๊ะบิลัง",
        "name_en": "Che Bilang",
        "zip_codes": [
            91000
        ],
        "district_id": 9101
    },
    {
        "id": 910109,
        "name_th": "ตำมะลัง",
        "name_en": "Tam Malang",
        "zip_codes": [
            91000
        ],
        "district_id": 9101
    },
    {
        "id": 910110,
        "name_th": "ปูยู",
        "name_en": "Puyu",
        "zip_codes": [
            91000
        ],
        "district_id": 9101
    },
    {
        "id": 910111,
        "name_th": "ควนโพธิ์",
        "name_en": "Khuan Pho",
        "zip_codes": [
            91140
        ],
        "district_id": 9101
    },
    {
        "id": 910112,
        "name_th": "เกตรี",
        "name_en": "Ket Ri",
        "zip_codes": [
            91140
        ],
        "district_id": 9101
    },
    {
        "id": 910201,
        "name_th": "ควนโดน",
        "name_en": "Khuan Don",
        "zip_codes": [
            91160
        ],
        "district_id": 9102
    },
    {
        "id": 910202,
        "name_th": "ควนสตอ",
        "name_en": "Khuan Sato",
        "zip_codes": [
            91160
        ],
        "district_id": 9102
    },
    {
        "id": 910203,
        "name_th": "ย่านซื่อ",
        "name_en": "Yan Sue",
        "zip_codes": [
            91160
        ],
        "district_id": 9102
    },
    {
        "id": 910204,
        "name_th": "วังประจัน",
        "name_en": "Wang Prachan",
        "zip_codes": [
            91160
        ],
        "district_id": 9102
    },
    {
        "id": 910301,
        "name_th": "ทุ่งนุ้ย",
        "name_en": "Thung Nui",
        "zip_codes": [
            91130
        ],
        "district_id": 9103
    },
    {
        "id": 910302,
        "name_th": "ควนกาหลง",
        "name_en": "Khuan Kalong",
        "zip_codes": [
            91130
        ],
        "district_id": 9103
    },
    {
        "id": 910303,
        "name_th": "อุใดเจริญ",
        "name_en": "Udai Charoen",
        "zip_codes": [
            91130
        ],
        "district_id": 9103
    },
    {
        "id": 910401,
        "name_th": "ท่าแพ",
        "name_en": "Tha Phae",
        "zip_codes": [
            91150
        ],
        "district_id": 9104
    },
    {
        "id": 910402,
        "name_th": "แป-ระ",
        "name_en": "Pae-ra",
        "zip_codes": [
            91150
        ],
        "district_id": 9104
    },
    {
        "id": 910403,
        "name_th": "สาคร",
        "name_en": "Sakhon",
        "zip_codes": [
            91150
        ],
        "district_id": 9104
    },
    {
        "id": 910404,
        "name_th": "ท่าเรือ",
        "name_en": "Tha Ruea",
        "zip_codes": [
            91150
        ],
        "district_id": 9104
    },
    {
        "id": 910501,
        "name_th": "กำแพง",
        "name_en": "Kamphaeng",
        "zip_codes": [
            91110
        ],
        "district_id": 9105
    },
    {
        "id": 910502,
        "name_th": "ละงู",
        "name_en": "La-ngu",
        "zip_codes": [
            91110
        ],
        "district_id": 9105
    },
    {
        "id": 910503,
        "name_th": "เขาขาว",
        "name_en": "Khao Khao",
        "zip_codes": [
            91110
        ],
        "district_id": 9105
    },
    {
        "id": 910504,
        "name_th": "ปากน้ำ",
        "name_en": "Pak Nam",
        "zip_codes": [
            91110
        ],
        "district_id": 9105
    },
    {
        "id": 910505,
        "name_th": "น้ำผุด",
        "name_en": "Nam Phut",
        "zip_codes": [
            91110
        ],
        "district_id": 9105
    },
    {
        "id": 910506,
        "name_th": "แหลมสน",
        "name_en": "Laem Son",
        "zip_codes": [
            91110
        ],
        "district_id": 9105
    },
    {
        "id": 910601,
        "name_th": "ทุ่งหว้า",
        "name_en": "Thung Wa",
        "zip_codes": [
            91120
        ],
        "district_id": 9106
    },
    {
        "id": 910602,
        "name_th": "นาทอน",
        "name_en": "Na Thon",
        "zip_codes": [
            91120
        ],
        "district_id": 9106
    },
    {
        "id": 910603,
        "name_th": "ขอนคลาน",
        "name_en": "Khon Khlan",
        "zip_codes": [
            91120
        ],
        "district_id": 9106
    },
    {
        "id": 910604,
        "name_th": "ทุ่งบุหลัง",
        "name_en": "Thung Bu Lang",
        "zip_codes": [
            91120
        ],
        "district_id": 9106
    },
    {
        "id": 910605,
        "name_th": "ป่าแก่บ่อหิน",
        "name_en": "Pa Kae Bo Hin",
        "zip_codes": [
            91120
        ],
        "district_id": 9106
    },
    {
        "id": 910701,
        "name_th": "ปาล์มพัฒนา",
        "name_en": "Pam Phatthana",
        "zip_codes": [
            91130
        ],
        "district_id": 9107
    },
    {
        "id": 910702,
        "name_th": "นิคมพัฒนา",
        "name_en": "Nikhom Phatthana",
        "zip_codes": [
            91130
        ],
        "district_id": 9107
    },
    {
        "id": 920101,
        "name_th": "ทับเที่ยง",
        "name_en": "Thap Thiang",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920104,
        "name_th": "นาพละ",
        "name_en": "Na Phala",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920105,
        "name_th": "บ้านควน",
        "name_en": "Ban Khuan",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920106,
        "name_th": "นาบินหลา",
        "name_en": "Na Bin La",
        "zip_codes": [
            92170
        ],
        "district_id": 9201
    },
    {
        "id": 920107,
        "name_th": "ควนปริง",
        "name_en": "Khuan Pring",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920108,
        "name_th": "นาโยงใต้",
        "name_en": "Na Yong Tai",
        "zip_codes": [
            92170
        ],
        "district_id": 9201
    },
    {
        "id": 920109,
        "name_th": "บางรัก",
        "name_en": "Bang Rak",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920110,
        "name_th": "โคกหล่อ",
        "name_en": "Khok Lo",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920113,
        "name_th": "นาโต๊ะหมิง",
        "name_en": "Na To Ming",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920114,
        "name_th": "หนองตรุด",
        "name_en": "Nong Trut",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920115,
        "name_th": "น้ำผุด",
        "name_en": "Nam Phut",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920117,
        "name_th": "นาตาล่วง",
        "name_en": "Na Ta Luang",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920118,
        "name_th": "บ้านโพธิ์",
        "name_en": "Ban Pho",
        "zip_codes": [
            92000
        ],
        "district_id": 9201
    },
    {
        "id": 920119,
        "name_th": "นาท่ามเหนือ",
        "name_en": "Na Tham Nuea",
        "zip_codes": [
            92190
        ],
        "district_id": 9201
    },
    {
        "id": 920120,
        "name_th": "นาท่ามใต้",
        "name_en": "Na Tham Tai",
        "zip_codes": [
            92190
        ],
        "district_id": 9201
    },
    {
        "id": 920201,
        "name_th": "กันตัง",
        "name_en": "Kantang",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920202,
        "name_th": "ควนธานี",
        "name_en": "Khuan Thani",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920203,
        "name_th": "บางหมาก",
        "name_en": "Bang Mak",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920204,
        "name_th": "บางเป้า",
        "name_en": "Bang Pao",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920205,
        "name_th": "วังวน",
        "name_en": "Wang Won",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920206,
        "name_th": "กันตังใต้",
        "name_en": "Kantang Tai",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920207,
        "name_th": "โคกยาง",
        "name_en": "Khok Yang",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920208,
        "name_th": "คลองลุ",
        "name_en": "Khlong Lu",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920209,
        "name_th": "ย่านซื่อ",
        "name_en": "Yan Sue",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920210,
        "name_th": "บ่อน้ำร้อน",
        "name_en": "Bo Nam Ron",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920211,
        "name_th": "บางสัก",
        "name_en": "Bang Sak",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920212,
        "name_th": "นาเกลือ",
        "name_en": "Na Kluea",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920213,
        "name_th": "เกาะลิบง",
        "name_en": "Ko Libong",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920214,
        "name_th": "คลองชีล้อม",
        "name_en": "Khlong Chi Lom",
        "zip_codes": [
            92110
        ],
        "district_id": 9202
    },
    {
        "id": 920301,
        "name_th": "ย่านตาขาว",
        "name_en": "Yan Ta Khao",
        "zip_codes": [
            92140
        ],
        "district_id": 9203
    },
    {
        "id": 920302,
        "name_th": "หนองบ่อ",
        "name_en": "Nong Bo",
        "zip_codes": [
            92140
        ],
        "district_id": 9203
    },
    {
        "id": 920303,
        "name_th": "นาชุมเห็ด",
        "name_en": "Na Chum Het",
        "zip_codes": [
            92140
        ],
        "district_id": 9203
    },
    {
        "id": 920304,
        "name_th": "ในควน",
        "name_en": "Nai Khuan",
        "zip_codes": [
            92140
        ],
        "district_id": 9203
    },
    {
        "id": 920305,
        "name_th": "โพรงจระเข้",
        "name_en": "Phrong Chorakhe",
        "zip_codes": [
            92140
        ],
        "district_id": 9203
    },
    {
        "id": 920306,
        "name_th": "ทุ่งกระบือ",
        "name_en": "Thung Krabue",
        "zip_codes": [
            92140
        ],
        "district_id": 9203
    },
    {
        "id": 920307,
        "name_th": "ทุ่งค่าย",
        "name_en": "Thung Khai",
        "zip_codes": [
            92140
        ],
        "district_id": 9203
    },
    {
        "id": 920308,
        "name_th": "เกาะเปียะ",
        "name_en": "Ko Pia",
        "zip_codes": [
            92140
        ],
        "district_id": 9203
    },
    {
        "id": 920401,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            92120
        ],
        "district_id": 9204
    },
    {
        "id": 920402,
        "name_th": "ทุ่งยาว",
        "name_en": "Thung Yao",
        "zip_codes": [
            92180
        ],
        "district_id": 9204
    },
    {
        "id": 920403,
        "name_th": "ปะเหลียน",
        "name_en": "Palian",
        "zip_codes": [
            92180
        ],
        "district_id": 9204
    },
    {
        "id": 920404,
        "name_th": "บางด้วน",
        "name_en": "Bang Duan",
        "zip_codes": [
            92140
        ],
        "district_id": 9204
    },
    {
        "id": 920407,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            92140
        ],
        "district_id": 9204
    },
    {
        "id": 920409,
        "name_th": "สุโสะ",
        "name_en": "Suso",
        "zip_codes": [
            92120
        ],
        "district_id": 9204
    },
    {
        "id": 920410,
        "name_th": "ลิพัง",
        "name_en": "Liphang",
        "zip_codes": [
            92180
        ],
        "district_id": 9204
    },
    {
        "id": 920411,
        "name_th": "เกาะสุกร",
        "name_en": "Ko Sukon",
        "zip_codes": [
            92120
        ],
        "district_id": 9204
    },
    {
        "id": 920412,
        "name_th": "ท่าพญา",
        "name_en": "Tha Phaya",
        "zip_codes": [
            92140
        ],
        "district_id": 9204
    },
    {
        "id": 920413,
        "name_th": "แหลมสอม",
        "name_en": "Laem Som",
        "zip_codes": [
            92180
        ],
        "district_id": 9204
    },
    {
        "id": 920501,
        "name_th": "บ่อหิน",
        "name_en": "Bo Hin",
        "zip_codes": [
            92150
        ],
        "district_id": 9205
    },
    {
        "id": 920502,
        "name_th": "เขาไม้แก้ว",
        "name_en": "Khao Mai Kaeo",
        "zip_codes": [
            92150
        ],
        "district_id": 9205
    },
    {
        "id": 920503,
        "name_th": "กะลาเส",
        "name_en": "Kalase",
        "zip_codes": [
            92150
        ],
        "district_id": 9205
    },
    {
        "id": 920504,
        "name_th": "ไม้ฝาด",
        "name_en": "Mai Fat",
        "zip_codes": [
            92150
        ],
        "district_id": 9205
    },
    {
        "id": 920505,
        "name_th": "นาเมืองเพชร",
        "name_en": "Na Mueang Phet",
        "zip_codes": [
            92000
        ],
        "district_id": 9205
    },
    {
        "id": 920601,
        "name_th": "ห้วยยอด",
        "name_en": "Huai Yot",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920602,
        "name_th": "หนองช้างแล่น",
        "name_en": "Nong Chang Laen",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920605,
        "name_th": "บางดี",
        "name_en": "Bang Di",
        "zip_codes": [
            92210
        ],
        "district_id": 9206
    },
    {
        "id": 920606,
        "name_th": "บางกุ้ง",
        "name_en": "Bang Kung",
        "zip_codes": [
            92210
        ],
        "district_id": 9206
    },
    {
        "id": 920607,
        "name_th": "เขากอบ",
        "name_en": "Khao Kop",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920608,
        "name_th": "เขาขาว",
        "name_en": "Khao Khao",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920609,
        "name_th": "เขาปูน",
        "name_en": "Khao Pun",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920610,
        "name_th": "ปากแจ่ม",
        "name_en": "Pak Chaem",
        "zip_codes": [
            92190
        ],
        "district_id": 9206
    },
    {
        "id": 920611,
        "name_th": "ปากคม",
        "name_en": "Pak Khom",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920614,
        "name_th": "ท่างิ้ว",
        "name_en": "Tha Ngio",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920615,
        "name_th": "ลำภูรา",
        "name_en": "Lamphu Ra",
        "zip_codes": [
            92190
        ],
        "district_id": 9206
    },
    {
        "id": 920616,
        "name_th": "นาวง",
        "name_en": "Na Wong",
        "zip_codes": [
            92210
        ],
        "district_id": 9206
    },
    {
        "id": 920617,
        "name_th": "ห้วยนาง",
        "name_en": "Huai Nang",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920619,
        "name_th": "ในเตา",
        "name_en": "Nai Tao",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920620,
        "name_th": "ทุ่งต่อ",
        "name_en": "Thung To",
        "zip_codes": [
            92130
        ],
        "district_id": 9206
    },
    {
        "id": 920621,
        "name_th": "วังคีรี",
        "name_en": "Wang Khiri",
        "zip_codes": [
            92210
        ],
        "district_id": 9206
    },
    {
        "id": 920701,
        "name_th": "เขาวิเศษ",
        "name_en": "Khao Wiset",
        "zip_codes": [
            92220
        ],
        "district_id": 9207
    },
    {
        "id": 920702,
        "name_th": "วังมะปราง",
        "name_en": "Wang Maprang",
        "zip_codes": [
            92220
        ],
        "district_id": 9207
    },
    {
        "id": 920703,
        "name_th": "อ่าวตง",
        "name_en": "Ao Tong",
        "zip_codes": [
            92220
        ],
        "district_id": 9207
    },
    {
        "id": 920704,
        "name_th": "ท่าสะบ้า",
        "name_en": "Tha Saba",
        "zip_codes": [
            92000
        ],
        "district_id": 9207
    },
    {
        "id": 920705,
        "name_th": "วังมะปรางเหนือ",
        "name_en": "Wang Maprang Nuea",
        "zip_codes": [
            92220
        ],
        "district_id": 9207
    },
    {
        "id": 920801,
        "name_th": "นาโยงเหนือ",
        "name_en": "Na Yong Nuea",
        "zip_codes": [
            92170
        ],
        "district_id": 9208
    },
    {
        "id": 920802,
        "name_th": "ช่อง",
        "name_en": "Chong",
        "zip_codes": [
            92170
        ],
        "district_id": 9208
    },
    {
        "id": 920803,
        "name_th": "ละมอ",
        "name_en": "Lamo",
        "zip_codes": [
            92170
        ],
        "district_id": 9208
    },
    {
        "id": 920804,
        "name_th": "โคกสะบ้า",
        "name_en": "Khok Saba",
        "zip_codes": [
            92170
        ],
        "district_id": 9208
    },
    {
        "id": 920805,
        "name_th": "นาหมื่นศรี",
        "name_en": "Na Muen Si",
        "zip_codes": [
            92170
        ],
        "district_id": 9208
    },
    {
        "id": 920806,
        "name_th": "นาข้าวเสีย",
        "name_en": "Na Khao Sia",
        "zip_codes": [
            92170
        ],
        "district_id": 9208
    },
    {
        "id": 920901,
        "name_th": "ควนเมา",
        "name_en": "Khuan Mao",
        "zip_codes": [
            92160
        ],
        "district_id": 9209
    },
    {
        "id": 920902,
        "name_th": "คลองปาง",
        "name_en": "Khlong Pang",
        "zip_codes": [
            92160
        ],
        "district_id": 9209
    },
    {
        "id": 920903,
        "name_th": "หนองบัว",
        "name_en": "Nong Bua",
        "zip_codes": [
            92160
        ],
        "district_id": 9209
    },
    {
        "id": 920904,
        "name_th": "หนองปรือ",
        "name_en": "Nong Prue",
        "zip_codes": [
            92130
        ],
        "district_id": 9209
    },
    {
        "id": 920905,
        "name_th": "เขาไพร",
        "name_en": "Khao Phrai",
        "zip_codes": [
            92160
        ],
        "district_id": 9209
    },
    {
        "id": 921001,
        "name_th": "หาดสำราญ",
        "name_en": "Hat Samran",
        "zip_codes": [
            92120
        ],
        "district_id": 9210
    },
    {
        "id": 921002,
        "name_th": "บ้าหวี",
        "name_en": "Ba Wi",
        "zip_codes": [
            92120
        ],
        "district_id": 9210
    },
    {
        "id": 921003,
        "name_th": "ตะเสะ",
        "name_en": "Tase",
        "zip_codes": [
            92120
        ],
        "district_id": 9210
    },
    {
        "id": 930101,
        "name_th": "คูหาสวรรค์",
        "name_en": "Khuha Sawan",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930103,
        "name_th": "เขาเจียก",
        "name_en": "Khao Chiak",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930104,
        "name_th": "ท่ามิหรำ",
        "name_en": "Tha Miram",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930105,
        "name_th": "โคกชะงาย",
        "name_en": "Khok Cha-ngai",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930106,
        "name_th": "นาท่อม",
        "name_en": "Na Thom",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930107,
        "name_th": "ปรางหมู่",
        "name_en": "Prang Mu",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930108,
        "name_th": "ท่าแค",
        "name_en": "Tha Kae",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930109,
        "name_th": "ลำปำ",
        "name_en": "Lampam",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930110,
        "name_th": "ตำนาน",
        "name_en": "Tamnan",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930111,
        "name_th": "ควนมะพร้าว",
        "name_en": "Khuan Maphrao",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930112,
        "name_th": "ร่มเมือง",
        "name_en": "Rom Mueang",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930113,
        "name_th": "ชัยบุรี",
        "name_en": "Chai Buri",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930114,
        "name_th": "นาโหนด",
        "name_en": "Na Not",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930115,
        "name_th": "พญาขัน",
        "name_en": "Phaya Khan",
        "zip_codes": [
            93000
        ],
        "district_id": 9301
    },
    {
        "id": 930201,
        "name_th": "กงหรา",
        "name_en": "Kong Ra",
        "zip_codes": [
            93180
        ],
        "district_id": 9302
    },
    {
        "id": 930202,
        "name_th": "ชะรัด",
        "name_en": "Charat",
        "zip_codes": [
            93000
        ],
        "district_id": 9302
    },
    {
        "id": 930203,
        "name_th": "คลองเฉลิม",
        "name_en": "Khlong Chaloem",
        "zip_codes": [
            93180
        ],
        "district_id": 9302
    },
    {
        "id": 930204,
        "name_th": "คลองทรายขาว",
        "name_en": "Khlong Sai Khao",
        "zip_codes": [
            93180
        ],
        "district_id": 9302
    },
    {
        "id": 930205,
        "name_th": "สมหวัง",
        "name_en": "Som Wang",
        "zip_codes": [
            93000
        ],
        "district_id": 9302
    },
    {
        "id": 930301,
        "name_th": "เขาชัยสน",
        "name_en": "Khao Chaison",
        "zip_codes": [
            93130
        ],
        "district_id": 9303
    },
    {
        "id": 930302,
        "name_th": "ควนขนุน",
        "name_en": "Khuan Khanun",
        "zip_codes": [
            93130
        ],
        "district_id": 9303
    },
    {
        "id": 930305,
        "name_th": "จองถนน",
        "name_en": "Chong Thanon",
        "zip_codes": [
            93130
        ],
        "district_id": 9303
    },
    {
        "id": 930306,
        "name_th": "หานโพธิ์",
        "name_en": "Han Pho",
        "zip_codes": [
            93130
        ],
        "district_id": 9303
    },
    {
        "id": 930307,
        "name_th": "โคกม่วง",
        "name_en": "Khok Muang",
        "zip_codes": [
            93130
        ],
        "district_id": 9303
    },
    {
        "id": 930401,
        "name_th": "แม่ขรี",
        "name_en": "Mae Khari",
        "zip_codes": [
            93160
        ],
        "district_id": 9304
    },
    {
        "id": 930402,
        "name_th": "ตะโหมด",
        "name_en": "Tamot",
        "zip_codes": [
            93160
        ],
        "district_id": 9304
    },
    {
        "id": 930403,
        "name_th": "คลองใหญ่",
        "name_en": "Khlong Yai",
        "zip_codes": [
            93160
        ],
        "district_id": 9304
    },
    {
        "id": 930501,
        "name_th": "ควนขนุน",
        "name_en": "Khuan Khanun",
        "zip_codes": [
            93110
        ],
        "district_id": 9305
    },
    {
        "id": 930502,
        "name_th": "ทะเลน้อย",
        "name_en": "Thale Noi",
        "zip_codes": [
            93150
        ],
        "district_id": 9305
    },
    {
        "id": 930504,
        "name_th": "นาขยาด",
        "name_en": "Na Khayat",
        "zip_codes": [
            93110
        ],
        "district_id": 9305
    },
    {
        "id": 930505,
        "name_th": "พนมวังก์",
        "name_en": "Phanom Wang",
        "zip_codes": [
            93110
        ],
        "district_id": 9305
    },
    {
        "id": 930506,
        "name_th": "แหลมโตนด",
        "name_en": "Laem Tanot",
        "zip_codes": [
            93110
        ],
        "district_id": 9305
    },
    {
        "id": 930508,
        "name_th": "ปันแต",
        "name_en": "Pan Tae",
        "zip_codes": [
            93110
        ],
        "district_id": 9305
    },
    {
        "id": 930509,
        "name_th": "โตนดด้วน",
        "name_en": "Tanot Duan",
        "zip_codes": [
            93110
        ],
        "district_id": 9305
    },
    {
        "id": 930510,
        "name_th": "ดอนทราย",
        "name_en": "Don Sai",
        "zip_codes": [
            93110
        ],
        "district_id": 9305
    },
    {
        "id": 930511,
        "name_th": "มะกอกเหนือ",
        "name_en": "Makok Nuea",
        "zip_codes": [
            93150
        ],
        "district_id": 9305
    },
    {
        "id": 930512,
        "name_th": "พนางตุง",
        "name_en": "Phanang Tung",
        "zip_codes": [
            93150
        ],
        "district_id": 9305
    },
    {
        "id": 930513,
        "name_th": "ชะมวง",
        "name_en": "Chamuang",
        "zip_codes": [
            93110
        ],
        "district_id": 9305
    },
    {
        "id": 930516,
        "name_th": "แพรกหา",
        "name_en": "Phraek Ha",
        "zip_codes": [
            93110
        ],
        "district_id": 9305
    },
    {
        "id": 930601,
        "name_th": "ปากพะยูน",
        "name_en": "Pak Phayun",
        "zip_codes": [
            93120
        ],
        "district_id": 9306
    },
    {
        "id": 930602,
        "name_th": "ดอนประดู่",
        "name_en": "Don Pradu",
        "zip_codes": [
            93120
        ],
        "district_id": 9306
    },
    {
        "id": 930603,
        "name_th": "เกาะนางคำ",
        "name_en": "Ko Nang Kham",
        "zip_codes": [
            93120
        ],
        "district_id": 9306
    },
    {
        "id": 930604,
        "name_th": "เกาะหมาก",
        "name_en": "Ko Mak",
        "zip_codes": [
            93120
        ],
        "district_id": 9306
    },
    {
        "id": 930605,
        "name_th": "ฝาละมี",
        "name_en": "Falami",
        "zip_codes": [
            93120
        ],
        "district_id": 9306
    },
    {
        "id": 930606,
        "name_th": "หารเทา",
        "name_en": "Han Thao",
        "zip_codes": [
            93120
        ],
        "district_id": 9306
    },
    {
        "id": 930607,
        "name_th": "ดอนทราย",
        "name_en": "Don Sai",
        "zip_codes": [
            93120
        ],
        "district_id": 9306
    },
    {
        "id": 930701,
        "name_th": "เขาย่า",
        "name_en": "Khao Ya",
        "zip_codes": [
            93190
        ],
        "district_id": 9307
    },
    {
        "id": 930702,
        "name_th": "เขาปู่",
        "name_en": "Khao Pu",
        "zip_codes": [
            93190
        ],
        "district_id": 9307
    },
    {
        "id": 930703,
        "name_th": "ตะแพน",
        "name_en": "Taphaen",
        "zip_codes": [
            93190
        ],
        "district_id": 9307
    },
    {
        "id": 930801,
        "name_th": "ป่าบอน",
        "name_en": "Pa Bon",
        "zip_codes": [
            93170
        ],
        "district_id": 9308
    },
    {
        "id": 930802,
        "name_th": "โคกทราย",
        "name_en": "Khok Sai",
        "zip_codes": [
            93170
        ],
        "district_id": 9308
    },
    {
        "id": 930803,
        "name_th": "หนองธง",
        "name_en": "Nong Thong",
        "zip_codes": [
            93170
        ],
        "district_id": 9308
    },
    {
        "id": 930804,
        "name_th": "ทุ่งนารี",
        "name_en": "Thung Nari",
        "zip_codes": [
            93170
        ],
        "district_id": 9308
    },
    {
        "id": 930806,
        "name_th": "วังใหม่",
        "name_en": "Wang Mai",
        "zip_codes": [
            93170
        ],
        "district_id": 9308
    },
    {
        "id": 930901,
        "name_th": "ท่ามะเดื่อ",
        "name_en": "Tha Maduea",
        "zip_codes": [
            93140
        ],
        "district_id": 9309
    },
    {
        "id": 930902,
        "name_th": "นาปะขอ",
        "name_en": "Na Pakho",
        "zip_codes": [
            93140
        ],
        "district_id": 9309
    },
    {
        "id": 930903,
        "name_th": "โคกสัก",
        "name_en": "Khok Sak",
        "zip_codes": [
            93140,
            93160
        ],
        "district_id": 9309
    },
    {
        "id": 931001,
        "name_th": "ป่าพะยอม",
        "name_en": "Pa Phayom",
        "zip_codes": [
            93210
        ],
        "district_id": 9310
    },
    {
        "id": 931002,
        "name_th": "ลานข่อย",
        "name_en": "Lan Khoi",
        "zip_codes": [
            93210
        ],
        "district_id": 9310
    },
    {
        "id": 931003,
        "name_th": "เกาะเต่า",
        "name_en": "Ko Tao",
        "zip_codes": [
            93210
        ],
        "district_id": 9310
    },
    {
        "id": 931004,
        "name_th": "บ้านพร้าว",
        "name_en": "Ban Phrao",
        "zip_codes": [
            93210
        ],
        "district_id": 9310
    },
    {
        "id": 931101,
        "name_th": "ชุมพล",
        "name_en": "Chumpon",
        "zip_codes": [
            93000
        ],
        "district_id": 9311
    },
    {
        "id": 931102,
        "name_th": "บ้านนา",
        "name_en": "Ban Na",
        "zip_codes": [
            93000
        ],
        "district_id": 9311
    },
    {
        "id": 931103,
        "name_th": "อ่างทอง",
        "name_en": "Ang Thong",
        "zip_codes": [
            93000
        ],
        "district_id": 9311
    },
    {
        "id": 931104,
        "name_th": "ลำสินธุ์",
        "name_en": "Lam Sin",
        "zip_codes": [
            93000
        ],
        "district_id": 9311
    },
    {
        "id": 940101,
        "name_th": "สะบารัง",
        "name_en": "Sabarang",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940102,
        "name_th": "อาเนาะรู",
        "name_en": "Anoru",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940103,
        "name_th": "จะบังติกอ",
        "name_en": "Chabang Tiko",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940104,
        "name_th": "บานา",
        "name_en": "Bana",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940105,
        "name_th": "ตันหยงลุโละ",
        "name_en": "Tanyong Lulo",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940106,
        "name_th": "คลองมานิง",
        "name_en": "Khlong Maning",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940107,
        "name_th": "กะมิยอ",
        "name_en": "Kamiyo",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940108,
        "name_th": "บาราโหม",
        "name_en": "Bara Hom",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940109,
        "name_th": "ปะกาฮะรัง",
        "name_en": "Paka Harang",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940110,
        "name_th": "รูสะมิแล",
        "name_en": "Ru Samilae",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940111,
        "name_th": "ตะลุโบะ",
        "name_en": "Talubo",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940112,
        "name_th": "บาราเฮาะ",
        "name_en": "Bara Ho",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940113,
        "name_th": "ปุยุด",
        "name_en": "Puyut",
        "zip_codes": [
            94000
        ],
        "district_id": 9401
    },
    {
        "id": 940201,
        "name_th": "โคกโพธิ์",
        "name_en": "Khok Pho",
        "zip_codes": [
            94120
        ],
        "district_id": 9402
    },
    {
        "id": 940202,
        "name_th": "มะกรูด",
        "name_en": "Makrut",
        "zip_codes": [
            94120
        ],
        "district_id": 9402
    },
    {
        "id": 940203,
        "name_th": "บางโกระ",
        "name_en": "Bang Kro",
        "zip_codes": [
            94120
        ],
        "district_id": 9402
    },
    {
        "id": 940204,
        "name_th": "ป่าบอน",
        "name_en": "Pa Bon",
        "zip_codes": [
            94120
        ],
        "district_id": 9402
    },
    {
        "id": 940205,
        "name_th": "ทรายขาว",
        "name_en": "Sai Khao",
        "zip_codes": [
            94120
        ],
        "district_id": 9402
    },
    {
        "id": 940206,
        "name_th": "นาประดู่",
        "name_en": "Na Pradu",
        "zip_codes": [
            94180
        ],
        "district_id": 9402
    },
    {
        "id": 940207,
        "name_th": "ปากล่อ",
        "name_en": "Pak Lo",
        "zip_codes": [
            94180
        ],
        "district_id": 9402
    },
    {
        "id": 940208,
        "name_th": "ทุ่งพลา",
        "name_en": "Thung Phala",
        "zip_codes": [
            94180
        ],
        "district_id": 9402
    },
    {
        "id": 940211,
        "name_th": "ท่าเรือ",
        "name_en": "Tha Ruea",
        "zip_codes": [
            94120
        ],
        "district_id": 9402
    },
    {
        "id": 940213,
        "name_th": "นาเกตุ",
        "name_en": "Na Ket",
        "zip_codes": [
            94120
        ],
        "district_id": 9402
    },
    {
        "id": 940214,
        "name_th": "ควนโนรี",
        "name_en": "Khuan Nori",
        "zip_codes": [
            94180
        ],
        "district_id": 9402
    },
    {
        "id": 940215,
        "name_th": "ช้างให้ตก",
        "name_en": "Chang Hai Tok",
        "zip_codes": [
            94120
        ],
        "district_id": 9402
    },
    {
        "id": 940301,
        "name_th": "เกาะเปาะ",
        "name_en": "Ko Po",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940302,
        "name_th": "คอลอตันหยง",
        "name_en": "Kholo Tanyong",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940303,
        "name_th": "ดอนรัก",
        "name_en": "Don Rak",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940304,
        "name_th": "ดาโต๊ะ",
        "name_en": "Dato",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940305,
        "name_th": "ตุยง",
        "name_en": "Tuyong",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940306,
        "name_th": "ท่ากำชำ",
        "name_en": "Tha Kamcham",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940307,
        "name_th": "บ่อทอง",
        "name_en": "Bo Thong",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940308,
        "name_th": "บางเขา",
        "name_en": "Bang Khao",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940309,
        "name_th": "บางตาวา",
        "name_en": "Bang Tawa",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940310,
        "name_th": "ปุโละปุโย",
        "name_en": "Pulo Puyo",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940311,
        "name_th": "ยาบี",
        "name_en": "Yabi",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940312,
        "name_th": "ลิปะสะโง",
        "name_en": "Lipa Sa-ngo",
        "zip_codes": [
            94170
        ],
        "district_id": 9403
    },
    {
        "id": 940401,
        "name_th": "ปะนาเระ",
        "name_en": "Panare",
        "zip_codes": [
            94130
        ],
        "district_id": 9404
    },
    {
        "id": 940402,
        "name_th": "ท่าข้าม",
        "name_en": "Tha Kham",
        "zip_codes": [
            94130
        ],
        "district_id": 9404
    },
    {
        "id": 940403,
        "name_th": "บ้านนอก",
        "name_en": "Ban Nok",
        "zip_codes": [
            94130
        ],
        "district_id": 9404
    },
    {
        "id": 940404,
        "name_th": "ดอน",
        "name_en": "Don",
        "zip_codes": [
            94130,
            94190
        ],
        "district_id": 9404
    },
    {
        "id": 940405,
        "name_th": "ควน",
        "name_en": "Khuan",
        "zip_codes": [
            94190
        ],
        "district_id": 9404
    },
    {
        "id": 940406,
        "name_th": "ท่าน้ำ",
        "name_en": "Tha Nam",
        "zip_codes": [
            94130
        ],
        "district_id": 9404
    },
    {
        "id": 940407,
        "name_th": "คอกกระบือ",
        "name_en": "Khok Krabue",
        "zip_codes": [
            94130
        ],
        "district_id": 9404
    },
    {
        "id": 940408,
        "name_th": "พ่อมิ่ง",
        "name_en": "Pho Ming",
        "zip_codes": [
            94130
        ],
        "district_id": 9404
    },
    {
        "id": 940409,
        "name_th": "บ้านกลาง",
        "name_en": "Ban Klang",
        "zip_codes": [
            94130
        ],
        "district_id": 9404
    },
    {
        "id": 940410,
        "name_th": "บ้านน้ำบ่อ",
        "name_en": "Ban Nam Bo",
        "zip_codes": [
            94130
        ],
        "district_id": 9404
    },
    {
        "id": 940501,
        "name_th": "มายอ",
        "name_en": "Mayo",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940502,
        "name_th": "ถนน",
        "name_en": "Thanon",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940503,
        "name_th": "ตรัง",
        "name_en": "Trang",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940504,
        "name_th": "กระหวะ",
        "name_en": "Krawa",
        "zip_codes": [
            94140,
            94190
        ],
        "district_id": 9405
    },
    {
        "id": 940505,
        "name_th": "ลุโบะยิไร",
        "name_en": "Lubo yilai",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940506,
        "name_th": "ลางา",
        "name_en": "La-nga",
        "zip_codes": [
            94190
        ],
        "district_id": 9405
    },
    {
        "id": 940507,
        "name_th": "กระเสาะ",
        "name_en": "Kraso",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940508,
        "name_th": "เกาะจัน",
        "name_en": "Ko Chan",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940509,
        "name_th": "ปะโด",
        "name_en": "Pado",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940510,
        "name_th": "สาคอบน",
        "name_en": "Sakho Bon",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940511,
        "name_th": "สาคอใต้",
        "name_en": "Sakho Tai",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940512,
        "name_th": "สะกำ",
        "name_en": "Sakam",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940513,
        "name_th": "ปานัน",
        "name_en": "Panan",
        "zip_codes": [
            94140
        ],
        "district_id": 9405
    },
    {
        "id": 940601,
        "name_th": "ตะโละแมะนา",
        "name_en": "Talo Maena",
        "zip_codes": [
            94140
        ],
        "district_id": 9406
    },
    {
        "id": 940602,
        "name_th": "พิเทน",
        "name_en": "Phithen",
        "zip_codes": [
            94140
        ],
        "district_id": 9406
    },
    {
        "id": 940603,
        "name_th": "น้ำดำ",
        "name_en": "Nam Dam",
        "zip_codes": [
            94140
        ],
        "district_id": 9406
    },
    {
        "id": 940604,
        "name_th": "ปากู",
        "name_en": "Paku",
        "zip_codes": [
            94140
        ],
        "district_id": 9406
    },
    {
        "id": 940701,
        "name_th": "ตะลุบัน",
        "name_en": "Taluban",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940702,
        "name_th": "ตะบิ้ง",
        "name_en": "Tabing",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940703,
        "name_th": "ปะเสยะวอ",
        "name_en": "Pase Yawo",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940704,
        "name_th": "บางเก่า",
        "name_en": "Bang Kao",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940705,
        "name_th": "บือเระ",
        "name_en": "Bue Re",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940706,
        "name_th": "เตราะบอน",
        "name_en": "Tro Bon",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940707,
        "name_th": "กะดุนง",
        "name_en": "Kadunong",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940708,
        "name_th": "ละหาร",
        "name_en": "Lahan",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940709,
        "name_th": "มะนังดาลำ",
        "name_en": "Manang Dalam",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940710,
        "name_th": "แป้น",
        "name_en": "Paen",
        "zip_codes": [
            94110
        ],
        "district_id": 9407
    },
    {
        "id": 940711,
        "name_th": "ทุ่งคล้า",
        "name_en": "Thung Khla",
        "zip_codes": [
            94190
        ],
        "district_id": 9407
    },
    {
        "id": 940801,
        "name_th": "ไทรทอง",
        "name_en": "Sai Thong",
        "zip_codes": [
            94220
        ],
        "district_id": 9408
    },
    {
        "id": 940802,
        "name_th": "ไม้แก่น",
        "name_en": "Mai Kaen",
        "zip_codes": [
            94220
        ],
        "district_id": 9408
    },
    {
        "id": 940803,
        "name_th": "ตะโละไกรทอง",
        "name_en": "Talo Kraithong",
        "zip_codes": [
            94220
        ],
        "district_id": 9408
    },
    {
        "id": 940804,
        "name_th": "ดอนทราย",
        "name_en": "Don Sai",
        "zip_codes": [
            94220
        ],
        "district_id": 9408
    },
    {
        "id": 940901,
        "name_th": "ตะโละ",
        "name_en": "Talo",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940902,
        "name_th": "ตะโละกาโปร์",
        "name_en": "Talo Kapo",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940903,
        "name_th": "ตันหยงดาลอ",
        "name_en": "Tanyong Dalo",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940904,
        "name_th": "ตันหยงจึงงา",
        "name_en": "Tanyong Chueng-nga",
        "zip_codes": [
            94190
        ],
        "district_id": 9409
    },
    {
        "id": 940905,
        "name_th": "ตอหลัง",
        "name_en": "Tolang",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940906,
        "name_th": "ตาแกะ",
        "name_en": "Takae",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940907,
        "name_th": "ตาลีอายร์",
        "name_en": "Tali-ai",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940908,
        "name_th": "ยามู",
        "name_en": "Yamu",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940909,
        "name_th": "บางปู",
        "name_en": "Bang Pu",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940910,
        "name_th": "หนองแรต",
        "name_en": "Nong Raet",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940911,
        "name_th": "ปิยามุมัง",
        "name_en": "Piya Mumang",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940912,
        "name_th": "ปุลากง",
        "name_en": "Pulakong",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940913,
        "name_th": "บาโลย",
        "name_en": "Baloi",
        "zip_codes": [
            94190
        ],
        "district_id": 9409
    },
    {
        "id": 940914,
        "name_th": "สาบัน",
        "name_en": "Saban",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940915,
        "name_th": "มะนังยง",
        "name_en": "Manang Yong",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940916,
        "name_th": "ราตาปันยัง",
        "name_en": "Rata Panyang",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940917,
        "name_th": "จะรัง",
        "name_en": "Charang",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 940918,
        "name_th": "แหลมโพธิ์",
        "name_en": "Laem Pho",
        "zip_codes": [
            94150
        ],
        "district_id": 9409
    },
    {
        "id": 941001,
        "name_th": "ยะรัง",
        "name_en": "Yarang",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941002,
        "name_th": "สะดาวา",
        "name_en": "Sadawa",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941003,
        "name_th": "ประจัน",
        "name_en": "Prachan",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941004,
        "name_th": "สะนอ",
        "name_en": "Sano",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941005,
        "name_th": "ระแว้ง",
        "name_en": "Rawaeng",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941006,
        "name_th": "ปิตูมุดี",
        "name_en": "Pitu Mudi",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941007,
        "name_th": "วัด",
        "name_en": "Wat",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941008,
        "name_th": "กระโด",
        "name_en": "Krado",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941009,
        "name_th": "คลองใหม่",
        "name_en": "Khlong Mai",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941010,
        "name_th": "เมาะมาวี",
        "name_en": "Mo Mawi",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941011,
        "name_th": "กอลำ",
        "name_en": "Kolam",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941012,
        "name_th": "เขาตูม",
        "name_en": "Khao Tum",
        "zip_codes": [
            94160
        ],
        "district_id": 9410
    },
    {
        "id": 941101,
        "name_th": "กะรุบี",
        "name_en": "Karubi",
        "zip_codes": [
            94230
        ],
        "district_id": 9411
    },
    {
        "id": 941102,
        "name_th": "ตะโละดือรามัน",
        "name_en": "Talo Due Raman",
        "zip_codes": [
            94230
        ],
        "district_id": 9411
    },
    {
        "id": 941103,
        "name_th": "ปล่องหอย",
        "name_en": "Plong Hoi",
        "zip_codes": [
            94230
        ],
        "district_id": 9411
    },
    {
        "id": 941201,
        "name_th": "แม่ลาน",
        "name_en": "Mae Lan",
        "zip_codes": [
            94180
        ],
        "district_id": 9412
    },
    {
        "id": 941202,
        "name_th": "ม่วงเตี้ย",
        "name_en": "Muang Tia",
        "zip_codes": [
            94180
        ],
        "district_id": 9412
    },
    {
        "id": 941203,
        "name_th": "ป่าไร่",
        "name_en": "Pa Rai",
        "zip_codes": [
            94180
        ],
        "district_id": 9412
    },
    {
        "id": 950101,
        "name_th": "สะเตง",
        "name_en": "Sateng",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950102,
        "name_th": "บุดี",
        "name_en": "Budi",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950103,
        "name_th": "ยุโป",
        "name_en": "Yupo",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950104,
        "name_th": "ลิดล",
        "name_en": "Lidon",
        "zip_codes": [
            95160
        ],
        "district_id": 9501
    },
    {
        "id": 950106,
        "name_th": "ยะลา",
        "name_en": "Yala",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950108,
        "name_th": "ท่าสาป",
        "name_en": "Tha Sap",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950109,
        "name_th": "ลำใหม่",
        "name_en": "Lam Mai",
        "zip_codes": [
            95160
        ],
        "district_id": 9501
    },
    {
        "id": 950110,
        "name_th": "หน้าถ้ำ",
        "name_en": "Na Tham",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950111,
        "name_th": "ลำพะยา",
        "name_en": "Lam Phaya",
        "zip_codes": [
            95160
        ],
        "district_id": 9501
    },
    {
        "id": 950112,
        "name_th": "เปาะเส้ง",
        "name_en": "Po Seng",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950114,
        "name_th": "พร่อน",
        "name_en": "Phron",
        "zip_codes": [
            95160
        ],
        "district_id": 9501
    },
    {
        "id": 950115,
        "name_th": "บันนังสาเรง",
        "name_en": "Bannang Sareng",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950116,
        "name_th": "สะเตงนอก",
        "name_en": "Sateng Nok",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950118,
        "name_th": "ตาเซะ",
        "name_en": "Tase",
        "zip_codes": [
            95000
        ],
        "district_id": 9501
    },
    {
        "id": 950201,
        "name_th": "เบตง",
        "name_en": "Betong",
        "zip_codes": [
            95110
        ],
        "district_id": 9502
    },
    {
        "id": 950202,
        "name_th": "ยะรม",
        "name_en": "Yarom",
        "zip_codes": [
            95110
        ],
        "district_id": 9502
    },
    {
        "id": 950203,
        "name_th": "ตาเนาะแมเราะ",
        "name_en": "Tano Maero",
        "zip_codes": [
            95110
        ],
        "district_id": 9502
    },
    {
        "id": 950204,
        "name_th": "อัยเยอร์เวง",
        "name_en": "Aiyoeweng",
        "zip_codes": [
            95110
        ],
        "district_id": 9502
    },
    {
        "id": 950205,
        "name_th": "ธารน้ำทิพย์",
        "name_en": "Than Nam Thip",
        "zip_codes": [
            95110
        ],
        "district_id": 9502
    },
    {
        "id": 950301,
        "name_th": "บันนังสตา",
        "name_en": "Bannang Sata",
        "zip_codes": [
            95130
        ],
        "district_id": 9503
    },
    {
        "id": 950302,
        "name_th": "บาเจาะ",
        "name_en": "Bacho",
        "zip_codes": [
            95130
        ],
        "district_id": 9503
    },
    {
        "id": 950303,
        "name_th": "ตาเนาะปูเต๊ะ",
        "name_en": "Tanao Pute",
        "zip_codes": [
            95130
        ],
        "district_id": 9503
    },
    {
        "id": 950304,
        "name_th": "ถ้ำทะลุ",
        "name_en": "Tham Thalu",
        "zip_codes": [
            95130
        ],
        "district_id": 9503
    },
    {
        "id": 950305,
        "name_th": "ตลิ่งชัน",
        "name_en": "Taling Chan",
        "zip_codes": [
            95130
        ],
        "district_id": 9503
    },
    {
        "id": 950306,
        "name_th": "เขื่อนบางลาง",
        "name_en": "Khuean Bang Lang",
        "zip_codes": [
            95130
        ],
        "district_id": 9503
    },
    {
        "id": 950401,
        "name_th": "ธารโต",
        "name_en": "Than To",
        "zip_codes": [
            95150
        ],
        "district_id": 9504
    },
    {
        "id": 950402,
        "name_th": "บ้านแหร",
        "name_en": "Ban Rae",
        "zip_codes": [
            95150
        ],
        "district_id": 9504
    },
    {
        "id": 950403,
        "name_th": "แม่หวาด",
        "name_en": "Mae Wat",
        "zip_codes": [
            95130,
            95170
        ],
        "district_id": 9504
    },
    {
        "id": 950404,
        "name_th": "คีรีเขต",
        "name_en": "Khiri Khet",
        "zip_codes": [
            95150
        ],
        "district_id": 9504
    },
    {
        "id": 950501,
        "name_th": "ยะหา",
        "name_en": "Yaha",
        "zip_codes": [
            95120
        ],
        "district_id": 9505
    },
    {
        "id": 950502,
        "name_th": "ละแอ",
        "name_en": "La-ae",
        "zip_codes": [
            95120
        ],
        "district_id": 9505
    },
    {
        "id": 950503,
        "name_th": "ปะแต",
        "name_en": "Patae",
        "zip_codes": [
            95120
        ],
        "district_id": 9505
    },
    {
        "id": 950504,
        "name_th": "บาโร๊ะ",
        "name_en": "Baro",
        "zip_codes": [
            95120
        ],
        "district_id": 9505
    },
    {
        "id": 950506,
        "name_th": "ตาชี",
        "name_en": "Tashi",
        "zip_codes": [
            95120
        ],
        "district_id": 9505
    },
    {
        "id": 950507,
        "name_th": "บาโงยซิแน",
        "name_en": "Ba-ngoi Sinae",
        "zip_codes": [
            95120
        ],
        "district_id": 9505
    },
    {
        "id": 950508,
        "name_th": "กาตอง",
        "name_en": "Ka Tong",
        "zip_codes": [
            95120
        ],
        "district_id": 9505
    },
    {
        "id": 950601,
        "name_th": "กายูบอเกาะ",
        "name_en": "Kayu Boko",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950602,
        "name_th": "กาลูปัง",
        "name_en": "Kalupang",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950603,
        "name_th": "กาลอ",
        "name_en": "Kalo",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950604,
        "name_th": "กอตอตือร๊ะ",
        "name_en": "Koto Tuera",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950605,
        "name_th": "โกตาบารู",
        "name_en": "Kota Baru",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950606,
        "name_th": "เกะรอ",
        "name_en": "Kero",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950607,
        "name_th": "จะกว๊ะ",
        "name_en": "Cha-kwa",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950608,
        "name_th": "ท่าธง",
        "name_en": "Tha Thong",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950609,
        "name_th": "เนินงาม",
        "name_en": "Noen Ngam",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950610,
        "name_th": "บาลอ",
        "name_en": "Balo",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950611,
        "name_th": "บาโงย",
        "name_en": "Ba-ngoi",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950612,
        "name_th": "บือมัง",
        "name_en": "Buemang",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950613,
        "name_th": "ยะต๊ะ",
        "name_en": "Yata",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950614,
        "name_th": "วังพญา",
        "name_en": "Wang Phaya",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950615,
        "name_th": "อาซ่อง",
        "name_en": "A-song",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950616,
        "name_th": "ตะโล๊ะหะลอ",
        "name_en": "Talo Halo",
        "zip_codes": [
            95140
        ],
        "district_id": 9506
    },
    {
        "id": 950701,
        "name_th": "กาบัง",
        "name_en": "Kabang",
        "zip_codes": [
            95120
        ],
        "district_id": 9507
    },
    {
        "id": 950702,
        "name_th": "บาละ",
        "name_en": "Bala",
        "zip_codes": [
            95120
        ],
        "district_id": 9507
    },
    {
        "id": 950801,
        "name_th": "กรงปินัง",
        "name_en": "Krong Pinang",
        "zip_codes": [
            95000
        ],
        "district_id": 9508
    },
    {
        "id": 950802,
        "name_th": "สะเอะ",
        "name_en": "Sa-e",
        "zip_codes": [
            95000
        ],
        "district_id": 9508
    },
    {
        "id": 950803,
        "name_th": "ห้วยกระทิง",
        "name_en": "Huai Krathing",
        "zip_codes": [
            95000
        ],
        "district_id": 9508
    },
    {
        "id": 950804,
        "name_th": "ปุโรง",
        "name_en": "Purong",
        "zip_codes": [
            95000
        ],
        "district_id": 9508
    },
    {
        "id": 960101,
        "name_th": "บางนาค",
        "name_en": "Bang Nak",
        "zip_codes": [
            96000
        ],
        "district_id": 9601
    },
    {
        "id": 960102,
        "name_th": "ลำภู",
        "name_en": "Lamphu",
        "zip_codes": [
            96000
        ],
        "district_id": 9601
    },
    {
        "id": 960103,
        "name_th": "มะนังตายอ",
        "name_en": "Manang Tayo",
        "zip_codes": [
            96000
        ],
        "district_id": 9601
    },
    {
        "id": 960104,
        "name_th": "บางปอ",
        "name_en": "Bang Po",
        "zip_codes": [
            96000
        ],
        "district_id": 9601
    },
    {
        "id": 960105,
        "name_th": "กะลุวอ",
        "name_en": "Kaluwo",
        "zip_codes": [
            96000
        ],
        "district_id": 9601
    },
    {
        "id": 960106,
        "name_th": "กะลุวอเหนือ",
        "name_en": "Kaluwo Nuea",
        "zip_codes": [
            96000
        ],
        "district_id": 9601
    },
    {
        "id": 960107,
        "name_th": "โคกเคียน",
        "name_en": "Khok Khian",
        "zip_codes": [
            96000
        ],
        "district_id": 9601
    },
    {
        "id": 960201,
        "name_th": "เจ๊ะเห",
        "name_en": "Chehe",
        "zip_codes": [
            96110
        ],
        "district_id": 9602
    },
    {
        "id": 960202,
        "name_th": "ไพรวัน",
        "name_en": "Phraiwan",
        "zip_codes": [
            96110
        ],
        "district_id": 9602
    },
    {
        "id": 960203,
        "name_th": "พร่อน",
        "name_en": "Phron",
        "zip_codes": [
            96110
        ],
        "district_id": 9602
    },
    {
        "id": 960204,
        "name_th": "ศาลาใหม่",
        "name_en": "Sala Mai",
        "zip_codes": [
            96110
        ],
        "district_id": 9602
    },
    {
        "id": 960205,
        "name_th": "บางขุนทอง",
        "name_en": "Bang Khun Thong",
        "zip_codes": [
            96110
        ],
        "district_id": 9602
    },
    {
        "id": 960206,
        "name_th": "เกาะสะท้อน",
        "name_en": "Ko Sathon",
        "zip_codes": [
            96110
        ],
        "district_id": 9602
    },
    {
        "id": 960207,
        "name_th": "นานาค",
        "name_en": "Na Nak",
        "zip_codes": [
            96110
        ],
        "district_id": 9602
    },
    {
        "id": 960208,
        "name_th": "โฆษิต",
        "name_en": "Khosit",
        "zip_codes": [
            96110
        ],
        "district_id": 9602
    },
    {
        "id": 960301,
        "name_th": "บาเจาะ",
        "name_en": "Bacho",
        "zip_codes": [
            96170
        ],
        "district_id": 9603
    },
    {
        "id": 960302,
        "name_th": "ลุโบะสาวอ",
        "name_en": "Lubo Sawo",
        "zip_codes": [
            96170
        ],
        "district_id": 9603
    },
    {
        "id": 960303,
        "name_th": "กาเยาะมาตี",
        "name_en": "Kayo Mati",
        "zip_codes": [
            96170
        ],
        "district_id": 9603
    },
    {
        "id": 960304,
        "name_th": "ปะลุกาสาเมาะ",
        "name_en": "Paluka Samo",
        "zip_codes": [
            96170
        ],
        "district_id": 9603
    },
    {
        "id": 960305,
        "name_th": "บาเระเหนือ",
        "name_en": "Bare Nuea",
        "zip_codes": [
            96170
        ],
        "district_id": 9603
    },
    {
        "id": 960306,
        "name_th": "บาเระใต้",
        "name_en": "Bare Tai",
        "zip_codes": [
            96170
        ],
        "district_id": 9603
    },
    {
        "id": 960401,
        "name_th": "ยี่งอ",
        "name_en": "Yi-ngo",
        "zip_codes": [
            96180
        ],
        "district_id": 9604
    },
    {
        "id": 960402,
        "name_th": "ละหาร",
        "name_en": "Lahan",
        "zip_codes": [
            96180
        ],
        "district_id": 9604
    },
    {
        "id": 960403,
        "name_th": "จอเบาะ",
        "name_en": "Cho Bo",
        "zip_codes": [
            96180
        ],
        "district_id": 9604
    },
    {
        "id": 960404,
        "name_th": "ลุโบะบายะ",
        "name_en": "Lubo Baya",
        "zip_codes": [
            96180
        ],
        "district_id": 9604
    },
    {
        "id": 960405,
        "name_th": "ลุโบะบือซา",
        "name_en": "Lubo Buesa",
        "zip_codes": [
            96180
        ],
        "district_id": 9604
    },
    {
        "id": 960406,
        "name_th": "ตะปอเยาะ",
        "name_en": "Tapoyo",
        "zip_codes": [
            96180
        ],
        "district_id": 9604
    },
    {
        "id": 960501,
        "name_th": "ตันหยงมัส",
        "name_en": "Tanyong Mat",
        "zip_codes": [
            96130
        ],
        "district_id": 9605
    },
    {
        "id": 960502,
        "name_th": "ตันหยงลิมอ",
        "name_en": "Tanyong Limo",
        "zip_codes": [
            96130
        ],
        "district_id": 9605
    },
    {
        "id": 960506,
        "name_th": "บองอ",
        "name_en": "Bo-ngo",
        "zip_codes": [
            96220
        ],
        "district_id": 9605
    },
    {
        "id": 960507,
        "name_th": "กาลิซา",
        "name_en": "Kalisa",
        "zip_codes": [
            96130
        ],
        "district_id": 9605
    },
    {
        "id": 960508,
        "name_th": "บาโงสะโต",
        "name_en": "Ba-ngo Sato",
        "zip_codes": [
            96130
        ],
        "district_id": 9605
    },
    {
        "id": 960509,
        "name_th": "เฉลิม",
        "name_en": "Chaloem",
        "zip_codes": [
            96130
        ],
        "district_id": 9605
    },
    {
        "id": 960510,
        "name_th": "มะรือโบตก",
        "name_en": "Marue Botok",
        "zip_codes": [
            96130
        ],
        "district_id": 9605
    },
    {
        "id": 960601,
        "name_th": "รือเสาะ",
        "name_en": "Rueso",
        "zip_codes": [
            96150
        ],
        "district_id": 9606
    },
    {
        "id": 960602,
        "name_th": "สาวอ",
        "name_en": "Sawo",
        "zip_codes": [
            96150
        ],
        "district_id": 9606
    },
    {
        "id": 960603,
        "name_th": "เรียง",
        "name_en": "Riang",
        "zip_codes": [
            96150
        ],
        "district_id": 9606
    },
    {
        "id": 960604,
        "name_th": "สามัคคี",
        "name_en": "Samakkhi",
        "zip_codes": [
            96150
        ],
        "district_id": 9606
    },
    {
        "id": 960605,
        "name_th": "บาตง",
        "name_en": "Batong",
        "zip_codes": [
            96150
        ],
        "district_id": 9606
    },
    {
        "id": 960606,
        "name_th": "ลาโละ",
        "name_en": "Lalo",
        "zip_codes": [
            96150
        ],
        "district_id": 9606
    },
    {
        "id": 960607,
        "name_th": "รือเสาะออก",
        "name_en": "Rueso Ok",
        "zip_codes": [
            96150
        ],
        "district_id": 9606
    },
    {
        "id": 960608,
        "name_th": "โคกสะตอ",
        "name_en": "Khok Sato",
        "zip_codes": [
            96150
        ],
        "district_id": 9606
    },
    {
        "id": 960609,
        "name_th": "สุวารี",
        "name_en": "Suwari",
        "zip_codes": [
            96150
        ],
        "district_id": 9606
    },
    {
        "id": 960701,
        "name_th": "ซากอ",
        "name_en": "Sako",
        "zip_codes": [
            96210
        ],
        "district_id": 9607
    },
    {
        "id": 960702,
        "name_th": "ตะมะยูง",
        "name_en": "Tamayung",
        "zip_codes": [
            96210
        ],
        "district_id": 9607
    },
    {
        "id": 960703,
        "name_th": "ศรีสาคร",
        "name_en": "Si Sakhon",
        "zip_codes": [
            96210
        ],
        "district_id": 9607
    },
    {
        "id": 960704,
        "name_th": "เชิงคีรี",
        "name_en": "Choeng Khiri",
        "zip_codes": [
            96210
        ],
        "district_id": 9607
    },
    {
        "id": 960705,
        "name_th": "กาหลง",
        "name_en": "Kalong",
        "zip_codes": [
            96210
        ],
        "district_id": 9607
    },
    {
        "id": 960706,
        "name_th": "ศรีบรรพต",
        "name_en": "Si Banphot",
        "zip_codes": [
            96210
        ],
        "district_id": 9607
    },
    {
        "id": 960801,
        "name_th": "แว้ง",
        "name_en": "Waeng",
        "zip_codes": [
            96160
        ],
        "district_id": 9608
    },
    {
        "id": 960802,
        "name_th": "กายูคละ",
        "name_en": "Kayu Khla",
        "zip_codes": [
            96160
        ],
        "district_id": 9608
    },
    {
        "id": 960803,
        "name_th": "ฆอเลาะ",
        "name_en": "Kholo",
        "zip_codes": [
            96160
        ],
        "district_id": 9608
    },
    {
        "id": 960804,
        "name_th": "โละจูด",
        "name_en": "Lochut",
        "zip_codes": [
            96160
        ],
        "district_id": 9608
    },
    {
        "id": 960805,
        "name_th": "แม่ดง",
        "name_en": "Mae Dong",
        "zip_codes": [
            96160
        ],
        "district_id": 9608
    },
    {
        "id": 960806,
        "name_th": "เอราวัณ",
        "name_en": "Erawan",
        "zip_codes": [
            96160
        ],
        "district_id": 9608
    },
    {
        "id": 960901,
        "name_th": "มาโมง",
        "name_en": "Mamong",
        "zip_codes": [
            96190
        ],
        "district_id": 9609
    },
    {
        "id": 960902,
        "name_th": "สุคิริน",
        "name_en": "Sukhirin",
        "zip_codes": [
            96190
        ],
        "district_id": 9609
    },
    {
        "id": 960903,
        "name_th": "เกียร์",
        "name_en": "Kia",
        "zip_codes": [
            96190
        ],
        "district_id": 9609
    },
    {
        "id": 960904,
        "name_th": "ภูเขาทอง",
        "name_en": "Phukhao Thong",
        "zip_codes": [
            96190
        ],
        "district_id": 9609
    },
    {
        "id": 960905,
        "name_th": "ร่มไทร",
        "name_en": "Rom Sai",
        "zip_codes": [
            96190
        ],
        "district_id": 9609
    },
    {
        "id": 961001,
        "name_th": "สุไหงโก-ลก",
        "name_en": "Su-ngai Kolok",
        "zip_codes": [
            96120
        ],
        "district_id": 9610
    },
    {
        "id": 961002,
        "name_th": "ปาเสมัส",
        "name_en": "Pasemat",
        "zip_codes": [
            96120
        ],
        "district_id": 9610
    },
    {
        "id": 961003,
        "name_th": "มูโนะ",
        "name_en": "Muno",
        "zip_codes": [
            96120
        ],
        "district_id": 9610
    },
    {
        "id": 961004,
        "name_th": "ปูโยะ",
        "name_en": "Puyo",
        "zip_codes": [
            96120
        ],
        "district_id": 9610
    },
    {
        "id": 961101,
        "name_th": "ปะลุรู",
        "name_en": "Paluru",
        "zip_codes": [
            96140
        ],
        "district_id": 9611
    },
    {
        "id": 961102,
        "name_th": "สุไหงปาดี",
        "name_en": "Su-ngai Padi",
        "zip_codes": [
            96140
        ],
        "district_id": 9611
    },
    {
        "id": 961103,
        "name_th": "โต๊ะเด็ง",
        "name_en": "Todeng",
        "zip_codes": [
            96140
        ],
        "district_id": 9611
    },
    {
        "id": 961104,
        "name_th": "สากอ",
        "name_en": "Sako",
        "zip_codes": [
            96140
        ],
        "district_id": 9611
    },
    {
        "id": 961105,
        "name_th": "ริโก๋",
        "name_en": "Riko",
        "zip_codes": [
            96140
        ],
        "district_id": 9611
    },
    {
        "id": 961106,
        "name_th": "กาวะ",
        "name_en": "Kawa",
        "zip_codes": [
            96140
        ],
        "district_id": 9611
    },
    {
        "id": 961201,
        "name_th": "จะแนะ",
        "name_en": "Chanae",
        "zip_codes": [
            96220
        ],
        "district_id": 9612
    },
    {
        "id": 961202,
        "name_th": "ดุซงญอ",
        "name_en": "Dusongyo",
        "zip_codes": [
            96220
        ],
        "district_id": 9612
    },
    {
        "id": 961203,
        "name_th": "ผดุงมาตร",
        "name_en": "Phadung Mat",
        "zip_codes": [
            96220
        ],
        "district_id": 9612
    },
    {
        "id": 961204,
        "name_th": "ช้างเผือก",
        "name_en": "Chang Phueak",
        "zip_codes": [
            96220
        ],
        "district_id": 9612
    },
    {
        "id": 961301,
        "name_th": "จวบ",
        "name_en": "Chuap",
        "zip_codes": [
            96130
        ],
        "district_id": 9613
    },
    {
        "id": 961302,
        "name_th": "บูกิต",
        "name_en": "Bukit",
        "zip_codes": [
            96130
        ],
        "district_id": 9613
    },
    {
        "id": 961303,
        "name_th": "มะรือโบออก",
        "name_en": "Maruebo Ok",
        "zip_codes": [
            96130
        ],
        "district_id": 9613
    }
]